// src/data/regions.geojson.ts
export const REGION_GEOJSON = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-109.050044, 31.332502],
              [-108.861028, 31.332315],
              [-108.851105, 31.332301],
              [-108.208573, 31.333395],
              [-108.208572, 31.499742],
              [-108.208521, 31.499798],
              [-108.208394, 31.783599],
              [-107.422495, 31.783599],
              [-107.422246, 31.783599],
              [-107.296824, 31.783762],
              [-107.00056, 31.783513],
              [-107.00056, 31.783679],
              [-106.998235, 31.783671],
              [-106.993544, 31.783689],
              [-106.750547, 31.783898],
              [-106.750547, 31.783706],
              [-106.528543, 31.783907],
              [-106.472514, 31.751802],
              [-106.436743, 31.756872],
              [-106.41794, 31.752009],
              [-106.381039, 31.73211],
              [-106.356938, 31.70221],
              [-106.254062, 31.547512],
              [-106.218538, 31.47972],
              [-106.212918, 31.473409],
              [-106.2092, 31.469234],
              [-106.207524, 31.467872],
              [-106.206018, 31.466648],
              [-106.202851, 31.464073],
              [-106.132782, 31.425367],
              [-106.099393, 31.41476],
              [-106.00693, 31.392826],
              [-105.997658, 31.386489],
              [-105.981027, 31.375122],
              [-105.923131, 31.312089],
              [-105.900315, 31.300008],
              [-105.869353, 31.288634],
              [-105.793719, 31.201713],
              [-105.750519, 31.16494],
              [-105.709491, 31.136375],
              [-105.648834, 31.115902],
              [-105.60333, 31.082625],
              [-105.585323, 31.057488],
              [-105.579756, 31.036588],
              [-105.57765, 31.019811],
              [-105.55679, 30.989469],
              [-105.411833, 30.893367],
              [-105.394627, 30.85892],
              [-105.265479, 30.802536],
              [-105.250028, 30.799068],
              [-105.211234, 30.799609],
              [-105.129328, 30.750139],
              [-105.044407, 30.683895],
              [-104.985365, 30.623792],
              [-104.972071, 30.61026],
              [-104.929778, 30.59924],
              [-104.872808, 30.500145],
              [-104.859521, 30.390413],
              [-104.78102, 30.314564],
              [-104.761634, 30.301148],
              [-104.708916, 30.235826],
              [-104.687296, 30.179464],
              [-104.685793, 30.092656],
              [-104.693592, 30.019077],
              [-104.679877, 29.920946],
              [-104.674932, 29.911112],
              [-104.667301, 29.910401],
              [-104.633275, 29.870485],
              [-104.566055, 29.771379],
              [-104.549117, 29.728814],
              [-104.549773, 29.716091],
              [-104.538569, 29.677396],
              [-104.515512, 29.641493],
              [-104.394351, 29.560535],
              [-104.321603, 29.527923],
              [-104.290728, 29.519326],
              [-104.264155, 29.514001],
              [-104.235847, 29.496744],
              [-104.21341, 29.462069],
              [-104.167506, 29.402928],
              [-104.143692, 29.383278],
              [-104.025488, 29.314404],
              [-103.963076, 29.298404],
              [-103.924976, 29.293913],
              [-103.838303, 29.278304],
              [-103.792705, 29.262931],
              [-103.792005, 29.262695],
              [-103.767814, 29.224954],
              [-103.714867, 29.184137],
              [-103.627067, 29.163336],
              [-103.61007, 29.165727],
              [-103.558679, 29.154962],
              [-103.525471, 29.137744],
              [-103.503236, 29.11911],
              [-103.470518, 29.085108],
              [-103.471037, 29.075368],
              [-103.383508, 29.024112],
              [-103.281903, 28.990089],
              [-103.163865, 28.972099],
              [-103.156646, 28.972831],
              [-103.115328, 28.98527],
              [-103.10443, 29.03359],
              [-102.995688, 29.161219],
              [-102.95089, 29.176835],
              [-102.87802, 29.214698],
              [-102.866846, 29.225015],
              [-102.871347, 29.241625],
              [-102.881135, 29.246022],
              [-102.886308, 29.24568],
              [-102.895886, 29.284778],
              [-102.875813, 29.353715],
              [-102.83332, 29.408981],
              [-102.831938, 29.437943],
              [-102.808692, 29.522319],
              [-102.781807, 29.542454],
              [-102.745494, 29.592967],
              [-102.698347, 29.695591],
              [-102.689738, 29.722349],
              [-102.665194, 29.737421],
              [-102.612879, 29.748182],
              [-102.554915, 29.748966],
              [-102.500741, 29.781446],
              [-102.486819, 29.786725],
              [-102.434063, 29.7767],
              [-102.404422, 29.765105],
              [-102.386677, 29.76148],
              [-102.364647, 29.843624],
              [-102.323389, 29.875193],
              [-102.320819, 29.875193],
              [-102.297331, 29.875194],
              [-102.282247, 29.863598],
              [-102.262466, 29.853765],
              [-102.116076, 29.792527],
              [-102.050044, 29.78507],
              [-102.040539, 29.790061],
              [-101.944913, 29.801468],
              [-101.883655, 29.796193],
              [-101.786353, 29.782047],
              [-101.761839, 29.777187],
              [-101.646418, 29.754304],
              [-101.635128, 29.758675],
              [-101.625958, 29.771063],
              [-101.455007, 29.770188],
              [-101.403926, 29.757587],
              [-101.343743, 29.662047],
              [-101.314135, 29.659054],
              [-101.250383, 29.624171],
              [-101.247319, 29.618482],
              [-101.235275, 29.524854],
              [-101.137503, 29.473542],
              [-101.087149, 29.469414],
              [-101.060151, 29.458661],
              [-101.043364, 29.42988],
              [-101.037642, 29.414681],
              [-100.995607, 29.363403],
              [-100.954042, 29.347598],
              [-100.797671, 29.246943],
              [-100.793662, 29.242146],
              [-100.674656, 29.099777],
              [-100.668356, 29.08397],
              [-100.664065, 29.073206],
              [-100.645894, 28.986421],
              [-100.648104, 28.98386],
              [-100.651512, 28.943432],
              [-100.640092, 28.915833],
              [-100.589854, 28.861618],
              [-100.546804, 28.825374],
              [-100.535438, 28.805195],
              [-100.507613, 28.740599],
              [-100.506701, 28.716745],
              [-100.511998, 28.705352],
              [-100.510055, 28.690723],
              [-100.500354, 28.66196],
              [-100.446659, 28.608659],
              [-100.429856, 28.596441],
              [-100.405058, 28.53578],
              [-100.386963, 28.514023],
              [-100.338518, 28.501833],
              [-100.333814, 28.499252],
              [-100.346986, 28.407232],
              [-100.291391, 28.275398],
              [-100.257788, 28.240341],
              [-100.209464, 28.196866],
              [-100.202448, 28.190554],
              [-100.171323, 28.17623],
              [-100.14414, 28.168238],
              [-100.088143, 28.147503],
              [-100.083393, 28.144035],
              [-100.080868, 28.137192],
              [-100.057049, 28.095656],
              [-99.991447, 27.99456],
              [-99.922046, 27.922119],
              [-99.895828, 27.904178],
              [-99.904385, 27.875284],
              [-99.901486, 27.864162],
              [-99.876174, 27.806276],
              [-99.843463, 27.77456],
              [-99.666175, 27.638324],
              [-99.627123, 27.638412],
              [-99.626294, 27.64245],
              [-99.623478, 27.644136],
              [-99.600619, 27.641314],
              [-99.541644, 27.605772],
              [-99.519381, 27.573569],
              [-99.480219, 27.485796],
              [-99.487704, 27.409924],
              [-99.492831, 27.390491],
              [-99.50696, 27.35642],
              [-99.537771, 27.316073],
              [-99.536443, 27.312538],
              [-99.529654, 27.306051],
              [-99.494678, 27.277595],
              [-99.47088, 27.265444],
              [-99.463309, 27.268437],
              [-99.453949, 27.264673],
              [-99.452391, 27.264046],
              [-99.441549, 27.24992],
              [-99.426348, 27.176262],
              [-99.429879, 27.094323],
              [-99.446593, 27.070593],
              [-99.451035, 27.066765],
              [-99.452316, 27.062669],
              [-99.446524, 27.023008],
              [-99.379149, 26.93449],
              [-99.321819, 26.906846],
              [-99.268613, 26.843213],
              [-99.242444, 26.788262],
              [-99.208951, 26.689489],
              [-99.172058, 26.57086],
              [-99.167996, 26.557799],
              [-99.105719, 26.43872],
              [-99.047575, 26.406922],
              [-98.861354, 26.36599],
              [-98.822373, 26.370902],
              [-98.807348, 26.369421],
              [-98.751164, 26.331307],
              [-98.705676, 26.27748],
              [-98.6329, 26.250348],
              [-98.623335, 26.259592],
              [-98.58672, 26.257456],
              [-98.58581, 26.257403],
              [-98.466167, 26.223245],
              [-98.438822, 26.212022],
              [-98.386694, 26.157872],
              [-98.264514, 26.085507],
              [-98.241664, 26.074544],
              [-98.132605, 26.057507],
              [-98.044517, 26.043746],
              [-98.011883, 26.056608],
              [-98.008307, 26.061147],
              [-97.888699, 26.064931],
              [-97.863056, 26.061273],
              [-97.671568, 26.033955],
              [-97.668099, 26.022522],
              [-97.582565, 25.937857],
              [-97.511161, 25.887458],
              [-97.496861, 25.880058],
              [-97.408357, 25.856459],
              [-97.366723, 25.885066],
              [-97.367045, 25.903021],
              [-97.362345, 25.915724],
              [-97.348275, 25.931143],
              [-97.271382, 25.951832],
              [-97.228025, 25.958936],
              [-97.172633, 25.962883],
              [-97.145567, 25.971132],
              [-97.151922, 26.017653],
              [-97.15321, 26.038906],
              [-97.152009, 26.062108],
              [-97.164982, 26.063876],
              [-97.18273, 26.053126],
              [-97.178659, 26.045492],
              [-97.172043, 26.044729],
              [-97.162628, 26.023482],
              [-97.162755, 26.014576],
              [-97.167208, 26.007069],
              [-97.17446, 26.000072],
              [-97.195834, 25.993074],
              [-97.208557, 25.991802],
              [-97.216954, 25.993838],
              [-97.219244, 25.996128],
              [-97.226114, 26.024372],
              [-97.224842, 26.027426],
              [-97.214918, 26.030734],
              [-97.204995, 26.030225],
              [-97.195071, 26.04193],
              [-97.199651, 26.077044],
              [-97.208048, 26.079589],
              [-97.24698, 26.080352],
              [-97.270898, 26.086459],
              [-97.279804, 26.092057],
              [-97.295072, 26.108342],
              [-97.294054, 26.11394],
              [-97.283112, 26.117757],
              [-97.282094, 26.120301],
              [-97.28536, 26.128378],
              [-97.296598, 26.142439],
              [-97.306776, 26.159487],
              [-97.296089, 26.182388],
              [-97.294817, 26.192312],
              [-97.296598, 26.200709],
              [-97.304486, 26.20249],
              [-97.32128, 26.228699],
              [-97.32128, 26.236078],
              [-97.308049, 26.249055],
              [-97.307031, 26.253126],
              [-97.311866, 26.273737],
              [-97.322807, 26.271956],
              [-97.331967, 26.265595],
              [-97.341128, 26.265595],
              [-97.343927, 26.267376],
              [-97.347489, 26.292821],
              [-97.34698, 26.311396],
              [-97.354359, 26.313941],
              [-97.352833, 26.318521],
              [-97.336802, 26.331753],
              [-97.330441, 26.350582],
              [-97.335275, 26.355672],
              [-97.343418, 26.359234],
              [-97.358176, 26.356435],
              [-97.369372, 26.348547],
              [-97.372171, 26.339895],
              [-97.376242, 26.336333],
              [-97.387947, 26.330481],
              [-97.391001, 26.332262],
              [-97.392019, 26.339386],
              [-97.388965, 26.36585],
              [-97.374461, 26.380862],
              [-97.369627, 26.394603],
              [-97.377769, 26.409107],
              [-97.382485, 26.411326],
              [-97.395072, 26.417249],
              [-97.394309, 26.41445],
              [-97.398126, 26.410888],
              [-97.406014, 26.409107],
              [-97.4195, 26.413178],
              [-97.42179, 26.417249],
              [-97.412884, 26.433026],
              [-97.411612, 26.447275],
              [-97.41721, 26.44982],
              [-97.421026, 26.446766],
              [-97.425861, 26.446003],
              [-97.437566, 26.44982],
              [-97.441383, 26.455418],
              [-97.441383, 26.466614],
              [-97.43553, 26.470176],
              [-97.429169, 26.478064],
              [-97.42637, 26.484425],
              [-97.430696, 26.494603],
              [-97.430696, 26.506563],
              [-97.425861, 26.516741],
              [-97.422299, 26.520303],
              [-97.416955, 26.553637],
              [-97.428151, 26.572466],
              [-97.441206, 26.599901],
              [-97.445708, 26.609362],
              [-97.444945, 26.633535],
              [-97.467337, 26.710126],
              [-97.468609, 26.740915],
              [-97.471663, 26.758727],
              [-97.478024, 26.7572],
              [-97.484385, 26.763562],
              [-97.509831, 26.803511],
              [-97.537566, 26.824885],
              [-97.547745, 26.824631],
              [-97.552579, 26.827938],
              [-97.563266, 26.842188],
              [-97.558432, 26.864325],
              [-97.552325, 26.867633],
              [-97.552325, 26.888499],
              [-97.547999, 26.895114],
              [-97.540111, 26.900967],
              [-97.540874, 26.90631],
              [-97.555378, 26.93888],
              [-97.555378, 26.947277],
              [-97.552325, 26.952112],
              [-97.549526, 26.965344],
              [-97.551053, 26.980865],
              [-97.555378, 26.99028],
              [-97.549271, 26.995878],
              [-97.536803, 26.999695],
              [-97.484131, 27.000458],
              [-97.480569, 26.997659],
              [-97.478533, 26.999186],
              [-97.473444, 27.02285],
              [-97.473953, 27.029212],
              [-97.477515, 27.03252],
              [-97.486676, 27.03481],
              [-97.487693, 27.053639],
              [-97.48693, 27.057711],
              [-97.482257, 27.061942],
              [-97.479042, 27.0628],
              [-97.477515, 27.066108],
              [-97.493291, 27.078067],
              [-97.495836, 27.094098],
              [-97.49151, 27.101222],
              [-97.480569, 27.102494],
              [-97.47548, 27.098423],
              [-97.461739, 27.095624],
              [-97.45665, 27.099695],
              [-97.455887, 27.110383],
              [-97.452324, 27.115217],
              [-97.443673, 27.116235],
              [-97.444945, 27.144734],
              [-97.434767, 27.202241],
              [-97.422299, 27.257712],
              [-97.42408, 27.264073],
              [-97.450289, 27.262546],
              [-97.458431, 27.259493],
              [-97.467083, 27.25364],
              [-97.485149, 27.250841],
              [-97.500162, 27.24448],
              [-97.503215, 27.2399],
              [-97.509831, 27.23532],
              [-97.520009, 27.231248],
              [-97.54291, 27.229213],
              [-97.561231, 27.232775],
              [-97.573953, 27.238882],
              [-97.582605, 27.240409],
              [-97.597363, 27.242444],
              [-97.628916, 27.242953],
              [-97.635022, 27.247024],
              [-97.639094, 27.253131],
              [-97.640111, 27.270943],
              [-97.63668, 27.281727],
              [-97.636549, 27.282139],
              [-97.63146, 27.28621],
              [-97.621791, 27.287228],
              [-97.609068, 27.285193],
              [-97.584132, 27.30962],
              [-97.5709, 27.315727],
              [-97.53833, 27.335574],
              [-97.520518, 27.352877],
              [-97.514411, 27.361529],
              [-97.501688, 27.366618],
              [-97.48693, 27.358984],
              [-97.483877, 27.351351],
              [-97.483877, 27.338628],
              [-97.499144, 27.327941],
              [-97.502706, 27.322343],
              [-97.498126, 27.308602],
              [-97.504742, 27.30504],
              [-97.517465, 27.30504],
              [-97.524589, 27.297915],
              [-97.526625, 27.291808],
              [-97.536803, 27.289264],
              [-97.546981, 27.290791],
              [-97.544437, 27.284175],
              [-97.532223, 27.278577],
              [-97.508304, 27.275014],
              [-97.482859, 27.297915],
              [-97.450798, 27.313691],
              [-97.430441, 27.313691],
              [-97.420263, 27.317254],
              [-97.413138, 27.321325],
              [-97.404996, 27.329977],
              [-97.401942, 27.335574],
              [-97.399398, 27.344735],
              [-97.37955, 27.390028],
              [-97.372935, 27.401224],
              [-97.369881, 27.41242],
              [-97.371917, 27.425142],
              [-97.36581, 27.450588],
              [-97.359194, 27.458221],
              [-97.350543, 27.478578],
              [-97.347489, 27.503005],
              [-97.343418, 27.517764],
              [-97.336802, 27.527433],
              [-97.325118, 27.560927],
              [-97.321535, 27.571199],
              [-97.302196, 27.585957],
              [-97.294054, 27.5941],
              [-97.297616, 27.59868],
              [-97.298634, 27.604787],
              [-97.296598, 27.613947],
              [-97.266064, 27.678579],
              [-97.259957, 27.679597],
              [-97.253955, 27.696696],
              [-97.316446, 27.712676],
              [-97.34698, 27.725398],
              [-97.368355, 27.741683],
              [-97.386166, 27.76662],
              [-97.393291, 27.782905],
              [-97.391764, 27.813948],
              [-97.379042, 27.837867],
              [-97.361246, 27.849891],
              [-97.360547, 27.850363],
              [-97.360212, 27.85059],
              [-97.354614, 27.849572],
              [-97.327494, 27.866405],
              [-97.325097, 27.867893],
              [-97.317892, 27.870335],
              [-97.301455, 27.875907],
              [-97.295072, 27.878071],
              [-97.285466, 27.879672],
              [-97.276632, 27.881144],
              [-97.273698, 27.881633],
              [-97.272253, 27.881427],
              [-97.26301, 27.880106],
              [-97.258305, 27.878538],
              [-97.256394, 27.877901],
              [-97.250797, 27.876035],
              [-97.242922, 27.865208],
              [-97.242654, 27.864839],
              [-97.241393, 27.858953],
              [-97.241127, 27.857714],
              [-97.234512, 27.849063],
              [-97.228388, 27.843661],
              [-97.226514, 27.838307],
              [-97.227317, 27.832952],
              [-97.227317, 27.832895],
              [-97.227317, 27.831258],
              [-97.227317, 27.830939],
              [-97.227317, 27.829204],
              [-97.226012, 27.827083],
              [-97.225811, 27.826755],
              [-97.225435, 27.826145],
              [-97.225176, 27.825723],
              [-97.222957, 27.824919],
              [-97.222212, 27.824649],
              [-97.220771, 27.824126],
              [-97.219738, 27.823939],
              [-97.211226, 27.822391],
              [-97.209575, 27.822091],
              [-97.209127, 27.822091],
              [-97.196852, 27.822091],
              [-97.193701, 27.822754],
              [-97.192874, 27.822928],
              [-97.188866, 27.823772],
              [-97.187183, 27.824126],
              [-97.186871, 27.825001],
              [-97.186709, 27.825453],
              [-97.184639, 27.831251],
              [-97.183455, 27.833231],
              [-97.155122, 27.880615],
              [-97.144435, 27.894356],
              [-97.136615, 27.898956],
              [-97.135783, 27.899445],
              [-97.134801, 27.902467],
              [-97.129168, 27.919801],
              [-97.121534, 27.923364],
              [-97.075732, 27.986977],
              [-97.061992, 27.996138],
              [-97.04876, 28.022092],
              [-97.040618, 28.028708],
              [-97.030948, 28.033288],
              [-97.025859, 28.041939],
              [-97.031457, 28.053644],
              [-97.035528, 28.074],
              [-97.035528, 28.084688],
              [-97.031966, 28.093848],
              [-97.023824, 28.103517],
              [-97.022806, 28.107588],
              [-97.028913, 28.117258],
              [-97.027386, 28.124382],
              [-97.007539, 28.136087],
              [-97.000414, 28.137614],
              [-96.962755, 28.123365],
              [-96.934765, 28.123873],
              [-96.910337, 28.147283],
              [-96.898123, 28.152881],
              [-96.872678, 28.176291],
              [-96.842143, 28.193594],
              [-96.810037, 28.217086],
              [-96.800413, 28.224128],
              [-96.787181, 28.250083],
              [-96.787181, 28.255681],
              [-96.799302, 28.272716],
              [-96.806011, 28.282144],
              [-96.809573, 28.290287],
              [-96.806011, 28.296902],
              [-96.791761, 28.31217],
              [-96.791159, 28.319095],
              [-96.790744, 28.323874],
              [-96.79254, 28.336705],
              [-96.793765, 28.345453],
              [-96.793835, 28.345959],
              [-96.793926, 28.346606],
              [-96.794016, 28.347249],
              [-96.794306, 28.34932],
              [-96.794357, 28.350865],
              [-96.794812, 28.364503],
              [-96.794812, 28.364515],
              [-96.794815, 28.364587],
              [-96.794796, 28.364668],
              [-96.794554, 28.365688],
              [-96.790235, 28.383926],
              [-96.780796, 28.398421],
              [-96.775985, 28.405809],
              [-96.772209, 28.408074],
              [-96.768352, 28.410389],
              [-96.76696, 28.410737],
              [-96.762245, 28.411916],
              [-96.749013, 28.408862],
              [-96.72255, 28.408862],
              [-96.710336, 28.406827],
              [-96.705756, 28.400211],
              [-96.700158, 28.369676],
              [-96.705247, 28.348811],
              [-96.698122, 28.342704],
              [-96.69456, 28.347284],
              [-96.688453, 28.347284],
              [-96.672677, 28.335579],
              [-96.650794, 28.346775],
              [-96.600412, 28.354409],
              [-96.59176, 28.357462],
              [-96.570386, 28.368658],
              [-96.559699, 28.377819],
              [-96.542905, 28.385452],
              [-96.520513, 28.394104],
              [-96.504737, 28.397666],
              [-96.481836, 28.407844],
              [-96.46148, 28.421585],
              [-96.403973, 28.44245],
              [-96.402446, 28.449066],
              [-96.410589, 28.459244],
              [-96.419749, 28.467387],
              [-96.450284, 28.490796],
              [-96.505755, 28.525911],
              [-96.514406, 28.535071],
              [-96.52204, 28.55441],
              [-96.526111, 28.557972],
              [-96.536289, 28.559499],
              [-96.561226, 28.570695],
              [-96.564279, 28.576293],
              [-96.565297, 28.5824],
              [-96.573949, 28.584436],
              [-96.608045, 28.583418],
              [-96.611099, 28.585962],
              [-96.622804, 28.622095],
              [-96.61975, 28.627693],
              [-96.61059, 28.636344],
              [-96.61059, 28.638889],
              [-96.615679, 28.644487],
              [-96.623313, 28.649576],
              [-96.627893, 28.650085],
              [-96.634, 28.654665],
              [-96.635018, 28.668914],
              [-96.657918, 28.687744],
              [-96.664534, 28.696904],
              [-96.655528, 28.704167],
              [-96.648758, 28.709627],
              [-96.645867, 28.710457],
              [-96.634912, 28.713601],
              [-96.634419, 28.713743],
              [-96.604921, 28.72221],
              [-96.593796, 28.725403],
              [-96.591647, 28.724838],
              [-96.584196, 28.722877],
              [-96.584127, 28.722859],
              [-96.584091, 28.722798],
              [-96.580564, 28.716752],
              [-96.579669, 28.712455],
              [-96.579639, 28.712312],
              [-96.57802, 28.704538],
              [-96.577727, 28.704365],
              [-96.575141, 28.702837],
              [-96.566824, 28.697922],
              [-96.561226, 28.696395],
              [-96.559699, 28.691306],
              [-96.55919, 28.687235],
              [-96.570386, 28.674003],
              [-96.572931, 28.667897],
              [-96.563262, 28.644487],
              [-96.555119, 28.646013],
              [-96.54545, 28.645505],
              [-96.506264, 28.63838],
              [-96.499648, 28.635835],
              [-96.496595, 28.630746],
              [-96.497612, 28.625148],
              [-96.510335, 28.617515],
              [-96.510844, 28.61497],
              [-96.490488, 28.610899],
              [-96.485907, 28.607845],
              [-96.480309, 28.596649],
              [-96.482854, 28.580364],
              [-96.487943, 28.569677],
              [-96.473694, 28.57324],
              [-96.384635, 28.615988],
              [-96.376492, 28.620059],
              [-96.373439, 28.626675],
              [-96.328655, 28.640924],
              [-96.322921, 28.64186],
              [-96.303718, 28.644996],
              [-96.305245, 28.660263],
              [-96.304227, 28.671459],
              [-96.287942, 28.683164],
              [-96.268604, 28.688762],
              [-96.263515, 28.683673],
              [-96.256899, 28.68469],
              [-96.231453, 28.696395],
              [-96.222802, 28.698431],
              [-96.202446, 28.700976],
              [-96.19583, 28.69894],
              [-96.19125, 28.69436],
              [-96.192267, 28.687744],
              [-96.214659, 28.665352],
              [-96.208552, 28.662298],
              [-96.230944, 28.641433],
              [-96.212624, 28.622604],
              [-96.21415, 28.613443],
              [-96.222293, 28.607336],
              [-96.233998, 28.601738],
              [-96.233998, 28.596649],
              [-96.228909, 28.580873],
              [-96.221784, 28.580364],
              [-96.198374, 28.58698],
              [-96.187178, 28.593596],
              [-96.148501, 28.611408],
              [-96.099137, 28.624639],
              [-96.072165, 28.635326],
              [-96.047737, 28.649067],
              [-96.033488, 28.652629],
              [-96.006516, 28.648049],
              [-96.002954, 28.656192],
              [-95.996338, 28.658736],
              [-95.986066, 28.655468],
              [-95.978526, 28.650594],
              [-95.983106, 28.641942],
              [-95.985651, 28.621077],
              [-95.982088, 28.614461],
              [-95.98616, 28.606319],
              [-96.007534, 28.599703],
              [-96.032979, 28.589016],
              [-96.046211, 28.58698],
              [-96.104735, 28.559499],
              [-96.145448, 28.544741],
              [-96.21505, 28.509679],
              [-96.218978, 28.500383],
              [-96.223825, 28.495067],
              [-96.268341, 28.477992],
              [-96.335119, 28.437795],
              [-96.374138, 28.404275],
              [-96.37596, 28.401682],
              [-96.381864, 28.393276],
              [-96.379372, 28.386089],
              [-96.378616, 28.383909],
              [-96.370717, 28.387667],
              [-96.372101, 28.393875],
              [-96.371117, 28.397661],
              [-96.341617, 28.417334],
              [-96.328817, 28.423659],
              [-96.32156, 28.425148],
              [-96.303212, 28.441871],
              [-96.270391, 28.46193],
              [-96.244751, 28.475055],
              [-96.220376, 28.491966],
              [-96.194412, 28.502224],
              [-96.077868, 28.556626],
              [-96.000682, 28.588238],
              [-95.884026, 28.633098],
              [-95.812504, 28.664942],
              [-95.568136, 28.789998],
              [-95.507041, 28.824755],
              [-95.486769, 28.836287],
              [-95.439594, 28.859022],
              [-95.416174, 28.859482],
              [-95.38239, 28.866348],
              [-95.376979, 28.87616],
              [-95.353451, 28.898145],
              [-95.309704, 28.928262],
              [-95.297147, 28.934073],
              [-95.272266, 28.961546],
              [-95.238924, 28.988644],
              [-95.191391, 29.02309],
              [-95.125134, 29.067321],
              [-95.122525, 29.074],
              [-95.119271, 29.077844],
              [-95.110484, 29.088224],
              [-95.081773, 29.111222],
              [-95.026219, 29.148064],
              [-94.803695, 29.279237],
              [-94.786095, 29.290737],
              [-94.769695, 29.304936],
              [-94.731082, 29.331833],
              [-94.72253, 29.331446],
              [-94.73132, 29.338066],
              [-94.744945, 29.33641],
              [-94.745529, 29.334235],
              [-94.777064, 29.336811],
              [-94.779995, 29.334935],
              [-94.784895, 29.335535],
              [-94.810696, 29.353435],
              [-94.822307, 29.344254],
              [-94.822547, 29.321882],
              [-94.824953, 29.306005],
              [-94.84973, 29.297345],
              [-94.865126, 29.293977],
              [-94.875952, 29.293015],
              [-94.886536, 29.297826],
              [-94.893994, 29.30817],
              [-94.894234, 29.338],
              [-94.886536, 29.366386],
              [-94.8873, 29.415132],
              [-94.8908, 29.433432],
              [-94.919401, 29.448031],
              [-94.930861, 29.450504],
              [-94.925914, 29.469047],
              [-94.913385, 29.487254],
              [-94.909465, 29.496838],
              [-94.909898, 29.49691],
              [-94.933039, 29.500773],
              [-94.933483, 29.500847],
              [-94.934876, 29.501079],
              [-94.958443, 29.505013],
              [-94.981916, 29.511141],
              [-94.999581, 29.521093],
              [-95.013378, 29.537822],
              [-95.015165, 29.539989],
              [-95.016889, 29.548303],
              [-95.018191, 29.554584],
              [-95.018198, 29.554618],
              [-95.018253, 29.554885],
              [-95.016672, 29.558388],
              [-95.016627, 29.558487],
              [-95.016353, 29.55897],
              [-95.016145, 29.559336],
              [-95.00767, 29.574257],
              [-94.988993, 29.591155],
              [-94.982923, 29.600992],
              [-94.982855, 29.601103],
              [-94.982706, 29.601344],
              [-94.982936, 29.60167],
              [-94.984831, 29.604361],
              [-94.988871, 29.610095],
              [-94.999082, 29.618014],
              [-94.999481, 29.618323],
              [-95.00046, 29.619082],
              [-95.000781, 29.619331],
              [-95.01166, 29.627768],
              [-95.013499, 29.629194],
              [-95.013623, 29.62979],
              [-95.0156, 29.639285],
              [-95.015636, 29.639457],
              [-95.013777, 29.644322],
              [-95.01272, 29.647088],
              [-95.011683, 29.649802],
              [-95.011025, 29.650803],
              [-95.007623, 29.65598],
              [-95.006381, 29.657871],
              [-95.005648, 29.658985],
              [-95.005398, 29.659366],
              [-94.988924, 29.672202],
              [-94.972666, 29.68487],
              [-94.965963, 29.70033],
              [-94.942681, 29.697778],
              [-94.936089, 29.692704],
              [-94.934167, 29.678682],
              [-94.931154, 29.673874],
              [-94.921318, 29.658178],
              [-94.915413, 29.656614],
              [-94.893107, 29.661336],
              [-94.872551, 29.67125],
              [-94.867438, 29.678768],
              [-94.865007, 29.695337],
              [-94.851108, 29.721373],
              [-94.816085, 29.75671],
              [-94.792238, 29.767433],
              [-94.771512, 29.773889],
              [-94.740919, 29.787081],
              [-94.735271, 29.785433],
              [-94.724616, 29.774766],
              [-94.695317, 29.723052],
              [-94.692434, 29.70361],
              [-94.693154, 29.694453],
              [-94.708741, 29.625226],
              [-94.734626, 29.584046],
              [-94.755237, 29.562782],
              [-94.771053, 29.548439],
              [-94.779439, 29.549472],
              [-94.790605, 29.548401],
              [-94.78954, 29.546494],
              [-94.786649, 29.541319],
              [-94.786512, 29.541073],
              [-94.784034, 29.536635],
              [-94.783296, 29.535314],
              [-94.780938, 29.531093],
              [-94.779831, 29.530602],
              [-94.779708, 29.530548],
              [-94.779674, 29.530533],
              [-94.774798, 29.528372],
              [-94.774571, 29.528271],
              [-94.77084, 29.526618],
              [-94.769573, 29.526057],
              [-94.769418, 29.525988],
              [-94.768676, 29.525659],
              [-94.767246, 29.525523],
              [-94.757883, 29.524635],
              [-94.757788, 29.524626],
              [-94.757689, 29.524617],
              [-94.755514, 29.524776],
              [-94.740699, 29.525858],
              [-94.718276, 29.533547],
              [-94.691625, 29.537787],
              [-94.689353, 29.538306],
              [-94.682706, 29.539825],
              [-94.62589, 29.552808],
              [-94.621953, 29.553843],
              [-94.621819, 29.553878],
              [-94.618028, 29.554875],
              [-94.610147, 29.556947],
              [-94.593518, 29.561319],
              [-94.578211, 29.567281],
              [-94.570867, 29.571713],
              [-94.570593, 29.571878],
              [-94.570006, 29.572232],
              [-94.553988, 29.573882],
              [-94.546385, 29.572048],
              [-94.542532, 29.569],
              [-94.541108, 29.567561],
              [-94.532021, 29.558379],
              [-94.526336, 29.552634],
              [-94.523743, 29.545987],
              [-94.522421, 29.545672],
              [-94.511086, 29.542971],
              [-94.509487, 29.54259],
              [-94.503429, 29.54325],
              [-94.495025, 29.525031],
              [-94.511045, 29.51965],
              [-94.532348, 29.5178],
              [-94.546994, 29.524379],
              [-94.55399, 29.529559],
              [-94.566674, 29.531988],
              [-94.580274, 29.525295],
              [-94.591407, 29.513858],
              [-94.59544, 29.507669],
              [-94.594211, 29.492127],
              [-94.608557, 29.483345],
              [-94.628217, 29.475986],
              [-94.645948, 29.473769],
              [-94.656737, 29.478033],
              [-94.665853, 29.478401],
              [-94.6724, 29.476843],
              [-94.681541, 29.471389],
              [-94.686386, 29.466509],
              [-94.706365, 29.436805],
              [-94.723818, 29.426536],
              [-94.7541, 29.401],
              [-94.766848, 29.393489],
              [-94.783131, 29.375642],
              [-94.782356, 29.364266],
              [-94.778691, 29.361483],
              [-94.761491, 29.361883],
              [-94.744834, 29.369158],
              [-94.731047, 29.369141],
              [-94.723959, 29.383268],
              [-94.708473, 29.403049],
              [-94.694158, 29.415632],
              [-94.670389, 29.43078],
              [-94.631084, 29.451464],
              [-94.594853, 29.467903],
              [-94.500807, 29.505367],
              [-94.370866, 29.55507],
              [-94.354163, 29.561459],
              [-94.132577, 29.646217],
              [-94.056506, 29.671163],
              [-94.001406, 29.681486],
              [-93.931, 29.679612],
              [-93.88999, 29.674013],
              [-93.866981, 29.673085],
              [-93.852868, 29.675885],
              [-93.837971, 29.690619],
              [-93.892246, 29.765241],
              [-93.89847, 29.771577],
              [-93.890679, 29.843159],
              [-93.840799, 29.914423],
              [-93.789431, 29.987812],
              [-93.75663, 30.014163],
              [-93.752038, 30.016403],
              [-93.722481, 30.050898],
              [-93.721589, 30.051939],
              [-93.712101, 30.067346],
              [-93.695684, 30.135729],
              [-93.695252, 30.1476],
              [-93.712008, 30.194304],
              [-93.716223, 30.244318],
              [-93.720575, 30.295961],
              [-93.723586, 30.294951],
              [-93.735896, 30.29944],
              [-93.765822, 30.333318],
              [-93.757654, 30.390423],
              [-93.751437, 30.396288],
              [-93.741701, 30.403007],
              [-93.702665, 30.429947],
              [-93.698302, 30.438657],
              [-93.697828, 30.443838],
              [-93.710117, 30.5064],
              [-93.740045, 30.538765],
              [-93.727844, 30.57407],
              [-93.578395, 30.802047],
              [-93.563292, 30.818503],
              [-93.558672, 30.868829],
              [-93.558617, 30.869424],
              [-93.55497, 30.876685],
              [-93.554576, 30.87747],
              [-93.530936, 30.924534],
              [-93.540354, 31.008135],
              [-93.527644, 31.074509],
              [-93.531744, 31.180817],
              [-93.535097, 31.185614],
              [-93.548931, 31.186601],
              [-93.55254, 31.185605],
              [-93.552649, 31.185575],
              [-93.579215, 31.167422],
              [-93.588503, 31.165581],
              [-93.598828, 31.174679],
              [-93.599705, 31.176456],
              [-93.602315, 31.181742],
              [-93.607243, 31.204806],
              [-93.608158, 31.227835],
              [-93.614402, 31.260869],
              [-93.620829, 31.271299],
              [-93.644407, 31.27711],
              [-93.671676, 31.299586],
              [-93.640805, 31.372546],
              [-93.670182, 31.387184],
              [-93.695866, 31.409392],
              [-93.729613, 31.487922],
              [-93.798087, 31.534044],
              [-93.818582, 31.554826],
              [-93.834923, 31.58621],
              [-93.834924, 31.586211],
              [-93.82629, 31.614903],
              [-93.817059, 31.671694],
              [-93.812477, 31.715246],
              [-93.840029, 31.800596],
              [-93.878225, 31.844276],
              [-93.889193, 31.856819],
              [-93.92029, 31.888651],
              [-93.932135, 31.893672],
              [-93.975377, 31.92366],
              [-94.01563, 31.979856],
              [-94.04272, 31.999265],
              [-94.0427, 32.056012],
              [-94.042337, 32.119914],
              [-94.042681, 32.137956],
              [-94.042591, 32.158097],
              [-94.042539, 32.166826],
              [-94.042566, 32.166894],
              [-94.042621, 32.196005],
              [-94.042662, 32.218146],
              [-94.042732, 32.26962],
              [-94.042733, 32.269696],
              [-94.042739, 32.363559],
              [-94.042763, 32.373332],
              [-94.042901, 32.392283],
              [-94.042923, 32.399918],
              [-94.042899, 32.400659],
              [-94.042986, 32.435507],
              [-94.042908, 32.439891],
              [-94.042903, 32.470386],
              [-94.042875, 32.471348],
              [-94.042902, 32.472906],
              [-94.042995, 32.478004],
              [-94.042955, 32.480261],
              [-94.043072, 32.4843],
              [-94.043089, 32.486561],
              [-94.042911, 32.492852],
              [-94.042885, 32.505145],
              [-94.043081, 32.513613],
              [-94.043142, 32.559502],
              [-94.043083, 32.564261],
              [-94.042919, 32.610142],
              [-94.042929, 32.61826],
              [-94.042926, 32.622015],
              [-94.042824, 32.640305],
              [-94.04278, 32.643466],
              [-94.042913, 32.655127],
              [-94.043147, 32.69303],
              [-94.043147, 32.693031],
              [-94.042947, 32.767991],
              [-94.043027, 32.776863],
              [-94.042938, 32.780558],
              [-94.042829, 32.785277],
              [-94.042747, 32.786973],
              [-94.043026, 32.797476],
              [-94.042785, 32.871486],
              [-94.043025, 32.880446],
              [-94.042886, 32.880965],
              [-94.042886, 32.881089],
              [-94.042859, 32.892771],
              [-94.042885, 32.898911],
              [-94.043092, 32.910021],
              [-94.043067, 32.937903],
              [-94.043088, 32.955592],
              [-94.042964, 33.019219],
              [-94.043036, 33.079485],
              [-94.04287, 33.092727],
              [-94.043007, 33.13389],
              [-94.043077, 33.138162],
              [-94.043185, 33.143476],
              [-94.042875, 33.199785],
              [-94.042892, 33.202666],
              [-94.042876, 33.215219],
              [-94.04273, 33.241823],
              [-94.043004, 33.250128],
              [-94.04305, 33.260904],
              [-94.04299, 33.271227],
              [-94.04299, 33.271243],
              [-94.043067, 33.330498],
              [-94.043067, 33.347351],
              [-94.043067, 33.352097],
              [-94.043128, 33.358757],
              [-94.042869, 33.37117],
              [-94.043053, 33.377716],
              [-94.042887, 33.420225],
              [-94.042988, 33.431024],
              [-94.042988, 33.435824],
              [-94.043188, 33.470324],
              [-94.043279, 33.49103],
              [-94.043009, 33.493039],
              [-94.043375, 33.542315],
              [-94.043428, 33.551425],
              [-94.04345, 33.552253],
              [-94.066846, 33.568909],
              [-94.085243, 33.575546],
              [-94.181805, 33.593217],
              [-94.252656, 33.586144],
              [-94.257801, 33.582508],
              [-94.355945, 33.54318],
              [-94.409329, 33.568265],
              [-94.464336, 33.598819],
              [-94.470963, 33.60594],
              [-94.478366, 33.620847],
              [-94.485875, 33.637867],
              [-94.485577, 33.65331],
              [-94.485528, 33.663388],
              [-94.48452, 33.687909],
              [-94.484616, 33.691592],
              [-94.48384, 33.711332],
              [-94.483874, 33.716733],
              [-94.48287, 33.750564],
              [-94.482862, 33.75078],
              [-94.482777, 33.753638],
              [-94.482682, 33.756286],
              [-94.481842, 33.789008],
              [-94.481543, 33.795719],
              [-94.481361, 33.802649],
              [-94.481355, 33.802887],
              [-94.480574, 33.830166],
              [-94.479954, 33.85133],
              [-94.478994, 33.881197],
              [-94.478842, 33.881485],
              [-94.477387, 33.937759],
              [-94.477318, 33.940932],
              [-94.477038, 33.953838],
              [-94.476957, 33.957365],
              [-94.474895, 34.019655],
              [-94.474896, 34.021838],
              [-94.474896, 34.021877],
              [-94.470292, 34.189864],
              [-94.465847, 34.352073],
              [-94.465425, 34.359548],
              [-94.464176, 34.402713],
              [-94.463816, 34.414465],
              [-94.463671, 34.419585],
              [-94.461149, 34.507457],
              [-94.460058, 34.545264],
              [-94.460052, 34.547869],
              [-94.4575, 34.634945],
              [-94.45753, 34.642961],
              [-94.454576, 34.728962],
              [-94.450233, 34.855413],
              [-94.45014, 34.858694],
              [-94.450065, 34.861335],
              [-94.44963, 34.875253],
              [-94.449058, 34.890556],
              [-94.449086, 34.894152],
              [-94.449253, 34.895869],
              [-94.447889, 34.933941],
              [-94.441232, 35.119724],
              [-94.440754, 35.128806],
              [-94.43955, 35.169037],
              [-94.439509, 35.171807],
              [-94.439056, 35.193588],
              [-94.439084, 35.197298],
              [-94.43847, 35.208587],
              [-94.438247, 35.210992],
              [-94.437774, 35.239271],
              [-94.437578, 35.242202],
              [-94.435812, 35.2713],
              [-94.435706, 35.274267],
              [-94.435316, 35.275893],
              [-94.43528, 35.287485],
              [-94.43517, 35.291494],
              [-94.434115, 35.306493],
              [-94.431815, 35.362891],
              [-94.432685, 35.380806],
              [-94.433742, 35.386467],
              [-94.433915, 35.387391],
              [-94.431215, 35.39429],
              [-94.431789, 35.397659],
              [-94.463318, 35.58266],
              [-94.464097, 35.587265],
              [-94.464457, 35.588909],
              [-94.465272, 35.594037],
              [-94.472647, 35.638556],
              [-94.487585, 35.726147],
              [-94.48821, 35.72924],
              [-94.492932, 35.759166],
              [-94.493362, 35.761892],
              [-94.494549, 35.768303],
              [-94.499045, 35.79346],
              [-94.499647, 35.79691],
              [-94.500526, 35.802642],
              [-94.500764, 35.80382],
              [-94.501162, 35.80643],
              [-94.503011, 35.81721],
              [-94.504438, 35.826369],
              [-94.505642, 35.833628],
              [-94.507631, 35.845901],
              [-94.522658, 35.93425],
              [-94.522658, 35.934799],
              [-94.522634, 35.934892],
              [-94.52291, 35.936127],
              [-94.524344, 35.94405],
              [-94.52464, 35.945727],
              [-94.528162, 35.965665],
              [-94.528305, 35.966054],
              [-94.532071, 35.987852],
              [-94.533646, 35.996804],
              [-94.534852, 36.002678],
              [-94.535724, 36.007807],
              [-94.547715, 36.077271],
              [-94.547871, 36.078281],
              [-94.552184, 36.102235],
              [-94.561165, 36.15211],
              [-94.562803, 36.161749],
              [-94.562828, 36.161895],
              [-94.565655, 36.178439],
              [-94.566588, 36.183774],
              [-94.571253, 36.210901],
              [-94.571806, 36.213748],
              [-94.574395, 36.229996],
              [-94.57488, 36.232741],
              [-94.575071, 36.233682],
              [-94.576003, 36.24007],
              [-94.577899, 36.249548],
              [-94.577883, 36.25008],
              [-94.5862, 36.299969],
              [-94.593397, 36.345742],
              [-94.599723, 36.387587],
              [-94.601984, 36.40212],
              [-94.602623, 36.405283],
              [-94.605408, 36.421949],
              [-94.611609, 36.461528],
              [-94.61383, 36.476248],
              [-94.615311, 36.484992],
              [-94.617919, 36.499414],
              [-94.617877, 36.514999],
              [-94.617883, 36.517799],
              [-94.617997, 36.53428],
              [-94.617868, 36.53609],
              [-94.617897, 36.536983],
              [-94.617814, 36.577732],
              [-94.617853, 36.59912],
              [-94.617865, 36.606851],
              [-94.617815, 36.612604],
              [-94.618019, 36.667921],
              [-94.618025, 36.66943],
              [-94.61813, 36.701423],
              [-94.618307, 36.76656],
              [-94.61838, 36.84732],
              [-94.618658, 36.880064],
              [-94.618243, 36.897027],
              [-94.618282, 36.911472],
              [-94.618207, 36.926236],
              [-94.618295, 36.929647],
              [-94.618166, 36.937584],
              [-94.618109, 36.946564],
              [-94.618026, 36.950158],
              [-94.618031, 36.994704],
              [-94.618049, 36.996208],
              [-94.61808, 36.998135],
              [-94.699735, 36.998805],
              [-94.701797, 36.998814],
              [-94.71277, 36.998794],
              [-94.737183, 36.998665],
              [-94.739324, 36.998687],
              [-94.777257, 36.998764],
              [-94.83128, 36.998812],
              [-94.840926, 36.998833],
              [-94.849801, 36.998876],
              [-94.853197, 36.998874],
              [-94.995293, 36.999529],
              [-95.00762, 36.999514],
              [-95.011433, 36.999535],
              [-95.030324, 36.999517],
              [-95.037857, 36.999497],
              [-95.049499, 36.99958],
              [-95.073504, 36.999509],
              [-95.073509, 36.999509],
              [-95.155187, 36.999539],
              [-95.155372, 36.99954],
              [-95.177301, 36.99952],
              [-95.195307, 36.999565],
              [-95.322565, 36.999358],
              [-95.328058, 36.999365],
              [-95.328327, 36.999366],
              [-95.33121, 36.99938],
              [-95.407572, 36.999241],
              [-95.407683, 36.999241],
              [-95.511578, 36.999235],
              [-95.522415, 36.999281],
              [-95.534401, 36.999332],
              [-95.573598, 36.99931],
              [-95.61214, 36.999321],
              [-95.615934, 36.999365],
              [-95.62435, 36.99936],
              [-95.630079, 36.99932],
              [-95.664301, 36.999322],
              [-95.686452, 36.999349],
              [-95.696659, 36.999215],
              [-95.71038, 36.999371],
              [-95.714887, 36.999279],
              [-95.718054, 36.999255],
              [-95.741908, 36.999244],
              [-95.759905, 36.999271],
              [-95.768719, 36.999205],
              [-95.786762, 36.99931],
              [-95.80798, 36.999124],
              [-95.866899, 36.999261],
              [-95.873944, 36.9993],
              [-95.875257, 36.999302],
              [-95.877151, 36.999304],
              [-95.91018, 36.999336],
              [-95.928122, 36.999245],
              [-95.936992, 36.999268],
              [-95.96427, 36.999094],
              [-96.00081, 36.99886],
              [-96.14121, 36.998973],
              [-96.143207, 36.999134],
              [-96.147143, 36.999022],
              [-96.149709, 36.99904],
              [-96.152384, 36.999051],
              [-96.154017, 36.999161],
              [-96.184768, 36.999211],
              [-96.200028, 36.999028],
              [-96.217571, 36.99907],
              [-96.276368, 36.999271],
              [-96.279079, 36.999272],
              [-96.394272, 36.999221],
              [-96.415412, 36.999113],
              [-96.525493, 36.999147],
              [-96.705431, 36.999203],
              [-96.710482, 36.999271],
              [-96.73659, 36.999286],
              [-96.74127, 36.999239],
              [-96.749838, 36.998988],
              [-96.79206, 36.99918],
              [-96.795199, 36.99886],
              [-96.822791, 36.999182],
              [-96.867517, 36.999217],
              [-96.87629, 36.999233],
              [-96.902083, 36.999155],
              [-96.90351, 36.999132],
              [-96.917093, 36.999182],
              [-96.921915, 36.999151],
              [-96.934642, 36.99907],
              [-96.967371, 36.999067],
              [-96.975562, 36.999019],
              [-97.030082, 36.998929],
              [-97.039784, 36.999],
              [-97.100652, 36.998998],
              [-97.104276, 36.99902],
              [-97.120285, 36.999014],
              [-97.122597, 36.999036],
              [-97.147721, 36.999111],
              [-97.372421, 36.998861],
              [-97.384925, 36.998843],
              [-97.46228, 36.998685],
              [-97.462346, 36.998685],
              [-97.472861, 36.998721],
              [-97.527292, 36.99875],
              [-97.5459, 36.998709],
              [-97.546498, 36.998747],
              [-97.564536, 36.998711],
              [-97.606549, 36.998682],
              [-97.637137, 36.99909],
              [-97.650466, 36.999004],
              [-97.697104, 36.998826],
              [-97.768704, 36.99875],
              [-97.783432, 36.998961],
              [-97.783489, 36.998847],
              [-97.802298, 36.998713],
              [-97.802313, 36.998713],
              [-98.033955, 36.998366],
              [-98.03989, 36.998349],
              [-98.045342, 36.998327],
              [-98.111985, 36.998133],
              [-98.147452, 36.998162],
              [-98.177596, 36.998009],
              [-98.208218, 36.997997],
              [-98.219499, 36.997824],
              [-98.237712, 36.997972],
              [-98.346188, 36.997962],
              [-98.347149, 36.997962],
              [-98.354073, 36.997961],
              [-98.408991, 36.998513],
              [-98.418268, 36.998538],
              [-98.420209, 36.998516],
              [-98.54466, 36.998996],
              [-98.544872, 36.998997],
              [-98.714512, 36.99906],
              [-98.718465, 36.99918],
              [-98.761597, 36.999425],
              [-98.791936, 36.999255],
              [-98.793711, 36.999227],
              [-98.797452, 36.999229],
              [-98.869449, 36.999286],
              [-98.880009, 36.999263],
              [-98.88058, 36.999309],
              [-98.994371, 36.999493],
              [-99.000303, 36.99951],
              [-99.029337, 36.999595],
              [-99.124883, 36.99942],
              [-99.129449, 36.999422],
              [-99.24812, 36.999565],
              [-99.277506, 36.999579],
              [-99.456203, 36.999471],
              [-99.484333, 36.999626],
              [-99.500395, 36.999576],
              [-99.500395, 36.999637],
              [-99.502665, 36.999645],
              [-99.504093, 36.999648],
              [-99.508574, 36.999658],
              [-99.541116, 36.999573],
              [-99.558068, 36.999528],
              [-99.625399, 36.999671],
              [-99.657658, 37.000197],
              [-99.774255, 37.000837],
              [-99.774816, 37.000841],
              [-99.786016, 37.000931],
              [-99.995201, 37.001631],
              [-100.001286, 37.001699],
              [-100.002563, 37.001706],
              [-100.005706, 37.001726],
              [-100.089484, 37.002092],
              [-100.115722, 37.002206],
              [-100.187547, 37.002082],
              [-100.192371, 37.002036],
              [-100.193754, 37.002133],
              [-100.201676, 37.002081],
              [-100.551598, 37.00062],
              [-100.552683, 37.000735],
              [-100.591328, 37.000376],
              [-100.591413, 37.000399],
              [-100.62977, 37.000025],
              [-100.633323, 36.999936],
              [-100.633327, 36.999936],
              [-100.675552, 36.999688],
              [-100.756894, 36.999357],
              [-100.765484, 36.999177],
              [-100.806116, 36.999091],
              [-100.814277, 36.999085],
              [-100.855634, 36.998626],
              [-100.89166, 36.998604],
              [-100.904274, 36.998745],
              [-100.904588, 36.998561],
              [-100.945469, 36.998153],
              [-100.945566, 36.998152],
              [-100.996502, 36.998044],
              [-101.012641, 36.998176],
              [-101.053589, 36.997967],
              [-101.066742, 36.997921],
              [-101.211486, 36.997124],
              [-101.212909, 36.997044],
              [-101.357797, 36.996271],
              [-101.359674, 36.996232],
              [-101.37818, 36.996164],
              [-101.413868, 36.996008],
              [-101.415005, 36.995966],
              [-101.485326, 36.995611],
              [-101.519066, 36.995546],
              [-101.555239, 36.995414],
              [-101.55526, 36.995414],
              [-101.600396, 36.995153],
              [-101.601593, 36.995095],
              [-101.90244, 36.993702],
              [-102.000447, 36.993249],
              [-102.000447, 36.993272],
              [-102.028204, 36.993125],
              [-102.028207, 36.993125],
              [-102.04224, 36.993083],
              [-102.054503, 36.993109],
              [-102.184271, 36.993593],
              [-102.208316, 36.99373],
              [-102.355288, 36.994506],
              [-102.355367, 36.994575],
              [-102.570896, 36.995136],
              [-102.875481, 36.999628],
              [-102.979613, 36.998549],
              [-102.985807, 36.998571],
              [-102.986976, 36.998524],
              [-103.002199, 37.000104],
              [-103.086105, 36.999864],
              [-103.733247, 36.998016],
              [-103.734364, 36.998041],
              [-104.007855, 36.996239],
              [-104.732031, 36.993447],
              [-104.73212, 36.993484],
              [-105.000554, 36.993264],
              [-105.1208, 36.995428],
              [-105.155042, 36.995339],
              [-105.220613, 36.995169],
              [-105.41931, 36.995856],
              [-105.442459, 36.995994],
              [-105.447255, 36.996017],
              [-105.465182, 36.995991],
              [-105.508836, 36.995895],
              [-105.512485, 36.995777],
              [-105.533922, 36.995875],
              [-105.62747, 36.995679],
              [-105.66472, 36.995874],
              [-105.716471, 36.995849],
              [-105.71847, 36.995846],
              [-105.996159, 36.995418],
              [-105.997472, 36.995417],
              [-106.006634, 36.995343],
              [-106.247705, 36.994266],
              [-106.248675, 36.994288],
              [-106.476228, 36.993472],
              [-106.617159, 36.992967],
              [-106.617125, 36.993004],
              [-106.628652, 36.993175],
              [-106.628733, 36.993161],
              [-106.661344, 36.993243],
              [-106.675626, 36.993123],
              [-106.869796, 36.992426],
              [-107.000592, 37.000009],
              [-107.420913, 37.000005],
              [-107.420915, 37.000005],
              [-107.481737, 36.999973],
              [-108.288086, 36.999555],
              [-108.2884, 36.99952],
              [-108.320464, 36.999499],
              [-108.320721, 36.99951],
              [-108.379203, 36.999459],
              [-108.619689, 36.999249],
              [-108.620309, 36.999287],
              [-108.954404, 36.998906],
              [-108.958868, 36.998913],
              [-109.045223, 36.999084],
              [-109.181196, 36.999271],
              [-109.233848, 36.999266],
              [-109.246917, 36.999346],
              [-109.26339, 36.999263],
              [-109.268213, 36.999242],
              [-109.270097, 36.999266],
              [-109.378039, 36.999135],
              [-109.381226, 36.999148],
              [-110.000677, 36.997968],
              [-110.33105, 36.998216],
              [-110.495259, 37.003875],
              [-110.75069, 37.003197],
              [-111.189888, 37.000959],
              [-111.405517, 37.001497],
              [-111.405869, 37.001481],
              [-111.412784, 37.001478],
              [-112.35769, 37.001025],
              [-112.368946, 37.001125],
              [-112.534545, 37.000684],
              [-112.538593, 37.000674],
              [-112.540368, 37.000669],
              [-112.545094, 37.000734],
              [-112.558974, 37.000692],
              [-112.609787, 37.000753],
              [-112.899366, 37.000319],
              [-112.966471, 37.000219],
              [-113.965907, 36.999976],
              [-113.965907, 37.000025],
              [-114.0506, 37.000396],
              [-114.050583, 36.843141],
              [-114.050578, 36.800173],
              [-114.050562, 36.656259],
              [-114.046488, 36.473449],
              [-114.046403, 36.371873],
              [-114.048515, 36.289598],
              [-114.047106, 36.250591],
              [-114.046838, 36.194069],
              [-114.060302, 36.189363],
              [-114.063021, 36.186942],
              [-114.120193, 36.102228],
              [-114.125796, 36.077531],
              [-114.138202, 36.041284],
              [-114.148774, 36.02731],
              [-114.15413, 36.023862],
              [-114.21369, 36.015613],
              [-114.233289, 36.014289],
              [-114.238799, 36.014561],
              [-114.252651, 36.020193],
              [-114.263146, 36.025937],
              [-114.292663, 36.051118],
              [-114.303614, 36.066456],
              [-114.307235, 36.076544],
              [-114.310857, 36.083787],
              [-114.328777, 36.105501],
              [-114.365835, 36.133722],
              [-114.381446, 36.141665],
              [-114.513256, 36.151217],
              [-114.572031, 36.15161],
              [-114.631716, 36.142306],
              [-114.736165, 36.104367],
              [-114.744857, 36.098693],
              [-114.755618, 36.087166],
              [-114.743576, 35.983721],
              [-114.731296, 35.945157],
              [-114.70613, 35.878712],
              [-114.704211, 35.851984],
              [-114.705611, 35.848884],
              [-114.70771, 35.811885],
              [-114.700308, 35.700387],
              [-114.689407, 35.651412],
              [-114.676707, 35.640989],
              [-114.657506, 35.618289],
              [-114.653406, 35.610789],
              [-114.653806, 35.59949],
              [-114.671147, 35.520641],
              [-114.674981, 35.510564],
              [-114.676733, 35.499063],
              [-114.677643, 35.489742],
              [-114.662125, 35.444241],
              [-114.652005, 35.429165],
              [-114.627137, 35.409504],
              [-114.604314, 35.353584],
              [-114.595931, 35.325234],
              [-114.569238, 35.18348],
              [-114.569569, 35.163053],
              [-114.572747, 35.138725],
              [-114.578524, 35.12875],
              [-114.5843, 35.124999],
              [-114.59912, 35.12105],
              [-114.621956, 35.094678],
              [-114.635469, 35.028266],
              [-114.633544, 35.015644],
              [-114.633013, 35.002085],
              [-114.62919, 34.991887],
              [-114.629015, 34.986148],
              [-114.630877, 34.907263],
              [-114.636725, 34.889107],
              [-114.635176, 34.875003],
              [-114.633051, 34.869971],
              [-114.552682, 34.766871],
              [-114.465607, 34.69226],
              [-114.452547, 34.653494],
              [-114.339627, 34.451435],
              [-114.264317, 34.401329],
              [-114.199482, 34.361373],
              [-114.176909, 34.349306],
              [-114.138282, 34.30323],
              [-114.131489, 34.260387],
              [-114.133264, 34.258462],
              [-114.164476, 34.251667],
              [-114.225861, 34.201774],
              [-114.244191, 34.179625],
              [-114.312592, 34.144453],
              [-114.321618, 34.138093],
              [-114.366521, 34.118575],
              [-114.390565, 34.110084],
              [-114.401352, 34.111652],
              [-114.411681, 34.110031],
              [-114.420499, 34.103466],
              [-114.43338, 34.088413],
              [-114.435429, 34.079727],
              [-114.434949, 34.037784],
              [-114.438266, 34.022609],
              [-114.46361, 33.993431],
              [-114.499883, 33.961789],
              [-114.518434, 33.917518],
              [-114.525539, 33.838614],
              [-114.523365, 33.80612],
              [-114.50434, 33.756381],
              [-114.494197, 33.707922],
              [-114.496489, 33.696901],
              [-114.519113, 33.688473],
              [-114.523959, 33.685879],
              [-114.530348, 33.679245],
              [-114.540617, 33.591412],
              [-114.5403, 33.580615],
              [-114.535965, 33.569154],
              [-114.535664, 33.568788],
              [-114.558898, 33.531819],
              [-114.594534, 33.495059],
              [-114.622918, 33.456561],
              [-114.627125, 33.433554],
              [-114.665278, 33.415358],
              [-114.721233, 33.396912],
              [-114.700103, 33.341045],
              [-114.672088, 33.258499],
              [-114.67536, 33.185489],
              [-114.679359, 33.159519],
              [-114.687074, 33.142196],
              [-114.696829, 33.131209],
              [-114.706175, 33.105335],
              [-114.707819, 33.091102],
              [-114.675104, 33.047532],
              [-114.62387, 33.02872],
              [-114.606282, 33.025703],
              [-114.589778, 33.026228],
              [-114.584765, 33.028231],
              [-114.578287, 33.035375],
              [-114.571653, 33.036624],
              [-114.523578, 33.030961],
              [-114.516912, 33.026871],
              [-114.511343, 33.023455],
              [-114.468605, 32.971649],
              [-114.46289, 32.905797],
              [-114.465715, 32.87942],
              [-114.465715, 32.879191],
              [-114.496284, 32.822326],
              [-114.496827, 32.822119],
              [-114.615733, 32.729427],
              [-114.615585, 32.728446],
              [-114.65826, 32.733799],
              [-114.65884, 32.73383],
              [-114.677091, 32.736218],
              [-114.678632, 32.736614],
              [-114.719633, 32.718763],
              [-114.748, 32.664184],
              [-114.753111, 32.658304],
              [-114.781872, 32.62505],
              [-114.799302, 32.625115],
              [-114.80739, 32.621332],
              [-114.809393, 32.617119],
              [-114.813613, 32.494277],
              [-114.250775, 32.32391],
              [-113.493196, 32.088943],
              [-113.333794, 32.038521],
              [-113.125961, 31.97278],
              [-112.867074, 31.895488],
              [-112.246102, 31.704195],
              [-111.57953, 31.494095],
              [-111.366635, 31.42588],
              [-111.098097, 31.339836],
              [-110.976828, 31.33256],
              [-110.760997, 31.332765],
              [-110.460172, 31.333051],
              [-109.426931, 31.334033],
              [-109.050044, 31.332502],
            ],
          ],
          [
            [
              [-96.83003, 28.111842],
              [-96.84538, 28.108881],
              [-96.857165, 28.115559],
              [-96.864628, 28.126296],
              [-96.870782, 28.131271],
              [-96.874972, 28.133236],
              [-96.879424, 28.131402],
              [-96.886887, 28.11713],
              [-96.889113, 28.099454],
              [-96.888328, 28.086622],
              [-96.886233, 28.084396],
              [-96.890947, 28.076802],
              [-96.906004, 28.076147],
              [-96.927085, 28.057292],
              [-96.929573, 28.0514],
              [-96.92643, 28.043413],
              [-96.932454, 28.035426],
              [-96.946988, 28.026522],
              [-96.952618, 28.01644],
              [-96.962569, 28.012381],
              [-96.965188, 28.013297],
              [-96.966759, 28.020368],
              [-96.967807, 28.020041],
              [-96.978282, 28.001709],
              [-96.986661, 27.980759],
              [-96.986007, 27.976177],
              [-96.9809, 27.978272],
              [-96.978805, 27.978272],
              [-96.977889, 27.976439],
              [-96.985745, 27.954048],
              [-97.016384, 27.917255],
              [-97.017955, 27.911494],
              [-97.013634, 27.90678],
              [-97.043226, 27.859119],
              [-97.055823, 27.843404],
              [-97.056713, 27.842294],
              [-97.132394, 27.827301],
              [-97.134489, 27.825206],
              [-97.130299, 27.820493],
              [-97.126109, 27.819707],
              [-97.098874, 27.82285],
              [-97.092589, 27.819183],
              [-97.092851, 27.81447],
              [-97.098874, 27.808447],
              [-97.102279, 27.798233],
              [-97.103326, 27.789068],
              [-97.127681, 27.76],
              [-97.127942, 27.75581],
              [-97.130823, 27.75162],
              [-97.147321, 27.735384],
              [-97.153606, 27.733289],
              [-97.1612, 27.734074],
              [-97.166176, 27.732372],
              [-97.170628, 27.720326],
              [-97.190007, 27.692829],
              [-97.203089, 27.688001],
              [-97.203474, 27.684533],
              [-97.197601, 27.678426],
              [-97.197339, 27.664547],
              [-97.200743, 27.650144],
              [-97.214099, 27.631551],
              [-97.219075, 27.630241],
              [-97.221955, 27.63286],
              [-97.231383, 27.632336],
              [-97.242643, 27.607458],
              [-97.241072, 27.602483],
              [-97.236882, 27.598293],
              [-97.247619, 27.581533],
              [-97.247877, 27.581366],
              [-97.252071, 27.578652],
              [-97.260451, 27.567392],
              [-97.26176, 27.563464],
              [-97.257832, 27.556393],
              [-97.266474, 27.542514],
              [-97.282972, 27.521564],
              [-97.293709, 27.497209],
              [-97.317277, 27.46369],
              [-97.329847, 27.43436],
              [-97.330895, 27.425456],
              [-97.329585, 27.418124],
              [-97.331157, 27.412362],
              [-97.336132, 27.402411],
              [-97.346607, 27.390365],
              [-97.361796, 27.359988],
              [-97.366771, 27.333276],
              [-97.36232, 27.32673],
              [-97.357606, 27.307875],
              [-97.359963, 27.304732],
              [-97.364676, 27.302637],
              [-97.367033, 27.298709],
              [-97.372861, 27.278069],
              [-97.373318, 27.27645],
              [-97.37489, 27.250262],
              [-97.382222, 27.229051],
              [-97.386674, 27.204696],
              [-97.379865, 27.202863],
              [-97.377508, 27.199459],
              [-97.390078, 27.156512],
              [-97.390602, 27.094186],
              [-97.387459, 27.090519],
              [-97.386412, 27.083187],
              [-97.389816, 27.067213],
              [-97.39034, 27.052286],
              [-97.389554, 26.945965],
              [-97.391649, 26.90197],
              [-97.385626, 26.888876],
              [-97.383531, 26.875521],
              [-97.387459, 26.820789],
              [-97.373056, 26.808481],
              [-97.368343, 26.795649],
              [-97.370438, 26.781508],
              [-97.368866, 26.774699],
              [-97.364646, 26.767122],
              [-97.364153, 26.758987],
              [-97.367557, 26.740394],
              [-97.370961, 26.736204],
              [-97.370438, 26.723896],
              [-97.363105, 26.71054],
              [-97.345822, 26.700589],
              [-97.336394, 26.666022],
              [-97.338489, 26.647429],
              [-97.324872, 26.611814],
              [-97.318458, 26.60027],
              [-97.317015, 26.597673],
              [-97.308635, 26.576723],
              [-97.308112, 26.571223],
              [-97.31073, 26.556558],
              [-97.292399, 26.528014],
              [-97.276425, 26.521729],
              [-97.262546, 26.482972],
              [-97.254166, 26.471188],
              [-97.247619, 26.456261],
              [-97.243167, 26.434263],
              [-97.240849, 26.411504],
              [-97.240286, 26.405981],
              [-97.226931, 26.385555],
              [-97.214885, 26.353606],
              [-97.194458, 26.27164],
              [-97.183983, 26.214289],
              [-97.178746, 26.177103],
              [-97.179532, 26.146202],
              [-97.171781, 26.102522],
              [-97.169842, 26.077853],
              [-97.161462, 26.06764],
              [-97.154271, 26.066841],
              [-97.161471, 26.088705],
              [-97.173265, 26.192314],
              [-97.185844, 26.267103],
              [-97.194644, 26.306513],
              [-97.223728, 26.411492],
              [-97.229844, 26.433569],
              [-97.269392, 26.554046],
              [-97.275119, 26.565415],
              [-97.287885, 26.600341],
              [-97.30069, 26.635375],
              [-97.333028, 26.736479],
              [-97.351413, 26.808604],
              [-97.364726, 26.871693],
              [-97.370731, 26.909706],
              [-97.378362, 26.992877],
              [-97.37913, 27.047996],
              [-97.377001, 27.101021],
              [-97.370941, 27.161166],
              [-97.363401, 27.210366],
              [-97.350398, 27.268105],
              [-97.347438, 27.277963],
              [-97.326523, 27.347612],
              [-97.30447, 27.407734],
              [-97.276091, 27.472145],
              [-97.221912, 27.576315],
              [-97.201866, 27.614858],
              [-97.166682, 27.676583],
              [-97.116277, 27.752599],
              [-97.085395, 27.793245],
              [-97.04598, 27.835004],
              [-97.045409, 27.837452],
              [-97.041799, 27.852926],
              [-97.03166, 27.869975],
              [-97.001441, 27.911442],
              [-96.966996, 27.950531],
              [-96.929053, 27.99044],
              [-96.853455, 28.061345],
              [-96.849624, 28.064939],
              [-96.758141, 28.136873],
              [-96.694666, 28.18212],
              [-96.621534, 28.2297],
              [-96.547774, 28.270798],
              [-96.439099, 28.319052],
              [-96.4137, 28.327343],
              [-96.397846, 28.343513],
              [-96.401242, 28.366892],
              [-96.403206, 28.371475],
              [-96.412896, 28.369511],
              [-96.417217, 28.367154],
              [-96.415253, 28.362833],
              [-96.418919, 28.354846],
              [-96.434108, 28.344764],
              [-96.450998, 28.337039],
              [-96.476269, 28.330754],
              [-96.528906, 28.322505],
              [-96.542131, 28.315958],
              [-96.546975, 28.305614],
              [-96.55326, 28.302341],
              [-96.581019, 28.30221],
              [-96.592934, 28.296972],
              [-96.61048, 28.283093],
              [-96.611527, 28.281391],
              [-96.608123, 28.280081],
              [-96.607992, 28.27707],
              [-96.651856, 28.251275],
              [-96.663116, 28.233206],
              [-96.660628, 28.228885],
              [-96.662462, 28.227314],
              [-96.686816, 28.21841],
              [-96.703314, 28.216446],
              [-96.702659, 28.211208],
              [-96.697422, 28.202959],
              [-96.703838, 28.198246],
              [-96.733037, 28.190913],
              [-96.791958, 28.188687],
              [-96.816443, 28.174808],
              [-96.818656, 28.17228],
              [-96.822859, 28.167476],
              [-96.820315, 28.163494],
              [-96.816836, 28.158048],
              [-96.810944, 28.136378],
              [-96.81042, 28.126034],
              [-96.816574, 28.119618],
              [-96.827049, 28.112417],
              [-96.83003, 28.111842],
            ],
          ],
        ],
      },
      properties: { region: 'SOUTHWEST' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-94.042964, 33.019219],
              [-94.043088, 32.955592],
              [-94.043067, 32.937903],
              [-94.043092, 32.910021],
              [-94.042885, 32.898911],
              [-94.042859, 32.892771],
              [-94.042886, 32.881089],
              [-94.042886, 32.880965],
              [-94.043025, 32.880446],
              [-94.042785, 32.871486],
              [-94.043026, 32.797476],
              [-94.042747, 32.786973],
              [-94.042829, 32.785277],
              [-94.042938, 32.780558],
              [-94.043027, 32.776863],
              [-94.042947, 32.767991],
              [-94.043147, 32.693031],
              [-94.043147, 32.69303],
              [-94.042913, 32.655127],
              [-94.04278, 32.643466],
              [-94.042824, 32.640305],
              [-94.042926, 32.622015],
              [-94.042929, 32.61826],
              [-94.042919, 32.610142],
              [-94.043083, 32.564261],
              [-94.043142, 32.559502],
              [-94.043081, 32.513613],
              [-94.042885, 32.505145],
              [-94.042911, 32.492852],
              [-94.043089, 32.486561],
              [-94.043072, 32.4843],
              [-94.042955, 32.480261],
              [-94.042995, 32.478004],
              [-94.042902, 32.472906],
              [-94.042875, 32.471348],
              [-94.042903, 32.470386],
              [-94.042908, 32.439891],
              [-94.042986, 32.435507],
              [-94.042899, 32.400659],
              [-94.042923, 32.399918],
              [-94.042901, 32.392283],
              [-94.042763, 32.373332],
              [-94.042739, 32.363559],
              [-94.042733, 32.269696],
              [-94.042732, 32.26962],
              [-94.042662, 32.218146],
              [-94.042621, 32.196005],
              [-94.042566, 32.166894],
              [-94.042539, 32.166826],
              [-94.042591, 32.158097],
              [-94.042681, 32.137956],
              [-94.042337, 32.119914],
              [-94.0427, 32.056012],
              [-94.04272, 31.999265],
              [-94.01563, 31.979856],
              [-93.975377, 31.92366],
              [-93.932135, 31.893672],
              [-93.92029, 31.888651],
              [-93.889193, 31.856819],
              [-93.878225, 31.844276],
              [-93.840029, 31.800596],
              [-93.812477, 31.715246],
              [-93.817059, 31.671694],
              [-93.82629, 31.614903],
              [-93.834924, 31.586211],
              [-93.834923, 31.58621],
              [-93.818582, 31.554826],
              [-93.798087, 31.534044],
              [-93.729613, 31.487922],
              [-93.695866, 31.409392],
              [-93.670182, 31.387184],
              [-93.640805, 31.372546],
              [-93.671676, 31.299586],
              [-93.644407, 31.27711],
              [-93.620829, 31.271299],
              [-93.614402, 31.260869],
              [-93.608158, 31.227835],
              [-93.607243, 31.204806],
              [-93.602315, 31.181742],
              [-93.599705, 31.176456],
              [-93.598828, 31.174679],
              [-93.588503, 31.165581],
              [-93.579215, 31.167422],
              [-93.552649, 31.185575],
              [-93.55254, 31.185605],
              [-93.548931, 31.186601],
              [-93.535097, 31.185614],
              [-93.531744, 31.180817],
              [-93.527644, 31.074509],
              [-93.540354, 31.008135],
              [-93.530936, 30.924534],
              [-93.554576, 30.87747],
              [-93.55497, 30.876685],
              [-93.558617, 30.869424],
              [-93.558672, 30.868829],
              [-93.563292, 30.818503],
              [-93.578395, 30.802047],
              [-93.727844, 30.57407],
              [-93.740045, 30.538765],
              [-93.710117, 30.5064],
              [-93.697828, 30.443838],
              [-93.698302, 30.438657],
              [-93.702665, 30.429947],
              [-93.741701, 30.403007],
              [-93.751437, 30.396288],
              [-93.757654, 30.390423],
              [-93.765822, 30.333318],
              [-93.735896, 30.29944],
              [-93.723586, 30.294951],
              [-93.720575, 30.295961],
              [-93.716223, 30.244318],
              [-93.712008, 30.194304],
              [-93.695252, 30.1476],
              [-93.695684, 30.135729],
              [-93.712101, 30.067346],
              [-93.721589, 30.051939],
              [-93.722481, 30.050898],
              [-93.752038, 30.016403],
              [-93.75663, 30.014163],
              [-93.789431, 29.987812],
              [-93.840799, 29.914423],
              [-93.890679, 29.843159],
              [-93.89847, 29.771577],
              [-93.892246, 29.765241],
              [-93.837971, 29.690619],
              [-93.818995, 29.704076],
              [-93.79925, 29.71526],
              [-93.766048, 29.7295],
              [-93.741948, 29.736343],
              [-93.68364, 29.747153],
              [-93.635304, 29.752806],
              [-93.590786, 29.755649],
              [-93.538462, 29.763299],
              [-93.475252, 29.769242],
              [-93.438973, 29.768949],
              [-93.372029, 29.763049],
              [-93.347331, 29.759046],
              [-93.344993, 29.759618],
              [-93.342104, 29.763402],
              [-93.295573, 29.775071],
              [-93.267456, 29.778113],
              [-93.226934, 29.777519],
              [-93.17693, 29.770487],
              [-93.088182, 29.749125],
              [-93.065354, 29.740966],
              [-92.974305, 29.71398],
              [-92.940455, 29.701033],
              [-92.871232, 29.670028],
              [-92.744126, 29.617608],
              [-92.653651, 29.588065],
              [-92.617725, 29.579092],
              [-92.61627, 29.578729],
              [-92.558602, 29.569935],
              [-92.473585, 29.561081],
              [-92.402165, 29.551269],
              [-92.347236, 29.539394],
              [-92.309357, 29.533026],
              [-92.280392, 29.533434],
              [-92.25186, 29.539354],
              [-92.21259, 29.562479],
              [-92.158624, 29.581616],
              [-92.105923, 29.586335],
              [-92.066533, 29.583842],
              [-92.046316, 29.584362],
              [-92.041168, 29.581648],
              [-92.035462, 29.57864],
              [-92.02681, 29.566805],
              [-91.985726, 29.547708],
              [-91.969312, 29.536893],
              [-91.947007, 29.53316],
              [-91.915322, 29.518513],
              [-91.906175, 29.518052],
              [-91.886815, 29.505577],
              [-91.878746, 29.502937],
              [-91.862324, 29.502393],
              [-91.852598, 29.494984],
              [-91.848665, 29.484144],
              [-91.8385, 29.478874],
              [-91.821576, 29.473925],
              [-91.814609, 29.482061],
              [-91.803448, 29.486851],
              [-91.800121, 29.486828],
              [-91.789119, 29.482081],
              [-91.782387, 29.482882],
              [-91.770516, 29.488953],
              [-91.770069, 29.493812],
              [-91.772529, 29.499016],
              [-91.771927, 29.504871],
              [-91.765448, 29.520844],
              [-91.747058, 29.535144],
              [-91.733956, 29.539504],
              [-91.711654, 29.55427],
              [-91.709205, 29.561012],
              [-91.712002, 29.56474],
              [-91.715642, 29.565844],
              [-91.719102, 29.565568],
              [-91.74632, 29.574337],
              [-91.774686, 29.576387],
              [-91.774805, 29.582113],
              [-91.7785, 29.58922],
              [-91.784976, 29.595204],
              [-91.803831, 29.599562],
              [-91.821693, 29.606049],
              [-91.838297, 29.616041],
              [-91.840921, 29.619913],
              [-91.838981, 29.624475],
              [-91.841294, 29.62962],
              [-91.863018, 29.633739],
              [-91.866113, 29.631583],
              [-91.882318, 29.62977],
              [-91.896763, 29.634618],
              [-91.898996, 29.63701],
              [-91.922825, 29.633173],
              [-91.929567, 29.61884],
              [-91.935024, 29.612239],
              [-91.939903, 29.610291],
              [-91.965031, 29.608019],
              [-92.000003, 29.613013],
              [-92.000371, 29.613143],
              [-92.01627, 29.618741],
              [-92.02532, 29.625647],
              [-92.04767, 29.624527],
              [-92.06564, 29.619967],
              [-92.093419, 29.618694],
              [-92.111787, 29.62177],
              [-92.132804, 29.660462],
              [-92.134347, 29.669516],
              [-92.149349, 29.697052],
              [-92.144431, 29.716418],
              [-92.107486, 29.744429],
              [-92.056398, 29.772313],
              [-92.035666, 29.781662],
              [-91.983871, 29.794516],
              [-91.978381, 29.799217],
              [-91.970443, 29.80431],
              [-91.96123, 29.810221],
              [-91.940723, 29.817008],
              [-91.919143, 29.815379],
              [-91.915989, 29.815654],
              [-91.90689, 29.83094],
              [-91.889118, 29.836023],
              [-91.869998, 29.828328],
              [-91.854677, 29.807436],
              [-91.859151, 29.783331],
              [-91.874761, 29.760083],
              [-91.878355, 29.751025],
              [-91.879748, 29.742668],
              [-91.878355, 29.735007],
              [-91.87557, 29.728043],
              [-91.87557, 29.722471],
              [-91.875637, 29.722316],
              [-91.878331, 29.716087],
              [-91.880999, 29.713338],
              [-91.88075, 29.710839],
              [-91.866516, 29.70715],
              [-91.85864, 29.703121],
              [-91.845962, 29.708763],
              [-91.830499, 29.718918],
              [-91.783674, 29.740689],
              [-91.752259, 29.748264],
              [-91.737253, 29.74937],
              [-91.710935, 29.738993],
              [-91.667128, 29.745822],
              [-91.632829, 29.742576],
              [-91.621512, 29.735429],
              [-91.61809, 29.720694],
              [-91.618479, 29.710816],
              [-91.623829, 29.69924],
              [-91.626826, 29.684753],
              [-91.625114, 29.671679],
              [-91.627286, 29.662132],
              [-91.637344, 29.647217],
              [-91.643198, 29.640274],
              [-91.646478, 29.639427],
              [-91.648657, 29.636713],
              [-91.648941, 29.633635],
              [-91.643832, 29.630625],
              [-91.625114, 29.626195],
              [-91.600179, 29.631156],
              [-91.581843, 29.637165],
              [-91.570589, 29.638312],
              [-91.560908, 29.63735],
              [-91.553537, 29.632766],
              [-91.541974, 29.594353],
              [-91.537445, 29.565888],
              [-91.529217, 29.558598],
              [-91.525523, 29.551904],
              [-91.52584, 29.545946],
              [-91.531471, 29.535374],
              [-91.531021, 29.531543],
              [-91.517274, 29.52974],
              [-91.468748, 29.544299],
              [-91.447345, 29.544749],
              [-91.439941, 29.540434],
              [-91.432337, 29.53283],
              [-91.42713, 29.520215],
              [-91.420449, 29.515745],
              [-91.402214, 29.511914],
              [-91.356625, 29.515191],
              [-91.34588, 29.504538],
              [-91.343567, 29.492593],
              [-91.335742, 29.485886],
              [-91.294325, 29.476894],
              [-91.2813, 29.481547],
              [-91.265649, 29.472362],
              [-91.261588, 29.464954],
              [-91.260024, 29.462102],
              [-91.259988, 29.461803],
              [-91.259844, 29.460582],
              [-91.259537, 29.458001],
              [-91.258226, 29.446954],
              [-91.251319, 29.444483],
              [-91.24164, 29.441021],
              [-91.221166, 29.436421],
              [-91.219242, 29.434418],
              [-91.218067, 29.433193],
              [-91.217448, 29.432549],
              [-91.2151, 29.427542],
              [-91.211999, 29.420931],
              [-91.214284, 29.416089],
              [-91.215976, 29.412505],
              [-91.218463, 29.407235],
              [-91.200087, 29.38955],
              [-91.197465, 29.369882],
              [-91.207299, 29.360703],
              [-91.222377, 29.360703],
              [-91.235348, 29.370638],
              [-91.238515, 29.371999],
              [-91.245558, 29.37058],
              [-91.249109, 29.369864],
              [-91.249517, 29.369662],
              [-91.251232, 29.368814],
              [-91.251546, 29.368659],
              [-91.265479, 29.361767],
              [-91.266589, 29.361218],
              [-91.26994, 29.357231],
              [-91.270053, 29.356912],
              [-91.270582, 29.355415],
              [-91.274308, 29.344878],
              [-91.276187, 29.332783],
              [-91.276647, 29.329825],
              [-91.279742, 29.326058],
              [-91.29042, 29.313062],
              [-91.291821, 29.311357],
              [-91.299054, 29.309017],
              [-91.309314, 29.305698],
              [-91.33275, 29.305816],
              [-91.334885, 29.298775],
              [-91.302677, 29.265958],
              [-91.278792, 29.247776],
              [-91.219032, 29.226051],
              [-91.199647, 29.221287],
              [-91.129141, 29.215863],
              [-91.11476, 29.207918],
              [-91.094015, 29.187711],
              [-91.05863, 29.181734],
              [-91.031786, 29.182188],
              [-91.023955, 29.174784],
              [-91.000096, 29.169481],
              [-90.981458, 29.171211],
              [-90.961278, 29.180817],
              [-90.948091, 29.174104],
              [-90.941877, 29.162373],
              [-90.925797, 29.153116],
              [-90.898215, 29.131342],
              [-90.885351, 29.117016],
              [-90.877583, 29.104891],
              [-90.867766, 29.095434],
              [-90.862757, 29.094863],
              [-90.844593, 29.06728],
              [-90.841226, 29.054266],
              [-90.844849, 29.048721],
              [-90.842762, 29.042947],
              [-90.839345, 29.039167],
              [-90.811473, 29.03658],
              [-90.79768, 29.039741],
              [-90.755677, 29.038997],
              [-90.730899, 29.042259],
              [-90.648058, 29.062649],
              [-90.637495, 29.066608],
              [-90.636033, 29.069792],
              [-90.637623, 29.072084],
              [-90.63924, 29.072848],
              [-90.641247, 29.072313],
              [-90.644189, 29.07151],
              [-90.652348, 29.069237],
              [-90.665589, 29.06723],
              [-90.676958, 29.063619],
              [-90.683645, 29.060944],
              [-90.692205, 29.059607],
              [-90.702102, 29.060275],
              [-90.70535, 29.062679],
              [-90.709105, 29.064305],
              [-90.7253, 29.066616],
              [-90.750092, 29.053247],
              [-90.765188, 29.049403],
              [-90.781981, 29.049431],
              [-90.79872, 29.054841],
              [-90.803699, 29.063709],
              [-90.802053, 29.083322],
              [-90.799444, 29.087377],
              [-90.773458, 29.100133],
              [-90.764189, 29.113374],
              [-90.731239, 29.122886],
              [-90.718035, 29.116611],
              [-90.700893, 29.12147],
              [-90.691109, 29.121722],
              [-90.677724, 29.118742],
              [-90.647042, 29.12858],
              [-90.636973, 29.164572],
              [-90.640863, 29.171261],
              [-90.645169, 29.172958],
              [-90.645612, 29.175867],
              [-90.640223, 29.196554],
              [-90.633819, 29.209128],
              [-90.62742, 29.211004],
              [-90.624161, 29.210366],
              [-90.618413, 29.20329],
              [-90.575277, 29.206827],
              [-90.560889, 29.204261],
              [-90.55739, 29.207881],
              [-90.556501, 29.219913],
              [-90.544311, 29.224292],
              [-90.543245, 29.227843],
              [-90.544547, 29.230683],
              [-90.565378, 29.242475],
              [-90.576506, 29.243986],
              [-90.583924, 29.242886],
              [-90.58847, 29.245863],
              [-90.589724, 29.248521],
              [-90.582525, 29.276037],
              [-90.565436, 29.285111],
              [-90.552005, 29.278512],
              [-90.526216, 29.276492],
              [-90.517277, 29.282719],
              [-90.510555, 29.290925],
              [-90.495299, 29.287277],
              [-90.472779, 29.272556],
              [-90.452186, 29.26625],
              [-90.450674, 29.263739],
              [-90.462866, 29.249809],
              [-90.465764, 29.242951],
              [-90.46832, 29.227532],
              [-90.490987, 29.220883],
              [-90.494928, 29.216713],
              [-90.485786, 29.209843],
              [-90.467233, 29.202549],
              [-90.468773, 29.198469],
              [-90.473273, 29.195224],
              [-90.472489, 29.192688],
              [-90.443954, 29.19583],
              [-90.435907, 29.188449],
              [-90.432912, 29.188132],
              [-90.409416, 29.196135],
              [-90.408578, 29.196421],
              [-90.399465, 29.201046],
              [-90.383857, 29.235606],
              [-90.387924, 29.252786],
              [-90.372565, 29.258923],
              [-90.367012, 29.264956],
              [-90.368154, 29.270736],
              [-90.367166, 29.274128],
              [-90.332796, 29.276956],
              [-90.316093, 29.264777],
              [-90.311523, 29.256374],
              [-90.311663, 29.237954],
              [-90.300304, 29.231241],
              [-90.286621, 29.225694],
              [-90.271251, 29.204639],
              [-90.275851, 29.193668],
              [-90.2828, 29.192545],
              [-90.293183, 29.199789],
              [-90.300885, 29.196171],
              [-90.302948, 29.187948],
              [-90.302846, 29.175098],
              [-90.297, 29.171317],
              [-90.27832, 29.150691],
              [-90.280516, 29.142521],
              [-90.26901, 29.139242],
              [-90.248629, 29.13837],
              [-90.243435, 29.136311],
              [-90.234405, 29.128824],
              [-90.234235, 29.110268],
              [-90.243849, 29.11045],
              [-90.250044, 29.108067],
              [-90.249806, 29.100919],
              [-90.253141, 29.093772],
              [-90.258145, 29.091627],
              [-90.26629, 29.089421],
              [-90.282983, 29.082326],
              [-90.29293, 29.078761],
              [-90.304129, 29.077332],
              [-90.325514, 29.075138],
              [-90.349891, 29.063681],
              [-90.348768, 29.057817],
              [-90.343293, 29.057062],
              [-90.245283, 29.085824],
              [-90.231984, 29.08773],
              [-90.223587, 29.085075],
              [-90.174273, 29.105301],
              [-90.104162, 29.150407],
              [-90.088684, 29.162574],
              [-90.079276, 29.16997],
              [-90.058512, 29.183687],
              [-90.022029, 29.216065],
              [-89.95646, 29.253744],
              [-89.950756, 29.260801],
              [-89.949925, 29.263154],
              [-89.951175, 29.266124],
              [-89.959509, 29.267677],
              [-89.965667, 29.259126],
              [-89.969981, 29.255753],
              [-90.005718, 29.240627],
              [-90.019772, 29.231903],
              [-90.04291, 29.211765],
              [-90.06361, 29.209474],
              [-90.070622, 29.208698],
              [-90.073355, 29.210611],
              [-90.073355, 29.227282],
              [-90.096038, 29.240673],
              [-90.101231, 29.259804],
              [-90.097678, 29.26199],
              [-90.091119, 29.261443],
              [-90.086747, 29.259257],
              [-90.070622, 29.262537],
              [-90.060511, 29.267729],
              [-90.059691, 29.272648],
              [-90.061057, 29.276748],
              [-90.057094, 29.281331],
              [-90.043293, 29.282487],
              [-90.032088, 29.280027],
              [-90.019517, 29.282213],
              [-90.016288, 29.284257],
              [-90.009678, 29.294785],
              [-90.013778, 29.30271],
              [-90.028536, 29.307083],
              [-90.034275, 29.322661],
              [-90.031815, 29.344251],
              [-90.032842, 29.348624],
              [-90.036374, 29.363661],
              [-90.035415, 29.368201],
              [-90.033604, 29.370851],
              [-90.030855, 29.374876],
              [-90.030764, 29.375008],
              [-90.030761, 29.375043],
              [-90.029967, 29.383087],
              [-90.029614, 29.386658],
              [-90.029468, 29.388136],
              [-90.033295, 29.393274],
              [-90.031536, 29.412545],
              [-90.032298, 29.427005],
              [-90.029466, 29.432015],
              [-90.022404, 29.444509],
              [-90.018598, 29.45212],
              [-90.01251, 29.462775],
              [-89.991961, 29.463536],
              [-89.972934, 29.443748],
              [-89.964563, 29.434615],
              [-89.96195, 29.432874],
              [-89.95543, 29.428527],
              [-89.932598, 29.429288],
              [-89.918999, 29.444254],
              [-89.902179, 29.460011],
              [-89.876224, 29.472168],
              [-89.86258, 29.476474],
              [-89.849642, 29.477996],
              [-89.840509, 29.47343],
              [-89.83442, 29.470386],
              [-89.833659, 29.467341],
              [-89.832898, 29.463536],
              [-89.833659, 29.459731],
              [-89.833659, 29.456686],
              [-89.836773, 29.45404],
              [-89.845075, 29.434615],
              [-89.843553, 29.421677],
              [-89.835392, 29.418538],
              [-89.826049, 29.415589],
              [-89.822243, 29.4095],
              [-89.819199, 29.404173],
              [-89.816916, 29.398845],
              [-89.816155, 29.393518],
              [-89.816916, 29.384385],
              [-89.820824, 29.377486],
              [-89.835, 29.359043],
              [-89.847124, 29.349186],
              [-89.853699, 29.34064],
              [-89.855109, 29.334997],
              [-89.850305, 29.311768],
              [-89.819859, 29.310241],
              [-89.782149, 29.311132],
              [-89.726162, 29.304026],
              [-89.697258, 29.296679],
              [-89.671781, 29.289028],
              [-89.606651, 29.252023],
              [-89.5366, 29.236212],
              [-89.482844, 29.215053],
              [-89.47231, 29.20755],
              [-89.455829, 29.190991],
              [-89.447472, 29.178576],
              [-89.432932, 29.149023],
              [-89.428965, 29.14451],
              [-89.417718, 29.13869],
              [-89.409371, 29.127855],
              [-89.411154, 29.105838],
              [-89.405654, 29.086936],
              [-89.374522, 29.084174],
              [-89.354798, 29.072543],
              [-89.339828, 29.052221],
              [-89.334735, 29.040335],
              [-89.375049, 28.985368],
              [-89.382106, 28.981525],
              [-89.398104, 28.977016],
              [-89.408157, 28.965341],
              [-89.412388, 28.957504],
              [-89.419865, 28.929709],
              [-89.41148, 28.925011],
              [-89.383814, 28.947434],
              [-89.338249, 29.012935],
              [-89.335228, 29.015003],
              [-89.32485, 29.013805],
              [-89.315182, 29.032662],
              [-89.318102, 29.035342],
              [-89.315389, 29.039081],
              [-89.304888, 29.046379],
              [-89.29109, 29.053097],
              [-89.283215, 29.053325],
              [-89.259354, 29.058358],
              [-89.25364, 29.064954],
              [-89.256869, 29.0738],
              [-89.257283, 29.081086],
              [-89.254726, 29.083261],
              [-89.23631, 29.084605],
              [-89.225865, 29.07866],
              [-89.217201, 29.067275],
              [-89.215531, 29.06141],
              [-89.216101, 29.056371],
              [-89.211144, 29.040813],
              [-89.202563, 29.031603],
              [-89.197871, 29.029701],
              [-89.189893, 29.032635],
              [-89.18215, 29.025486],
              [-89.186061, 29.017993],
              [-89.175732, 29.012123],
              [-89.16985, 29.008703],
              [-89.164788, 29.008703],
              [-89.162326, 29.011713],
              [-89.162, 29.01586],
              [-89.156339, 29.028782],
              [-89.143453, 29.047591],
              [-89.121542, 29.069074],
              [-89.105009, 29.073641],
              [-89.098068, 29.067984],
              [-89.09126, 29.066931],
              [-89.062335, 29.070234],
              [-89.055475, 29.084167],
              [-89.051953, 29.106554],
              [-89.026031, 29.130126],
              [-89.023942, 29.1337],
              [-89.024149, 29.137298],
              [-89.032004, 29.144747],
              [-89.03873, 29.14238],
              [-89.047233, 29.157833],
              [-89.043919, 29.162528],
              [-89.024269, 29.170043],
              [-89.018344, 29.165046],
              [-89.013254, 29.16328],
              [-89.00529, 29.164949],
              [-89.000674, 29.180091],
              [-89.015192, 29.211561],
              [-89.02185, 29.218162],
              [-89.029103, 29.220956],
              [-89.067371, 29.208636],
              [-89.068265, 29.204166],
              [-89.090724, 29.199992],
              [-89.10065, 29.206314],
              [-89.106244, 29.215912],
              [-89.105833, 29.231608],
              [-89.098389, 29.232963],
              [-89.095544, 29.238028],
              [-89.096173, 29.24293],
              [-89.100106, 29.25022],
              [-89.129688, 29.265632],
              [-89.136979, 29.275239],
              [-89.134337, 29.27934],
              [-89.140275, 29.291085],
              [-89.157593, 29.296691],
              [-89.165015, 29.303039],
              [-89.178221, 29.32697],
              [-89.177351, 29.33521],
              [-89.179547, 29.339608],
              [-89.189354, 29.345061],
              [-89.200599, 29.347672],
              [-89.200389, 29.344418],
              [-89.204703, 29.338674],
              [-89.219734, 29.324412],
              [-89.223444, 29.318066],
              [-89.224192, 29.313792],
              [-89.24087, 29.310081],
              [-89.253545, 29.322802],
              [-89.257852, 29.336872],
              [-89.2653, 29.345352],
              [-89.272543, 29.351195],
              [-89.283028, 29.356467],
              [-89.303766, 29.357455],
              [-89.32317, 29.343982],
              [-89.350694, 29.349544],
              [-89.347615, 29.365],
              [-89.336589, 29.378228],
              [-89.340304, 29.381412],
              [-89.355528, 29.381569],
              [-89.373109, 29.387175],
              [-89.380001, 29.391785],
              [-89.42238, 29.390628],
              [-89.457303, 29.393148],
              [-89.470142, 29.401471],
              [-89.47714, 29.411241],
              [-89.482318, 29.406222],
              [-89.484354, 29.397471],
              [-89.487308, 29.393346],
              [-89.505038, 29.38604],
              [-89.508551, 29.386168],
              [-89.518368, 29.40023],
              [-89.531943, 29.425679],
              [-89.53215, 29.434567],
              [-89.528429, 29.454702],
              [-89.548686, 29.465723],
              [-89.574653, 29.4411],
              [-89.574635, 29.435734],
              [-89.577096, 29.433692],
              [-89.589536, 29.437662],
              [-89.592474, 29.449822],
              [-89.596533, 29.456303],
              [-89.617558, 29.468298],
              [-89.63533, 29.489294],
              [-89.644039, 29.492343],
              [-89.665813, 29.49002],
              [-89.693877, 29.508559],
              [-89.700501, 29.515967],
              [-89.700845, 29.520785],
              [-89.699698, 29.523423],
              [-89.69623, 29.525004],
              [-89.681092, 29.534487],
              [-89.684486, 29.551073],
              [-89.684486, 29.563263],
              [-89.668648, 29.580322],
              [-89.671082, 29.588243],
              [-89.684486, 29.602867],
              [-89.688141, 29.615055],
              [-89.684486, 29.624804],
              [-89.674736, 29.626633],
              [-89.657677, 29.624195],
              [-89.647324, 29.625414],
              [-89.641228, 29.635773],
              [-89.641228, 29.647961],
              [-89.64975, 29.672941],
              [-89.644272, 29.675381],
              [-89.632698, 29.671724],
              [-89.62355, 29.662584],
              [-89.621109, 29.657101],
              [-89.608925, 29.657707],
              [-89.583336, 29.652834],
              [-89.535202, 29.648567],
              [-89.523018, 29.639427],
              [-89.504738, 29.631508],
              [-89.486931, 29.620447],
              [-89.486709, 29.621003],
              [-89.485367, 29.624357],
              [-89.487915, 29.630405],
              [-89.53376, 29.670204],
              [-89.55732, 29.670204],
              [-89.573883, 29.674025],
              [-89.596802, 29.684212],
              [-89.599663, 29.690262],
              [-89.592979, 29.702042],
              [-89.59903, 29.704908],
              [-89.618446, 29.700768],
              [-89.644562, 29.710957],
              [-89.649651, 29.719872],
              [-89.651237, 29.749479],
              [-89.634048, 29.752981],
              [-89.598068, 29.74757],
              [-89.572922, 29.746616],
              [-89.560181, 29.735472],
              [-89.540131, 29.74375],
              [-89.530258, 29.74375],
              [-89.506065, 29.731651],
              [-89.486961, 29.72592],
              [-89.471992, 29.718597],
              [-89.44812, 29.703316],
              [-89.42421, 29.697638],
              [-89.428207, 29.74155],
              [-89.414536, 29.752371],
              [-89.399162, 29.770592],
              [-89.394608, 29.784828],
              [-89.386063, 29.788815],
              [-89.367271, 29.775148],
              [-89.354179, 29.781412],
              [-89.337662, 29.779135],
              [-89.325134, 29.772301],
              [-89.316025, 29.760912],
              [-89.305199, 29.756926],
              [-89.271034, 29.756355],
              [-89.269325, 29.760912],
              [-89.284706, 29.770021],
              [-89.284134, 29.795649],
              [-89.277298, 29.799635],
              [-89.277298, 29.807608],
              [-89.293251, 29.803053],
              [-89.318306, 29.788815],
              [-89.33197, 29.790524],
              [-89.342781, 29.798496],
              [-89.345634, 29.820135],
              [-89.372971, 29.82526],
              [-89.383217, 29.830385],
              [-89.383789, 29.838928],
              [-89.363289, 29.84576],
              [-89.317726, 29.850885],
              [-89.294952, 29.857149],
              [-89.269897, 29.859997],
              [-89.254517, 29.864552],
              [-89.236298, 29.877081],
              [-89.236298, 29.886763],
              [-89.241425, 29.88961],
              [-89.272179, 29.886763],
              [-89.289253, 29.880499],
              [-89.311462, 29.881636],
              [-89.322289, 29.887333],
              [-89.318306, 29.898149],
              [-89.280144, 29.924915],
              [-89.263062, 29.929472],
              [-89.244843, 29.93004],
              [-89.231178, 29.925484],
              [-89.22377, 29.961929],
              [-89.218071, 29.97275],
              [-89.249969, 29.975597],
              [-89.243706, 29.997236],
              [-89.250534, 30.002361],
              [-89.273315, 29.99382],
              [-89.283562, 29.97332],
              [-89.315453, 29.923208],
              [-89.331894, 29.91585],
              [-89.368019, 29.911491],
              [-89.378601, 29.919588],
              [-89.379227, 29.963804],
              [-89.393555, 29.966295],
              [-89.40538, 29.965672],
              [-89.432785, 29.978752],
              [-89.433411, 29.991205],
              [-89.432785, 30.008022],
              [-89.422813, 30.015495],
              [-89.41597, 30.020477],
              [-89.393555, 30.029818],
              [-89.381096, 30.030441],
              [-89.372375, 30.036671],
              [-89.368637, 30.047256],
              [-89.372375, 30.054729],
              [-89.418465, 30.049747],
              [-89.429047, 30.05224],
              [-89.444618, 30.060959],
              [-89.458946, 30.06345],
              [-89.481926, 30.079128],
              [-89.493484, 30.072191],
              [-89.499275, 30.058893],
              [-89.494637, 30.0508],
              [-89.494064, 30.040972],
              [-89.501587, 30.034037],
              [-89.551292, 30.005709],
              [-89.571533, 29.999926],
              [-89.58136, 29.994722],
              [-89.574425, 29.983738],
              [-89.574997, 29.959455],
              [-89.583099, 29.945581],
              [-89.583099, 29.931705],
              [-89.592346, 29.917253],
              [-89.591194, 29.897018],
              [-89.598129, 29.881409],
              [-89.613159, 29.87216],
              [-89.638016, 29.864065],
              [-89.660568, 29.862909],
              [-89.671555, 29.867535],
              [-89.692004, 29.868722],
              [-89.711158, 29.879287],
              [-89.742479, 29.90817],
              [-89.746273, 29.928221],
              [-89.742727, 29.935894],
              [-89.736311, 29.936263],
              [-89.71291, 29.946349],
              [-89.719067, 29.953699],
              [-89.727933, 29.95878],
              [-89.748492, 29.945831],
              [-89.775459, 29.937416],
              [-89.804463, 29.932588],
              [-89.81803, 29.934145],
              [-89.829023, 29.939228],
              [-89.8385, 29.945816],
              [-89.844202, 29.955645],
              [-89.852312, 29.97765],
              [-89.857558, 30.004439],
              [-89.854533, 30.007821],
              [-89.841739, 30.022127],
              [-89.840963, 30.022995],
              [-89.839933, 30.024146],
              [-89.839926, 30.024153],
              [-89.835202, 30.028393],
              [-89.834644, 30.028893],
              [-89.833794, 30.029656],
              [-89.832965, 30.0304],
              [-89.832213, 30.031075],
              [-89.830442, 30.032664],
              [-89.829762, 30.033275],
              [-89.818561, 30.043328],
              [-89.813684, 30.043605],
              [-89.78463, 30.045253],
              [-89.782534, 30.045372],
              [-89.763216, 30.042108],
              [-89.757138, 30.03865],
              [-89.746506, 30.0326],
              [-89.746505, 30.032599],
              [-89.746313, 30.032445],
              [-89.745827, 30.032056],
              [-89.740886, 30.028104],
              [-89.739574, 30.027055],
              [-89.739028, 30.026618],
              [-89.734361, 30.022884],
              [-89.733323, 30.022054],
              [-89.72576, 30.022403],
              [-89.724669, 30.022453],
              [-89.724649, 30.022454],
              [-89.716377, 30.026222],
              [-89.716358, 30.026686],
              [-89.716336, 30.02723],
              [-89.716328, 30.027415],
              [-89.716301, 30.028088],
              [-89.7163, 30.028106],
              [-89.7163, 30.02811],
              [-89.731544, 30.04969],
              [-89.731545, 30.049691],
              [-89.731545, 30.049694],
              [-89.731452, 30.05104],
              [-89.731428, 30.051377],
              [-89.731208, 30.054558],
              [-89.730999, 30.057581],
              [-89.73099, 30.057594],
              [-89.729911, 30.059139],
              [-89.72979, 30.059314],
              [-89.72968, 30.05947],
              [-89.72957, 30.059628],
              [-89.728026, 30.061841],
              [-89.727453, 30.062661],
              [-89.72633, 30.063158],
              [-89.724433, 30.063999],
              [-89.721992, 30.06508],
              [-89.716887, 30.067341],
              [-89.71675, 30.067402],
              [-89.716425, 30.067545],
              [-89.716237, 30.067628],
              [-89.715884, 30.067785],
              [-89.715494, 30.067958],
              [-89.714827, 30.068253],
              [-89.714085, 30.068582],
              [-89.713003, 30.069061],
              [-89.712942, 30.069088],
              [-89.711848, 30.069194],
              [-89.699629, 30.070381],
              [-89.699144, 30.070428],
              [-89.698909, 30.070451],
              [-89.698496, 30.070491],
              [-89.698461, 30.070504],
              [-89.697556, 30.070842],
              [-89.683712, 30.076018],
              [-89.683168, 30.08153],
              [-89.683051, 30.082718],
              [-89.682691, 30.086365],
              [-89.682409, 30.089225],
              [-89.682393, 30.089391],
              [-89.682371, 30.089607],
              [-89.682331, 30.090015],
              [-89.68228, 30.090531],
              [-89.682277, 30.090565],
              [-89.682181, 30.091531],
              [-89.682181, 30.091536],
              [-89.682057, 30.092052],
              [-89.681906, 30.092682],
              [-89.681265, 30.095355],
              [-89.680485, 30.098605],
              [-89.68035, 30.099171],
              [-89.680042, 30.100452],
              [-89.679838, 30.101304],
              [-89.679823, 30.101367],
              [-89.679655, 30.102067],
              [-89.678499, 30.106886],
              [-89.678457, 30.107059],
              [-89.678293, 30.107746],
              [-89.678163, 30.108286],
              [-89.678156, 30.10829],
              [-89.676117, 30.109515],
              [-89.675762, 30.109728],
              [-89.674956, 30.110212],
              [-89.674633, 30.110406],
              [-89.674124, 30.11043],
              [-89.672881, 30.11049],
              [-89.669182, 30.110667],
              [-89.669157, 30.110683],
              [-89.668638, 30.111011],
              [-89.668164, 30.111311],
              [-89.658594, 30.117364],
              [-89.656986, 30.118381],
              [-89.650467, 30.126625],
              [-89.64455, 30.134108],
              [-89.640989, 30.138612],
              [-89.625053, 30.150717],
              [-89.62288, 30.152368],
              [-89.617542, 30.156422],
              [-89.598027, 30.152409],
              [-89.595021, 30.149891],
              [-89.587062, 30.150648],
              [-89.572093, 30.160362],
              [-89.56827, 30.163932],
              [-89.562825, 30.168667],
              [-89.555013, 30.170798],
              [-89.537493, 30.171745],
              [-89.531213, 30.177099],
              [-89.524504, 30.180753],
              [-89.522814, 30.183076],
              [-89.503231, 30.183051],
              [-89.490099, 30.187677],
              [-89.480214, 30.193751],
              [-89.475824, 30.191561],
              [-89.469792, 30.176278],
              [-89.463595, 30.173943],
              [-89.461275, 30.174745],
              [-89.44791, 30.185352],
              [-89.447465, 30.205098],
              [-89.430428, 30.223218],
              [-89.424493, 30.239092],
              [-89.424624, 30.245391],
              [-89.419348, 30.25432],
              [-89.383747, 30.267796],
              [-89.379547, 30.270396],
              [-89.365747, 30.284896],
              [-89.358546, 30.288896],
              [-89.344746, 30.293196],
              [-89.329946, 30.302896],
              [-89.322545, 30.314896],
              [-89.322345, 30.319296],
              [-89.332546, 30.337895],
              [-89.338847, 30.342995],
              [-89.345934, 30.343573],
              [-89.366116, 30.352169],
              [-89.363848, 30.357395],
              [-89.353248, 30.368795],
              [-89.349447, 30.370995],
              [-89.340947, 30.372896],
              [-89.335942, 30.374016],
              [-89.315067, 30.375408],
              [-89.292499, 30.365635],
              [-89.279818, 30.34979],
              [-89.281564, 30.33198],
              [-89.287844, 30.333196],
              [-89.291844, 30.328096],
              [-89.294444, 30.307596],
              [-89.291444, 30.303296],
              [-89.285744, 30.303097],
              [-89.271833, 30.305491],
              [-89.220442, 30.322497],
              [-89.18684, 30.331197],
              [-89.083237, 30.368097],
              [-89.016334, 30.383898],
              [-88.971233, 30.390798],
              [-88.922031, 30.393798],
              [-88.89393, 30.393398],
              [-88.884829, 30.391998],
              [-88.883789, 30.389172],
              [-88.880526, 30.3866],
              [-88.851442, 30.375355],
              [-88.857828, 30.392898],
              [-88.845609, 30.405266],
              [-88.841328, 30.409598],
              [-88.823724, 30.402376],
              [-88.810227, 30.394698],
              [-88.810127, 30.391298],
              [-88.812576, 30.38768],
              [-88.811615, 30.384907],
              [-88.771742, 30.365403],
              [-88.746945, 30.347622],
              [-88.728893, 30.342671],
              [-88.714077, 30.342186],
              [-88.700587, 30.343689],
              [-88.692164, 30.347302],
              [-88.679575, 30.35571],
              [-88.66382, 30.362099],
              [-88.624523, 30.358713],
              [-88.613745, 30.353108],
              [-88.601762, 30.355876],
              [-88.599249, 30.358933],
              [-88.596349, 30.358365],
              [-88.579483, 30.34419],
              [-88.536214, 30.343299],
              [-88.522494, 30.340092],
              [-88.506334, 30.327398],
              [-88.506226, 30.322393],
              [-88.504802, 30.321472],
              [-88.480117, 30.318345],
              [-88.471875, 30.32002],
              [-88.45381, 30.329626],
              [-88.446625, 30.337671],
              [-88.446495, 30.347753],
              [-88.433891, 30.354652],
              [-88.418811, 30.353911],
              [-88.409927, 30.342115],
              [-88.401181, 30.344382],
              [-88.39398, 30.349307],
              [-88.39415, 30.352493],
              [-88.397082, 30.354785],
              [-88.399062, 30.360744],
              [-88.397236, 30.367689],
              [-88.395023, 30.369425],
              [-88.374671, 30.385608],
              [-88.364022, 30.388006],
              [-88.341345, 30.38947],
              [-88.332277, 30.38844],
              [-88.319599, 30.380334],
              [-88.316525, 30.369985],
              [-88.311608, 30.368908],
              [-88.290649, 30.370741],
              [-88.282635, 30.382876],
              [-88.260695, 30.382381],
              [-88.204495, 30.362102],
              [-88.200065, 30.362378],
              [-88.188527, 30.348124],
              [-88.188532, 30.345053],
              [-88.196353, 30.343586],
              [-88.198361, 30.338819],
              [-88.195664, 30.321242],
              [-88.191542, 30.317002],
              [-88.171967, 30.324679],
              [-88.155775, 30.327184],
              [-88.136173, 30.320729],
              [-88.128052, 30.338509],
              [-88.124611, 30.341623],
              [-88.115432, 30.35657],
              [-88.107274, 30.377246],
              [-88.10407, 30.4273],
              [-88.106437, 30.452738],
              [-88.100646, 30.46122],
              [-88.096867, 30.471053],
              [-88.102988, 30.493029],
              [-88.103768, 30.500903],
              [-88.100874, 30.50975],
              [-88.090734, 30.52357],
              [-88.082792, 30.528713],
              [-88.081617, 30.546317],
              [-88.085493, 30.563258],
              [-88.074898, 30.578892],
              [-88.064898, 30.588292],
              [-88.053998, 30.612491],
              [-88.059598, 30.619091],
              [-88.061998, 30.644891],
              [-88.044339, 30.652568],
              [-88.034588, 30.653715],
              [-88.026706, 30.66149],
              [-88.022076, 30.673873],
              [-88.012444, 30.68319],
              [-88.008396, 30.684956],
              [-87.981196, 30.67509],
              [-87.955989, 30.658862],
              [-87.936717, 30.657432],
              [-87.93107, 30.652694],
              [-87.919346, 30.63606],
              [-87.91253, 30.615795],
              [-87.914956, 30.585893],
              [-87.911431, 30.576261],
              [-87.907891, 30.573114],
              [-87.904168, 30.565985],
              [-87.901711, 30.550879],
              [-87.905343, 30.537566],
              [-87.911141, 30.525848],
              [-87.933355, 30.487357],
              [-87.931902, 30.4811],
              [-87.924211, 30.4761],
              [-87.920031, 30.470645],
              [-87.914136, 30.446144],
              [-87.908908, 30.41424],
              [-87.906343, 30.40938],
              [-87.865017, 30.38345],
              [-87.853806, 30.378481],
              [-87.845132, 30.377446],
              [-87.837239, 30.369324],
              [-87.82988, 30.353809],
              [-87.809266, 30.332702],
              [-87.796717, 30.324198],
              [-87.772758, 30.311701],
              [-87.755516, 30.291217],
              [-87.755263, 30.277292],
              [-87.766626, 30.262353],
              [-87.78775, 30.254244],
              [-87.802087, 30.253054],
              [-87.817743, 30.254292],
              [-87.860085, 30.240289],
              [-87.879343, 30.23859],
              [-87.893201, 30.239237],
              [-87.90046, 30.241531],
              [-87.913762, 30.247837],
              [-87.918247, 30.253308],
              [-87.936041, 30.261469],
              [-87.948979, 30.256564],
              [-87.966847, 30.235618],
              [-88.023991, 30.23039],
              [-88.029272, 30.222714],
              [-88.028401, 30.221132],
              [-88.014572, 30.222366],
              [-87.999996, 30.225753],
              [-87.962253, 30.229522],
              [-87.926119, 30.230373],
              [-87.838462, 30.227185],
              [-87.80056, 30.229365],
              [-87.73553, 30.240679],
              [-87.656888, 30.249709],
              [-87.581362, 30.269257],
              [-87.558097, 30.274437],
              [-87.544533, 30.275659],
              [-87.518324, 30.280435],
              [-87.419859, 30.297128],
              [-87.350486, 30.313064],
              [-87.319518, 30.317814],
              [-87.295422, 30.323503],
              [-87.282787, 30.318744],
              [-87.267827, 30.31548],
              [-87.206254, 30.320943],
              [-87.155392, 30.327748],
              [-86.919292, 30.370675],
              [-86.909679, 30.372423],
              [-86.850625, 30.380967],
              [-86.800283, 30.386477],
              [-86.750906, 30.391881],
              [-86.632953, 30.396299],
              [-86.529067, 30.386896],
              [-86.50615, 30.3823],
              [-86.47399, 30.383758],
              [-86.470849, 30.3839],
              [-86.457045, 30.383065],
              [-86.456197, 30.383014],
              [-86.454731, 30.382925],
              [-86.429322, 30.381389],
              [-86.412076, 30.380346],
              [-86.400403, 30.378927],
              [-86.397325, 30.378553],
              [-86.364175, 30.374524],
              [-86.2987, 30.363049],
              [-86.222561, 30.343585],
              [-86.089963, 30.303569],
              [-85.999937, 30.27078],
              [-85.996083, 30.269148],
              [-85.9226, 30.238024],
              [-85.878138, 30.215619],
              [-85.811219, 30.17832],
              [-85.775405, 30.15629],
              [-85.74993, 30.136537],
              [-85.730054, 30.118153],
              [-85.69681, 30.09689],
              [-85.653251, 30.077839],
              [-85.637285, 30.073319],
              [-85.618254, 30.065481],
              [-85.601178, 30.056342],
              [-85.588242, 30.055543],
              [-85.58139, 30.037783],
              [-85.571907, 30.02644],
              [-85.541176, 29.995791],
              [-85.509148, 29.971466],
              [-85.487764, 29.961227],
              [-85.469425, 29.957788],
              [-85.460488, 29.959579],
              [-85.425956, 29.949888],
              [-85.405052, 29.938487],
              [-85.388677, 29.924355],
              [-85.38473, 29.920949],
              [-85.363731, 29.898915],
              [-85.347044, 29.871981],
              [-85.336654, 29.849295],
              [-85.332289, 29.845905],
              [-85.325008, 29.844966],
              [-85.317464, 29.838894],
              [-85.312911, 29.832273],
              [-85.314783, 29.830575],
              [-85.314547, 29.822279],
              [-85.31142, 29.814373],
              [-85.304877, 29.811096],
              [-85.302591, 29.808094],
              [-85.301331, 29.797117],
              [-85.31139, 29.697557],
              [-85.317661, 29.691286],
              [-85.344986, 29.685015],
              [-85.353885, 29.684765],
              [-85.3638, 29.693526],
              [-85.37796, 29.709621],
              [-85.395528, 29.762368],
              [-85.405907, 29.80193],
              [-85.405011, 29.830151],
              [-85.39874, 29.859267],
              [-85.392469, 29.870914],
              [-85.405815, 29.865817],
              [-85.413575, 29.85294],
              [-85.416548, 29.842628],
              [-85.417971, 29.828855],
              [-85.413983, 29.799865],
              [-85.397871, 29.740498],
              [-85.380303, 29.698485],
              [-85.369419, 29.681048],
              [-85.352615, 29.659787],
              [-85.344768, 29.654793],
              [-85.347711, 29.66719],
              [-85.343619, 29.672004],
              [-85.319215, 29.681494],
              [-85.29074, 29.684081],
              [-85.259719, 29.681296],
              [-85.22745, 29.693633],
              [-85.217355, 29.694953],
              [-85.177284, 29.700193],
              [-85.153238, 29.708231],
              [-85.121473, 29.715854],
              [-85.101682, 29.718748],
              [-85.072123, 29.719027],
              [-85.037212, 29.711074],
              [-84.993264, 29.714961],
              [-84.977004, 29.721209],
              [-84.968841, 29.72708],
              [-84.964007, 29.742422],
              [-84.946595, 29.745032],
              [-84.93837, 29.750211],
              [-84.920917, 29.772901],
              [-84.91511, 29.783303],
              [-84.90413, 29.786279],
              [-84.893992, 29.785176],
              [-84.877111, 29.772888],
              [-84.890066, 29.755802],
              [-84.901781, 29.735723],
              [-84.892493, 29.72266],
              [-84.888031, 29.722406],
              [-84.881777, 29.733882],
              [-84.868271, 29.742454],
              [-84.837168, 29.755926],
              [-84.824197, 29.758288],
              [-84.762998, 29.788846],
              [-84.755595, 29.78854],
              [-84.730327, 29.8069],
              [-84.692053, 29.829059],
              [-84.683934, 29.831327],
              [-84.669728, 29.82891],
              [-84.65645, 29.834277],
              [-84.656318, 29.837943],
              [-84.647958, 29.847104],
              [-84.613154, 29.867984],
              [-84.603303, 29.876117],
              [-84.57744, 29.887828],
              [-84.535873, 29.910092],
              [-84.511996, 29.916574],
              [-84.494562, 29.913957],
              [-84.470323, 29.924524],
              [-84.451705, 29.929085],
              [-84.443652, 29.913785],
              [-84.434287, 29.906328],
              [-84.423834, 29.902996],
              [-84.404958, 29.901229],
              [-84.378937, 29.893112],
              [-84.349066, 29.896812],
              [-84.343389, 29.899539],
              [-84.335953, 29.912962],
              [-84.333746, 29.923721],
              [-84.336511, 29.942508],
              [-84.339426, 29.946007],
              [-84.341261, 29.960775],
              [-84.343041, 29.9751],
              [-84.3477, 29.984123],
              [-84.359986, 29.984739],
              [-84.361962, 29.987739],
              [-84.365882, 30.024588],
              [-84.358923, 30.058224],
              [-84.342022, 30.063858],
              [-84.315344, 30.069492],
              [-84.297836, 30.057451],
              [-84.289727, 30.057197],
              [-84.277168, 30.060263],
              [-84.270792, 30.068094],
              [-84.270368, 30.075469],
              [-84.274003, 30.083079],
              [-84.272511, 30.092358],
              [-84.269363, 30.09766],
              [-84.256439, 30.103791],
              [-84.247491, 30.10114],
              [-84.245668, 30.093021],
              [-84.237014, 30.08556],
              [-84.20801, 30.084776],
              [-84.203349, 30.085875],
              [-84.201585, 30.087982],
              [-84.19853, 30.087937],
              [-84.179149, 30.073187],
              [-84.167881, 30.071422],
              [-84.157278, 30.072714],
              [-84.135683, 30.083018],
              [-84.124889, 30.090601],
              [-84.11384, 30.085478],
              [-84.10273, 30.093611],
              [-84.094725, 30.094964],
              [-84.087034, 30.092103],
              [-84.083057, 30.092286],
              [-84.076043, 30.095464],
              [-84.06299, 30.101378],
              [-84.048715, 30.103208],
              [-84.024274, 30.103271],
              [-84.000716, 30.096209],
              [-83.991607, 30.08392],
              [-83.95968, 30.064943],
              [-83.933432, 30.046305],
              [-83.931879, 30.044175],
              [-83.933668, 30.041152],
              [-83.93151, 30.039068],
              [-83.845427, 29.998068],
              [-83.82869, 29.983187],
              [-83.788729, 29.976982],
              [-83.757249, 29.957943],
              [-83.686423, 29.923735],
              [-83.679219, 29.918513],
              [-83.659951, 29.899524],
              [-83.63798, 29.886073],
              [-83.618568, 29.842336],
              [-83.605244, 29.836387],
              [-83.595493, 29.827984],
              [-83.585899, 29.811754],
              [-83.581903, 29.792063],
              [-83.583045, 29.787307],
              [-83.586089, 29.784644],
              [-83.584716, 29.77608],
              [-83.578955, 29.768378],
              [-83.566018, 29.761434],
              [-83.554993, 29.7426],
              [-83.547172, 29.732223],
              [-83.537645, 29.72306],
              [-83.512716, 29.71648],
              [-83.493728, 29.708388],
              [-83.483567, 29.698542],
              [-83.483143, 29.690478],
              [-83.455356, 29.676444],
              [-83.448194, 29.675254],
              [-83.444635, 29.677155],
              [-83.436259, 29.677389],
              [-83.414701, 29.670536],
              [-83.412768, 29.668485],
              [-83.412278, 29.666922],
              [-83.404081, 29.640798],
              [-83.39948, 29.612956],
              [-83.405068, 29.59557],
              [-83.405256, 29.578319],
              [-83.39983, 29.533042],
              [-83.401552, 29.523291],
              [-83.400252, 29.517242],
              [-83.383973, 29.512995],
              [-83.379254, 29.503558],
              [-83.370288, 29.499901],
              [-83.356722, 29.499901],
              [-83.350067, 29.489358],
              [-83.33113, 29.475594],
              [-83.323214, 29.476789],
              [-83.311546, 29.475666],
              [-83.307828, 29.468861],
              [-83.307094, 29.459651],
              [-83.294747, 29.437923],
              [-83.272019, 29.432256],
              [-83.263965, 29.435806],
              [-83.240509, 29.433178],
              [-83.218075, 29.420492],
              [-83.202446, 29.394422],
              [-83.200702, 29.373855],
              [-83.189581, 29.363417],
              [-83.175518, 29.34469],
              [-83.176852, 29.329269],
              [-83.17826, 29.327916],
              [-83.176736, 29.31422],
              [-83.169576, 29.290355],
              [-83.166091, 29.28888],
              [-83.16073, 29.286611],
              [-83.149764, 29.289768],
              [-83.146445, 29.289194],
              [-83.128027, 29.282733],
              [-83.125567, 29.278845],
              [-83.107477, 29.268889],
              [-83.089013, 29.266502],
              [-83.077265, 29.255331],
              [-83.074734, 29.247975],
              [-83.087839, 29.21642],
              [-83.078986, 29.196944],
              [-83.065242, 29.184489],
              [-83.061162, 29.176113],
              [-83.060947, 29.170959],
              [-83.068249, 29.153135],
              [-83.056867, 29.146263],
              [-83.053207, 29.130839],
              [-83.030453, 29.134023],
              [-83.019071, 29.141324],
              [-83.018212, 29.151417],
              [-82.996144, 29.178074],
              [-82.991653, 29.180664],
              [-82.987162, 29.180094],
              [-82.979522, 29.171817],
              [-82.974676, 29.17091],
              [-82.945302, 29.167821],
              [-82.932405, 29.167891],
              [-82.922613, 29.169769],
              [-82.887211, 29.161741],
              [-82.858179, 29.162275],
              [-82.827073, 29.158425],
              [-82.804736, 29.146624],
              [-82.805703, 29.129848],
              [-82.798876, 29.114504],
              [-82.799117, 29.110647],
              [-82.801166, 29.105103],
              [-82.809483, 29.10462],
              [-82.823659, 29.098902],
              [-82.816925, 29.076215],
              [-82.780558, 29.07358],
              [-82.783328, 29.064619],
              [-82.759704, 29.054192],
              [-82.753513, 29.026496],
              [-82.759378, 29.006619],
              [-82.764055, 28.999707],
              [-82.760551, 28.993087],
              [-82.758906, 28.993277],
              [-82.737872, 28.995703],
              [-82.735754, 28.973709],
              [-82.723861, 28.953506],
              [-82.708793, 28.935979],
              [-82.702618, 28.932955],
              [-82.688864, 28.905609],
              [-82.673399, 28.900419],
              [-82.656028, 28.899179],
              [-82.644861, 28.889252],
              [-82.639898, 28.876224],
              [-82.643, 28.860094],
              [-82.638657, 28.843344],
              [-82.652926, 28.830936],
              [-82.650445, 28.80488],
              [-82.648584, 28.796195],
              [-82.643, 28.789991],
              [-82.643, 28.782546],
              [-82.645482, 28.767037],
              [-82.651065, 28.747184],
              [-82.662232, 28.737258],
              [-82.656028, 28.727952],
              [-82.652926, 28.719267],
              [-82.656028, 28.712443],
              [-82.652926, 28.705618],
              [-82.645482, 28.697553],
              [-82.646411, 28.694434],
              [-82.654167, 28.668395],
              [-82.65851, 28.636756],
              [-82.656649, 28.623727],
              [-82.664055, 28.606584],
              [-82.654138, 28.590837],
              [-82.65705, 28.568028],
              [-82.66165, 28.554143],
              [-82.661729, 28.549743],
              [-82.656694, 28.544814],
              [-82.663705, 28.530193],
              [-82.66804, 28.528199],
              [-82.669416, 28.519879],
              [-82.670146, 28.500769],
              [-82.66639, 28.49733],
              [-82.66447, 28.488788],
              [-82.665055, 28.484434],
              [-82.67241, 28.464746],
              [-82.680396, 28.457194],
              [-82.674787, 28.441956],
              [-82.677839, 28.434367],
              [-82.678743, 28.433456],
              [-82.684137, 28.428019],
              [-82.697433, 28.420166],
              [-82.706322, 28.401325],
              [-82.706112, 28.368057],
              [-82.715822, 28.345501],
              [-82.73146, 28.325075],
              [-82.735463, 28.30039],
              [-82.732792, 28.291933],
              [-82.746188, 28.261192],
              [-82.759072, 28.25402],
              [-82.764103, 28.244345],
              [-82.76446, 28.220069],
              [-82.762643, 28.219013],
              [-82.797762, 28.187789],
              [-82.805097, 28.172181],
              [-82.808474, 28.154803],
              [-82.799024, 28.15179],
              [-82.790724, 28.15249],
              [-82.786624, 28.144991],
              [-82.781324, 28.127591],
              [-82.782181, 28.120287],
              [-82.783824, 28.106292],
              [-82.782724, 28.055894],
              [-82.792635, 28.032307],
              [-82.792635, 28.01116],
              [-82.79782, 27.990563],
              [-82.805462, 27.960201],
              [-82.808745, 27.953112],
              [-82.820715, 27.927268],
              [-82.832155, 27.909242],
              [-82.838484, 27.909111],
              [-82.830819, 27.930926],
              [-82.821975, 27.956868],
              [-82.824875, 27.960201],
              [-82.831388, 27.962117],
              [-82.840882, 27.937162],
              [-82.847826, 27.910199],
              [-82.851126, 27.8863],
              [-82.849126, 27.8632],
              [-82.846526, 27.854301],
              [-82.828561, 27.822254],
              [-82.820433, 27.813742],
              [-82.790224, 27.791603],
              [-82.783124, 27.783804],
              [-82.770023, 27.767904],
              [-82.760923, 27.745205],
              [-82.753723, 27.736306],
              [-82.746223, 27.731306],
              [-82.740323, 27.718206],
              [-82.738022, 27.706807],
              [-82.739122, 27.636909],
              [-82.73779, 27.626758],
              [-82.737312, 27.623115],
              [-82.736552, 27.617326],
              [-82.733076, 27.612972],
              [-82.705017, 27.62531],
              [-82.698091, 27.638858],
              [-82.712555, 27.646647],
              [-82.716322, 27.651409],
              [-82.721622, 27.663908],
              [-82.723022, 27.671208],
              [-82.718822, 27.692007],
              [-82.713629, 27.698661],
              [-82.693748, 27.700217],
              [-82.679251, 27.694665],
              [-82.679019, 27.696054],
              [-82.677321, 27.706207],
              [-82.674123, 27.706039],
              [-82.673061, 27.705983],
              [-82.672093, 27.705932],
              [-82.671621, 27.705907],
              [-82.671549, 27.705877],
              [-82.670942, 27.705626],
              [-82.670449, 27.705422],
              [-82.668772, 27.704728],
              [-82.667445, 27.704179],
              [-82.663246, 27.702442],
              [-82.662921, 27.702307],
              [-82.652521, 27.700307],
              [-82.63982, 27.703907],
              [-82.63362, 27.710607],
              [-82.62572, 27.727006],
              [-82.62502, 27.732706],
              [-82.63052, 27.753905],
              [-82.622723, 27.779868],
              [-82.60742, 27.798904],
              [-82.586519, 27.816703],
              [-82.589319, 27.835702],
              [-82.594819, 27.843402],
              [-82.598443, 27.857582],
              [-82.566819, 27.858002],
              [-82.567826, 27.881537],
              [-82.567919, 27.883701],
              [-82.61002, 27.873501],
              [-82.63212, 27.8911],
              [-82.63422, 27.9037],
              [-82.628063, 27.910397],
              [-82.671221, 27.913],
              [-82.685121, 27.916299],
              [-82.691621, 27.924899],
              [-82.710022, 27.928299],
              [-82.720122, 27.936399],
              [-82.720395, 27.937199],
              [-82.721429, 27.940222],
              [-82.721975, 27.941819],
              [-82.724122, 27.948098],
              [-82.720522, 27.955798],
              [-82.716522, 27.958398],
              [-82.648616, 27.966309],
              [-82.61952, 27.969698],
              [-82.589419, 27.970898],
              [-82.553918, 27.966998],
              [-82.541218, 27.948998],
              [-82.533718, 27.932999],
              [-82.531318, 27.9039],
              [-82.535818, 27.898],
              [-82.541747, 27.893706],
              [-82.542818, 27.890601],
              [-82.539318, 27.885001],
              [-82.529918, 27.877501],
              [-82.533218, 27.870701],
              [-82.538618, 27.864901],
              [-82.552918, 27.862702],
              [-82.553946, 27.848462],
              [-82.511193, 27.828015],
              [-82.489849, 27.822607],
              [-82.475273, 27.820991],
              [-82.47244, 27.822559],
              [-82.46884, 27.843295],
              [-82.471624, 27.847342],
              [-82.480137, 27.853246],
              [-82.488057, 27.863566],
              [-82.487417, 27.895001],
              [-82.491117, 27.9145],
              [-82.489817, 27.9196],
              [-82.478063, 27.92768],
              [-82.462078, 27.920066],
              [-82.459616, 27.9169],
              [-82.460016, 27.9116],
              [-82.451591, 27.907506],
              [-82.432316, 27.901301],
              [-82.413915, 27.901401],
              [-82.402615, 27.882602],
              [-82.397463, 27.851631],
              [-82.393383, 27.837519],
              [-82.402857, 27.812671],
              [-82.410837, 27.810868],
              [-82.418401, 27.803187],
              [-82.419066, 27.793767],
              [-82.433981, 27.774087],
              [-82.43198, 27.768092],
              [-82.434635, 27.764355],
              [-82.457543, 27.752571],
              [-82.478339, 27.74625],
              [-82.482305, 27.742649],
              [-82.477129, 27.735216],
              [-82.476297, 27.729929],
              [-82.477638, 27.723004],
              [-82.482449, 27.719886],
              [-82.494891, 27.718963],
              [-82.514265, 27.705588],
              [-82.537146, 27.672933],
              [-82.554499, 27.645145],
              [-82.558538, 27.638678],
              [-82.565667, 27.615713],
              [-82.570607, 27.608882],
              [-82.584629, 27.596021],
              [-82.596488, 27.594045],
              [-82.611717, 27.585283],
              [-82.612749, 27.583319],
              [-82.613003, 27.582837],
              [-82.612019, 27.571231],
              [-82.632053, 27.551908],
              [-82.646014, 27.53354],
              [-82.65072, 27.523115],
              [-82.66202, 27.522814],
              [-82.674621, 27.519614],
              [-82.683621, 27.513115],
              [-82.686921, 27.508015],
              [-82.686421, 27.497215],
              [-82.690421, 27.496415],
              [-82.706821, 27.498415],
              [-82.710621, 27.501715],
              [-82.708121, 27.523514],
              [-82.742437, 27.53936],
              [-82.745748, 27.538834],
              [-82.743017, 27.531086],
              [-82.724522, 27.513614],
              [-82.714521, 27.500415],
              [-82.707821, 27.487615],
              [-82.691004, 27.444331],
              [-82.691821, 27.437218],
              [-82.675121, 27.424318],
              [-82.642837, 27.389737],
              [-82.642821, 27.38972],
              [-82.623863, 27.362206],
              [-82.597629, 27.335754],
              [-82.57602, 27.309324],
              [-82.569248, 27.298588],
              [-82.569754, 27.279452],
              [-82.55902, 27.268826],
              [-82.54512, 27.261026],
              [-82.539719, 27.254326],
              [-82.512319, 27.207528],
              [-82.477019, 27.141231],
              [-82.46889, 27.113612],
              [-82.465319, 27.110732],
              [-82.460319, 27.099933],
              [-82.445718, 27.060634],
              [-82.419218, 27.020736],
              [-82.400618, 26.984937],
              [-82.375737, 26.946041],
              [-82.351649, 26.908384],
              [-82.301736, 26.841588],
              [-82.289086, 26.827784],
              [-82.281552, 26.811203],
              [-82.271699, 26.789516],
              [-82.269499, 26.784674],
              [-82.264682, 26.756836],
              [-82.263804, 26.725644],
              [-82.259867, 26.717398],
              [-82.251134, 26.755881],
              [-82.241935, 26.774279],
              [-82.234019, 26.783251],
              [-82.233311, 26.784054],
              [-82.232193, 26.78288],
              [-82.221812, 26.77198],
              [-82.209329, 26.772146],
              [-82.17869, 26.772555],
              [-82.172941, 26.778879],
              [-82.151093, 26.783479],
              [-82.147068, 26.789803],
              [-82.156267, 26.851898],
              [-82.172941, 26.897319],
              [-82.175241, 26.916867],
              [-82.169491, 26.923191],
              [-82.162017, 26.925491],
              [-82.137294, 26.926066],
              [-82.124645, 26.945615],
              [-82.117171, 26.954239],
              [-82.113039, 26.955788],
              [-82.107972, 26.957688],
              [-82.076349, 26.958263],
              [-82.063126, 26.950214],
              [-82.061401, 26.938715],
              [-82.061976, 26.931241],
              [-82.067725, 26.927791],
              [-82.083249, 26.927791],
              [-82.090148, 26.923191],
              [-82.093023, 26.906518],
              [-82.090723, 26.888694],
              [-82.066575, 26.88237],
              [-82.059101, 26.876621],
              [-82.056801, 26.858797],
              [-82.058526, 26.838674],
              [-82.057951, 26.822],
              [-82.055076, 26.802452],
              [-82.061401, 26.789228],
              [-82.061401, 26.774279],
              [-82.062029, 26.770439],
              [-82.066575, 26.742657],
              [-82.079799, 26.716784],
              [-82.084974, 26.702411],
              [-82.086698, 26.685162],
              [-82.093023, 26.665614],
              [-82.099922, 26.662739],
              [-82.106247, 26.667339],
              [-82.118896, 26.690912],
              [-82.125795, 26.699536],
              [-82.139019, 26.702986],
              [-82.151668, 26.704136],
              [-82.173516, 26.701836],
              [-82.17984, 26.696661],
              [-82.181565, 26.681712],
              [-82.149943, 26.654115],
              [-82.137869, 26.637441],
              [-82.122345, 26.579371],
              [-82.118896, 26.560973],
              [-82.111996, 26.54085],
              [-82.105672, 26.48393],
              [-82.094748, 26.48393],
              [-82.07175, 26.492554],
              [-82.06715, 26.513252],
              [-82.043577, 26.519577],
              [-82.024604, 26.512677],
              [-82.00908, 26.505203],
              [-82.01368, 26.490829],
              [-82.008961, 26.484052],
              [-81.997012, 26.484856],
              [-81.980712, 26.480957],
              [-81.969509, 26.476505],
              [-81.966212, 26.465057],
              [-81.967112, 26.462857],
              [-81.964212, 26.457957],
              [-81.956611, 26.452358],
              [-81.938411, 26.445058],
              [-81.923611, 26.436658],
              [-81.91171, 26.427158],
              [-81.90271, 26.416159],
              [-81.90191, 26.410859],
              [-81.868983, 26.378648],
              [-81.845834, 26.330378],
              [-81.844555, 26.327712],
              [-81.833142, 26.294518],
              [-81.820675, 26.236735],
              [-81.81681, 26.207166],
              [-81.81461, 26.173167],
              [-81.808833, 26.152246],
              [-81.801663, 26.088227],
              [-81.762439, 26.00607],
              [-81.757463, 26.000374],
              [-81.750668, 25.998425],
              [-81.747834, 25.994273],
              [-81.749724, 25.960463],
              [-81.745579, 25.949643],
              [-81.738118, 25.942009],
              [-81.73195, 25.931506],
              [-81.727086, 25.907207],
              [-81.717687, 25.902039],
              [-81.713172, 25.897568],
              [-81.68954, 25.85271],
              [-81.6848, 25.847205],
              [-81.678287, 25.845301],
              [-81.672633, 25.856654],
              [-81.663821, 25.885605],
              [-81.654493, 25.893579],
              [-81.644553, 25.897953],
              [-81.640084, 25.897784],
              [-81.623482, 25.897158],
              [-81.614735, 25.893977],
              [-81.584519, 25.888808],
              [-81.577363, 25.889206],
              [-81.541183, 25.900338],
              [-81.527665, 25.901531],
              [-81.515738, 25.899941],
              [-81.511762, 25.89676],
              [-81.512955, 25.886423],
              [-81.508979, 25.884037],
              [-81.501027, 25.884037],
              [-81.48751, 25.888411],
              [-81.473992, 25.888411],
              [-81.471607, 25.881652],
              [-81.458487, 25.868929],
              [-81.441391, 25.863761],
              [-81.429066, 25.865351],
              [-81.424295, 25.867737],
              [-81.417536, 25.864954],
              [-81.394476, 25.851834],
              [-81.386127, 25.839906],
              [-81.362272, 25.824401],
              [-81.352731, 25.822015],
              [-81.349152, 25.816847],
              [-81.344564, 25.803322],
              [-81.341598, 25.794582],
              [-81.340406, 25.786631],
              [-81.344779, 25.782257],
              [-81.361875, 25.772715],
              [-81.359489, 25.766354],
              [-81.355116, 25.76039],
              [-81.346767, 25.754029],
              [-81.343984, 25.747668],
              [-81.345972, 25.736536],
              [-81.346078, 25.721473],
              [-81.335037, 25.715649],
              [-81.328935, 25.717233],
              [-81.290328, 25.687506],
              [-81.277374, 25.66498],
              [-81.268924, 25.656927],
              [-81.253951, 25.638181],
              [-81.240677, 25.613629],
              [-81.240519, 25.599041],
              [-81.233051, 25.586587],
              [-81.232705, 25.573366],
              [-81.225557, 25.55847],
              [-81.209321, 25.548611],
              [-81.204389, 25.538908],
              [-81.203175, 25.53416],
              [-81.210149, 25.516888],
              [-81.208201, 25.504937],
              [-81.191924, 25.484745],
              [-81.179406, 25.475427],
              [-81.168652, 25.463848],
              [-81.146765, 25.407577],
              [-81.147144, 25.404297],
              [-81.150656, 25.399206],
              [-81.150508, 25.387255],
              [-81.141395, 25.381358],
              [-81.128492, 25.380511],
              [-81.117265, 25.354953],
              [-81.118208, 25.34522],
              [-81.12141, 25.33875],
              [-81.133913, 25.342996],
              [-81.140099, 25.341117],
              [-81.148103, 25.332793],
              [-81.151916, 25.324766],
              [-81.148915, 25.318067],
              [-81.1523, 25.305543],
              [-81.159293, 25.298595],
              [-81.16207, 25.289833],
              [-81.168307, 25.253178],
              [-81.169294, 25.250398],
              [-81.169509, 25.249795],
              [-81.169709, 25.249231],
              [-81.170907, 25.245857],
              [-81.170953, 25.244898],
              [-81.171369, 25.236268],
              [-81.171455, 25.234483],
              [-81.171978, 25.223648],
              [-81.172044, 25.222276],
              [-81.171265, 25.221609],
              [-81.168046, 25.218854],
              [-81.15582, 25.208389],
              [-81.155481, 25.208098],
              [-81.155252, 25.207706],
              [-81.146737, 25.193139],
              [-81.142897, 25.184406],
              [-81.142471, 25.18344],
              [-81.142278, 25.183],
              [-81.141024, 25.163868],
              [-81.133567, 25.156295],
              [-81.120616, 25.152302],
              [-81.111943, 25.14547],
              [-81.094524, 25.127054],
              [-81.079859, 25.118797],
              [-81.050505, 25.128273],
              [-81.049896, 25.128298],
              [-81.049445, 25.128316],
              [-81.049344, 25.12832],
              [-81.049308, 25.128322],
              [-81.038021, 25.128781],
              [-81.033404, 25.128969],
              [-81.025154, 25.129305],
              [-81.022989, 25.129393],
              [-81.009598, 25.125403],
              [-80.999772, 25.12429],
              [-80.999176, 25.124222],
              [-80.994096, 25.126026],
              [-80.991949, 25.126789],
              [-80.977198, 25.132028],
              [-80.973129, 25.133473],
              [-80.971765, 25.133958],
              [-80.971664, 25.13397],
              [-80.971585, 25.13398],
              [-80.970797, 25.134076],
              [-80.970727, 25.134084],
              [-80.970185, 25.13415],
              [-80.967832, 25.134437],
              [-80.96774, 25.134448],
              [-80.967506, 25.134477],
              [-80.967465, 25.134482],
              [-80.958727, 25.135546],
              [-80.957427, 25.135704],
              [-80.95615, 25.135591],
              [-80.955577, 25.13554],
              [-80.954567, 25.13545],
              [-80.943216, 25.134443],
              [-80.943164, 25.134456],
              [-80.940988, 25.135003],
              [-80.939272, 25.135434],
              [-80.93675, 25.136068],
              [-80.931353, 25.137424],
              [-80.915965, 25.141291],
              [-80.915924, 25.141301],
              [-80.906578, 25.140307],
              [-80.902311, 25.139853],
              [-80.900668, 25.139679],
              [-80.900577, 25.139669],
              [-80.900559, 25.139755],
              [-80.898911, 25.147652],
              [-80.90022, 25.150627],
              [-80.901617, 25.153803],
              [-80.901592, 25.153933],
              [-80.90111, 25.156496],
              [-80.900124, 25.161726],
              [-80.900066, 25.162034],
              [-80.899459, 25.162337],
              [-80.891681, 25.166221],
              [-80.879235, 25.172436],
              [-80.878982, 25.172562],
              [-80.875731, 25.174185],
              [-80.87546, 25.174321],
              [-80.874815, 25.174405],
              [-80.874323, 25.174469],
              [-80.858801, 25.176493],
              [-80.858167, 25.176576],
              [-80.8464, 25.17706],
              [-80.846395, 25.17706],
              [-80.843703, 25.176312],
              [-80.838227, 25.174791],
              [-80.830034, 25.168094],
              [-80.828435, 25.164619],
              [-80.827489, 25.162562],
              [-80.827179, 25.161888],
              [-80.826544, 25.160509],
              [-80.82653, 25.160478],
              [-80.826465, 25.160504],
              [-80.823441, 25.161698],
              [-80.817116, 25.164196],
              [-80.815193, 25.164956],
              [-80.796219, 25.17245],
              [-80.795456, 25.172337],
              [-80.757581, 25.166734],
              [-80.751866, 25.163762],
              [-80.746264, 25.155303],
              [-80.746379, 25.148559],
              [-80.742877, 25.142646],
              [-80.73833, 25.143178],
              [-80.734741, 25.143598],
              [-80.728602, 25.144316],
              [-80.721886, 25.145101],
              [-80.715099, 25.140872],
              [-80.703718, 25.139115],
              [-80.70127, 25.146683],
              [-80.695038, 25.157588],
              [-80.688361, 25.164711],
              [-80.683909, 25.166491],
              [-80.679852, 25.166751],
              [-80.674324, 25.167104],
              [-80.66995, 25.167384],
              [-80.660692, 25.167976],
              [-80.656944, 25.168216],
              [-80.649251, 25.168708],
              [-80.648565, 25.169773],
              [-80.646099, 25.173599],
              [-80.645822, 25.174029],
              [-80.645737, 25.174069],
              [-80.642456, 25.175601],
              [-80.640823, 25.176364],
              [-80.640275, 25.17662],
              [-80.639873, 25.176633],
              [-80.633992, 25.176829],
              [-80.619024, 25.177328],
              [-80.618989, 25.177345],
              [-80.609609, 25.181901],
              [-80.609607, 25.181902],
              [-80.601627, 25.187931],
              [-80.594338, 25.193437],
              [-80.584771, 25.200665],
              [-80.584783, 25.200695],
              [-80.587593, 25.207695],
              [-80.589186, 25.223796],
              [-80.570785, 25.239366],
              [-80.558223, 25.239012],
              [-80.548491, 25.236535],
              [-80.540765, 25.229678],
              [-80.540947, 25.224945],
              [-80.54204, 25.22185],
              [-80.540947, 25.21821],
              [-80.530207, 25.216207],
              [-80.525784, 25.218649],
              [-80.52319, 25.22008],
              [-80.520359, 25.220788],
              [-80.515297, 25.218016],
              [-80.514724, 25.217702],
              [-80.512928, 25.216719],
              [-80.508116, 25.206725],
              [-80.508113, 25.206719],
              [-80.50778, 25.206488],
              [-80.503125, 25.203259],
              [-80.502983, 25.20316],
              [-80.498644, 25.20015],
              [-80.498361, 25.200091],
              [-80.496179, 25.199637],
              [-80.495341, 25.199463],
              [-80.488216, 25.206757],
              [-80.488035, 25.206942],
              [-80.487591, 25.207829],
              [-80.483244, 25.216526],
              [-80.469843, 25.230442],
              [-80.468366, 25.231977],
              [-80.467824, 25.23254],
              [-80.462832, 25.236248],
              [-80.447066, 25.24796],
              [-80.437815, 25.253077],
              [-80.419191, 25.26338],
              [-80.385978, 25.288289],
              [-80.383013, 25.301337],
              [-80.374116, 25.31735],
              [-80.361662, 25.327433],
              [-80.352469, 25.329805],
              [-80.335269, 25.338701],
              [-80.31036, 25.3731],
              [-80.306801, 25.384369],
              [-80.31036, 25.389707],
              [-80.320442, 25.391486],
              [-80.32578, 25.39801],
              [-80.326373, 25.422919],
              [-80.320442, 25.437153],
              [-80.328152, 25.443084],
              [-80.337049, 25.465621],
              [-80.339421, 25.478669],
              [-80.339421, 25.499427],
              [-80.328746, 25.53264],
              [-80.324594, 25.535605],
              [-80.313918, 25.539164],
              [-80.302057, 25.567632],
              [-80.305615, 25.575342],
              [-80.305615, 25.593134],
              [-80.301464, 25.613299],
              [-80.296719, 25.622195],
              [-80.288416, 25.630498],
              [-80.277147, 25.637022],
              [-80.267065, 25.651849],
              [-80.265879, 25.658373],
              [-80.250459, 25.688028],
              [-80.244528, 25.717089],
              [-80.240376, 25.724206],
              [-80.229107, 25.732509],
              [-80.197674, 25.74437],
              [-80.184626, 25.745557],
              [-80.172765, 25.737847],
              [-80.166241, 25.72895],
              [-80.164461, 25.721833],
              [-80.170392, 25.710565],
              [-80.176916, 25.685062],
              [-80.160903, 25.664897],
              [-80.154972, 25.66549],
              [-80.152303, 25.676759],
              [-80.154082, 25.683283],
              [-80.152896, 25.702855],
              [-80.144, 25.740812],
              [-80.137476, 25.750301],
              [-80.127987, 25.772245],
              [-80.127394, 25.791224],
              [-80.122056, 25.817913],
              [-80.119684, 25.841043],
              [-80.12087, 25.883152],
              [-80.117904, 25.915772],
              [-80.117798, 25.975152],
              [-80.117778, 25.986369],
              [-80.112334, 26.053193],
              [-80.109566, 26.087165],
              [-80.108995, 26.088372],
              [-80.106813, 26.092991],
              [-80.105266, 26.096264],
              [-80.101366, 26.147762],
              [-80.089365, 26.231859],
              [-80.085565, 26.249259],
              [-80.079865, 26.264358],
              [-80.075264, 26.318656],
              [-80.074837, 26.321032],
              [-80.072264, 26.335356],
              [-80.070564, 26.336455],
              [-80.060564, 26.444652],
              [-80.050363, 26.509549],
              [-80.038863, 26.569347],
              [-80.035363, 26.612346],
              [-80.035763, 26.676043],
              [-80.032862, 26.700842],
              [-80.032862, 26.715242],
              [-80.037462, 26.76634],
              [-80.036362, 26.77124],
              [-80.03212, 26.77153],
              [-80.031362, 26.796339],
              [-80.046263, 26.859238],
              [-80.066697, 26.927579],
              [-80.079531, 26.9705],
              [-80.093909, 27.018587],
              [-80.116772, 27.072397],
              [-80.138605, 27.111517],
              [-80.14982, 27.143557],
              [-80.159554, 27.163325],
              [-80.153375, 27.169308],
              [-80.16147, 27.192814],
              [-80.19309, 27.249546],
              [-80.199288, 27.263022],
              [-80.226753, 27.322736],
              [-80.233538, 27.341307],
              [-80.253665, 27.37979],
              [-80.265535, 27.420542],
              [-80.293171, 27.500314],
              [-80.30117, 27.500314],
              [-80.311757, 27.524625],
              [-80.321271, 27.557378],
              [-80.324699, 27.569178],
              [-80.330956, 27.597541],
              [-80.34437, 27.616226],
              [-80.350553, 27.628361],
              [-80.351717, 27.642623],
              [-80.383695, 27.740045],
              [-80.447179, 27.859731],
              [-80.447084, 27.860755],
              [-80.446973, 27.861954],
              [-80.508871, 27.970477],
              [-80.547675, 28.048795],
              [-80.566432, 28.09563],
              [-80.589975, 28.17799],
              [-80.604214, 28.257733],
              [-80.608074, 28.311285],
              [-80.606874, 28.336484],
              [-80.603374, 28.363983],
              [-80.596174, 28.390682],
              [-80.587813, 28.410856],
              [-80.574136, 28.427764],
              [-80.562877, 28.437779],
              [-80.526732, 28.451705],
              [-80.525094, 28.459454],
              [-80.536115, 28.478647],
              [-80.560973, 28.530736],
              [-80.567361, 28.562353],
              [-80.574868, 28.585166],
              [-80.583884, 28.597705],
              [-80.61679, 28.634561],
              [-80.631314, 28.655188],
              [-80.639019, 28.666131],
              [-80.641436, 28.669564],
              [-80.645839, 28.675817],
              [-80.647288, 28.677875],
              [-80.64776, 28.67847],
              [-80.647924, 28.678677],
              [-80.663183, 28.69794],
              [-80.672232, 28.709363],
              [-80.708545, 28.755202],
              [-80.709725, 28.756692],
              [-80.712714, 28.761277],
              [-80.713108, 28.761882],
              [-80.713183, 28.761997],
              [-80.732244, 28.791237],
              [-80.787021, 28.875266],
              [-80.878275, 29.010563],
              [-80.893675, 29.036163],
              [-80.907275, 29.064262],
              [-80.944376, 29.110861],
              [-80.966176, 29.14796],
              [-80.995423, 29.206052],
              [-81.046678, 29.307856],
              [-81.101923, 29.427055],
              [-81.123896, 29.474465],
              [-81.163581, 29.55529],
              [-81.211565, 29.667085],
              [-81.212878, 29.670667],
              [-81.229015, 29.714693],
              [-81.240924, 29.739218],
              [-81.256711, 29.784693],
              [-81.263396, 29.820663],
              [-81.264693, 29.858212],
              [-81.270442, 29.883106],
              [-81.27654, 29.90046],
              [-81.288955, 29.91518],
              [-81.295268, 29.928614],
              [-81.308978, 29.96944],
              [-81.355591, 30.162563],
              [-81.379879, 30.252914],
              [-81.385505, 30.273841],
              [-81.391606, 30.303441],
              [-81.396407, 30.34004],
              [-81.397422, 30.400626],
              [-81.407008, 30.42204],
              [-81.410809, 30.482039],
              [-81.42601, 30.496739],
              [-81.440108, 30.497678],
              [-81.447087, 30.503679],
              [-81.442784, 30.50992],
              [-81.434064, 30.522569],
              [-81.442564, 30.555189],
              [-81.443099, 30.600938],
              [-81.430843, 30.669393],
              [-81.42742, 30.69802],
              [-81.432725, 30.703017],
              [-81.444124, 30.709714],
              [-81.449375, 30.715601],
              [-81.45947, 30.741979],
              [-81.461065, 30.753684],
              [-81.460061, 30.769912],
              [-81.455287, 30.79093],
              [-81.446927, 30.81039],
              [-81.44013, 30.821369],
              [-81.430835, 30.831156],
              [-81.428577, 30.836336],
              [-81.405153, 30.908203],
              [-81.403409, 30.957914],
              [-81.408484, 30.977718],
              [-81.415825, 30.977192],
              [-81.420108, 30.974076],
              [-81.426929, 30.956615],
              [-81.447388, 30.956732],
              [-81.453568, 30.965573],
              [-81.466814, 30.97091],
              [-81.472321, 30.969899],
              [-81.475789, 30.965976],
              [-81.486966, 30.969602],
              [-81.493651, 30.977528],
              [-81.490586, 30.984952],
              [-81.469298, 30.996028],
              [-81.45924, 31.005692],
              [-81.457795, 31.010259],
              [-81.451444, 31.015515],
              [-81.44317, 31.016661],
              [-81.434923, 31.017804],
              [-81.43471, 31.014641],
              [-81.432475, 31.012991],
              [-81.424732, 31.013678],
              [-81.420474, 31.016703],
              [-81.415123, 31.026718],
              [-81.401267, 31.072781],
              [-81.401209, 31.086143],
              [-81.403732, 31.107115],
              [-81.402096, 31.125383],
              [-81.399677, 31.134113],
              [-81.38683, 31.133214],
              [-81.368241, 31.136534],
              [-81.359349, 31.149166],
              [-81.360791, 31.155903],
              [-81.35488, 31.167204],
              [-81.339028, 31.186918],
              [-81.314183, 31.207938],
              [-81.304957, 31.206173],
              [-81.293359, 31.206332],
              [-81.288403, 31.211065],
              [-81.289136, 31.225487],
              [-81.282842, 31.24433],
              [-81.276862, 31.254734],
              [-81.274688, 31.289454],
              [-81.269906, 31.294489],
              [-81.260958, 31.30391],
              [-81.25482, 31.315452],
              [-81.268027, 31.324218],
              [-81.274513, 31.326237],
              [-81.282923, 31.326491],
              [-81.279338, 31.351127],
              [-81.278798, 31.367214],
              [-81.258616, 31.404425],
              [-81.246911, 31.422784],
              [-81.204883, 31.473124],
              [-81.189643, 31.503588],
              [-81.177254, 31.517074],
              [-81.17831, 31.52241],
              [-81.181592, 31.527697],
              [-81.193016, 31.535833],
              [-81.199518, 31.537596],
              [-81.213519, 31.528152],
              [-81.217948, 31.527284],
              [-81.258809, 31.52906],
              [-81.263437, 31.530932],
              [-81.263905, 31.532579],
              [-81.260076, 31.54828],
              [-81.254218, 31.55594],
              [-81.240699, 31.552313],
              [-81.214536, 31.557601],
              [-81.204315, 31.568183],
              [-81.19438, 31.568101],
              [-81.186114, 31.568032],
              [-81.183252, 31.560058],
              [-81.178822, 31.55553],
              [-81.173079, 31.555908],
              [-81.160364, 31.570436],
              [-81.14997, 31.593476],
              [-81.133493, 31.623348],
              [-81.131728, 31.654484],
              [-81.136408, 31.674832],
              [-81.135608, 31.683491],
              [-81.131137, 31.695774],
              [-81.139394, 31.699917],
              [-81.149369, 31.699304],
              [-81.151888, 31.698411],
              [-81.154624, 31.693874],
              [-81.161084, 31.691401],
              [-81.186303, 31.701509],
              [-81.203572, 31.719448],
              [-81.198394, 31.72607],
              [-81.192784, 31.733245],
              [-81.16067, 31.728144],
              [-81.154686, 31.726203],
              [-81.138448, 31.720934],
              [-81.130634, 31.722692],
              [-81.097402, 31.753126],
              [-81.077057, 31.761256],
              [-81.068116, 31.768735],
              [-81.047345, 31.802865],
              [-81.036873, 31.812721],
              [-81.036958, 31.819558],
              [-81.039808, 31.823],
              [-81.04794, 31.824881],
              [-81.050946, 31.822383],
              [-81.057181, 31.822687],
              [-81.075812, 31.829031],
              [-81.076178, 31.836132],
              [-81.06279, 31.84474],
              [-81.05907, 31.850106],
              [-81.058596, 31.857811],
              [-81.065255, 31.877095],
              [-81.041548, 31.876198],
              [-81.014478, 31.867474],
              [-81.000317, 31.856744],
              [-80.99269, 31.857641],
              [-80.971434, 31.877941],
              [-80.947294, 31.89621],
              [-80.934508, 31.90918],
              [-80.941359, 31.912984],
              [-80.954469, 31.911768],
              [-80.968494, 31.915822],
              [-80.975714, 31.923602],
              [-80.972392, 31.94127],
              [-80.948491, 31.95723],
              [-80.930279, 31.956705],
              [-80.929101, 31.944964],
              [-80.911207, 31.943769],
              [-80.897687, 31.949065],
              [-80.882814, 31.959075],
              [-80.862814, 31.969346],
              [-80.848441, 31.988279],
              [-80.841913, 32.002643],
              [-80.840549, 32.011306],
              [-80.84313, 32.024226],
              [-80.852276, 32.026676],
              [-80.859111, 32.023693],
              [-80.885517, 32.0346],
              [-80.892344, 32.043764],
              [-80.905378, 32.051943],
              [-80.878111, 32.079792],
              [-80.858735, 32.099581],
              [-80.844431, 32.109709],
              [-80.831531, 32.112709],
              [-80.828394, 32.113222],
              [-80.82153, 32.108589],
              [-80.812503, 32.109746],
              [-80.789996, 32.122494],
              [-80.749091, 32.140137],
              [-80.721463, 32.160427],
              [-80.688857, 32.200971],
              [-80.669166, 32.216783],
              [-80.658634, 32.248638],
              [-80.638857, 32.255618],
              [-80.618286, 32.260183],
              [-80.596394, 32.273549],
              [-80.571096, 32.273278],
              [-80.545688, 32.282076],
              [-80.539429, 32.287024],
              [-80.517871, 32.298796],
              [-80.466342, 32.31917],
              [-80.455192, 32.326458],
              [-80.456814, 32.336884],
              [-80.445451, 32.350335],
              [-80.434303, 32.375193],
              [-80.429291, 32.389667],
              [-80.429941, 32.401782],
              [-80.43296, 32.410659],
              [-80.446075, 32.423721],
              [-80.467588, 32.425259],
              [-80.480156, 32.447048],
              [-80.484617, 32.460976],
              [-80.48025, 32.477407],
              [-80.47691, 32.48539],
              [-80.472068, 32.496964],
              [-80.46571, 32.4953],
              [-80.452078, 32.497286],
              [-80.439407, 32.503472],
              [-80.423454, 32.497989],
              [-80.418502, 32.490894],
              [-80.417896, 32.476076],
              [-80.415943, 32.472074],
              [-80.413487, 32.470672],
              [-80.392561, 32.475332],
              [-80.386827, 32.47881],
              [-80.380716, 32.486359],
              [-80.363956, 32.496098],
              [-80.343883, 32.490795],
              [-80.338354, 32.47873],
              [-80.332438, 32.478104],
              [-80.277681, 32.516161],
              [-80.249566, 32.529584],
              [-80.246361, 32.531114],
              [-80.20523, 32.555547],
              [-80.193676, 32.554213],
              [-80.188401, 32.553604],
              [-80.171764, 32.546118],
              [-80.167286, 32.559885],
              [-80.148406, 32.578479],
              [-80.121368, 32.590523],
              [-80.077039, 32.603319],
              [-80.037276, 32.610236],
              [-80.010505, 32.608852],
              [-79.999374, 32.611851],
              [-79.99175, 32.616389],
              [-79.986917, 32.626388],
              [-79.975248, 32.639537],
              [-79.968468, 32.639732],
              [-79.915682, 32.664915],
              [-79.884961, 32.684402],
              [-79.888028, 32.695177],
              [-79.870336, 32.727777],
              [-79.868352, 32.734849],
              [-79.873605, 32.745657],
              [-79.872232, 32.752128],
              [-79.866742, 32.757422],
              [-79.848527, 32.755248],
              [-79.84035, 32.756816],
              [-79.818237, 32.766352],
              [-79.811021, 32.77696],
              [-79.726389, 32.805996],
              [-79.716761, 32.813627],
              [-79.719879, 32.825796],
              [-79.702956, 32.835781],
              [-79.699482, 32.839997],
              [-79.695141, 32.850398],
              [-79.655426, 32.872705],
              [-79.631149, 32.888606],
              [-79.576006, 32.906235],
              [-79.569762, 32.926692],
              [-79.572614, 32.933885],
              [-79.574951, 32.934526],
              [-79.581687, 32.931341],
              [-79.585897, 32.926461],
              [-79.606194, 32.925953],
              [-79.612928, 32.934815],
              [-79.617715, 32.94487],
              [-79.617611, 32.952726],
              [-79.606615, 32.972248],
              [-79.60102, 32.979282],
              [-79.58659, 32.991334],
              [-79.580725, 33.006447],
              [-79.55756, 33.021269],
              [-79.522449, 33.03535],
              [-79.506923, 33.032813],
              [-79.488727, 33.015832],
              [-79.483499, 33.001265],
              [-79.461047, 33.007639],
              [-79.423447, 33.015085],
              [-79.416515, 33.006815],
              [-79.403712, 33.003903],
              [-79.359961, 33.006672],
              [-79.339313, 33.050336],
              [-79.335346, 33.065362],
              [-79.337169, 33.072302],
              [-79.329909, 33.089986],
              [-79.291591, 33.109773],
              [-79.290754, 33.110051],
              [-79.24609, 33.124865],
              [-79.238262, 33.137055],
              [-79.215453, 33.155569],
              [-79.195631, 33.166016],
              [-79.18787, 33.173712],
              [-79.172394, 33.206577],
              [-79.180563, 33.237955],
              [-79.180318, 33.254141],
              [-79.162332, 33.327246],
              [-79.158429, 33.332811],
              [-79.152035, 33.350925],
              [-79.147496, 33.378243],
              [-79.135441, 33.403867],
              [-79.10136, 33.461016],
              [-79.084588, 33.483669],
              [-79.041125, 33.523773],
              [-79.028516, 33.533365],
              [-79.007356, 33.566565],
              [-79.002109, 33.572114],
              [-78.938076, 33.639826],
              [-78.862931, 33.705654],
              [-78.812931, 33.743472],
              [-78.772737, 33.768511],
              [-78.714116, 33.800138],
              [-78.67226, 33.817587],
              [-78.584841, 33.844282],
              [-78.553944, 33.847831],
              [-78.541087, 33.851112],
              [-78.509042, 33.865515],
              [-78.383964, 33.901946],
              [-78.276147, 33.912364],
              [-78.17772, 33.914272],
              [-78.136952, 33.912178],
              [-78.095429, 33.906031],
              [-78.018689, 33.888289],
              [-78.009426, 33.867823],
              [-78.009973, 33.861406],
              [-78.006765, 33.858704],
              [-77.970606, 33.844517],
              [-77.960172, 33.853315],
              [-77.956881, 33.87779],
              [-77.946568, 33.912261],
              [-77.937313, 33.928645],
              [-77.927926, 33.945265],
              [-77.915536, 33.971723],
              [-77.878161, 34.067963],
              [-77.874384, 34.075671],
              [-77.870327, 34.079221],
              [-77.841785, 34.140747],
              [-77.829209, 34.162618],
              [-77.764022, 34.245641],
              [-77.740136, 34.272546],
              [-77.715916, 34.292719],
              [-77.713322, 34.294879],
              [-77.687226, 34.320444],
              [-77.661673, 34.341868],
              [-77.635034, 34.359555],
              [-77.582323, 34.400506],
              [-77.556943, 34.417218],
              [-77.51796, 34.440483],
              [-77.491796, 34.456098],
              [-77.462922, 34.471354],
              [-77.322524, 34.535574],
              [-77.240991, 34.587507],
              [-77.209161, 34.605032],
              [-77.169701, 34.622023],
              [-77.136843, 34.632926],
              [-77.1128, 34.639352],
              [-77.031105, 34.661184],
              [-76.990262, 34.669623],
              [-76.906257, 34.68282],
              [-76.817453, 34.693722],
              [-76.770044, 34.696899],
              [-76.726969, 34.69669],
              [-76.693751, 34.692509],
              [-76.676312, 34.693151],
              [-76.662645, 34.685524],
              [-76.642939, 34.677618],
              [-76.618719, 34.67255],
              [-76.579467, 34.660174],
              [-76.549343, 34.645585],
              [-76.550423, 34.630789],
              [-76.553806, 34.628252],
              [-76.555196, 34.615993],
              [-76.535946, 34.588577],
              [-76.524199, 34.615416],
              [-76.494068, 34.66197],
              [-76.450454, 34.71445],
              [-76.386804, 34.784579],
              [-76.31021, 34.852309],
              [-76.233088, 34.905477],
              [-76.137269, 34.987858],
              [-76.073, 35.030509],
              [-76.035933, 35.058987],
              [-76.038648, 35.065045],
              [-76.043621, 35.070017],
              [-76.064933, 35.077121],
              [-76.069906, 35.075701],
              [-76.093349, 35.048705],
              [-76.11182, 35.034497],
              [-76.160127, 34.991163],
              [-76.194936, 34.962747],
              [-76.233672, 34.925926],
              [-76.273986, 34.897298],
              [-76.322808, 34.86116],
              [-76.341279, 34.842689],
              [-76.362591, 34.824219],
              [-76.373247, 34.817115],
              [-76.383827, 34.807906],
              [-76.390254, 34.805568],
              [-76.403108, 34.806153],
              [-76.415871, 34.813563],
              [-76.415871, 34.82564],
              [-76.411609, 34.841268],
              [-76.400242, 34.855476],
              [-76.395269, 34.855476],
              [-76.379641, 34.86258],
              [-76.377154, 34.867553],
              [-76.368274, 34.872881],
              [-76.347673, 34.872171],
              [-76.33382, 34.882116],
              [-76.319967, 34.897745],
              [-76.311442, 34.910177],
              [-76.284092, 34.936817],
              [-76.277698, 34.940014],
              [-76.274856, 34.953867],
              [-76.275567, 34.960971],
              [-76.290691, 34.969059],
              [-76.296524, 34.976245],
              [-76.296188, 34.98669],
              [-76.293851, 34.991948],
              [-76.29093, 34.994285],
              [-76.288709, 34.997201],
              [-76.288354, 35.005726],
              [-76.293682, 35.009633],
              [-76.318546, 35.020645],
              [-76.35229, 35.033077],
              [-76.364367, 35.034853],
              [-76.364367, 35.031301],
              [-76.360815, 35.025973],
              [-76.350159, 35.016737],
              [-76.329557, 34.986901],
              [-76.326361, 34.976245],
              [-76.332044, 34.970917],
              [-76.395625, 34.975179],
              [-76.398466, 34.9766],
              [-76.406281, 34.987256],
              [-76.425461, 35.001464],
              [-76.431855, 35.030945],
              [-76.432565, 35.049061],
              [-76.435762, 35.057941],
              [-76.463468, 35.076411],
              [-76.468796, 35.075345],
              [-76.474521, 35.070116],
              [-76.480141, 35.05213],
              [-76.490258, 35.034144],
              [-76.491382, 35.017283],
              [-76.495879, 35.011662],
              [-76.502623, 35.007166],
              [-76.539719, 35.000421],
              [-76.566697, 34.998173],
              [-76.588055, 34.991428],
              [-76.628523, 34.994801],
              [-76.642012, 35.012786],
              [-76.644562, 35.019799],
              [-76.646509, 35.025151],
              [-76.646509, 35.042013],
              [-76.639764, 35.051006],
              [-76.631895, 35.056626],
              [-76.622902, 35.061123],
              [-76.61391, 35.061123],
              [-76.60042, 35.067867],
              [-76.593676, 35.075736],
              [-76.592552, 35.083605],
              [-76.586931, 35.092598],
              [-76.57569, 35.092598],
              [-76.568945, 35.097094],
              [-76.561077, 35.108335],
              [-76.557704, 35.116204],
              [-76.546463, 35.122948],
              [-76.536346, 35.142058],
              [-76.536346, 35.149927],
              [-76.539719, 35.166788],
              [-76.536346, 35.174657],
              [-76.521733, 35.192643],
              [-76.504872, 35.207256],
              [-76.494755, 35.212877],
              [-76.491382, 35.220745],
              [-76.490258, 35.233111],
              [-76.483514, 35.240979],
              [-76.477893, 35.243228],
              [-76.467776, 35.261213],
              [-76.467776, 35.276951],
              [-76.472273, 35.294936],
              [-76.482389, 35.314046],
              [-76.500375, 35.321915],
              [-76.548712, 35.328659],
              [-76.554332, 35.332032],
              [-76.588055, 35.333156],
              [-76.602669, 35.336528],
              [-76.604962, 35.337751],
              [-76.61953, 35.345521],
              [-76.628523, 35.368003],
              [-76.628125, 35.368515],
              [-76.620654, 35.37812],
              [-76.606041, 35.387113],
              [-76.580187, 35.387113],
              [-76.546901, 35.389673],
              [-76.521733, 35.391609],
              [-76.499251, 35.381492],
              [-76.485762, 35.371375],
              [-76.472273, 35.371375],
              [-76.462156, 35.380368],
              [-76.455411, 35.383741],
              [-76.448666, 35.383741],
              [-76.436301, 35.37812],
              [-76.431805, 35.362383],
              [-76.420564, 35.35901],
              [-76.409323, 35.35339],
              [-76.408199, 35.350017],
              [-76.399206, 35.348893],
              [-76.387965, 35.356762],
              [-76.382344, 35.356762],
              [-76.374475, 35.355638],
              [-76.365483, 35.348893],
              [-76.349745, 35.345521],
              [-76.340752, 35.346645],
              [-76.335132, 35.355638],
              [-76.327263, 35.356762],
              [-76.304781, 35.355638],
              [-76.282299, 35.345521],
              [-76.265437, 35.343273],
              [-76.257569, 35.344397],
              [-76.253072, 35.350017],
              [-76.235087, 35.350017],
              [-76.20586, 35.336528],
              [-76.182254, 35.336528],
              [-76.168764, 35.332032],
              [-76.165392, 35.328659],
              [-76.149655, 35.326411],
              [-76.14291, 35.32866],
              [-76.14291, 35.338776],
              [-76.132793, 35.349455],
              [-76.123238, 35.351142],
              [-76.092887, 35.361259],
              [-76.069281, 35.370813],
              [-76.059726, 35.383741],
              [-76.06085, 35.392733],
              [-76.063661, 35.398354],
              [-76.063661, 35.405099],
              [-76.059726, 35.410157],
              [-76.050171, 35.415778],
              [-76.037244, 35.414091],
              [-76.025441, 35.408471],
              [-76.020945, 35.410719],
              [-76.014762, 35.416902],
              [-76.01139, 35.423084],
              [-76.012514, 35.432639],
              [-76.009704, 35.442194],
              [-75.997901, 35.453435],
              [-75.994528, 35.463552],
              [-75.995652, 35.475355],
              [-75.987222, 35.484348],
              [-75.963053, 35.493903],
              [-75.961929, 35.496713],
              [-75.96474, 35.504582],
              [-75.964178, 35.511326],
              [-75.954623, 35.526502],
              [-75.950126, 35.530998],
              [-75.94563, 35.53437],
              [-75.916403, 35.538305],
              [-75.908534, 35.546174],
              [-75.908534, 35.555166],
              [-75.906848, 35.559101],
              [-75.895045, 35.573152],
              [-75.869869, 35.582743],
              [-75.859636, 35.586641],
              [-75.851767, 35.578773],
              [-75.837154, 35.570904],
              [-75.797248, 35.574276],
              [-75.775328, 35.579335],
              [-75.778138, 35.592262],
              [-75.762963, 35.603503],
              [-75.747225, 35.610248],
              [-75.729802, 35.625985],
              [-75.729802, 35.628795],
              [-75.737109, 35.63835],
              [-75.742167, 35.655212],
              [-75.741605, 35.672073],
              [-75.713502, 35.693993],
              [-75.71294, 35.69849],
              [-75.715188, 35.708045],
              [-75.719123, 35.714227],
              [-75.724743, 35.742892],
              [-75.735422, 35.767622],
              [-75.739357, 35.770994],
              [-75.738233, 35.778301],
              [-75.732612, 35.790666],
              [-75.726689, 35.811361],
              [-75.727216, 35.822703],
              [-75.734587, 35.839266],
              [-75.748276, 35.852428],
              [-75.753014, 35.871382],
              [-75.751961, 35.878227],
              [-75.768809, 35.901393],
              [-75.778813, 35.918241],
              [-75.782498, 35.928244],
              [-75.782498, 35.935615],
              [-75.800926, 35.944566],
              [-75.805138, 35.954043],
              [-75.80935, 35.959308],
              [-75.84989, 35.976156],
              [-75.86042, 35.978262],
              [-75.879374, 35.978789],
              [-75.899382, 35.977209],
              [-75.938343, 35.9651],
              [-75.947293, 35.959835],
              [-75.946767, 35.955623],
              [-75.943608, 35.952464],
              [-75.937816, 35.950884],
              [-75.92676, 35.940354],
              [-75.927286, 35.93193],
              [-75.929919, 35.928771],
              [-75.934131, 35.928244],
              [-75.94782, 35.920347],
              [-75.962562, 35.901393],
              [-75.966247, 35.899287],
              [-75.97783, 35.897181],
              [-75.999386, 35.903521],
              [-76.004682, 35.905078],
              [-76.011526, 35.914029],
              [-76.01995, 35.934036],
              [-76.014159, 35.957202],
              [-76.014685, 35.960361],
              [-76.024162, 35.970891],
              [-76.062071, 35.993004],
              [-76.083131, 35.989845],
              [-76.093697, 35.993001],
              [-76.176585, 35.993267],
              [-76.213966, 35.988002],
              [-76.272408, 35.972734],
              [-76.317687, 35.946935],
              [-76.340327, 35.94325],
              [-76.362966, 35.942197],
              [-76.36521, 35.944697],
              [-76.381394, 35.96273],
              [-76.38192, 35.971681],
              [-76.389818, 35.980105],
              [-76.398242, 35.984317],
              [-76.460632, 35.970365],
              [-76.473795, 35.960888],
              [-76.496961, 35.955096],
              [-76.507491, 35.949831],
              [-76.528551, 35.944039],
              [-76.586992, 35.941933],
              [-76.60384, 35.939827],
              [-76.608052, 35.936668],
              [-76.657017, 35.935089],
              [-76.667547, 35.933509],
              [-76.673865, 35.935089],
              [-76.691766, 35.944566],
              [-76.692376, 35.945342],
              [-76.697558, 35.951937],
              [-76.70019, 35.964573],
              [-76.695452, 35.973524],
              [-76.684922, 35.983001],
              [-76.679657, 35.991951],
              [-76.683869, 36.000375],
              [-76.684922, 36.009852],
              [-76.671759, 36.018276],
              [-76.668814, 36.020968],
              [-76.653332, 36.035124],
              [-76.631745, 36.038283],
              [-76.615423, 36.037757],
              [-76.60384, 36.033018],
              [-76.589625, 36.015644],
              [-76.580674, 36.00722],
              [-76.575936, 36.006167],
              [-76.5633, 36.009852],
              [-76.547505, 36.009852],
              [-76.514335, 36.00564],
              [-76.491959, 36.018013],
              [-76.459316, 36.024331],
              [-76.458789, 36.028016],
              [-76.451418, 36.039073],
              [-76.442994, 36.042758],
              [-76.420881, 36.06066],
              [-76.412984, 36.072243],
              [-76.411844, 36.075376],
              [-76.410878, 36.078034],
              [-76.355069, 36.086458],
              [-76.337168, 36.086458],
              [-76.331902, 36.083826],
              [-76.323478, 36.084879],
              [-76.303998, 36.092776],
              [-76.298733, 36.1012],
              [-76.28715, 36.104886],
              [-76.265037, 36.104886],
              [-76.238712, 36.098568],
              [-76.216599, 36.095409],
              [-76.191715, 36.107197],
              [-76.19238, 36.113448],
              [-76.190784, 36.116108],
              [-76.19051, 36.116333],
              [-76.184133, 36.121562],
              [-76.178946, 36.123424],
              [-76.092555, 36.135794],
              [-76.071672, 36.140183],
              [-76.064224, 36.143775],
              [-76.05927, 36.149285],
              [-76.05992, 36.15514],
              [-76.06545, 36.165224],
              [-76.065287, 36.170591],
              [-76.063498, 36.173518],
              [-76.051626, 36.181325],
              [-76.0471, 36.183106],
              [-76.031784, 36.189131],
              [-76.018936, 36.188318],
              [-76.016984, 36.186367],
              [-75.995191, 36.178072],
              [-75.939047, 36.165518],
              [-75.924654, 36.163591],
              [-75.920028, 36.164853],
              [-75.904999, 36.164188],
              [-75.887415, 36.160233],
              [-75.875033, 36.157448],
              [-75.869828, 36.15458],
              [-75.867385, 36.151182],
              [-75.866323, 36.14141],
              [-75.867792, 36.127262],
              [-75.847785, 36.10199],
              [-75.836084, 36.092616],
              [-75.799779, 36.07264],
              [-75.793974, 36.07171],
              [-75.791637, 36.082267],
              [-75.800378, 36.112728],
              [-75.813444, 36.136871],
              [-75.822531, 36.145957],
              [-75.823915, 36.158332],
              [-75.839924, 36.17711],
              [-75.841222, 36.193812],
              [-75.838367, 36.200129],
              [-75.848838, 36.21657],
              [-75.858703, 36.222628],
              [-75.864154, 36.235522],
              [-75.867356, 36.252483],
              [-75.861818, 36.266415],
              [-75.86052, 36.280607],
              [-75.864933, 36.284674],
              [-75.872721, 36.28277],
              [-75.882154, 36.284674],
              [-75.888211, 36.293414],
              [-75.895285, 36.319615],
              [-75.915331, 36.352335],
              [-75.917758, 36.353593],
              [-75.923331, 36.361863],
              [-75.923511, 36.367796],
              [-75.916949, 36.383167],
              [-75.916409, 36.38901],
              [-75.923601, 36.425788],
              [-75.928369, 36.428588],
              [-75.932694, 36.427627],
              [-75.936446, 36.423079],
              [-75.940676, 36.41885],
              [-75.962285, 36.41724],
              [-75.98005, 36.435464],
              [-75.989869, 36.436808],
              [-76.003912, 36.441864],
              [-76.012337, 36.447462],
              [-76.020216, 36.45862],
              [-76.031949, 36.482496],
              [-76.029221, 36.494365],
              [-76.023627, 36.500778],
              [-76.019261, 36.503506],
              [-76.003708, 36.506235],
              [-75.972545, 36.494671],
              [-75.960069, 36.495025],
              [-75.935473, 36.490601],
              [-75.927333, 36.482815],
              [-75.924127, 36.482124],
              [-75.917283, 36.485809],
              [-75.913071, 36.486336],
              [-75.907279, 36.485809],
              [-75.899908, 36.482124],
              [-75.891484, 36.460537],
              [-75.888325, 36.441583],
              [-75.880428, 36.435792],
              [-75.864106, 36.430527],
              [-75.85147, 36.415785],
              [-75.852523, 36.384721],
              [-75.85147, 36.379456],
              [-75.847258, 36.372085],
              [-75.843046, 36.371032],
              [-75.836201, 36.363135],
              [-75.831595, 36.346418],
              [-75.831858, 36.339047],
              [-75.841335, 36.328517],
              [-75.845284, 36.305614],
              [-75.837913, 36.294558],
              [-75.833964, 36.292188],
              [-75.822907, 36.291662],
              [-75.814483, 36.285344],
              [-75.808165, 36.259545],
              [-75.811851, 36.247699],
              [-75.811588, 36.244014],
              [-75.80369, 36.235853],
              [-75.798528, 36.2308],
              [-75.794371, 36.227336],
              [-75.793286, 36.226432],
              [-75.783676, 36.215949],
              [-75.775814, 36.201097],
              [-75.75572, 36.153922],
              [-75.752226, 36.140817],
              [-75.750479, 36.131208],
              [-75.75025, 36.121076],
              [-75.73972, 36.07527],
              [-75.739457, 36.066846],
              [-75.741563, 36.055526],
              [-75.74051, 36.046839],
              [-75.737088, 36.040784],
              [-75.726821, 36.040521],
              [-75.722609, 36.037362],
              [-75.722082, 36.03236],
              [-75.726558, 36.02104],
              [-75.727084, 36.01051],
              [-75.723662, 36.003139],
              [-75.678909, 35.993925],
              [-75.671801, 35.985238],
              [-75.668379, 35.978394],
              [-75.648899, 35.965758],
              [-75.631215, 35.941512],
              [-75.620114, 35.925288],
              [-75.617552, 35.914186],
              [-75.617045, 35.906],
              [-75.619151, 35.889415],
              [-75.60125, 35.867302],
              [-75.588878, 35.844926],
              [-75.573083, 35.828867],
              [-75.566238, 35.813072],
              [-75.553934, 35.799332],
              [-75.546675, 35.787377],
              [-75.543259, 35.779691],
              [-75.536428, 35.780118],
              [-75.533012, 35.787377],
              [-75.538739, 35.797396],
              [-75.552299, 35.822173],
              [-75.569794, 35.863301],
              [-75.658537, 36.02043],
              [-75.696742, 36.077497],
              [-75.71831, 36.113674],
              [-75.738431, 36.154282],
              [-75.759637, 36.204705],
              [-75.77251, 36.22944],
              [-75.773329, 36.231529],
              [-75.79641, 36.290351],
              [-75.818735, 36.357579],
              [-75.834975, 36.42265],
              [-75.856901, 36.500155],
              [-75.867044, 36.550754],
              [-75.874145, 36.583853],
              [-75.890946, 36.630753],
              [-75.921748, 36.692051],
              [-75.94955, 36.76115],
              [-75.965451, 36.812449],
              [-75.972151, 36.842268],
              [-75.991552, 36.910847],
              [-75.996252, 36.922047],
              [-76.007553, 36.929047],
              [-76.013753, 36.930746],
              [-76.033454, 36.931946],
              [-76.043054, 36.927547],
              [-76.058154, 36.916947],
              [-76.087955, 36.908647],
              [-76.095508, 36.908817],
              [-76.139557, 36.923047],
              [-76.177019, 36.92929],
              [-76.189959, 36.931447],
              [-76.22166, 36.939547],
              [-76.234961, 36.945147],
              [-76.267962, 36.964547],
              [-76.285063, 36.968747],
              [-76.297663, 36.968147],
              [-76.299364, 36.965547],
              [-76.315867, 36.955351],
              [-76.322764, 36.959147],
              [-76.327365, 36.959447],
              [-76.330765, 36.938647],
              [-76.328864, 36.918447],
              [-76.333158, 36.917293],
              [-76.344663, 36.919313],
              [-76.345569, 36.924531],
              [-76.353765, 36.922747],
              [-76.385867, 36.923247],
              [-76.387567, 36.899547],
              [-76.406908, 36.897507],
              [-76.407507, 36.897444],
              [-76.43122, 36.904532],
              [-76.441605, 36.906116],
              [-76.447413, 36.90322],
              [-76.453941, 36.89274],
              [-76.45329, 36.887031],
              [-76.454692, 36.884077],
              [-76.469914, 36.882898],
              [-76.483369, 36.896239],
              [-76.482135, 36.901108],
              [-76.482407, 36.917364],
              [-76.484107, 36.928916],
              [-76.487559, 36.952372],
              [-76.500355, 36.965212],
              [-76.513363, 36.968057],
              [-76.521006, 36.973187],
              [-76.524142, 36.978316],
              [-76.522971, 36.981085],
              [-76.524853, 36.983833],
              [-76.551246, 36.998946],
              [-76.562923, 37.003796],
              [-76.565803, 37.007493],
              [-76.576617, 37.021374],
              [-76.577531, 37.022548],
              [-76.57816, 37.022982],
              [-76.579236, 37.023726],
              [-76.579393, 37.023835],
              [-76.584478, 37.027349],
              [-76.586491, 37.02874],
              [-76.612124, 37.035604],
              [-76.646013, 37.036228],
              [-76.653998, 37.039172],
              [-76.662558, 37.045748],
              [-76.66835, 37.05506],
              [-76.669822, 37.06426],
              [-76.669118, 37.068132],
              [-76.668295, 37.072656],
              [-76.667646, 37.076228],
              [-76.667219, 37.077149],
              [-76.666526, 37.078643],
              [-76.66555, 37.080746],
              [-76.659394, 37.094019],
              [-76.65811, 37.096787],
              [-76.657703, 37.101161],
              [-76.657101, 37.107617],
              [-76.656894, 37.109843],
              [-76.66375, 37.129979],
              [-76.665641, 37.135534],
              [-76.665833, 37.136098],
              [-76.666542, 37.138179],
              [-76.669604, 37.140534],
              [-76.671588, 37.14206],
              [-76.67147, 37.158739],
              [-76.66867, 37.166771],
              [-76.66427, 37.171027],
              [-76.663774, 37.173875],
              [-76.669886, 37.183571],
              [-76.685614, 37.198851],
              [-76.691918, 37.195731],
              [-76.692926, 37.186147],
              [-76.696735, 37.174403],
              [-76.715295, 37.148035],
              [-76.73032, 37.145395],
              [-76.73728, 37.146164],
              [-76.747632, 37.150548],
              [-76.756899, 37.161582],
              [-76.796905, 37.189404],
              [-76.802511, 37.198308],
              [-76.803198, 37.201513],
              [-76.801023, 37.206043],
              [-76.791555, 37.207564],
              [-76.780532, 37.209336],
              [-76.773752, 37.206061],
              [-76.757765, 37.191658],
              [-76.75047, 37.190098],
              [-76.74304, 37.192611],
              [-76.74, 37.195379],
              [-76.73432, 37.204211],
              [-76.730951, 37.213813],
              [-76.698943, 37.219059],
              [-76.693373, 37.221228],
              [-76.689166, 37.222866],
              [-76.649869, 37.220914],
              [-76.641085, 37.216002],
              [-76.639608, 37.214783],
              [-76.629868, 37.206738],
              [-76.623292, 37.198738],
              [-76.621113, 37.195103],
              [-76.619962, 37.193184],
              [-76.61934, 37.192146],
              [-76.618008, 37.186429],
              [-76.617537, 37.184409],
              [-76.616804, 37.18126],
              [-76.616268, 37.178962],
              [-76.614221, 37.174335],
              [-76.613599, 37.172931],
              [-76.612517, 37.170486],
              [-76.611018, 37.167097],
              [-76.610972, 37.166994],
              [-76.606684, 37.166674],
              [-76.604476, 37.160034],
              [-76.617084, 37.144498],
              [-76.622252, 37.142146],
              [-76.62478, 37.127091],
              [-76.618252, 37.119347],
              [-76.579499, 37.096627],
              [-76.567931, 37.080467],
              [-76.564219, 37.077507],
              [-76.555066, 37.075859],
              [-76.536875, 37.083942],
              [-76.528997, 37.079388],
              [-76.526203, 37.077773],
              [-76.526573, 37.070047],
              [-76.527973, 37.068247],
              [-76.526273, 37.062947],
              [-76.518242, 37.055351],
              [-76.512289, 37.054858],
              [-76.509339, 37.053173],
              [-76.507614, 37.052188],
              [-76.46949, 37.030414],
              [-76.464471, 37.027547],
              [-76.448231, 37.007705],
              [-76.449891, 37.004868],
              [-76.452461, 37.004603],
              [-76.452118, 36.998163],
              [-76.428869, 36.969947],
              [-76.418969, 36.964047],
              [-76.411768, 36.962847],
              [-76.408568, 36.969147],
              [-76.396368, 36.982347],
              [-76.387711, 36.989671],
              [-76.383367, 36.993347],
              [-76.373567, 36.998347],
              [-76.356366, 37.002947],
              [-76.348066, 37.006747],
              [-76.340666, 37.015246],
              [-76.34011, 37.015212],
              [-76.329531, 37.014556],
              [-76.318065, 37.013846],
              [-76.314624, 37.00933],
              [-76.315008, 37.001683],
              [-76.312048, 37.000371],
              [-76.304272, 37.001378],
              [-76.300352, 37.00885],
              [-76.292863, 37.035145],
              [-76.271262, 37.084544],
              [-76.274463, 37.094544],
              [-76.287236, 37.117453],
              [-76.292344, 37.126615],
              [-76.311088, 37.138495],
              [-76.324353, 37.142895],
              [-76.330481, 37.141727],
              [-76.334017, 37.144223],
              [-76.340129, 37.151823],
              [-76.34405, 37.160367],
              [-76.344898, 37.164479],
              [-76.343234, 37.166207],
              [-76.348658, 37.170655],
              [-76.35969, 37.16858],
              [-76.375255, 37.16084],
              [-76.381379, 37.155711],
              [-76.394756, 37.157568],
              [-76.399659, 37.160272],
              [-76.397883, 37.164415],
              [-76.391252, 37.179887],
              [-76.389284, 37.193503],
              [-76.396052, 37.201087],
              [-76.3936, 37.214049],
              [-76.389793, 37.222981],
              [-76.394132, 37.22515],
              [-76.471799, 37.216016],
              [-76.494008, 37.225408],
              [-76.50364, 37.233856],
              [-76.4989, 37.241015],
              [-76.493302, 37.24947],
              [-76.48284, 37.254831],
              [-76.475927, 37.250543],
              [-76.429141, 37.25331],
              [-76.421765, 37.255198],
              [-76.417173, 37.26395],
              [-76.392788, 37.264973],
              [-76.36229, 37.270226],
              [-76.349489, 37.273963],
              [-76.352556, 37.278334],
              [-76.369029, 37.279311],
              [-76.381075, 37.28534],
              [-76.385603, 37.294108],
              [-76.38777, 37.30767],
              [-76.406388, 37.332924],
              [-76.434965, 37.354524],
              [-76.445333, 37.36646],
              [-76.437525, 37.37975],
              [-76.422503, 37.381355],
              [-76.418176, 37.385064],
              [-76.418719, 37.3978],
              [-76.415167, 37.402133],
              [-76.404756, 37.400213],
              [-76.393125, 37.398068],
              [-76.393958, 37.39594],
              [-76.391437, 37.390284],
              [-76.387112, 37.385061],
              [-76.366751, 37.374495],
              [-76.337476, 37.364014],
              [-76.31205, 37.338088],
              [-76.308581, 37.329366],
              [-76.291324, 37.324145],
              [-76.282555, 37.319107],
              [-76.275552, 37.309964],
              [-76.272005, 37.322194],
              [-76.272888, 37.335174],
              [-76.264847, 37.357399],
              [-76.262407, 37.360786],
              [-76.258277, 37.36202],
              [-76.24846, 37.375135],
              [-76.245283, 37.386839],
              [-76.246617, 37.404122],
              [-76.250454, 37.421886],
              [-76.252415, 37.447274],
              [-76.265056, 37.481365],
              [-76.281043, 37.507821],
              [-76.288167, 37.514118],
              [-76.293599, 37.516499],
              [-76.297651, 37.515424],
              [-76.298456, 37.512677],
              [-76.296445, 37.511235],
              [-76.297739, 37.506863],
              [-76.306952, 37.497488],
              [-76.32947, 37.49492],
              [-76.352678, 37.504913],
              [-76.359378, 37.513426],
              [-76.360474, 37.51924],
              [-76.355084, 37.527364],
              [-76.348992, 37.536548],
              [-76.339989, 37.53833],
              [-76.330598, 37.536391],
              [-76.302762, 37.551295],
              [-76.29796, 37.557636],
              [-76.300144, 37.561734],
              [-76.332641, 37.570042],
              [-76.357835, 37.573699],
              [-76.383188, 37.573056],
              [-76.410781, 37.581815],
              [-76.420252, 37.598686],
              [-76.435474, 37.612807],
              [-76.527188, 37.611315],
              [-76.533777, 37.61253],
              [-76.542666, 37.616857],
              [-76.574049, 37.646781],
              [-76.583143, 37.661986],
              [-76.579591, 37.671508],
              [-76.597868, 37.702918],
              [-76.598073, 37.70912],
              [-76.595943, 37.712989],
              [-76.597213, 37.717269],
              [-76.606466, 37.724819],
              [-76.61997, 37.731271],
              [-76.621433, 37.737973],
              [-76.617373, 37.742347],
              [-76.61971, 37.744795],
              [-76.639962, 37.750941],
              [-76.663887, 37.751887],
              [-76.677002, 37.7561],
              [-76.680922, 37.759647],
              [-76.683372, 37.765507],
              [-76.683359, 37.770258],
              [-76.683343, 37.775783],
              [-76.681901, 37.778118],
              [-76.683775, 37.781391],
              [-76.689773, 37.78519],
              [-76.715498, 37.785873],
              [-76.723863, 37.788503],
              [-76.734309, 37.79866],
              [-76.7512, 37.824141],
              [-76.766328, 37.840437],
              [-76.782826, 37.863184],
              [-76.784618, 37.869569],
              [-76.77539, 37.874306],
              [-76.765711, 37.879274],
              [-76.747552, 37.875864],
              [-76.738395, 37.865373],
              [-76.733046, 37.852009],
              [-76.72718, 37.842263],
              [-76.722156, 37.83668],
              [-76.701606, 37.822677],
              [-76.692747, 37.82277],
              [-76.680197, 37.825654],
              [-76.658302, 37.806815],
              [-76.651413, 37.796239],
              [-76.642276, 37.792317],
              [-76.615351, 37.780759],
              [-76.602024, 37.772731],
              [-76.595939, 37.77168],
              [-76.593835, 37.772848],
              [-76.584289, 37.76889],
              [-76.576387, 37.757493],
              [-76.560476, 37.727827],
              [-76.54005, 37.704432],
              [-76.537228, 37.698892],
              [-76.535302, 37.687516],
              [-76.537698, 37.66893],
              [-76.536548, 37.663574],
              [-76.510187, 37.642324],
              [-76.501522, 37.643762],
              [-76.497564, 37.647056],
              [-76.491799, 37.663614],
              [-76.489576, 37.666201],
              [-76.472392, 37.665772],
              [-76.443254, 37.652347],
              [-76.399236, 37.628636],
              [-76.390054, 37.630326],
              [-76.381106, 37.627003],
              [-76.36232, 37.610368],
              [-76.309174, 37.621892],
              [-76.28037, 37.613715],
              [-76.279447, 37.618225],
              [-76.287959, 37.631771],
              [-76.292534, 37.636098],
              [-76.306464, 37.642005],
              [-76.332562, 37.645817],
              [-76.339892, 37.655966],
              [-76.324808, 37.676983],
              [-76.320216, 37.680666],
              [-76.315161, 37.68472],
              [-76.312079, 37.684651],
              [-76.302545, 37.689],
              [-76.300067, 37.695364],
              [-76.302803, 37.704474],
              [-76.312858, 37.720338],
              [-76.304917, 37.729913],
              [-76.312108, 37.750522],
              [-76.306489, 37.788646],
              [-76.310307, 37.794849],
              [-76.307482, 37.81235],
              [-76.293525, 37.822717],
              [-76.284904, 37.822308],
              [-76.281985, 37.818068],
              [-76.282592, 37.814109],
              [-76.280544, 37.812597],
              [-76.275178, 37.812664],
              [-76.266057, 37.8174],
              [-76.251358, 37.833072],
              [-76.245072, 37.861918],
              [-76.236725, 37.889174],
              [-76.265998, 37.91138],
              [-76.343848, 37.947345],
              [-76.360211, 37.952329],
              [-76.391439, 37.958742],
              [-76.416299, 37.966828],
              [-76.427487, 37.977038],
              [-76.462542, 37.998572],
              [-76.465291, 38.010226],
              [-76.469343, 38.013544],
              [-76.491998, 38.017222],
              [-76.516547, 38.026566],
              [-76.519536, 38.034814],
              [-76.522354, 38.04259],
              [-76.535919, 38.069532],
              [-76.543155, 38.076971],
              [-76.579497, 38.09487],
              [-76.600937, 38.110084],
              [-76.604131, 38.128771],
              [-76.613939, 38.148587],
              [-76.629476, 38.15305],
              [-76.638983, 38.151476],
              [-76.643448, 38.14825],
              [-76.665127, 38.147638],
              [-76.684892, 38.156497],
              [-76.701297, 38.155718],
              [-76.704048, 38.149264],
              [-76.721722, 38.137635],
              [-76.738938, 38.14651],
              [-76.740278, 38.152824],
              [-76.743064, 38.156988],
              [-76.749685, 38.162114],
              [-76.760241, 38.166581],
              [-76.788445, 38.169199],
              [-76.802968, 38.167988],
              [-76.824274, 38.163639],
              [-76.838795, 38.163476],
              [-76.875272, 38.172207],
              [-76.910832, 38.197073],
              [-76.916922, 38.199751],
              [-76.937134, 38.202384],
              [-76.962311, 38.214075],
              [-76.967335, 38.227185],
              [-76.966553, 38.229542],
              [-76.962375, 38.230093],
              [-76.957417, 38.236341],
              [-76.957796, 38.243183],
              [-76.96215, 38.256486],
              [-76.981372, 38.274214],
              [-76.990255, 38.273935],
              [-76.99767, 38.278047],
              [-77.026304, 38.302685],
              [-77.030683, 38.311623],
              [-77.020947, 38.329273],
              [-77.016932, 38.341697],
              [-77.011827, 38.374554],
              [-77.024866, 38.386791],
              [-77.043526, 38.400548],
              [-77.051437, 38.399083],
              [-77.056032, 38.3962],
              [-77.069956, 38.377895],
              [-77.08481, 38.368297],
              [-77.094665, 38.367715],
              [-77.104717, 38.369655],
              [-77.138224, 38.367917],
              [-77.155191, 38.351047],
              [-77.162692, 38.345994],
              [-77.17934, 38.341915],
              [-77.199433, 38.34089],
              [-77.240072, 38.331598],
              [-77.265295, 38.333165],
              [-77.279633, 38.339444],
              [-77.286202, 38.347024],
              [-77.286202, 38.347025],
              [-77.28835, 38.351286],
              [-77.288145, 38.359477],
              [-77.296077, 38.369797],
              [-77.317288, 38.383576],
              [-77.314848, 38.389579],
              [-77.312201, 38.390958],
              [-77.310719, 38.397669],
              [-77.319036, 38.417803],
              [-77.32544, 38.44885],
              [-77.322622, 38.467131],
              [-77.310334, 38.493926],
              [-77.302457, 38.504683],
              [-77.300776, 38.506978],
              [-77.298844, 38.508724],
              [-77.29582, 38.511457],
              [-77.291103, 38.515721],
              [-77.283503, 38.525221],
              [-77.276303, 38.53962],
              [-77.276603, 38.54712],
              [-77.26083, 38.56533],
              [-77.265304, 38.580319],
              [-77.26443, 38.582845],
              [-77.247003, 38.590618],
              [-77.246441, 38.599532],
              [-77.245104, 38.620717],
              [-77.248904, 38.628617],
              [-77.246704, 38.635217],
              [-77.240604, 38.638917],
              [-77.22235, 38.638091],
              [-77.216303, 38.637817],
              [-77.205103, 38.623917],
              [-77.204302, 38.617817],
              [-77.202002, 38.617217],
              [-77.174902, 38.624217],
              [-77.157501, 38.636417],
              [-77.1302, 38.635017],
              [-77.135901, 38.649817],
              [-77.132501, 38.673816],
              [-77.121101, 38.686616],
              [-77.1059, 38.696815],
              [-77.086113, 38.705792],
              [-77.074599, 38.711015],
              [-77.05991, 38.734419],
              [-77.041398, 38.763914],
              [-77.039239, 38.7852],
              [-77.038598, 38.791513],
              [-77.032986, 38.8395],
              [-77.031698, 38.850512],
              [-77.040599, 38.871212],
              [-77.068199, 38.899811],
              [-77.0902, 38.904211],
              [-77.1012, 38.911111],
              [-77.119863, 38.934265],
              [-77.1199, 38.934311],
              [-77.137701, 38.95531],
              [-77.148179, 38.965002],
              [-77.166901, 38.96811],
              [-77.197502, 38.96681],
              [-77.221502, 38.97131],
              [-77.235403, 38.97661],
              [-77.249803, 38.985909],
              [-77.255703, 39.002409],
              [-77.251803, 39.011409],
              [-77.261403, 39.031009],
              [-77.291605, 39.045408],
              [-77.328002, 39.058554],
              [-77.340287, 39.062991],
              [-77.375079, 39.061297],
              [-77.42318, 39.066878],
              [-77.458202, 39.073723],
              [-77.519929, 39.120925],
              [-77.524559, 39.127821],
              [-77.527282, 39.146236],
              [-77.516426, 39.170891],
              [-77.510631, 39.178484],
              [-77.505162, 39.18205],
              [-77.485971, 39.185665],
              [-77.478596, 39.189168],
              [-77.458884, 39.219826],
              [-77.458779, 39.22028],
              [-77.45768, 39.22502],
              [-77.46021, 39.228359],
              [-77.484605, 39.245941],
              [-77.511222, 39.2535],
              [-77.534461, 39.262361],
              [-77.543228, 39.266937],
              [-77.545846, 39.271535],
              [-77.560854, 39.286152],
              [-77.592739, 39.30129],
              [-77.667749, 39.318129],
              [-77.677505, 39.318699],
              [-77.719029, 39.321125],
              [-77.727379, 39.321666],
              [-77.755789, 39.333899],
              [-77.760586, 39.338864],
              [-77.760435, 39.344171],
              [-77.739204, 39.38573],
              [-77.765442, 39.428574],
              [-77.807821, 39.490241],
              [-77.825411, 39.494036],
              [-77.845105, 39.498285],
              [-77.865423, 39.516472],
              [-77.888945, 39.55595],
              [-77.886135, 39.560432],
              [-77.884536, 39.568174],
              [-77.902649, 39.587796],
              [-77.946442, 39.58491],
              [-78.009985, 39.602893],
              [-78.023427, 39.61986],
              [-78.035992, 39.63572],
              [-78.074595, 39.666686],
              [-78.107834, 39.682137],
              [-78.143478, 39.690412],
              [-78.176625, 39.695967],
              [-78.182759, 39.69511],
              [-78.191107, 39.690262],
              [-78.224337, 39.66327],
              [-78.271122, 39.619642],
              [-78.283039, 39.62047],
              [-78.313033, 39.631001],
              [-78.334044, 39.63577],
              [-78.355218, 39.640576],
              [-78.43025, 39.62329],
              [-78.457187, 39.587379],
              [-78.458456, 39.581158],
              [-78.454376, 39.574319],
              [-78.450207, 39.570889],
              [-78.432033, 39.561053],
              [-78.436939, 39.538959],
              [-78.468639, 39.516789],
              [-78.565929, 39.519444],
              [-78.655984, 39.534695],
              [-78.657324, 39.535087],
              [-78.676219, 39.540622],
              [-78.689455, 39.54577],
              [-78.760196, 39.582154],
              [-78.76749, 39.587487],
              [-78.772048, 39.593833],
              [-78.769029, 39.599871],
              [-78.760497, 39.609984],
              [-78.787461, 39.627492],
              [-78.824788, 39.590233],
              [-78.874744, 39.522611],
              [-78.968996, 39.441543],
              [-79.025681, 39.465539],
              [-79.04244, 39.479339],
              [-79.067072, 39.474658],
              [-79.08445, 39.471356],
              [-79.201676, 39.379726],
              [-79.213192, 39.367897],
              [-79.25688, 39.356077],
              [-79.280039, 39.340076],
              [-79.378687, 39.27192],
              [-79.402911, 39.250106],
              [-79.486873, 39.205961],
              [-79.485874, 39.264905],
              [-79.486179, 39.26497],
              [-79.486737, 39.278149],
              [-79.487651, 39.279933],
              [-79.482648, 39.521364],
              [-79.482354, 39.524682],
              [-79.478866, 39.531689],
              [-79.476662, 39.721078],
              [-79.608223, 39.721154],
              [-79.610623, 39.721245],
              [-79.763774, 39.720776],
              [-79.852904, 39.720713],
              [-79.853131, 39.720713],
              [-79.916266, 39.720792],
              [-80.308651, 39.721283],
              [-80.309457, 39.721264],
              [-80.421388, 39.721189],
              [-80.519342, 39.721403],
              [-80.519248, 39.936967],
              [-80.519115, 39.939188],
              [-80.519175, 39.956648],
              [-80.519203, 39.959394],
              [-80.519217, 39.962199],
              [-80.519218, 39.962424],
              [-80.519207, 39.963381],
              [-80.51912, 40.01641],
              [-80.519008, 40.077001],
              [-80.51896, 40.078089],
              [-80.519104, 40.159672],
              [-80.519056, 40.172744],
              [-80.519056, 40.172771],
              [-80.517991, 40.398868],
              [-80.517998, 40.399644],
              [-80.518692, 40.477365],
              [-80.519054, 40.517922],
              [-80.519057, 40.517922],
              [-80.519055, 40.590173],
              [-80.519086, 40.590161],
              [-80.519086, 40.616385],
              [-80.519039, 40.616391],
              [-80.518991, 40.638801],
              [-80.56072, 40.62368],
              [-80.589041, 40.620128],
              [-80.594065, 40.623664],
              [-80.601494, 40.625387],
              [-80.627171, 40.619936],
              [-80.634355, 40.616095],
              [-80.665892, 40.587728],
              [-80.667957, 40.582496],
              [-80.666917, 40.573664],
              [-80.610259, 40.490962],
              [-80.599194, 40.482566],
              [-80.612295, 40.434867],
              [-80.617346, 40.396004],
              [-80.619196, 40.381768],
              [-80.609313, 40.360468],
              [-80.599895, 40.317669],
              [-80.602895, 40.307069],
              [-80.616696, 40.28027],
              [-80.637198, 40.25507],
              [-80.644598, 40.25127],
              [-80.652098, 40.24497],
              [-80.685391, 40.187642],
              [-80.703052, 40.157231],
              [-80.705482, 40.153047],
              [-80.726504, 40.089072],
              [-80.733104, 40.058772],
              [-80.730904, 40.049172],
              [-80.731504, 40.037472],
              [-80.732051, 40.03324],
              [-80.740126, 39.970793],
              [-80.743166, 39.969113],
              [-80.759455, 39.958233],
              [-80.806018, 39.91713],
              [-80.808722, 39.91257],
              [-80.809619, 39.905626],
              [-80.806179, 39.897306],
              [-80.812342, 39.848845],
              [-80.828618, 39.720848],
              [-80.829764, 39.711839],
              [-80.831871, 39.705655],
              [-80.88036, 39.620706],
              [-80.892208, 39.616756],
              [-80.943782, 39.606926],
              [-81.020055, 39.55541],
              [-81.038691, 39.540464],
              [-81.063587, 39.520497],
              [-81.127696, 39.464879],
              [-81.215617, 39.388602],
              [-81.223581, 39.386062],
              [-81.249088, 39.389992],
              [-81.270716, 39.385914],
              [-81.295373, 39.37529],
              [-81.347567, 39.34577],
              [-81.356911, 39.343178],
              [-81.371271, 39.342062],
              [-81.375961, 39.341697],
              [-81.384556, 39.343449],
              [-81.393794, 39.351706],
              [-81.406689, 39.38809],
              [-81.412706, 39.394618],
              [-81.435642, 39.408474],
              [-81.446543, 39.410374],
              [-81.456143, 39.409274],
              [-81.467744, 39.403774],
              [-81.542346, 39.352874],
              [-81.605816, 39.275851],
              [-81.695724, 39.242859],
              [-81.721551, 39.212448],
              [-81.740061, 39.190652],
              [-81.749853, 39.186489],
              [-81.749689, 39.180742],
              [-81.747253, 39.095379],
              [-81.747253, 39.095378],
              [-81.812355, 39.082078],
              [-81.814155, 39.073478],
              [-81.811655, 39.059578],
              [-81.803355, 39.047678],
              [-81.793304, 39.040353],
              [-81.772854, 39.026179],
              [-81.764253, 39.015279],
              [-81.756131, 38.933545],
              [-81.759995, 38.925828],
              [-81.874857, 38.881174],
              [-81.908645, 38.87846],
              [-81.926967, 38.891602],
              [-81.928352, 38.895371],
              [-81.926671, 38.901311],
              [-81.90091, 38.924338],
              [-81.89847, 38.929603],
              [-81.900595, 38.937671],
              [-81.919783, 38.968494],
              [-81.935619, 38.9895],
              [-82.002261, 39.027878],
              [-82.017562, 39.030078],
              [-82.035963, 39.025478],
              [-82.041563, 39.017878],
              [-82.045663, 39.003778],
              [-82.051563, 38.994378],
              [-82.093165, 38.97098],
              [-82.098762, 38.958288],
              [-82.139279, 38.866407],
              [-82.184428, 38.816529],
              [-82.191172, 38.815137],
              [-82.215759, 38.797462],
              [-82.221566, 38.787187],
              [-82.220449, 38.773739],
              [-82.198882, 38.757725],
              [-82.188268, 38.734082],
              [-82.182467, 38.708782],
              [-82.172066, 38.625984],
              [-82.172066, 38.619284],
              [-82.175167, 38.608484],
              [-82.177267, 38.603784],
              [-82.181967, 38.599384],
              [-82.193824, 38.593096],
              [-82.218967, 38.591683],
              [-82.245969, 38.598483],
              [-82.26207, 38.598183],
              [-82.27427, 38.593683],
              [-82.287102, 38.582588],
              [-82.291271, 38.578983],
              [-82.293871, 38.572683],
              [-82.293271, 38.560283],
              [-82.295571, 38.539783],
              [-82.313935, 38.468084],
              [-82.320223, 38.454516],
              [-82.323999, 38.449268],
              [-82.330335, 38.4445],
              [-82.34064, 38.440948],
              [-82.50667, 38.410092],
              [-82.520178, 38.407582],
              [-82.560664, 38.404338],
              [-82.593673, 38.421809],
              [-82.665485, 38.505734],
              [-82.665548, 38.505808],
              [-82.690509, 38.536576],
              [-82.696621, 38.542112],
              [-82.724846, 38.5576],
              [-82.730958, 38.559264],
              [-82.789776, 38.559951],
              [-82.800112, 38.563183],
              [-82.816012, 38.570733],
              [-82.820161, 38.572703],
              [-82.839538, 38.586159],
              [-82.847186, 38.595166],
              [-82.853554, 38.610926],
              [-82.869592, 38.678177],
              [-82.873492, 38.710077],
              [-82.870392, 38.722077],
              [-82.869992, 38.730477],
              [-82.871292, 38.739376],
              [-82.874466, 38.745346],
              [-82.875492, 38.747276],
              [-82.879492, 38.751476],
              [-82.889193, 38.756076],
              [-82.894193, 38.756576],
              [-82.923694, 38.750076],
              [-82.943147, 38.74328],
              [-82.968695, 38.728776],
              [-82.979395, 38.725976],
              [-83.011816, 38.730057],
              [-83.030702, 38.72572],
              [-83.030889, 38.72556],
              [-83.127652, 38.642451],
              [-83.135046, 38.631719],
              [-83.142836, 38.625076],
              [-83.156926, 38.620547],
              [-83.265769, 38.605278],
              [-83.2821, 38.602987],
              [-83.320531, 38.622713],
              [-83.324157, 38.633326],
              [-83.333347, 38.641562],
              [-83.369077, 38.659334],
              [-83.512571, 38.701716],
              [-83.520953, 38.703045],
              [-83.533339, 38.702105],
              [-83.574754, 38.692671],
              [-83.615736, 38.684145],
              [-83.626922, 38.679387],
              [-83.636208, 38.670584],
              [-83.642994, 38.643273],
              [-83.646701, 38.637489],
              [-83.649737, 38.632753],
              [-83.655425, 38.629735],
              [-83.663911, 38.62793],
              [-83.679484, 38.630036],
              [-83.706043, 38.637101],
              [-83.762445, 38.652103],
              [-83.769347, 38.65522],
              [-83.773682, 38.661309],
              [-83.777823, 38.674453],
              [-83.85333, 38.752572],
              [-83.859028, 38.756793],
              [-83.870443, 38.761608],
              [-83.903918, 38.76815],
              [-83.903971, 38.76816],
              [-83.943978, 38.783616],
              [-83.962123, 38.787384],
              [-83.978814, 38.787104],
              [-84.044486, 38.770572],
              [-84.052707, 38.770542],
              [-84.071491, 38.770475],
              [-84.205592, 38.802588],
              [-84.212904, 38.805707],
              [-84.2253, 38.817665],
              [-84.229954, 38.82765],
              [-84.231306, 38.830552],
              [-84.233727, 38.853576],
              [-84.232478, 38.874638],
              [-84.232132, 38.880483],
              [-84.234453, 38.893226],
              [-84.304698, 39.006455],
              [-84.31368, 39.016981],
              [-84.319936, 39.022081],
              [-84.326539, 39.027463],
              [-84.432841, 39.094261],
              [-84.493743, 39.10246],
              [-84.502062, 39.096641],
              [-84.506082, 39.095081],
              [-84.509743, 39.09366],
              [-84.510057, 39.093593],
              [-84.603444, 39.073699],
              [-84.620112, 39.073457],
              [-84.623732, 39.074427],
              [-84.632446, 39.07676],
              [-84.684847, 39.100459],
              [-84.689747, 39.104159],
              [-84.718548, 39.137059],
              [-84.732048, 39.144458],
              [-84.744149, 39.147458],
              [-84.754449, 39.146658],
              [-84.766749, 39.138558],
              [-84.78768, 39.115297],
              [-84.820157, 39.10548],
              [-84.831197, 39.10192],
              [-84.888873, 39.066376],
              [-84.897364, 39.057378],
              [-84.897171, 39.052407],
              [-84.889065, 39.04082],
              [-84.878614, 39.030296],
              [-84.849445, 39.000923],
              [-84.813182, 38.930583],
              [-84.789521, 38.884687],
              [-84.785111, 38.879988],
              [-84.785799, 38.869496],
              [-84.791078, 38.855859],
              [-84.81335, 38.79833],
              [-84.844412, 38.787078],
              [-84.944296, 38.775184],
              [-84.973432, 38.778847],
              [-84.984627, 38.779072],
              [-84.995939, 38.776756],
              [-85.024205, 38.763311],
              [-85.100963, 38.7268],
              [-85.106902, 38.720789],
              [-85.13868, 38.699168],
              [-85.156158, 38.692251],
              [-85.172528, 38.688082],
              [-85.189362, 38.687579],
              [-85.201498, 38.691575],
              [-85.213257, 38.695446],
              [-85.226062, 38.705456],
              [-85.246505, 38.731821],
              [-85.258846, 38.737754],
              [-85.275454, 38.741172],
              [-85.289226, 38.74241],
              [-85.333285, 38.74048],
              [-85.410925, 38.73708],
              [-85.422021, 38.734834],
              [-85.434065, 38.729455],
              [-85.452114, 38.709348],
              [-85.456978, 38.689135],
              [-85.439351, 38.610388],
              [-85.427467, 38.586735],
              [-85.415821, 38.563558],
              [-85.4156, 38.546341],
              [-85.417322, 38.540763],
              [-85.423077, 38.531581],
              [-85.432928, 38.524072],
              [-85.433136, 38.523914],
              [-85.462518, 38.512602],
              [-85.607629, 38.439295],
              [-85.620521, 38.423105],
              [-85.632937, 38.395666],
              [-85.638041, 38.380338],
              [-85.638044, 38.38027],
              [-85.638777, 38.361443],
              [-85.653641, 38.327108],
              [-85.675017, 38.301317],
              [-85.683561, 38.295469],
              [-85.744862, 38.26717],
              [-85.750962, 38.26787],
              [-85.761062, 38.27257],
              [-85.766563, 38.27767],
              [-85.765963, 38.280469],
              [-85.773363, 38.286169],
              [-85.780963, 38.288469],
              [-85.791563, 38.288569],
              [-85.791575, 38.288566],
              [-85.816164, 38.282969],
              [-85.823764, 38.280569],
              [-85.829364, 38.276769],
              [-85.897664, 38.184269],
              [-85.89955, 38.180343],
              [-85.908764, 38.161169],
              [-85.909464, 38.14007],
              [-85.905164, 38.11107],
              [-85.904564, 38.10027],
              [-85.906163, 38.08617],
              [-85.911607, 38.06689],
              [-85.922395, 38.028679],
              [-85.930235, 38.018311],
              [-85.941403, 38.009831],
              [-85.947952, 38.007083],
              [-85.951467, 38.005608],
              [-85.998609, 37.997775],
              [-86.029509, 37.99264],
              [-86.172186, 38.00992],
              [-86.178983, 38.011308],
              [-86.220371, 38.027922],
              [-86.266891, 38.057125],
              [-86.273584, 38.067443],
              [-86.27872, 38.089303],
              [-86.278034, 38.102426],
              [-86.271223, 38.130112],
              [-86.283964, 38.143185],
              [-86.309727, 38.144393],
              [-86.314292, 38.14261],
              [-86.323453, 38.139032],
              [-86.326788, 38.134604],
              [-86.332567, 38.130131],
              [-86.398661, 38.106238],
              [-86.426508, 38.081784],
              [-86.430091, 38.078638],
              [-86.432789, 38.067171],
              [-86.438236, 38.060426],
              [-86.452192, 38.05049],
              [-86.466876, 38.046597],
              [-86.490853, 38.045796],
              [-86.490858, 38.045796],
              [-86.51176, 38.044448],
              [-86.517289, 38.042634],
              [-86.521825, 38.038327],
              [-86.524969, 38.027879],
              [-86.525174, 37.968228],
              [-86.604624, 37.858272],
              [-86.634271, 37.843845],
              [-86.648028, 37.841425],
              [-86.655285, 37.842506],
              [-86.655296, 37.842508],
              [-86.660293, 37.865057],
              [-86.709164, 37.89764],
              [-86.718462, 37.893123],
              [-86.72351, 37.892831],
              [-86.73146, 37.89434],
              [-86.740877, 37.902568],
              [-86.75099, 37.912893],
              [-86.770179, 37.940264],
              [-86.787695, 37.971449],
              [-86.794985, 37.988982],
              [-86.814776, 37.998638],
              [-86.815267, 37.998877],
              [-86.823491, 37.998939],
              [-86.85595, 37.987292],
              [-86.884961, 37.964373],
              [-86.902413, 37.946161],
              [-86.919329, 37.936664],
              [-86.97883, 37.930214],
              [-86.978957, 37.9302],
              [-87.010315, 37.919668],
              [-87.033444, 37.906593],
              [-87.042249, 37.898291],
              [-87.046237, 37.889866],
              [-87.043407, 37.87994],
              [-87.043854, 37.870796],
              [-87.057836, 37.827457],
              [-87.067836, 37.806065],
              [-87.077404, 37.796209],
              [-87.090636, 37.787808],
              [-87.111133, 37.782512],
              [-87.119229, 37.782848],
              [-87.128749, 37.785728],
              [-87.132621, 37.791008],
              [-87.20224, 37.843791],
              [-87.26293, 37.872846],
              [-87.269561, 37.877155],
              [-87.302324, 37.898445],
              [-87.380247, 37.935596],
              [-87.402632, 37.942267],
              [-87.418585, 37.944763],
              [-87.436859, 37.944192],
              [-87.450458, 37.941451],
              [-87.451185, 37.941034],
              [-87.511499, 37.906426],
              [-87.550333, 37.92489],
              [-87.559342, 37.931146],
              [-87.57203, 37.947466],
              [-87.574287, 37.954842],
              [-87.573415, 37.962642],
              [-87.574715, 37.967742],
              [-87.581115, 37.973442],
              [-87.585916, 37.975442],
              [-87.592916, 37.975842],
              [-87.601416, 37.972542],
              [-87.62896, 37.926714],
              [-87.626256, 37.916138],
              [-87.620272, 37.906922],
              [-87.597118, 37.892394],
              [-87.591582, 37.887194],
              [-87.588426, 37.868791],
              [-87.588729, 37.860984],
              [-87.591504, 37.856642],
              [-87.606599, 37.838669],
              [-87.615399, 37.831974],
              [-87.645858, 37.825899],
              [-87.670889, 37.828429],
              [-87.679188, 37.836321],
              [-87.6819, 37.84641],
              [-87.681633, 37.855917],
              [-87.662865, 37.885578],
              [-87.666481, 37.895786],
              [-87.67573, 37.90193],
              [-87.684018, 37.903498],
              [-87.700421, 37.900858],
              [-87.76226, 37.890906],
              [-87.783643, 37.877759],
              [-87.7909, 37.875714],
              [-87.830578, 37.876516],
              [-87.841193, 37.882325],
              [-87.857243, 37.900649],
              [-87.865558, 37.915056],
              [-87.87254, 37.920999],
              [-87.883321, 37.926238],
              [-87.898062, 37.927514],
              [-87.904789, 37.924892],
              [-87.927424, 37.902038],
              [-87.936784, 37.892587],
              [-87.940069, 37.88767],
              [-87.940839, 37.883338],
              [-87.940005, 37.875044],
              [-87.936228, 37.867937],
              [-87.927303, 37.858709],
              [-87.914892, 37.849618],
              [-87.910276, 37.843416],
              [-87.907773, 37.837611],
              [-87.903804, 37.817762],
              [-87.90681, 37.807624],
              [-87.943756, 37.776843],
              [-87.970869, 37.783456],
              [-87.976389, 37.788004],
              [-88.004706, 37.800145],
              [-88.017314, 37.801911],
              [-88.02803, 37.799224],
              [-88.039, 37.775454],
              [-88.045008, 37.762436],
              [-88.050969, 37.752599],
              [-88.059588, 37.742608],
              [-88.072538, 37.733286],
              [-88.122412, 37.709685],
              [-88.151646, 37.675098],
              [-88.158207, 37.664542],
              [-88.160187, 37.657592],
              [-88.156827, 37.632801],
              [-88.139973, 37.586451],
              [-88.133416, 37.574277],
              [-88.133393, 37.574235],
              [-88.133306, 37.574191],
              [-88.133235, 37.574154],
              [-88.121517, 37.568166],
              [-88.072242, 37.528826],
              [-88.063311, 37.515755],
              [-88.061311, 37.505332],
              [-88.061292, 37.505232],
              [-88.062562, 37.489385],
              [-88.083395, 37.473683],
              [-88.255193, 37.456748],
              [-88.281667, 37.452596],
              [-88.312585, 37.440591],
              [-88.330622, 37.429316],
              [-88.358436, 37.40486],
              [-88.408808, 37.425216],
              [-88.414895, 37.423461],
              [-88.439333, 37.416416],
              [-88.456, 37.408482],
              [-88.470224, 37.396255],
              [-88.476592, 37.386875],
              [-88.514661, 37.290948],
              [-88.515939, 37.284043],
              [-88.509328, 37.26213],
              [-88.471753, 37.220155],
              [-88.458763, 37.213536],
              [-88.447764, 37.203527],
              [-88.424403, 37.152428],
              [-88.444605, 37.098601],
              [-88.458948, 37.073796],
              [-88.482856, 37.067114],
              [-88.490297, 37.066669],
              [-88.514356, 37.065231],
              [-88.531576, 37.067192],
              [-88.545403, 37.070003],
              [-88.560032, 37.07601],
              [-88.564152, 37.07844],
              [-88.576718, 37.085852],
              [-88.589207, 37.099655],
              [-88.625889, 37.119458],
              [-88.809206, 37.189235],
              [-88.916934, 37.224291],
              [-88.928021, 37.226281],
              [-88.942111, 37.228811],
              [-88.933385, 37.225005],
              [-88.933399, 37.225007],
              [-88.966831, 37.229891],
              [-88.98326, 37.228685],
              [-89.000968, 37.224401],
              [-89.041263, 37.202881],
              [-89.086526, 37.165602],
              [-89.168087, 37.074218],
              [-89.171881, 37.068184],
              [-89.175725, 37.062069],
              [-89.181369, 37.046305],
              [-89.182509, 37.037275],
              [-89.178975, 37.020928],
              [-89.173595, 37.011409],
              [-89.166447, 37.003337],
              [-89.132685, 36.9822],
              [-89.100794, 36.944006],
              [-89.100766, 36.943973],
              [-89.147674, 36.847148],
              [-89.177177, 36.835779],
              [-89.178574, 36.816554],
              [-89.179229, 36.812915],
              [-89.12353, 36.785309],
              [-89.123548, 36.78522],
              [-89.130399, 36.751702],
              [-89.142313, 36.755369],
              [-89.169106, 36.759473],
              [-89.184523, 36.753638],
              [-89.197808, 36.739412],
              [-89.201047, 36.725772],
              [-89.19948, 36.716045],
              [-89.171882, 36.672526],
              [-89.174733, 36.650476],
              [-89.174741, 36.650416],
              [-89.187749, 36.641115],
              [-89.197654, 36.628936],
              [-89.200902, 36.618177],
              [-89.202607, 36.601576],
              [-89.213563, 36.580119],
              [-89.227319, 36.569375],
              [-89.236542, 36.566824],
              [-89.259994, 36.565149],
              [-89.27171, 36.571387],
              [-89.294637, 36.593729],
              [-89.313405, 36.62012],
              [-89.326731, 36.632186],
              [-89.327578, 36.632127],
              [-89.343753, 36.630991],
              [-89.365548, 36.625059],
              [-89.376367, 36.613868],
              [-89.38814, 36.573416],
              [-89.400581, 36.538337],
              [-89.417293, 36.499033],
              [-89.429311, 36.481875],
              [-89.448468, 36.46442],
              [-89.460436, 36.45814],
              [-89.471718, 36.457001],
              [-89.486215, 36.46162],
              [-89.493198, 36.470124],
              [-89.493495, 36.4787],
              [-89.485106, 36.497692],
              [-89.47246, 36.513741],
              [-89.465888, 36.529946],
              [-89.465445, 36.536163],
              [-89.467761, 36.546847],
              [-89.473341, 36.559918],
              [-89.479093, 36.568206],
              [-89.484836, 36.571821],
              [-89.500076, 36.576305],
              [-89.527583, 36.581147],
              [-89.546113, 36.579989],
              [-89.55264, 36.577178],
              [-89.566817, 36.564216],
              [-89.571509, 36.552569],
              [-89.570071, 36.544387],
              [-89.560344, 36.525436],
              [-89.5391, 36.498201],
              [-89.522674, 36.481305],
              [-89.519501, 36.475419],
              [-89.509558, 36.375065],
              [-89.513178, 36.359897],
              [-89.519, 36.3486],
              [-89.531822, 36.339246],
              [-89.545006, 36.336809],
              [-89.560439, 36.337746],
              [-89.581636, 36.342357],
              [-89.605668, 36.342234],
              [-89.610689, 36.340442],
              [-89.615841, 36.336085],
              [-89.6198, 36.329546],
              [-89.620255, 36.323006],
              [-89.611819, 36.309088],
              [-89.578492, 36.288317],
              [-89.554289, 36.277751],
              [-89.544797, 36.280458],
              [-89.539487, 36.277368],
              [-89.535529, 36.270541],
              [-89.534745, 36.252576],
              [-89.541621, 36.247891],
              [-89.589561, 36.239116],
              [-89.602374, 36.238106],
              [-89.678046, 36.248284],
              [-89.691308, 36.252079],
              [-89.699817, 36.248384],
              [-89.629452, 36.185382],
              [-89.618228, 36.179966],
              [-89.607004, 36.171179],
              [-89.594397, 36.155457],
              [-89.591605, 36.144096],
              [-89.594, 36.12719],
              [-89.601936, 36.11947],
              [-89.624235, 36.108626],
              [-89.684439, 36.051719],
              [-89.687254, 36.034048],
              [-89.690306, 36.024835],
              [-89.706932, 36.000981],
              [-89.733095, 36.000608],
              [-89.737564, 36.000522],
              [-89.737648, 36.000567],
              [-89.769973, 36.000536],
              [-89.770255, 36.000524],
              [-89.86901, 35.99964],
              [-89.87459, 35.999575],
              [-89.875085, 35.999578],
              [-89.875586, 35.999562],
              [-89.896508, 35.999432],
              [-89.901183, 35.999365],
              [-89.959375, 35.99902],
              [-89.959377, 35.99902],
              [-89.959893, 35.99902],
              [-89.961075, 35.999135],
              [-89.965327, 35.998813],
              [-89.972563, 35.998994],
              [-90.12635, 35.997596],
              [-90.127331, 35.997635],
              [-90.158812, 35.997375],
              [-90.2888, 35.996419],
              [-90.288947, 35.996418],
              [-90.292376, 35.996397],
              [-90.339434, 35.996033],
              [-90.342616, 35.995895],
              [-90.368718, 35.995812],
              [-90.36443, 36.013625],
              [-90.319168, 36.089976],
              [-90.220425, 36.184764],
              [-90.198735, 36.201382],
              [-90.114922, 36.265595],
              [-90.083731, 36.272332],
              [-90.076301, 36.280708],
              [-90.06398, 36.303038],
              [-90.064514, 36.382085],
              [-90.072897, 36.393007],
              [-90.133993, 36.437906],
              [-90.156369, 36.487748],
              [-90.154409, 36.496832],
              [-90.152481, 36.497952],
              [-90.193943, 36.497823],
              [-90.217323, 36.497797],
              [-90.220702, 36.497858],
              [-90.220732, 36.497858],
              [-90.228943, 36.497771],
              [-90.339892, 36.498213],
              [-90.494575, 36.498368],
              [-90.495027, 36.498371],
              [-90.50016, 36.498399],
              [-90.576112, 36.498446],
              [-90.57618, 36.498446],
              [-90.585342, 36.498497],
              [-90.5943, 36.498459],
              [-90.60545, 36.498459],
              [-90.612554, 36.498559],
              [-90.648494, 36.498447],
              [-90.653246, 36.498488],
              [-90.693005, 36.49851],
              [-90.711226, 36.498318],
              [-90.765672, 36.498494],
              [-90.782454, 36.498523],
              [-90.784398, 36.498524],
              [-90.850434, 36.498548],
              [-90.873775, 36.498074],
              [-90.876567, 36.498313],
              [-90.876867, 36.498423],
              [-90.87922, 36.498378],
              [-90.960648, 36.498426],
              [-90.963063, 36.498418],
              [-91.008558, 36.49827],
              [-91.017974, 36.498062],
              [-91.09588, 36.49787],
              [-91.096277, 36.497893],
              [-91.126529, 36.497712],
              [-91.21736, 36.497511],
              [-91.218645, 36.497564],
              [-91.227398, 36.497617],
              [-91.404915, 36.49712],
              [-91.405141, 36.497165],
              [-91.407137, 36.497112],
              [-91.407261, 36.497123],
              [-91.433298, 36.497262],
              [-91.436502, 36.497377],
              [-91.446284, 36.497469],
              [-91.450005, 36.497538],
              [-91.529774, 36.499022],
              [-91.53687, 36.499156],
              [-91.539359, 36.499116],
              [-91.549163, 36.499161],
              [-91.596213, 36.499162],
              [-91.601317, 36.499343],
              [-91.631439, 36.499198],
              [-91.64259, 36.499335],
              [-91.672343, 36.499463],
              [-91.686026, 36.499374],
              [-91.687615, 36.499397],
              [-91.726663, 36.499209],
              [-91.766111, 36.499114],
              [-91.784713, 36.499074],
              [-91.7995, 36.498952],
              [-91.80204, 36.498963],
              [-91.805981, 36.498987],
              [-91.864385, 36.498789],
              [-91.865995, 36.498783],
              [-91.985802, 36.498431],
              [-91.988751, 36.498498],
              [-92.019375, 36.498524],
              [-92.028847, 36.498642],
              [-92.055789, 36.49867],
              [-92.057178, 36.49867],
              [-92.074934, 36.498761],
              [-92.098356, 36.498803],
              [-92.120306, 36.498864],
              [-92.120415, 36.498863],
              [-92.137741, 36.498706],
              [-92.150295, 36.498634],
              [-92.199396, 36.498351],
              [-92.211449, 36.498395],
              [-92.214143, 36.498372],
              [-92.216412, 36.498417],
              [-92.309424, 36.497894],
              [-92.318415, 36.497711],
              [-92.529145, 36.497739],
              [-92.772333, 36.497772],
              [-92.772341, 36.497772],
              [-92.838621, 36.498079],
              [-92.838876, 36.498033],
              [-92.854049, 36.497983],
              [-92.894001, 36.49785],
              [-92.894336, 36.497867],
              [-93.013742, 36.49813],
              [-93.068455, 36.49825],
              [-93.069512, 36.498242],
              [-93.087635, 36.498239],
              [-93.088988, 36.498184],
              [-93.296117, 36.498389],
              [-93.315324, 36.498408],
              [-93.315337, 36.498408],
              [-93.394718, 36.498519],
              [-93.396079, 36.498669],
              [-93.426989, 36.498585],
              [-93.507408, 36.498911],
              [-93.514512, 36.498881],
              [-93.584281, 36.498896],
              [-93.584282, 36.498896],
              [-93.700171, 36.499135],
              [-93.709956, 36.499179],
              [-93.718893, 36.499178],
              [-93.727552, 36.499055],
              [-93.728022, 36.499037],
              [-93.866758, 36.498789],
              [-93.906128, 36.498718],
              [-93.92184, 36.498718],
              [-93.95919, 36.498717],
              [-93.96392, 36.498717],
              [-94.077089, 36.49873],
              [-94.098588, 36.498676],
              [-94.100252, 36.49867],
              [-94.110673, 36.498587],
              [-94.111473, 36.498597],
              [-94.519478, 36.499214],
              [-94.55929, 36.499496],
              [-94.617919, 36.499414],
              [-94.615311, 36.484992],
              [-94.61383, 36.476248],
              [-94.611609, 36.461528],
              [-94.605408, 36.421949],
              [-94.602623, 36.405283],
              [-94.601984, 36.40212],
              [-94.599723, 36.387587],
              [-94.593397, 36.345742],
              [-94.5862, 36.299969],
              [-94.577883, 36.25008],
              [-94.577899, 36.249548],
              [-94.576003, 36.24007],
              [-94.575071, 36.233682],
              [-94.57488, 36.232741],
              [-94.574395, 36.229996],
              [-94.571806, 36.213748],
              [-94.571253, 36.210901],
              [-94.566588, 36.183774],
              [-94.565655, 36.178439],
              [-94.562828, 36.161895],
              [-94.562803, 36.161749],
              [-94.561165, 36.15211],
              [-94.552184, 36.102235],
              [-94.547871, 36.078281],
              [-94.547715, 36.077271],
              [-94.535724, 36.007807],
              [-94.534852, 36.002678],
              [-94.533646, 35.996804],
              [-94.532071, 35.987852],
              [-94.528305, 35.966054],
              [-94.528162, 35.965665],
              [-94.52464, 35.945727],
              [-94.524344, 35.94405],
              [-94.52291, 35.936127],
              [-94.522634, 35.934892],
              [-94.522658, 35.934799],
              [-94.522658, 35.93425],
              [-94.507631, 35.845901],
              [-94.505642, 35.833628],
              [-94.504438, 35.826369],
              [-94.503011, 35.81721],
              [-94.501162, 35.80643],
              [-94.500764, 35.80382],
              [-94.500526, 35.802642],
              [-94.499647, 35.79691],
              [-94.499045, 35.79346],
              [-94.494549, 35.768303],
              [-94.493362, 35.761892],
              [-94.492932, 35.759166],
              [-94.48821, 35.72924],
              [-94.487585, 35.726147],
              [-94.472647, 35.638556],
              [-94.465272, 35.594037],
              [-94.464457, 35.588909],
              [-94.464097, 35.587265],
              [-94.463318, 35.58266],
              [-94.431789, 35.397659],
              [-94.431215, 35.39429],
              [-94.433915, 35.387391],
              [-94.433742, 35.386467],
              [-94.432685, 35.380806],
              [-94.431815, 35.362891],
              [-94.434115, 35.306493],
              [-94.43517, 35.291494],
              [-94.43528, 35.287485],
              [-94.435316, 35.275893],
              [-94.435706, 35.274267],
              [-94.435812, 35.2713],
              [-94.437578, 35.242202],
              [-94.437774, 35.239271],
              [-94.438247, 35.210992],
              [-94.43847, 35.208587],
              [-94.439084, 35.197298],
              [-94.439056, 35.193588],
              [-94.439509, 35.171807],
              [-94.43955, 35.169037],
              [-94.440754, 35.128806],
              [-94.441232, 35.119724],
              [-94.447889, 34.933941],
              [-94.449253, 34.895869],
              [-94.449086, 34.894152],
              [-94.449058, 34.890556],
              [-94.44963, 34.875253],
              [-94.450065, 34.861335],
              [-94.45014, 34.858694],
              [-94.450233, 34.855413],
              [-94.454576, 34.728962],
              [-94.45753, 34.642961],
              [-94.4575, 34.634945],
              [-94.460052, 34.547869],
              [-94.460058, 34.545264],
              [-94.461149, 34.507457],
              [-94.463671, 34.419585],
              [-94.463816, 34.414465],
              [-94.464176, 34.402713],
              [-94.465425, 34.359548],
              [-94.465847, 34.352073],
              [-94.470292, 34.189864],
              [-94.474896, 34.021877],
              [-94.474896, 34.021838],
              [-94.474895, 34.019655],
              [-94.476957, 33.957365],
              [-94.477038, 33.953838],
              [-94.477318, 33.940932],
              [-94.477387, 33.937759],
              [-94.478842, 33.881485],
              [-94.478994, 33.881197],
              [-94.479954, 33.85133],
              [-94.480574, 33.830166],
              [-94.481355, 33.802887],
              [-94.481361, 33.802649],
              [-94.481543, 33.795719],
              [-94.481842, 33.789008],
              [-94.482682, 33.756286],
              [-94.482777, 33.753638],
              [-94.482862, 33.75078],
              [-94.48287, 33.750564],
              [-94.483874, 33.716733],
              [-94.48384, 33.711332],
              [-94.484616, 33.691592],
              [-94.48452, 33.687909],
              [-94.485528, 33.663388],
              [-94.485577, 33.65331],
              [-94.485875, 33.637867],
              [-94.478366, 33.620847],
              [-94.470963, 33.60594],
              [-94.464336, 33.598819],
              [-94.409329, 33.568265],
              [-94.355945, 33.54318],
              [-94.257801, 33.582508],
              [-94.252656, 33.586144],
              [-94.181805, 33.593217],
              [-94.085243, 33.575546],
              [-94.066846, 33.568909],
              [-94.04345, 33.552253],
              [-94.043428, 33.551425],
              [-94.043375, 33.542315],
              [-94.043009, 33.493039],
              [-94.043279, 33.49103],
              [-94.043188, 33.470324],
              [-94.042988, 33.435824],
              [-94.042988, 33.431024],
              [-94.042887, 33.420225],
              [-94.043053, 33.377716],
              [-94.042869, 33.37117],
              [-94.043128, 33.358757],
              [-94.043067, 33.352097],
              [-94.043067, 33.347351],
              [-94.043067, 33.330498],
              [-94.04299, 33.271243],
              [-94.04299, 33.271227],
              [-94.04305, 33.260904],
              [-94.043004, 33.250128],
              [-94.04273, 33.241823],
              [-94.042876, 33.215219],
              [-94.042892, 33.202666],
              [-94.042875, 33.199785],
              [-94.043185, 33.143476],
              [-94.043077, 33.138162],
              [-94.043007, 33.13389],
              [-94.04287, 33.092727],
              [-94.043036, 33.079485],
              [-94.042964, 33.019219],
            ],
          ],
          [
            [
              [-88.865067, 29.752714],
              [-88.844078, 29.795713],
              [-88.83271, 29.824062],
              [-88.826538, 29.847092],
              [-88.818146, 29.889109],
              [-88.817017, 29.93425],
              [-88.824158, 29.970461],
              [-88.833725, 29.998821],
              [-88.841225, 30.012789],
              [-88.855583, 30.034414],
              [-88.870476, 30.049212],
              [-88.881454, 30.053202],
              [-88.86972, 30.043798],
              [-88.857368, 30.027826],
              [-88.848373, 30.01333],
              [-88.840866, 29.995613],
              [-88.83979, 29.983803],
              [-88.835495, 29.974138],
              [-88.835495, 29.967695],
              [-88.838715, 29.962326],
              [-88.837379, 29.944878],
              [-88.828247, 29.920717],
              [-88.8312, 29.878839],
              [-88.843277, 29.86381],
              [-88.83683, 29.858978],
              [-88.836296, 29.855221],
              [-88.84301, 29.82596],
              [-88.846497, 29.817101],
              [-88.861267, 29.805826],
              [-88.867973, 29.79133],
              [-88.867973, 29.772272],
              [-88.873611, 29.758043],
              [-88.89006, 29.729202],
              [-88.911751, 29.699348],
              [-88.920235, 29.694319],
              [-88.941605, 29.674833],
              [-88.94632, 29.662579],
              [-88.944435, 29.658806],
              [-88.940346, 29.657234],
              [-88.889755, 29.718204],
              [-88.865067, 29.752714],
            ],
          ],
          [
            [
              [-89.095623, 30.231767],
              [-89.156738, 30.230699],
              [-89.118222, 30.223343],
              [-89.091469, 30.202305],
              [-89.073538, 30.223318],
              [-89.065097, 30.239929],
              [-89.063989, 30.246299],
              [-89.067128, 30.250199],
              [-89.077259, 30.23168],
              [-89.095623, 30.231767],
            ],
          ],
          [
            [
              [-88.90037, 30.224576],
              [-88.87366, 30.241748],
              [-88.877824, 30.242442],
              [-88.889797, 30.239665],
              [-88.908885, 30.225437],
              [-88.920511, 30.220578],
              [-88.947872, 30.214179],
              [-88.976811, 30.210987],
              [-88.982219, 30.211627],
              [-88.984249, 30.21032],
              [-88.980239, 30.207962],
              [-88.974672, 30.207391],
              [-88.945498, 30.209646],
              [-88.909752, 30.220405],
              [-88.90037, 30.224576],
            ],
          ],
          [
            [
              [-88.506999, 30.214348],
              [-88.502752, 30.210506],
              [-88.493523, 30.205945],
              [-88.453654, 30.196584],
              [-88.428301, 30.198511],
              [-88.404581, 30.206162],
              [-88.401466, 30.210172],
              [-88.430332, 30.208548],
              [-88.442654, 30.202314],
              [-88.453444, 30.201236],
              [-88.465713, 30.20254],
              [-88.500011, 30.214044],
              [-88.506999, 30.214348],
            ],
          ],
          [
            [
              [-88.710719, 30.250799],
              [-88.718104, 30.252931],
              [-88.73255, 30.246322],
              [-88.771991, 30.245523],
              [-88.764022, 30.241488],
              [-88.752782, 30.238803],
              [-88.740647, 30.238665],
              [-88.71183, 30.242662],
              [-88.665857, 30.228847],
              [-88.633743, 30.226342],
              [-88.587424, 30.219154],
              [-88.569138, 30.221357],
              [-88.565576, 30.222847],
              [-88.562067, 30.227476],
              [-88.568056, 30.222732],
              [-88.573044, 30.22264],
              [-88.656804, 30.233956],
              [-88.710719, 30.250799],
            ],
          ],
          [
            [
              [-75.242266, 38.027209],
              [-75.242296, 38.027206],
              [-75.250358, 38.026489],
              [-75.256076, 38.02598],
              [-75.260635, 38.025574],
              [-75.262088, 38.025445],
              [-75.263779, 38.025295],
              [-75.377851, 38.015145],
              [-75.398839, 38.013277],
              [-75.42881, 38.010854],
              [-75.435956, 38.010282],
              [-75.624341, 37.994211],
              [-75.626129, 37.9925],
              [-75.630222, 37.988584],
              [-75.635502, 37.983531],
              [-75.639786, 37.979432],
              [-75.644545, 37.974877],
              [-75.644591, 37.974833],
              [-75.644665, 37.974763],
              [-75.645096, 37.97435],
              [-75.645251, 37.974202],
              [-75.646289, 37.973209],
              [-75.646507, 37.973],
              [-75.660956, 37.959174],
              [-75.669711, 37.950796],
              [-75.693942, 37.930362],
              [-75.704318, 37.92901],
              [-75.712065, 37.936082],
              [-75.757694, 37.903912],
              [-75.759835, 37.899333],
              [-75.758796, 37.897615],
              [-75.753048, 37.896605],
              [-75.726699, 37.897299],
              [-75.724505, 37.900184],
              [-75.72049, 37.901926],
              [-75.709626, 37.900622],
              [-75.687584, 37.88634],
              [-75.685293, 37.873341],
              [-75.689837, 37.861817],
              [-75.702914, 37.849659],
              [-75.709114, 37.8477],
              [-75.714487, 37.837777],
              [-75.71659, 37.826696],
              [-75.723224, 37.820124],
              [-75.73588, 37.816561],
              [-75.743097, 37.806656],
              [-75.770607, 37.804602],
              [-75.784599, 37.806826],
              [-75.793399, 37.804493],
              [-75.818125, 37.791698],
              [-75.812125, 37.776589],
              [-75.803041, 37.762464],
              [-75.812155, 37.749502],
              [-75.82481, 37.741671],
              [-75.827922, 37.737986],
              [-75.831438, 37.73169],
              [-75.830773, 37.725486],
              [-75.837685, 37.712985],
              [-75.845579, 37.707993],
              [-75.859262, 37.703111],
              [-75.868355, 37.687609],
              [-75.869523, 37.674356],
              [-75.868481, 37.668224],
              [-75.877059, 37.660641],
              [-75.909586, 37.622671],
              [-75.924756, 37.600215],
              [-75.941182, 37.563839],
              [-75.941153, 37.558436],
              [-75.937299, 37.551729],
              [-75.937665, 37.549652],
              [-75.940318, 37.534582],
              [-75.949974, 37.521876],
              [-75.958966, 37.500133],
              [-75.963326, 37.481785],
              [-75.963496, 37.475352],
              [-75.960877, 37.467562],
              [-75.976491, 37.444878],
              [-75.981624, 37.434116],
              [-75.983105, 37.415802],
              [-75.97997, 37.404608],
              [-75.987122, 37.368548],
              [-75.997778, 37.351739],
              [-76.014251, 37.331943],
              [-76.018645, 37.31782],
              [-76.023475, 37.289067],
              [-76.015507, 37.280874],
              [-76.023664, 37.268971],
              [-76.025753, 37.257407],
              [-76.014026, 37.235381],
              [-76.010535, 37.231579],
              [-76.013778, 37.219263],
              [-76.013071, 37.205366],
              [-76.006094, 37.19481],
              [-75.998647, 37.188739],
              [-75.978083, 37.157338],
              [-75.970004, 37.128861],
              [-75.97043, 37.118608],
              [-75.962596, 37.117535],
              [-75.945872, 37.120514],
              [-75.942539, 37.125142],
              [-75.92552, 37.133601],
              [-75.913222, 37.119849],
              [-75.912308, 37.115154],
              [-75.906734, 37.114193],
              [-75.897298, 37.118037],
              [-75.886369, 37.126085],
              [-75.87767, 37.135604],
              [-75.830341, 37.1706],
              [-75.800755, 37.197297],
              [-75.800468, 37.201029],
              [-75.804446, 37.208011],
              [-75.790903, 37.225066],
              [-75.789929, 37.228134],
              [-75.790386, 37.231225],
              [-75.795881, 37.236922],
              [-75.799343, 37.251779],
              [-75.79083, 37.276207],
              [-75.798448, 37.296285],
              [-75.791913, 37.300589],
              [-75.784634, 37.300976],
              [-75.780766, 37.297222],
              [-75.778817, 37.297176],
              [-75.765401, 37.305596],
              [-75.735829, 37.335426],
              [-75.726691, 37.350127],
              [-75.725634, 37.358416],
              [-75.727335, 37.360346],
              [-75.720739, 37.373129],
              [-75.697914, 37.405301],
              [-75.672648, 37.429915],
              [-75.665957, 37.439209],
              [-75.66179, 37.455028],
              [-75.664311, 37.458901],
              [-75.6655, 37.467319],
              [-75.666178, 37.472124],
              [-75.63337, 37.52214],
              [-75.60672, 37.55717],
              [-75.594044, 37.569698],
              [-75.595716, 37.576657],
              [-75.608123, 37.578018],
              [-75.612237, 37.585602],
              [-75.610808, 37.605909],
              [-75.60322, 37.620243],
              [-75.586136, 37.660653],
              [-75.581333, 37.683593],
              [-75.572464, 37.701565],
              [-75.556868, 37.72441],
              [-75.548082, 37.742383],
              [-75.514921, 37.799149],
              [-75.487485, 37.832136],
              [-75.467951, 37.851328],
              [-75.452681, 37.86351],
              [-75.437868, 37.872324],
              [-75.428956, 37.875305],
              [-75.40054, 37.874865],
              [-75.392008, 37.867738],
              [-75.374642, 37.859454],
              [-75.36683, 37.859446],
              [-75.359036, 37.864143],
              [-75.349338, 37.873143],
              [-75.334296, 37.893477],
              [-75.319335, 37.922484],
              [-75.296871, 37.959043],
              [-75.242266, 38.027209],
            ],
          ],
          [
            [
              [-75.973607, 37.835817],
              [-75.982098, 37.837253],
              [-75.988018, 37.841085],
              [-75.992556, 37.848889],
              [-75.996859, 37.85042],
              [-75.999658, 37.848198],
              [-76.001116, 37.834947],
              [-75.9983, 37.812626],
              [-75.987301, 37.804917],
              [-75.982158, 37.806226],
              [-75.977301, 37.825821],
              [-75.971705, 37.830928],
              [-75.973607, 37.835817],
            ],
          ],
          [
            [
              [-75.993905, 37.953489],
              [-75.994739, 37.953501],
              [-76.005888, 37.953662],
              [-76.017686, 37.953832],
              [-76.020796, 37.953877],
              [-76.020932, 37.953879],
              [-76.021714, 37.953887],
              [-76.022325, 37.953878],
              [-76.029405, 37.953776],
              [-76.029463, 37.953775],
              [-76.030122, 37.953655],
              [-76.038026, 37.953901],
              [-76.041402, 37.954006],
              [-76.041691, 37.954],
              [-76.045561, 37.953669],
              [-76.04653, 37.953586],
              [-76.035802, 37.929008],
              [-76.032491, 37.915008],
              [-76.017592, 37.935161],
              [-76.00313, 37.947997],
              [-75.993905, 37.953489],
            ],
          ],
          [
            [
              [-88.124658, 30.28364],
              [-88.124722, 30.273541],
              [-88.130631, 30.262125],
              [-88.141143, 30.255024],
              [-88.158303, 30.252393],
              [-88.17335, 30.252418],
              [-88.224615, 30.245559],
              [-88.25837, 30.239595],
              [-88.280781, 30.233781],
              [-88.299705, 30.231812],
              [-88.310025, 30.233233],
              [-88.313323, 30.230024],
              [-88.304773, 30.228031],
              [-88.280571, 30.230274],
              [-88.20854, 30.244807],
              [-88.166569, 30.249255],
              [-88.137083, 30.249179],
              [-88.120151, 30.246149],
              [-88.109432, 30.242097],
              [-88.078786, 30.245039],
              [-88.075856, 30.246139],
              [-88.074854, 30.249119],
              [-88.086812, 30.259864],
              [-88.124658, 30.28364],
            ],
          ],
          [
            [
              [-80.250581, 25.34193],
              [-80.249865, 25.342853],
              [-80.240376, 25.347005],
              [-80.238004, 25.361832],
              [-80.221991, 25.397417],
              [-80.204198, 25.412244],
              [-80.184033, 25.468587],
              [-80.173951, 25.482821],
              [-80.174544, 25.518406],
              [-80.179288, 25.518999],
              [-80.188778, 25.50773],
              [-80.191743, 25.495275],
              [-80.189964, 25.485786],
              [-80.192336, 25.473331],
              [-80.199453, 25.458504],
              [-80.20657, 25.434188],
              [-80.21428, 25.416988],
              [-80.219025, 25.411058],
              [-80.226142, 25.406313],
              [-80.246307, 25.398603],
              [-80.251052, 25.391486],
              [-80.25461, 25.38081],
              [-80.256982, 25.361239],
              [-80.264614, 25.354322],
              [-80.275961, 25.344039],
              [-80.289602, 25.325061],
              [-80.292567, 25.314385],
              [-80.315698, 25.29422],
              [-80.328746, 25.28651],
              [-80.334676, 25.285917],
              [-80.339421, 25.290069],
              [-80.364034, 25.28651],
              [-80.368186, 25.282359],
              [-80.342683, 25.268125],
              [-80.336159, 25.261601],
              [-80.333787, 25.253891],
              [-80.337345, 25.231353],
              [-80.3498, 25.210595],
              [-80.358696, 25.207037],
              [-80.369965, 25.206444],
              [-80.387164, 25.198141],
              [-80.391909, 25.19221],
              [-80.38835, 25.182721],
              [-80.387164, 25.170859],
              [-80.395467, 25.150694],
              [-80.403177, 25.141798],
              [-80.41326, 25.137053],
              [-80.446473, 25.151287],
              [-80.447659, 25.147729],
              [-80.433499, 25.114665],
              [-80.433575, 25.106317],
              [-80.444887, 25.092966],
              [-80.450399, 25.088751],
              [-80.463987, 25.09321],
              [-80.476174, 25.099454],
              [-80.47748, 25.107407],
              [-80.484188, 25.10943],
              [-80.494715, 25.102269],
              [-80.481763, 25.091905],
              [-80.470211, 25.089438],
              [-80.465496, 25.086609],
              [-80.460652, 25.078904],
              [-80.481197, 25.056604],
              [-80.4889, 25.05011],
              [-80.495569, 25.047497],
              [-80.501326, 25.041436],
              [-80.509136, 25.028317],
              [-80.524498, 25.016945],
              [-80.545971, 25.01477],
              [-80.543254, 25.007337],
              [-80.54411, 24.999916],
              [-80.558785, 24.971505],
              [-80.570813, 24.962215],
              [-80.578185, 24.962811],
              [-80.581131, 24.964738],
              [-80.597074, 24.958492],
              [-80.621658, 24.944265],
              [-80.624172, 24.939058],
              [-80.622896, 24.935587],
              [-80.623866, 24.931236],
              [-80.641306, 24.914311],
              [-80.650765, 24.908121],
              [-80.660198, 24.90498],
              [-80.66128, 24.899704],
              [-80.659395, 24.897433],
              [-80.635571, 24.913003],
              [-80.611693, 24.93842],
              [-80.596073, 24.948173],
              [-80.588272, 24.951153],
              [-80.571668, 24.953659],
              [-80.565831, 24.958155],
              [-80.537995, 24.990244],
              [-80.494781, 25.023019],
              [-80.48912, 25.031301],
              [-80.493881, 25.038502],
              [-80.47387, 25.060253],
              [-80.462011, 25.069935],
              [-80.443375, 25.076084],
              [-80.431032, 25.08925],
              [-80.428318, 25.095547],
              [-80.399767, 25.108536],
              [-80.377084, 25.130487],
              [-80.35857, 25.154073],
              [-80.349855, 25.168825],
              [-80.354019, 25.184306],
              [-80.351399, 25.190615],
              [-80.307584, 25.257561],
              [-80.288184, 25.282835],
              [-80.268138, 25.320675],
              [-80.260137, 25.324641],
              [-80.254916, 25.336336],
              [-80.250581, 25.34193],
            ],
          ],
          [
            [
              [-81.582923, 24.658732],
              [-81.587759, 24.655998],
              [-81.597685, 24.655397],
              [-81.614529, 24.650584],
              [-81.614829, 24.642764],
              [-81.637087, 24.621408],
              [-81.655735, 24.616295],
              [-81.66897, 24.607873],
              [-81.678595, 24.597647],
              [-81.687017, 24.592534],
              [-81.694235, 24.591932],
              [-81.699349, 24.597647],
              [-81.705364, 24.597647],
              [-81.71548, 24.592498],
              [-81.715944, 24.587956],
              [-81.730473, 24.58196],
              [-81.734573, 24.584148],
              [-81.739241, 24.589973],
              [-81.748071, 24.590199],
              [-81.773808, 24.584977],
              [-81.794057, 24.586],
              [-81.800676, 24.570989],
              [-81.811386, 24.56975],
              [-81.814446, 24.56358],
              [-81.81289, 24.546468],
              [-81.810333, 24.544701],
              [-81.786157, 24.54658],
              [-81.765993, 24.552103],
              [-81.732511, 24.556423],
              [-81.691575, 24.559886],
              [-81.685278, 24.558739],
              [-81.674694, 24.564359],
              [-81.664209, 24.573143],
              [-81.602998, 24.586444],
              [-81.54645, 24.614895],
              [-81.518595, 24.620304],
              [-81.511165, 24.625135],
              [-81.509028, 24.631516],
              [-81.50874, 24.64421],
              [-81.505585, 24.654609],
              [-81.502992, 24.660877],
              [-81.49858, 24.66498],
              [-81.480504, 24.659757],
              [-81.47641, 24.653197],
              [-81.477915, 24.649893],
              [-81.48183, 24.647369],
              [-81.480951, 24.645121],
              [-81.470411, 24.641985],
              [-81.448623, 24.640172],
              [-81.432315, 24.645949],
              [-81.414187, 24.647167],
              [-81.403319, 24.640294],
              [-81.401946, 24.623564],
              [-81.395096, 24.621062],
              [-81.332831, 24.639528],
              [-81.303113, 24.651665],
              [-81.298369, 24.654326],
              [-81.298028, 24.656774],
              [-81.309664, 24.665017],
              [-81.313933, 24.680707],
              [-81.314787, 24.691764],
              [-81.319282, 24.701238],
              [-81.345881, 24.70756],
              [-81.36041, 24.708788],
              [-81.38558, 24.726182],
              [-81.389468, 24.731298],
              [-81.390287, 24.73846],
              [-81.392947, 24.743371],
              [-81.402769, 24.749101],
              [-81.425483, 24.752989],
              [-81.431009, 24.751761],
              [-81.430599, 24.747259],
              [-81.427121, 24.745827],
              [-81.421595, 24.737641],
              [-81.423028, 24.731911],
              [-81.432032, 24.722908],
              [-81.435715, 24.723931],
              [-81.43858, 24.727],
              [-81.440831, 24.73539],
              [-81.451267, 24.747464],
              [-81.456588, 24.740097],
              [-81.4527, 24.736209],
              [-81.451881, 24.714518],
              [-81.454132, 24.710834],
              [-81.459043, 24.707355],
              [-81.469275, 24.704286],
              [-81.474186, 24.706332],
              [-81.476642, 24.711244],
              [-81.490962, 24.710105],
              [-81.5124, 24.703737],
              [-81.516433, 24.700341],
              [-81.51898, 24.687818],
              [-81.535323, 24.67954],
              [-81.542116, 24.681026],
              [-81.55761, 24.692488],
              [-81.562917, 24.692912],
              [-81.580534, 24.66914],
              [-81.582923, 24.658732],
            ],
          ],
          [
            [
              [-82.15068, 24.576331],
              [-82.164426, 24.563375],
              [-82.165206, 24.552159],
              [-82.159439, 24.548212],
              [-82.116787, 24.549144],
              [-82.104429, 24.561167],
              [-82.099417, 24.572522],
              [-82.101051, 24.584679],
              [-82.104187, 24.588256],
              [-82.125268, 24.597426],
              [-82.135423, 24.596879],
              [-82.143075, 24.593395],
              [-82.15068, 24.576331],
            ],
          ],
          [
            [
              [-81.249799, 24.673357],
              [-81.260006, 24.674848],
              [-81.278312, 24.660448],
              [-81.281778, 24.65375],
              [-81.244761, 24.669202],
              [-81.243232, 24.673998],
              [-81.246095, 24.675832],
              [-81.249799, 24.673357],
            ],
          ],
          [
            [
              [-80.909954, 24.781154],
              [-80.910431, 24.782324],
              [-80.960129, 24.764226],
              [-80.986454, 24.752749],
              [-80.994426, 24.743991],
              [-81.016918, 24.734676],
              [-81.02217, 24.733091],
              [-81.035192, 24.739982],
              [-81.036698, 24.742827],
              [-81.041797, 24.742965],
              [-81.05057, 24.737581],
              [-81.066816, 24.723926],
              [-81.099135, 24.711993],
              [-81.105287, 24.71128],
              [-81.107355, 24.71276],
              [-81.125371, 24.708291],
              [-81.124094, 24.704873],
              [-81.108041, 24.688592],
              [-81.078439, 24.692382],
              [-81.078716, 24.696557],
              [-81.075855, 24.704266],
              [-81.071034, 24.711722],
              [-81.064554, 24.715453],
              [-81.03429, 24.727341],
              [-81.032447, 24.727323],
              [-81.028616, 24.720618],
              [-81.023794, 24.716901],
              [-81.015933, 24.719881],
              [-80.938543, 24.767535],
              [-80.912042, 24.76505],
              [-80.906288, 24.769867],
              [-80.909954, 24.781154],
            ],
          ],
          [
            [
              [-81.317673, 24.75729],
              [-81.324637, 24.76721],
              [-81.327555, 24.762315],
              [-81.342695, 24.75625],
              [-81.357417, 24.756834],
              [-81.350162, 24.746524],
              [-81.326844, 24.728375],
              [-81.318505, 24.729477],
              [-81.310744, 24.727068],
              [-81.302984, 24.714199],
              [-81.288259, 24.720881],
              [-81.290801, 24.736862],
              [-81.305468, 24.756612],
              [-81.317673, 24.75729],
            ],
          ],
          [
            [
              [-80.89054, 24.791678],
              [-80.906874, 24.783744],
              [-80.892649, 24.785991],
              [-80.88402, 24.790414],
              [-80.884572, 24.791561],
              [-80.89054, 24.791678],
            ],
          ],
          [
            [
              [-80.788263, 24.824218],
              [-80.780564, 24.84052],
              [-80.79278, 24.843918],
              [-80.814551, 24.827953],
              [-80.830158, 24.81428],
              [-80.846142, 24.807488],
              [-80.850866, 24.803701],
              [-80.850338, 24.8026],
              [-80.846191, 24.802968],
              [-80.822342, 24.812629],
              [-80.796053, 24.81194],
              [-80.790497, 24.817789],
              [-80.788263, 24.824218],
            ],
          ],
          [
            [
              [-80.729275, 24.865361],
              [-80.732343, 24.86481],
              [-80.740611, 24.857421],
              [-80.745468, 24.850652],
              [-80.766966, 24.836158],
              [-80.761359, 24.836225],
              [-80.71185, 24.863323],
              [-80.703176, 24.869495],
              [-80.690354, 24.881539],
              [-80.691762, 24.885759],
              [-80.703028, 24.880873],
              [-80.719977, 24.864644],
              [-80.729275, 24.865361],
            ],
          ],
          [
            [
              [-82.255777, 26.703437],
              [-82.264351, 26.698496],
              [-82.268007, 26.682791],
              [-82.263008, 26.673388],
              [-82.248659, 26.654337],
              [-82.238872, 26.636433],
              [-82.222131, 26.590402],
              [-82.205523, 26.566536],
              [-82.201402, 26.55631],
              [-82.186441, 26.489221],
              [-82.180717, 26.476257],
              [-82.177017, 26.471558],
              [-82.172917, 26.467658],
              [-82.148716, 26.455458],
              [-82.126671, 26.436279],
              [-82.098115, 26.424959],
              [-82.082915, 26.422059],
              [-82.075015, 26.422059],
              [-82.063114, 26.425459],
              [-82.013913, 26.452058],
              [-82.013713, 26.454258],
              [-82.015607, 26.454858],
              [-82.038403, 26.456907],
              [-82.062551, 26.470131],
              [-82.076924, 26.466106],
              [-82.088423, 26.455182],
              [-82.120046, 26.473581],
              [-82.131545, 26.47703],
              [-82.149368, 26.477605],
              [-82.166042, 26.489679],
              [-82.177541, 26.502328],
              [-82.187315, 26.527626],
              [-82.196514, 26.559823],
              [-82.214337, 26.602944],
              [-82.218342, 26.626407],
              [-82.23744, 26.661976],
              [-82.246535, 26.683437],
              [-82.24596, 26.688612],
              [-82.24251, 26.694361],
              [-82.246535, 26.706435],
              [-82.255159, 26.70816],
              [-82.255777, 26.703437],
            ],
          ],
          [
            [
              [-84.777208, 29.707398],
              [-84.79816, 29.699321],
              [-84.813352, 29.687028],
              [-84.862099, 29.672572],
              [-84.895885, 29.657444],
              [-84.920333, 29.648638],
              [-84.925842, 29.644949],
              [-84.932592, 29.637232],
              [-84.968314, 29.617238],
              [-84.987775, 29.610307],
              [-85.017205, 29.604379],
              [-85.023501, 29.597073],
              [-85.038497, 29.599552],
              [-85.06653, 29.609952],
              [-85.094882, 29.627757],
              [-85.097082, 29.625215],
              [-85.09519, 29.62249],
              [-85.069453, 29.605282],
              [-85.054624, 29.592084],
              [-85.051033, 29.586928],
              [-85.036219, 29.588919],
              [-84.957779, 29.612635],
              [-84.884632, 29.652248],
              [-84.853829, 29.66472],
              [-84.799129, 29.681565],
              [-84.776954, 29.692191],
              [-84.765117, 29.699724],
              [-84.713747, 29.74139],
              [-84.694939, 29.761844],
              [-84.694125, 29.764593],
              [-84.696726, 29.76993],
              [-84.716994, 29.749066],
              [-84.729836, 29.738881],
              [-84.777208, 29.707398],
            ],
          ],
          [
            [
              [-85.156415, 29.679628],
              [-85.168625, 29.682409],
              [-85.184776, 29.68271],
              [-85.208981, 29.681775],
              [-85.220324, 29.680138],
              [-85.222546, 29.678039],
              [-85.204314, 29.672695],
              [-85.18453, 29.663987],
              [-85.16252, 29.650282],
              [-85.142746, 29.635404],
              [-85.124913, 29.628433],
              [-85.097218, 29.633004],
              [-85.091399, 29.648634],
              [-85.077237, 29.670862],
              [-85.083719, 29.679019],
              [-85.093902, 29.684838],
              [-85.114268, 29.688658],
              [-85.134639, 29.686569],
              [-85.137397, 29.684348],
              [-85.156415, 29.679628],
            ],
          ],
          [
            [
              [-82.821585, 27.964443],
              [-82.815168, 27.973721],
              [-82.817248, 27.992094],
              [-82.821755, 28.002494],
              [-82.821408, 28.008387],
              [-82.815168, 28.012547],
              [-82.813435, 28.03716],
              [-82.818288, 28.057613],
              [-82.823063, 28.068258],
              [-82.826125, 28.083793],
              [-82.830525, 28.085293],
              [-82.833225, 28.082193],
              [-82.836326, 28.073193],
              [-82.831825, 28.062893],
              [-82.826282, 28.05345],
              [-82.823063, 28.044758],
              [-82.823025, 28.030695],
              [-82.828625, 28.019795],
              [-82.829801, 27.968469],
              [-82.821585, 27.964443],
            ],
          ],
          [
            [
              [-75.753765, 35.199612],
              [-75.754289, 35.199402],
              [-75.785729, 35.194244],
              [-75.793283, 35.18852],
              [-75.801444, 35.183079],
              [-75.812902, 35.178568],
              [-75.819172, 35.176826],
              [-75.839531, 35.172197],
              [-75.893942, 35.150433],
              [-75.910265, 35.142271],
              [-75.923867, 35.135017],
              [-75.9547, 35.1196],
              [-75.966489, 35.117787],
              [-75.973499, 35.121087],
              [-75.98395, 35.120042],
              [-75.989175, 35.115165],
              [-75.990569, 35.108546],
              [-75.989175, 35.100882],
              [-75.99188, 35.092395],
              [-76.000949, 35.084234],
              [-76.013561, 35.068832],
              [-76.014954, 35.065349],
              [-76.013145, 35.061855],
              [-76.00151, 35.06723],
              [-75.982812, 35.081513],
              [-75.963768, 35.092395],
              [-75.944725, 35.105091],
              [-75.912985, 35.1196],
              [-75.840438, 35.15134],
              [-75.789655, 35.172197],
              [-75.769705, 35.180359],
              [-75.757916, 35.183079],
              [-75.749406, 35.185207],
              [-75.728897, 35.190334],
              [-75.672673, 35.208471],
              [-75.635493, 35.22026],
              [-75.610101, 35.227514],
              [-75.580176, 35.231142],
              [-75.560225, 35.232048],
              [-75.544809, 35.228421],
              [-75.533627, 35.225825],
              [-75.52592, 35.233839],
              [-75.502188, 35.320012],
              [-75.486771, 35.391652],
              [-75.471355, 35.479615],
              [-75.462491, 35.553556],
              [-75.460061, 35.581314],
              [-75.458659, 35.596597],
              [-75.479128, 35.678634],
              [-75.496086, 35.728515],
              [-75.502427, 35.742913],
              [-75.522232, 35.774178],
              [-75.528992, 35.776289],
              [-75.533512, 35.773577],
              [-75.515397, 35.73038],
              [-75.515745, 35.721671],
              [-75.507385, 35.680564],
              [-75.498675, 35.666281],
              [-75.487678, 35.648287],
              [-75.48133, 35.622896],
              [-75.47861, 35.599318],
              [-75.47861, 35.553069],
              [-75.482237, 35.53856],
              [-75.487528, 35.525889],
              [-75.489618, 35.508471],
              [-75.488585, 35.497752],
              [-75.487678, 35.485056],
              [-75.494933, 35.454224],
              [-75.500374, 35.424298],
              [-75.506722, 35.387118],
              [-75.51261, 35.362853],
              [-75.518511, 35.336335],
              [-75.523952, 35.318198],
              [-75.529393, 35.288272],
              [-75.535741, 35.272856],
              [-75.561033, 35.266008],
              [-75.581935, 35.263917],
              [-75.585419, 35.266356],
              [-75.596915, 35.269491],
              [-75.59796, 35.266704],
              [-75.598312, 35.261067],
              [-75.599005, 35.256253],
              [-75.615378, 35.248938],
              [-75.630358, 35.238487],
              [-75.640934, 35.233862],
              [-75.664512, 35.227514],
              [-75.675394, 35.228421],
              [-75.681916, 35.232913],
              [-75.684006, 35.232913],
              [-75.68749, 35.231171],
              [-75.694437, 35.22298],
              [-75.698972, 35.221166],
              [-75.708947, 35.213912],
              [-75.718015, 35.209377],
              [-75.734171, 35.204347],
              [-75.74522, 35.20303],
              [-75.753765, 35.199612],
            ],
          ],
          [
            [
              [-75.675245, 35.929024],
              [-75.686358, 35.932973],
              [-75.69115, 35.936932],
              [-75.705323, 35.939403],
              [-75.718266, 35.939714],
              [-75.726807, 35.935844],
              [-75.727251, 35.93362],
              [-75.723782, 35.925569],
              [-75.702165, 35.915428],
              [-75.696871, 35.909556],
              [-75.697672, 35.901639],
              [-75.681415, 35.88398],
              [-75.67283, 35.882423],
              [-75.663356, 35.869835],
              [-75.660598, 35.862541],
              [-75.660086, 35.83861],
              [-75.675054, 35.830204],
              [-75.667891, 35.82354],
              [-75.63898, 35.818639],
              [-75.624235, 35.809387],
              [-75.620454, 35.809253],
              [-75.614361, 35.815659],
              [-75.619772, 35.847606],
              [-75.616833, 35.856331],
              [-75.62767, 35.883149],
              [-75.64512, 35.905788],
              [-75.648519, 35.906982],
              [-75.653478, 35.904686],
              [-75.662019, 35.906522],
              [-75.662938, 35.916166],
              [-75.65954, 35.919564],
              [-75.675245, 35.929024],
            ],
          ],
        ],
      },
      properties: { region: 'SOUTHEAST' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-120.248484, 33.999329],
              [-120.224461, 33.989059],
              [-120.209372, 33.972376],
              [-120.200085, 33.956904],
              [-120.198602, 33.952211],
              [-120.192339, 33.950266],
              [-120.18984, 33.947703],
              [-120.179049, 33.927994],
              [-120.168974, 33.91909],
              [-120.121817, 33.895712],
              [-120.109137, 33.899129],
              [-120.105489, 33.90428],
              [-120.098601, 33.907853],
              [-120.077793, 33.908886],
              [-120.049682, 33.914563],
              [-120.048611, 33.915775],
              [-120.048315, 33.917625],
              [-120.046881, 33.919597],
              [-120.017715, 33.936366],
              [-120.00096, 33.941554],
              [-119.973691, 33.942481],
              [-119.97026, 33.944359],
              [-119.971141, 33.950401],
              [-119.976857, 33.956693],
              [-119.979913, 33.969623],
              [-119.978876, 33.983081],
              [-119.984316, 33.983948],
              [-120.003815, 33.979547],
              [-120.011123, 33.979894],
              [-120.025653, 33.985553],
              [-120.041311, 33.994507],
              [-120.046575, 34.000002],
              [-120.048926, 34.009898],
              [-120.050382, 34.013331],
              [-120.047798, 34.021227],
              [-120.044004, 34.02482],
              [-120.043259, 34.035806],
              [-120.055107, 34.037729],
              [-120.057637, 34.03734],
              [-120.061953, 34.033976],
              [-120.062778, 34.031161],
              [-120.073609, 34.024477],
              [-120.090182, 34.019806],
              [-120.115058, 34.019866],
              [-120.135853, 34.026087],
              [-120.140362, 34.025974],
              [-120.147647, 34.024831],
              [-120.151663, 34.018126],
              [-120.167306, 34.008219],
              [-120.19578, 34.004284],
              [-120.208478, 34.005655],
              [-120.221287, 34.010367],
              [-120.230001, 34.010136],
              [-120.238657, 34.007592],
              [-120.247393, 34.001911],
              [-120.248484, 33.999329],
            ],
          ],
          [
            [
              [-119.789798, 34.05726],
              [-119.807825, 34.052127],
              [-119.818742, 34.052997],
              [-119.825865, 34.059794],
              [-119.857304, 34.071298],
              [-119.89113, 34.072856],
              [-119.912857, 34.077508],
              [-119.919155, 34.07728],
              [-119.923337, 34.069361],
              [-119.916216, 34.058351],
              [-119.892821, 34.045529],
              [-119.876329, 34.032087],
              [-119.876916, 34.023527],
              [-119.882531, 34.011674],
              [-119.884896, 34.008814],
              [-119.883033, 34.000802],
              [-119.877057, 33.985757],
              [-119.873358, 33.980375],
              [-119.842748, 33.97034],
              [-119.795938, 33.962929],
              [-119.758141, 33.959212],
              [-119.750438, 33.963759],
              [-119.742966, 33.963877],
              [-119.721206, 33.959583],
              [-119.714696, 33.961439],
              [-119.712363, 33.965422],
              [-119.706952, 33.969178],
              [-119.69011, 33.972225],
              [-119.662825, 33.985889],
              [-119.64771, 33.987786],
              [-119.621117, 33.98899],
              [-119.619082, 33.987228],
              [-119.596877, 33.988611],
              [-119.5902, 33.989712],
              [-119.575636, 33.996009],
              [-119.560464, 33.99553],
              [-119.554472, 33.99782],
              [-119.547072, 34.005469],
              [-119.54828, 34.009819],
              [-119.542449, 34.021082],
              [-119.538847, 34.023988],
              [-119.532413, 34.024949],
              [-119.52177, 34.032247],
              [-119.52064, 34.034262],
              [-119.529603, 34.041155],
              [-119.5667, 34.053452],
              [-119.57341, 34.05011],
              [-119.59324, 34.049625],
              [-119.609239, 34.03735],
              [-119.608798, 34.035245],
              [-119.604287, 34.031561],
              [-119.612226, 34.021256],
              [-119.619343, 34.016468],
              [-119.637742, 34.013178],
              [-119.686507, 34.019805],
              [-119.704628, 34.037681],
              [-119.712576, 34.043265],
              [-119.726437, 34.047908],
              [-119.739472, 34.049299],
              [-119.755521, 34.056716],
              [-119.763688, 34.057155],
              [-119.766081, 34.05537],
              [-119.770729, 34.055051],
              [-119.789798, 34.05726],
            ],
          ],
          [
            [
              [-120.46258, 34.042627],
              [-120.465329, 34.038448],
              [-120.459635, 34.031537],
              [-120.454134, 34.028081],
              [-120.427408, 34.025425],
              [-120.419021, 34.028949],
              [-120.415225, 34.032245],
              [-120.409368, 34.032198],
              [-120.375143, 34.018775],
              [-120.35793, 34.015029],
              [-120.35532, 34.017914],
              [-120.347706, 34.020114],
              [-120.317052, 34.018837],
              [-120.304543, 34.021171],
              [-120.302122, 34.023574],
              [-120.313175, 34.036576],
              [-120.319032, 34.041979],
              [-120.331161, 34.049097],
              [-120.346946, 34.046576],
              [-120.358608, 34.050235],
              [-120.36029, 34.05582],
              [-120.354982, 34.059256],
              [-120.362251, 34.073056],
              [-120.368278, 34.076465],
              [-120.370176, 34.074907],
              [-120.368584, 34.071214],
              [-120.368813, 34.06778],
              [-120.374211, 34.062658],
              [-120.390906, 34.051994],
              [-120.396188, 34.050187],
              [-120.403613, 34.050442],
              [-120.411314, 34.052869],
              [-120.415287, 34.05496],
              [-120.418768, 34.052093],
              [-120.440248, 34.036918],
              [-120.46258, 34.042627],
            ],
          ],
          [
            [
              [-119.543842, 33.280329],
              [-119.547642, 33.280328],
              [-119.555242, 33.273429],
              [-119.562042, 33.271129],
              [-119.578942, 33.278628],
              [-119.570642, 33.257729],
              [-119.566014, 33.252639],
              [-119.565641, 33.250029],
              [-119.564971, 33.24744],
              [-119.545872, 33.233406],
              [-119.517514, 33.226737],
              [-119.511659, 33.223027],
              [-119.500684, 33.220569],
              [-119.476029, 33.21552],
              [-119.464725, 33.215432],
              [-119.444269, 33.21919],
              [-119.429559, 33.228167],
              [-119.458466, 33.254661],
              [-119.465717, 33.259239],
              [-119.48278, 33.263973],
              [-119.50504, 33.272829],
              [-119.528141, 33.284929],
              [-119.532941, 33.284728],
              [-119.543842, 33.280329],
            ],
          ],
          [
            [
              [-119.422972, 34.004368],
              [-119.414528, 34.004994],
              [-119.391551, 34.002505],
              [-119.376396, 34.010551],
              [-119.357462, 34.015919],
              [-119.366591, 34.016785],
              [-119.389983, 34.006099],
              [-119.396251, 34.005918],
              [-119.411317, 34.008005],
              [-119.421376, 34.015012],
              [-119.433912, 34.015975],
              [-119.441226, 34.014075],
              [-119.441116, 34.012426],
              [-119.437734, 34.01],
              [-119.427589, 34.006445],
              [-119.422972, 34.004368],
            ],
          ],
          [
            [
              [-118.524531, 32.895488],
              [-118.524641, 32.893175],
              [-118.507193, 32.876264],
              [-118.508095, 32.871321],
              [-118.506902, 32.868503],
              [-118.496298, 32.851572],
              [-118.487908, 32.84459],
              [-118.476074, 32.841754],
              [-118.44492, 32.820593],
              [-118.428372, 32.806872],
              [-118.42943, 32.805429],
              [-118.425634, 32.800595],
              [-118.401268, 32.820338],
              [-118.394565, 32.823978],
              [-118.387375, 32.825327],
              [-118.379968, 32.824545],
              [-118.36053, 32.819921],
              [-118.356541, 32.817311],
              [-118.353504, 32.821962],
              [-118.369984, 32.839273],
              [-118.446771, 32.895424],
              [-118.460623, 32.90951],
              [-118.479039, 32.920363],
              [-118.485288, 32.923545],
              [-118.496811, 32.933847],
              [-118.529228, 32.970921],
              [-118.540069, 32.980933],
              [-118.559171, 33.006291],
              [-118.564527, 33.018637],
              [-118.564445, 33.024914],
              [-118.569013, 33.029151],
              [-118.57516, 33.033961],
              [-118.594033, 33.035951],
              [-118.605534, 33.030999],
              [-118.606559, 33.01469],
              [-118.596037, 33.015357],
              [-118.586928, 33.008281],
              [-118.573522, 32.969183],
              [-118.560887, 32.957891],
              [-118.551134, 32.945155],
              [-118.535823, 32.90628],
              [-118.524531, 32.895488],
            ],
          ],
          [
            [
              [-118.500212, 33.449592],
              [-118.530702, 33.468071],
              [-118.54453, 33.474119],
              [-118.585936, 33.473819],
              [-118.598783, 33.477939],
              [-118.603375, 33.478098],
              [-118.60403, 33.47654],
              [-118.601185, 33.469853],
              [-118.593969, 33.467198],
              [-118.575901, 33.448261],
              [-118.570927, 33.439351],
              [-118.563442, 33.434381],
              [-118.558715, 33.433419],
              [-118.53738, 33.434608],
              [-118.52323, 33.430733],
              [-118.516267, 33.425075],
              [-118.515914, 33.422417],
              [-118.503952, 33.424234],
              [-118.48875, 33.419826],
              [-118.484949, 33.412131],
              [-118.478465, 33.38632],
              [-118.482609, 33.369914],
              [-118.48877, 33.356649],
              [-118.481886, 33.344123],
              [-118.465368, 33.326056],
              [-118.456309, 33.32182],
              [-118.440047, 33.318638],
              [-118.402941, 33.320901],
              [-118.374768, 33.320065],
              [-118.360332, 33.31533],
              [-118.343249, 33.305234],
              [-118.325244, 33.299075],
              [-118.316787, 33.301137],
              [-118.305084, 33.310323],
              [-118.303174, 33.320264],
              [-118.310213, 33.335795],
              [-118.316083, 33.342928],
              [-118.32446, 33.348782],
              [-118.365094, 33.388374],
              [-118.368301, 33.40711],
              [-118.370323, 33.409285],
              [-118.382037, 33.409883],
              [-118.423576, 33.427258],
              [-118.445812, 33.428907],
              [-118.477646, 33.448392],
              [-118.48557, 33.446213],
              [-118.499669, 33.447879],
              [-118.500212, 33.449592],
            ],
          ],
          [
            [
              [-122.418698, 37.852717],
              [-122.41847, 37.852721],
              [-122.41847, 37.861764],
              [-122.421341, 37.869946],
              [-122.421439, 37.869969],
              [-122.430958, 37.872242],
              [-122.438565, 37.868367],
              [-122.446316, 37.861046],
              [-122.443302, 37.855448],
              [-122.434403, 37.852434],
              [-122.418698, 37.852717],
            ],
          ],
          [
            [
              [-123.013916, 37.700355],
              [-123.014303, 37.696205],
              [-123.011464, 37.691907],
              [-123.005543, 37.689392],
              [-123.000677, 37.690203],
              [-122.997189, 37.697909],
              [-123.00019, 37.702937],
              [-123.004489, 37.706262],
              [-123.012194, 37.706749],
              [-123.013897, 37.704478],
              [-123.013916, 37.700355],
            ],
          ],
          [
            [
              [-122.3785, 37.826505],
              [-122.37267, 37.81651],
              [-122.372422, 37.811301],
              [-122.362661, 37.807577],
              [-122.358779, 37.814278],
              [-122.363244, 37.823951],
              [-122.369941, 37.832137],
              [-122.377879, 37.830648],
              [-122.3785, 37.826505],
            ],
          ],
          [
            [
              [-114.633013, 35.002085],
              [-114.633544, 35.015644],
              [-114.635469, 35.028266],
              [-114.621956, 35.094678],
              [-114.59912, 35.12105],
              [-114.5843, 35.124999],
              [-114.578524, 35.12875],
              [-114.572747, 35.138725],
              [-114.569569, 35.163053],
              [-114.569238, 35.18348],
              [-114.595931, 35.325234],
              [-114.604314, 35.353584],
              [-114.627137, 35.409504],
              [-114.652005, 35.429165],
              [-114.662125, 35.444241],
              [-114.677643, 35.489742],
              [-114.676733, 35.499063],
              [-114.674981, 35.510564],
              [-114.671147, 35.520641],
              [-114.653806, 35.59949],
              [-114.653406, 35.610789],
              [-114.657506, 35.618289],
              [-114.676707, 35.640989],
              [-114.689407, 35.651412],
              [-114.700308, 35.700387],
              [-114.70771, 35.811885],
              [-114.705611, 35.848884],
              [-114.704211, 35.851984],
              [-114.70613, 35.878712],
              [-114.731296, 35.945157],
              [-114.743576, 35.983721],
              [-114.755618, 36.087166],
              [-114.744857, 36.098693],
              [-114.736165, 36.104367],
              [-114.631716, 36.142306],
              [-114.572031, 36.15161],
              [-114.513256, 36.151217],
              [-114.381446, 36.141665],
              [-114.365835, 36.133722],
              [-114.328777, 36.105501],
              [-114.310857, 36.083787],
              [-114.307235, 36.076544],
              [-114.303614, 36.066456],
              [-114.292663, 36.051118],
              [-114.263146, 36.025937],
              [-114.252651, 36.020193],
              [-114.238799, 36.014561],
              [-114.233289, 36.014289],
              [-114.21369, 36.015613],
              [-114.15413, 36.023862],
              [-114.148774, 36.02731],
              [-114.138202, 36.041284],
              [-114.125796, 36.077531],
              [-114.120193, 36.102228],
              [-114.063021, 36.186942],
              [-114.060302, 36.189363],
              [-114.046838, 36.194069],
              [-114.047106, 36.250591],
              [-114.048515, 36.289598],
              [-114.046403, 36.371873],
              [-114.046488, 36.473449],
              [-114.050562, 36.656259],
              [-114.050578, 36.800173],
              [-114.050583, 36.843141],
              [-114.0506, 37.000396],
              [-114.051749, 37.088434],
              [-114.051822, 37.090976],
              [-114.051974, 37.283848],
              [-114.051974, 37.284511],
              [-114.0518, 37.293044],
              [-114.0518, 37.293548],
              [-114.051927, 37.370459],
              [-114.051927, 37.370734],
              [-114.052701, 37.492014],
              [-114.052685, 37.502513],
              [-114.052718, 37.517264],
              [-114.052689, 37.517859],
              [-114.052472, 37.604776],
              [-114.051728, 37.745997],
              [-114.051785, 37.746249],
              [-114.05167, 37.746958],
              [-114.051109, 37.756276],
              [-114.048473, 37.809861],
              [-114.050423, 37.999961],
              [-114.049903, 38.148601],
              [-114.05012, 38.404536],
              [-114.050091, 38.404673],
              [-114.049834, 38.543784],
              [-114.049862, 38.547764],
              [-114.050154, 38.57292],
              [-114.049893, 38.677365],
              [-114.047728, 39.542742],
              [-114.047134, 39.906037],
              [-114.046555, 40.116931],
              [-114.045518, 40.494474],
              [-114.045577, 40.495801],
              [-114.045281, 40.506586],
              [-114.043505, 40.726292],
              [-114.043831, 40.758666],
              [-114.043803, 40.759205],
              [-114.042145, 40.999926],
              [-114.039882, 41.741991],
              [-114.041152, 41.850595],
              [-114.041107, 41.850573],
              [-114.041723, 41.99372],
              [-114.048246, 41.993721],
              [-114.048257, 41.993814],
              [-114.061774, 41.993797],
              [-114.061763, 41.993939],
              [-114.107259, 41.993831],
              [-114.107428, 41.993965],
              [-114.281854, 41.994264],
              [-114.498243, 41.994636],
              [-114.498259, 41.994599],
              [-114.598267, 41.994511],
              [-114.763825, 41.999909],
              [-114.914187, 41.999909],
              [-115.031783, 41.996008],
              [-115.038256, 41.996025],
              [-115.98688, 41.998534],
              [-116.012212, 41.998035],
              [-116.012219, 41.998048],
              [-116.018945, 41.997722],
              [-116.01896, 41.997762],
              [-116.030758, 41.997383],
              [-116.030754, 41.997399],
              [-116.03857, 41.997413],
              [-116.038602, 41.99746],
              [-116.160833, 41.997508],
              [-116.163931, 41.997555],
              [-116.463528, 41.996547],
              [-116.483094, 41.996885],
              [-116.485823, 41.996861],
              [-116.510452, 41.997096],
              [-116.586937, 41.99737],
              [-116.62677, 41.99775],
              [-117.018294, 41.999358],
              [-117.026222, 42.000252],
              [-117.026331, 42.807015],
              [-117.026303, 42.80717],
              [-117.026253, 42.807447],
              [-117.026683, 43.024876],
              [-117.026652, 43.025128],
              [-117.026746, 43.577526],
              [-117.026774, 43.578674],
              [-117.026922, 43.593632],
              [-117.026889, 43.596033],
              [-117.026824, 43.600357],
              [-117.02676, 43.601912],
              [-117.026789, 43.610669],
              [-117.026937, 43.617614],
              [-117.027001, 43.621032],
              [-117.026905, 43.62488],
              [-117.026705, 43.631659],
              [-117.026661, 43.664385],
              [-117.026717, 43.675523],
              [-117.026623, 43.680865],
              [-117.026586, 43.683001],
              [-117.026825, 43.706193],
              [-117.026725, 43.714815],
              [-117.026841, 43.732905],
              [-117.026651, 43.733935],
              [-117.026634, 43.808104],
              [-116.996504, 43.864714],
              [-116.982482, 43.872799],
              [-116.979186, 43.879973],
              [-116.961535, 43.918388],
              [-116.935301, 43.988616],
              [-116.931719, 44.102474],
              [-116.897145, 44.152537],
              [-116.895931, 44.154295],
              [-116.894083, 44.160191],
              [-116.895757, 44.171267],
              [-116.902752, 44.179467],
              [-116.975905, 44.242844],
              [-116.98687, 44.245477],
              [-117.027558, 44.248881],
              [-117.03317, 44.248192],
              [-117.041144, 44.243653],
              [-117.170342, 44.25889],
              [-117.190107, 44.273958],
              [-117.196597, 44.287529],
              [-117.197777, 44.295789],
              [-117.197506, 44.29728],
              [-117.196597, 44.30228],
              [-117.194827, 44.31054],
              [-117.191546, 44.329621],
              [-117.189769, 44.336585],
              [-117.214889, 44.466901],
              [-117.208454, 44.485928],
              [-117.156489, 44.528312],
              [-117.149242, 44.536151],
              [-117.144161, 44.545647],
              [-117.1159, 44.623339],
              [-117.095868, 44.664737],
              [-117.062273, 44.727143],
              [-117.044217, 44.74514],
              [-117.03827, 44.748179],
              [-117.016216, 44.755572],
              [-116.931499, 44.792281],
              [-116.891463, 44.840531],
              [-116.852427, 44.887577],
              [-116.83199, 44.933007],
              [-116.835702, 44.940633],
              [-116.844653, 44.949338],
              [-116.850737, 44.958113],
              [-116.858277, 44.978008],
              [-116.845369, 45.017059],
              [-116.783902, 45.079022],
              [-116.729607, 45.142091],
              [-116.709536, 45.203015],
              [-116.696047, 45.254679],
              [-116.691197, 45.269245],
              [-116.673793, 45.321511],
              [-116.553473, 45.499107],
              [-116.481208, 45.580597],
              [-116.463635, 45.602785],
              [-116.463504, 45.615785],
              [-116.471504, 45.628467],
              [-116.48912, 45.65114],
              [-116.510938, 45.668114],
              [-116.528272, 45.681473],
              [-116.535396, 45.691734],
              [-116.538014, 45.714929],
              [-116.535698, 45.734231],
              [-116.54809, 45.752364],
              [-116.59421, 45.77908],
              [-116.633377, 45.784681],
              [-116.789099, 45.847749],
              [-116.796418, 45.853807],
              [-116.857254, 45.904159],
              [-116.866544, 45.916958],
              [-116.875125, 45.9422],
              [-116.915989, 45.995413],
              [-116.94353, 46.062173],
              [-116.925621, 46.158888],
              [-116.958801, 46.24232],
              [-116.985333, 46.294617],
              [-116.987939, 46.298031],
              [-117.047469, 46.342884],
              [-117.061045, 46.367747],
              [-117.046915, 46.379577],
              [-117.039813, 46.425425],
              [-117.039741, 46.462704],
              [-117.039763, 46.46957],
              [-117.039771, 46.471779],
              [-117.039783, 46.541785],
              [-117.039828, 46.815443],
              [-117.039657, 46.825798],
              [-117.039821, 47.127265],
              [-117.039836, 47.154734],
              [-117.039871, 47.181858],
              [-117.039888, 47.203282],
              [-117.039899, 47.225515],
              [-117.040019, 47.259272],
              [-117.039843, 47.347201],
              [-117.039857, 47.366093],
              [-117.039882, 47.399085],
              [-117.03995, 47.412412],
              [-117.039948, 47.434885],
              [-117.039971, 47.463309],
              [-117.039945, 47.477823],
              [-117.040514, 47.522351],
              [-117.040545, 47.527562],
              [-117.040745, 47.532909],
              [-117.041276, 47.55821],
              [-117.041174, 47.55853],
              [-117.041431, 47.67814],
              [-117.041431, 47.678185],
              [-117.041431, 47.68],
              [-117.041532, 47.683194],
              [-117.041633, 47.7064],
              [-117.041678, 47.72271],
              [-117.042135, 47.7441],
              [-117.042059, 47.7451],
              [-117.042657, 47.760857],
              [-117.042623, 47.761223],
              [-117.042521, 47.764896],
              [-117.042485, 47.766525],
              [-117.041874, 47.977387],
              [-117.041676, 48.04556],
              [-117.041401, 48.0855],
              [-117.039552, 48.17396],
              [-117.039413, 48.17725],
              [-117.039618, 48.178142],
              [-117.039583, 48.180313],
              [-117.039582, 48.180853],
              [-117.039582, 48.181124],
              [-117.039615, 48.184015],
              [-117.039599, 48.184387],
              [-117.035178, 48.370878],
              [-117.035178, 48.371221],
              [-117.035289, 48.422732],
              [-117.035254, 48.423144],
              [-117.035285, 48.429816],
              [-117.035285, 48.430113],
              [-117.034499, 48.620769],
              [-117.034358, 48.628523],
              [-117.033177, 48.846563],
              [-117.032351, 48.999188],
              [-117.268247, 48.999818],
              [-117.268192, 48.999928],
              [-117.429539, 48.999957],
              [-118.196891, 49.000094],
              [-118.836794, 49.000209],
              [-119.132102, 49.000262],
              [-119.137274, 49.000297],
              [-119.428678, 49.000253],
              [-119.4577, 49.000261],
              [-119.701218, 49.000258],
              [-119.702016, 49.000269],
              [-120.851202, 49.001191],
              [-121.12624, 49.001412],
              [-121.751252, 48.997399],
              [-122.098357, 49.002146],
              [-122.405989, 49.002239],
              [-122.407829, 49.002193],
              [-122.75802, 49.002357],
              [-122.756037, 48.999512],
              [-122.756318, 48.996881],
              [-122.766307, 48.991672],
              [-122.774276, 48.991038],
              [-122.796887, 48.975026],
              [-122.817226, 48.95597],
              [-122.822464, 48.944911],
              [-122.821631, 48.941369],
              [-122.818232, 48.939062],
              [-122.787539, 48.931702],
              [-122.770432, 48.942528],
              [-122.766096, 48.941955],
              [-122.755624, 48.93866],
              [-122.746596, 48.930731],
              [-122.745371, 48.921227],
              [-122.747514, 48.915582],
              [-122.751289, 48.911239],
              [-122.783747, 48.894639],
              [-122.792584, 48.894732],
              [-122.793175, 48.892927],
              [-122.785659, 48.885066],
              [-122.722685, 48.852855],
              [-122.717073, 48.84719],
              [-122.711805, 48.832408],
              [-122.709169, 48.817829],
              [-122.7112, 48.79146],
              [-122.709815, 48.786205],
              [-122.703106, 48.786321],
              [-122.699303, 48.789063],
              [-122.699507, 48.794906],
              [-122.698675, 48.800522],
              [-122.697219, 48.80281],
              [-122.693683, 48.804475],
              [-122.680246, 48.80275],
              [-122.659708, 48.786523],
              [-122.656528, 48.784969],
              [-122.646777, 48.785011],
              [-122.645743, 48.781538],
              [-122.647443, 48.773998],
              [-122.661111, 48.753962],
              [-122.666953, 48.748445],
              [-122.673472, 48.733082],
              [-122.646323, 48.708001],
              [-122.630422, 48.696625],
              [-122.620338, 48.693651],
              [-122.615169, 48.693839],
              [-122.606105, 48.698556],
              [-122.605733, 48.701066],
              [-122.612562, 48.714932],
              [-122.626287, 48.72093],
              [-122.638082, 48.732486],
              [-122.637146, 48.735708],
              [-122.627808, 48.74466],
              [-122.606787, 48.759143],
              [-122.598033, 48.769489],
              [-122.596844, 48.771492],
              [-122.567498, 48.779185],
              [-122.535803, 48.776128],
              [-122.528203, 48.768428],
              [-122.510902, 48.757728],
              [-122.490401, 48.751128],
              [-122.495301, 48.737328],
              [-122.505684, 48.724524],
              [-122.515511, 48.720992],
              [-122.519172, 48.713095],
              [-122.506718, 48.669692],
              [-122.500308, 48.656163],
              [-122.49399, 48.651596],
              [-122.488754, 48.645358],
              [-122.486878, 48.643122],
              [-122.46425, 48.625717],
              [-122.448702, 48.622624],
              [-122.425271, 48.599522],
              [-122.433059, 48.581609],
              [-122.44456, 48.570115],
              [-122.478431, 48.559303],
              [-122.482406, 48.559653],
              [-122.488421, 48.564665],
              [-122.495904, 48.575927],
              [-122.512372, 48.578067],
              [-122.534787, 48.57596],
              [-122.534719, 48.574246],
              [-122.531978, 48.568644],
              [-122.52537, 48.567344],
              [-122.504428, 48.564775],
              [-122.498463, 48.556206],
              [-122.485288, 48.528106],
              [-122.483872, 48.521891],
              [-122.484996, 48.50962],
              [-122.483501, 48.49243],
              [-122.478851, 48.481736],
              [-122.473763, 48.47975],
              [-122.46967, 48.474975],
              [-122.469634, 48.472187],
              [-122.471832, 48.470724],
              [-122.500721, 48.460887],
              [-122.511348, 48.461825],
              [-122.515056, 48.465554],
              [-122.526943, 48.468004],
              [-122.532845, 48.466057],
              [-122.537355, 48.466749],
              [-122.556834, 48.498812],
              [-122.568071, 48.50821],
              [-122.598469, 48.512169],
              [-122.599951, 48.520946],
              [-122.606961, 48.522152],
              [-122.615183, 48.521427],
              [-122.671386, 48.50398],
              [-122.676922, 48.504484],
              [-122.679122, 48.507797],
              [-122.684521, 48.509123],
              [-122.701644, 48.497622],
              [-122.712981, 48.47879],
              [-122.712322, 48.464143],
              [-122.710362, 48.461584],
              [-122.700603, 48.457632],
              [-122.695587, 48.460558],
              [-122.695725, 48.464785],
              [-122.689121, 48.476849],
              [-122.664623, 48.478128],
              [-122.657753, 48.47294],
              [-122.654844, 48.454087],
              [-122.667249, 48.442503],
              [-122.674085, 48.441979],
              [-122.674188, 48.443327],
              [-122.677072, 48.444059],
              [-122.678928, 48.439466],
              [-122.674158, 48.424726],
              [-122.665338, 48.416453],
              [-122.649839, 48.408526],
              [-122.61448, 48.41488],
              [-122.581607, 48.429244],
              [-122.575254, 48.443333],
              [-122.568348, 48.44499],
              [-122.557298, 48.444438],
              [-122.551221, 48.439465],
              [-122.558403, 48.426758],
              [-122.554536, 48.40604],
              [-122.547492, 48.399889],
              [-122.539449, 48.39719],
              [-122.533452, 48.383409],
              [-122.507437, 48.364666],
              [-122.497686, 48.361837],
              [-122.482423, 48.361737],
              [-122.475529, 48.359912],
              [-122.442678, 48.337934],
              [-122.424102, 48.334346],
              [-122.408718, 48.326413],
              [-122.38431, 48.304123],
              [-122.37821, 48.29759],
              [-122.376818, 48.296099],
              [-122.371693, 48.287839],
              [-122.392058, 48.269628],
              [-122.395328, 48.257187],
              [-122.405757, 48.252193],
              [-122.406516, 48.25183],
              [-122.463962, 48.270541],
              [-122.466803, 48.269604],
              [-122.474494, 48.255227],
              [-122.480925, 48.251706],
              [-122.493448, 48.252043],
              [-122.497727, 48.253389],
              [-122.499648, 48.256611],
              [-122.503786, 48.257045],
              [-122.530996, 48.249821],
              [-122.535209, 48.240213],
              [-122.534431, 48.223005],
              [-122.538916, 48.209683],
              [-122.53722, 48.183745],
              [-122.522576, 48.161712],
              [-122.512031, 48.133931],
              [-122.489986, 48.120617],
              [-122.486736, 48.12095],
              [-122.477983, 48.129048],
              [-122.4675, 48.130353],
              [-122.44966, 48.114041],
              [-122.423703, 48.102941],
              [-122.400692, 48.085255],
              [-122.393413, 48.078472],
              [-122.390787, 48.069477],
              [-122.38769, 48.065189],
              [-122.377114, 48.057568],
              [-122.363107, 48.054546],
              [-122.358375, 48.056133],
              [-122.360345, 48.061527],
              [-122.379481, 48.087384],
              [-122.411649, 48.11321],
              [-122.442383, 48.130841],
              [-122.475803, 48.166792],
              [-122.479008, 48.175703],
              [-122.478535, 48.188087],
              [-122.47025, 48.194007],
              [-122.464801, 48.194767],
              [-122.461888, 48.193137],
              [-122.45493, 48.196639],
              [-122.442051, 48.20935],
              [-122.441731, 48.211776],
              [-122.444508, 48.214522],
              [-122.449513, 48.214736],
              [-122.453618, 48.22683],
              [-122.45371, 48.228859],
              [-122.449605, 48.232598],
              [-122.433767, 48.23655],
              [-122.430578, 48.236237],
              [-122.425572, 48.232887],
              [-122.396121, 48.229233],
              [-122.395499, 48.228551],
              [-122.385703, 48.217811],
              [-122.382102, 48.207106],
              [-122.372492, 48.193022],
              [-122.362044, 48.187568],
              [-122.363479, 48.174438],
              [-122.370253, 48.164809],
              [-122.364744, 48.151304],
              [-122.363797, 48.142759],
              [-122.365078, 48.125822],
              [-122.363842, 48.12393],
              [-122.343241, 48.097631],
              [-122.326119, 48.092877],
              [-122.321709, 48.085507],
              [-122.305838, 48.073415],
              [-122.281087, 48.049793],
              [-122.231761, 48.029876],
              [-122.224979, 48.016626],
              [-122.228767, 48.012468],
              [-122.23022, 48.007154],
              [-122.232391, 47.987713],
              [-122.226346, 47.976417],
              [-122.230046, 47.970917],
              [-122.249007, 47.959507],
              [-122.278047, 47.956517],
              [-122.307048, 47.949117],
              [-122.311148, 47.936717],
              [-122.309747, 47.929117],
              [-122.310747, 47.925117],
              [-122.311927, 47.923703],
              [-122.321847, 47.911817],
              [-122.328546, 47.897917],
              [-122.333543, 47.880246],
              [-122.330145, 47.875318],
              [-122.329545, 47.869418],
              [-122.33595, 47.852306],
              [-122.339944, 47.846718],
              [-122.346544, 47.842418],
              [-122.353244, 47.840618],
              [-122.392044, 47.807718],
              [-122.394944, 47.803318],
              [-122.397043, 47.779719],
              [-122.396422, 47.777927],
              [-122.394442, 47.772219],
              [-122.380241, 47.758519],
              [-122.382641, 47.749119],
              [-122.37314, 47.729219],
              [-122.375607, 47.719724],
              [-122.37644, 47.716519],
              [-122.38044, 47.709119],
              [-122.393248, 47.701602],
              [-122.403841, 47.689419],
              [-122.407841, 47.680119],
              [-122.429841, 47.658919],
              [-122.414645, 47.639766],
              [-122.40424, 47.63392],
              [-122.393739, 47.63102],
              [-122.386039, 47.63172],
              [-122.367819, 47.624213],
              [-122.344937, 47.60912],
              [-122.339513, 47.599113],
              [-122.342937, 47.59122],
              [-122.358238, 47.58482],
              [-122.370167, 47.583087],
              [-122.375421, 47.585181],
              [-122.387139, 47.59572],
              [-122.401839, 47.58392],
              [-122.421139, 47.57602],
              [-122.409839, 47.56892],
              [-122.398338, 47.55012],
              [-122.393938, 47.52482],
              [-122.396538, 47.51522],
              [-122.386637, 47.50222],
              [-122.365236, 47.48842],
              [-122.361336, 47.481421],
              [-122.363062, 47.475702],
              [-122.368036, 47.459221],
              [-122.383136, 47.450521],
              [-122.367036, 47.447621],
              [-122.355135, 47.441921],
              [-122.348035, 47.415921],
              [-122.335234, 47.408421],
              [-122.328434, 47.400621],
              [-122.325734, 47.391521],
              [-122.324833, 47.348521],
              [-122.336934, 47.341421],
              [-122.364168, 47.335953],
              [-122.418268, 47.320614],
              [-122.423535, 47.319121],
              [-122.443008, 47.306333],
              [-122.444635, 47.300421],
              [-122.432335, 47.296021],
              [-122.424235, 47.297521],
              [-122.413735, 47.293921],
              [-122.409199, 47.288556],
              [-122.418074, 47.281765],
              [-122.429605, 47.269707],
              [-122.437727, 47.268046],
              [-122.4442, 47.266723],
              [-122.471652, 47.277321],
              [-122.533338, 47.31662],
              [-122.540238, 47.31852],
              [-122.547408, 47.317734],
              [-122.547747, 47.316403],
              [-122.571239, 47.315619],
              [-122.573739, 47.318419],
              [-122.575985, 47.32642],
              [-122.57134, 47.327219],
              [-122.55584, 47.347519],
              [-122.551536, 47.35954],
              [-122.537935, 47.359203],
              [-122.52603, 47.358908],
              [-122.528129, 47.345542],
              [-122.52416, 47.33837],
              [-122.51885, 47.33332],
              [-122.504918, 47.33068],
              [-122.493123, 47.330253],
              [-122.491063, 47.332427],
              [-122.491237, 47.335172],
              [-122.469703, 47.344623],
              [-122.457494, 47.342567],
              [-122.453998, 47.343337],
              [-122.448399, 47.354987],
              [-122.437809, 47.365607],
              [-122.401768, 47.381325],
              [-122.378482, 47.38533],
              [-122.373629, 47.388718],
              [-122.395054, 47.399277],
              [-122.427327, 47.402129],
              [-122.437657, 47.407424],
              [-122.440083, 47.417647],
              [-122.43984, 47.458083],
              [-122.433386, 47.46643],
              [-122.460029, 47.486861],
              [-122.460503, 47.494773],
              [-122.452399, 47.503471],
              [-122.467796, 47.509956],
              [-122.484993, 47.512731],
              [-122.494882, 47.510265],
              [-122.500543, 47.51528],
              [-122.52305, 47.524],
              [-122.532909, 47.522184],
              [-122.546611, 47.52355],
              [-122.547207, 47.528257],
              [-122.542355, 47.53784],
              [-122.543118, 47.556326],
              [-122.534664, 47.566122],
              [-122.529915, 47.568441],
              [-122.518367, 47.57408],
              [-122.503672, 47.575178],
              [-122.479089, 47.583654],
              [-122.483805, 47.586721],
              [-122.493933, 47.588963],
              [-122.49824, 47.598242],
              [-122.500357, 47.617816],
              [-122.494518, 47.623625],
              [-122.492809, 47.629591],
              [-122.493205, 47.635122],
              [-122.502116, 47.639074],
              [-122.518277, 47.65132],
              [-122.508709, 47.670843],
              [-122.504452, 47.685888],
              [-122.504604, 47.699136],
              [-122.511196, 47.708715],
              [-122.523962, 47.708034],
              [-122.525851, 47.705095],
              [-122.53094, 47.704814],
              [-122.543161, 47.710941],
              [-122.554454, 47.745704],
              [-122.537318, 47.74714],
              [-122.519325, 47.74622],
              [-122.515193, 47.743911],
              [-122.507638, 47.74304],
              [-122.488491, 47.743605],
              [-122.477344, 47.746019],
              [-122.471844, 47.749819],
              [-122.470333, 47.757109],
              [-122.471402, 47.765965],
              [-122.495458, 47.786692],
              [-122.495346, 47.79704],
              [-122.485214, 47.804128],
              [-122.482437, 47.809255],
              [-122.482529, 47.815511],
              [-122.502224, 47.826395],
              [-122.506122, 47.831745],
              [-122.512778, 47.863879],
              [-122.513986, 47.880807],
              [-122.527593, 47.905882],
              [-122.549072, 47.919072],
              [-122.581846, 47.920282],
              [-122.592184, 47.922519],
              [-122.601507, 47.931726],
              [-122.603861, 47.940478],
              [-122.611956, 47.940772],
              [-122.617022, 47.938987],
              [-122.620316, 47.931553],
              [-122.616701, 47.925139],
              [-122.596228, 47.92021],
              [-122.588235, 47.912923],
              [-122.586339, 47.902023],
              [-122.573098, 47.874081],
              [-122.573672, 47.857582],
              [-122.608105, 47.856728],
              [-122.614585, 47.850806],
              [-122.623192, 47.836199],
              [-122.648108, 47.825123],
              [-122.682015, 47.800882],
              [-122.684085, 47.798574],
              [-122.690562, 47.778372],
              [-122.714801, 47.768176],
              [-122.719712, 47.760976],
              [-122.722686, 47.748827],
              [-122.733012, 47.737625],
              [-122.740159, 47.736228],
              [-122.749199, 47.741063],
              [-122.758498, 47.746036],
              [-122.757885, 47.757744],
              [-122.75054, 47.773966],
              [-122.748061, 47.800546],
              [-122.731956, 47.809741],
              [-122.719609, 47.813036],
              [-122.688596, 47.831438],
              [-122.683742, 47.838773],
              [-122.681602, 47.850405],
              [-122.690974, 47.860118],
              [-122.69376, 47.868002],
              [-122.666417, 47.867497],
              [-122.650083, 47.86386],
              [-122.63636, 47.866186],
              [-122.633879, 47.868401],
              [-122.631857, 47.874815],
              [-122.610341, 47.887343],
              [-122.618873, 47.890242],
              [-122.637425, 47.889945],
              [-122.646494, 47.894771],
              [-122.655085, 47.905058],
              [-122.65399, 47.91589],
              [-122.651063, 47.920985],
              [-122.657722, 47.931156],
              [-122.66238, 47.9307],
              [-122.681924, 47.936415],
              [-122.68445, 47.939593],
              [-122.684688, 47.944049],
              [-122.676215, 47.958743],
              [-122.6788, 47.96793],
              [-122.683223, 47.972226],
              [-122.701294, 47.972979],
              [-122.718082, 47.987739],
              [-122.723374, 48.008095],
              [-122.70184, 48.016106],
              [-122.697185, 48.014978],
              [-122.690066, 48.00842],
              [-122.686898, 48.008305],
              [-122.669868, 48.017217],
              [-122.668942, 48.032026],
              [-122.677153, 48.036346],
              [-122.682264, 48.042723],
              [-122.69222, 48.087081],
              [-122.69164, 48.096726],
              [-122.68724, 48.101662],
              [-122.698465, 48.103102],
              [-122.718558, 48.097567],
              [-122.733257, 48.091232],
              [-122.748345, 48.072097],
              [-122.747389, 48.070795],
              [-122.741184, 48.070958],
              [-122.739271, 48.069153],
              [-122.740007, 48.054116],
              [-122.74229, 48.049324],
              [-122.766648, 48.04429],
              [-122.770496, 48.047897],
              [-122.770559, 48.053432],
              [-122.801399, 48.087561],
              [-122.798464, 48.092451],
              [-122.792902, 48.09718],
              [-122.778466, 48.106135],
              [-122.773177, 48.106864],
              [-122.748911, 48.117026],
              [-122.760448, 48.14324],
              [-122.784076, 48.142974],
              [-122.833173, 48.134406],
              [-122.876282, 48.110877],
              [-122.882013, 48.100779],
              [-122.878255, 48.076072],
              [-122.857727, 48.065774],
              [-122.849273, 48.053808],
              [-122.877641, 48.047025],
              [-122.918602, 48.058238],
              [-122.926851, 48.064593],
              [-122.927146, 48.065133],
              [-122.927975, 48.06665],
              [-122.926644, 48.0741],
              [-122.920911, 48.088199],
              [-122.917942, 48.091535],
              [-122.929095, 48.096244],
              [-122.946119, 48.098552],
              [-122.979413, 48.09594],
              [-123.004128, 48.090516],
              [-123.016651, 48.08538],
              [-123.038727, 48.081138],
              [-123.050446, 48.102825],
              [-123.06621, 48.120469],
              [-123.085154, 48.127137],
              [-123.116479, 48.150208],
              [-123.124816, 48.153472],
              [-123.131422, 48.152736],
              [-123.143229, 48.156633],
              [-123.139258, 48.16648],
              [-123.132417, 48.174704],
              [-123.133445, 48.177276],
              [-123.144783, 48.175943],
              [-123.1644, 48.165894],
              [-123.191521, 48.143821],
              [-123.21719, 48.127203],
              [-123.239129, 48.118217],
              [-123.248615, 48.115745],
              [-123.268917, 48.116094],
              [-123.280178, 48.117309],
              [-123.288265, 48.121036],
              [-123.314578, 48.113725],
              [-123.332699, 48.11297],
              [-123.360923, 48.115864],
              [-123.395048, 48.114243],
              [-123.424668, 48.118065],
              [-123.441972, 48.124259],
              [-123.439127, 48.141278],
              [-123.440128, 48.142014],
              [-123.455458, 48.140047],
              [-123.473379, 48.134079],
              [-123.507235, 48.131807],
              [-123.52232, 48.135539],
              [-123.534879, 48.14578],
              [-123.551131, 48.151382],
              [-123.560591, 48.150697],
              [-123.574214, 48.140756],
              [-123.590839, 48.134949],
              [-123.628819, 48.139279],
              [-123.641108, 48.146127],
              [-123.636967, 48.150319],
              [-123.651408, 48.156952],
              [-123.672445, 48.162715],
              [-123.702743, 48.166783],
              [-123.706432, 48.165822],
              [-123.706226, 48.1634],
              [-123.71835, 48.158713],
              [-123.725352, 48.159191],
              [-123.72829, 48.160858],
              [-123.728736, 48.1628],
              [-123.756395, 48.161057],
              [-123.778122, 48.155466],
              [-123.831571, 48.157937],
              [-123.858821, 48.154273],
              [-123.866677, 48.154796],
              [-123.880068, 48.160621],
              [-123.915589, 48.159352],
              [-123.934921, 48.16084],
              [-123.955347, 48.165455],
              [-123.981032, 48.164761],
              [-124.050734, 48.177747],
              [-124.072124, 48.189903],
              [-124.090717, 48.196458],
              [-124.107215, 48.200082],
              [-124.101773, 48.216883],
              [-124.110974, 48.220557],
              [-124.14129, 48.227413],
              [-124.192692, 48.246316],
              [-124.217873, 48.253294],
              [-124.238582, 48.262471],
              [-124.250882, 48.264773],
              [-124.252267, 48.261004],
              [-124.255109, 48.258972],
              [-124.265824, 48.254842],
              [-124.272017, 48.25441],
              [-124.295693, 48.259282],
              [-124.297643, 48.260676],
              [-124.296924, 48.261796],
              [-124.295589, 48.262983],
              [-124.299146, 48.268239],
              [-124.342412, 48.277695],
              [-124.361351, 48.287582],
              [-124.380874, 48.284699],
              [-124.395593, 48.288772],
              [-124.414007, 48.300887],
              [-124.510582, 48.343236],
              [-124.525453, 48.349022],
              [-124.538821, 48.349893],
              [-124.546259, 48.353594],
              [-124.564841, 48.367921],
              [-124.572864, 48.366228],
              [-124.590733, 48.373604],
              [-124.597331, 48.381882],
              [-124.599278, 48.381035],
              [-124.611782, 48.378182],
              [-124.631108, 48.376522],
              [-124.639389, 48.385524],
              [-124.653243, 48.390691],
              [-124.694511, 48.389004],
              [-124.716947, 48.389776],
              [-124.725839, 48.386012],
              [-124.731828, 48.381157],
              [-124.730863, 48.3762],
              [-124.727022, 48.371101],
              [-124.713817, 48.366309],
              [-124.696703, 48.349748],
              [-124.670072, 48.341341],
              [-124.65894, 48.331057],
              [-124.662068, 48.31045],
              [-124.665908, 48.299324],
              [-124.669265, 48.296353],
              [-124.676319, 48.295143],
              [-124.680877, 48.26535],
              [-124.684677, 48.255228],
              [-124.699663, 48.245812],
              [-124.70592, 48.239894],
              [-124.705031, 48.238774],
              [-124.690389, 48.219745],
              [-124.6909, 48.212617],
              [-124.696111, 48.198599],
              [-124.704153, 48.184422],
              [-124.731746, 48.169997],
              [-124.733174, 48.163393],
              [-124.731703, 48.160402],
              [-124.721725, 48.153185],
              [-124.695088, 48.114878],
              [-124.687101, 48.098657],
              [-124.688602, 48.092466],
              [-124.695114, 48.087096],
              [-124.696542, 48.069274],
              [-124.693676, 48.058697],
              [-124.688359, 48.054927],
              [-124.685393, 48.049238],
              [-124.682157, 48.035987],
              [-124.679024, 48.015697],
              [-124.67083, 47.982366],
              [-124.672427, 47.964414],
              [-124.662334, 47.951451],
              [-124.651966, 47.943177],
              [-124.645442, 47.935338],
              [-124.629706, 47.896968],
              [-124.630153, 47.892467],
              [-124.625512, 47.887963],
              [-124.610763, 47.880607],
              [-124.609538, 47.879996],
              [-124.588172, 47.877878],
              [-124.562363, 47.866216],
              [-124.559034, 47.863085],
              [-124.558254, 47.855979],
              [-124.539927, 47.836967],
              [-124.51278, 47.822518],
              [-124.50668, 47.82391],
              [-124.497987, 47.822605],
              [-124.489737, 47.816988],
              [-124.482154, 47.797454],
              [-124.47657, 47.769671],
              [-124.471687, 47.766907],
              [-124.453927, 47.765334],
              [-124.430546, 47.746249],
              [-124.425195, 47.738434],
              [-124.420219, 47.725294],
              [-124.412106, 47.691199],
              [-124.395983, 47.665534],
              [-124.382215, 47.632302],
              [-124.374927, 47.603891],
              [-124.371746, 47.599575],
              [-124.366221, 47.582439],
              [-124.359028, 47.547616],
              [-124.355955, 47.545698],
              [-124.353651, 47.53361],
              [-124.345155, 47.48903],
              [-124.336724, 47.415996],
              [-124.32665, 47.388759],
              [-124.324091, 47.367602],
              [-124.319379, 47.355559],
              [-124.307509, 47.352268],
              [-124.299943, 47.34836],
              [-124.293288, 47.339309],
              [-124.286369, 47.325162],
              [-124.271193, 47.305025],
              [-124.257452, 47.304059],
              [-124.25359, 47.30248],
              [-124.242234, 47.295101],
              [-124.236349, 47.287287],
              [-124.209017, 47.218151],
              [-124.195893, 47.174],
              [-124.189725, 47.146827],
              [-124.185806, 47.136017],
              [-124.182802, 47.134041],
              [-124.183833, 47.124807],
              [-124.176745, 47.092999],
              [-124.173501, 47.06637],
              [-124.169113, 46.994508],
              [-124.171161, 46.958443],
              [-124.174503, 46.941623],
              [-124.180111, 46.926357],
              [-124.158624, 46.929439],
              [-124.141267, 46.940266],
              [-124.124386, 46.94387],
              [-124.138035, 46.970959],
              [-124.139733, 46.98837],
              [-124.151288, 47.021112],
              [-124.149043, 47.029294],
              [-124.141517, 47.035142],
              [-124.122057, 47.04165],
              [-124.106378, 47.04264],
              [-124.065856, 47.04114],
              [-124.026345, 47.030187],
              [-124.016999, 47.014848],
              [-124.017035, 47.011717],
              [-124.005248, 47.003915],
              [-124.010068, 46.997882],
              [-124.019727, 46.991189],
              [-124.012218, 46.985176],
              [-123.991612, 46.980215],
              [-123.959185, 46.981759],
              [-123.947996, 46.971818],
              [-123.939214, 46.969739],
              [-123.921617, 46.971864],
              [-123.898245, 46.971927],
              [-123.889402, 46.968904],
              [-123.876136, 46.961054],
              [-123.86018, 46.948556],
              [-123.882884, 46.939946],
              [-123.915256, 46.932964],
              [-123.957493, 46.921261],
              [-123.979378, 46.923038],
              [-123.985082, 46.921916],
              [-124.009519, 46.910325],
              [-124.01366, 46.90363],
              [-124.03624, 46.898473],
              [-124.046344, 46.893972],
              [-124.049279, 46.891253],
              [-124.055085, 46.870429],
              [-124.061051, 46.865127],
              [-124.066349, 46.863504],
              [-124.073113, 46.861493],
              [-124.089286, 46.867716],
              [-124.090422, 46.8955],
              [-124.093392, 46.901168],
              [-124.110641, 46.91252],
              [-124.117712, 46.91238],
              [-124.138225, 46.905534],
              [-124.122979, 46.879809],
              [-124.108078, 46.836388],
              [-124.101232, 46.810656],
              [-124.098359, 46.794157],
              [-124.096655, 46.784374],
              [-124.095041, 46.756812],
              [-124.096515, 46.746202],
              [-124.092176, 46.741624],
              [-124.080983, 46.735003],
              [-124.063117, 46.733664],
              [-124.046399, 46.725686],
              [-124.042111, 46.722783],
              [-124.042478, 46.72004],
              [-124.022413, 46.708973],
              [-124.003458, 46.702337],
              [-123.994242, 46.707929],
              [-123.987521, 46.707507],
              [-123.973663, 46.703353],
              [-123.966886, 46.705184],
              [-123.975157, 46.713971],
              [-123.979655, 46.724658],
              [-123.974994, 46.733391],
              [-123.968564, 46.736106],
              [-123.948683, 46.725369],
              [-123.929073, 46.725278],
              [-123.916874, 46.726739],
              [-123.91285, 46.730647],
              [-123.91584, 46.737322],
              [-123.916371, 46.741322],
              [-123.910716, 46.746715],
              [-123.898641, 46.750205],
              [-123.893054, 46.750204],
              [-123.87668, 46.730657],
              [-123.870782, 46.728327],
              [-123.862149, 46.727749],
              [-123.848725, 46.719898],
              [-123.84621, 46.716795],
              [-123.851356, 46.70256],
              [-123.864902, 46.698685],
              [-123.895601, 46.683672],
              [-123.915596, 46.678649],
              [-123.923269, 46.672708],
              [-123.920916, 46.653576],
              [-123.921913, 46.650262],
              [-123.940616, 46.640862],
              [-123.960642, 46.636364],
              [-123.959175, 46.613581],
              [-123.955556, 46.60357],
              [-123.939139, 46.596326],
              [-123.928861, 46.588875],
              [-123.922332, 46.577057],
              [-123.920247, 46.567343],
              [-123.916902, 46.562633],
              [-123.903321, 46.55191],
              [-123.894254, 46.537028],
              [-123.897242, 46.52848],
              [-123.896703, 46.522665],
              [-123.921192, 46.507731],
              [-123.943667, 46.477197],
              [-123.968044, 46.473497],
              [-123.97083, 46.47537],
              [-123.979213, 46.489949],
              [-123.979053, 46.497378],
              [-123.983688, 46.498542],
              [-123.988386, 46.497008],
              [-123.99268, 46.488617],
              [-123.994181, 46.468868],
              [-123.99087, 46.465738],
              [-123.990615, 46.463019],
              [-124.001271, 46.459992],
              [-124.026032, 46.462978],
              [-124.031737, 46.496375],
              [-124.026019, 46.531589],
              [-124.023148, 46.564113],
              [-124.023566, 46.582559],
              [-124.028799, 46.59104],
              [-124.050842, 46.617421],
              [-124.052708, 46.622796],
              [-124.035874, 46.630822],
              [-124.048444, 46.645827],
              [-124.056476, 46.645645],
              [-124.062715, 46.642582],
              [-124.068655, 46.634879],
              [-124.069583, 46.630651],
              [-124.06842, 46.601397],
              [-124.061953, 46.556165],
              [-124.057024, 46.493338],
              [-124.057425, 46.409315],
              [-124.058351, 46.386503],
              [-124.064624, 46.326899],
              [-124.071384, 46.305504],
              [-124.076262, 46.296498],
              [-124.081729, 46.274714],
              [-124.082187, 46.269159],
              [-124.080671, 46.267239],
              [-124.060961, 46.278761],
              [-124.044018, 46.275925],
              [-124.038797, 46.283675],
              [-124.035599, 46.296843],
              [-124.029924, 46.308312],
              [-124.020551, 46.315737],
              [-124.001264, 46.31326],
              [-123.985204, 46.309039],
              [-123.974509, 46.303063],
              [-123.970355, 46.299352],
              [-123.970912, 46.293866],
              [-123.969427, 46.291398],
              [-123.954353, 46.277001],
              [-123.919581, 46.251217],
              [-123.909306, 46.245491],
              [-123.875525, 46.239787],
              [-123.806139, 46.283588],
              [-123.795556, 46.284501],
              [-123.782654, 46.280227],
              [-123.775054, 46.274599],
              [-123.766682, 46.273499],
              [-123.75956, 46.275073],
              [-123.741478, 46.290274],
              [-123.728585, 46.288725],
              [-123.727913, 46.289661],
              [-123.724038, 46.295058],
              [-123.724273, 46.301161],
              [-123.700764, 46.305278],
              [-123.687763, 46.299235],
              [-123.680574, 46.296025],
              [-123.67876, 46.290721],
              [-123.678069, 46.286469],
              [-123.68008, 46.277943],
              [-123.679125, 46.272502],
              [-123.669501, 46.266832],
              [-123.613544, 46.259988],
              [-123.581642, 46.260502],
              [-123.564405, 46.262172],
              [-123.559923, 46.265098],
              [-123.547636, 46.265595],
              [-123.547659, 46.259109],
              [-123.548194, 46.248245],
              [-123.586205, 46.228654],
              [-123.60019, 46.234814],
              [-123.605487, 46.2393],
              [-123.613459, 46.239228],
              [-123.622812, 46.23664],
              [-123.625219, 46.233868],
              [-123.626247, 46.226434],
              [-123.6325, 46.216681],
              [-123.636474, 46.214359],
              [-123.65539, 46.217974],
              [-123.666751, 46.218228],
              [-123.673831, 46.215418],
              [-123.67538, 46.212401],
              [-123.706667, 46.199665],
              [-123.71278, 46.198751],
              [-123.736747, 46.200687],
              [-123.759976, 46.2073],
              [-123.793936, 46.196283],
              [-123.821834, 46.190293],
              [-123.838801, 46.192211],
              [-123.864209, 46.189527],
              [-123.866643, 46.187674],
              [-123.863347, 46.18235],
              [-123.841521, 46.169824],
              [-123.842849, 46.160529],
              [-123.854801, 46.157342],
              [-123.891186, 46.164778],
              [-123.9042, 46.169293],
              [-123.912405, 46.17945],
              [-123.927038, 46.191617],
              [-123.950148, 46.204097],
              [-123.961739, 46.207916],
              [-123.982149, 46.209662],
              [-123.987196, 46.211521],
              [-123.990117, 46.21763],
              [-123.988429, 46.224132],
              [-123.998052, 46.235327],
              [-124.001998, 46.237316],
              [-124.011355, 46.236223],
              [-124.024305, 46.229256],
              [-124.010344, 46.223514],
              [-123.996766, 46.20399],
              [-123.974124, 46.168798],
              [-123.95919, 46.141675],
              [-123.947531, 46.116131],
              [-123.933366, 46.071672],
              [-123.92933, 46.041978],
              [-123.927891, 46.009564],
              [-123.937471, 45.977306],
              [-123.941831, 45.97566],
              [-123.957438, 45.974469],
              [-123.969991, 45.969139],
              [-123.993703, 45.946431],
              [-123.99304, 45.938842],
              [-123.979501, 45.930389],
              [-123.96763, 45.907807],
              [-123.962736, 45.869974],
              [-123.961544, 45.837101],
              [-123.96934, 45.783197],
              [-123.969459, 45.782371],
              [-123.981864, 45.768285],
              [-123.982578, 45.761815],
              [-123.968563, 45.757019],
              [-123.946027, 45.733249],
              [-123.943121, 45.727031],
              [-123.939448, 45.708795],
              [-123.939005, 45.661923],
              [-123.951246, 45.585775],
              [-123.956711, 45.571303],
              [-123.947556, 45.564878],
              [-123.957568, 45.510399],
              [-123.96634, 45.493417],
              [-123.970794, 45.493507],
              [-123.976544, 45.489733],
              [-123.972953, 45.467513],
              [-123.964074, 45.449112],
              [-123.960557, 45.430778],
              [-123.965728, 45.386242],
              [-123.973398, 45.354791],
              [-123.979715, 45.347724],
              [-124.007494, 45.33974],
              [-124.007756, 45.336813],
              [-123.978671, 45.338854],
              [-123.972899, 45.33689],
              [-123.964169, 45.317026],
              [-123.962887, 45.280218],
              [-123.972919, 45.216784],
              [-123.968187, 45.201217],
              [-123.975425, 45.145476],
              [-123.989529, 45.094045],
              [-124.004863, 45.084232],
              [-124.006057, 45.084736],
              [-124.012163, 45.076921],
              [-124.015851, 45.064759],
              [-124.017991, 45.049808],
              [-124.00977, 45.047266],
              [-124.004668, 45.048167],
              [-124.004386, 45.046197],
              [-124.004598, 45.044959],
              [-124.015243, 44.982904],
              [-124.023834, 44.949825],
              [-124.025678, 44.936542],
              [-124.025136, 44.928175],
              [-124.032296, 44.900809],
              [-124.048814, 44.850007],
              [-124.054151, 44.838233],
              [-124.063155, 44.835333],
              [-124.066746, 44.831191],
              [-124.074066, 44.798107],
              [-124.075473, 44.771403],
              [-124.066325, 44.762671],
              [-124.059077, 44.737656],
              [-124.063406, 44.703177],
              [-124.070394, 44.683514],
              [-124.060043, 44.669361],
              [-124.058281, 44.658866],
              [-124.065008, 44.632504],
              [-124.065202, 44.622445],
              [-124.084476, 44.611056],
              [-124.082326, 44.608861],
              [-124.06914, 44.612979],
              [-124.067251, 44.60804],
              [-124.076387, 44.531214],
              [-124.083601, 44.501123],
              [-124.084429, 44.486927],
              [-124.082061, 44.478171],
              [-124.082113, 44.441518],
              [-124.079301, 44.430863],
              [-124.073941, 44.434481],
              [-124.067569, 44.428582],
              [-124.071706, 44.423662],
              [-124.080989, 44.419728],
              [-124.084401, 44.415611],
              [-124.092101, 44.370388],
              [-124.100587, 44.331926],
              [-124.109556, 44.314545],
              [-124.108088, 44.309926],
              [-124.10907, 44.303707],
              [-124.1152, 44.286486],
              [-124.115849, 44.276277],
              [-124.115953, 44.274641],
              [-124.114869, 44.272721],
              [-124.109744, 44.270597],
              [-124.108945, 44.265475],
              [-124.111054, 44.235071],
              [-124.115671, 44.206554],
              [-124.114424, 44.198164],
              [-124.117006, 44.171913],
              [-124.125824, 44.12613],
              [-124.122406, 44.104442],
              [-124.133547, 44.035845],
              [-124.142704, 43.958182],
              [-124.150267, 43.91085],
              [-124.158684, 43.863504],
              [-124.168392, 43.808903],
              [-124.193455, 43.706085],
              [-124.198275, 43.689481],
              [-124.204888, 43.673976],
              [-124.203028, 43.667825],
              [-124.218876, 43.610319],
              [-124.233534, 43.55713],
              [-124.255609, 43.502172],
              [-124.286896, 43.436296],
              [-124.315012, 43.388389],
              [-124.341587, 43.351337],
              [-124.353332, 43.342667],
              [-124.373037, 43.338953],
              [-124.387642, 43.325968],
              [-124.402814, 43.305872],
              [-124.400404, 43.302121],
              [-124.393988, 43.29926],
              [-124.388891, 43.290523],
              [-124.38246, 43.270167],
              [-124.395607, 43.223908],
              [-124.395302, 43.211101],
              [-124.401726, 43.184896],
              [-124.424113, 43.126859],
              [-124.434451, 43.115986],
              [-124.432236, 43.097383],
              [-124.436198, 43.071312],
              [-124.456918, 43.000315],
              [-124.462619, 42.99143],
              [-124.479344, 42.95497],
              [-124.480938, 42.951495],
              [-124.500141, 42.917502],
              [-124.552441, 42.840568],
              [-124.544179, 42.822958],
              [-124.536073, 42.814175],
              [-124.524439, 42.789793],
              [-124.516236, 42.753632],
              [-124.514669, 42.736806],
              [-124.513368, 42.735068],
              [-124.510017, 42.734746],
              [-124.499122, 42.738606],
              [-124.498473, 42.741077],
              [-124.491679, 42.741789],
              [-124.473864, 42.732671],
              [-124.448418, 42.689909],
              [-124.447487, 42.68474],
              [-124.451484, 42.677787],
              [-124.45074, 42.675798],
              [-124.416774, 42.661594],
              [-124.413119, 42.657934],
              [-124.401177, 42.627192],
              [-124.399421, 42.618079],
              [-124.400918, 42.597518],
              [-124.389977, 42.574758],
              [-124.390664, 42.566593],
              [-124.399065, 42.539928],
              [-124.421381, 42.491737],
              [-124.423084, 42.478952],
              [-124.422038, 42.461226],
              [-124.435105, 42.440163],
              [-124.434882, 42.434916],
              [-124.428068, 42.420333],
              [-124.424863, 42.395426],
              [-124.424066, 42.377242],
              [-124.425554, 42.351874],
              [-124.427222, 42.33488],
              [-124.429288, 42.331746],
              [-124.410556, 42.307431],
              [-124.405148, 42.278107],
              [-124.408514, 42.260588],
              [-124.411534, 42.254115],
              [-124.410982, 42.250547],
              [-124.383633, 42.22716],
              [-124.377762, 42.218809],
              [-124.375553, 42.20882],
              [-124.376215, 42.196381],
              [-124.374949, 42.193129],
              [-124.373175, 42.190218],
              [-124.367751, 42.188321],
              [-124.361009, 42.180752],
              [-124.360318, 42.162272],
              [-124.363389, 42.158588],
              [-124.366832, 42.15845],
              [-124.366028, 42.152343],
              [-124.361563, 42.143767],
              [-124.355696, 42.141964],
              [-124.351784, 42.134965],
              [-124.351535, 42.129796],
              [-124.357122, 42.118016],
              [-124.356229, 42.114952],
              [-124.34101, 42.092929],
              [-124.314289, 42.067864],
              [-124.299649, 42.051736],
              [-124.287374, 42.046016],
              [-124.270464, 42.045553],
              [-124.214213, 42.005939],
              [-124.211605, 41.99846],
              [-124.204948, 41.983441],
              [-124.203402, 41.940964],
              [-124.208439, 41.888192],
              [-124.219592, 41.846432],
              [-124.230678, 41.818681],
              [-124.245027, 41.7923],
              [-124.255994, 41.783014],
              [-124.248704, 41.771459],
              [-124.242288, 41.772034],
              [-124.23972, 41.7708],
              [-124.203843, 41.747035],
              [-124.194953, 41.736778],
              [-124.19104, 41.736079],
              [-124.185363, 41.739351],
              [-124.17739, 41.745756],
              [-124.164716, 41.740126],
              [-124.154246, 41.728801],
              [-124.147412, 41.717955],
              [-124.143479, 41.709284],
              [-124.138373, 41.678881],
              [-124.139354, 41.671652],
              [-124.135552, 41.657307],
              [-124.120225, 41.640354],
              [-124.116037, 41.628849],
              [-124.114413, 41.616768],
              [-124.100961, 41.602499],
              [-124.097385, 41.585251],
              [-124.101403, 41.578524],
              [-124.101123, 41.569192],
              [-124.092404, 41.553615],
              [-124.081987, 41.547761],
              [-124.081427, 41.511228],
              [-124.075917, 41.501757],
              [-124.066057, 41.470258],
              [-124.065521, 41.464739],
              [-124.063076, 41.439579],
              [-124.072294, 41.374844],
              [-124.079015, 41.347135],
              [-124.092284, 41.287695],
              [-124.106389, 41.240682],
              [-124.106986, 41.229678],
              [-124.122677, 41.189726],
              [-124.1438, 41.144686],
              [-124.149674, 41.140845],
              [-124.158539, 41.143021],
              [-124.163988, 41.138675],
              [-124.165414, 41.129822],
              [-124.159065, 41.121957],
              [-124.160556, 41.099011],
              [-124.154513, 41.087159],
              [-124.154028, 41.059923],
              [-124.153622, 41.05355],
              [-124.151266, 41.051101],
              [-124.148939, 41.051467],
              [-124.147216, 41.052884],
              [-124.142867, 41.054032],
              [-124.138217, 41.054342],
              [-124.132946, 41.052482],
              [-124.125448, 41.048504],
              [-124.112165, 41.028173],
              [-124.118147, 40.989263],
              [-124.137066, 40.925732],
              [-124.158322, 40.876069],
              [-124.176715, 40.843618],
              [-124.201921, 40.805111],
              [-124.228244, 40.76939],
              [-124.248406, 40.735166],
              [-124.289119, 40.67963],
              [-124.312558, 40.641333],
              [-124.315141, 40.639526],
              [-124.329404, 40.61643],
              [-124.363545, 40.548698],
              [-124.379096, 40.522865],
              [-124.382816, 40.519],
              [-124.387023, 40.504954],
              [-124.383224, 40.499852],
              [-124.38494, 40.48982],
              [-124.396642, 40.462119],
              [-124.408601, 40.443201],
              [-124.409591, 40.438076],
              [-124.402623, 40.422105],
              [-124.391496, 40.407047],
              [-124.379082, 40.398828],
              [-124.373599, 40.392923],
              [-124.365357, 40.374855],
              [-124.362796, 40.350046],
              [-124.356595, 40.335016],
              [-124.353124, 40.331425],
              [-124.347853, 40.314634],
              [-124.363634, 40.276212],
              [-124.363414, 40.260974],
              [-124.352715, 40.250453],
              [-124.34307, 40.243979],
              [-124.327691, 40.23737],
              [-124.320912, 40.226617],
              [-124.296497, 40.208816],
              [-124.258405, 40.184277],
              [-124.231095, 40.171581],
              [-124.214895, 40.160902],
              [-124.187874, 40.130542],
              [-124.170767, 40.124207],
              [-124.139952, 40.11635],
              [-124.110549, 40.103765],
              [-124.087086, 40.078442],
              [-124.080709, 40.06611],
              [-124.079983, 40.029773],
              [-124.072509, 40.022657],
              [-124.068908, 40.021307],
              [-124.065069, 40.024785],
              [-124.056408, 40.024305],
              [-124.035904, 40.013319],
              [-124.023938, 40.001284],
              [-123.99586, 39.973045],
              [-123.980031, 39.962458],
              [-123.962655, 39.937635],
              [-123.954952, 39.922373],
              [-123.930047, 39.909697],
              [-123.915853, 39.881114],
              [-123.915142, 39.875313],
              [-123.907664, 39.863028],
              [-123.881458, 39.845422],
              [-123.853764, 39.8341],
              [-123.851714, 39.832041],
              [-123.839797, 39.795637],
              [-123.83715, 39.776232],
              [-123.838089, 39.752409],
              [-123.835092, 39.738768],
              [-123.831599, 39.730629],
              [-123.829545, 39.723071],
              [-123.824744, 39.718128],
              [-123.808208, 39.710715],
              [-123.792659, 39.684122],
              [-123.78636, 39.659932],
              [-123.782322, 39.621486],
              [-123.78354, 39.609517],
              [-123.787417, 39.604552],
              [-123.76721, 39.559852],
              [-123.766475, 39.552803],
              [-123.778521, 39.521478],
              [-123.78417, 39.509419],
              [-123.795639, 39.492215],
              [-123.81469, 39.446538],
              [-123.821887, 39.406809],
              [-123.822325, 39.379987],
              [-123.826306, 39.36871],
              [-123.825331, 39.360814],
              [-123.822085, 39.343857],
              [-123.817369, 39.3388],
              [-123.808772, 39.324368],
              [-123.811387, 39.312825],
              [-123.803081, 39.291747],
              [-123.801757, 39.28353],
              [-123.803848, 39.278771],
              [-123.798991, 39.271355],
              [-123.787893, 39.264327],
              [-123.777368, 39.237214],
              [-123.774998, 39.212083],
              [-123.765891, 39.193657],
              [-123.76101, 39.191595],
              [-123.742221, 39.164885],
              [-123.737913, 39.143442],
              [-123.735936, 39.139644],
              [-123.721505, 39.125327],
              [-123.713392, 39.108422],
              [-123.693969, 39.057363],
              [-123.690095, 39.031157],
              [-123.69074, 39.021293],
              [-123.6969, 39.004401],
              [-123.711149, 38.977316],
              [-123.721347, 38.963879],
              [-123.729053, 38.956667],
              [-123.732892, 38.954994],
              [-123.738886, 38.95412],
              [-123.726315, 38.936367],
              [-123.72763, 38.9295],
              [-123.725367, 38.917438],
              [-123.71054, 38.91323],
              [-123.688099, 38.893594],
              [-123.659846, 38.872529],
              [-123.654696, 38.865638],
              [-123.652212, 38.854582],
              [-123.647387, 38.845472],
              [-123.642676, 38.844005],
              [-123.638637, 38.843865],
              [-123.605317, 38.822765],
              [-123.601569, 38.81899],
              [-123.600221, 38.814115],
              [-123.58638, 38.802857],
              [-123.579856, 38.802835],
              [-123.571987, 38.798189],
              [-123.541837, 38.776764],
              [-123.533535, 38.768408],
              [-123.525152, 38.753801],
              [-123.514784, 38.741966],
              [-123.490021, 38.732213],
              [-123.461291, 38.717001],
              [-123.441774, 38.699744],
              [-123.43272, 38.687131],
              [-123.405663, 38.656729],
              [-123.40301, 38.649449],
              [-123.398166, 38.647044],
              [-123.379303, 38.621953],
              [-123.371876, 38.607235],
              [-123.349612, 38.596805],
              [-123.343338, 38.590008],
              [-123.331899, 38.565542],
              [-123.297151, 38.543452],
              [-123.287156, 38.540223],
              [-123.249797, 38.511045],
              [-123.202277, 38.494314],
              [-123.166428, 38.474947],
              [-123.145325, 38.459422],
              [-123.128825, 38.450418],
              [-123.122379, 38.437314],
              [-123.103706, 38.415541],
              [-123.085572, 38.390525],
              [-123.068265, 38.359865],
              [-123.068437, 38.33521],
              [-123.074684, 38.322574],
              [-123.063671, 38.302178],
              [-123.058239, 38.298355],
              [-123.053504, 38.299385],
              [-123.052021, 38.302246],
              [-123.053476, 38.305722],
              [-123.051061, 38.310693],
              [-123.038742, 38.313576],
              [-123.024333, 38.310573],
              [-123.004122, 38.297012],
              [-123.002911, 38.295708],
              [-122.997106, 38.289458],
              [-122.994603, 38.283096],
              [-122.986319, 38.273164],
              [-122.977082, 38.267902],
              [-122.967203, 38.250691],
              [-122.968569, 38.242879],
              [-122.987149, 38.237538],
              [-122.993235, 38.239686],
              [-122.993959, 38.237602],
              [-122.991953, 38.233185],
              [-122.968112, 38.202428],
              [-122.96637, 38.198514],
              [-122.965408, 38.187113],
              [-122.953629, 38.17567],
              [-122.949626, 38.164041],
              [-122.949074, 38.15406],
              [-122.952086, 38.138562],
              [-122.960889, 38.112962],
              [-122.99242, 38.041758],
              [-123.011533, 38.003438],
              [-123.016303, 38.001691],
              [-123.020562, 37.999544],
              [-123.024066, 37.994878],
              [-122.97439, 37.992429],
              [-122.976764, 37.99568],
              [-122.980147, 38.000831],
              [-122.982386, 38.004274],
              [-122.981776, 38.009119],
              [-122.972378, 38.020247],
              [-122.956811, 38.02872],
              [-122.939711, 38.031908],
              [-122.882114, 38.025273],
              [-122.856573, 38.016717],
              [-122.821383, 37.996735],
              [-122.797405, 37.976657],
              [-122.791739, 37.969422],
              [-122.783244, 37.951334],
              [-122.766138, 37.938004],
              [-122.754606, 37.935527],
              [-122.736898, 37.925825],
              [-122.732898, 37.920225],
              [-122.727297, 37.904626],
              [-122.70264, 37.89382],
              [-122.693569, 37.901171],
              [-122.682171, 37.90645],
              [-122.678474, 37.906604],
              [-122.656519, 37.904519],
              [-122.639977, 37.897349],
              [-122.627113, 37.88608],
              [-122.60129, 37.875126],
              [-122.584289, 37.859227],
              [-122.561487, 37.851827],
              [-122.548986, 37.836227],
              [-122.537285, 37.830328],
              [-122.523585, 37.824828],
              [-122.522836, 37.824717],
              [-122.505383, 37.822128],
              [-122.492474, 37.82484],
              [-122.483483, 37.826728],
              [-122.47986, 37.825641],
              [-122.479151, 37.825428],
              [-122.476473, 37.832513],
              [-122.476536, 37.832812],
              [-122.483102, 37.863957],
              [-122.483429, 37.868866],
              [-122.480811, 37.873448],
              [-122.474266, 37.874429],
              [-122.462158, 37.868866],
              [-122.45005, 37.871157],
              [-122.438268, 37.880974],
              [-122.43925, 37.88392],
              [-122.448413, 37.89341],
              [-122.458558, 37.894064],
              [-122.472303, 37.902573],
              [-122.471975, 37.910427],
              [-122.478193, 37.918608],
              [-122.486375, 37.921881],
              [-122.493574, 37.921881],
              [-122.503064, 37.928753],
              [-122.503064, 37.936607],
              [-122.499465, 37.939225],
              [-122.48572, 37.937589],
              [-122.479175, 37.941516],
              [-122.480484, 37.945443],
              [-122.487684, 37.948716],
              [-122.490302, 37.959188],
              [-122.490302, 37.964751],
              [-122.488665, 37.966714],
              [-122.471975, 37.981768],
              [-122.462485, 37.981441],
              [-122.456595, 37.978823],
              [-122.448413, 37.984713],
              [-122.448413, 37.988313],
              [-122.452995, 37.996167],
              [-122.462812, 38.003367],
              [-122.481466, 38.007621],
              [-122.494556, 38.015148],
              [-122.497828, 38.019402],
              [-122.499465, 38.032165],
              [-122.492265, 38.056381],
              [-122.483757, 38.071762],
              [-122.486702, 38.090088],
              [-122.489974, 38.096961],
              [-122.491283, 38.108087],
              [-122.490727, 38.109755],
              [-122.489974, 38.112014],
              [-122.484411, 38.11496],
              [-122.454958, 38.118887],
              [-122.450377, 38.116269],
              [-122.439577, 38.116923],
              [-122.409798, 38.136231],
              [-122.40358, 38.15063],
              [-122.403514, 38.150624],
              [-122.39638, 38.149976],
              [-122.366273, 38.141467],
              [-122.314567, 38.115287],
              [-122.301804, 38.105142],
              [-122.282824, 38.082889],
              [-122.273006, 38.07438],
              [-122.266669, 38.06007],
              [-122.262861, 38.051473],
              [-122.262861, 38.0446],
              [-122.283478, 38.022674],
              [-122.300823, 38.010893],
              [-122.315549, 38.013511],
              [-122.321112, 38.012857],
              [-122.331912, 38.00533],
              [-122.340093, 38.003694],
              [-122.359493, 38.009941],
              [-122.363655, 38.014166],
              [-122.367909, 38.01253],
              [-122.368891, 38.007948],
              [-122.366928, 37.998458],
              [-122.363001, 37.994375],
              [-122.361905, 37.989991],
              [-122.367582, 37.978168],
              [-122.399832, 37.956009],
              [-122.408383, 37.957544],
              [-122.411761, 37.960497],
              [-122.415361, 37.963115],
              [-122.42976, 37.965405],
              [-122.430087, 37.963115],
              [-122.417371, 37.943513],
              [-122.413725, 37.937262],
              [-122.401289, 37.928426],
              [-122.395071, 37.927117],
              [-122.39049, 37.922535],
              [-122.389181, 37.9101],
              [-122.385908, 37.908136],
              [-122.378709, 37.905191],
              [-122.367582, 37.903882],
              [-122.362346, 37.904209],
              [-122.35711, 37.908791],
              [-122.33453, 37.908791],
              [-122.32373, 37.905845],
              [-122.313496, 37.897211],
              [-122.313258, 37.89701],
              [-122.309986, 37.892755],
              [-122.310477, 37.873938],
              [-122.301313, 37.847758],
              [-122.303931, 37.830087],
              [-122.306222, 37.827469],
              [-122.317676, 37.826814],
              [-122.323567, 37.823214],
              [-122.333711, 37.809797],
              [-122.335675, 37.799652],
              [-122.33555, 37.799538],
              [-122.331748, 37.796052],
              [-122.330963, 37.786035],
              [-122.33079, 37.78383],
              [-122.329159, 37.783173],
              [-122.318909, 37.77904],
              [-122.304345, 37.774632],
              [-122.293996, 37.770416],
              [-122.286139, 37.769458],
              [-122.275408, 37.76735],
              [-122.264101, 37.764667],
              [-122.253753, 37.761218],
              [-122.242638, 37.753744],
              [-122.244938, 37.750294],
              [-122.252226, 37.747619],
              [-122.257134, 37.745001],
              [-122.257953, 37.739601],
              [-122.255989, 37.735674],
              [-122.246826, 37.72193],
              [-122.221628, 37.705567],
              [-122.213774, 37.698695],
              [-122.203971, 37.697769],
              [-122.197411, 37.692804],
              [-122.179085, 37.680041],
              [-122.170904, 37.676114],
              [-122.163049, 37.667933],
              [-122.152905, 37.640771],
              [-122.14636, 37.607391],
              [-122.145378, 37.600846],
              [-122.147014, 37.588411],
              [-122.144396, 37.581866],
              [-122.137524, 37.567467],
              [-122.133924, 37.562885],
              [-122.128688, 37.560594],
              [-122.111998, 37.528851],
              [-122.111344, 37.50758],
              [-122.116112, 37.505386],
              [-122.127706, 37.500053],
              [-122.130979, 37.503652],
              [-122.140142, 37.507907],
              [-122.149632, 37.502671],
              [-122.155686, 37.501198],
              [-122.168449, 37.504143],
              [-122.194957, 37.522469],
              [-122.196593, 37.537196],
              [-122.214264, 37.538505],
              [-122.225135, 37.545594],
              [-122.236323, 37.552891],
              [-122.242832, 37.557136],
              [-122.244372, 37.55814],
              [-122.251898, 37.566321],
              [-122.262698, 37.572866],
              [-122.305895, 37.575484],
              [-122.315713, 37.583666],
              [-122.315385, 37.587265],
              [-122.317676, 37.590865],
              [-122.360219, 37.592501],
              [-122.378545, 37.605592],
              [-122.373309, 37.613773],
              [-122.370364, 37.614427],
              [-122.358583, 37.611155],
              [-122.35531, 37.615736],
              [-122.365455, 37.626208],
              [-122.386072, 37.637662],
              [-122.387381, 37.648462],
              [-122.37789, 37.650425],
              [-122.3756, 37.652389],
              [-122.374291, 37.662206],
              [-122.387626, 37.67906],
              [-122.39319, 37.707531],
              [-122.391374, 37.708331],
              [-122.370411, 37.717572],
              [-122.361749, 37.71501],
              [-122.356784, 37.729505],
              [-122.365478, 37.734621],
              [-122.367697, 37.734943],
              [-122.370094, 37.732331],
              [-122.375854, 37.734979],
              [-122.385323, 37.790724],
              [-122.398139, 37.80563],
              [-122.407452, 37.811441],
              [-122.425942, 37.810979],
              [-122.463793, 37.804653],
              [-122.470336, 37.808671],
              [-122.478083, 37.810828],
              [-122.485783, 37.790629],
              [-122.492883, 37.787929],
              [-122.50531, 37.788312],
              [-122.514483, 37.780829],
              [-122.511983, 37.77113],
              [-122.509397, 37.748841],
              [-122.506483, 37.723731],
              [-122.502427, 37.708133],
              [-122.496784, 37.686433],
              [-122.494085, 37.644035],
              [-122.496786, 37.612136],
              [-122.501386, 37.599637],
              [-122.517187, 37.590637],
              [-122.518088, 37.576138],
              [-122.513688, 37.552239],
              [-122.514789, 37.546139],
              [-122.516589, 37.544939],
              [-122.519533, 37.537302],
              [-122.516689, 37.52134],
              [-122.499289, 37.495341],
              [-122.494429, 37.49269],
              [-122.493789, 37.492341],
              [-122.487139, 37.494277],
              [-122.486749, 37.49439],
              [-122.485888, 37.494641],
              [-122.482351, 37.496187],
              [-122.476443, 37.498768],
              [-122.472388, 37.50054],
              [-122.467888, 37.49814],
              [-122.452087, 37.48054],
              [-122.445987, 37.461541],
              [-122.443687, 37.435941],
              [-122.423286, 37.392542],
              [-122.409258, 37.374805],
              [-122.40085, 37.359225],
              [-122.401323, 37.337009],
              [-122.411686, 37.265844],
              [-122.418452, 37.248521],
              [-122.419113, 37.24147],
              [-122.415822, 37.232839],
              [-122.408982, 37.225258],
              [-122.407181, 37.219465],
              [-122.405073, 37.195791],
              [-122.397065, 37.187249],
              [-122.390599, 37.182988],
              [-122.37927, 37.181128],
              [-122.367085, 37.172817],
              [-122.36179, 37.163593],
              [-122.359791, 37.155574],
              [-122.344029, 37.144099],
              [-122.337833, 37.135936],
              [-122.337085, 37.130795],
              [-122.338856, 37.120854],
              [-122.337071, 37.117382],
              [-122.330463, 37.115338],
              [-122.322971, 37.11546],
              [-122.313907, 37.118161],
              [-122.306139, 37.116383],
              [-122.292974, 37.107318],
              [-122.284882, 37.101747],
              [-122.260481, 37.072548],
              [-122.252181, 37.059448],
              [-122.20618, 37.013949],
              [-122.186879, 37.00345],
              [-122.155078, 36.98085],
              [-122.140578, 36.97495],
              [-122.105976, 36.955951],
              [-122.079356, 36.950783],
              [-122.066421, 36.948271],
              [-122.050122, 36.948523],
              [-122.027174, 36.95115],
              [-122.023373, 36.96215],
              [-122.012373, 36.96455],
              [-121.983896, 36.958727],
              [-121.975871, 36.954051],
              [-121.972771, 36.954151],
              [-121.95167, 36.97145],
              [-121.93947, 36.97805],
              [-121.930069, 36.97815],
              [-121.906468, 36.96895],
              [-121.894667, 36.961851],
              [-121.880167, 36.950151],
              [-121.862266, 36.931552],
              [-121.827664, 36.879353],
              [-121.810552, 36.850648],
              [-121.809363, 36.848654],
              [-121.791544, 36.815186],
              [-121.788278, 36.803994],
              [-121.805643, 36.750239],
              [-121.807062, 36.714157],
              [-121.814462, 36.682858],
              [-121.825052, 36.657207],
              [-121.831995, 36.644856],
              [-121.842263, 36.630059],
              [-121.860604, 36.611136],
              [-121.871364, 36.604559],
              [-121.886764, 36.601459],
              [-121.889064, 36.601759],
              [-121.890164, 36.609259],
              [-121.923866, 36.634559],
              [-121.929666, 36.636959],
              [-121.93643, 36.636746],
              [-121.938551, 36.633908],
              [-121.941666, 36.618059],
              [-121.970427, 36.582754],
              [-121.978592, 36.580488],
              [-121.972594, 36.57337],
              [-121.957335, 36.564482],
              [-121.95146, 36.564009],
              [-121.949659, 36.567602],
              [-121.942533, 36.566435],
              [-121.932508, 36.559935],
              [-121.925937, 36.525173],
              [-121.928769, 36.523147],
              [-121.944666, 36.521861],
              [-121.943678, 36.511802],
              [-121.938763, 36.506423],
              [-121.939216, 36.496896],
              [-121.9416, 36.485602],
              [-121.937205, 36.472488],
              [-121.9255, 36.453918],
              [-121.91474, 36.42589],
              [-121.917463, 36.414809],
              [-121.914378, 36.404344],
              [-121.905657, 36.398206],
              [-121.903195, 36.393603],
              [-121.901813, 36.381879],
              [-121.902669, 36.363901],
              [-121.905446, 36.358269],
              [-121.892917, 36.340428],
              [-121.894714, 36.317806],
              [-121.888491, 36.30281],
              [-121.874797, 36.289064],
              [-121.851967, 36.277831],
              [-121.83935, 36.260478],
              [-121.835785, 36.250748],
              [-121.826425, 36.24186],
              [-121.813734, 36.234235],
              [-121.806979, 36.232907],
              [-121.797059, 36.234211],
              [-121.779851, 36.227407],
              [-121.717176, 36.195146],
              [-121.680145, 36.165818],
              [-121.629634, 36.114452],
              [-121.622009, 36.099695],
              [-121.618672, 36.087767],
              [-121.606845, 36.072065],
              [-121.592853, 36.065062],
              [-121.589183, 36.053775],
              [-121.590395, 36.050363],
              [-121.574602, 36.025156],
              [-121.569612, 36.021539],
              [-121.553716, 36.019798],
              [-121.531876, 36.014368],
              [-121.51159, 36.006598],
              [-121.503112, 36.000299],
              [-121.4862, 35.970348],
              [-121.472435, 35.91989],
              [-121.463452, 35.904416],
              [-121.461227, 35.896906],
              [-121.462264, 35.885618],
              [-121.439584, 35.86695],
              [-121.426955, 35.860103],
              [-121.413146, 35.855316],
              [-121.406823, 35.844623],
              [-121.388053, 35.823483],
              [-121.356737, 35.804187],
              [-121.346363, 35.795183],
              [-121.332449, 35.783106],
              [-121.324918, 35.769347],
              [-121.315786, 35.75252],
              [-121.314632, 35.71331],
              [-121.304583, 35.701794],
              [-121.296473, 35.696824],
              [-121.289794, 35.689428],
              [-121.284973, 35.674109],
              [-121.272322, 35.666711],
              [-121.251034, 35.656641],
              [-121.195291, 35.640734],
              [-121.188897, 35.643138],
              [-121.166712, 35.635399],
              [-121.143561, 35.606046],
              [-121.133556, 35.600455],
              [-121.126027, 35.593058],
              [-121.101595, 35.548814],
              [-121.059913, 35.509671],
              [-121.05308, 35.50753],
              [-121.025621, 35.484598],
              [-121.003359, 35.46071],
              [-120.976122, 35.459028],
              [-120.969436, 35.460197],
              [-120.955863, 35.453743],
              [-120.950742, 35.44802],
              [-120.946546, 35.446715],
              [-120.907937, 35.449069],
              [-120.896862, 35.442243],
              [-120.884757, 35.430196],
              [-120.869209, 35.403276],
              [-120.866099, 35.393045],
              [-120.862133, 35.360763],
              [-120.862684, 35.346776],
              [-120.8672, 35.327154],
              [-120.87957, 35.294184],
              [-120.889354, 35.277819],
              [-120.896876, 35.25399],
              [-120.89679, 35.247877],
              [-120.873046, 35.225688],
              [-120.856047, 35.206487],
              [-120.846674, 35.204429],
              [-120.805258, 35.184973],
              [-120.786076, 35.177666],
              [-120.778998, 35.168897],
              [-120.760492, 35.15971],
              [-120.756086, 35.160459],
              [-120.756862, 35.169208],
              [-120.754823, 35.174701],
              [-120.74887, 35.177795],
              [-120.734231, 35.178472],
              [-120.714185, 35.175998],
              [-120.704203, 35.173206],
              [-120.698906, 35.171192],
              [-120.686974, 35.160708],
              [-120.675074, 35.153061],
              [-120.667994, 35.15203],
              [-120.662475, 35.153357],
              [-120.651134, 35.147768],
              [-120.644311, 35.139616],
              [-120.635787, 35.123805],
              [-120.630957, 35.101941],
              [-120.629583, 35.078362],
              [-120.629931, 35.061515],
              [-120.63357, 35.033085],
              [-120.63999, 35.002963],
              [-120.648905, 34.974393],
              [-120.670835, 34.904115],
              [-120.662889, 34.901183],
              [-120.647328, 34.901133],
              [-120.642212, 34.894145],
              [-120.639283, 34.880413],
              [-120.616325, 34.866739],
              [-120.610266, 34.85818],
              [-120.609898, 34.842751],
              [-120.616296, 34.816308],
              [-120.62297, 34.7933],
              [-120.637415, 34.755895],
              [-120.62632, 34.738072],
              [-120.614852, 34.730709],
              [-120.601672, 34.709721],
              [-120.60045, 34.70464],
              [-120.60197, 34.692095],
              [-120.625127, 34.634489],
              [-120.640244, 34.604406],
              [-120.645739, 34.581035],
              [-120.637805, 34.56622],
              [-120.622575, 34.554017],
              [-120.612005, 34.553564],
              [-120.608355, 34.556656],
              [-120.581293, 34.556959],
              [-120.524776, 34.531291],
              [-120.511421, 34.522953],
              [-120.490523, 34.490075],
              [-120.480372, 34.481059],
              [-120.47661, 34.475131],
              [-120.471376, 34.447846],
              [-120.451425, 34.447094],
              [-120.441975, 34.451512],
              [-120.341369, 34.458789],
              [-120.301822, 34.467077],
              [-120.299169, 34.469731],
              [-120.295051, 34.470623],
              [-120.283001, 34.468354],
              [-120.25777, 34.467451],
              [-120.238002, 34.468098],
              [-120.225498, 34.470587],
              [-120.183505, 34.470372],
              [-120.141165, 34.473405],
              [-120.118411, 34.469927],
              [-120.097212, 34.461809],
              [-120.088591, 34.460208],
              [-120.050682, 34.461651],
              [-120.038828, 34.463434],
              [-120.008077, 34.460447],
              [-119.971951, 34.444641],
              [-119.956433, 34.435288],
              [-119.925227, 34.433931],
              [-119.873971, 34.408795],
              [-119.853771, 34.407996],
              [-119.835771, 34.415796],
              [-119.794771, 34.417597],
              [-119.785871, 34.415997],
              [-119.74547, 34.402898],
              [-119.729369, 34.395897],
              [-119.709067, 34.395397],
              [-119.691749, 34.403154],
              [-119.684666, 34.408297],
              [-119.688167, 34.412497],
              [-119.671866, 34.416096],
              [-119.648664, 34.417396],
              [-119.638864, 34.415696],
              [-119.616862, 34.420995],
              [-119.559459, 34.413395],
              [-119.536957, 34.395495],
              [-119.510655, 34.386295],
              [-119.478265, 34.377197],
              [-119.472678, 34.375628],
              [-119.461036, 34.374064],
              [-119.435888, 34.355839],
              [-119.431066, 34.355297],
              [-119.42777, 34.353016],
              [-119.390449, 34.318198],
              [-119.388249, 34.317398],
              [-119.37578, 34.321118],
              [-119.370356, 34.319486],
              [-119.349187, 34.304383],
              [-119.337475, 34.290576],
              [-119.313034, 34.275689],
              [-119.302131, 34.272761],
              [-119.290945, 34.274902],
              [-119.278644, 34.266902],
              [-119.270144, 34.252903],
              [-119.265927, 34.234609],
              [-119.257043, 34.213304],
              [-119.237142, 34.175804],
              [-119.227743, 34.161728],
              [-119.216441, 34.146105],
              [-119.211241, 34.144905],
              [-119.20314, 34.144505],
              [-119.18864, 34.139005],
              [-119.159554, 34.119653],
              [-119.130169, 34.100102],
              [-119.109784, 34.094566],
              [-119.098216, 34.099334],
              [-119.088536, 34.09831],
              [-119.069959, 34.09047],
              [-119.037494, 34.083111],
              [-119.004644, 34.066231],
              [-118.99698, 34.065943],
              [-118.977751, 34.059822],
              [-118.954722, 34.048167],
              [-118.944887, 34.04534],
              [-118.938081, 34.043383],
              [-118.928048, 34.045847],
              [-118.896159, 34.039207],
              [-118.854653, 34.034215],
              [-118.84038, 34.027527],
              [-118.821579, 34.013959],
              [-118.805114, 34.001239],
              [-118.787094, 34.019545],
              [-118.783433, 34.021543],
              [-118.744952, 34.032103],
              [-118.732391, 34.032743],
              [-118.706215, 34.029383],
              [-118.679366, 34.033255],
              [-118.67543, 34.037479],
              [-118.668358, 34.038887],
              [-118.609652, 34.036424],
              [-118.603572, 34.039048],
              [-118.569235, 34.04164],
              [-118.543115, 34.038508],
              [-118.519514, 34.027509],
              [-118.502813, 34.015509],
              [-118.484212, 33.99771],
              [-118.482729, 33.995912],
              [-118.460611, 33.969111],
              [-118.44241, 33.940312],
              [-118.412708, 33.883913],
              [-118.392107, 33.840915],
              [-118.391507, 33.815415],
              [-118.394307, 33.804315],
              [-118.394376, 33.804289],
              [-118.405007, 33.800215],
              [-118.423407, 33.782015],
              [-118.428407, 33.774715],
              [-118.411211, 33.741985],
              [-118.396606, 33.735917],
              [-118.385006, 33.741417],
              [-118.360505, 33.736817],
              [-118.354705, 33.732317],
              [-118.317205, 33.712818],
              [-118.297104, 33.708319],
              [-118.277208, 33.707091],
              [-118.258687, 33.703741],
              [-118.207476, 33.716905],
              [-118.181367, 33.717367],
              [-118.1837, 33.736118],
              [-118.187701, 33.749218],
              [-118.180831, 33.763072],
              [-118.1755, 33.763617],
              [-118.1569, 33.760317],
              [-118.132698, 33.753217],
              [-118.116703, 33.743549],
              [-118.101097, 33.734117],
              [-118.088896, 33.729817],
              [-118.064895, 33.711018],
              [-118.029694, 33.676418],
              [-118.000593, 33.654319],
              [-117.957114, 33.629466],
              [-117.940591, 33.620021],
              [-117.927091, 33.605521],
              [-117.89979, 33.599622],
              [-117.87679, 33.592322],
              [-117.840289, 33.573523],
              [-117.814188, 33.552224],
              [-117.801288, 33.546324],
              [-117.784888, 33.541525],
              [-117.761387, 33.516326],
              [-117.726486, 33.483427],
              [-117.715349, 33.460556],
              [-117.691384, 33.454028],
              [-117.691984, 33.456627],
              [-117.689284, 33.460155],
              [-117.684584, 33.461927],
              [-117.645592, 33.440733],
              [-117.645582, 33.440728],
              [-117.631682, 33.430528],
              [-117.607905, 33.406317],
              [-117.59588, 33.386629],
              [-117.571722, 33.378988],
              [-117.547693, 33.365491],
              [-117.50565, 33.334063],
              [-117.469794, 33.296417],
              [-117.445583, 33.268517],
              [-117.401926, 33.213598],
              [-117.39148, 33.202762],
              [-117.362572, 33.168437],
              [-117.359484, 33.164231],
              [-117.328359, 33.121842],
              [-117.315278, 33.093504],
              [-117.309771, 33.07454],
              [-117.29337, 33.034642],
              [-117.28077, 33.012343],
              [-117.262547, 32.939542],
              [-117.26047, 32.931245],
              [-117.25447, 32.900146],
              [-117.25167, 32.874346],
              [-117.25617, 32.859447],
              [-117.26067, 32.852647],
              [-117.26497, 32.848947],
              [-117.27387, 32.851447],
              [-117.28117, 32.843047],
              [-117.28217, 32.839547],
              [-117.280971, 32.822247],
              [-117.26107, 32.803148],
              [-117.25497, 32.786948],
              [-117.25257, 32.752949],
              [-117.25537, 32.745449],
              [-117.25757, 32.72605],
              [-117.255169, 32.700051],
              [-117.246069, 32.669352],
              [-117.236239, 32.671353],
              [-117.223868, 32.683051],
              [-117.213068, 32.687751],
              [-117.196767, 32.688851],
              [-117.192967, 32.687751],
              [-117.180366, 32.681652],
              [-117.168866, 32.671952],
              [-117.159865, 32.660652],
              [-117.139464, 32.627054],
              [-117.136664, 32.618754],
              [-117.132963, 32.597054],
              [-117.133363, 32.575625],
              [-117.124862, 32.534156],
              [-117.118865, 32.534661],
              [-116.390091, 32.59602],
              [-116.106159, 32.618328],
              [-115.875842, 32.636424],
              [-115.465164, 32.6671],
              [-114.719633, 32.718763],
              [-114.678632, 32.736614],
              [-114.677091, 32.736218],
              [-114.65884, 32.73383],
              [-114.65826, 32.733799],
              [-114.615585, 32.728446],
              [-114.615733, 32.729427],
              [-114.496827, 32.822119],
              [-114.496284, 32.822326],
              [-114.465715, 32.879191],
              [-114.465715, 32.87942],
              [-114.46289, 32.905797],
              [-114.468605, 32.971649],
              [-114.511343, 33.023455],
              [-114.516912, 33.026871],
              [-114.523578, 33.030961],
              [-114.571653, 33.036624],
              [-114.578287, 33.035375],
              [-114.584765, 33.028231],
              [-114.589778, 33.026228],
              [-114.606282, 33.025703],
              [-114.62387, 33.02872],
              [-114.675104, 33.047532],
              [-114.707819, 33.091102],
              [-114.706175, 33.105335],
              [-114.696829, 33.131209],
              [-114.687074, 33.142196],
              [-114.679359, 33.159519],
              [-114.67536, 33.185489],
              [-114.672088, 33.258499],
              [-114.700103, 33.341045],
              [-114.721233, 33.396912],
              [-114.665278, 33.415358],
              [-114.627125, 33.433554],
              [-114.622918, 33.456561],
              [-114.594534, 33.495059],
              [-114.558898, 33.531819],
              [-114.535664, 33.568788],
              [-114.535965, 33.569154],
              [-114.5403, 33.580615],
              [-114.540617, 33.591412],
              [-114.530348, 33.679245],
              [-114.523959, 33.685879],
              [-114.519113, 33.688473],
              [-114.496489, 33.696901],
              [-114.494197, 33.707922],
              [-114.50434, 33.756381],
              [-114.523365, 33.80612],
              [-114.525539, 33.838614],
              [-114.518434, 33.917518],
              [-114.499883, 33.961789],
              [-114.46361, 33.993431],
              [-114.438266, 34.022609],
              [-114.434949, 34.037784],
              [-114.435429, 34.079727],
              [-114.43338, 34.088413],
              [-114.420499, 34.103466],
              [-114.411681, 34.110031],
              [-114.401352, 34.111652],
              [-114.390565, 34.110084],
              [-114.366521, 34.118575],
              [-114.321618, 34.138093],
              [-114.312592, 34.144453],
              [-114.244191, 34.179625],
              [-114.225861, 34.201774],
              [-114.164476, 34.251667],
              [-114.133264, 34.258462],
              [-114.131489, 34.260387],
              [-114.138282, 34.30323],
              [-114.176909, 34.349306],
              [-114.199482, 34.361373],
              [-114.264317, 34.401329],
              [-114.339627, 34.451435],
              [-114.452547, 34.653494],
              [-114.465607, 34.69226],
              [-114.552682, 34.766871],
              [-114.633051, 34.869971],
              [-114.635176, 34.875003],
              [-114.636725, 34.889107],
              [-114.630877, 34.907263],
              [-114.629015, 34.986148],
              [-114.62919, 34.991887],
              [-114.633013, 35.002085],
            ],
          ],
          [
            [
              [-122.397349, 47.912401],
              [-122.39042, 47.905696],
              [-122.380497, 47.904023],
              [-122.3773, 47.905941],
              [-122.37578, 47.910252],
              [-122.376837, 47.923703],
              [-122.367876, 47.932415],
              [-122.358812, 47.93742],
              [-122.350741, 47.953235],
              [-122.349597, 47.958796],
              [-122.350254, 47.969355],
              [-122.353611, 47.981433],
              [-122.369161, 47.995295],
              [-122.373263, 48.000791],
              [-122.376259, 48.034457],
              [-122.387382, 48.03403],
              [-122.400628, 48.036563],
              [-122.431266, 48.045001],
              [-122.448419, 48.054323],
              [-122.461606, 48.068501],
              [-122.491104, 48.094242],
              [-122.513276, 48.097538],
              [-122.525422, 48.096537],
              [-122.516906, 48.081085],
              [-122.511081, 48.075301],
              [-122.513994, 48.059077],
              [-122.516314, 48.057181],
              [-122.538953, 48.050232],
              [-122.54512, 48.05255],
              [-122.554559, 48.077392],
              [-122.571853, 48.102143],
              [-122.571615, 48.105113],
              [-122.559911, 48.114186],
              [-122.558205, 48.119579],
              [-122.567936, 48.148624],
              [-122.574905, 48.155593],
              [-122.582595, 48.170424],
              [-122.585778, 48.182352],
              [-122.588138, 48.18594],
              [-122.606406, 48.208262],
              [-122.628352, 48.222467],
              [-122.63126, 48.220686],
              [-122.668385, 48.223967],
              [-122.66921, 48.240614],
              [-122.65343, 48.25934],
              [-122.652639, 48.265081],
              [-122.623779, 48.269431],
              [-122.620748, 48.282961],
              [-122.626757, 48.288991],
              [-122.618466, 48.294159],
              [-122.599532, 48.298303],
              [-122.584086, 48.297987],
              [-122.574872, 48.294903],
              [-122.558332, 48.282061],
              [-122.551793, 48.281512],
              [-122.530976, 48.282445],
              [-122.522756, 48.285504],
              [-122.519535, 48.288314],
              [-122.505828, 48.297677],
              [-122.504729, 48.300373],
              [-122.506568, 48.310041],
              [-122.515979, 48.320419],
              [-122.551334, 48.342138],
              [-122.565525, 48.348217],
              [-122.585162, 48.353304],
              [-122.588891, 48.363005],
              [-122.585038, 48.395166],
              [-122.595351, 48.3972],
              [-122.596732, 48.405626],
              [-122.60198, 48.409907],
              [-122.609715, 48.411565],
              [-122.617174, 48.407145],
              [-122.627809, 48.3972],
              [-122.63582, 48.395128],
              [-122.637892, 48.395681],
              [-122.637339, 48.398029],
              [-122.634024, 48.398858],
              [-122.632643, 48.401068],
              [-122.634991, 48.404244],
              [-122.644798, 48.405488],
              [-122.664659, 48.401508],
              [-122.664928, 48.374823],
              [-122.673731, 48.354683],
              [-122.707077, 48.315286],
              [-122.72259, 48.304268],
              [-122.732022, 48.279425],
              [-122.752563, 48.260061],
              [-122.769939, 48.227548],
              [-122.770045, 48.224395],
              [-122.763042, 48.215342],
              [-122.744612, 48.20965],
              [-122.73503, 48.199964],
              [-122.711508, 48.193573],
              [-122.693084, 48.181509],
              [-122.686626, 48.174653],
              [-122.679556, 48.155113],
              [-122.677337, 48.154587],
              [-122.671235, 48.157312],
              [-122.65602, 48.162513],
              [-122.633167, 48.163281],
              [-122.617464, 48.159055],
              [-122.609568, 48.15186],
              [-122.602109, 48.135249],
              [-122.598301, 48.110616],
              [-122.607291, 48.088034],
              [-122.613217, 48.079485],
              [-122.614028, 48.072788],
              [-122.594922, 48.056318],
              [-122.593621, 48.0472],
              [-122.596786, 48.038834],
              [-122.607342, 48.030992],
              [-122.58178, 48.010386],
              [-122.560018, 48.006502],
              [-122.542924, 47.996404],
              [-122.541564, 47.992998],
              [-122.543063, 47.985983],
              [-122.551032, 47.977346],
              [-122.552053, 47.973644],
              [-122.546824, 47.967215],
              [-122.521219, 47.972997],
              [-122.51778, 47.974916],
              [-122.514813, 47.981152],
              [-122.501257, 47.987089],
              [-122.487505, 47.990729],
              [-122.47266, 47.988449],
              [-122.446682, 47.963155],
              [-122.44076, 47.951845],
              [-122.44079, 47.946594],
              [-122.445759, 47.93619],
              [-122.445519, 47.930226],
              [-122.431035, 47.914732],
              [-122.419274, 47.912125],
              [-122.397349, 47.912401],
            ],
          ],
          [
            [
              [-122.649405, 48.588457],
              [-122.652385, 48.583432],
              [-122.650786, 48.554019],
              [-122.653612, 48.548975],
              [-122.654342, 48.537956],
              [-122.652041, 48.531329],
              [-122.649256, 48.528769],
              [-122.640414, 48.52586],
              [-122.635738, 48.526021],
              [-122.619858, 48.529246],
              [-122.599948, 48.536904],
              [-122.590194, 48.536259],
              [-122.583565, 48.53234],
              [-122.572967, 48.529028],
              [-122.578856, 48.54813],
              [-122.583985, 48.551534],
              [-122.592901, 48.553635],
              [-122.610841, 48.561146],
              [-122.629321, 48.5722],
              [-122.642597, 48.588339],
              [-122.649405, 48.588457],
            ],
          ],
          [
            [
              [-122.714512, 48.60878],
              [-122.72493, 48.603263],
              [-122.739898, 48.583949],
              [-122.73944, 48.573893],
              [-122.736199, 48.569005],
              [-122.73048, 48.565602],
              [-122.724031, 48.549906],
              [-122.722407, 48.540606],
              [-122.717278, 48.539739],
              [-122.68944, 48.543903],
              [-122.670638, 48.568812],
              [-122.691745, 48.590612],
              [-122.694672, 48.596602],
              [-122.714512, 48.60878],
            ],
          ],
          [
            [
              [-122.699266, 48.621115],
              [-122.686136, 48.613267],
              [-122.676796, 48.610055],
              [-122.666149, 48.608088],
              [-122.657016, 48.609891],
              [-122.674173, 48.629944],
              [-122.69806, 48.62308],
              [-122.699266, 48.621115],
            ],
          ],
          [
            [
              [-122.800217, 48.60169],
              [-122.79877, 48.602352],
              [-122.79901, 48.604683],
              [-122.808864, 48.61531],
              [-122.809622, 48.619035],
              [-122.792147, 48.633502],
              [-122.783875, 48.635419],
              [-122.755031, 48.649512],
              [-122.742082, 48.660689],
              [-122.743049, 48.661991],
              [-122.800267, 48.67962],
              [-122.802545, 48.682682],
              [-122.833124, 48.698173],
              [-122.875938, 48.71212],
              [-122.894599, 48.71503],
              [-122.918252, 48.713505],
              [-122.942367, 48.706723],
              [-122.941316, 48.702904],
              [-122.949116, 48.693398],
              [-122.984853, 48.672686],
              [-122.988884, 48.667246],
              [-123.009924, 48.655064],
              [-123.014829, 48.647503],
              [-123.015592, 48.642567],
              [-123.023495, 48.634001],
              [-123.048652, 48.621002],
              [-123.04653, 48.61149],
              [-123.041189, 48.611947],
              [-123.023433, 48.599477],
              [-123.024902, 48.594484],
              [-123.034101, 48.591767],
              [-123.016647, 48.580244],
              [-123.0048, 48.580788],
              [-122.995026, 48.578162],
              [-122.989649, 48.574668],
              [-122.98611, 48.569984],
              [-122.987296, 48.561895],
              [-123.015046, 48.560821],
              [-123.033669, 48.563409],
              [-123.048403, 48.569216],
              [-123.06004, 48.582105],
              [-123.074611, 48.591816],
              [-123.101552, 48.59782],
              [-123.102074, 48.604035],
              [-123.098254, 48.610092],
              [-123.098462, 48.612834],
              [-123.107362, 48.622451],
              [-123.135645, 48.620171],
              [-123.139705, 48.622786],
              [-123.151643, 48.623686],
              [-123.178425, 48.622115],
              [-123.195725, 48.607055],
              [-123.203026, 48.596178],
              [-123.20268, 48.590214],
              [-123.197754, 48.586216],
              [-123.184941, 48.58697],
              [-123.173061, 48.579086],
              [-123.171958, 48.572255],
              [-123.175852, 48.568483],
              [-123.176266, 48.562131],
              [-123.172412, 48.556486],
              [-123.16147, 48.547618],
              [-123.161853, 48.539255],
              [-123.164057, 48.535622],
              [-123.163234, 48.529544],
              [-123.151065, 48.513955],
              [-123.141478, 48.505291],
              [-123.119451, 48.492576],
              [-123.067675, 48.479497],
              [-123.058154, 48.471522],
              [-123.039156, 48.460003],
              [-122.962009, 48.451161],
              [-122.937881, 48.456221],
              [-122.926901, 48.460874],
              [-122.920099, 48.458428],
              [-122.91646, 48.453263],
              [-122.928004, 48.439966],
              [-122.917771, 48.439781],
              [-122.913888, 48.443231],
              [-122.903214, 48.436979],
              [-122.889016, 48.435947],
              [-122.893646, 48.422655],
              [-122.883759, 48.418793],
              [-122.874135, 48.418196],
              [-122.825803, 48.424131],
              [-122.812208, 48.422326],
              [-122.803521, 48.428748],
              [-122.802509, 48.433098],
              [-122.807708, 48.444058],
              [-122.8131, 48.452856],
              [-122.81973, 48.458843],
              [-122.817912, 48.483888],
              [-122.816332, 48.487841],
              [-122.800414, 48.494467],
              [-122.779124, 48.508911],
              [-122.777467, 48.517799],
              [-122.787347, 48.523012],
              [-122.788503, 48.530393],
              [-122.782618, 48.545191],
              [-122.772384, 48.552143],
              [-122.770349, 48.558106],
              [-122.771206, 48.562426],
              [-122.786586, 48.576666],
              [-122.801096, 48.585425],
              [-122.804869, 48.595932],
              [-122.800217, 48.60169],
            ],
          ],
          [
            [
              [-123.197953, 48.68466],
              [-123.212892, 48.689713],
              [-123.236567, 48.68895],
              [-123.237148, 48.683466],
              [-123.215917, 48.669352],
              [-123.134956, 48.63724],
              [-123.119677, 48.632972],
              [-123.106165, 48.633473],
              [-123.122016, 48.647065],
              [-123.130962, 48.656789],
              [-123.14799, 48.668001],
              [-123.172066, 48.679866],
              [-123.186076, 48.684917],
              [-123.197953, 48.68466],
            ],
          ],
          [
            [
              [-123.025486, 48.717966],
              [-123.040179, 48.717296],
              [-123.070427, 48.699971],
              [-123.047058, 48.695772],
              [-123.03636, 48.69008],
              [-123.035672, 48.68535],
              [-123.041645, 48.678633],
              [-123.042337, 48.675663],
              [-123.021215, 48.681416],
              [-123.014449, 48.684978],
              [-123.005086, 48.694342],
              [-123.007511, 48.718863],
              [-123.009787, 48.722291],
              [-123.019699, 48.721312],
              [-123.025486, 48.717966],
            ],
          ],
          [
            [
              [-122.321721, 48.019977],
              [-122.328343, 48.021335],
              [-122.334524, 48.018916],
              [-122.326115, 48.010295],
              [-122.306629, 48.004397],
              [-122.303455, 48.005603],
              [-122.321721, 48.019977],
            ],
          ],
          [
            [
              [-123.035393, 49.002154],
              [-123.090546, 49.001976],
              [-123.084498, 48.986535],
              [-123.083834, 48.976139],
              [-123.060717, 48.975388],
              [-123.040967, 48.977305],
              [-123.028091, 48.973943],
              [-123.021459, 48.977299],
              [-123.035393, 49.002154],
            ],
          ],
          [
            [
              [-122.695907, 48.737273],
              [-122.70306, 48.743602],
              [-122.715709, 48.748672],
              [-122.722262, 48.731624],
              [-122.721981, 48.723375],
              [-122.718833, 48.716818],
              [-122.702223, 48.717004],
              [-122.691795, 48.711498],
              [-122.673538, 48.680809],
              [-122.635299, 48.651846],
              [-122.616956, 48.645563],
              [-122.609576, 48.645018],
              [-122.618225, 48.670721],
              [-122.644901, 48.691389],
              [-122.663259, 48.697077],
              [-122.668947, 48.706644],
              [-122.695907, 48.737273],
            ],
          ],
        ],
      },
      properties: { region: 'NORTHWEST' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-104.053249, 41.001406],
            [-104.053158, 41.016809],
            [-104.053097, 41.018045],
            [-104.053177, 41.089725],
            [-104.053025, 41.090274],
            [-104.053083, 41.104985],
            [-104.053142, 41.114457],
            [-104.052666, 41.275251],
            [-104.052574, 41.278019],
            [-104.052453, 41.278202],
            [-104.052568, 41.316202],
            [-104.052476, 41.320961],
            [-104.052324, 41.321144],
            [-104.052287, 41.393214],
            [-104.052287, 41.393307],
            [-104.05216, 41.407662],
            [-104.05234, 41.417865],
            [-104.052478, 41.515754],
            [-104.052476, 41.522343],
            [-104.052686, 41.539111],
            [-104.052692, 41.541154],
            [-104.052584, 41.55265],
            [-104.052531, 41.552723],
            [-104.05254, 41.564274],
            [-104.052859, 41.592254],
            [-104.052735, 41.613676],
            [-104.052975, 41.622931],
            [-104.052945, 41.638167],
            [-104.052913, 41.64519],
            [-104.05283, 41.697954],
            [-104.052774, 41.733401],
            [-104.053026, 41.885464],
            [-104.052931, 41.906143],
            [-104.052991, 41.914973],
            [-104.052734, 41.973007],
            [-104.052856, 41.975958],
            [-104.05283, 41.9946],
            [-104.052761, 41.994967],
            [-104.052699, 41.998673],
            [-104.052704, 42.001718],
            [-104.052729, 42.016318],
            [-104.05288, 42.021761],
            [-104.052967, 42.075004],
            [-104.052954, 42.089077],
            [-104.0526, 42.124963],
            [-104.052738, 42.133769],
            [-104.053001, 42.137254],
            [-104.052547, 42.166801],
            [-104.052761, 42.170278],
            [-104.052793, 42.249962],
            [-104.052776, 42.25822],
            [-104.052775, 42.610813],
            [-104.052775, 42.61159],
            [-104.052773, 42.611766],
            [-104.052586, 42.630917],
            [-104.052741, 42.633982],
            [-104.052583, 42.650062],
            [-104.052809, 42.749966],
            [-104.052863, 42.754569],
            [-104.053127, 43.000585],
            [-104.053876, 43.289801],
            [-104.053884, 43.297047],
            [-104.054218, 43.30437],
            [-104.054403, 43.325914],
            [-104.054614, 43.390949],
            [-104.054766, 43.428914],
            [-104.054779, 43.477815],
            [-104.054786, 43.503072],
            [-104.054787, 43.503328],
            [-104.055032, 43.558603],
            [-104.05484, 43.579368],
            [-104.054885, 43.583512],
            [-104.054902, 43.583852],
            [-104.055133, 43.747105],
            [-104.055138, 43.750421],
            [-104.055104, 43.853478],
            [-104.055077, 43.936535],
            [-104.05495, 43.93809],
            [-104.054562, 44.141081],
            [-104.054487, 44.180381],
            [-104.055927, 44.51773],
            [-104.055892, 44.543341],
            [-104.055877, 44.571016],
            [-104.05581, 44.691343],
            [-104.055938, 44.693881],
            [-104.055777, 44.700466],
            [-104.05587, 44.723422],
            [-104.055934, 44.72372],
            [-104.055963, 44.767962],
            [-104.055963, 44.768236],
            [-104.057698, 44.997431],
            [-104.040128, 44.999987],
            [-104.040274, 45.212891],
            [-104.040358, 45.335946],
            [-104.040265, 45.345356],
            [-104.040114, 45.374214],
            [-104.04041, 45.393474],
            [-104.041764, 45.490789],
            [-104.041274, 45.499994],
            [-104.041145, 45.503367],
            [-104.041717, 45.539122],
            [-104.041647, 45.550691],
            [-104.041937, 45.557915],
            [-104.043814, 45.868385],
            [-104.044009, 45.871974],
            [-104.04403, 45.881971],
            [-104.04403, 45.881975],
            [-104.045443, 45.94531],
            [-104.04667, 46.000001],
            [-104.045633, 46.280188],
            [-104.045469, 46.324545],
            [-104.045462, 46.341895],
            [-104.045335, 46.540929],
            [-104.045271, 46.641443],
            [-104.045271, 46.641449],
            [-104.045474, 46.708738],
            [-104.045572, 46.713881],
            [-104.04537, 46.721332],
            [-104.045403, 46.722177],
            [-104.045402, 46.725423],
            [-104.045542, 46.933887],
            [-104.045535, 46.934009],
            [-104.045566, 46.941231],
            [-104.045076, 47.037589],
            [-104.045052, 47.040863],
            [-104.045195, 47.053639],
            [-104.045227, 47.057502],
            [-104.045259, 47.063901],
            [-104.045354, 47.078574],
            [-104.045018, 47.081202],
            [-104.045081, 47.092813],
            [-104.045159, 47.263874],
            [-104.045091, 47.265953],
            [-104.045057, 47.266868],
            [-104.045088, 47.271406],
            [-104.045155, 47.27393],
            [-104.045121, 47.276969],
            [-104.045307, 47.330128],
            [-104.045313, 47.331955],
            [-104.045333, 47.343452],
            [-104.045069, 47.397461],
            [-104.044797, 47.438445],
            [-104.044621, 47.45938],
            [-104.043242, 47.747106],
            [-104.043199, 47.747292],
            [-104.042384, 47.803256],
            [-104.042432, 47.805358],
            [-104.042567, 47.808237],
            [-104.041869, 47.841699],
            [-104.041662, 47.862282],
            [-104.04223, 47.891031],
            [-104.043329, 47.949554],
            [-104.043497, 47.95449],
            [-104.043933, 47.971515],
            [-104.044162, 47.992836],
            [-104.04412, 47.996107],
            [-104.045399, 48.16439],
            [-104.045498, 48.176249],
            [-104.045424, 48.192473],
            [-104.04556, 48.193913],
            [-104.045692, 48.241415],
            [-104.045729, 48.244586],
            [-104.045645, 48.246179],
            [-104.045861, 48.255097],
            [-104.046039, 48.256761],
            [-104.046332, 48.34229],
            [-104.046371, 48.374154],
            [-104.046654, 48.374773],
            [-104.046913, 48.389429],
            [-104.046913, 48.389433],
            [-104.046969, 48.390675],
            [-104.047134, 48.411057],
            [-104.04696, 48.421065],
            [-104.04709, 48.445903],
            [-104.047192, 48.447251],
            [-104.047294, 48.452529],
            [-104.047259, 48.452941],
            [-104.047392, 48.467086],
            [-104.047555, 48.49414],
            [-104.047675, 48.517852],
            [-104.047513, 48.525913],
            [-104.047876, 48.530798],
            [-104.047648, 48.531489],
            [-104.047783, 48.539737],
            [-104.047811, 48.56277],
            [-104.047974, 48.591606],
            [-104.048212, 48.599055],
            [-104.04793, 48.62019],
            [-104.047586, 48.625644],
            [-104.04762, 48.627015],
            [-104.047582, 48.633976],
            [-104.047582, 48.633984],
            [-104.047819, 48.648631],
            [-104.047887, 48.649911],
            [-104.047865, 48.65745],
            [-104.047861, 48.658856],
            [-104.047849, 48.663163],
            [-104.047883, 48.664191],
            [-104.04834, 48.747133],
            [-104.048548, 48.751356],
            [-104.048537, 48.788552],
            [-104.048569, 48.797052],
            [-104.0489, 48.847387],
            [-104.048652, 48.865734],
            [-104.048824, 48.867539],
            [-104.048883, 48.874008],
            [-104.048893, 48.875739],
            [-104.048719, 48.879921],
            [-104.048643, 48.902609],
            [-104.048746, 48.906858],
            [-104.048744, 48.912113],
            [-104.048807, 48.933636],
            [-104.048701, 48.940331],
            [-104.04877, 48.943301],
            [-104.048872, 48.94963],
            [-104.048698, 48.951823],
            [-104.048627, 48.957124],
            [-104.0488, 48.958997],
            [-104.048555, 48.963772],
            [-104.048616, 48.966736],
            [-104.048478, 48.987007],
            [-104.048736, 48.999877],
            [-104.543636, 48.999541],
            [-104.647389, 48.999344],
            [-105.057514, 48.999448],
            [-105.265192, 48.9995],
            [-105.277521, 48.999457],
            [-105.355888, 48.999357],
            [-105.38749, 48.999382],
            [-105.391379, 48.999475],
            [-105.407909, 48.99948],
            [-105.411972, 48.999582],
            [-105.522636, 48.999591],
            [-105.578616, 48.999673],
            [-105.607542, 48.999624],
            [-105.612577, 48.999703],
            [-105.65027, 48.999444],
            [-105.775808, 48.999637],
            [-105.834181, 48.999707],
            [-105.966197, 48.999445],
            [-106.050543, 48.999207],
            [-106.112108, 48.999279],
            [-106.233987, 48.999423],
            [-106.243154, 48.999373],
            [-106.24621, 48.999258],
            [-106.274267, 48.999312],
            [-106.368151, 48.999503],
            [-106.374616, 48.999617],
            [-106.500592, 48.999756],
            [-106.518201, 48.999564],
            [-106.617539, 48.999583],
            [-106.625597, 48.99964],
            [-107.179865, 48.999559],
            [-108.236495, 48.999405],
            [-108.488063, 48.999368],
            [-108.543194, 48.999377],
            [-108.994722, 48.999237],
            [-109.000708, 48.999234],
            [-109.060292, 48.999621],
            [-109.06057, 48.999666],
            [-109.384068, 49.000374],
            [-109.384762, 49.000397],
            [-109.489686, 49.000267],
            [-109.995618, 48.999642],
            [-110.171595, 48.999262],
            [-110.215516, 48.999197],
            [-110.216135, 48.999239],
            [-110.743209, 48.998363],
            [-110.886706, 48.998124],
            [-110.887459, 48.998087],
            [-111.270702, 48.997895],
            [-111.761613, 48.99765],
            [-111.761679, 48.997614],
            [-111.85409, 48.998039],
            [-111.854088, 48.998067],
            [-112.193588, 48.998229],
            [-113.009895, 48.998619],
            [-113.011041, 48.998643],
            [-113.085576, 48.998581],
            [-113.087863, 48.998557],
            [-113.092055, 48.998543],
            [-113.095436, 48.998533],
            [-113.098147, 48.998494],
            [-113.103212, 48.99853],
            [-113.106891, 48.998501],
            [-113.110155, 48.99855],
            [-113.116356, 48.998462],
            [-113.692982, 48.997632],
            [-114.068151, 48.999364],
            [-114.43883, 49.001076],
            [-114.674398, 49.000679],
            [-114.678217, 49.000725],
            [-114.728125, 49.000623],
            [-115.251126, 48.999557],
            [-116.049193, 49.000912],
            [-116.757234, 48.999943],
            [-116.757185, 48.999791],
            [-117.032351, 48.999188],
            [-117.033177, 48.846563],
            [-117.034358, 48.628523],
            [-117.034499, 48.620769],
            [-117.035285, 48.430113],
            [-117.035285, 48.429816],
            [-117.035254, 48.423144],
            [-117.035289, 48.422732],
            [-117.035178, 48.371221],
            [-117.035178, 48.370878],
            [-117.039599, 48.184387],
            [-117.039615, 48.184015],
            [-117.039582, 48.181124],
            [-117.039582, 48.180853],
            [-117.039583, 48.180313],
            [-117.039618, 48.178142],
            [-117.039413, 48.17725],
            [-117.039552, 48.17396],
            [-117.041401, 48.0855],
            [-117.041676, 48.04556],
            [-117.041874, 47.977387],
            [-117.042485, 47.766525],
            [-117.042521, 47.764896],
            [-117.042623, 47.761223],
            [-117.042657, 47.760857],
            [-117.042059, 47.7451],
            [-117.042135, 47.7441],
            [-117.041678, 47.72271],
            [-117.041633, 47.7064],
            [-117.041532, 47.683194],
            [-117.041431, 47.68],
            [-117.041431, 47.678185],
            [-117.041431, 47.67814],
            [-117.041174, 47.55853],
            [-117.041276, 47.55821],
            [-117.040745, 47.532909],
            [-117.040545, 47.527562],
            [-117.040514, 47.522351],
            [-117.039945, 47.477823],
            [-117.039971, 47.463309],
            [-117.039948, 47.434885],
            [-117.03995, 47.412412],
            [-117.039882, 47.399085],
            [-117.039857, 47.366093],
            [-117.039843, 47.347201],
            [-117.040019, 47.259272],
            [-117.039899, 47.225515],
            [-117.039888, 47.203282],
            [-117.039871, 47.181858],
            [-117.039836, 47.154734],
            [-117.039821, 47.127265],
            [-117.039657, 46.825798],
            [-117.039828, 46.815443],
            [-117.039783, 46.541785],
            [-117.039771, 46.471779],
            [-117.039763, 46.46957],
            [-117.039741, 46.462704],
            [-117.039813, 46.425425],
            [-117.046915, 46.379577],
            [-117.061045, 46.367747],
            [-117.047469, 46.342884],
            [-116.987939, 46.298031],
            [-116.985333, 46.294617],
            [-116.958801, 46.24232],
            [-116.925621, 46.158888],
            [-116.94353, 46.062173],
            [-116.915989, 45.995413],
            [-116.875125, 45.9422],
            [-116.866544, 45.916958],
            [-116.857254, 45.904159],
            [-116.796418, 45.853807],
            [-116.789099, 45.847749],
            [-116.633377, 45.784681],
            [-116.59421, 45.77908],
            [-116.54809, 45.752364],
            [-116.535698, 45.734231],
            [-116.538014, 45.714929],
            [-116.535396, 45.691734],
            [-116.528272, 45.681473],
            [-116.510938, 45.668114],
            [-116.48912, 45.65114],
            [-116.471504, 45.628467],
            [-116.463504, 45.615785],
            [-116.463635, 45.602785],
            [-116.481208, 45.580597],
            [-116.553473, 45.499107],
            [-116.673793, 45.321511],
            [-116.691197, 45.269245],
            [-116.696047, 45.254679],
            [-116.709536, 45.203015],
            [-116.729607, 45.142091],
            [-116.783902, 45.079022],
            [-116.845369, 45.017059],
            [-116.858277, 44.978008],
            [-116.850737, 44.958113],
            [-116.844653, 44.949338],
            [-116.835702, 44.940633],
            [-116.83199, 44.933007],
            [-116.852427, 44.887577],
            [-116.891463, 44.840531],
            [-116.931499, 44.792281],
            [-117.016216, 44.755572],
            [-117.03827, 44.748179],
            [-117.044217, 44.74514],
            [-117.062273, 44.727143],
            [-117.095868, 44.664737],
            [-117.1159, 44.623339],
            [-117.144161, 44.545647],
            [-117.149242, 44.536151],
            [-117.156489, 44.528312],
            [-117.208454, 44.485928],
            [-117.214889, 44.466901],
            [-117.189769, 44.336585],
            [-117.191546, 44.329621],
            [-117.194827, 44.31054],
            [-117.196597, 44.30228],
            [-117.197506, 44.29728],
            [-117.197777, 44.295789],
            [-117.196597, 44.287529],
            [-117.190107, 44.273958],
            [-117.170342, 44.25889],
            [-117.041144, 44.243653],
            [-117.03317, 44.248192],
            [-117.027558, 44.248881],
            [-116.98687, 44.245477],
            [-116.975905, 44.242844],
            [-116.902752, 44.179467],
            [-116.895757, 44.171267],
            [-116.894083, 44.160191],
            [-116.895931, 44.154295],
            [-116.897145, 44.152537],
            [-116.931719, 44.102474],
            [-116.935301, 43.988616],
            [-116.961535, 43.918388],
            [-116.979186, 43.879973],
            [-116.982482, 43.872799],
            [-116.996504, 43.864714],
            [-117.026634, 43.808104],
            [-117.026651, 43.733935],
            [-117.026841, 43.732905],
            [-117.026725, 43.714815],
            [-117.026825, 43.706193],
            [-117.026586, 43.683001],
            [-117.026623, 43.680865],
            [-117.026717, 43.675523],
            [-117.026661, 43.664385],
            [-117.026705, 43.631659],
            [-117.026905, 43.62488],
            [-117.027001, 43.621032],
            [-117.026937, 43.617614],
            [-117.026789, 43.610669],
            [-117.02676, 43.601912],
            [-117.026824, 43.600357],
            [-117.026889, 43.596033],
            [-117.026922, 43.593632],
            [-117.026774, 43.578674],
            [-117.026746, 43.577526],
            [-117.026652, 43.025128],
            [-117.026683, 43.024876],
            [-117.026253, 42.807447],
            [-117.026303, 42.80717],
            [-117.026331, 42.807015],
            [-117.026222, 42.000252],
            [-117.018294, 41.999358],
            [-116.62677, 41.99775],
            [-116.586937, 41.99737],
            [-116.510452, 41.997096],
            [-116.485823, 41.996861],
            [-116.483094, 41.996885],
            [-116.463528, 41.996547],
            [-116.163931, 41.997555],
            [-116.160833, 41.997508],
            [-116.038602, 41.99746],
            [-116.03857, 41.997413],
            [-116.030754, 41.997399],
            [-116.030758, 41.997383],
            [-116.01896, 41.997762],
            [-116.018945, 41.997722],
            [-116.012219, 41.998048],
            [-116.012212, 41.998035],
            [-115.98688, 41.998534],
            [-115.038256, 41.996025],
            [-115.031783, 41.996008],
            [-114.914187, 41.999909],
            [-114.763825, 41.999909],
            [-114.598267, 41.994511],
            [-114.498259, 41.994599],
            [-114.498243, 41.994636],
            [-114.281854, 41.994264],
            [-114.107428, 41.993965],
            [-114.107259, 41.993831],
            [-114.061763, 41.993939],
            [-114.061774, 41.993797],
            [-114.048257, 41.993814],
            [-114.048246, 41.993721],
            [-114.041723, 41.99372],
            [-114.041107, 41.850573],
            [-114.041152, 41.850595],
            [-114.039882, 41.741991],
            [-114.042145, 40.999926],
            [-114.043803, 40.759205],
            [-114.043831, 40.758666],
            [-114.043505, 40.726292],
            [-114.045281, 40.506586],
            [-114.045577, 40.495801],
            [-114.045518, 40.494474],
            [-114.046555, 40.116931],
            [-114.047134, 39.906037],
            [-114.047728, 39.542742],
            [-114.049893, 38.677365],
            [-114.050154, 38.57292],
            [-114.049862, 38.547764],
            [-114.049834, 38.543784],
            [-114.050091, 38.404673],
            [-114.05012, 38.404536],
            [-114.049903, 38.148601],
            [-114.050423, 37.999961],
            [-114.048473, 37.809861],
            [-114.051109, 37.756276],
            [-114.05167, 37.746958],
            [-114.051785, 37.746249],
            [-114.051728, 37.745997],
            [-114.052472, 37.604776],
            [-114.052689, 37.517859],
            [-114.052718, 37.517264],
            [-114.052685, 37.502513],
            [-114.052701, 37.492014],
            [-114.051927, 37.370734],
            [-114.051927, 37.370459],
            [-114.0518, 37.293548],
            [-114.0518, 37.293044],
            [-114.051974, 37.284511],
            [-114.051974, 37.283848],
            [-114.051822, 37.090976],
            [-114.051749, 37.088434],
            [-114.0506, 37.000396],
            [-113.965907, 37.000025],
            [-113.965907, 36.999976],
            [-112.966471, 37.000219],
            [-112.899366, 37.000319],
            [-112.609787, 37.000753],
            [-112.558974, 37.000692],
            [-112.545094, 37.000734],
            [-112.540368, 37.000669],
            [-112.538593, 37.000674],
            [-112.534545, 37.000684],
            [-112.368946, 37.001125],
            [-112.35769, 37.001025],
            [-111.412784, 37.001478],
            [-111.405869, 37.001481],
            [-111.405517, 37.001497],
            [-111.189888, 37.000959],
            [-110.75069, 37.003197],
            [-110.495259, 37.003875],
            [-110.33105, 36.998216],
            [-110.000677, 36.997968],
            [-109.381226, 36.999148],
            [-109.378039, 36.999135],
            [-109.270097, 36.999266],
            [-109.268213, 36.999242],
            [-109.26339, 36.999263],
            [-109.246917, 36.999346],
            [-109.233848, 36.999266],
            [-109.181196, 36.999271],
            [-109.045223, 36.999084],
            [-108.958868, 36.998913],
            [-108.954404, 36.998906],
            [-108.620309, 36.999287],
            [-108.619689, 36.999249],
            [-108.379203, 36.999459],
            [-108.320721, 36.99951],
            [-108.320464, 36.999499],
            [-108.2884, 36.99952],
            [-108.288086, 36.999555],
            [-107.481737, 36.999973],
            [-107.420915, 37.000005],
            [-107.420913, 37.000005],
            [-107.000592, 37.000009],
            [-106.869796, 36.992426],
            [-106.675626, 36.993123],
            [-106.661344, 36.993243],
            [-106.628733, 36.993161],
            [-106.628652, 36.993175],
            [-106.617125, 36.993004],
            [-106.617159, 36.992967],
            [-106.476228, 36.993472],
            [-106.248675, 36.994288],
            [-106.247705, 36.994266],
            [-106.006634, 36.995343],
            [-105.997472, 36.995417],
            [-105.996159, 36.995418],
            [-105.71847, 36.995846],
            [-105.716471, 36.995849],
            [-105.66472, 36.995874],
            [-105.62747, 36.995679],
            [-105.533922, 36.995875],
            [-105.512485, 36.995777],
            [-105.508836, 36.995895],
            [-105.465182, 36.995991],
            [-105.447255, 36.996017],
            [-105.442459, 36.995994],
            [-105.41931, 36.995856],
            [-105.220613, 36.995169],
            [-105.155042, 36.995339],
            [-105.1208, 36.995428],
            [-105.000554, 36.993264],
            [-104.73212, 36.993484],
            [-104.732031, 36.993447],
            [-104.007855, 36.996239],
            [-103.734364, 36.998041],
            [-103.733247, 36.998016],
            [-103.086105, 36.999864],
            [-103.002199, 37.000104],
            [-102.986976, 36.998524],
            [-102.985807, 36.998571],
            [-102.979613, 36.998549],
            [-102.875481, 36.999628],
            [-102.570896, 36.995136],
            [-102.355367, 36.994575],
            [-102.355288, 36.994506],
            [-102.208316, 36.99373],
            [-102.184271, 36.993593],
            [-102.054503, 36.993109],
            [-102.04224, 36.993083],
            [-102.041952, 37.024742],
            [-102.04195, 37.030805],
            [-102.041921, 37.032178],
            [-102.041749, 37.034397],
            [-102.04192, 37.035083],
            [-102.041983, 37.106551],
            [-102.041809, 37.111973],
            [-102.042092, 37.125021],
            [-102.042135, 37.125021],
            [-102.042002, 37.141744],
            [-102.041963, 37.258164],
            [-102.041664, 37.29765],
            [-102.041817, 37.30949],
            [-102.041974, 37.352613],
            [-102.042089, 37.352819],
            [-102.041826, 37.389191],
            [-102.041676, 37.409898],
            [-102.041669, 37.43474],
            [-102.041755, 37.434855],
            [-102.041801, 37.469488],
            [-102.041786, 37.506066],
            [-102.042016, 37.535261],
            [-102.041899, 37.541186],
            [-102.041894, 37.557977],
            [-102.041618, 37.607868],
            [-102.041585, 37.644282],
            [-102.041582, 37.654495],
            [-102.041694, 37.665681],
            [-102.041574, 37.680436],
            [-102.041876, 37.723875],
            [-102.04199, 37.738541],
            [-102.042158, 37.760164],
            [-102.042668, 37.788758],
            [-102.042953, 37.803535],
            [-102.043033, 37.824146],
            [-102.043219, 37.867929],
            [-102.043845, 37.926135],
            [-102.043844, 37.928102],
            [-102.044398, 38.250015],
            [-102.04451, 38.262412],
            [-102.044567, 38.268749],
            [-102.044568, 38.268819],
            [-102.044613, 38.312324],
            [-102.044944, 38.384419],
            [-102.045263, 38.505395],
            [-102.045262, 38.505532],
            [-102.045112, 38.523784],
            [-102.045223, 38.543797],
            [-102.045189, 38.558732],
            [-102.045211, 38.581609],
            [-102.045288, 38.615168],
            [-102.045288, 38.615249],
            [-102.045074, 38.669617],
            [-102.045102, 38.674946],
            [-102.04516, 38.675221],
            [-102.045127, 38.686725],
            [-102.045156, 38.688555],
            [-102.045212, 38.697567],
            [-102.045375, 38.754339],
            [-102.045287, 38.755528],
            [-102.045371, 38.770064],
            [-102.045448, 38.783453],
            [-102.045334, 38.799463],
            [-102.045388, 38.813392],
            [-102.046571, 39.047038],
            [-102.047134, 39.129701],
            [-102.047189, 39.133147],
            [-102.04725, 39.13702],
            [-102.048449, 39.303138],
            [-102.04896, 39.373712],
            [-102.049167, 39.403597],
            [-102.04937, 39.41821],
            [-102.049369, 39.423333],
            [-102.049679, 39.506183],
            [-102.049673, 39.536691],
            [-102.049554, 39.538932],
            [-102.049764, 39.56818],
            [-102.049806, 39.574058],
            [-102.049954, 39.592331],
            [-102.050594, 39.675594],
            [-102.051254, 39.818992],
            [-102.051318, 39.833311],
            [-102.051363, 39.843471],
            [-102.051569, 39.849805],
            [-102.051744, 40.003078],
            [-102.052001, 40.148359],
            [-102.051909, 40.162674],
            [-102.051894, 40.229193],
            [-102.051922, 40.235344],
            [-102.051669, 40.349213],
            [-102.051572, 40.39308],
            [-102.05184, 40.396396],
            [-102.051465, 40.440008],
            [-102.051519, 40.520094],
            [-102.051725, 40.537839],
            [-102.051398, 40.697542],
            [-102.051292, 40.749586],
            [-102.051292, 40.749591],
            [-102.051614, 41.002377],
            [-102.051718, 41.002377],
            [-102.070598, 41.002423],
            [-102.124972, 41.002338],
            [-102.19121, 41.002326],
            [-102.209361, 41.002442],
            [-102.2122, 41.002462],
            [-102.231931, 41.002327],
            [-102.267812, 41.002383],
            [-102.2721, 41.002245],
            [-102.291354, 41.002207],
            [-102.292553, 41.002207],
            [-102.292622, 41.00223],
            [-102.292833, 41.002207],
            [-102.364066, 41.002174],
            [-102.379593, 41.002301],
            [-102.469223, 41.002424],
            [-102.470537, 41.002382],
            [-102.487955, 41.002445],
            [-102.556789, 41.002219],
            [-102.566048, 41.0022],
            [-102.575496, 41.0022],
            [-102.575738, 41.002268],
            [-102.578696, 41.002291],
            [-102.621033, 41.002597],
            [-102.653463, 41.002332],
            [-102.739624, 41.00223],
            [-102.754617, 41.002361],
            [-102.766723, 41.002275],
            [-102.773546, 41.002414],
            [-102.82728, 41.002143],
            [-102.830303, 41.002351],
            [-102.846455, 41.002256],
            [-102.849263, 41.002301],
            [-102.865784, 41.001988],
            [-102.867822, 41.002183],
            [-102.885746, 41.002131],
            [-102.887407, 41.002178],
            [-102.904796, 41.002207],
            [-102.906547, 41.002276],
            [-102.924029, 41.002142],
            [-102.925568, 41.00228],
            [-102.943109, 41.002051],
            [-102.94483, 41.002303],
            [-102.959624, 41.002095],
            [-102.960706, 41.002059],
            [-102.962522, 41.002072],
            [-102.963669, 41.002186],
            [-102.981483, 41.002112],
            [-102.98269, 41.002157],
            [-103.000102, 41.0024],
            [-103.002026, 41.002486],
            [-103.038704, 41.002251],
            [-103.043444, 41.002344],
            [-103.057998, 41.002368],
            [-103.059538, 41.002368],
            [-103.076536, 41.002253],
            [-103.077804, 41.002298],
            [-103.362979, 41.001844],
            [-103.365314, 41.001846],
            [-103.382493, 41.001883],
            [-103.421925, 41.001969],
            [-103.421975, 41.002007],
            [-103.486697, 41.001914],
            [-103.497447, 41.001635],
            [-103.574522, 41.001721],
            [-103.858449, 41.001681],
            [-103.877967, 41.001673],
            [-103.896207, 41.00175],
            [-103.953525, 41.001596],
            [-103.971373, 41.001524],
            [-103.972642, 41.001615],
            [-104.018223, 41.001617],
            [-104.023383, 41.001887],
            [-104.039238, 41.001502],
            [-104.053249, 41.001406],
          ],
        ],
      },
      properties: { region: 'ROCKIES' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-71.85957, 41.322399],
              [-71.862109, 41.316612],
              [-71.862772, 41.309791],
              [-71.857432, 41.306318],
              [-71.833755, 41.315631],
              [-71.785957, 41.325739],
              [-71.773702, 41.327977],
              [-71.729247, 41.33099],
              [-71.72074, 41.331567],
              [-71.701631, 41.336968],
              [-71.68807, 41.342823],
              [-71.624505, 41.36087],
              [-71.555381, 41.373316],
              [-71.526724, 41.376636],
              [-71.513401, 41.374702],
              [-71.483295, 41.371722],
              [-71.474918, 41.386104],
              [-71.455371, 41.407962],
              [-71.455845, 41.432986],
              [-71.448948, 41.438479],
              [-71.441199, 41.441602],
              [-71.43767, 41.441302],
              [-71.433612, 41.444995],
              [-71.428652, 41.454158],
              [-71.427935, 41.459529],
              [-71.430926, 41.465655],
              [-71.430744, 41.470636],
              [-71.422991, 41.472682],
              [-71.421157, 41.469888],
              [-71.418404, 41.472652],
              [-71.417621, 41.477934],
              [-71.417957, 41.482073],
              [-71.419971, 41.484758],
              [-71.421425, 41.498629],
              [-71.414937, 41.516303],
              [-71.414825, 41.523126],
              [-71.417398, 41.534536],
              [-71.421649, 41.537892],
              [-71.442567, 41.565075],
              [-71.447712, 41.5804],
              [-71.40377, 41.589321],
              [-71.408636, 41.653819],
              [-71.409302, 41.662643],
              [-71.425452, 41.670785],
              [-71.430038, 41.667541],
              [-71.444468, 41.664409],
              [-71.449318, 41.687401],
              [-71.445923, 41.691144],
              [-71.441896, 41.690025],
              [-71.443082, 41.688303],
              [-71.441336, 41.686446],
              [-71.418069, 41.684208],
              [-71.390551, 41.684096],
              [-71.389432, 41.683425],
              [-71.390775, 41.680629],
              [-71.38988, 41.671903],
              [-71.382049, 41.667317],
              [-71.37791, 41.666646],
              [-71.372988, 41.672575],
              [-71.365717, 41.694947],
              [-71.365717, 41.711615],
              [-71.353748, 41.724702],
              [-71.353172, 41.725191],
              [-71.350057, 41.727835],
              [-71.342786, 41.728506],
              [-71.31482, 41.723808],
              [-71.305759, 41.718662],
              [-71.291217, 41.702666],
              [-71.293119, 41.688347],
              [-71.298935, 41.681524],
              [-71.302627, 41.681747],
              [-71.306095, 41.672575],
              [-71.303746, 41.654788],
              [-71.301396, 41.649978],
              [-71.299159, 41.649531],
              [-71.290546, 41.662395],
              [-71.287637, 41.672463],
              [-71.280366, 41.672575],
              [-71.26918, 41.6549],
              [-71.270075, 41.652439],
              [-71.267055, 41.644945],
              [-71.25956, 41.642595],
              [-71.24155, 41.667205],
              [-71.237635, 41.681635],
              [-71.240991, 41.697744],
              [-71.227875, 41.705498],
              [-71.224798, 41.710498],
              [-71.19564, 41.67509],
              [-71.212136, 41.641945],
              [-71.251082, 41.63878],
              [-71.271862, 41.623986],
              [-71.275234, 41.619444],
              [-71.272412, 41.615041],
              [-71.273445, 41.60699],
              [-71.285142, 41.577127],
              [-71.288376, 41.573274],
              [-71.294363, 41.571416],
              [-71.303652, 41.559925],
              [-71.310533, 41.54692],
              [-71.313079, 41.534672],
              [-71.330831, 41.518364],
              [-71.330694, 41.507699],
              [-71.327804, 41.504258],
              [-71.323125, 41.503088],
              [-71.317414, 41.488776],
              [-71.316519, 41.47756],
              [-71.335992, 41.469647],
              [-71.34707, 41.47123],
              [-71.36152, 41.464831],
              [-71.36176, 41.463955],
              [-71.362012, 41.463041],
              [-71.362736, 41.460405],
              [-71.362743, 41.460379],
              [-71.362699, 41.460343],
              [-71.362288, 41.460006],
              [-71.362201, 41.459934],
              [-71.361852, 41.459647],
              [-71.359292, 41.457542],
              [-71.359136, 41.457414],
              [-71.359015, 41.457314],
              [-71.358657, 41.457019],
              [-71.358356, 41.456772],
              [-71.358262, 41.456695],
              [-71.358166, 41.456616],
              [-71.351457, 41.451099],
              [-71.351096, 41.450802],
              [-71.337695, 41.448902],
              [-71.337377, 41.449033],
              [-71.32141, 41.4556],
              [-71.312718, 41.454597],
              [-71.312694, 41.451402],
              [-71.311404, 41.450807],
              [-71.311394, 41.450802],
              [-71.311344, 41.450829],
              [-71.310473, 41.451289],
              [-71.310357, 41.45135],
              [-71.305896, 41.453708],
              [-71.304604, 41.454391],
              [-71.304394, 41.454502],
              [-71.304247, 41.454976],
              [-71.302929, 41.459213],
              [-71.302895, 41.459323],
              [-71.302741, 41.459817],
              [-71.302583, 41.460325],
              [-71.300438, 41.46722],
              [-71.296517, 41.479829],
              [-71.295111, 41.48435],
              [-71.285639, 41.487805],
              [-71.282262, 41.487982],
              [-71.267579, 41.488755],
              [-71.264793, 41.488902],
              [-71.252692, 41.485902],
              [-71.245992, 41.481302],
              [-71.246174, 41.478917],
              [-71.246676, 41.472323],
              [-71.246703, 41.47196],
              [-71.24071, 41.474872],
              [-71.240047, 41.476296],
              [-71.239804, 41.476817],
              [-71.237902, 41.480899],
              [-71.237783, 41.481155],
              [-71.236751, 41.483369],
              [-71.237175, 41.486546],
              [-71.238586, 41.486845],
              [-71.240614, 41.500557],
              [-71.233435, 41.514045],
              [-71.233141, 41.514598],
              [-71.233056, 41.514757],
              [-71.229444, 41.521544],
              [-71.227989, 41.528297],
              [-71.234775, 41.532538],
              [-71.236642, 41.535852],
              [-71.23613, 41.574767],
              [-71.2436, 41.587508],
              [-71.240709, 41.619225],
              [-71.21616, 41.62549],
              [-71.212004, 41.62299],
              [-71.212417, 41.61829],
              [-71.212656, 41.610072],
              [-71.20778, 41.60066],
              [-71.20865, 41.571028],
              [-71.213563, 41.545818],
              [-71.200788, 41.514371],
              [-71.206382, 41.499215],
              [-71.199692, 41.495511],
              [-71.19939, 41.491769],
              [-71.190167, 41.484285],
              [-71.190016, 41.478275],
              [-71.196607, 41.464756],
              [-71.196857, 41.461116],
              [-71.194967, 41.459037],
              [-71.19302, 41.457931],
              [-71.170131, 41.463974],
              [-71.167345, 41.471405],
              [-71.140224, 41.485855],
              [-71.141093, 41.489937],
              [-71.136867, 41.493942],
              [-71.12057, 41.497448],
              [-71.085663, 41.509292],
              [-71.058418, 41.505967],
              [-71.035514, 41.499047],
              [-71.023523, 41.506326],
              [-71.019354, 41.508857],
              [-71.003275, 41.511912],
              [-70.983354, 41.520616],
              [-70.979225, 41.530427],
              [-70.941785, 41.540121],
              [-70.931545, 41.540169],
              [-70.93783, 41.565239],
              [-70.9473, 41.573659],
              [-70.948797, 41.579038],
              [-70.946911, 41.581089],
              [-70.941588, 41.581034],
              [-70.937978, 41.577416],
              [-70.931338, 41.5842],
              [-70.927393, 41.594064],
              [-70.93, 41.600441],
              [-70.929722, 41.609479],
              [-70.927172, 41.611253],
              [-70.920074, 41.61081],
              [-70.916581, 41.607483],
              [-70.910814, 41.595506],
              [-70.901381, 41.592504],
              [-70.899981, 41.593504],
              [-70.904522, 41.610361],
              [-70.913202, 41.619266],
              [-70.905765, 41.623494],
              [-70.904513, 41.624205],
              [-70.889594, 41.632685],
              [-70.88926, 41.632875],
              [-70.889209, 41.632904],
              [-70.887643, 41.632422],
              [-70.87904, 41.629777],
              [-70.872665, 41.627816],
              [-70.869624, 41.625608],
              [-70.86836, 41.622664],
              [-70.868904, 41.614664],
              [-70.868501, 41.613733],
              [-70.863486, 41.602143],
              [-70.862998, 41.601014],
              [-70.862852, 41.600678],
              [-70.857239, 41.587705],
              [-70.85324, 41.587332],
              [-70.853121, 41.587321],
              [-70.852551, 41.588526],
              [-70.852488, 41.588658],
              [-70.85222, 41.589223],
              [-70.850181, 41.593529],
              [-70.853445, 41.613592],
              [-70.854211, 41.618302],
              [-70.854232, 41.618429],
              [-70.855162, 41.624145],
              [-70.855031, 41.624283],
              [-70.852518, 41.626919],
              [-70.844165, 41.628983],
              [-70.843528, 41.628663],
              [-70.843522, 41.62866],
              [-70.843177, 41.628487],
              [-70.835296, 41.624532],
              [-70.810279, 41.624873],
              [-70.801063, 41.629513],
              [-70.800215, 41.631753],
              [-70.804664, 41.641157],
              [-70.816351, 41.645995],
              [-70.815729, 41.652796],
              [-70.813286, 41.65567],
              [-70.809118, 41.656437],
              [-70.776709, 41.650756],
              [-70.775798, 41.649145],
              [-70.773654, 41.645033],
              [-70.769318, 41.641145],
              [-70.765463, 41.641575],
              [-70.757622, 41.654265],
              [-70.758198, 41.661225],
              [-70.76236, 41.667735],
              [-70.761497, 41.676641],
              [-70.761481, 41.676808],
              [-70.755347, 41.694326],
              [-70.744396, 41.696967],
              [-70.729395, 41.68814],
              [-70.719575, 41.685002],
              [-70.717451, 41.69398],
              [-70.721302, 41.712968],
              [-70.728933, 41.723433],
              [-70.726331, 41.732731],
              [-70.718739, 41.73574],
              [-70.708193, 41.730959],
              [-70.670453, 41.721912],
              [-70.656596, 41.715401],
              [-70.651093, 41.715715],
              [-70.644641, 41.71898],
              [-70.642914, 41.71841],
              [-70.626529, 41.712995],
              [-70.623652, 41.707398],
              [-70.62544, 41.698691],
              [-70.645962, 41.693794],
              [-70.661475, 41.681756],
              [-70.649285, 41.680943],
              [-70.646308, 41.678433],
              [-70.637632, 41.654573],
              [-70.638695, 41.649427],
              [-70.650419, 41.644202],
              [-70.652614, 41.637829],
              [-70.645251, 41.633547],
              [-70.640003, 41.624616],
              [-70.651986, 41.610184],
              [-70.652449, 41.60521],
              [-70.64204, 41.583066],
              [-70.640948, 41.577325],
              [-70.642748, 41.572385],
              [-70.64878, 41.56987],
              [-70.653899, 41.56516],
              [-70.655365, 41.557498],
              [-70.654302, 41.549926],
              [-70.658659, 41.543385],
              [-70.6948, 41.52564],
              [-70.745053, 41.500966],
              [-70.753905, 41.492256],
              [-70.775268, 41.477465],
              [-70.787769, 41.474609],
              [-70.802186, 41.460864],
              [-70.828546, 41.456448],
              [-70.855265, 41.448892],
              [-70.883247, 41.432239],
              [-70.906011, 41.425708],
              [-70.91164, 41.424484],
              [-70.918983, 41.4253],
              [-70.923698, 41.430716],
              [-70.928165, 41.431265],
              [-70.949861, 41.415323],
              [-70.951045, 41.411777],
              [-70.948431, 41.409193],
              [-70.937282, 41.411618],
              [-70.928197, 41.415781],
              [-70.902763, 41.421061],
              [-70.866946, 41.422378],
              [-70.857528, 41.425767],
              [-70.835867, 41.441877],
              [-70.817478, 41.445562],
              [-70.79027, 41.446339],
              [-70.760863, 41.460947],
              [-70.756481, 41.465977],
              [-70.757171, 41.469917],
              [-70.734306, 41.486335],
              [-70.705181, 41.496677],
              [-70.675379, 41.512623],
              [-70.669518, 41.513339],
              [-70.663856, 41.514031],
              [-70.654168, 41.518992],
              [-70.654104, 41.519025],
              [-70.65205, 41.521639],
              [-70.651566, 41.522254],
              [-70.650128, 41.524084],
              [-70.650059, 41.524172],
              [-70.643627, 41.532357],
              [-70.6338, 41.538141],
              [-70.633713, 41.538192],
              [-70.633607, 41.538254],
              [-70.617911, 41.541553],
              [-70.617638, 41.541611],
              [-70.617223, 41.541698],
              [-70.616715, 41.541805],
              [-70.614398, 41.542292],
              [-70.613006, 41.542584],
              [-70.611147, 41.542975],
              [-70.611081, 41.542989],
              [-70.59657, 41.544497],
              [-70.58957, 41.545225],
              [-70.588894, 41.545295],
              [-70.58881, 41.545304],
              [-70.588494, 41.545336],
              [-70.588412, 41.545345],
              [-70.574023, 41.54684],
              [-70.561261, 41.548167],
              [-70.560909, 41.548203],
              [-70.559728, 41.548326],
              [-70.559689, 41.54833],
              [-70.559482, 41.548334],
              [-70.53164, 41.548807],
              [-70.522327, 41.548965],
              [-70.522009, 41.548999],
              [-70.493244, 41.552044],
              [-70.486815, 41.553887],
              [-70.485571, 41.554244],
              [-70.485155, 41.554434],
              [-70.48335, 41.555259],
              [-70.476275, 41.558493],
              [-70.476256, 41.558502],
              [-70.476231, 41.558524],
              [-70.473328, 41.561106],
              [-70.472778, 41.561595],
              [-70.462239, 41.570965],
              [-70.462206, 41.570995],
              [-70.46196, 41.571213],
              [-70.461278, 41.57182],
              [-70.461093, 41.572051],
              [-70.457356, 41.576724],
              [-70.456052, 41.578355],
              [-70.450382, 41.585445],
              [-70.446543, 41.590247],
              [-70.445289, 41.591815],
              [-70.44435, 41.593393],
              [-70.442225, 41.596963],
              [-70.440556, 41.599767],
              [-70.437889, 41.604249],
              [-70.437246, 41.605329],
              [-70.413944, 41.606965],
              [-70.408535, 41.607345],
              [-70.401148, 41.606451],
              [-70.400581, 41.606382],
              [-70.379151, 41.611361],
              [-70.369854, 41.615888],
              [-70.364744, 41.623671],
              [-70.364892, 41.626721],
              [-70.360352, 41.631069],
              [-70.351634, 41.634687],
              [-70.338067, 41.636338],
              [-70.329924, 41.634578],
              [-70.321588, 41.630508],
              [-70.29062, 41.635196],
              [-70.28132, 41.635125],
              [-70.274522, 41.632927],
              [-70.26913, 41.625742],
              [-70.269687, 41.617775],
              [-70.267587, 41.610912],
              [-70.265424, 41.609333],
              [-70.259601, 41.610863],
              [-70.25542, 41.617541],
              [-70.25621, 41.620698],
              [-70.245867, 41.628479],
              [-70.191061, 41.645259],
              [-70.158621, 41.650438],
              [-70.148435, 41.650429],
              [-70.147011, 41.650428],
              [-70.145882, 41.650427],
              [-70.142592, 41.650424],
              [-70.141141, 41.650423],
              [-70.141049, 41.650423],
              [-70.140877, 41.650423],
              [-70.140437, 41.650529],
              [-70.140207, 41.650584],
              [-70.140163, 41.650594],
              [-70.134702, 41.651905],
              [-70.122689, 41.654787],
              [-70.122597, 41.654809],
              [-70.121351, 41.655108],
              [-70.120935, 41.655208],
              [-70.119904, 41.655455],
              [-70.089238, 41.662813],
              [-70.055523, 41.664843],
              [-70.037757, 41.666812],
              [-70.037255, 41.666868],
              [-70.037145, 41.66688],
              [-70.029346, 41.667744],
              [-70.029319, 41.667751],
              [-70.029119, 41.667807],
              [-70.020964, 41.670085],
              [-70.015789, 41.67153],
              [-70.014211, 41.671971],
              [-70.007153, 41.671587],
              [-70.007011, 41.671579],
              [-70.006833, 41.671506],
              [-70.003016, 41.669931],
              [-70.002697, 41.669799],
              [-69.996509, 41.667246],
              [-69.996359, 41.667184],
              [-69.996194, 41.667076],
              [-69.99079, 41.663556],
              [-69.990748, 41.663528],
              [-69.990734, 41.663519],
              [-69.990668, 41.663476],
              [-69.990659, 41.663471],
              [-69.975811, 41.653798],
              [-69.975719, 41.653738],
              [-69.973153, 41.646963],
              [-69.973037, 41.641126],
              [-69.973035, 41.641046],
              [-69.975245, 41.635978],
              [-69.975579, 41.635212],
              [-69.976641, 41.632777],
              [-69.976886, 41.632213],
              [-69.977489, 41.630832],
              [-69.980418, 41.624113],
              [-69.982946, 41.618316],
              [-69.987111, 41.608765],
              [-69.987192, 41.608579],
              [-69.991723, 41.58851],
              [-69.994357, 41.576846],
              [-70.000627, 41.563827],
              [-70.000937, 41.563184],
              [-70.001281, 41.56247],
              [-70.00153, 41.561953],
              [-70.008854, 41.55451],
              [-70.010644, 41.552692],
              [-70.011596, 41.552766],
              [-70.015059, 41.553037],
              [-70.016584, 41.550772],
              [-70.014456, 41.545534],
              [-70.011725, 41.54312],
              [-70.011504, 41.542924],
              [-70.011211, 41.542892],
              [-70.004554, 41.542166],
              [-70.004136, 41.54212],
              [-70.003768, 41.542213],
              [-69.999063, 41.5434],
              [-69.998071, 41.54365],
              [-69.996546, 41.54536],
              [-69.988495, 41.55439],
              [-69.988215, 41.554704],
              [-69.982768, 41.581812],
              [-69.976478, 41.603664],
              [-69.967869, 41.627503],
              [-69.963234, 41.633794],
              [-69.958272, 41.639429],
              [-69.956862, 41.639701],
              [-69.953924, 41.640268],
              [-69.952844, 41.640476],
              [-69.951911, 41.640656],
              [-69.951169, 41.640799],
              [-69.947599, 41.645394],
              [-69.943474, 41.652406],
              [-69.942742, 41.653649],
              [-69.93412, 41.668304],
              [-69.933149, 41.669955],
              [-69.933114, 41.670014],
              [-69.9309, 41.67991],
              [-69.929457, 41.686357],
              [-69.929377, 41.686713],
              [-69.928723, 41.689634],
              [-69.928261, 41.6917],
              [-69.928265, 41.692242],
              [-69.928265, 41.692247],
              [-69.928275, 41.693504],
              [-69.928308, 41.697681],
              [-69.928311, 41.697981],
              [-69.928652, 41.74125],
              [-69.935952, 41.809422],
              [-69.945314, 41.845222],
              [-69.968598, 41.9117],
              [-69.986024, 41.949465],
              [-69.986085, 41.949597],
              [-69.986196, 41.949769],
              [-70.004271, 41.977865],
              [-70.004608, 41.978389],
              [-70.005332, 41.979515],
              [-70.005458, 41.97971],
              [-70.005717, 41.980113],
              [-70.01051, 41.987563],
              [-70.011898, 41.98972],
              [-70.011957, 41.989796],
              [-70.013876, 41.992285],
              [-70.014109, 41.992587],
              [-70.01628, 41.995403],
              [-70.029449, 42.012482],
              [-70.029953, 42.013135],
              [-70.031054, 42.014562],
              [-70.033501, 42.017736],
              [-70.034806, 42.018916],
              [-70.058531, 42.040363],
              [-70.082624, 42.054657],
              [-70.115968, 42.067638],
              [-70.154177, 42.077139],
              [-70.160166, 42.078628],
              [-70.189305, 42.082337],
              [-70.206899, 42.0819],
              [-70.225626, 42.078601],
              [-70.238087, 42.072878],
              [-70.245385, 42.063733],
              [-70.24354, 42.060569],
              [-70.238875, 42.060479],
              [-70.233256, 42.057714],
              [-70.218701, 42.045848],
              [-70.208016, 42.03073],
              [-70.196693, 42.022429],
              [-70.190834, 42.020028],
              [-70.186708, 42.019904],
              [-70.186295, 42.021308],
              [-70.193074, 42.027576],
              [-70.195345, 42.034163],
              [-70.194456, 42.03947],
              [-70.186816, 42.05045],
              [-70.178468, 42.05642],
              [-70.169781, 42.059736],
              [-70.155415, 42.062409],
              [-70.148294, 42.06195],
              [-70.147411, 42.06159],
              [-70.123043, 42.051668],
              [-70.10806, 42.043601],
              [-70.095595, 42.032832],
              [-70.089578, 42.024896],
              [-70.083775, 42.012041],
              [-70.077421, 41.985497],
              [-70.074006, 41.93865],
              [-70.073039, 41.899783],
              [-70.070889, 41.882973],
              [-70.067566, 41.877793],
              [-70.066002, 41.877011],
              [-70.064084, 41.878924],
              [-70.065372, 41.887702],
              [-70.065723, 41.899641],
              [-70.065671, 41.911658],
              [-70.054464, 41.927366],
              [-70.044995, 41.930049],
              [-70.030537, 41.929154],
              [-70.025553, 41.911699],
              [-70.024335, 41.89882],
              [-70.012154, 41.891656],
              [-70.002922, 41.890315],
              [-70.000188, 41.886938],
              [-70.009013, 41.876625],
              [-70.004486, 41.838826],
              [-70.003842, 41.80852],
              [-70.008462, 41.800786],
              [-70.008882, 41.80044],
              [-70.009936, 41.79957],
              [-70.022381, 41.789305],
              [-70.022809, 41.788952],
              [-70.023082, 41.788726],
              [-70.024658, 41.787427],
              [-70.024734, 41.787364],
              [-70.033223, 41.78425],
              [-70.033874, 41.784011],
              [-70.03439, 41.783822],
              [-70.060674, 41.77418],
              [-70.064314, 41.772845],
              [-70.065142, 41.772681],
              [-70.067603, 41.772193],
              [-70.081833, 41.769371],
              [-70.086376, 41.76847],
              [-70.096061, 41.766549],
              [-70.096768, 41.766339],
              [-70.097658, 41.766074],
              [-70.097666, 41.766072],
              [-70.109319, 41.762606],
              [-70.115067, 41.760896],
              [-70.115895, 41.76065],
              [-70.121978, 41.758841],
              [-70.122132, 41.758851],
              [-70.12407, 41.758973],
              [-70.124364, 41.758991],
              [-70.129065, 41.759287],
              [-70.136007, 41.759724],
              [-70.14038, 41.759999],
              [-70.141519, 41.760071],
              [-70.141533, 41.760072],
              [-70.143444, 41.759639],
              [-70.143848, 41.759547],
              [-70.159127, 41.756085],
              [-70.176566, 41.752134],
              [-70.182076, 41.750885],
              [-70.189117, 41.751961],
              [-70.189254, 41.751982],
              [-70.193202, 41.750657],
              [-70.197525, 41.749206],
              [-70.198037, 41.749034],
              [-70.216073, 41.742981],
              [-70.216697, 41.742674],
              [-70.220842, 41.740632],
              [-70.224006, 41.739074],
              [-70.224462, 41.738849],
              [-70.225312, 41.738431],
              [-70.225881, 41.73815],
              [-70.23485, 41.733733],
              [-70.235048, 41.733572],
              [-70.237418, 41.731648],
              [-70.24705, 41.723825],
              [-70.247379, 41.723558],
              [-70.247935, 41.723106],
              [-70.250704, 41.720858],
              [-70.251794, 41.719973],
              [-70.252686, 41.719248],
              [-70.256395, 41.716236],
              [-70.259205, 41.713954],
              [-70.26144, 41.714035],
              [-70.263097, 41.714095],
              [-70.263654, 41.714115],
              [-70.263831, 41.714263],
              [-70.272289, 41.721346],
              [-70.274188, 41.724471],
              [-70.275164, 41.726079],
              [-70.275203, 41.726143],
              [-70.275393, 41.726242],
              [-70.277064, 41.727108],
              [-70.288323, 41.732946],
              [-70.290788, 41.734224],
              [-70.290957, 41.734312],
              [-70.291301, 41.73433],
              [-70.314667, 41.735567],
              [-70.31529, 41.7356],
              [-70.318091, 41.735748],
              [-70.375253, 41.738774],
              [-70.375341, 41.738779],
              [-70.376992, 41.739029],
              [-70.412071, 41.744336],
              [-70.412476, 41.744397],
              [-70.413713, 41.744756],
              [-70.458968, 41.757906],
              [-70.471552, 41.761563],
              [-70.471807, 41.761702],
              [-70.471969, 41.761791],
              [-70.471999, 41.761808],
              [-70.473335, 41.762539],
              [-70.473707, 41.762743],
              [-70.474051, 41.762931],
              [-70.482152, 41.767368],
              [-70.483477, 41.768094],
              [-70.492884, 41.773245],
              [-70.493016, 41.773318],
              [-70.494048, 41.773883],
              [-70.514424, 41.788771],
              [-70.514483, 41.788814],
              [-70.514603, 41.788901],
              [-70.516101, 41.789996],
              [-70.516651, 41.790398],
              [-70.516921, 41.790595],
              [-70.517411, 41.790953],
              [-70.517615, 41.791139],
              [-70.518468, 41.791912],
              [-70.52507, 41.797907],
              [-70.532656, 41.804796],
              [-70.533303, 41.805643],
              [-70.533823, 41.806323],
              [-70.537289, 41.810859],
              [-70.54103, 41.815754],
              [-70.543168, 41.824446],
              [-70.542065, 41.831263],
              [-70.535487, 41.839381],
              [-70.525567, 41.85873],
              [-70.532084, 41.889568],
              [-70.545949, 41.907158],
              [-70.54741, 41.911934],
              [-70.546386, 41.916751],
              [-70.552941, 41.929641],
              [-70.583572, 41.950007],
              [-70.598078, 41.947772],
              [-70.608166, 41.940701],
              [-70.616491, 41.940204],
              [-70.623513, 41.943273],
              [-70.631251, 41.950475],
              [-70.648365, 41.961672],
              [-70.651673, 41.958701],
              [-70.662476, 41.960592],
              [-70.698981, 41.987103],
              [-70.710034, 41.999544],
              [-70.712204, 42.007586],
              [-70.695809, 42.013346],
              [-70.686798, 42.012764],
              [-70.678798, 42.00551],
              [-70.670934, 42.007786],
              [-70.667512, 42.01232],
              [-70.671666, 42.02139],
              [-70.66936, 42.037116],
              [-70.650874, 42.046247],
              [-70.644337, 42.045895],
              [-70.643208, 42.050821],
              [-70.64819, 42.068441],
              [-70.647349, 42.076331],
              [-70.63848, 42.081579],
              [-70.640169, 42.088633],
              [-70.663931, 42.108336],
              [-70.685315, 42.133025],
              [-70.706264, 42.163137],
              [-70.714301, 42.168783],
              [-70.718707, 42.184853],
              [-70.722269, 42.207959],
              [-70.73056, 42.21094],
              [-70.74723, 42.221816],
              [-70.754488, 42.228673],
              [-70.764757, 42.244062],
              [-70.770964, 42.249197],
              [-70.780722, 42.251792],
              [-70.788724, 42.25392],
              [-70.811742, 42.262935],
              [-70.824661, 42.265935],
              [-70.831075, 42.267424],
              [-70.851093, 42.26827],
              [-70.861807, 42.275965],
              [-70.870873, 42.285668],
              [-70.881242, 42.300663],
              [-70.882764, 42.30886],
              [-70.907556, 42.307889],
              [-70.91749, 42.305686],
              [-70.915588, 42.302463],
              [-70.897123, 42.29586],
              [-70.895778, 42.292436],
              [-70.896267, 42.2851],
              [-70.906302, 42.271636],
              [-70.910941, 42.265412],
              [-70.923169, 42.263211],
              [-70.935886, 42.264189],
              [-70.945547, 42.269081],
              [-70.948971, 42.272505],
              [-70.967351, 42.268168],
              [-70.98909, 42.267449],
              [-70.996097, 42.271222],
              [-71.0049, 42.28272],
              [-71.006158, 42.28811],
              [-71.000948, 42.302483],
              [-71.005399, 42.307196],
              [-71.013165, 42.315419],
              [-71.01568, 42.326019],
              [-71.011804, 42.335274],
              [-71.010146, 42.339234],
              [-71.006877, 42.347039],
              [-70.998253, 42.352788],
              [-70.982282, 42.35592],
              [-70.979927, 42.356382],
              [-70.974897, 42.355843],
              [-70.972418, 42.353875],
              [-70.963578, 42.34686],
              [-70.953022, 42.343973],
              [-70.953292, 42.349698],
              [-70.960798, 42.360648],
              [-70.972223, 42.377316],
              [-70.972706, 42.381759],
              [-70.972513, 42.385042],
              [-70.97174, 42.387071],
              [-70.970195, 42.388036],
              [-70.972706, 42.389968],
              [-70.980336, 42.391513],
              [-70.983426, 42.396246],
              [-70.985068, 42.402041],
              [-70.989195, 42.402598],
              [-70.990595, 42.407098],
              [-70.987694, 42.416696],
              [-70.982994, 42.423996],
              [-70.960835, 42.441272],
              [-70.960647, 42.443787],
              [-70.96047, 42.446166],
              [-70.94702, 42.456236],
              [-70.943612, 42.452092],
              [-70.943295, 42.436248],
              [-70.936393, 42.418097],
              [-70.905692, 42.416197],
              [-70.901992, 42.420297],
              [-70.908392, 42.425197],
              [-70.913192, 42.427697],
              [-70.928226, 42.430986],
              [-70.933155, 42.437833],
              [-70.934264, 42.444646],
              [-70.934993, 42.457896],
              [-70.921993, 42.466696],
              [-70.917693, 42.467996],
              [-70.908092, 42.466896],
              [-70.894292, 42.460896],
              [-70.887292, 42.464896],
              [-70.887992, 42.467096],
              [-70.886493, 42.470197],
              [-70.879692, 42.478796],
              [-70.857791, 42.490296],
              [-70.847391, 42.491496],
              [-70.841591, 42.487596],
              [-70.835991, 42.490496],
              [-70.831091, 42.503596],
              [-70.842091, 42.519495],
              [-70.857125, 42.521492],
              [-70.859751, 42.520441],
              [-70.866279, 42.522617],
              [-70.872357, 42.542952],
              [-70.871382, 42.546404],
              [-70.848492, 42.550195],
              [-70.823291, 42.551495],
              [-70.815391, 42.554195],
              [-70.804091, 42.561595],
              [-70.757283, 42.570455],
              [-70.737044, 42.576863],
              [-70.729688, 42.57151],
              [-70.698574, 42.577393],
              [-70.684502, 42.588858],
              [-70.681428, 42.593173],
              [-70.678819, 42.594389],
              [-70.675747, 42.594669],
              [-70.672583, 42.594296],
              [-70.670442, 42.592249],
              [-70.668488, 42.589643],
              [-70.668115, 42.585361],
              [-70.668022, 42.581732],
              [-70.664887, 42.580436],
              [-70.654727, 42.582234],
              [-70.635635, 42.600243],
              [-70.61842, 42.62864],
              [-70.605611, 42.634898],
              [-70.594014, 42.63503],
              [-70.591469, 42.639821],
              [-70.591742, 42.648508],
              [-70.595474, 42.660336],
              [-70.61482, 42.65765],
              [-70.622791, 42.660873],
              [-70.623815, 42.665481],
              [-70.622864, 42.67599],
              [-70.620031, 42.688006],
              [-70.630077, 42.692699],
              [-70.645101, 42.689423],
              [-70.663548, 42.677603],
              [-70.681594, 42.662342],
              [-70.682594, 42.654525],
              [-70.689402, 42.653319],
              [-70.728845, 42.663877],
              [-70.72982, 42.669602],
              [-70.744427, 42.682092],
              [-70.748752, 42.683878],
              [-70.764421, 42.68565],
              [-70.778671, 42.693622],
              [-70.778552, 42.69852],
              [-70.770453, 42.704824],
              [-70.772267, 42.711064],
              [-70.792867, 42.747118],
              [-70.80522, 42.781798],
              [-70.817731, 42.850613],
              [-70.817296, 42.87229],
              [-70.816321, 42.884487],
              [-70.81461, 42.891346],
              [-70.810069, 42.909549],
              [-70.795596, 42.93629],
              [-70.759975, 42.988592],
              [-70.749024, 42.995467],
              [-70.74457, 43.00009],
              [-70.718936, 43.03235],
              [-70.703936, 43.059621],
              [-70.673114, 43.070314],
              [-70.665958, 43.076234],
              [-70.656223, 43.093164],
              [-70.655322, 43.098008],
              [-70.654213, 43.099065],
              [-70.638355, 43.114182],
              [-70.634311, 43.122162],
              [-70.634455, 43.127603],
              [-70.618973, 43.163625],
              [-70.587814, 43.199858],
              [-70.576692, 43.217651],
              [-70.575787, 43.221859],
              [-70.591022, 43.237851],
              [-70.593907, 43.249295],
              [-70.585184, 43.270113],
              [-70.562779, 43.310614],
              [-70.553854, 43.321886],
              [-70.536702, 43.335605],
              [-70.535244, 43.336771],
              [-70.517695, 43.344037],
              [-70.485312, 43.346391],
              [-70.472933, 43.343972],
              [-70.465975, 43.340246],
              [-70.460717, 43.34325],
              [-70.442438, 43.356487],
              [-70.424986, 43.375928],
              [-70.424421, 43.379656],
              [-70.427672, 43.389254],
              [-70.421282, 43.395777],
              [-70.406416, 43.400942],
              [-70.401666, 43.401262],
              [-70.400035, 43.399927],
              [-70.39089, 43.402607],
              [-70.383981, 43.41294],
              [-70.384949, 43.418839],
              [-70.370514, 43.434133],
              [-70.362015, 43.439077],
              [-70.349684, 43.442032],
              [-70.37223, 43.45508],
              [-70.380233, 43.46423],
              [-70.382928, 43.469674],
              [-70.385615, 43.487031],
              [-70.384885, 43.49604],
              [-70.379123, 43.507202],
              [-70.361214, 43.52919],
              [-70.353392, 43.535405],
              [-70.352826, 43.535855],
              [-70.341793, 43.540484],
              [-70.307764, 43.544315],
              [-70.299184, 43.550589],
              [-70.272497, 43.562616],
              [-70.261917, 43.553687],
              [-70.244331, 43.551849],
              [-70.231963, 43.561118],
              [-70.219784, 43.562149],
              [-70.216782, 43.556874],
              [-70.206123, 43.557627],
              [-70.196911, 43.565146],
              [-70.20112, 43.586515],
              [-70.214369, 43.590445],
              [-70.217087, 43.596717],
              [-70.211204, 43.625765],
              [-70.22299, 43.639023],
              [-70.240987, 43.659132],
              [-70.241942, 43.663296],
              [-70.240119, 43.664685],
              [-70.239512, 43.665986],
              [-70.242289, 43.669544],
              [-70.247321, 43.671973],
              [-70.252961, 43.67501],
              [-70.254144, 43.676839],
              [-70.251812, 43.683251],
              [-70.23199, 43.704822],
              [-70.227909, 43.701907],
              [-70.216832, 43.704822],
              [-70.215666, 43.707737],
              [-70.219164, 43.715899],
              [-70.217998, 43.71998],
              [-70.194678, 43.742134],
              [-70.194095, 43.745632],
              [-70.197593, 43.753211],
              [-70.194678, 43.766037],
              [-70.190014, 43.771866],
              [-70.17544, 43.777113],
              [-70.172525, 43.773615],
              [-70.177772, 43.764871],
              [-70.176023, 43.76079],
              [-70.153869, 43.774781],
              [-70.153869, 43.781194],
              [-70.142792, 43.791688],
              [-70.107229, 43.809178],
              [-70.080995, 43.819672],
              [-70.06642, 43.819672],
              [-70.064671, 43.813259],
              [-70.053011, 43.821421],
              [-70.053594, 43.828417],
              [-70.032023, 43.849988],
              [-70.022845, 43.856245],
              [-70.019197, 43.858733],
              [-70.009869, 43.859315],
              [-70.002874, 43.852903],
              [-70.002874, 43.848239],
              [-70.006954, 43.844158],
              [-70.023278, 43.834247],
              [-70.026193, 43.829],
              [-70.026193, 43.822587],
              [-70.011035, 43.810927],
              [-70.002874, 43.812093],
              [-69.999376, 43.805097],
              [-69.99821, 43.798684],
              [-70.005205, 43.787607],
              [-70.02561, 43.769534],
              [-70.034355, 43.759041],
              [-70.040768, 43.745049],
              [-70.041351, 43.738053],
              [-70.001708, 43.744466],
              [-69.998793, 43.740385],
              [-70.001125, 43.733389],
              [-70.005205, 43.727559],
              [-70.006954, 43.717065],
              [-70.001645, 43.717666],
              [-69.992615, 43.724793],
              [-69.992396, 43.726852],
              [-69.994479, 43.728451],
              [-69.989131, 43.743227],
              [-69.982574, 43.750801],
              [-69.958056, 43.767786],
              [-69.953246, 43.768806],
              [-69.948539, 43.765948],
              [-69.927011, 43.780174],
              [-69.915593, 43.775112],
              [-69.903164, 43.77239],
              [-69.88739, 43.777052],
              [-69.884066, 43.778035],
              [-69.869732, 43.775656],
              [-69.862155, 43.758962],
              [-69.868673, 43.742701],
              [-69.858947, 43.740531],
              [-69.855595, 43.73266],
              [-69.857927, 43.723915],
              [-69.855081, 43.704746],
              [-69.851297, 43.703581],
              [-69.838689, 43.70514],
              [-69.835323, 43.721125],
              [-69.778348, 43.744612],
              [-69.778494, 43.747089],
              [-69.782283, 43.75117],
              [-69.782429, 43.753794],
              [-69.780097, 43.755397],
              [-69.761587, 43.757],
              [-69.752801, 43.75594],
              [-69.719723, 43.786685],
              [-69.717074, 43.792403],
              [-69.717804, 43.801047],
              [-69.714873, 43.810264],
              [-69.705838, 43.823024],
              [-69.697858, 43.824918],
              [-69.697239, 43.825065],
              [-69.692429, 43.824336],
              [-69.685579, 43.820546],
              [-69.685473, 43.816328],
              [-69.664922, 43.791033],
              [-69.653337, 43.79103],
              [-69.650818, 43.803785],
              [-69.65315, 43.817194],
              [-69.649798, 43.836287],
              [-69.634932, 43.845907],
              [-69.629685, 43.843429],
              [-69.630268, 43.837016],
              [-69.621086, 43.826814],
              [-69.61511, 43.831623],
              [-69.613069, 43.837453],
              [-69.613215, 43.845032],
              [-69.604616, 43.858004],
              [-69.594705, 43.858878],
              [-69.589167, 43.851299],
              [-69.592373, 43.830895],
              [-69.598495, 43.825502],
              [-69.604616, 43.825793],
              [-69.605928, 43.814862],
              [-69.604179, 43.813551],
              [-69.588551, 43.81836],
              [-69.578527, 43.823316],
              [-69.575466, 43.841972],
              [-69.572697, 43.844012],
              [-69.568325, 43.844449],
              [-69.558122, 43.84066],
              [-69.552606, 43.841347],
              [-69.545028, 43.861241],
              [-69.550616, 43.872579],
              [-69.550908, 43.877971],
              [-69.54945, 43.880012],
              [-69.543912, 43.881615],
              [-69.524673, 43.875639],
              [-69.520301, 43.868498],
              [-69.513267, 43.84479],
              [-69.516212, 43.837222],
              [-69.514889, 43.831298],
              [-69.50329, 43.837673],
              [-69.486243, 43.869118],
              [-69.483498, 43.88028],
              [-69.459637, 43.903316],
              [-69.45107, 43.941955],
              [-69.441596, 43.964254],
              [-69.436495, 43.966878],
              [-69.431686, 43.964546],
              [-69.42876, 43.957929],
              [-69.416165, 43.977267],
              [-69.398455, 43.971804],
              [-69.388059, 43.96434],
              [-69.375478, 43.964584],
              [-69.366702, 43.964755],
              [-69.351961, 43.974748],
              [-69.331411, 43.974311],
              [-69.321808, 43.969975],
              [-69.304301, 43.962068],
              [-69.305176, 43.956676],
              [-69.319751, 43.94487],
              [-69.31427, 43.942951],
              [-69.307776, 43.943451],
              [-69.288513, 43.957665],
              [-69.283998, 43.958569],
              [-69.282559, 43.958105],
              [-69.280498, 43.95744],
              [-69.267515, 43.943667],
              [-69.265257, 43.933393],
              [-69.259838, 43.921427],
              [-69.24271, 43.925465],
              [-69.237368, 43.931596],
              [-69.214205, 43.935583],
              [-69.203668, 43.941806],
              [-69.19633, 43.950504],
              [-69.193805, 43.959762],
              [-69.197803, 43.967547],
              [-69.193805, 43.975543],
              [-69.170345, 43.995637],
              [-69.162559, 43.999003],
              [-69.148883, 43.998582],
              [-69.128611, 44.005922],
              [-69.124475, 44.007419],
              [-69.128052, 44.017309],
              [-69.125738, 44.019623],
              [-69.113113, 44.028881],
              [-69.094177, 44.038981],
              [-69.081131, 44.041295],
              [-69.073767, 44.046135],
              [-69.079805, 44.055256],
              [-69.067876, 44.067596],
              [-69.064299, 44.069911],
              [-69.056093, 44.06949],
              [-69.050622, 44.068017],
              [-69.050566, 44.063152],
              [-69.048917, 44.062506],
              [-69.031878, 44.079036],
              [-69.043403, 44.092164],
              [-69.050814, 44.094888],
              [-69.056303, 44.095162],
              [-69.076452, 44.090634],
              [-69.089078, 44.085326],
              [-69.092, 44.085734],
              [-69.101107, 44.093601],
              [-69.100863, 44.104529],
              [-69.080331, 44.117824],
              [-69.075667, 44.129991],
              [-69.079608, 44.143962],
              [-69.080978, 44.156768],
              [-69.079835, 44.160953],
              [-69.077776, 44.165043],
              [-69.06124, 44.165498],
              [-69.054546, 44.171542],
              [-69.05269, 44.188082],
              [-69.05181, 44.19592],
              [-69.042807, 44.215173],
              [-69.043599, 44.225029],
              [-69.040193, 44.233673],
              [-69.029434, 44.248558],
              [-69.02859, 44.249139],
              [-69.017051, 44.257086],
              [-69.005071, 44.274071],
              [-69.003682, 44.294582],
              [-68.979005, 44.296327],
              [-68.958889, 44.314353],
              [-68.954465, 44.32405],
              [-68.948164, 44.355882],
              [-68.961111, 44.375076],
              [-68.9673, 44.381106],
              [-68.978815, 44.38634],
              [-68.984404, 44.396879],
              [-68.990767, 44.415033],
              [-68.982449, 44.426195],
              [-68.946582, 44.429108],
              [-68.931934, 44.43869],
              [-68.927452, 44.448039],
              [-68.900934, 44.452062],
              [-68.897104, 44.450643],
              [-68.892073, 44.445075],
              [-68.8928, 44.443415],
              [-68.890826, 44.437995],
              [-68.886491, 44.430676],
              [-68.880271, 44.428112],
              [-68.858993, 44.444923],
              [-68.829153, 44.462242],
              [-68.810059, 44.468737],
              [-68.796206, 44.471437],
              [-68.783679, 44.473879],
              [-68.785898, 44.462611],
              [-68.801634, 44.434803],
              [-68.815325, 44.42808],
              [-68.821767, 44.40894],
              [-68.818703, 44.375077],
              [-68.814811, 44.362194],
              [-68.817647, 44.353093],
              [-68.821311, 44.349594],
              [-68.825419, 44.334547],
              [-68.828377, 44.316549],
              [-68.827197, 44.31216],
              [-68.795063, 44.30786],
              [-68.771489, 44.320523],
              [-68.766197, 44.327015],
              [-68.762021, 44.329597],
              [-68.746164, 44.331148],
              [-68.733004, 44.328388],
              [-68.725657, 44.321591],
              [-68.682979, 44.299201],
              [-68.630036, 44.286235],
              [-68.627515, 44.284435],
              [-68.626075, 44.280473],
              [-68.61563, 44.275431],
              [-68.603385, 44.27471],
              [-68.572772, 44.252741],
              [-68.562687, 44.248059],
              [-68.551162, 44.238335],
              [-68.550802, 44.236534],
              [-68.534595, 44.229331],
              [-68.525302, 44.227554],
              [-68.52348, 44.235819],
              [-68.528153, 44.241263],
              [-68.529802, 44.249594],
              [-68.519819, 44.260209],
              [-68.519516, 44.265046],
              [-68.528611, 44.276117],
              [-68.532266, 44.28634],
              [-68.531532, 44.290388],
              [-68.538595, 44.299902],
              [-68.556236, 44.300819],
              [-68.564005, 44.308022],
              [-68.566203, 44.313007],
              [-68.566936, 44.317603],
              [-68.563209, 44.333039],
              [-68.553873, 44.346256],
              [-68.545434, 44.355],
              [-68.550051, 44.371788],
              [-68.559285, 44.374307],
              [-68.564741, 44.385219],
              [-68.56642, 44.394453],
              [-68.565161, 44.39907],
              [-68.560964, 44.402847],
              [-68.555088, 44.403687],
              [-68.534522, 44.397811],
              [-68.529905, 44.39907],
              [-68.51452, 44.41334],
              [-68.505562, 44.411661],
              [-68.499686, 44.414179],
              [-68.494649, 44.429709],
              [-68.485415, 44.434326],
              [-68.480379, 44.432647],
              [-68.472824, 44.404106],
              [-68.480798, 44.397391],
              [-68.483317, 44.388157],
              [-68.47828, 44.378084],
              [-68.466109, 44.377245],
              [-68.461072, 44.378504],
              [-68.461072, 44.385639],
              [-68.464262, 44.391081],
              [-68.464106, 44.398078],
              [-68.458849, 44.412141],
              [-68.46382, 44.436592],
              [-68.460003, 44.443317],
              [-68.455095, 44.447498],
              [-68.448006, 44.449497],
              [-68.439281, 44.448043],
              [-68.429648, 44.439136],
              [-68.432556, 44.426594],
              [-68.433901, 44.401534],
              [-68.427874, 44.3968],
              [-68.421783, 44.396411],
              [-68.416412, 44.397973],
              [-68.392559, 44.41807],
              [-68.390932, 44.427387],
              [-68.387678, 44.430936],
              [-68.3791, 44.430049],
              [-68.372445, 44.42369],
              [-68.359082, 44.402847],
              [-68.3581, 44.392337],
              [-68.360318, 44.389674],
              [-68.36372, 44.388935],
              [-68.367565, 44.39071],
              [-68.398035, 44.376191],
              [-68.395516, 44.369561],
              [-68.396552, 44.363941],
              [-68.406089, 44.356679],
              [-68.409867, 44.356259],
              [-68.421471, 44.337754],
              [-68.421619, 44.336113],
              [-68.409867, 44.329397],
              [-68.409027, 44.32562],
              [-68.411965, 44.322262],
              [-68.430853, 44.312609],
              [-68.430946, 44.298624],
              [-68.426107, 44.295102],
              [-68.421302, 44.284468],
              [-68.41965, 44.274612],
              [-68.401268, 44.252244],
              [-68.389848, 44.247066],
              [-68.377982, 44.247563],
              [-68.369759, 44.243311],
              [-68.365364, 44.237871],
              [-68.343132, 44.229505],
              [-68.339498, 44.222893],
              [-68.317588, 44.225101],
              [-68.290818, 44.247673],
              [-68.295265, 44.261722],
              [-68.297641, 44.263035],
              [-68.298643, 44.26665],
              [-68.298223, 44.276303],
              [-68.289409, 44.283858],
              [-68.275139, 44.288895],
              [-68.233435, 44.288578],
              [-68.191924, 44.306675],
              [-68.173608, 44.328397],
              [-68.174687, 44.343604],
              [-68.184532, 44.369145],
              [-68.196937, 44.386352],
              [-68.20354, 44.392365],
              [-68.209664, 44.392984],
              [-68.21554, 44.390466],
              [-68.249956, 44.414809],
              [-68.249956, 44.417747],
              [-68.24366, 44.420685],
              [-68.2445, 44.429919],
              [-68.247438, 44.433276],
              [-68.268423, 44.440411],
              [-68.294865, 44.432857],
              [-68.299063, 44.437893],
              [-68.298223, 44.449225],
              [-68.281015, 44.451324],
              [-68.270522, 44.459718],
              [-68.268004, 44.47147],
              [-68.261708, 44.484062],
              [-68.252474, 44.483222],
              [-68.2445, 44.471051],
              [-68.22939, 44.463496],
              [-68.224354, 44.464335],
              [-68.227292, 44.479865],
              [-68.223934, 44.487],
              [-68.213861, 44.492456],
              [-68.192036, 44.487419],
              [-68.189937, 44.484901],
              [-68.189517, 44.478605],
              [-68.194554, 44.47189],
              [-68.17105, 44.470211],
              [-68.163075, 44.473149],
              [-68.162656, 44.477346],
              [-68.159298, 44.479445],
              [-68.150904, 44.482383],
              [-68.123203, 44.478815],
              [-68.117746, 44.475038],
              [-68.115228, 44.467903],
              [-68.119425, 44.459508],
              [-68.119845, 44.445658],
              [-68.116487, 44.429289],
              [-68.11271, 44.421314],
              [-68.11229, 44.401588],
              [-68.103818, 44.385111],
              [-68.092983, 44.370949],
              [-68.090045, 44.371369],
              [-68.086268, 44.376405],
              [-68.077873, 44.373047],
              [-68.076066, 44.347925],
              [-68.067047, 44.335692],
              [-68.060356, 44.331988],
              [-68.049334, 44.33073],
              [-68.043037, 44.343667],
              [-68.044716, 44.351222],
              [-68.044296, 44.357938],
              [-68.039679, 44.360876],
              [-68.034223, 44.360456],
              [-68.01399, 44.390255],
              [-68.019533, 44.396971],
              [-68.010719, 44.407464],
              [-68.006102, 44.409562],
              [-68.000646, 44.406624],
              [-67.997288, 44.399909],
              [-67.985668, 44.386917],
              [-67.978876, 44.387034],
              [-67.961613, 44.39907],
              [-67.961613, 44.4125],
              [-67.957089, 44.415408],
              [-67.955737, 44.416278],
              [-67.947342, 44.415858],
              [-67.936531, 44.411187],
              [-67.931453, 44.411848],
              [-67.927616, 44.421314],
              [-67.930554, 44.428869],
              [-67.926357, 44.431807],
              [-67.92132, 44.433066],
              [-67.913346, 44.430128],
              [-67.911667, 44.419216],
              [-67.899571, 44.394078],
              [-67.892033, 44.409668],
              [-67.887323, 44.426351],
              [-67.887323, 44.433066],
              [-67.878509, 44.435585],
              [-67.868856, 44.424672],
              [-67.855108, 44.419434],
              [-67.851697, 44.424282],
              [-67.851764, 44.428695],
              [-67.868875, 44.456881],
              [-67.868774, 44.465272],
              [-67.866801, 44.471812],
              [-67.860994, 44.477576],
              [-67.855579, 44.478676],
              [-67.851648, 44.484901],
              [-67.851228, 44.492456],
              [-67.853746, 44.497492],
              [-67.856684, 44.523934],
              [-67.843254, 44.542822],
              [-67.845772, 44.551636],
              [-67.844513, 44.556252],
              [-67.839896, 44.558771],
              [-67.829823, 44.557512],
              [-67.808837, 44.544081],
              [-67.805479, 44.536946],
              [-67.805479, 44.52981],
              [-67.802541, 44.523934],
              [-67.79726, 44.520685],
              [-67.781556, 44.520577],
              [-67.781975, 44.534008],
              [-67.779457, 44.543661],
              [-67.774001, 44.547438],
              [-67.767285, 44.548278],
              [-67.758891, 44.546599],
              [-67.753854, 44.543661],
              [-67.742942, 44.526453],
              [-67.740076, 44.508944],
              [-67.742789, 44.506176],
              [-67.743353, 44.497418],
              [-67.733986, 44.496252],
              [-67.722876, 44.498524],
              [-67.71419, 44.495238],
              [-67.703489, 44.504837],
              [-67.698872, 44.51575],
              [-67.702649, 44.527922],
              [-67.696354, 44.533798],
              [-67.685861, 44.537155],
              [-67.660678, 44.537575],
              [-67.656901, 44.535896],
              [-67.653123, 44.525823],
              [-67.648506, 44.525403],
              [-67.568159, 44.531117],
              [-67.562321, 44.539435],
              [-67.569836, 44.556788],
              [-67.575056, 44.560659],
              [-67.552392, 44.619629],
              [-67.551133, 44.621938],
              [-67.543368, 44.626554],
              [-67.54022, 44.626345],
              [-67.533925, 44.621518],
              [-67.530777, 44.621938],
              [-67.524061, 44.626554],
              [-67.522802, 44.63306],
              [-67.505804, 44.636837],
              [-67.493632, 44.628863],
              [-67.492373, 44.61795],
              [-67.457747, 44.598014],
              [-67.448513, 44.600322],
              [-67.447464, 44.60326],
              [-67.443686, 44.605779],
              [-67.428367, 44.609136],
              [-67.420602, 44.607877],
              [-67.418923, 44.60347],
              [-67.411815, 44.596954],
              [-67.405492, 44.594236],
              [-67.398987, 44.602631],
              [-67.395839, 44.612914],
              [-67.388704, 44.626554],
              [-67.386605, 44.626974],
              [-67.377554, 44.619757],
              [-67.368269, 44.624672],
              [-67.363158, 44.631825],
              [-67.367298, 44.652472],
              [-67.374014, 44.662965],
              [-67.37905, 44.665483],
              [-67.381149, 44.66947],
              [-67.376742, 44.681852],
              [-67.355966, 44.69906],
              [-67.347782, 44.69948],
              [-67.308538, 44.707454],
              [-67.299176, 44.705705],
              [-67.300144, 44.696752],
              [-67.307909, 44.691295],
              [-67.309627, 44.659316],
              [-67.298449, 44.654377],
              [-67.292462, 44.648455],
              [-67.293665, 44.634316],
              [-67.310745, 44.613212],
              [-67.322491, 44.612458],
              [-67.32297, 44.609394],
              [-67.314938, 44.598215],
              [-67.302427, 44.597323],
              [-67.293403, 44.599265],
              [-67.27916, 44.606782],
              [-67.273076, 44.610873],
              [-67.27706, 44.61795],
              [-67.274122, 44.626345],
              [-67.251247, 44.640825],
              [-67.24726, 44.641664],
              [-67.234275, 44.637201],
              [-67.213025, 44.63922],
              [-67.189427, 44.645533],
              [-67.191438, 44.64775],
              [-67.192068, 44.655515],
              [-67.186612, 44.66265],
              [-67.181785, 44.663699],
              [-67.169857, 44.662105],
              [-67.154479, 44.668114],
              [-67.155119, 44.66944],
              [-67.148061, 44.684114],
              [-67.139209, 44.693849],
              [-67.128792, 44.695421],
              [-67.103957, 44.717444],
              [-67.098931, 44.741311],
              [-67.092542, 44.742693],
              [-67.083477, 44.739899],
              [-67.073439, 44.741957],
              [-67.063308, 44.758238],
              [-67.062239, 44.769543],
              [-67.05516, 44.771442],
              [-67.04335, 44.765071],
              [-67.02615, 44.768199],
              [-67.01995, 44.771427],
              [-66.995154, 44.791073],
              [-66.989351, 44.79878],
              [-66.979708, 44.80736],
              [-66.97626, 44.808315],
              [-66.970026, 44.805713],
              [-66.961068, 44.807269],
              [-66.950569, 44.814539],
              [-66.949895, 44.817419],
              [-66.952112, 44.82007],
              [-66.966468, 44.819063],
              [-66.975009, 44.815495],
              [-66.986318, 44.820657],
              [-66.996523, 44.844654],
              [-66.99296, 44.849181],
              [-66.978142, 44.856963],
              [-66.981008, 44.862813],
              [-66.990351, 44.882551],
              [-66.989235, 44.89648],
              [-66.985901, 44.89715],
              [-66.983558, 44.903277],
              [-66.984466, 44.912557],
              [-66.990937, 44.917835],
              [-67.002118, 44.918836],
              [-67.033474, 44.939923],
              [-67.038299, 44.945433],
              [-67.05461, 44.986764],
              [-67.068274, 45.001014],
              [-67.072753, 45.008329],
              [-67.074914, 45.019254],
              [-67.082074, 45.029608],
              [-67.099749, 45.04501],
              [-67.117688, 45.05673],
              [-67.105899, 45.065786],
              [-67.090786, 45.068721],
              [-67.112414, 45.112323],
              [-67.128935, 45.132168],
              [-67.161247, 45.162879],
              [-67.271076, 45.191081],
              [-67.283619, 45.192022],
              [-67.290603, 45.187589],
              [-67.302568, 45.161348],
              [-67.305472, 45.144826],
              [-67.339869, 45.125594],
              [-67.345004, 45.12621],
              [-67.354306, 45.129886],
              [-67.405208, 45.165686],
              [-67.46357, 45.244097],
              [-67.489333, 45.281282],
              [-67.485683, 45.291433],
              [-67.465833, 45.297223],
              [-67.460101, 45.301179],
              [-67.429161, 45.344247],
              [-67.422153, 45.379661],
              [-67.430001, 45.392965],
              [-67.460281, 45.419594],
              [-67.473366, 45.425328],
              [-67.503771, 45.488522],
              [-67.463481, 45.508516],
              [-67.448729, 45.510576],
              [-67.425674, 45.502917],
              [-67.420875, 45.55056],
              [-67.423646, 45.572153],
              [-67.425452, 45.579086],
              [-67.449674, 45.60286],
              [-67.455406, 45.604665],
              [-67.476704, 45.604157],
              [-67.489793, 45.60118],
              [-67.491061, 45.598917],
              [-67.488452, 45.594643],
              [-67.490923, 45.591488],
              [-67.499444, 45.587014],
              [-67.51858, 45.587925],
              [-67.561359, 45.594906],
              [-67.64581, 45.613597],
              [-67.754245, 45.667791],
              [-67.803313, 45.677886],
              [-67.805483, 45.680241],
              [-67.817892, 45.693705],
              [-67.806598, 45.794723],
              [-67.801989, 45.803546],
              [-67.780443, 45.816206],
              [-67.763767, 45.820315],
              [-67.763955, 45.829983],
              [-67.768709, 45.901997],
              [-67.781095, 45.943032],
              [-67.782114, 46.279381],
              [-67.789284, 46.758219],
              [-67.78938, 46.765528],
              [-67.789461, 47.062544],
              [-67.790515, 47.067921],
              [-67.816345, 47.081188],
              [-67.846865, 47.092404],
              [-67.889155, 47.118772],
              [-67.935868, 47.164843],
              [-67.949369, 47.182542],
              [-67.952269, 47.196142],
              [-67.955669, 47.199542],
              [-68.153509, 47.314038],
              [-68.224005, 47.348456],
              [-68.240168, 47.354217],
              [-68.284101, 47.360389],
              [-68.33368, 47.36007],
              [-68.361559, 47.355605],
              [-68.474851, 47.297534],
              [-68.580398, 47.286957],
              [-68.723168, 47.239569],
              [-68.85343, 47.193443],
              [-68.900985, 47.178519],
              [-68.926421, 47.19786],
              [-68.941948, 47.206248],
              [-68.982002, 47.220295],
              [-69.033456, 47.240984],
              [-69.0402, 47.2451],
              [-69.050334, 47.256621],
              [-69.053819, 47.375036],
              [-69.046448, 47.383934],
              [-69.043958, 47.383682],
              [-69.03928, 47.385052],
              [-69.041733, 47.397326],
              [-69.04079, 47.39808],
              [-69.031127, 47.403106],
              [-69.032909, 47.407907],
              [-69.042702, 47.426651],
              [-69.055465, 47.432274],
              [-69.146439, 47.44886],
              [-69.22442, 47.459686],
              [-69.566383, 47.125032],
              [-69.818552, 46.87503],
              [-69.997086, 46.69523],
              [-70.023016, 46.573486],
              [-70.056433, 46.41659],
              [-70.133367, 46.368906],
              [-70.174709, 46.358472],
              [-70.188046, 46.350015],
              [-70.207415, 46.331316],
              [-70.292736, 46.191599],
              [-70.290896, 46.185838],
              [-70.278034, 46.175001],
              [-70.237947, 46.147378],
              [-70.252411, 46.106221],
              [-70.284554, 46.098713],
              [-70.28978, 46.094325],
              [-70.310609, 46.064544],
              [-70.313364, 46.016383],
              [-70.312055, 45.971544],
              [-70.26541, 45.962692],
              [-70.252242, 45.954777],
              [-70.240177, 45.943729],
              [-70.253704, 45.902981],
              [-70.262655, 45.887853],
              [-70.284204, 45.872034],
              [-70.307798, 45.85894],
              [-70.34244, 45.852192],
              [-70.36702, 45.834993],
              [-70.387916, 45.819043],
              [-70.397208, 45.807572],
              [-70.398159, 45.80412],
              [-70.396362, 45.802703],
              [-70.417674, 45.79457],
              [-70.40775, 45.773654],
              [-70.39721, 45.756872],
              [-70.451503, 45.704432],
              [-70.469869, 45.701639],
              [-70.551038, 45.661885],
              [-70.564789, 45.65515],
              [-70.659286, 45.58688],
              [-70.688214, 45.563981],
              [-70.686531, 45.54999],
              [-70.700776, 45.532777],
              [-70.721611, 45.515058],
              [-70.723167, 45.507606],
              [-70.716332, 45.486909],
              [-70.67591, 45.452582],
              [-70.663701, 45.447049],
              [-70.650161, 45.443685],
              [-70.635498, 45.427817],
              [-70.626527, 45.407011],
              [-70.634661, 45.383608],
              [-70.651986, 45.377146],
              [-70.660029, 45.377901],
              [-70.712286, 45.390611],
              [-70.729972, 45.399359],
              [-70.743775, 45.411925],
              [-70.744077, 45.421091],
              [-70.753977, 45.427789],
              [-70.781471, 45.431159],
              [-70.798483, 45.42474],
              [-70.825612, 45.400305],
              [-70.824053, 45.391094],
              [-70.807664, 45.378118],
              [-70.808322, 45.325824],
              [-70.831612, 45.260055],
              [-70.839482, 45.237829],
              [-70.842845, 45.234422],
              [-70.857042, 45.22916],
              [-70.885029, 45.234873],
              [-70.896898, 45.242031],
              [-70.907978, 45.269316],
              [-70.913732, 45.292746],
              [-70.912176, 45.296768],
              [-70.917904, 45.311924],
              [-70.950824, 45.33453],
              [-70.990233, 45.336277],
              [-71.005087, 45.331545],
              [-71.002401, 45.327956],
              [-71.00905, 45.319022],
              [-71.014268, 45.316761],
              [-71.030565, 45.312652],
              [-71.084334, 45.305293],
              [-71.097772, 45.301906],
              [-71.105151, 45.294635],
              [-71.120112, 45.265738],
              [-71.119914, 45.262287],
              [-71.124517, 45.25527],
              [-71.131953, 45.245423],
              [-71.13943, 45.242958],
              [-71.183785, 45.244932],
              [-71.232998, 45.256625],
              [-71.259614, 45.27324],
              [-71.263042, 45.277401],
              [-71.266754, 45.29123],
              [-71.284396, 45.302434],
              [-71.297092, 45.298985],
              [-71.342961, 45.271281],
              [-71.401182, 45.242544],
              [-71.44288, 45.234799],
              [-71.403267, 45.215348],
              [-71.39781, 45.203553],
              [-71.428828, 45.123881],
              [-71.489145, 45.072308],
              [-71.496098, 45.069235],
              [-71.502487, 45.013367],
              [-71.767452, 45.011437],
              [-71.897622, 45.009172],
              [-72.103058, 45.005598],
              [-72.342453, 45.005354],
              [-72.554253, 45.011794],
              [-72.67477, 45.015459],
              [-72.845633, 45.016659],
              [-73.014766, 45.01498],
              [-73.015539, 45.015072],
              [-73.085972, 45.015494],
              [-73.191948, 45.013576],
              [-73.343124, 45.01084],
              [-73.624588, 45.003954],
              [-73.874597, 45.001223],
              [-74.027392, 44.995765],
              [-74.146814, 44.9915],
              [-74.291307, 44.992058],
              [-74.702018, 45.003322],
              [-74.72498, 45.005915],
              [-74.801625, 45.014571],
              [-74.826578, 45.01585],
              [-74.972463, 44.983402],
              [-74.992756, 44.977449],
              [-74.99927, 44.971638],
              [-74.999655, 44.965921],
              [-75.005155, 44.958402],
              [-75.027125, 44.946568],
              [-75.064826, 44.929449],
              [-75.139868, 44.896676],
              [-75.189313, 44.883037],
              [-75.216486, 44.877478],
              [-75.283136, 44.849156],
              [-75.30763, 44.836813],
              [-75.301975, 44.826637],
              [-75.333744, 44.806378],
              [-75.433124, 44.750062],
              [-75.491201, 44.712947],
              [-75.696586, 44.567583],
              [-75.765495, 44.516285],
              [-75.807778, 44.471644],
              [-75.82083, 44.432244],
              [-75.86006, 44.403282],
              [-75.871496, 44.394839],
              [-75.912985, 44.368084],
              [-75.94954, 44.349129],
              [-75.970185, 44.342835],
              [-75.978281, 44.34688],
              [-76.000998, 44.347534],
              [-76.045228, 44.331724],
              [-76.118136, 44.29485],
              [-76.164265, 44.239603],
              [-76.191328, 44.221244],
              [-76.206777, 44.214543],
              [-76.245487, 44.203669],
              [-76.286547, 44.203773],
              [-76.312647, 44.199044],
              [-76.355679, 44.133258],
              [-76.358163, 44.123337],
              [-76.363835, 44.111696],
              [-76.366972, 44.100409],
              [-76.360798, 44.087644],
              [-76.360306, 44.070907],
              [-76.304207, 44.059445],
              [-76.300532, 44.057188],
              [-76.296986, 44.045455],
              [-76.299592, 44.030956],
              [-76.300222, 44.022762],
              [-76.298962, 44.017719],
              [-76.296755, 44.013307],
              [-76.287821, 44.01142],
              [-76.281928, 44.009177],
              [-76.269672, 44.001148],
              [-76.266733, 43.995578],
              [-76.268702, 43.987278],
              [-76.268706, 43.980846],
              [-76.264294, 43.978009],
              [-76.258306, 43.976118],
              [-76.252318, 43.975803],
              [-76.244439, 43.975803],
              [-76.236864, 43.9779],
              [-76.22805, 43.982737],
              [-76.184874, 43.971128],
              [-76.169802, 43.962202],
              [-76.146072, 43.964705],
              [-76.139086, 43.962111],
              [-76.134296, 43.954726],
              [-76.134359, 43.945614],
              [-76.133697, 43.940356],
              [-76.130446, 43.933082],
              [-76.125023, 43.912773],
              [-76.127285, 43.897889],
              [-76.133267, 43.892975],
              [-76.145506, 43.888681],
              [-76.158249, 43.887542],
              [-76.180604, 43.877529],
              [-76.192777, 43.869175],
              [-76.202257, 43.864898],
              [-76.219313, 43.86682],
              [-76.227485, 43.875061],
              [-76.234578, 43.877388],
              [-76.243384, 43.877975],
              [-76.249842, 43.875626],
              [-76.261584, 43.873278],
              [-76.269217, 43.868581],
              [-76.276262, 43.863297],
              [-76.28272, 43.858601],
              [-76.284481, 43.850968],
              [-76.283307, 43.843923],
              [-76.277812, 43.841205],
              [-76.266977, 43.838046],
              [-76.250135, 43.825713],
              [-76.229268, 43.804135],
              [-76.213205, 43.753513],
              [-76.205436, 43.718751],
              [-76.2005, 43.680231],
              [-76.196596, 43.649761],
              [-76.199138, 43.600454],
              [-76.203473, 43.574978],
              [-76.209853, 43.560136],
              [-76.217958, 43.545156],
              [-76.228701, 43.532987],
              [-76.235834, 43.529256],
              [-76.259858, 43.524728],
              [-76.297103, 43.51287],
              [-76.330911, 43.511978],
              [-76.345492, 43.513437],
              [-76.368849, 43.525822],
              [-76.410636, 43.523159],
              [-76.417581, 43.521285],
              [-76.437473, 43.509213],
              [-76.472498, 43.492781],
              [-76.486962, 43.47535],
              [-76.506858, 43.469127],
              [-76.515882, 43.471136],
              [-76.521999, 43.468617],
              [-76.53181, 43.460299],
              [-76.562826, 43.448537],
              [-76.607093, 43.423374],
              [-76.617109, 43.419137],
              [-76.630774, 43.413356],
              [-76.642672, 43.401241],
              [-76.669624, 43.366526],
              [-76.684856, 43.352691],
              [-76.69836, 43.344436],
              [-76.722501, 43.343686],
              [-76.731039, 43.343421],
              [-76.747067, 43.331477],
              [-76.769025, 43.318452],
              [-76.794708, 43.309632],
              [-76.841675, 43.305399],
              [-76.854976, 43.298443],
              [-76.877397, 43.292926],
              [-76.886913, 43.293891],
              [-76.904288, 43.291816],
              [-76.922351, 43.285006],
              [-76.952174, 43.270692],
              [-76.958402, 43.270005],
              [-76.988445, 43.2745],
              [-76.999691, 43.271456],
              [-77.033875, 43.271218],
              [-77.067295, 43.280937],
              [-77.111866, 43.287945],
              [-77.130429, 43.285635],
              [-77.143416, 43.287561],
              [-77.173088, 43.281509],
              [-77.214058, 43.284114],
              [-77.264177, 43.277363],
              [-77.303979, 43.27815],
              [-77.314619, 43.28103],
              [-77.341092, 43.280661],
              [-77.376038, 43.277652],
              [-77.385388, 43.276847],
              [-77.391015, 43.276363],
              [-77.414516, 43.269263],
              [-77.436831, 43.265701],
              [-77.476642, 43.254522],
              [-77.50092, 43.250363],
              [-77.534184, 43.234569],
              [-77.551022, 43.235763],
              [-77.577223, 43.243263],
              [-77.602161, 43.256949],
              [-77.628315, 43.271303],
              [-77.653759, 43.279484],
              [-77.660359, 43.282998],
              [-77.701429, 43.308261],
              [-77.714129, 43.323561],
              [-77.73063, 43.330161],
              [-77.756931, 43.337361],
              [-77.760231, 43.341161],
              [-77.785132, 43.339261],
              [-77.797381, 43.339857],
              [-77.816533, 43.34356],
              [-77.875335, 43.34966],
              [-77.904836, 43.35696],
              [-77.922736, 43.35696],
              [-77.952937, 43.36346],
              [-77.965238, 43.368059],
              [-77.976438, 43.369159],
              [-77.994838, 43.365259],
              [-77.995591, 43.365293],
              [-78.023609, 43.366575],
              [-78.104509, 43.375628],
              [-78.145195, 43.37551],
              [-78.233609, 43.36907],
              [-78.250641, 43.370866],
              [-78.358711, 43.373988],
              [-78.370221, 43.376505],
              [-78.465502, 43.371232],
              [-78.473099, 43.370812],
              [-78.482526, 43.374425],
              [-78.488857, 43.374763],
              [-78.547395, 43.369541],
              [-78.634346, 43.357624],
              [-78.696856, 43.341255],
              [-78.747158, 43.334555],
              [-78.777759, 43.327055],
              [-78.834061, 43.317555],
              [-78.836261, 43.318455],
              [-78.859362, 43.310955],
              [-78.930764, 43.293254],
              [-78.971866, 43.281254],
              [-79.019848, 43.273686],
              [-79.070469, 43.262454],
              [-79.058399, 43.238924],
              [-79.042366, 43.143655],
              [-79.044066, 43.138055],
              [-79.056767, 43.126855],
              [-79.066269, 43.09097],
              [-79.058399, 43.075231],
              [-79.028653, 43.069474],
              [-79.028353, 43.066897],
              [-79.019964, 42.994756],
              [-79.011563, 42.985256],
              [-78.972524, 42.966804],
              [-78.93236, 42.955857],
              [-78.921206, 42.948422],
              [-78.918859, 42.946857],
              [-78.909159, 42.933257],
              [-78.905659, 42.923357],
              [-78.905758, 42.899957],
              [-78.912458, 42.886557],
              [-78.891655, 42.884845],
              [-78.882557, 42.867258],
              [-78.872227, 42.853306],
              [-78.865592, 42.852358],
              [-78.859456, 42.841358],
              [-78.860445, 42.83511],
              [-78.865656, 42.826758],
              [-78.863656, 42.813058],
              [-78.859356, 42.800658],
              [-78.856456, 42.800258],
              [-78.851355, 42.791758],
              [-78.853455, 42.783958],
              [-78.868556, 42.770258],
              [-78.918157, 42.737258],
              [-78.944158, 42.731958],
              [-78.991159, 42.705358],
              [-79.00616, 42.704558],
              [-79.01886, 42.701558],
              [-79.04886, 42.689158],
              [-79.062261, 42.668358],
              [-79.06376, 42.644758],
              [-79.073261, 42.639958],
              [-79.078761, 42.640058],
              [-79.111361, 42.613358],
              [-79.113713, 42.605994],
              [-79.121921, 42.594234],
              [-79.126261, 42.590937],
              [-79.12963, 42.589824],
              [-79.136725, 42.569693],
              [-79.138569, 42.564462],
              [-79.148723, 42.553672],
              [-79.193232, 42.545881],
              [-79.223195, 42.536087],
              [-79.242889, 42.531757],
              [-79.264624, 42.523159],
              [-79.283364, 42.511228],
              [-79.31774, 42.499884],
              [-79.323079, 42.494795],
              [-79.331483, 42.489076],
              [-79.335129, 42.488321],
              [-79.342316, 42.489664],
              [-79.351989, 42.48892],
              [-79.36213, 42.480195],
              [-79.381943, 42.466491],
              [-79.405458, 42.453281],
              [-79.429119, 42.42838],
              [-79.453533, 42.411157],
              [-79.474794, 42.404291],
              [-79.510999, 42.382373],
              [-79.546262, 42.363417],
              [-79.593992, 42.341641],
              [-79.645358, 42.315631],
              [-79.717825, 42.284711],
              [-79.761951, 42.26986],
              [-79.798447, 42.255939],
              [-79.844661, 42.235486],
              [-79.867979, 42.230999],
              [-79.886187, 42.224933],
              [-79.90105, 42.216701],
              [-79.923924, 42.207546],
              [-79.931324, 42.206737],
              [-79.989186, 42.177051],
              [-80.06108, 42.144857],
              [-80.07198, 42.146057],
              [-80.076281, 42.147857],
              [-80.078781, 42.151457],
              [-80.071981, 42.155357],
              [-80.080028, 42.163625],
              [-80.073381, 42.168658],
              [-80.077388, 42.171262],
              [-80.088512, 42.173184],
              [-80.117368, 42.166341],
              [-80.13043, 42.156331],
              [-80.136213, 42.149937],
              [-80.154084, 42.114757],
              [-80.165884, 42.105857],
              [-80.188085, 42.094257],
              [-80.230486, 42.077957],
              [-80.296758, 42.049076],
              [-80.329976, 42.036168],
              [-80.349169, 42.030243],
              [-80.363251, 42.027973],
              [-80.371869, 42.023966],
              [-80.373066, 42.024102],
              [-80.409776, 42.011578],
              [-80.435451, 42.005611],
              [-80.519425, 41.977523],
              [-80.519425, 41.977522],
              [-80.519405, 41.976158],
              [-80.519304, 41.943992],
              [-80.519345, 41.929168],
              [-80.519294, 41.849563],
              [-80.519239, 41.765138],
              [-80.519369, 41.752487],
              [-80.519408, 41.739359],
              [-80.519373, 41.701473],
              [-80.519424, 41.671228],
              [-80.519357, 41.669767],
              [-80.519339, 41.539297],
              [-80.519157, 41.528769],
              [-80.519225, 41.499924],
              [-80.519209, 41.489013],
              [-80.519169, 41.462581],
              [-80.518993, 41.435454],
              [-80.518993, 41.416437],
              [-80.519025, 41.416438],
              [-80.519249, 41.378918],
              [-80.519217, 41.372006],
              [-80.519249, 41.36103],
              [-80.519297, 41.350833],
              [-80.519345, 41.34074],
              [-80.519345, 41.340145],
              [-80.519293, 41.339654],
              [-80.519293, 41.339054],
              [-80.519311, 41.339052],
              [-80.519281, 41.337174],
              [-80.519281, 41.337145],
              [-80.519281, 41.335958],
              [-80.519265, 41.333495],
              [-80.519129, 41.312408],
              [-80.518794, 41.305509],
              [-80.518996, 41.2683],
              [-80.518993, 41.268155],
              [-80.518893, 41.265155],
              [-80.518693, 41.248855],
              [-80.518893, 41.232556],
              [-80.518893, 41.219357],
              [-80.518893, 41.219356],
              [-80.51883, 41.209213],
              [-80.519144, 41.171203],
              [-80.519115, 41.14552],
              [-80.519167, 41.133388],
              [-80.519167, 41.133343],
              [-80.519012, 41.125116],
              [-80.519012, 41.125093],
              [-80.519012, 41.125057],
              [-80.519056, 41.125057],
              [-80.518992, 41.115958],
              [-80.519192, 41.105358],
              [-80.519125, 41.100819],
              [-80.519092, 41.090658],
              [-80.519088, 41.082074],
              [-80.518999, 41.075014],
              [-80.51896, 41.071866],
              [-80.518928, 41.070954],
              [-80.51896, 41.061546],
              [-80.518927, 41.015387],
              [-80.518989, 40.995445],
              [-80.519, 40.98738],
              [-80.519091, 40.921061],
              [-80.51979, 40.900761],
              [-80.519764, 40.899858],
              [-80.519039, 40.851339],
              [-80.51902, 40.850073],
              [-80.519081, 40.849157],
              [-80.518992, 40.801221],
              [-80.519058, 40.792298],
              [-80.518991, 40.638801],
              [-80.519039, 40.616391],
              [-80.519086, 40.616385],
              [-80.519086, 40.590161],
              [-80.519055, 40.590173],
              [-80.519057, 40.517922],
              [-80.519054, 40.517922],
              [-80.518692, 40.477365],
              [-80.517998, 40.399644],
              [-80.517991, 40.398868],
              [-80.519056, 40.172771],
              [-80.519056, 40.172744],
              [-80.519104, 40.159672],
              [-80.51896, 40.078089],
              [-80.519008, 40.077001],
              [-80.51912, 40.01641],
              [-80.519207, 39.963381],
              [-80.519218, 39.962424],
              [-80.519217, 39.962199],
              [-80.519203, 39.959394],
              [-80.519175, 39.956648],
              [-80.519115, 39.939188],
              [-80.519248, 39.936967],
              [-80.519342, 39.721403],
              [-80.421388, 39.721189],
              [-80.309457, 39.721264],
              [-80.308651, 39.721283],
              [-79.916266, 39.720792],
              [-79.853131, 39.720713],
              [-79.852904, 39.720713],
              [-79.763774, 39.720776],
              [-79.610623, 39.721245],
              [-79.608223, 39.721154],
              [-79.476662, 39.721078],
              [-79.478866, 39.531689],
              [-79.482354, 39.524682],
              [-79.482648, 39.521364],
              [-79.487651, 39.279933],
              [-79.486737, 39.278149],
              [-79.486179, 39.26497],
              [-79.485874, 39.264905],
              [-79.486873, 39.205961],
              [-79.402911, 39.250106],
              [-79.378687, 39.27192],
              [-79.280039, 39.340076],
              [-79.25688, 39.356077],
              [-79.213192, 39.367897],
              [-79.201676, 39.379726],
              [-79.08445, 39.471356],
              [-79.067072, 39.474658],
              [-79.04244, 39.479339],
              [-79.025681, 39.465539],
              [-78.968996, 39.441543],
              [-78.874744, 39.522611],
              [-78.824788, 39.590233],
              [-78.787461, 39.627492],
              [-78.760497, 39.609984],
              [-78.769029, 39.599871],
              [-78.772048, 39.593833],
              [-78.76749, 39.587487],
              [-78.760196, 39.582154],
              [-78.689455, 39.54577],
              [-78.676219, 39.540622],
              [-78.657324, 39.535087],
              [-78.655984, 39.534695],
              [-78.565929, 39.519444],
              [-78.468639, 39.516789],
              [-78.436939, 39.538959],
              [-78.432033, 39.561053],
              [-78.450207, 39.570889],
              [-78.454376, 39.574319],
              [-78.458456, 39.581158],
              [-78.457187, 39.587379],
              [-78.43025, 39.62329],
              [-78.355218, 39.640576],
              [-78.334044, 39.63577],
              [-78.313033, 39.631001],
              [-78.283039, 39.62047],
              [-78.271122, 39.619642],
              [-78.224337, 39.66327],
              [-78.191107, 39.690262],
              [-78.182759, 39.69511],
              [-78.176625, 39.695967],
              [-78.143478, 39.690412],
              [-78.107834, 39.682137],
              [-78.074595, 39.666686],
              [-78.035992, 39.63572],
              [-78.023427, 39.61986],
              [-78.009985, 39.602893],
              [-77.946442, 39.58491],
              [-77.902649, 39.587796],
              [-77.884536, 39.568174],
              [-77.886135, 39.560432],
              [-77.888945, 39.55595],
              [-77.865423, 39.516472],
              [-77.845105, 39.498285],
              [-77.825411, 39.494036],
              [-77.807821, 39.490241],
              [-77.765442, 39.428574],
              [-77.739204, 39.38573],
              [-77.760435, 39.344171],
              [-77.760586, 39.338864],
              [-77.755789, 39.333899],
              [-77.727379, 39.321666],
              [-77.719029, 39.321125],
              [-77.677505, 39.318699],
              [-77.667749, 39.318129],
              [-77.592739, 39.30129],
              [-77.560854, 39.286152],
              [-77.545846, 39.271535],
              [-77.543228, 39.266937],
              [-77.534461, 39.262361],
              [-77.511222, 39.2535],
              [-77.484605, 39.245941],
              [-77.46021, 39.228359],
              [-77.45768, 39.22502],
              [-77.458779, 39.22028],
              [-77.458884, 39.219826],
              [-77.478596, 39.189168],
              [-77.485971, 39.185665],
              [-77.505162, 39.18205],
              [-77.510631, 39.178484],
              [-77.516426, 39.170891],
              [-77.527282, 39.146236],
              [-77.524559, 39.127821],
              [-77.519929, 39.120925],
              [-77.458202, 39.073723],
              [-77.42318, 39.066878],
              [-77.375079, 39.061297],
              [-77.340287, 39.062991],
              [-77.328002, 39.058554],
              [-77.291605, 39.045408],
              [-77.261403, 39.031009],
              [-77.251803, 39.011409],
              [-77.255703, 39.002409],
              [-77.249803, 38.985909],
              [-77.235403, 38.97661],
              [-77.221502, 38.97131],
              [-77.197502, 38.96681],
              [-77.166901, 38.96811],
              [-77.148179, 38.965002],
              [-77.137701, 38.95531],
              [-77.1199, 38.934311],
              [-77.119863, 38.934265],
              [-77.1012, 38.911111],
              [-77.0902, 38.904211],
              [-77.068199, 38.899811],
              [-77.040599, 38.871212],
              [-77.031698, 38.850512],
              [-77.032986, 38.8395],
              [-77.038598, 38.791513],
              [-77.039239, 38.7852],
              [-77.041398, 38.763914],
              [-77.05991, 38.734419],
              [-77.074599, 38.711015],
              [-77.086113, 38.705792],
              [-77.1059, 38.696815],
              [-77.121101, 38.686616],
              [-77.132501, 38.673816],
              [-77.135901, 38.649817],
              [-77.1302, 38.635017],
              [-77.12463, 38.619778],
              [-77.125191, 38.619096],
              [-77.12634, 38.6177],
              [-77.128841, 38.61466],
              [-77.129084, 38.614364],
              [-77.129213, 38.614306],
              [-77.135539, 38.611473],
              [-77.146087, 38.606748],
              [-77.148651, 38.6056],
              [-77.161585, 38.606381],
              [-77.162649, 38.606446],
              [-77.16316, 38.606477],
              [-77.163409, 38.606492],
              [-77.163945, 38.606524],
              [-77.167523, 38.60674],
              [-77.169671, 38.60687],
              [-77.169968, 38.60674],
              [-77.175969, 38.604113],
              [-77.183767, 38.600699],
              [-77.205261, 38.574525],
              [-77.209905, 38.56887],
              [-77.221117, 38.555217],
              [-77.226465, 38.554139],
              [-77.236728, 38.552071],
              [-77.237724, 38.55187],
              [-77.242736, 38.544214],
              [-77.246089, 38.539093],
              [-77.254882, 38.52566],
              [-77.257378, 38.521847],
              [-77.263599, 38.512344],
              [-77.271099, 38.490753],
              [-77.274125, 38.482044],
              [-77.27422, 38.48177],
              [-77.27417, 38.481608],
              [-77.274021, 38.481127],
              [-77.269474, 38.466476],
              [-77.266845, 38.458004],
              [-77.263682, 38.44781],
              [-77.26076, 38.438394],
              [-77.259962, 38.435821],
              [-77.259962, 38.427902],
              [-77.26129, 38.42367],
              [-77.264238, 38.414282],
              [-77.261937, 38.409131],
              [-77.257177, 38.39847],
              [-77.256412, 38.396755],
              [-77.253202, 38.389567],
              [-77.25122, 38.385127],
              [-77.250862, 38.384325],
              [-77.250172, 38.382781],
              [-77.236231, 38.374601],
              [-77.216834, 38.363221],
              [-77.216729, 38.363159],
              [-77.212189, 38.361572],
              [-77.208334, 38.360224],
              [-77.207371, 38.359888],
              [-77.207312, 38.359867],
              [-77.207214, 38.359894],
              [-77.205009, 38.360511],
              [-77.189412, 38.364872],
              [-77.18668, 38.365636],
              [-77.184917, 38.366559],
              [-77.183268, 38.367423],
              [-77.182638, 38.367753],
              [-77.1798, 38.369239],
              [-77.177, 38.370706],
              [-77.168697, 38.375055],
              [-77.163531, 38.377761],
              [-77.147541, 38.386136],
              [-77.143152, 38.388435],
              [-77.139968, 38.390102],
              [-77.136947, 38.391684],
              [-77.136728, 38.391799],
              [-77.136434, 38.392094],
              [-77.135224, 38.393311],
              [-77.130287, 38.398271],
              [-77.12909, 38.399474],
              [-77.128872, 38.399692],
              [-77.128823, 38.399742],
              [-77.128649, 38.399917],
              [-77.128377, 38.40019],
              [-77.127737, 38.400833],
              [-77.127392, 38.4016],
              [-77.125933, 38.404845],
              [-77.123325, 38.410646],
              [-77.110623, 38.409214],
              [-77.110586, 38.40921],
              [-77.109171, 38.408162],
              [-77.109055, 38.408076],
              [-77.107881, 38.407207],
              [-77.107631, 38.407022],
              [-77.106968, 38.406531],
              [-77.106571, 38.406237],
              [-77.091073, 38.407546],
              [-77.086393, 38.414755],
              [-77.081418, 38.419297],
              [-77.081252, 38.419449],
              [-77.075489, 38.42471],
              [-77.074703, 38.42517],
              [-77.074339, 38.425382],
              [-77.074174, 38.425479],
              [-77.062607, 38.432244],
              [-77.057684, 38.435123],
              [-77.05746, 38.435254],
              [-77.057277, 38.435361],
              [-77.056892, 38.435586],
              [-77.05532, 38.436505],
              [-77.055162, 38.436598],
              [-77.054972, 38.436709],
              [-77.053979, 38.43729],
              [-77.053663, 38.437475],
              [-77.053445, 38.437602],
              [-77.05329, 38.437693],
              [-77.053187, 38.437753],
              [-77.044188, 38.443016],
              [-77.042879, 38.443607],
              [-77.042046, 38.443983],
              [-77.040638, 38.444618],
              [-77.016674, 38.44556],
              [-77.016371, 38.445572],
              [-77.006767, 38.430176],
              [-77.006495, 38.429738],
              [-77.00257, 38.423447],
              [-77.001902, 38.422376],
              [-77.001638, 38.421952],
              [-77.001541, 38.421548],
              [-77.000997, 38.419293],
              [-76.998843, 38.410362],
              [-76.998585, 38.409294],
              [-76.996724, 38.406708],
              [-76.996663, 38.406623],
              [-76.993839, 38.402699],
              [-76.990305, 38.397788],
              [-76.989306, 38.396401],
              [-76.989271, 38.396352],
              [-76.98828, 38.394975],
              [-76.987838, 38.391965],
              [-76.986996, 38.386237],
              [-76.986699, 38.384213],
              [-76.986464, 38.382618],
              [-76.983582, 38.362999],
              [-76.975492, 38.347327],
              [-76.975092, 38.347067],
              [-76.966349, 38.341372],
              [-76.953928, 38.333282],
              [-76.942132, 38.329601],
              [-76.929554, 38.321088],
              [-76.927019, 38.318454],
              [-76.924668, 38.316011],
              [-76.923629, 38.314932],
              [-76.922177, 38.311339],
              [-76.922161, 38.311086],
              [-76.920932, 38.291568],
              [-76.920778, 38.291529],
              [-76.908506, 38.28843],
              [-76.886535, 38.277004],
              [-76.866416, 38.269715],
              [-76.866302, 38.269673],
              [-76.864292, 38.268945],
              [-76.847074, 38.25616],
              [-76.846036, 38.255809],
              [-76.844885, 38.25542],
              [-76.844221, 38.255195],
              [-76.843422, 38.254925],
              [-76.842139, 38.254491],
              [-76.842038, 38.254657],
              [-76.837789, 38.261609],
              [-76.837697, 38.26199],
              [-76.835136, 38.272628],
              [-76.834803, 38.274012],
              [-76.834908, 38.274299],
              [-76.838539, 38.28417],
              [-76.840383, 38.289184],
              [-76.841241, 38.289564],
              [-76.841703, 38.289768],
              [-76.84622, 38.291768],
              [-76.846221, 38.29196],
              [-76.846252, 38.297718],
              [-76.846118, 38.297739],
              [-76.845846, 38.297783],
              [-76.834046, 38.29968],
              [-76.824889, 38.301152],
              [-76.824834, 38.30113],
              [-76.82167, 38.299869],
              [-76.821569, 38.299829],
              [-76.820799, 38.299064],
              [-76.816323, 38.29462],
              [-76.815098, 38.293404],
              [-76.811182, 38.289516],
              [-76.810596, 38.288934],
              [-76.806596, 38.284962],
              [-76.80547, 38.283844],
              [-76.805363, 38.283738],
              [-76.805037, 38.283414],
              [-76.804922, 38.2833],
              [-76.802347, 38.280743],
              [-76.802947, 38.275094],
              [-76.805224, 38.253648],
              [-76.80577, 38.252615],
              [-76.805949, 38.252275],
              [-76.808411, 38.252209],
              [-76.80888, 38.252197],
              [-76.809009, 38.252193],
              [-76.811927, 38.252115],
              [-76.811815, 38.251318],
              [-76.811647, 38.250129],
              [-76.797452, 38.236918],
              [-76.79659, 38.236531],
              [-76.791932, 38.234441],
              [-76.779865, 38.229026],
              [-76.778625, 38.22847],
              [-76.769988, 38.226388],
              [-76.752286, 38.222121],
              [-76.752085, 38.222336],
              [-76.752017, 38.222409],
              [-76.749384, 38.225231],
              [-76.744265, 38.230716],
              [-76.740055, 38.235227],
              [-76.719602, 38.233503],
              [-76.717537, 38.233329],
              [-76.716376, 38.233231],
              [-76.716139, 38.233237],
              [-76.712594, 38.233334],
              [-76.687075, 38.23403],
              [-76.678687, 38.234259],
              [-76.673462, 38.234401],
              [-76.659182, 38.229894],
              [-76.645166, 38.22547],
              [-76.645034, 38.225429],
              [-76.643999, 38.225102],
              [-76.643929, 38.22508],
              [-76.632544, 38.225657],
              [-76.632464, 38.225635],
              [-76.631997, 38.225508],
              [-76.631958, 38.225497],
              [-76.629893, 38.224933],
              [-76.629703, 38.224881],
              [-76.628078, 38.224437],
              [-76.625659, 38.223777],
              [-76.624387, 38.223429],
              [-76.590637, 38.214212],
              [-76.588683, 38.21295],
              [-76.57444, 38.203751],
              [-76.566297, 38.198492],
              [-76.552957, 38.187209],
              [-76.548946, 38.178982],
              [-76.548256, 38.177566],
              [-76.547902, 38.176839],
              [-76.547455, 38.175923],
              [-76.547333, 38.175673],
              [-76.545335, 38.165373],
              [-76.54038, 38.152991],
              [-76.529868, 38.134083],
              [-76.529439, 38.134388],
              [-76.52899, 38.134708],
              [-76.522418, 38.139391],
              [-76.514824, 38.141219],
              [-76.508825, 38.140713],
              [-76.502306, 38.138156],
              [-76.501258, 38.137744],
              [-76.500332, 38.137381],
              [-76.499923, 38.137221],
              [-76.499842, 38.137189],
              [-76.499018, 38.136255],
              [-76.497866, 38.13495],
              [-76.497081, 38.134059],
              [-76.49504, 38.131746],
              [-76.492029, 38.128333],
              [-76.48632, 38.121862],
              [-76.486274, 38.12181],
              [-76.485961, 38.121456],
              [-76.485149, 38.120535],
              [-76.48403, 38.119266],
              [-76.482007, 38.116974],
              [-76.481073, 38.115915],
              [-76.48105, 38.115889],
              [-76.481036, 38.115873],
              [-76.481, 38.115789],
              [-76.479799, 38.113005],
              [-76.479056, 38.111281],
              [-76.478817, 38.110726],
              [-76.478797, 38.11068],
              [-76.47861, 38.110247],
              [-76.478168, 38.109221],
              [-76.476222, 38.104709],
              [-76.475448, 38.104271],
              [-76.473266, 38.103035],
              [-76.467879, 38.104932],
              [-76.46533, 38.10583],
              [-76.465479, 38.106603],
              [-76.465892, 38.108738],
              [-76.466364, 38.111183],
              [-76.466387, 38.111302],
              [-76.466404, 38.111392],
              [-76.466568, 38.111596],
              [-76.466973, 38.112099],
              [-76.467333, 38.112546],
              [-76.469738, 38.115534],
              [-76.46974, 38.115653],
              [-76.46976, 38.116874],
              [-76.469784, 38.118381],
              [-76.469787, 38.118606],
              [-76.469795, 38.119061],
              [-76.469798, 38.119264],
              [-76.465727, 38.127408],
              [-76.460673, 38.137515],
              [-76.460072, 38.138717],
              [-76.459689, 38.139484],
              [-76.459236, 38.139471],
              [-76.439841, 38.138933],
              [-76.437242, 38.135699],
              [-76.429581, 38.126165],
              [-76.429744, 38.124856],
              [-76.43013, 38.121753],
              [-76.430412, 38.119488],
              [-76.430425, 38.119383],
              [-76.429471, 38.118001],
              [-76.429384, 38.117875],
              [-76.421896, 38.107026],
              [-76.421214, 38.106039],
              [-76.421066, 38.105989],
              [-76.41655, 38.104459],
              [-76.414994, 38.105572],
              [-76.414475, 38.105943],
              [-76.41316, 38.106884],
              [-76.405972, 38.106967],
              [-76.405368, 38.106974],
              [-76.398067, 38.10469],
              [-76.397656, 38.104561],
              [-76.396478, 38.104192],
              [-76.394006, 38.103419],
              [-76.393121, 38.103142],
              [-76.392335, 38.102896],
              [-76.392058, 38.102581],
              [-76.391823, 38.102315],
              [-76.390917, 38.101286],
              [-76.384886, 38.094437],
              [-76.383896, 38.093312],
              [-76.381842, 38.090981],
              [-76.381752, 38.090878],
              [-76.381298, 38.090362],
              [-76.380991, 38.090014],
              [-76.378292, 38.086949],
              [-76.37179, 38.079565],
              [-76.370845, 38.077771],
              [-76.370204, 38.076556],
              [-76.369306, 38.074853],
              [-76.361779, 38.06057],
              [-76.361668, 38.06036],
              [-76.361538, 38.060114],
              [-76.361237, 38.059542],
              [-76.35275, 38.053182],
              [-76.350656, 38.053277],
              [-76.345697, 38.053502],
              [-76.344327, 38.053565],
              [-76.341404, 38.053697],
              [-76.341172, 38.053596],
              [-76.332812, 38.049938],
              [-76.326994, 38.045105],
              [-76.322093, 38.036503],
              [-76.32195, 38.036874],
              [-76.321499, 38.03805],
              [-76.319476, 38.043315],
              [-76.320592, 38.046531],
              [-76.325044, 38.059368],
              [-76.329165, 38.071247],
              [-76.329308, 38.07166],
              [-76.329433, 38.073986],
              [-76.330787, 38.099201],
              [-76.330794, 38.099331],
              [-76.330807, 38.099354],
              [-76.33124, 38.100106],
              [-76.331484, 38.100531],
              [-76.331807, 38.101092],
              [-76.337402, 38.11082],
              [-76.337411, 38.110888],
              [-76.338535, 38.119472],
              [-76.338161, 38.119856],
              [-76.337342, 38.120696],
              [-76.335637, 38.122444],
              [-76.335243, 38.122848],
              [-76.331812, 38.126366],
              [-76.330982, 38.127217],
              [-76.324108, 38.134266],
              [-76.320136, 38.138339],
              [-76.320492, 38.138966],
              [-76.327124, 38.150641],
              [-76.328419, 38.152921],
              [-76.328778, 38.153552],
              [-76.328805, 38.1536],
              [-76.328864, 38.153703],
              [-76.329688, 38.155155],
              [-76.329705, 38.155184],
              [-76.329711, 38.15519],
              [-76.336106, 38.161353],
              [-76.337611, 38.162805],
              [-76.343517, 38.168497],
              [-76.347983, 38.172802],
              [-76.352395, 38.177054],
              [-76.352561, 38.177214],
              [-76.353516, 38.178135],
              [-76.353799, 38.178606],
              [-76.359887, 38.188737],
              [-76.361877, 38.192048],
              [-76.364135, 38.194532],
              [-76.372535, 38.203771],
              [-76.377693, 38.209445],
              [-76.378104, 38.209897],
              [-76.385244, 38.217751],
              [-76.391623, 38.236573],
              [-76.391659, 38.23668],
              [-76.39228, 38.238511],
              [-76.392464, 38.239055],
              [-76.399078, 38.258569],
              [-76.39932, 38.259284],
              [-76.399313, 38.259398],
              [-76.399078, 38.263275],
              [-76.399049, 38.263753],
              [-76.399013, 38.264338],
              [-76.398852, 38.266997],
              [-76.396913, 38.27165],
              [-76.394171, 38.278233],
              [-76.382051, 38.289384],
              [-76.376607, 38.294393],
              [-76.374481, 38.296348],
              [-76.374517, 38.296556],
              [-76.375023, 38.299419],
              [-76.37531, 38.299583],
              [-76.38012, 38.302343],
              [-76.381493, 38.30313],
              [-76.382163, 38.303389],
              [-76.402894, 38.311402],
              [-76.405716, 38.317794],
              [-76.409291, 38.325891],
              [-76.40494, 38.341089],
              [-76.403101, 38.343157],
              [-76.402043, 38.344348],
              [-76.401532, 38.344923],
              [-76.400871, 38.345666],
              [-76.398261, 38.348602],
              [-76.388915, 38.359115],
              [-76.388806, 38.359238],
              [-76.387408, 38.360811],
              [-76.387002, 38.361267],
              [-76.386957, 38.362462],
              [-76.386931, 38.363184],
              [-76.386243, 38.381631],
              [-76.386229, 38.382013],
              [-76.388328, 38.387727],
              [-76.388348, 38.387781],
              [-76.393378, 38.389477],
              [-76.40271, 38.396003],
              [-76.415384, 38.414682],
              [-76.435674, 38.432893],
              [-76.436271, 38.433429],
              [-76.438919, 38.435053],
              [-76.44118, 38.436439],
              [-76.442431, 38.437206],
              [-76.442441, 38.437212],
              [-76.445376, 38.439012],
              [-76.450937, 38.442422],
              [-76.45414, 38.44588],
              [-76.456002, 38.447891],
              [-76.455799, 38.451233],
              [-76.461078, 38.455756],
              [-76.46401, 38.458268],
              [-76.467186, 38.46099],
              [-76.467194, 38.460996],
              [-76.467342, 38.461123],
              [-76.471253, 38.464474],
              [-76.473372, 38.46629],
              [-76.491642, 38.481944],
              [-76.492699, 38.482849],
              [-76.498222, 38.491869],
              [-76.498792, 38.4928],
              [-76.499256, 38.493559],
              [-76.506023, 38.50461],
              [-76.50686, 38.506716],
              [-76.507489, 38.5083],
              [-76.51535, 38.528093],
              [-76.515706, 38.528988],
              [-76.515754, 38.52926],
              [-76.517506, 38.539149],
              [-76.51552, 38.5529],
              [-76.515415, 38.553623],
              [-76.515409, 38.553667],
              [-76.515376, 38.553895],
              [-76.515106, 38.555763],
              [-76.51634, 38.590229],
              [-76.515764, 38.593131],
              [-76.51576, 38.593154],
              [-76.515741, 38.593248],
              [-76.514812, 38.59793],
              [-76.512583, 38.609168],
              [-76.512452, 38.609827],
              [-76.511278, 38.615745],
              [-76.515554, 38.629361],
              [-76.516988, 38.631985],
              [-76.517862, 38.633586],
              [-76.524122, 38.645044],
              [-76.52462, 38.645956],
              [-76.525007, 38.647568],
              [-76.527428, 38.657655],
              [-76.52785, 38.659416],
              [-76.530454, 38.670263],
              [-76.532056, 38.676936],
              [-76.532398, 38.678363],
              [-76.532409, 38.680064],
              [-76.532432, 38.6836],
              [-76.532527, 38.698207],
              [-76.532537, 38.699669],
              [-76.532465, 38.699974],
              [-76.530824, 38.706881],
              [-76.530799, 38.706983],
              [-76.530575, 38.707929],
              [-76.529721, 38.711523],
              [-76.529532, 38.712317],
              [-76.529237, 38.713561],
              [-76.526655, 38.72443],
              [-76.52718, 38.727062],
              [-76.529284, 38.728137],
              [-76.529868, 38.728435],
              [-76.539769, 38.72794],
              [-76.542053, 38.727826],
              [-76.543435, 38.727757],
              [-76.54357, 38.72775],
              [-76.543853, 38.727736],
              [-76.544475, 38.727705],
              [-76.544561, 38.727784],
              [-76.551971, 38.734636],
              [-76.552743, 38.73535],
              [-76.553978, 38.737756],
              [-76.556954, 38.743554],
              [-76.557091, 38.743823],
              [-76.5573, 38.744229],
              [-76.557535, 38.744687],
              [-76.558933, 38.758177],
              [-76.559778, 38.766342],
              [-76.559884, 38.767361],
              [-76.559697, 38.767443],
              [-76.554693, 38.769639],
              [-76.554443, 38.769749],
              [-76.544413, 38.774151],
              [-76.544372, 38.774169],
              [-76.542973, 38.774783],
              [-76.539088, 38.776488],
              [-76.53723, 38.777304],
              [-76.536849, 38.777471],
              [-76.536819, 38.777484],
              [-76.536284, 38.777719],
              [-76.535642, 38.778],
              [-76.535426, 38.778095],
              [-76.535379, 38.778116],
              [-76.535352, 38.778145],
              [-76.535207, 38.778298],
              [-76.533975, 38.779604],
              [-76.532487, 38.781181],
              [-76.528136, 38.78579],
              [-76.527315, 38.78666],
              [-76.526979, 38.787016],
              [-76.527045, 38.787645],
              [-76.527105, 38.788223],
              [-76.52737, 38.790774],
              [-76.527372, 38.790788],
              [-76.527463, 38.791667],
              [-76.527479, 38.791816],
              [-76.527455, 38.791844],
              [-76.525531, 38.794043],
              [-76.52521, 38.794409],
              [-76.525039, 38.794605],
              [-76.524999, 38.79465],
              [-76.524806, 38.794871],
              [-76.524679, 38.795016],
              [-76.523405, 38.795557],
              [-76.51583, 38.798774],
              [-76.514296, 38.799425],
              [-76.51113, 38.800769],
              [-76.510078, 38.801216],
              [-76.509314, 38.802328],
              [-76.506876, 38.805875],
              [-76.50653, 38.80638],
              [-76.50291, 38.811648],
              [-76.499056, 38.817258],
              [-76.498878, 38.817516],
              [-76.497692, 38.820309],
              [-76.496965, 38.822022],
              [-76.491831, 38.834116],
              [-76.491684, 38.834462],
              [-76.491606, 38.834644],
              [-76.491387, 38.835161],
              [-76.490107, 38.838176],
              [-76.489878, 38.838715],
              [-76.489878, 38.842815],
              [-76.489919, 38.842878],
              [-76.491494, 38.845299],
              [-76.491581, 38.845433],
              [-76.492017, 38.846102],
              [-76.492761, 38.847246],
              [-76.493639, 38.848595],
              [-76.496474, 38.852953],
              [-76.496579, 38.853115],
              [-76.497562, 38.852749],
              [-76.499158, 38.852156],
              [-76.509211, 38.848416],
              [-76.509285, 38.848388],
              [-76.516582, 38.851026],
              [-76.516944, 38.851157],
              [-76.519442, 38.863135],
              [-76.511135, 38.869396],
              [-76.507858, 38.871866],
              [-76.498467, 38.878944],
              [-76.494858, 38.881665],
              [-76.494588, 38.881868],
              [-76.4944, 38.88201],
              [-76.491442, 38.884239],
              [-76.491107, 38.884492],
              [-76.49068, 38.884814],
              [-76.48938, 38.887414],
              [-76.489667, 38.888772],
              [-76.489675, 38.888811],
              [-76.489713, 38.888991],
              [-76.489933, 38.890031],
              [-76.490339, 38.891955],
              [-76.490403, 38.892254],
              [-76.49088, 38.894514],
              [-76.49278, 38.895614],
              [-76.49388, 38.899614],
              [-76.493856, 38.900846],
              [-76.493806, 38.903443],
              [-76.493798, 38.903865],
              [-76.493791, 38.904225],
              [-76.49368, 38.910013],
              [-76.475761, 38.914469],
              [-76.46948, 38.911513],
              [-76.46938, 38.907613],
              [-76.46528, 38.907406],
              [-76.462312, 38.907256],
              [-76.460716, 38.907175],
              [-76.460253, 38.907152],
              [-76.459479, 38.907113],
              [-76.45808, 38.914313],
              [-76.458759, 38.916045],
              [-76.458991, 38.916639],
              [-76.460272, 38.919909],
              [-76.461747, 38.923674],
              [-76.46188, 38.924013],
              [-76.450756, 38.940412],
              [-76.45028, 38.941113],
              [-76.451695, 38.94249],
              [-76.457229, 38.947875],
              [-76.457781, 38.948412],
              [-76.460234, 38.948505],
              [-76.463081, 38.948612],
              [-76.471281, 38.956512],
              [-76.473243, 38.962397],
              [-76.474743, 38.966895],
              [-76.474882, 38.967312],
              [-76.47445, 38.970683],
              [-76.474198, 38.972646],
              [-76.474198, 38.972647],
              [-76.454581, 38.974512],
              [-76.451599, 38.976767],
              [-76.450481, 38.977612],
              [-76.450152, 38.978751],
              [-76.449188, 38.982092],
              [-76.448981, 38.982811],
              [-76.448928, 38.982823],
              [-76.427301, 38.987827],
              [-76.422181, 38.989011],
              [-76.421535, 38.989524],
              [-76.414631, 38.995002],
              [-76.412326, 38.996832],
              [-76.39408, 39.011311],
              [-76.394358, 39.01216],
              [-76.394699, 39.0132],
              [-76.395338, 39.015154],
              [-76.395639, 39.016074],
              [-76.396395, 39.01838],
              [-76.396417, 39.018449],
              [-76.397738, 39.022482],
              [-76.39778, 39.022611],
              [-76.4026, 39.029609],
              [-76.405021, 39.033124],
              [-76.405081, 39.033211],
              [-76.405338, 39.03336],
              [-76.407205, 39.034439],
              [-76.407213, 39.034444],
              [-76.407398, 39.034551],
              [-76.422933, 39.043536],
              [-76.437044, 39.051698],
              [-76.438928, 39.052788],
              [-76.438845, 39.0529],
              [-76.432374, 39.061648],
              [-76.423081, 39.07421],
              [-76.42186, 39.081442],
              [-76.42208, 39.08207],
              [-76.422212, 39.082448],
              [-76.422714, 39.083881],
              [-76.423271, 39.085473],
              [-76.423321, 39.085615],
              [-76.423609, 39.086438],
              [-76.426276, 39.094057],
              [-76.426283, 39.094076],
              [-76.426456, 39.094571],
              [-76.427065, 39.096309],
              [-76.427196, 39.096685],
              [-76.432942, 39.113098],
              [-76.432981, 39.113209],
              [-76.432702, 39.120752],
              [-76.432481, 39.126709],
              [-76.428681, 39.131709],
              [-76.43013, 39.132419],
              [-76.430946, 39.132818],
              [-76.44011, 39.137305],
              [-76.452782, 39.143509],
              [-76.458192, 39.146749],
              [-76.45835, 39.146844],
              [-76.458649, 39.147023],
              [-76.458873, 39.147157],
              [-76.459119, 39.147304],
              [-76.468898, 39.153161],
              [-76.471483, 39.154709],
              [-76.473802, 39.158007],
              [-76.474807, 39.159436],
              [-76.475983, 39.161109],
              [-76.483845, 39.164334],
              [-76.484023, 39.164407],
              [-76.500512, 39.161362],
              [-76.500926, 39.161286],
              [-76.508384, 39.169408],
              [-76.511834, 39.171093],
              [-76.519292, 39.174736],
              [-76.52027, 39.175214],
              [-76.524221, 39.177144],
              [-76.525031, 39.17754],
              [-76.525454, 39.177746],
              [-76.525785, 39.177908],
              [-76.534185, 39.190608],
              [-76.535385, 39.203808],
              [-76.53476, 39.204841],
              [-76.533349, 39.207172],
              [-76.533085, 39.207608],
              [-76.533103, 39.20763],
              [-76.535885, 39.211008],
              [-76.53496, 39.21228],
              [-76.534285, 39.213208],
              [-76.529649, 39.216693],
              [-76.528587, 39.217492],
              [-76.520941, 39.22324],
              [-76.520584, 39.223508],
              [-76.519804, 39.222946],
              [-76.500984, 39.209376],
              [-76.500834, 39.209113],
              [-76.500086, 39.207798],
              [-76.498384, 39.204808],
              [-76.497977, 39.204697],
              [-76.49077, 39.202724],
              [-76.489777, 39.202453],
              [-76.489505, 39.202378],
              [-76.488883, 39.202208],
              [-76.486371, 39.203036],
              [-76.485527, 39.203314],
              [-76.482153, 39.204426],
              [-76.480083, 39.205108],
              [-76.471126, 39.20554],
              [-76.463483, 39.205908],
              [-76.462679, 39.205506],
              [-76.46156, 39.204947],
              [-76.447621, 39.197977],
              [-76.442482, 39.195408],
              [-76.441411, 39.196049],
              [-76.425413, 39.205629],
              [-76.425281, 39.205708],
              [-76.419201, 39.216988],
              [-76.41829, 39.218677],
              [-76.417681, 39.219808],
              [-76.41762, 39.219838],
              [-76.399122, 39.229048],
              [-76.398314, 39.22945],
              [-76.394381, 39.231408],
              [-76.393626, 39.232012],
              [-76.389563, 39.235261],
              [-76.38938, 39.235408],
              [-76.384699, 39.242242],
              [-76.38438, 39.242708],
              [-76.382358, 39.247292],
              [-76.38138, 39.249508],
              [-76.386937, 39.249216],
              [-76.401911, 39.258053],
              [-76.402355, 39.258315],
              [-76.402047, 39.258783],
              [-76.401103, 39.260219],
              [-76.400187, 39.261612],
              [-76.400094, 39.261753],
              [-76.395301, 39.269042],
              [-76.395136, 39.269293],
              [-76.385151, 39.275766],
              [-76.384901, 39.275928],
              [-76.383891, 39.281465],
              [-76.383345, 39.284455],
              [-76.383021, 39.286231],
              [-76.380734, 39.298765],
              [-76.380662, 39.299161],
              [-76.365532, 39.31095],
              [-76.36439, 39.31184],
              [-76.355495, 39.312155],
              [-76.354817, 39.311709],
              [-76.353205, 39.31065],
              [-76.341432, 39.30291],
              [-76.339817, 39.304216],
              [-76.337858, 39.305799],
              [-76.327579, 39.314108],
              [-76.33382, 39.319611],
              [-76.33957, 39.324681],
              [-76.338898, 39.325783],
              [-76.333924, 39.333935],
              [-76.334021, 39.334197],
              [-76.334401, 39.335222],
              [-76.335412, 39.337949],
              [-76.339942, 39.350169],
              [-76.341443, 39.354217],
              [-76.330027, 39.356139],
              [-76.323679, 39.357208],
              [-76.322687, 39.357092],
              [-76.314356, 39.35612],
              [-76.312864, 39.355946],
              [-76.31261, 39.355917],
              [-76.311679, 39.355808],
              [-76.31136, 39.355693],
              [-76.310829, 39.3555],
              [-76.310618, 39.355423],
              [-76.30177, 39.352216],
              [-76.295678, 39.350008],
              [-76.294978, 39.346608],
              [-76.295558, 39.345631],
              [-76.297569, 39.342244],
              [-76.298778, 39.340208],
              [-76.298778, 39.339278],
              [-76.298778, 39.333958],
              [-76.298778, 39.329208],
              [-76.291078, 39.318108],
              [-76.297878, 39.302408],
              [-76.296546, 39.302383],
              [-76.2817, 39.30211],
              [-76.281578, 39.302108],
              [-76.281556, 39.302369],
              [-76.281429, 39.303872],
              [-76.281374, 39.304531],
              [-76.281088, 39.30793],
              [-76.280778, 39.311608],
              [-76.280599, 39.312037],
              [-76.278499, 39.317088],
              [-76.278351, 39.317444],
              [-76.278239, 39.317712],
              [-76.277866, 39.31861],
              [-76.277813, 39.318738],
              [-76.276078, 39.322908],
              [-76.272671, 39.326015],
              [-76.266407, 39.331727],
              [-76.266257, 39.331864],
              [-76.266094, 39.332013],
              [-76.265777, 39.332302],
              [-76.265615, 39.33245],
              [-76.263624, 39.334265],
              [-76.263577, 39.334308],
              [-76.263073, 39.334436],
              [-76.262471, 39.33459],
              [-76.262008, 39.334708],
              [-76.253928, 39.336768],
              [-76.258342, 39.345737],
              [-76.258377, 39.345808],
              [-76.263019, 39.348634],
              [-76.265277, 39.350008],
              [-76.266365, 39.353352],
              [-76.250483, 39.361136],
              [-76.250107, 39.36132],
              [-76.245273, 39.361671],
              [-76.244988, 39.361691],
              [-76.244443, 39.361731],
              [-76.243377, 39.361808],
              [-76.241268, 39.361567],
              [-76.239877, 39.361408],
              [-76.237943, 39.358429],
              [-76.23652, 39.356236],
              [-76.235795, 39.355119],
              [-76.234765, 39.353532],
              [-76.234743, 39.353498],
              [-76.233776, 39.352008],
              [-76.229614, 39.350723],
              [-76.227625, 39.350109],
              [-76.226976, 39.349908],
              [-76.202346, 39.364455],
              [-76.199356, 39.366221],
              [-76.180074, 39.377609],
              [-76.180057, 39.377638],
              [-76.175928, 39.384648],
              [-76.175597, 39.38521],
              [-76.175121, 39.386019],
              [-76.171747, 39.391747],
              [-76.171474, 39.39221],
              [-76.171134, 39.392588],
              [-76.159358, 39.405661],
              [-76.158774, 39.40631],
              [-76.158592, 39.406295],
              [-76.157108, 39.406176],
              [-76.152357, 39.405793],
              [-76.152059, 39.405769],
              [-76.151948, 39.40576],
              [-76.150934, 39.405678],
              [-76.150516, 39.405644],
              [-76.150249, 39.405623],
              [-76.147048, 39.405364],
              [-76.146373, 39.40531],
              [-76.142224, 39.408007],
              [-76.132114, 39.414579],
              [-76.121889, 39.421226],
              [-76.121754, 39.421396],
              [-76.120991, 39.422358],
              [-76.117172, 39.42717],
              [-76.11682, 39.427614],
              [-76.115096, 39.428565],
              [-76.112761, 39.429852],
              [-76.102232, 39.435659],
              [-76.093595, 39.436871],
              [-76.083405, 39.438302],
              [-76.083269, 39.438321],
              [-76.081409, 39.436891],
              [-76.081176, 39.436712],
              [-76.060989, 39.447722],
              [-76.060988, 39.447775],
              [-76.060944, 39.451174],
              [-76.060931, 39.452208],
              [-76.062259, 39.454955],
              [-76.063874, 39.458295],
              [-76.069814, 39.470577],
              [-76.071836, 39.47476],
              [-76.071975, 39.475047],
              [-76.072309, 39.47513],
              [-76.073119, 39.475331],
              [-76.08159, 39.477438],
              [-76.083082, 39.477809],
              [-76.083286, 39.47786],
              [-76.098315, 39.476116],
              [-76.099506, 39.476618],
              [-76.100218, 39.476918],
              [-76.104665, 39.478792],
              [-76.108813, 39.482333],
              [-76.113929, 39.486701],
              [-76.11461, 39.488619],
              [-76.117253, 39.496068],
              [-76.116831, 39.496882],
              [-76.111583, 39.507001],
              [-76.107126, 39.515597],
              [-76.106215, 39.517353],
              [-76.105678, 39.518388],
              [-76.105571, 39.518595],
              [-76.102955, 39.523639],
              [-76.096072, 39.536912],
              [-76.075714, 39.543032],
              [-76.063811, 39.54661],
              [-76.063379, 39.546638],
              [-76.046876, 39.547713],
              [-76.03042, 39.548784],
              [-76.006341, 39.550352],
              [-76.006272, 39.550457],
              [-76.006213, 39.550546],
              [-76.004207, 39.553594],
              [-76.003434, 39.554768],
              [-76.002793, 39.555741],
              [-76.001244, 39.558096],
              [-76.00019, 39.559696],
              [-75.999669, 39.560488],
              [-75.992633, 39.563098],
              [-75.970337, 39.557637],
              [-75.967221, 39.55014],
              [-75.967186, 39.548627],
              [-75.967173, 39.548047],
              [-75.967093, 39.544623],
              [-75.966959, 39.538839],
              [-75.966955, 39.53865],
              [-75.973678, 39.532237],
              [-75.975313, 39.530678],
              [-75.976057, 39.529968],
              [-75.976105, 39.529876],
              [-75.980279, 39.5219],
              [-75.985238, 39.512424],
              [-75.985403, 39.512108],
              [-75.986298, 39.510398],
              [-75.993469, 39.490583],
              [-75.994135, 39.488743],
              [-75.995289, 39.483014],
              [-75.99657, 39.476658],
              [-76.002926, 39.469642],
              [-76.010009, 39.45717],
              [-76.011716, 39.454165],
              [-76.012312, 39.453115],
              [-76.01188, 39.452524],
              [-76.009536, 39.449316],
              [-76.009452, 39.449201],
              [-76.009071, 39.449256],
              [-76.002579, 39.450194],
              [-76.002513, 39.450204],
              [-76.002497, 39.450231],
              [-75.998276, 39.457182],
              [-75.994432, 39.457862],
              [-75.991779, 39.458332],
              [-75.990128, 39.458624],
              [-75.990005, 39.458646],
              [-75.976601, 39.447808],
              [-75.976698, 39.44569],
              [-75.976747, 39.444627],
              [-75.977751, 39.44302],
              [-75.982585, 39.435287],
              [-75.98884, 39.433187],
              [-75.992425, 39.431983],
              [-75.992742, 39.431877],
              [-75.996697, 39.430549],
              [-75.997396, 39.430314],
              [-75.998586, 39.428333],
              [-76.002856, 39.421225],
              [-76.00688, 39.414527],
              [-76.009693, 39.41276],
              [-76.012567, 39.410955],
              [-76.015763, 39.408947],
              [-76.016531, 39.408465],
              [-76.018061, 39.407929],
              [-76.018726, 39.407696],
              [-76.03472, 39.402093],
              [-76.035002, 39.401994],
              [-76.035298, 39.401609],
              [-76.040612, 39.394692],
              [-76.040962, 39.394237],
              [-76.040854, 39.393594],
              [-76.039973, 39.388327],
              [-76.039932, 39.38808],
              [-76.039279, 39.387796],
              [-76.035644, 39.386213],
              [-76.035568, 39.38618],
              [-76.035464, 39.386176],
              [-76.022304, 39.385716],
              [-76.006805, 39.385174],
              [-76.002515, 39.385024],
              [-76.002514, 39.384805],
              [-76.002463, 39.37644],
              [-76.002408, 39.367501],
              [-76.006546, 39.366374],
              [-76.019091, 39.362958],
              [-76.02299, 39.361896],
              [-76.030064, 39.365826],
              [-76.031767, 39.366772],
              [-76.032923, 39.367414],
              [-76.049846, 39.370644],
              [-76.054157, 39.370759],
              [-76.057876, 39.370857],
              [-76.05872, 39.37088],
              [-76.059335, 39.370896],
              [-76.061504, 39.370954],
              [-76.065716, 39.371066],
              [-76.065887, 39.37107],
              [-76.074992, 39.371312],
              [-76.108373, 39.3722],
              [-76.108942, 39.372215],
              [-76.110527, 39.372257],
              [-76.110598, 39.372119],
              [-76.113215, 39.367032],
              [-76.115935, 39.361744],
              [-76.116356, 39.360925],
              [-76.116698, 39.360744],
              [-76.129983, 39.353702],
              [-76.13495, 39.35107],
              [-76.136971, 39.344414],
              [-76.135105, 39.34246],
              [-76.133225, 39.340491],
              [-76.145524, 39.334399],
              [-76.152722, 39.335167],
              [-76.157163, 39.335641],
              [-76.159673, 39.335909],
              [-76.168365, 39.332824],
              [-76.169411, 39.332453],
              [-76.170422, 39.332094],
              [-76.170541, 39.331994],
              [-76.170588, 39.331954],
              [-76.185507, 39.319396],
              [-76.185581, 39.319334],
              [-76.186001, 39.317814],
              [-76.186647, 39.315475],
              [-76.186637, 39.315426],
              [-76.186024, 39.312462],
              [-76.179092, 39.310098],
              [-76.178983, 39.309926],
              [-76.176865, 39.306584],
              [-76.176778, 39.306447],
              [-76.176804, 39.306229],
              [-76.177178, 39.303099],
              [-76.177704, 39.298701],
              [-76.177712, 39.298686],
              [-76.181478, 39.291829],
              [-76.181496, 39.291797],
              [-76.185674, 39.285367],
              [-76.185909, 39.285157],
              [-76.189868, 39.281623],
              [-76.191285, 39.280358],
              [-76.193029, 39.278801],
              [-76.20259, 39.270265],
              [-76.203031, 39.269871],
              [-76.210748, 39.269816],
              [-76.211179, 39.269813],
              [-76.211253, 39.269812],
              [-76.211306, 39.269761],
              [-76.21752, 39.263754],
              [-76.218339, 39.262963],
              [-76.219312, 39.262022],
              [-76.219338, 39.261997],
              [-76.220475, 39.259433],
              [-76.22622, 39.246485],
              [-76.232051, 39.233341],
              [-76.232612, 39.232333],
              [-76.248741, 39.203333],
              [-76.251032, 39.199214],
              [-76.255831, 39.191595],
              [-76.266602, 39.180523],
              [-76.266963, 39.179848],
              [-76.268631, 39.176727],
              [-76.269467, 39.175163],
              [-76.274303, 39.166115],
              [-76.274637, 39.16549],
              [-76.274741, 39.164961],
              [-76.27566, 39.160304],
              [-76.276807, 39.154484],
              [-76.278527, 39.145764],
              [-76.276721, 39.145522],
              [-76.274907, 39.145279],
              [-76.268096, 39.144367],
              [-76.26654, 39.144158],
              [-76.264417, 39.143874],
              [-76.260894, 39.143402],
              [-76.260343, 39.142722],
              [-76.252968, 39.133626],
              [-76.252946, 39.133577],
              [-76.24505, 39.116484],
              [-76.240603, 39.106856],
              [-76.233457, 39.091385],
              [-76.231748, 39.082826],
              [-76.231427, 39.071714],
              [-76.231117, 39.061017],
              [-76.231212, 39.060769],
              [-76.237065, 39.045521],
              [-76.2375, 39.044872],
              [-76.239443, 39.041977],
              [-76.240905, 39.039798],
              [-76.242687, 39.028926],
              [-76.241932, 39.028206],
              [-76.240226, 39.026581],
              [-76.231765, 39.018518],
              [-76.223671, 39.015478],
              [-76.221148, 39.01453],
              [-76.21685, 39.012916],
              [-76.209285, 39.010074],
              [-76.209114, 39.01001],
              [-76.202176, 39.013714],
              [-76.201005, 39.014339],
              [-76.200666, 39.01452],
              [-76.205958, 39.021475],
              [-76.206796, 39.022575],
              [-76.206852, 39.022649],
              [-76.208346, 39.024614],
              [-76.208502, 39.024818],
              [-76.209517, 39.028848],
              [-76.209827, 39.030081],
              [-76.210477, 39.032664],
              [-76.211589, 39.03708],
              [-76.21204, 39.03887],
              [-76.212616, 39.041158],
              [-76.212602, 39.041288],
              [-76.212563, 39.041641],
              [-76.211838, 39.048184],
              [-76.210876, 39.056874],
              [-76.210251, 39.062511],
              [-76.210041, 39.06441],
              [-76.207604, 39.072176],
              [-76.205108, 39.080129],
              [-76.203548, 39.085101],
              [-76.203383, 39.085626],
              [-76.203333, 39.085654],
              [-76.194703, 39.090403],
              [-76.189907, 39.093042],
              [-76.183908, 39.096344],
              [-76.169891, 39.09507],
              [-76.169414, 39.095027],
              [-76.169087, 39.094997],
              [-76.167347, 39.094839],
              [-76.15809, 39.093998],
              [-76.145174, 39.092824],
              [-76.150528, 39.079421],
              [-76.153465, 39.074568],
              [-76.156572, 39.069433],
              [-76.15896, 39.065486],
              [-76.16906, 39.062787],
              [-76.175284, 39.058805],
              [-76.177046, 39.056329],
              [-76.179456, 39.052941],
              [-76.184207, 39.046264],
              [-76.178281, 39.031663],
              [-76.178115, 39.031456],
              [-76.177832, 39.031102],
              [-76.174633, 39.0271],
              [-76.173393, 39.02555],
              [-76.167574, 39.018273],
              [-76.163616, 39.010057],
              [-76.163898, 39.002096],
              [-76.163956, 39.000437],
              [-76.163988, 38.999542],
              [-76.163988, 38.999541],
              [-76.164004, 38.99953],
              [-76.168332, 38.996546],
              [-76.180663, 38.988042],
              [-76.182461, 38.986802],
              [-76.187165, 38.983558],
              [-76.202081, 38.973272],
              [-76.20236, 38.973079],
              [-76.218773, 38.970562],
              [-76.218929, 38.970538],
              [-76.228748, 38.97722],
              [-76.229277, 38.97758],
              [-76.229993, 38.977728],
              [-76.243619, 38.980534],
              [-76.246049, 38.981035],
              [-76.258724, 38.983646],
              [-76.258813, 38.983664],
              [-76.275964, 38.982587],
              [-76.277457, 38.982493],
              [-76.277478, 38.982492],
              [-76.278058, 38.983246],
              [-76.280355, 38.986236],
              [-76.28328, 38.990044],
              [-76.284893, 38.992143],
              [-76.286484, 38.994215],
              [-76.289326, 38.997914],
              [-76.2919, 39.001264],
              [-76.293962, 39.003948],
              [-76.29409, 39.004263],
              [-76.30265, 39.025346],
              [-76.302846, 39.025828],
              [-76.301027, 39.031595],
              [-76.30104, 39.031721],
              [-76.301054, 39.031862],
              [-76.301506, 39.036298],
              [-76.301645, 39.037663],
              [-76.301847, 39.039651],
              [-76.302029, 39.039571],
              [-76.311766, 39.035257],
              [-76.320269, 39.02302],
              [-76.320274, 39.023013],
              [-76.320277, 39.022998],
              [-76.32259, 39.0131],
              [-76.323557, 39.008961],
              [-76.322296, 39.006375],
              [-76.322346, 39.005488],
              [-76.322679, 38.999602],
              [-76.323293, 38.998767],
              [-76.33129, 38.98789],
              [-76.333703, 38.984607],
              [-76.343672, 38.971048],
              [-76.351637, 38.960214],
              [-76.353828, 38.957234],
              [-76.354949, 38.954672],
              [-76.357752, 38.948262],
              [-76.357933, 38.947848],
              [-76.359669, 38.94388],
              [-76.361727, 38.939175],
              [-76.36205, 38.936568],
              [-76.364523, 38.916632],
              [-76.36478, 38.914553],
              [-76.36513, 38.911736],
              [-76.365658, 38.907477],
              [-76.365388, 38.898219],
              [-76.365225, 38.892614],
              [-76.364678, 38.873831],
              [-76.367344, 38.868424],
              [-76.367549, 38.868009],
              [-76.372553, 38.85786],
              [-76.375874, 38.851126],
              [-76.376183, 38.8505],
              [-76.376202, 38.850461],
              [-76.376031, 38.848777],
              [-76.375443, 38.842988],
              [-76.375303, 38.841611],
              [-76.375138, 38.839981],
              [-76.375086, 38.839474],
              [-76.373122, 38.838519],
              [-76.372719, 38.838324],
              [-76.368359, 38.836205],
              [-76.368195, 38.836125],
              [-76.368164, 38.836194],
              [-76.366501, 38.839936],
              [-76.36132, 38.851589],
              [-76.361141, 38.851992],
              [-76.360095, 38.852518],
              [-76.35996, 38.852586],
              [-76.356361, 38.854396],
              [-76.35039, 38.857399],
              [-76.348826, 38.857134],
              [-76.340587, 38.85574],
              [-76.339667, 38.85637],
              [-76.338136, 38.857418],
              [-76.337901, 38.857579],
              [-76.334019, 38.860238],
              [-76.33103, 38.86432],
              [-76.331103, 38.864686],
              [-76.332651, 38.872438],
              [-76.333211, 38.875241],
              [-76.333258, 38.875478],
              [-76.333801, 38.878194],
              [-76.335341, 38.885907],
              [-76.335364, 38.886021],
              [-76.335681, 38.886673],
              [-76.336326, 38.888001],
              [-76.33656, 38.888481],
              [-76.336986, 38.889357],
              [-76.337946, 38.891332],
              [-76.338501, 38.892474],
              [-76.338416, 38.892954],
              [-76.338123, 38.894601],
              [-76.338047, 38.895034],
              [-76.337358, 38.898915],
              [-76.337227, 38.899653],
              [-76.337097, 38.90038],
              [-76.336966, 38.901118],
              [-76.336827, 38.901905],
              [-76.336116, 38.905907],
              [-76.336104, 38.905977],
              [-76.324102, 38.911172],
              [-76.324097, 38.911174],
              [-76.323252, 38.911193],
              [-76.322715, 38.911205],
              [-76.319272, 38.911282],
              [-76.31853, 38.911299],
              [-76.317977, 38.911311],
              [-76.317947, 38.911312],
              [-76.308425, 38.898404],
              [-76.293254, 38.902568],
              [-76.293255, 38.902582],
              [-76.293309, 38.903244],
              [-76.293328, 38.903479],
              [-76.293341, 38.903635],
              [-76.293358, 38.903854],
              [-76.293492, 38.905499],
              [-76.293794, 38.909222],
              [-76.293829, 38.909649],
              [-76.293843, 38.909826],
              [-76.293867, 38.910121],
              [-76.293963, 38.910266],
              [-76.298492, 38.917121],
              [-76.299406, 38.918505],
              [-76.299431, 38.918542],
              [-76.298208, 38.92206],
              [-76.295911, 38.928663],
              [-76.29558, 38.928855],
              [-76.291211, 38.931394],
              [-76.288813, 38.932787],
              [-76.284227, 38.935452],
              [-76.276033, 38.940213],
              [-76.273258, 38.941826],
              [-76.273083, 38.941927],
              [-76.273022, 38.94184],
              [-76.271625, 38.939844],
              [-76.270954, 38.938886],
              [-76.269179, 38.936349],
              [-76.26626, 38.932179],
              [-76.265772, 38.931482],
              [-76.264943, 38.930297],
              [-76.264692, 38.924764],
              [-76.264683, 38.924576],
              [-76.262226, 38.919976],
              [-76.258206, 38.919185],
              [-76.25808, 38.91916],
              [-76.256397, 38.918829],
              [-76.25619, 38.918893],
              [-76.255819, 38.919008],
              [-76.249889, 38.920841],
              [-76.249674, 38.920907],
              [-76.249355, 38.921465],
              [-76.249285, 38.921587],
              [-76.249163, 38.9218],
              [-76.248023, 38.92379],
              [-76.248472, 38.924494],
              [-76.248574, 38.924655],
              [-76.248702, 38.924855],
              [-76.248844, 38.925076],
              [-76.248896, 38.925159],
              [-76.249246, 38.925707],
              [-76.249622, 38.926297],
              [-76.250838, 38.928204],
              [-76.250868, 38.92825],
              [-76.250157, 38.938667],
              [-76.234681, 38.941956],
              [-76.233895, 38.942123],
              [-76.232038, 38.942518],
              [-76.228405, 38.941489],
              [-76.22813, 38.941412],
              [-76.213842, 38.937366],
              [-76.213731, 38.937269],
              [-76.207695, 38.931954],
              [-76.203638, 38.928382],
              [-76.204091, 38.917058],
              [-76.204122, 38.916269],
              [-76.204129, 38.916096],
              [-76.204544, 38.905715],
              [-76.205063, 38.892726],
              [-76.200082, 38.882885],
              [-76.202314, 38.864906],
              [-76.202598, 38.862616],
              [-76.200728, 38.855389],
              [-76.199544, 38.850817],
              [-76.197736, 38.84383],
              [-76.197705, 38.843712],
              [-76.192973, 38.833661],
              [-76.192946, 38.833603],
              [-76.192874, 38.83345],
              [-76.191172, 38.829834],
              [-76.19109, 38.82966],
              [-76.192537, 38.82479],
              [-76.192765, 38.824024],
              [-76.192865, 38.823687],
              [-76.192924, 38.823489],
              [-76.19302, 38.823165],
              [-76.193073, 38.822989],
              [-76.193272, 38.822319],
              [-76.19343, 38.821787],
              [-76.19537, 38.818759],
              [-76.196426, 38.817111],
              [-76.196488, 38.817015],
              [-76.197432, 38.815541],
              [-76.198138, 38.81444],
              [-76.219328, 38.812371],
              [-76.221162, 38.813052],
              [-76.228071, 38.815617],
              [-76.229199, 38.816036],
              [-76.23877, 38.81959],
              [-76.245886, 38.822232],
              [-76.250296, 38.825389],
              [-76.250364, 38.825438],
              [-76.255322, 38.832525],
              [-76.255343, 38.832554],
              [-76.255787, 38.833189],
              [-76.257353, 38.835428],
              [-76.261627, 38.841536],
              [-76.261907, 38.841936],
              [-76.262179, 38.842325],
              [-76.265678, 38.847326],
              [-76.265808, 38.847512],
              [-76.265759, 38.847638],
              [-76.264221, 38.851572],
              [-76.265999, 38.85162],
              [-76.267175, 38.851652],
              [-76.271575, 38.851771],
              [-76.274405, 38.844766],
              [-76.27804, 38.835768],
              [-76.278151, 38.835494],
              [-76.27742, 38.831468],
              [-76.277411, 38.831419],
              [-76.277748, 38.831295],
              [-76.277854, 38.831256],
              [-76.284768, 38.828706],
              [-76.288455, 38.827347],
              [-76.292144, 38.827729],
              [-76.293648, 38.827884],
              [-76.295436, 38.828069],
              [-76.295454, 38.828071],
              [-76.29555, 38.828081],
              [-76.295992, 38.828127],
              [-76.296259, 38.828155],
              [-76.29632, 38.828161],
              [-76.296329, 38.828162],
              [-76.296364, 38.828165],
              [-76.296394, 38.828168],
              [-76.296471, 38.828176],
              [-76.296564, 38.828186],
              [-76.2978, 38.828314],
              [-76.298956, 38.827519],
              [-76.300886, 38.826192],
              [-76.300889, 38.82619],
              [-76.301886, 38.824595],
              [-76.307267, 38.815993],
              [-76.308127, 38.814618],
              [-76.308294, 38.814349],
              [-76.308306, 38.814331],
              [-76.308922, 38.813346],
              [-76.310081, 38.796846],
              [-76.310556, 38.796237],
              [-76.310626, 38.796147],
              [-76.310664, 38.796098],
              [-76.310743, 38.795996],
              [-76.312886, 38.793247],
              [-76.3227, 38.780657],
              [-76.323768, 38.779287],
              [-76.329721, 38.775789],
              [-76.333752, 38.77342],
              [-76.334619, 38.772911],
              [-76.341302, 38.751901],
              [-76.341297, 38.751756],
              [-76.341293, 38.751654],
              [-76.341288, 38.751505],
              [-76.3411, 38.746148],
              [-76.341096, 38.746058],
              [-76.341093, 38.745959],
              [-76.34074, 38.735932],
              [-76.340739, 38.735894],
              [-76.340732, 38.735712],
              [-76.340715, 38.735215],
              [-76.340677, 38.734136],
              [-76.340645, 38.733225],
              [-76.340641, 38.733123],
              [-76.340637, 38.733003],
              [-76.340635, 38.73296],
              [-76.340632, 38.732857],
              [-76.340628, 38.732756],
              [-76.340618, 38.732464],
              [-76.340608, 38.732179],
              [-76.340567, 38.731008],
              [-76.340543, 38.730338],
              [-76.344597, 38.706352],
              [-76.345072, 38.703546],
              [-76.347998, 38.686234],
              [-76.344199, 38.678798],
              [-76.343784, 38.677985],
              [-76.343277, 38.676992],
              [-76.34322, 38.67688],
              [-76.340341, 38.671245],
              [-76.340065, 38.671369],
              [-76.33861, 38.672023],
              [-76.322418, 38.679304],
              [-76.321915, 38.688584],
              [-76.321905, 38.688768],
              [-76.321898, 38.688902],
              [-76.321881, 38.689217],
              [-76.321865, 38.689512],
              [-76.332079, 38.700956],
              [-76.333862, 38.702953],
              [-76.334017, 38.703127],
              [-76.333777, 38.704086],
              [-76.333532, 38.705063],
              [-76.333066, 38.706927],
              [-76.332517, 38.709118],
              [-76.331479, 38.713266],
              [-76.330149, 38.714682],
              [-76.328338, 38.716609],
              [-76.328035, 38.716932],
              [-76.327162, 38.717861],
              [-76.326135, 38.718954],
              [-76.32353, 38.721727],
              [-76.323214, 38.722063],
              [-76.322975, 38.722317],
              [-76.32286, 38.722439],
              [-76.322807, 38.722496],
              [-76.32273, 38.722578],
              [-76.322706, 38.722604],
              [-76.322705, 38.722605],
              [-76.322663, 38.72265],
              [-76.322028, 38.723326],
              [-76.322019, 38.723335],
              [-76.321885, 38.723478],
              [-76.321803, 38.723565],
              [-76.316146, 38.729586],
              [-76.312756, 38.730708],
              [-76.299401, 38.727395],
              [-76.29935, 38.727347],
              [-76.298186, 38.726255],
              [-76.295957, 38.724162],
              [-76.296537, 38.723283],
              [-76.296603, 38.723183],
              [-76.299171, 38.719287],
              [-76.298499, 38.718005],
              [-76.275019, 38.712715],
              [-76.275015, 38.712714],
              [-76.271596, 38.713216],
              [-76.271553, 38.713576],
              [-76.271447, 38.71448],
              [-76.271243, 38.716209],
              [-76.270277, 38.724385],
              [-76.26952, 38.724988],
              [-76.26937, 38.725107],
              [-76.268739, 38.725609],
              [-76.268288, 38.725969],
              [-76.261863, 38.731085],
              [-76.260976, 38.731791],
              [-76.260001, 38.732568],
              [-76.259876, 38.732667],
              [-76.259867, 38.732675],
              [-76.259741, 38.732775],
              [-76.259665, 38.732836],
              [-76.259238, 38.733176],
              [-76.258738, 38.733573],
              [-76.257851, 38.73428],
              [-76.257437, 38.734609],
              [-76.257423, 38.734621],
              [-76.257335, 38.734691],
              [-76.255348, 38.736273],
              [-76.255093, 38.736476],
              [-76.238685, 38.735434],
              [-76.23704, 38.724518],
              [-76.239841, 38.719756],
              [-76.239427, 38.717191],
              [-76.239377, 38.71688],
              [-76.238725, 38.712845],
              [-76.238306, 38.712344],
              [-76.238172, 38.712185],
              [-76.238077, 38.712071],
              [-76.237916, 38.711879],
              [-76.237818, 38.711762],
              [-76.234828, 38.708191],
              [-76.234392, 38.70767],
              [-76.234379, 38.707655],
              [-76.234249, 38.707499],
              [-76.232893, 38.70588],
              [-76.232875, 38.705859],
              [-76.232845, 38.705823],
              [-76.232814, 38.705785],
              [-76.232535, 38.705452],
              [-76.232365, 38.705249],
              [-76.232127, 38.704964],
              [-76.231758, 38.704524],
              [-76.231392, 38.704088],
              [-76.229242, 38.701519],
              [-76.226343, 38.698057],
              [-76.212808, 38.681892],
              [-76.200334, 38.670774],
              [-76.199948, 38.670997],
              [-76.199722, 38.671127],
              [-76.196716, 38.67286],
              [-76.175159, 38.673236],
              [-76.174611, 38.672811],
              [-76.168824, 38.668325],
              [-76.164465, 38.664946],
              [-76.160539, 38.661903],
              [-76.155611, 38.658083],
              [-76.154924, 38.656358],
              [-76.154889, 38.656268],
              [-76.154604, 38.655553],
              [-76.154581, 38.655495],
              [-76.154093, 38.654269],
              [-76.153769, 38.653455],
              [-76.153414, 38.652562],
              [-76.15299, 38.651495],
              [-76.152622, 38.650572],
              [-76.152603, 38.650523],
              [-76.152554, 38.6504],
              [-76.149353, 38.642356],
              [-76.148955, 38.641356],
              [-76.148559, 38.640362],
              [-76.148202, 38.639463],
              [-76.147577, 38.637893],
              [-76.147158, 38.63684],
              [-76.152885, 38.631819],
              [-76.160148, 38.625452],
              [-76.170066, 38.629225],
              [-76.174969, 38.628791],
              [-76.190902, 38.621092],
              [-76.202598, 38.613011],
              [-76.203065, 38.610741],
              [-76.212414, 38.606744],
              [-76.212427, 38.606738],
              [-76.220701, 38.609945],
              [-76.222982, 38.61083],
              [-76.22882, 38.613093],
              [-76.229159, 38.613224],
              [-76.229358, 38.613301],
              [-76.231187, 38.61401],
              [-76.234929, 38.624002],
              [-76.235987, 38.626827],
              [-76.23665, 38.628598],
              [-76.24651, 38.626282],
              [-76.247896, 38.625404],
              [-76.253926, 38.621586],
              [-76.260317, 38.617539],
              [-76.261135, 38.617021],
              [-76.262791, 38.615973],
              [-76.263577, 38.615475],
              [-76.264155, 38.615109],
              [-76.271827, 38.615661],
              [-76.276734, 38.611779],
              [-76.278146, 38.610662],
              [-76.279589, 38.60952],
              [-76.275658, 38.605298],
              [-76.275282, 38.604895],
              [-76.275246, 38.604856],
              [-76.274888, 38.604471],
              [-76.274611, 38.604174],
              [-76.272584, 38.601997],
              [-76.268633, 38.597753],
              [-76.273496, 38.59139],
              [-76.290895, 38.582548],
              [-76.291998, 38.581988],
              [-76.305172, 38.575293],
              [-76.308321, 38.571769],
              [-76.299301, 38.57048],
              [-76.296469, 38.570076],
              [-76.290667, 38.569247],
              [-76.290043, 38.569158],
              [-76.289017, 38.567982],
              [-76.283632, 38.561807],
              [-76.283189, 38.5613],
              [-76.27964, 38.557231],
              [-76.275913, 38.548809],
              [-76.277461, 38.541851],
              [-76.281047, 38.53613],
              [-76.278106, 38.532468],
              [-76.274057, 38.531207],
              [-76.253624, 38.539393],
              [-76.251033, 38.539191],
              [-76.250265, 38.539131],
              [-76.248885, 38.539023],
              [-76.244396, 38.536966],
              [-76.2473, 38.523818],
              [-76.247894, 38.523019],
              [-76.26035, 38.506255],
              [-76.262133, 38.504874],
              [-76.263968, 38.503452],
              [-76.281761, 38.502165],
              [-76.283595, 38.504157],
              [-76.289507, 38.503906],
              [-76.318054, 38.498199],
              [-76.327257, 38.500121],
              [-76.33636, 38.492235],
              [-76.33199, 38.475225],
              [-76.331758, 38.474324],
              [-76.331559, 38.473548],
              [-76.331469, 38.473432],
              [-76.331383, 38.473323],
              [-76.320843, 38.459862],
              [-76.311767, 38.450439],
              [-76.3116, 38.450266],
              [-76.301488, 38.439767],
              [-76.300186, 38.437916],
              [-76.290681, 38.424404],
              [-76.28302, 38.413512],
              [-76.280551, 38.403143],
              [-76.282271, 38.393118],
              [-76.282144, 38.392754],
              [-76.281697, 38.39147],
              [-76.281396, 38.390604],
              [-76.28132, 38.390384],
              [-76.281214, 38.390079],
              [-76.280749, 38.388743],
              [-76.278813, 38.383179],
              [-76.278722, 38.382919],
              [-76.273003, 38.366483],
              [-76.258022, 38.366695],
              [-76.257479, 38.366702],
              [-76.256788, 38.366712],
              [-76.249666, 38.364214],
              [-76.248766, 38.363076],
              [-76.24735, 38.361285],
              [-76.24041, 38.352508],
              [-76.240196, 38.352238],
              [-76.239902, 38.351866],
              [-76.239601, 38.351486],
              [-76.239056, 38.350795],
              [-76.23901, 38.350738],
              [-76.238611, 38.350233],
              [-76.238541, 38.349238],
              [-76.238478, 38.348355],
              [-76.238452, 38.347986],
              [-76.257898, 38.342014],
              [-76.258383, 38.341865],
              [-76.259235, 38.341603],
              [-76.259261, 38.341595],
              [-76.259286, 38.341619],
              [-76.264186, 38.346436],
              [-76.266602, 38.339502],
              [-76.258189, 38.318373],
              [-76.254473, 38.31512],
              [-76.243897, 38.310313],
              [-76.226408, 38.309989],
              [-76.226376, 38.309988],
              [-76.218051, 38.305899],
              [-76.217616, 38.305686],
              [-76.216266, 38.305023],
              [-76.211446, 38.302656],
              [-76.203909, 38.293461],
              [-76.20343, 38.292876],
              [-76.202897, 38.292226],
              [-76.202628, 38.291898],
              [-76.202334, 38.291539],
              [-76.201603, 38.290647],
              [-76.201591, 38.290633],
              [-76.197871, 38.286094],
              [-76.197693, 38.285877],
              [-76.197155, 38.28522],
              [-76.190531, 38.277139],
              [-76.189655, 38.272633],
              [-76.189627, 38.272487],
              [-76.188644, 38.267434],
              [-76.17335, 38.247037],
              [-76.151035, 38.234215],
              [-76.140068, 38.231305],
              [-76.131332, 38.23288],
              [-76.128898, 38.235267],
              [-76.128452, 38.235704],
              [-76.125756, 38.238348],
              [-76.125856, 38.23888],
              [-76.126453, 38.242046],
              [-76.126623, 38.242949],
              [-76.130952, 38.24443],
              [-76.132544, 38.244974],
              [-76.13498, 38.245807],
              [-76.135169, 38.245872],
              [-76.146297, 38.249678],
              [-76.163249, 38.248913],
              [-76.164388, 38.250061],
              [-76.171254, 38.256984],
              [-76.175783, 38.261551],
              [-76.178282, 38.270336],
              [-76.179123, 38.273291],
              [-76.180103, 38.276739],
              [-76.180165, 38.276956],
              [-76.180115, 38.277019],
              [-76.174683, 38.283818],
              [-76.174598, 38.283924],
              [-76.174484, 38.284068],
              [-76.174152, 38.284483],
              [-76.174104, 38.284543],
              [-76.174011, 38.284659],
              [-76.173844, 38.284869],
              [-76.173555, 38.28523],
              [-76.173418, 38.285326],
              [-76.166154, 38.290431],
              [-76.161348, 38.290898],
              [-76.160838, 38.290948],
              [-76.160474, 38.290983],
              [-76.149876, 38.284663],
              [-76.149398, 38.284525],
              [-76.143127, 38.282714],
              [-76.140947, 38.282085],
              [-76.140674, 38.282006],
              [-76.138596, 38.281406],
              [-76.138524, 38.281385],
              [-76.138479, 38.281394],
              [-76.137442, 38.281606],
              [-76.137238, 38.281648],
              [-76.131085, 38.282904],
              [-76.12694, 38.283751],
              [-76.111296, 38.286946],
              [-76.102549, 38.277153],
              [-76.107592, 38.262525],
              [-76.09972, 38.253647],
              [-76.094689, 38.25335],
              [-76.092723, 38.253234],
              [-76.092417, 38.253216],
              [-76.089797, 38.253061],
              [-76.082549, 38.252633],
              [-76.082268, 38.252616],
              [-76.074897, 38.252181],
              [-76.07476, 38.251832],
              [-76.074726, 38.251745],
              [-76.074607, 38.251443],
              [-76.074568, 38.251344],
              [-76.074515, 38.251208],
              [-76.074491, 38.251148],
              [-76.073725, 38.2492],
              [-76.073493, 38.248609],
              [-76.071154, 38.242657],
              [-76.070831, 38.241836],
              [-76.069502, 38.238455],
              [-76.05801, 38.227079],
              [-76.032044, 38.216684],
              [-76.033338, 38.221599],
              [-76.033455, 38.222046],
              [-76.035695, 38.230556],
              [-76.036102, 38.231094],
              [-76.037103, 38.232418],
              [-76.037109, 38.232426],
              [-76.03796, 38.233551],
              [-76.043814, 38.241294],
              [-76.044108, 38.241682],
              [-76.044141, 38.243447],
              [-76.044251, 38.249373],
              [-76.043927, 38.249712],
              [-76.039738, 38.254093],
              [-76.038935, 38.254932],
              [-76.033737, 38.266363],
              [-76.03361, 38.266644],
              [-76.032998, 38.267989],
              [-76.032771, 38.268487],
              [-76.032664, 38.268722],
              [-76.032595, 38.268875],
              [-76.027487, 38.280108],
              [-76.027557, 38.280288],
              [-76.028234, 38.282035],
              [-76.030532, 38.28796],
              [-76.040019, 38.295738],
              [-76.047147, 38.301582],
              [-76.05022, 38.304101],
              [-76.049647, 38.309017],
              [-76.049609, 38.309348],
              [-76.04958, 38.309594],
              [-76.049523, 38.309718],
              [-76.049207, 38.310404],
              [-76.048965, 38.31093],
              [-76.048637, 38.311643],
              [-76.047992, 38.313044],
              [-76.047401, 38.314329],
              [-76.046367, 38.316576],
              [-76.045964, 38.317452],
              [-76.045599, 38.318246],
              [-76.045057, 38.318776],
              [-76.044649, 38.319175],
              [-76.043923, 38.319884],
              [-76.04318, 38.32061],
              [-76.041659, 38.322097],
              [-76.041618, 38.322137],
              [-76.041431, 38.322163],
              [-76.033947, 38.323211],
              [-76.016682, 38.332429],
              [-76.010437, 38.352504],
              [-76.010366, 38.352732],
              [-76.010217, 38.353211],
              [-76.010255, 38.353287],
              [-76.010737, 38.354251],
              [-76.011033, 38.354844],
              [-76.012149, 38.357077],
              [-76.011869, 38.360582],
              [-76.006949, 38.370216],
              [-76.004946, 38.372045],
              [-76.002282, 38.374477],
              [-76.002156, 38.374439],
              [-76.001839, 38.374343],
              [-75.995706, 38.37248],
              [-75.980829, 38.367962],
              [-75.98018, 38.367765],
              [-75.979727, 38.367627],
              [-75.973876, 38.36585],
              [-75.972281, 38.362584],
              [-75.972174, 38.362365],
              [-75.97191, 38.361826],
              [-75.971541, 38.361069],
              [-75.971019, 38.360002],
              [-75.97084, 38.359635],
              [-75.969161, 38.356197],
              [-75.968881, 38.355623],
              [-75.966397, 38.35054],
              [-75.965366, 38.348429],
              [-75.961948, 38.341431],
              [-75.961946, 38.336018],
              [-75.961945, 38.33583],
              [-75.961944, 38.332572],
              [-75.964237, 38.324285],
              [-75.96888, 38.320498],
              [-75.96929, 38.320164],
              [-75.969577, 38.320044],
              [-75.981345, 38.315147],
              [-75.982523, 38.315022],
              [-75.983171, 38.314954],
              [-75.983186, 38.314952],
              [-75.984433, 38.314821],
              [-75.984784, 38.314783],
              [-75.986025, 38.314652],
              [-75.990485, 38.314181],
              [-75.991151, 38.31411],
              [-76.008647, 38.312261],
              [-76.009377, 38.311997],
              [-76.017364, 38.309106],
              [-76.017308, 38.309007],
              [-76.016514, 38.3076],
              [-76.016314, 38.307247],
              [-76.016291, 38.307206],
              [-76.011458, 38.30564],
              [-76.011245, 38.305572],
              [-76.007478, 38.304351],
              [-76.007375, 38.304318],
              [-76.007254, 38.304165],
              [-76.007118, 38.303994],
              [-76.00401, 38.300079],
              [-76.000241, 38.295331],
              [-75.993391, 38.286702],
              [-75.992829, 38.285994],
              [-75.992669, 38.285792],
              [-75.991687, 38.284555],
              [-75.991162, 38.283894],
              [-75.990385, 38.282915],
              [-75.988731, 38.280581],
              [-75.987814, 38.279287],
              [-75.985815, 38.276466],
              [-75.984274, 38.265155],
              [-75.963453, 38.251793],
              [-75.962235, 38.24754],
              [-75.963969, 38.241598],
              [-75.964119, 38.241085],
              [-75.964528, 38.240692],
              [-75.969326, 38.236076],
              [-75.969383, 38.236021],
              [-75.970115, 38.235317],
              [-75.9704, 38.235043],
              [-75.972212, 38.2333],
              [-75.971487, 38.233457],
              [-75.970514, 38.233668],
              [-75.962931, 38.235311],
              [-75.962729, 38.235355],
              [-75.962111, 38.235489],
              [-75.961972, 38.235519],
              [-75.958794, 38.236208],
              [-75.958338, 38.236306],
              [-75.955833, 38.236849],
              [-75.955164, 38.236994],
              [-75.951156, 38.237862],
              [-75.948197, 38.238504],
              [-75.946414, 38.23889],
              [-75.942804, 38.243949],
              [-75.94119, 38.246211],
              [-75.940697, 38.246902],
              [-75.942263, 38.247826],
              [-75.942465, 38.247945],
              [-75.943032, 38.248279],
              [-75.9445, 38.249145],
              [-75.945678, 38.249051],
              [-75.947876, 38.248875],
              [-75.948796, 38.248802],
              [-75.949458, 38.249273],
              [-75.950056, 38.249699],
              [-75.954542, 38.252894],
              [-75.954561, 38.253476],
              [-75.954582, 38.254108],
              [-75.95481, 38.261016],
              [-75.954908, 38.263997],
              [-75.954908, 38.263998],
              [-75.954824, 38.264071],
              [-75.954737, 38.264146],
              [-75.954701, 38.264177],
              [-75.954568, 38.264293],
              [-75.954483, 38.264366],
              [-75.951647, 38.266819],
              [-75.951563, 38.266892],
              [-75.951512, 38.266936],
              [-75.951497, 38.266949],
              [-75.95136, 38.267006],
              [-75.948346, 38.268261],
              [-75.942703, 38.270611],
              [-75.942462, 38.270711],
              [-75.940302, 38.271611],
              [-75.938577, 38.272329],
              [-75.925492, 38.26667],
              [-75.920279, 38.264415],
              [-75.919446, 38.264056],
              [-75.917297, 38.263126],
              [-75.911143, 38.257951],
              [-75.908272, 38.252045],
              [-75.90845, 38.246648],
              [-75.906016, 38.242447],
              [-75.905852, 38.242165],
              [-75.901381, 38.234448],
              [-75.900661, 38.233206],
              [-75.90004, 38.232133],
              [-75.899781, 38.231921],
              [-75.895879, 38.228717],
              [-75.895689, 38.228561],
              [-75.894583, 38.228439],
              [-75.890669, 38.228009],
              [-75.885909, 38.230866],
              [-75.885676, 38.231006],
              [-75.889356, 38.2395],
              [-75.888513, 38.241423],
              [-75.887409, 38.24208],
              [-75.886841, 38.242418],
              [-75.8852, 38.243395],
              [-75.883435, 38.244445],
              [-75.882873, 38.244449],
              [-75.874653, 38.244514],
              [-75.872464, 38.243968],
              [-75.870318, 38.243432],
              [-75.87031, 38.243425],
              [-75.864628, 38.23832],
              [-75.85916, 38.233407],
              [-75.851528, 38.22655],
              [-75.851396, 38.226432],
              [-75.846377, 38.210477],
              [-75.846713, 38.210295],
              [-75.847032, 38.210122],
              [-75.847299, 38.209977],
              [-75.848473, 38.20934],
              [-75.852258, 38.207286],
              [-75.854406, 38.20612],
              [-75.85696, 38.204734],
              [-75.862444, 38.201759],
              [-75.864104, 38.200858],
              [-75.86847, 38.200037],
              [-75.870975, 38.199566],
              [-75.87725, 38.198386],
              [-75.877751, 38.198292],
              [-75.878293, 38.198407],
              [-75.884544, 38.199739],
              [-75.884603, 38.199751],
              [-75.88494, 38.200493],
              [-75.886217, 38.203309],
              [-75.888073, 38.203813],
              [-75.933932, 38.18967],
              [-75.941448, 38.187352],
              [-75.942375, 38.187066],
              [-75.945419, 38.184094],
              [-75.946586, 38.182955],
              [-75.948738, 38.180854],
              [-75.948891, 38.180704],
              [-75.94942, 38.180188],
              [-75.949575, 38.180037],
              [-75.951566, 38.178093],
              [-75.951583, 38.178014],
              [-75.95185, 38.176794],
              [-75.951972, 38.176239],
              [-75.951812, 38.176053],
              [-75.948709, 38.172451],
              [-75.948566, 38.172285],
              [-75.94822, 38.171884],
              [-75.948129, 38.171778],
              [-75.94728, 38.170792],
              [-75.947417, 38.169439],
              [-75.947487, 38.168736],
              [-75.947534, 38.168274],
              [-75.949752, 38.164486],
              [-75.951273, 38.161887],
              [-75.951425, 38.161436],
              [-75.952411, 38.158513],
              [-75.959616, 38.137141],
              [-75.959496, 38.136915],
              [-75.958786, 38.135572],
              [-75.956434, 38.131126],
              [-75.956428, 38.131115],
              [-75.949557, 38.118127],
              [-75.945297, 38.113091],
              [-75.938484, 38.109976],
              [-75.936663, 38.109956],
              [-75.936866, 38.116745],
              [-75.937015, 38.121749],
              [-75.937055, 38.123077],
              [-75.937089, 38.124209],
              [-75.936773, 38.124355],
              [-75.932738, 38.126216],
              [-75.923797, 38.130339],
              [-75.907264, 38.137964],
              [-75.906497, 38.138317],
              [-75.905599, 38.138732],
              [-75.903442, 38.139726],
              [-75.902004, 38.14039],
              [-75.901058, 38.140826],
              [-75.900355, 38.14115],
              [-75.880978, 38.137015],
              [-75.880707, 38.136957],
              [-75.871037, 38.134893],
              [-75.870056, 38.134684],
              [-75.868636, 38.134381],
              [-75.866, 38.134886],
              [-75.85954, 38.140542],
              [-75.858667, 38.140893],
              [-75.854507, 38.142567],
              [-75.849919, 38.144414],
              [-75.843862, 38.144599],
              [-75.827712, 38.133464],
              [-75.827674, 38.133438],
              [-75.827892, 38.133004],
              [-75.827993, 38.132803],
              [-75.837048, 38.114777],
              [-75.837165, 38.114546],
              [-75.837204, 38.114468],
              [-75.837563, 38.113753],
              [-75.842604, 38.113111],
              [-75.86381, 38.100968],
              [-75.865146, 38.098893],
              [-75.865697, 38.098036],
              [-75.870282, 38.090911],
              [-75.871394, 38.089183],
              [-75.880515, 38.075011],
              [-75.874189, 38.060288],
              [-75.871503, 38.05887],
              [-75.868899, 38.059131],
              [-75.867511, 38.05927],
              [-75.867267, 38.059295],
              [-75.866194, 38.059402],
              [-75.86153, 38.05987],
              [-75.861033, 38.059919],
              [-75.860946, 38.059928],
              [-75.860629, 38.05996],
              [-75.858881, 38.060135],
              [-75.859005, 38.060717],
              [-75.859281, 38.062018],
              [-75.85944, 38.062769],
              [-75.859717, 38.064073],
              [-75.860072, 38.065743],
              [-75.859568, 38.066448],
              [-75.859026, 38.067208],
              [-75.858944, 38.067323],
              [-75.852305, 38.069561],
              [-75.84718, 38.071289],
              [-75.844265, 38.072272],
              [-75.841206, 38.071595],
              [-75.841057, 38.071562],
              [-75.839935, 38.071314],
              [-75.832742, 38.069723],
              [-75.831103, 38.069361],
              [-75.830017, 38.06912],
              [-75.819591, 38.066814],
              [-75.819479, 38.066682],
              [-75.819415, 38.066606],
              [-75.813468, 38.059587],
              [-75.813378, 38.059481],
              [-75.812913, 38.058932],
              [-75.825987, 38.0464],
              [-75.826492, 38.045915],
              [-75.829276, 38.043247],
              [-75.829375, 38.043152],
              [-75.830023, 38.042845],
              [-75.833418, 38.041238],
              [-75.833657, 38.041125],
              [-75.834643, 38.040657],
              [-75.836018, 38.040007],
              [-75.847716, 38.034468],
              [-75.847922, 38.03437],
              [-75.84998, 38.034294],
              [-75.850343, 38.035877],
              [-75.850531, 38.036697],
              [-75.852655, 38.037331],
              [-75.854711, 38.037944],
              [-75.855468, 38.03817],
              [-75.856854, 38.038583],
              [-75.857507, 38.038778],
              [-75.858891, 38.03839],
              [-75.864648, 38.036773],
              [-75.865912, 38.036418],
              [-75.869513, 38.035407],
              [-75.87319, 38.034375],
              [-75.875399, 38.028241],
              [-75.875297, 38.011965],
              [-75.882768, 38.002995],
              [-75.898956, 37.974514],
              [-75.890871, 37.954847],
              [-75.89281, 37.940239],
              [-75.893655, 37.933879],
              [-75.894065, 37.93079],
              [-75.898316, 37.925114],
              [-75.89594, 37.921625],
              [-75.895791, 37.921406],
              [-75.892686, 37.916848],
              [-75.885032, 37.911717],
              [-75.883708, 37.912076],
              [-75.881913, 37.912563],
              [-75.860727, 37.91831],
              [-75.849103, 37.92447],
              [-75.848133, 37.924983],
              [-75.847933, 37.925089],
              [-75.847817, 37.925151],
              [-75.847473, 37.925333],
              [-75.847207, 37.925474],
              [-75.846621, 37.925785],
              [-75.845992, 37.926118],
              [-75.843768, 37.927297],
              [-75.832793, 37.933112],
              [-75.832414, 37.933313],
              [-75.831836, 37.934519],
              [-75.831707, 37.934789],
              [-75.830154, 37.938028],
              [-75.829901, 37.938556],
              [-75.824448, 37.942584],
              [-75.824242, 37.942736],
              [-75.822901, 37.943726],
              [-75.820774, 37.945297],
              [-75.819088, 37.946542],
              [-75.807755, 37.954912],
              [-75.80693, 37.955522],
              [-75.806147, 37.9561],
              [-75.789943, 37.968068],
              [-75.788351, 37.969244],
              [-75.785487, 37.971359],
              [-75.785273, 37.971517],
              [-75.785209, 37.971564],
              [-75.785007, 37.971714],
              [-75.783815, 37.972594],
              [-75.783444, 37.972565],
              [-75.778975, 37.972216],
              [-75.776773, 37.972044],
              [-75.759091, 37.970663],
              [-75.750244, 37.968873],
              [-75.737997, 37.963526],
              [-75.737514, 37.963705],
              [-75.735125, 37.964592],
              [-75.727952, 37.967256],
              [-75.72533, 37.969266],
              [-75.724692, 37.969754],
              [-75.722662, 37.97131],
              [-75.722085, 37.973416],
              [-75.71315, 37.976623],
              [-75.708179, 37.974972],
              [-75.686525, 37.967783],
              [-75.685995, 37.967607],
              [-75.671681, 37.966576],
              [-75.669374, 37.96513],
              [-75.66502, 37.962401],
              [-75.663095, 37.961195],
              [-75.665057, 37.956282],
              [-75.669711, 37.950796],
              [-75.660956, 37.959174],
              [-75.646507, 37.973],
              [-75.646289, 37.973209],
              [-75.645251, 37.974202],
              [-75.645096, 37.97435],
              [-75.644665, 37.974763],
              [-75.644591, 37.974833],
              [-75.644545, 37.974877],
              [-75.639786, 37.979432],
              [-75.635502, 37.983531],
              [-75.630222, 37.988584],
              [-75.626129, 37.9925],
              [-75.624341, 37.994211],
              [-75.435956, 38.010282],
              [-75.42881, 38.010854],
              [-75.398839, 38.013277],
              [-75.377851, 38.015145],
              [-75.263779, 38.025295],
              [-75.262088, 38.025445],
              [-75.260635, 38.025574],
              [-75.256076, 38.02598],
              [-75.250358, 38.026489],
              [-75.242296, 38.027206],
              [-75.242266, 38.027209],
              [-75.241817, 38.027802],
              [-75.237538, 38.033461],
              [-75.236065, 38.035409],
              [-75.23586, 38.035679],
              [-75.227592, 38.046612],
              [-75.22434, 38.050912],
              [-75.216117, 38.061786],
              [-75.206515, 38.07651],
              [-75.204911, 38.07897],
              [-75.204684, 38.079317],
              [-75.195382, 38.093582],
              [-75.193796, 38.096013],
              [-75.192925, 38.097819],
              [-75.178945, 38.126798],
              [-75.177394, 38.130014],
              [-75.16164, 38.176383],
              [-75.15897, 38.184242],
              [-75.155351, 38.192572],
              [-75.143229, 38.220475],
              [-75.116837, 38.274229],
              [-75.103757, 38.309349],
              [-75.102947, 38.311525],
              [-75.093888, 38.323432],
              [-75.092142, 38.323252],
              [-75.087466, 38.322769],
              [-75.085518, 38.32427],
              [-75.085468, 38.324389],
              [-75.085327, 38.324724],
              [-75.085171, 38.325096],
              [-75.084149, 38.327526],
              [-75.074532, 38.35039],
              [-75.073852, 38.352006],
              [-75.072476, 38.355278],
              [-75.072111, 38.356402],
              [-75.071694, 38.357686],
              [-75.071687, 38.357707],
              [-75.071632, 38.357876],
              [-75.071329, 38.358809],
              [-75.069845, 38.363376],
              [-75.069817, 38.363463],
              [-75.068559, 38.367335],
              [-75.068548, 38.36737],
              [-75.068404, 38.367812],
              [-75.068162, 38.368559],
              [-75.068111, 38.368716],
              [-75.06137, 38.389466],
              [-75.057288, 38.404738],
              [-75.056182, 38.408876],
              [-75.056, 38.40956],
              [-75.055838, 38.410164],
              [-75.054591, 38.41483],
              [-75.053309, 38.423095],
              [-75.053277, 38.423297],
              [-75.053137, 38.424201],
              [-75.0531, 38.424441],
              [-75.05282, 38.426243],
              [-75.052804, 38.426349],
              [-75.052746, 38.42672],
              [-75.052505, 38.428275],
              [-75.052471, 38.428493],
              [-75.052467, 38.428521],
              [-75.052426, 38.428784],
              [-75.052368, 38.429159],
              [-75.052226, 38.430077],
              [-75.052206, 38.430206],
              [-75.052167, 38.430457],
              [-75.052008, 38.431479],
              [-75.051997, 38.431549],
              [-75.049582, 38.447117],
              [-75.049442, 38.448023],
              [-75.049365, 38.448518],
              [-75.048939, 38.451263],
              [-75.049748, 38.486387],
              [-75.060032, 38.607709],
              [-75.060478, 38.608012],
              [-75.061259, 38.608602],
              [-75.06192, 38.608869],
              [-75.065217, 38.632394],
              [-75.06551, 38.66103],
              [-75.079221, 38.738238],
              [-75.080217, 38.750112],
              [-75.082153, 38.772157],
              [-75.089473, 38.797198],
              [-75.093805, 38.803812],
              [-75.097197, 38.803101],
              [-75.093654, 38.793992],
              [-75.097103, 38.788703],
              [-75.113331, 38.782998],
              [-75.134022, 38.782242],
              [-75.159022, 38.790193],
              [-75.160748, 38.791224],
              [-75.190552, 38.806861],
              [-75.205329, 38.823386],
              [-75.232029, 38.844254],
              [-75.263115, 38.877351],
              [-75.304078, 38.91316],
              [-75.312282, 38.924594],
              [-75.302552, 38.939002],
              [-75.311542, 38.944633],
              [-75.311882, 38.945698],
              [-75.311923, 38.945917],
              [-75.312546, 38.94928],
              [-75.312546, 38.951065],
              [-75.311607, 38.967637],
              [-75.314951, 38.980775],
              [-75.318354, 38.988191],
              [-75.34089, 39.01996],
              [-75.345763, 39.024857],
              [-75.379873, 39.04879],
              [-75.387914, 39.051174],
              [-75.396277, 39.057884],
              [-75.395806, 39.059211],
              [-75.400294, 39.065645],
              [-75.402035, 39.066885],
              [-75.401193, 39.088762],
              [-75.410625, 39.156246],
              [-75.408266, 39.174625],
              [-75.400144, 39.186456],
              [-75.398584, 39.186616],
              [-75.39479, 39.188354],
              [-75.393015, 39.204512],
              [-75.396892, 39.216141],
              [-75.404745, 39.222666],
              [-75.405716, 39.223834],
              [-75.405927, 39.243631],
              [-75.404823, 39.245898],
              [-75.402964, 39.254626],
              [-75.408376, 39.264698],
              [-75.427953, 39.285049],
              [-75.435374, 39.296676],
              [-75.435551, 39.297546],
              [-75.436936, 39.309379],
              [-75.439027, 39.313384],
              [-75.460423, 39.328236],
              [-75.469324, 39.33082],
              [-75.479963, 39.336577],
              [-75.479845, 39.337472],
              [-75.490377, 39.342818],
              [-75.491688, 39.343963],
              [-75.493148, 39.345527],
              [-75.494122, 39.34658],
              [-75.491797, 39.351845],
              [-75.494158, 39.354613],
              [-75.505276, 39.359169],
              [-75.511788, 39.365191],
              [-75.512372, 39.365656],
              [-75.512996, 39.366153],
              [-75.521682, 39.387871],
              [-75.523583, 39.391583],
              [-75.535977, 39.409384],
              [-75.538512, 39.416502],
              [-75.55589, 39.430351],
              [-75.57183, 39.438897],
              [-75.570985, 39.442486],
              [-75.578914, 39.44788],
              [-75.580185, 39.450786],
              [-75.589439, 39.460812],
              [-75.589901, 39.462022],
              [-75.593068, 39.477996],
              [-75.593068, 39.479186],
              [-75.587729, 39.495369],
              [-75.587729, 39.496353],
              [-75.576436, 39.509195],
              [-75.566933, 39.508273],
              [-75.560728, 39.520472],
              [-75.570362, 39.527223],
              [-75.569418, 39.539124],
              [-75.569359, 39.540589],
              [-75.565636, 39.558509],
              [-75.564649, 39.559922],
              [-75.563034, 39.56224],
              [-75.570783, 39.56728],
              [-75.571599, 39.567728],
              [-75.586016, 39.578448],
              [-75.586608, 39.57888],
              [-75.5872, 39.580256],
              [-75.587744, 39.580672],
              [-75.591984, 39.583248],
              [-75.592224, 39.583568],
              [-75.603584, 39.58896],
              [-75.60464, 39.58992],
              [-75.611873, 39.597408],
              [-75.611905, 39.597568],
              [-75.613793, 39.606192],
              [-75.613473, 39.606832],
              [-75.613477, 39.606861],
              [-75.613233, 39.607408],
              [-75.613665, 39.61256],
              [-75.613345, 39.613056],
              [-75.614273, 39.61464],
              [-75.614929, 39.615952],
              [-75.614065, 39.61832],
              [-75.613377, 39.620288],
              [-75.613153, 39.62096],
              [-75.611969, 39.621968],
              [-75.587147, 39.651012],
              [-75.562246, 39.656712],
              [-75.529744, 39.692613],
              [-75.509742, 39.686113],
              [-75.509342, 39.685313],
              [-75.526344, 39.656413],
              [-75.526844, 39.655713],
              [-75.559446, 39.629812],
              [-75.570798, 39.626768],
              [-75.571759, 39.623584],
              [-75.567694, 39.613744],
              [-75.561934, 39.605216],
              [-75.55587, 39.605824],
              [-75.545405, 39.596784],
              [-75.543965, 39.596],
              [-75.539949, 39.594384],
              [-75.53954, 39.594251],
              [-75.537213, 39.592944],
              [-75.534477, 39.590384],
              [-75.531133, 39.587984],
              [-75.525677, 39.584048],
              [-75.512732, 39.578],
              [-75.511932, 39.567616],
              [-75.514756, 39.562612],
              [-75.527141, 39.500112],
              [-75.528088, 39.498114],
              [-75.542693, 39.496568],
              [-75.544368, 39.479602],
              [-75.542894, 39.470447],
              [-75.536431, 39.460559],
              [-75.508383, 39.459131],
              [-75.505672, 39.452927],
              [-75.483572, 39.440824],
              [-75.476279, 39.438126],
              [-75.465212, 39.43893],
              [-75.442393, 39.402291],
              [-75.431803, 39.391625],
              [-75.422099, 39.386521],
              [-75.407294, 39.381954],
              [-75.399304, 39.37949],
              [-75.395181, 39.371398],
              [-75.394331, 39.363753],
              [-75.39003, 39.358259],
              [-75.365016, 39.341388],
              [-75.355558, 39.347823],
              [-75.341969, 39.348697],
              [-75.333743, 39.345335],
              [-75.327463, 39.33927],
              [-75.326754, 39.332473],
              [-75.315201, 39.310593],
              [-75.30601, 39.301712],
              [-75.288898, 39.289557],
              [-75.285333, 39.292212],
              [-75.28262, 39.299055],
              [-75.271629, 39.304041],
              [-75.251806, 39.299913],
              [-75.244357, 39.2857],
              [-75.242881, 39.280574],
              [-75.244056, 39.27769],
              [-75.241639, 39.274097],
              [-75.21251, 39.262755],
              [-75.205857, 39.262619],
              [-75.177506, 39.242746],
              [-75.170444, 39.234643],
              [-75.164798, 39.216606],
              [-75.165979, 39.201842],
              [-75.139136, 39.180021],
              [-75.136548, 39.179425],
              [-75.12707, 39.189766],
              [-75.114748, 39.207554],
              [-75.107286, 39.211403],
              [-75.101019, 39.211657],
              [-75.086395, 39.208159],
              [-75.062506, 39.213564],
              [-75.052326, 39.213609],
              [-75.047797, 39.211702],
              [-75.041663, 39.215511],
              [-75.035672, 39.215415],
              [-75.026376, 39.20985],
              [-75.023437, 39.204791],
              [-75.023586, 39.202594],
              [-75.027824, 39.199482],
              [-75.028885, 39.19456],
              [-75.026179, 39.193621],
              [-74.998002, 39.191253],
              [-74.976266, 39.192271],
              [-74.962382, 39.190238],
              [-74.914936, 39.177553],
              [-74.905181, 39.174945],
              [-74.887167, 39.158825],
              [-74.885914, 39.143627],
              [-74.892547, 39.113183],
              [-74.897784, 39.098811],
              [-74.903664, 39.087437],
              [-74.93832, 39.035185],
              [-74.94947, 39.015637],
              [-74.955363, 39.001262],
              [-74.971995, 38.94037],
              [-74.967274, 38.933413],
              [-74.963463, 38.931194],
              [-74.933571, 38.928519],
              [-74.920414, 38.929136],
              [-74.90705, 38.931994],
              [-74.882309, 38.941759],
              [-74.870497, 38.943543],
              [-74.865198, 38.941439],
              [-74.864458, 38.94041],
              [-74.850748, 38.954538],
              [-74.819354, 38.979402],
              [-74.807917, 38.985948],
              [-74.792723, 38.991991],
              [-74.786356, 39.000113],
              [-74.778777, 39.023073],
              [-74.738316, 39.074727],
              [-74.705876, 39.102937],
              [-74.704409, 39.107858],
              [-74.714135, 39.114631],
              [-74.71532, 39.116893],
              [-74.714341, 39.119804],
              [-74.67143, 39.179802],
              [-74.651443, 39.198578],
              [-74.646595, 39.212002],
              [-74.636306, 39.220834],
              [-74.614481, 39.244659],
              [-74.597921, 39.258851],
              [-74.581008, 39.270819],
              [-74.560957, 39.278677],
              [-74.553439, 39.286915],
              [-74.551151, 39.293539],
              [-74.541443, 39.300245],
              [-74.521797, 39.313816],
              [-74.459894, 39.345016],
              [-74.412692, 39.360816],
              [-74.408237, 39.365071],
              [-74.406792, 39.373916],
              [-74.406692, 39.377516],
              [-74.36699, 39.402017],
              [-74.334804, 39.432001],
              [-74.304343, 39.471445],
              [-74.302184, 39.478935],
              [-74.304778, 39.482945],
              [-74.308344, 39.483945],
              [-74.313689, 39.493874],
              [-74.312451, 39.499869],
              [-74.311037, 39.506715],
              [-74.291585, 39.507705],
              [-74.27737, 39.514064],
              [-74.249043, 39.547994],
              [-74.240506, 39.554911],
              [-74.190974, 39.625118],
              [-74.141733, 39.689435],
              [-74.113655, 39.740719],
              [-74.101443, 39.756173],
              [-74.09892, 39.759538],
              [-74.096906, 39.76303],
              [-74.097071, 39.767847],
              [-74.090945, 39.799978],
              [-74.077247, 39.910991],
              [-74.064135, 39.979157],
              [-74.058798, 40.001244],
              [-74.039421, 40.081437],
              [-74.033546, 40.099518],
              [-74.031318, 40.100541],
              [-74.031861, 40.101047],
              [-74.03408, 40.103115],
              [-74.030181, 40.122814],
              [-74.016017, 40.166914],
              [-73.993292, 40.237669],
              [-73.981681, 40.279411],
              [-73.977442, 40.299373],
              [-73.971381, 40.34801],
              [-73.971381, 40.371709],
              [-73.976982, 40.408508],
              [-73.978282, 40.440208],
              [-73.995683, 40.468707],
              [-74.0071, 40.475298],
              [-74.014031, 40.476471],
              [-74.017917, 40.474338],
              [-74.017783, 40.472207],
              [-74.006077, 40.464625],
              [-73.991682, 40.442908],
              [-73.995486, 40.419472],
              [-73.998505, 40.410911],
              [-74.006383, 40.411108],
              [-74.047884, 40.418908],
              [-74.058984, 40.422708],
              [-74.076185, 40.433707],
              [-74.088085, 40.438407],
              [-74.116863, 40.446069],
              [-74.122327, 40.448258],
              [-74.124692, 40.44958],
              [-74.127466, 40.451061],
              [-74.131135, 40.453245],
              [-74.133727, 40.454672],
              [-74.135823, 40.455196],
              [-74.138415, 40.454468],
              [-74.139886, 40.453407],
              [-74.142886, 40.450407],
              [-74.151952, 40.448062],
              [-74.152686, 40.447344],
              [-74.153611, 40.447647],
              [-74.157787, 40.446607],
              [-74.163314, 40.448424],
              [-74.164029, 40.448312],
              [-74.166193, 40.447128],
              [-74.167009, 40.448737],
              [-74.169977, 40.45064],
              [-74.175346, 40.446607],
              [-74.176842, 40.44774],
              [-74.175074, 40.449144],
              [-74.174893, 40.454491],
              [-74.174787, 40.455607],
              [-74.187787, 40.447407],
              [-74.191309, 40.44299],
              [-74.193908, 40.440995],
              [-74.202128, 40.43894],
              [-74.207205, 40.435434],
              [-74.208655, 40.43752],
              [-74.206419, 40.438789],
              [-74.206188, 40.440707],
              [-74.209788, 40.447407],
              [-74.222959, 40.452499],
              [-74.224047, 40.452919],
              [-74.225035, 40.453301],
              [-74.236689, 40.457806],
              [-74.261889, 40.464706],
              [-74.26759, 40.471806],
              [-74.27269, 40.488405],
              [-74.269998, 40.495014],
              [-74.26829, 40.499205],
              [-74.246237, 40.520963],
              [-74.251441, 40.542301],
              [-74.248641, 40.549601],
              [-74.231589, 40.559204],
              [-74.218189, 40.557204],
              [-74.214788, 40.560604],
              [-74.208988, 40.576304],
              [-74.206731, 40.594569],
              [-74.202223, 40.631053],
              [-74.189106, 40.643832],
              [-74.186027, 40.646076],
              [-74.181083, 40.646484],
              [-74.161397, 40.644092],
              [-74.143387, 40.641903],
              [-74.094086, 40.649703],
              [-74.087397, 40.653607],
              [-74.089986, 40.659903],
              [-74.082786, 40.673702],
              [-74.069885, 40.684502],
              [-74.051185, 40.695802],
              [-74.038538, 40.710741],
              [-74.024543, 40.709436],
              [-74.019526, 40.706985],
              [-74.0168, 40.701794],
              [-74.01849, 40.695457],
              [-74.021721, 40.693504],
              [-74.024827, 40.687007],
              [-74.023982, 40.68236],
              [-74.022911, 40.681267],
              [-74.020467, 40.67877],
              [-74.018272, 40.659019],
              [-74.032066, 40.646479],
              [-74.035868, 40.640776],
              [-74.038336, 40.637074],
              [-74.042412, 40.624847],
              [-74.03959, 40.612934],
              [-74.032856, 40.604421],
              [-74.010926, 40.600789],
              [-74.003281, 40.595754],
              [-74.001591, 40.590684],
              [-74.00635, 40.584767],
              [-74.007276, 40.583616],
              [-74.012996, 40.578169],
              [-74.012022, 40.574528],
              [-74.00903, 40.572846],
              [-74.002056, 40.570623],
              [-73.991346, 40.57035],
              [-73.95938, 40.572682],
              [-73.95005, 40.573363],
              [-73.944558, 40.568716],
              [-73.938598, 40.566161],
              [-73.935686, 40.564914],
              [-73.932729, 40.560266],
              [-73.934466, 40.555281],
              [-73.934512, 40.545175],
              [-73.878906, 40.560888],
              [-73.834408, 40.577201],
              [-73.806834, 40.584619],
              [-73.80143, 40.585659],
              [-73.774928, 40.590759],
              [-73.753349, 40.59056],
              [-73.754323, 40.586357],
              [-73.754776, 40.584404],
              [-73.701138, 40.58361],
              [-73.646674, 40.582804],
              [-73.610873, 40.587703],
              [-73.583773, 40.586703],
              [-73.562372, 40.583703],
              [-73.450369, 40.603501],
              [-73.423806, 40.609869],
              [-73.391967, 40.617501],
              [-73.351465, 40.6305],
              [-73.319257, 40.635795],
              [-73.30974, 40.622532],
              [-73.306396, 40.620756],
              [-73.264493, 40.621437],
              [-73.262106, 40.621476],
              [-73.23914, 40.6251],
              [-73.20844, 40.630884],
              [-73.145266, 40.645491],
              [-73.054963, 40.666371],
              [-73.012545, 40.679651],
              [-72.923214, 40.713282],
              [-72.863164, 40.732962],
              [-72.768152, 40.761587],
              [-72.757176, 40.764371],
              [-72.753112, 40.763571],
              [-72.745208, 40.767091],
              [-72.573441, 40.813251],
              [-72.469996, 40.84274],
              [-72.39585, 40.86666],
              [-72.114448, 40.972085],
              [-72.029357, 40.999909],
              [-71.935689, 41.034182],
              [-71.903736, 41.040166],
              [-71.87391, 41.052278],
              [-71.856214, 41.070598],
              [-71.857494, 41.073558],
              [-71.86447, 41.076918],
              [-71.869558, 41.075046],
              [-71.889543, 41.075701],
              [-71.895496, 41.077381],
              [-71.899256, 41.080837],
              [-71.919385, 41.080517],
              [-71.93825, 41.077413],
              [-71.959595, 41.071237],
              [-71.961563, 41.064021],
              [-71.960355, 41.059878],
              [-71.961078, 41.054277],
              [-71.96704, 41.047772],
              [-71.99926, 41.039669],
              [-72.015013, 41.028348],
              [-72.035792, 41.020759],
              [-72.047468, 41.022565],
              [-72.051928, 41.020506],
              [-72.051549, 41.015741],
              [-72.049526, 41.009697],
              [-72.051585, 41.006437],
              [-72.055188, 41.005236],
              [-72.057075, 41.004893],
              [-72.057934, 41.004789],
              [-72.061448, 41.009442],
              [-72.076175, 41.009093],
              [-72.079208, 41.006437],
              [-72.079951, 41.003429],
              [-72.083039, 40.996453],
              [-72.095456, 40.991349],
              [-72.10216, 40.991509],
              [-72.109008, 40.994084],
              [-72.116368, 40.999796],
              [-72.137409, 41.023908],
              [-72.135137, 41.031284],
              [-72.137297, 41.039684],
              [-72.153857, 41.051859],
              [-72.16037, 41.053827],
              [-72.162898, 41.053187],
              [-72.174882, 41.046147],
              [-72.17949, 41.038435],
              [-72.183266, 41.035619],
              [-72.190563, 41.032579],
              [-72.201859, 41.032275],
              [-72.217476, 41.040611],
              [-72.229364, 41.044355],
              [-72.241252, 41.04477],
              [-72.260515, 41.042065],
              [-72.273657, 41.051533],
              [-72.283093, 41.067874],
              [-72.276709, 41.076722],
              [-72.280373, 41.080402],
              [-72.297718, 41.081042],
              [-72.317238, 41.088659],
              [-72.335177, 41.106917],
              [-72.335271, 41.120274],
              [-72.32663, 41.132162],
              [-72.318146, 41.137134],
              [-72.312734, 41.138546],
              [-72.306381, 41.13784],
              [-72.300044, 41.132059],
              [-72.300374, 41.112274],
              [-72.265124, 41.128482],
              [-72.253572, 41.137138],
              [-72.237731, 41.156434],
              [-72.238211, 41.15949],
              [-72.245348, 41.161217],
              [-72.2681, 41.154146],
              [-72.272997, 41.15501],
              [-72.278789, 41.158722],
              [-72.291109, 41.155874],
              [-72.322381, 41.140664],
              [-72.333351, 41.138018],
              [-72.356087, 41.133635],
              [-72.397, 41.096307],
              [-72.417945, 41.087955],
              [-72.445242, 41.086116],
              [-72.460778, 41.067012],
              [-72.477306, 41.052212],
              [-72.521548, 41.037652],
              [-72.549853, 41.019844],
              [-72.560974, 41.015444],
              [-72.565406, 41.009508],
              [-72.585327, 40.997587],
              [-72.635374, 40.990536],
              [-72.665018, 40.987496],
              [-72.689341, 40.989776],
              [-72.714425, 40.985596],
              [-72.760031, 40.975334],
              [-72.774104, 40.965314],
              [-72.826057, 40.969794],
              [-72.88825, 40.962962],
              [-72.913834, 40.962466],
              [-72.955163, 40.966146],
              [-72.995931, 40.966498],
              [-73.040445, 40.964498],
              [-73.043701, 40.962185],
              [-73.081582, 40.973058],
              [-73.110368, 40.971938],
              [-73.140785, 40.966178],
              [-73.144673, 40.955842],
              [-73.146242, 40.935074],
              [-73.148994, 40.928898],
              [-73.229285, 40.905121],
              [-73.295059, 40.924497],
              [-73.295061, 40.924497],
              [-73.33136, 40.929597],
              [-73.344161, 40.927297],
              [-73.345561, 40.925297],
              [-73.352761, 40.926697],
              [-73.365961, 40.931697],
              [-73.374462, 40.937597],
              [-73.392862, 40.955297],
              [-73.399762, 40.955197],
              [-73.400862, 40.953997],
              [-73.403462, 40.942197],
              [-73.402963, 40.925097],
              [-73.406074, 40.920235],
              [-73.428836, 40.921506],
              [-73.429665, 40.928203],
              [-73.429863, 40.929797],
              [-73.436664, 40.934897],
              [-73.437509, 40.934985],
              [-73.445026, 40.935763],
              [-73.456523, 40.936953],
              [-73.460603, 40.937375],
              [-73.463708, 40.937697],
              [-73.47441, 40.941056],
              [-73.478365, 40.942297],
              [-73.48011, 40.943319],
              [-73.484798, 40.946065],
              [-73.485365, 40.946397],
              [-73.491765, 40.942097],
              [-73.496642, 40.923476],
              [-73.497061, 40.922801],
              [-73.499941, 40.918166],
              [-73.514999, 40.912821],
              [-73.519267, 40.914298],
              [-73.548068, 40.908698],
              [-73.566169, 40.915798],
              [-73.569969, 40.915398],
              [-73.59517, 40.907298],
              [-73.60187, 40.902798],
              [-73.617571, 40.897898],
              [-73.626972, 40.899397],
              [-73.633771, 40.898198],
              [-73.641072, 40.892599],
              [-73.654372, 40.878199],
              [-73.655872, 40.863899],
              [-73.670692, 40.858708],
              [-73.675573, 40.856999],
              [-73.713674, 40.870099],
              [-73.729575, 40.8665],
              [-73.730675, 40.8654],
              [-73.726675, 40.8568],
              [-73.728275, 40.8529],
              [-73.7544, 40.826837],
              [-73.754032, 40.820941],
              [-73.768301, 40.800797],
              [-73.768431, 40.800704],
              [-73.776032, 40.795275],
              [-73.781369, 40.794907],
              [-73.785964, 40.800862],
              [-73.797332, 40.815597],
              [-73.804518, 40.818546],
              [-73.811889, 40.825363],
              [-73.815205, 40.831075],
              [-73.815574, 40.835129],
              [-73.81281, 40.846737],
              [-73.806914, 40.849501],
              [-73.799543, 40.848027],
              [-73.797252, 40.852196],
              [-73.793785, 40.855583],
              [-73.792253, 40.855825],
              [-73.789512, 40.85139],
              [-73.791044, 40.846552],
              [-73.788221, 40.842036],
              [-73.785399, 40.838004],
              [-73.783867, 40.836795],
              [-73.782577, 40.837601],
              [-73.781206, 40.838891],
              [-73.782254, 40.842359],
              [-73.782093, 40.844616],
              [-73.782174, 40.847358],
              [-73.784754, 40.851793],
              [-73.78806, 40.854131],
              [-73.788786, 40.858485],
              [-73.785502, 40.869079],
              [-73.784803, 40.878528],
              [-73.783545, 40.88104],
              [-73.781338, 40.885447],
              [-73.756776, 40.912599],
              [-73.731775, 40.924999],
              [-73.721739, 40.932037],
              [-73.697974, 40.939598],
              [-73.686473, 40.945198],
              [-73.683273, 40.948998],
              [-73.678073, 40.962798],
              [-73.664472, 40.967198],
              [-73.662072, 40.966198],
              [-73.659972, 40.968398],
              [-73.655972, 40.979597],
              [-73.657336, 40.985171],
              [-73.651175, 40.995229],
              [-73.643478, 41.002171],
              [-73.603952, 41.015054],
              [-73.595699, 41.015995],
              [-73.584988, 41.010537],
              [-73.583968, 41.000897],
              [-73.570068, 41.001597],
              [-73.567668, 41.010897],
              [-73.561968, 41.016797],
              [-73.551494, 41.024336],
              [-73.535338, 41.03192],
              [-73.532786, 41.03167],
              [-73.530189, 41.028776],
              [-73.531169, 41.021919],
              [-73.528866, 41.016397],
              [-73.522666, 41.019297],
              [-73.516766, 41.029497],
              [-73.516903, 41.038738],
              [-73.493327, 41.048173],
              [-73.477364, 41.035997],
              [-73.468239, 41.051347],
              [-73.450364, 41.057096],
              [-73.435063, 41.056696],
              [-73.41367, 41.073258],
              [-73.400154, 41.086299],
              [-73.392162, 41.087696],
              [-73.372296, 41.10402],
              [-73.33066, 41.109996],
              [-73.31186, 41.116296],
              [-73.296359, 41.125696],
              [-73.286759, 41.127896],
              [-73.262358, 41.117496],
              [-73.247958, 41.126396],
              [-73.235058, 41.143996],
              [-73.228295, 41.142602],
              [-73.202656, 41.158096],
              [-73.177774, 41.166697],
              [-73.170701, 41.164945],
              [-73.170074, 41.160532],
              [-73.16437, 41.158565],
              [-73.130253, 41.146797],
              [-73.111052, 41.150797],
              [-73.108352, 41.153718],
              [-73.109952, 41.156997],
              [-73.110352, 41.159697],
              [-73.107987, 41.168738],
              [-73.105493, 41.172194],
              [-73.105483, 41.172203],
              [-73.104328, 41.17317],
              [-73.092147, 41.183377],
              [-73.092, 41.1835],
              [-73.09122, 41.184153],
              [-73.07945, 41.194015],
              [-73.07761, 41.195176],
              [-73.05935, 41.206697],
              [-73.054947, 41.208468],
              [-73.05065, 41.210197],
              [-73.045602, 41.209658],
              [-73.024783, 41.207435],
              [-73.022549, 41.207197],
              [-73.020449, 41.206397],
              [-73.020254, 41.204906],
              [-73.02021, 41.204568],
              [-73.020195, 41.204446],
              [-73.020167, 41.204237],
              [-73.020149, 41.204097],
              [-73.014948, 41.204297],
              [-73.013988, 41.205062],
              [-73.013465, 41.205479],
              [-73.007548, 41.210197],
              [-73.003639, 41.215287],
              [-72.997948, 41.222697],
              [-72.986247, 41.233497],
              [-72.985095, 41.234358],
              [-72.983751, 41.235364],
              [-72.962047, 41.251597],
              [-72.961345, 41.25178],
              [-72.959633, 41.252228],
              [-72.956984, 41.25292],
              [-72.935646, 41.258497],
              [-72.933472, 41.260024],
              [-72.931887, 41.261139],
              [-72.920846, 41.268897],
              [-72.920714, 41.27078],
              [-72.920658, 41.271574],
              [-72.920062, 41.280056],
              [-72.917037, 41.281905],
              [-72.916827, 41.282033],
              [-72.9082, 41.282932],
              [-72.907962, 41.282549],
              [-72.903129, 41.274794],
              [-72.89637, 41.263949],
              [-72.893845, 41.259897],
              [-72.89473, 41.25626],
              [-72.894745, 41.256197],
              [-72.902808, 41.252894],
              [-72.903045, 41.252797],
              [-72.905245, 41.248297],
              [-72.904345, 41.247297],
              [-72.900803, 41.245864],
              [-72.895445, 41.243697],
              [-72.881445, 41.242597],
              [-72.861344, 41.245297],
              [-72.854055, 41.24774],
              [-72.85021, 41.255544],
              [-72.847767, 41.25669],
              [-72.826883, 41.256755],
              [-72.819372, 41.254061],
              [-72.818737, 41.252244],
              [-72.786142, 41.264796],
              [-72.757477, 41.266913],
              [-72.754444, 41.266913],
              [-72.732813, 41.254727],
              [-72.722439, 41.259138],
              [-72.71246, 41.254167],
              [-72.711208, 41.251018],
              [-72.713674, 41.249007],
              [-72.710821, 41.244812],
              [-72.710595, 41.24448],
              [-72.709193, 41.244523],
              [-72.708963, 41.24453],
              [-72.708658, 41.24454],
              [-72.707212, 41.244585],
              [-72.706236, 41.244615],
              [-72.701806, 41.244752],
              [-72.69547, 41.244948],
              [-72.694744, 41.24497],
              [-72.693441, 41.245493],
              [-72.690439, 41.246697],
              [-72.690237, 41.246887],
              [-72.689446, 41.247629],
              [-72.685539, 41.251297],
              [-72.685414, 41.252607],
              [-72.684939, 41.257597],
              [-72.674319, 41.26552],
              [-72.672339, 41.266997],
              [-72.671673, 41.267151],
              [-72.667176, 41.268192],
              [-72.662838, 41.269197],
              [-72.662203, 41.268964],
              [-72.654715, 41.266219],
              [-72.653931, 41.265931],
              [-72.653838, 41.265897],
              [-72.650697, 41.266178],
              [-72.642811, 41.266884],
              [-72.641538, 41.266998],
              [-72.641001, 41.267108],
              [-72.631363, 41.269092],
              [-72.617983, 41.271845],
              [-72.617521, 41.27194],
              [-72.617237, 41.271998],
              [-72.610236, 41.270795],
              [-72.607863, 41.270387],
              [-72.598036, 41.268698],
              [-72.590967, 41.270141],
              [-72.589818, 41.270375],
              [-72.587926, 41.270761],
              [-72.586674, 41.271017],
              [-72.585934, 41.271168],
              [-72.585181, 41.271321],
              [-72.583336, 41.271698],
              [-72.571136, 41.268098],
              [-72.571076, 41.268054],
              [-72.570655, 41.267744],
              [-72.547235, 41.250499],
              [-72.546833, 41.250718],
              [-72.537776, 41.255646],
              [-72.536746, 41.256207],
              [-72.533247, 41.26269],
              [-72.529416, 41.264421],
              [-72.521312, 41.2656],
              [-72.51866, 41.261253],
              [-72.506634, 41.260099],
              [-72.499534, 41.265866],
              [-72.485693, 41.270881],
              [-72.472539, 41.270103],
              [-72.451925, 41.278885],
              [-72.40593, 41.278398],
              [-72.398688, 41.278172],
              [-72.386629, 41.261798],
              [-72.348068, 41.269698],
              [-72.348643, 41.277446],
              [-72.34146, 41.28011],
              [-72.333894, 41.282916],
              [-72.327595, 41.27846],
              [-72.31776, 41.277782],
              [-72.261487, 41.282926],
              [-72.251323, 41.289997],
              [-72.250515, 41.294386],
              [-72.251895, 41.29862],
              [-72.248161, 41.299488],
              [-72.235531, 41.300413],
              [-72.225276, 41.299047],
              [-72.212924, 41.291365],
              [-72.204022, 41.299097],
              [-72.203022, 41.313197],
              [-72.201422, 41.315697],
              [-72.191022, 41.323197],
              [-72.184122, 41.323997],
              [-72.177622, 41.322497],
              [-72.173922, 41.317597],
              [-72.16158, 41.310262],
              [-72.134221, 41.299398],
              [-72.11182, 41.299098],
              [-72.09982, 41.306998],
              [-72.094443, 41.314164],
              [-72.084487, 41.319634],
              [-72.021898, 41.316838],
              [-71.988153, 41.320577],
              [-71.982194, 41.329861],
              [-71.979447, 41.329987],
              [-71.970955, 41.324526],
              [-71.956747, 41.329871],
              [-71.945652, 41.337799],
              [-71.936284, 41.337959],
              [-71.923282, 41.335113],
              [-71.922092, 41.334518],
              [-71.91671, 41.332217],
              [-71.886302, 41.33641],
              [-71.868235, 41.330941],
              [-71.85957, 41.322399],
            ],
          ],
          [
            [
              [-75.564927, 39.583248],
              [-75.565823, 39.590608],
              [-75.579615, 39.598656],
              [-75.578719, 39.591504],
              [-75.576271, 39.588144],
              [-75.564927, 39.583248],
            ],
          ],
          [
            [
              [-76.048373, 38.12055],
              [-76.043423, 38.117868],
              [-76.040665, 38.113606],
              [-76.039696, 38.112108],
              [-76.03962, 38.11199],
              [-76.040874, 38.110906],
              [-76.041083, 38.110726],
              [-76.042083, 38.109862],
              [-76.044482, 38.109237],
              [-76.045279, 38.109029],
              [-76.046494, 38.108712],
              [-76.047291, 38.108505],
              [-76.050156, 38.107758],
              [-76.059304, 38.095751],
              [-76.05831, 38.094906],
              [-76.052207, 38.089716],
              [-76.036676, 38.076509],
              [-76.0233, 38.07076],
              [-76.015235, 38.071825],
              [-76.012701, 38.072159],
              [-76.011544, 38.072312],
              [-76.005904, 38.07717],
              [-76.008168, 38.095385],
              [-76.015477, 38.102332],
              [-76.017394, 38.104154],
              [-76.020996, 38.107578],
              [-76.02137, 38.107934],
              [-76.021353, 38.108108],
              [-76.021305, 38.108608],
              [-76.020496, 38.117044],
              [-76.015702, 38.119933],
              [-76.014698, 38.120537],
              [-76.013363, 38.121342],
              [-76.011916, 38.122214],
              [-76.012487, 38.131731],
              [-76.013903, 38.131634],
              [-76.015155, 38.131548],
              [-76.01779, 38.131367],
              [-76.018574, 38.131713],
              [-76.019637, 38.132183],
              [-76.020476, 38.132553],
              [-76.020982, 38.132776],
              [-76.022515, 38.133453],
              [-76.031442, 38.147612],
              [-76.031868, 38.148288],
              [-76.031945, 38.148631],
              [-76.033978, 38.157636],
              [-76.034038, 38.157902],
              [-76.032816, 38.169141],
              [-76.032767, 38.169154],
              [-76.025892, 38.170946],
              [-76.021941, 38.171976],
              [-76.02217, 38.177882],
              [-76.025899, 38.181504],
              [-76.0269, 38.182476],
              [-76.028411, 38.183943],
              [-76.02858, 38.184107],
              [-76.036757, 38.192049],
              [-76.038929, 38.194158],
              [-76.040718, 38.195896],
              [-76.041952, 38.197094],
              [-76.04228, 38.197412],
              [-76.042385, 38.197515],
              [-76.042615, 38.197737],
              [-76.042691, 38.197811],
              [-76.046273, 38.20129],
              [-76.046539, 38.201549],
              [-76.048786, 38.203731],
              [-76.048945, 38.203729],
              [-76.050511, 38.203714],
              [-76.052165, 38.203697],
              [-76.053753, 38.203681],
              [-76.058925, 38.203629],
              [-76.05902, 38.203628],
              [-76.059158, 38.203626],
              [-76.059218, 38.203626],
              [-76.059562, 38.203622],
              [-76.059731, 38.203621],
              [-76.061906, 38.203599],
              [-76.066994, 38.203547],
              [-76.0671, 38.203546],
              [-76.067797, 38.203539],
              [-76.07147, 38.203502],
              [-76.088639, 38.192649],
              [-76.092334, 38.151355],
              [-76.090216, 38.144765],
              [-76.089918, 38.143837],
              [-76.089017, 38.141033],
              [-76.090527, 38.131919],
              [-76.09064, 38.13124],
              [-76.090649, 38.131185],
              [-76.095548, 38.125123],
              [-76.090872, 38.11446],
              [-76.089166, 38.115221],
              [-76.089018, 38.115287],
              [-76.086224, 38.116534],
              [-76.085947, 38.116658],
              [-76.085885, 38.116844],
              [-76.085542, 38.117869],
              [-76.085311, 38.118561],
              [-76.08523, 38.118589],
              [-76.081587, 38.119854],
              [-76.081127, 38.120014],
              [-76.064683, 38.125723],
              [-76.063661, 38.126078],
              [-76.06147, 38.126839],
              [-76.061111, 38.126963],
              [-76.061, 38.127002],
              [-76.056811, 38.125123],
              [-76.048373, 38.12055],
            ],
          ],
          [
            [
              [-75.993905, 37.953489],
              [-75.988879, 37.960337],
              [-75.991543, 37.966874],
              [-75.992789, 37.969932],
              [-75.99473, 37.974693],
              [-75.99473, 37.974694],
              [-75.992468, 37.981021],
              [-75.989101, 37.99044],
              [-75.988719, 37.991509],
              [-75.988541, 37.992006],
              [-75.986571, 37.997516],
              [-75.986249, 37.998416],
              [-75.985723, 37.999889],
              [-75.98502, 38.001855],
              [-75.984675, 38.002821],
              [-75.984479, 38.003369],
              [-75.984251, 38.004006],
              [-75.98288, 38.004236],
              [-75.980683, 38.004603],
              [-75.979879, 38.004738],
              [-75.970917, 38.006239],
              [-75.97039, 38.006327],
              [-75.970345, 38.008222],
              [-75.970178, 38.01526],
              [-75.970168, 38.015683],
              [-75.970168, 38.015685],
              [-75.970172, 38.015688],
              [-75.972304, 38.01775],
              [-75.973432, 38.018841],
              [-75.975487, 38.020827],
              [-75.975494, 38.020834],
              [-75.977246, 38.021334],
              [-75.981195, 38.02246],
              [-75.991846, 38.025497],
              [-76.004592, 38.036805],
              [-76.008695, 38.038226],
              [-76.008835, 38.038275],
              [-76.013128, 38.039762],
              [-76.020827, 38.039124],
              [-76.041668, 38.032148],
              [-76.046213, 38.025533],
              [-76.048617, 38.014843],
              [-76.049396, 37.990315],
              [-76.049527, 37.986184],
              [-76.049549, 37.985495],
              [-76.049562, 37.985065],
              [-76.049608, 37.983628],
              [-76.04653, 37.953586],
              [-76.045561, 37.953669],
              [-76.041691, 37.954],
              [-76.041402, 37.954006],
              [-76.038026, 37.953901],
              [-76.030122, 37.953655],
              [-76.029463, 37.953775],
              [-76.029405, 37.953776],
              [-76.022325, 37.953878],
              [-76.021714, 37.953887],
              [-76.020932, 37.953879],
              [-76.020796, 37.953877],
              [-76.017686, 37.953832],
              [-76.005888, 37.953662],
              [-75.994739, 37.953501],
              [-75.993905, 37.953489],
            ],
          ],
          [
            [
              [-69.307908, 43.773767],
              [-69.313631, 43.772762],
              [-69.321141, 43.765763],
              [-69.323569, 43.758994],
              [-69.322559, 43.755883],
              [-69.314325, 43.756707],
              [-69.300818, 43.768599],
              [-69.300376, 43.772144],
              [-69.302995, 43.774591],
              [-69.306751, 43.775095],
              [-69.307908, 43.773767],
            ],
          ],
          [
            [
              [-69.42792, 43.928798],
              [-69.421072, 43.938261],
              [-69.429806, 43.948438],
              [-69.433762, 43.949353],
              [-69.441894, 43.916331],
              [-69.440913, 43.909767],
              [-69.438066, 43.909539],
              [-69.423324, 43.915507],
              [-69.422153, 43.917702],
              [-69.423323, 43.922871],
              [-69.42792, 43.928798],
            ],
          ],
          [
            [
              [-67.619761, 44.519754],
              [-67.619211, 44.506009],
              [-67.614954, 44.503576],
              [-67.607199, 44.503576],
              [-67.604919, 44.502056],
              [-67.592755, 44.458572],
              [-67.588346, 44.449754],
              [-67.574206, 44.45173],
              [-67.571774, 44.453403],
              [-67.569189, 44.455531],
              [-67.562651, 44.472104],
              [-67.580288, 44.488068],
              [-67.590627, 44.49415],
              [-67.589259, 44.50084],
              [-67.582113, 44.513459],
              [-67.587738, 44.516196],
              [-67.61541, 44.521973],
              [-67.619761, 44.519754],
            ],
          ],
          [
            [
              [-70.119671, 43.748621],
              [-70.127051, 43.742717],
              [-70.138711, 43.727559],
              [-70.138128, 43.718231],
              [-70.129383, 43.70832],
              [-70.124136, 43.70832],
              [-70.108978, 43.722312],
              [-70.109561, 43.730474],
              [-70.107812, 43.734555],
              [-70.100233, 43.742134],
              [-70.094986, 43.753211],
              [-70.097318, 43.757292],
              [-70.113059, 43.74913],
              [-70.119671, 43.748621],
            ],
          ],
          [
            [
              [-70.171245, 43.663498],
              [-70.184659, 43.674699],
              [-70.188047, 43.673762],
              [-70.200116, 43.662978],
              [-70.211062, 43.641842],
              [-70.207165, 43.63369],
              [-70.205934, 43.633633],
              [-70.190323, 43.642986],
              [-70.171136, 43.6633],
              [-70.171245, 43.663498],
            ],
          ],
          [
            [
              [-70.186213, 43.682655],
              [-70.191041, 43.689071],
              [-70.196535, 43.688784],
              [-70.201893, 43.685483],
              [-70.209627, 43.676308],
              [-70.213948, 43.666161],
              [-70.21313, 43.662973],
              [-70.210825, 43.661695],
              [-70.207341, 43.662562],
              [-70.192574, 43.673139],
              [-70.187536, 43.678669],
              [-70.186213, 43.682655],
            ],
          ],
          [
            [
              [-70.163884, 43.692404],
              [-70.171339, 43.687546],
              [-70.173571, 43.683734],
              [-70.170284, 43.675441],
              [-70.168227, 43.675136],
              [-70.154503, 43.680933],
              [-70.135563, 43.700658],
              [-70.146115, 43.701635],
              [-70.156787, 43.694706],
              [-70.163884, 43.692404],
            ],
          ],
          [
            [
              [-70.087621, 43.699913],
              [-70.091929, 43.698111],
              [-70.097184, 43.700929],
              [-70.092137, 43.709468],
              [-70.093113, 43.710524],
              [-70.095727, 43.709278],
              [-70.100683, 43.705962],
              [-70.115961, 43.689202],
              [-70.118174, 43.686375],
              [-70.118291, 43.683343],
              [-70.115908, 43.682978],
              [-70.099594, 43.695366],
              [-70.093704, 43.6918],
              [-70.087621, 43.699913],
            ],
          ],
          [
            [
              [-68.880242, 43.863398],
              [-68.889367, 43.87553],
              [-68.902618, 43.868855],
              [-68.908222, 43.849852],
              [-68.903957, 43.848684],
              [-68.898045, 43.849545],
              [-68.8947, 43.84397],
              [-68.893537, 43.831498],
              [-68.899108, 43.821925],
              [-68.898319, 43.820987],
              [-68.886725, 43.822195],
              [-68.876224, 43.836597],
              [-68.882554, 43.848525],
              [-68.880242, 43.863398],
            ],
          ],
          [
            [
              [-69.043981, 44.005684],
              [-69.047583, 44.013995],
              [-69.061966, 44.015023],
              [-69.092994, 43.979063],
              [-69.0782, 43.974132],
              [-69.043981, 44.005684],
            ],
          ],
          [
            [
              [-68.618212, 44.012367],
              [-68.615896, 44.009761],
              [-68.610703, 44.013422],
              [-68.611473, 44.025176],
              [-68.601099, 44.058362],
              [-68.590792, 44.058662],
              [-68.588098, 44.06127],
              [-68.584074, 44.070578],
              [-68.585916, 44.075335],
              [-68.589563, 44.075585],
              [-68.602863, 44.08665],
              [-68.609722, 44.094674],
              [-68.6181, 44.096706],
              [-68.62535, 44.092906],
              [-68.627893, 44.088128],
              [-68.661594, 44.075837],
              [-68.654783, 44.059599],
              [-68.650767, 44.039908],
              [-68.657369, 44.024404],
              [-68.659874, 44.022758],
              [-68.659972, 44.016013],
              [-68.657031, 44.003823],
              [-68.652881, 44.003845],
              [-68.651863, 44.009859],
              [-68.64736, 44.0145],
              [-68.635315, 44.018886],
              [-68.618212, 44.012367],
            ],
          ],
          [
            [
              [-68.785601, 44.053503],
              [-68.77965, 44.057754],
              [-68.77029, 44.069566],
              [-68.772639, 44.078439],
              [-68.781772, 44.084274],
              [-68.790525, 44.09292],
              [-68.806832, 44.116339],
              [-68.815562, 44.115836],
              [-68.81953, 44.122056],
              [-68.820515, 44.130198],
              [-68.819659, 44.135434],
              [-68.818039, 44.136852],
              [-68.802162, 44.137857],
              [-68.792065, 44.136759],
              [-68.780693, 44.143274],
              [-68.782375, 44.14531],
              [-68.786886, 44.143961],
              [-68.792221, 44.145998],
              [-68.818423, 44.160978],
              [-68.82284, 44.173693],
              [-68.822206, 44.178815],
              [-68.819156, 44.180462],
              [-68.825067, 44.186338],
              [-68.847249, 44.183017],
              [-68.87868, 44.166612],
              [-68.888597, 44.15955],
              [-68.917286, 44.148239],
              [-68.935327, 44.13038],
              [-68.944597, 44.11284],
              [-68.943105, 44.10973],
              [-68.908984, 44.110001],
              [-68.907812, 44.105518],
              [-68.913406, 44.08519],
              [-68.905098, 44.077344],
              [-68.899997, 44.06696],
              [-68.889717, 44.032516],
              [-68.874139, 44.025359],
              [-68.862845, 44.025037],
              [-68.828465, 44.032118],
              [-68.818441, 44.032046],
              [-68.807315, 44.035796],
              [-68.790595, 44.053832],
              [-68.785601, 44.053503],
            ],
          ],
          [
            [
              [-68.942826, 44.281073],
              [-68.953686, 44.272346],
              [-68.965264, 44.259332],
              [-68.967074, 44.251968],
              [-68.965896, 44.249754],
              [-68.959468, 44.247439],
              [-68.955332, 44.243873],
              [-68.94709, 44.226792],
              [-68.95189, 44.218719],
              [-68.945976, 44.220824],
              [-68.92648, 44.233035],
              [-68.916872, 44.242866],
              [-68.904255, 44.279889],
              [-68.899445, 44.283775],
              [-68.88746, 44.303094],
              [-68.896587, 44.321986],
              [-68.89285, 44.334653],
              [-68.888706, 44.338196],
              [-68.883065, 44.338193],
              [-68.87169, 44.344662],
              [-68.864338, 44.355002],
              [-68.860649, 44.364425],
              [-68.868444, 44.38144],
              [-68.87894, 44.386584],
              [-68.90353, 44.378613],
              [-68.911634, 44.365027],
              [-68.919325, 44.335392],
              [-68.919301, 44.309872],
              [-68.942826, 44.281073],
            ],
          ],
          [
            [
              [-68.499465, 44.12419],
              [-68.506979, 44.127237],
              [-68.511266, 44.125082],
              [-68.518703, 44.113222],
              [-68.51706, 44.10341],
              [-68.502942, 44.099722],
              [-68.491521, 44.109833],
              [-68.492892, 44.116921],
              [-68.499465, 44.12419],
            ],
          ],
          [
            [
              [-68.358388, 44.125082],
              [-68.365514, 44.124079],
              [-68.375382, 44.11646],
              [-68.376591, 44.113762],
              [-68.376593, 44.112207],
              [-68.365176, 44.101464],
              [-68.338012, 44.101473],
              [-68.331032, 44.10758],
              [-68.330716, 44.110598],
              [-68.346724, 44.127749],
              [-68.35301, 44.127884],
              [-68.358388, 44.125082],
            ],
          ],
          [
            [
              [-68.453236, 44.189998],
              [-68.474365, 44.181875],
              [-68.495511, 44.162429],
              [-68.500817, 44.160026],
              [-68.502096, 44.152388],
              [-68.496639, 44.146855],
              [-68.484696, 44.146495],
              [-68.479934, 44.1478],
              [-68.456813, 44.145268],
              [-68.447505, 44.133493],
              [-68.448646, 44.125581],
              [-68.438518, 44.11618],
              [-68.427534, 44.119266],
              [-68.396634, 44.14069],
              [-68.384903, 44.154955],
              [-68.408207, 44.176298],
              [-68.416434, 44.187047],
              [-68.424441, 44.190753],
              [-68.437789, 44.188216],
              [-68.453236, 44.189998],
            ],
          ],
          [
            [
              [-68.680773, 44.279242],
              [-68.677577, 44.275431],
              [-68.677577, 44.268948],
              [-68.680458, 44.262105],
              [-68.694144, 44.248779],
              [-68.700627, 44.234013],
              [-68.711792, 44.228971],
              [-68.718635, 44.228611],
              [-68.722956, 44.223568],
              [-68.722956, 44.219607],
              [-68.721156, 44.212404],
              [-68.714313, 44.20376],
              [-68.715033, 44.191154],
              [-68.718995, 44.183231],
              [-68.720435, 44.169185],
              [-68.716474, 44.162702],
              [-68.713232, 44.160541],
              [-68.709631, 44.158741],
              [-68.700987, 44.15838],
              [-68.692343, 44.153698],
              [-68.686581, 44.147216],
              [-68.681899, 44.138212],
              [-68.675056, 44.137131],
              [-68.671454, 44.138572],
              [-68.670014, 44.151537],
              [-68.652366, 44.153698],
              [-68.643002, 44.15766],
              [-68.618872, 44.18107],
              [-68.618511, 44.186472],
              [-68.619592, 44.189354],
              [-68.625715, 44.194756],
              [-68.624994, 44.197637],
              [-68.612749, 44.207722],
              [-68.605906, 44.230772],
              [-68.611669, 44.244818],
              [-68.623554, 44.255622],
              [-68.658849, 44.268588],
              [-68.668213, 44.276511],
              [-68.675416, 44.279753],
              [-68.680773, 44.279242],
            ],
          ],
          [
            [
              [-68.355279, 44.199096],
              [-68.364469, 44.197534],
              [-68.371235, 44.193003],
              [-68.378872, 44.184222],
              [-68.347416, 44.169459],
              [-68.339029, 44.171839],
              [-68.332639, 44.192131],
              [-68.321178, 44.199032],
              [-68.318476, 44.196608],
              [-68.314789, 44.197157],
              [-68.31606, 44.200244],
              [-68.32423, 44.205732],
              [-68.333227, 44.207308],
              [-68.355279, 44.199096],
            ],
          ],
          [
            [
              [-68.472831, 44.219767],
              [-68.468572, 44.223999],
              [-68.470323, 44.22832],
              [-68.480565, 44.228591],
              [-68.482726, 44.227058],
              [-68.487227, 44.209517],
              [-68.48452, 44.202886],
              [-68.459182, 44.197681],
              [-68.454224, 44.199534],
              [-68.453843, 44.201683],
              [-68.460205, 44.212498],
              [-68.472831, 44.219767],
            ],
          ],
          [
            [
              [-68.792139, 44.237819],
              [-68.825631, 44.242556],
              [-68.827627, 44.242838],
              [-68.833524, 44.240872],
              [-68.839422, 44.236547],
              [-68.837849, 44.227112],
              [-68.829593, 44.21689],
              [-68.822909, 44.216496],
              [-68.815439, 44.214137],
              [-68.809149, 44.212565],
              [-68.801285, 44.208633],
              [-68.789884, 44.203915],
              [-68.780055, 44.203129],
              [-68.769047, 44.213351],
              [-68.769833, 44.222787],
              [-68.792139, 44.237819],
            ],
          ],
          [
            [
              [-68.23638, 44.266254],
              [-68.241142, 44.260354],
              [-68.246598, 44.257836],
              [-68.254153, 44.257836],
              [-68.262128, 44.260774],
              [-68.274719, 44.258675],
              [-68.276857, 44.240794],
              [-68.274427, 44.237099],
              [-68.266669, 44.234033],
              [-68.248913, 44.235443],
              [-68.240806, 44.239723],
              [-68.241545, 44.247543],
              [-68.24031, 44.251622],
              [-68.23713, 44.25343],
              [-68.231469, 44.256016],
              [-68.221383, 44.257254],
              [-68.212474, 44.255405],
              [-68.211329, 44.257074],
              [-68.214641, 44.263156],
              [-68.23638, 44.266254],
            ],
          ],
          [
            [
              [-68.498637, 44.369686],
              [-68.501364, 44.382281],
              [-68.50766, 44.385219],
              [-68.512697, 44.384799],
              [-68.518573, 44.381022],
              [-68.52193, 44.367591],
              [-68.520671, 44.358357],
              [-68.528635, 44.344605],
              [-68.530394, 44.333583],
              [-68.515173, 44.324797],
              [-68.489641, 44.313705],
              [-68.478785, 44.319563],
              [-68.498637, 44.369686],
            ],
          ],
          [
            [
              [-70.821001, 41.587268],
              [-70.820918, 41.587673],
              [-70.823735, 41.598569],
              [-70.827398, 41.602067],
              [-70.828025, 41.602666],
              [-70.831802, 41.606272],
              [-70.832044, 41.606504],
              [-70.834529, 41.60261],
              [-70.838452, 41.59646],
              [-70.838147, 41.596056],
              [-70.837632, 41.595374],
              [-70.830087, 41.585385],
              [-70.82191, 41.582841],
              [-70.821743, 41.583656],
              [-70.821001, 41.587268],
            ],
          ],
          [
            [
              [-70.59628, 41.471905],
              [-70.598444, 41.481151],
              [-70.603555, 41.482384],
              [-70.64933, 41.461068],
              [-70.686881, 41.441334],
              [-70.701378, 41.430925],
              [-70.711493, 41.41546],
              [-70.712432, 41.40885],
              [-70.724366, 41.398942],
              [-70.729225, 41.397728],
              [-70.768901, 41.353246],
              [-70.774974, 41.349176],
              [-70.783291, 41.347829],
              [-70.800289, 41.3538],
              [-70.812309, 41.355745],
              [-70.833802, 41.353386],
              [-70.838777, 41.347209],
              [-70.819415, 41.327212],
              [-70.802083, 41.314207],
              [-70.775665, 41.300982],
              [-70.768687, 41.303702],
              [-70.766166, 41.308962],
              [-70.768015, 41.311959],
              [-70.764188, 41.318706],
              [-70.747541, 41.329952],
              [-70.733253, 41.336226],
              [-70.709826, 41.341723],
              [-70.599157, 41.349272],
              [-70.538294, 41.348958],
              [-70.496162, 41.346452],
              [-70.451084, 41.348161],
              [-70.448262, 41.353651],
              [-70.449268, 41.380422],
              [-70.446233, 41.39648],
              [-70.450431, 41.420703],
              [-70.463833, 41.419145],
              [-70.470788, 41.412875],
              [-70.473035, 41.408757],
              [-70.472604, 41.399128],
              [-70.484503, 41.38629],
              [-70.490758, 41.383634],
              [-70.498959, 41.384339],
              [-70.501306, 41.385391],
              [-70.502372, 41.392005],
              [-70.506984, 41.400242],
              [-70.517584, 41.403769],
              [-70.528581, 41.4051],
              [-70.538301, 41.409241],
              [-70.547567, 41.415831],
              [-70.553096, 41.423952],
              [-70.555588, 41.430882],
              [-70.552943, 41.443394],
              [-70.553277, 41.452955],
              [-70.56328, 41.469127],
              [-70.567356, 41.471208],
              [-70.57485, 41.468259],
              [-70.59628, 41.471905],
            ],
          ],
          [
            [
              [-70.092142, 41.297741],
              [-70.12446, 41.293851],
              [-70.196304, 41.294612],
              [-70.20869, 41.290171],
              [-70.229541, 41.290171],
              [-70.240153, 41.295384],
              [-70.244435, 41.303203],
              [-70.249276, 41.305623],
              [-70.260632, 41.310092],
              [-70.275526, 41.310464],
              [-70.273478, 41.301528],
              [-70.266776, 41.294453],
              [-70.256164, 41.288123],
              [-70.237175, 41.282724],
              [-70.170681, 41.255881],
              [-70.118669, 41.242351],
              [-70.096967, 41.24085],
              [-70.083239, 41.2444],
              [-70.052807, 41.242685],
              [-70.015225, 41.237964],
              [-70.001586, 41.239353],
              [-69.975, 41.247392],
              [-69.965725, 41.252466],
              [-69.964422, 41.25457],
              [-69.960181, 41.264546],
              [-69.960277, 41.278731],
              [-70.018446, 41.36863],
              [-70.033514, 41.385816],
              [-70.049053, 41.391702],
              [-70.049564, 41.3879],
              [-70.045586, 41.383598],
              [-70.038458, 41.376399],
              [-70.035162, 41.372161],
              [-70.030924, 41.367453],
              [-70.028805, 41.359919],
              [-70.031332, 41.339332],
              [-70.046088, 41.321651],
              [-70.062565, 41.308726],
              [-70.082072, 41.299093],
              [-70.092142, 41.297741],
            ],
          ],
          [
            [
              [-73.773361, 40.859449],
              [-73.773717, 40.854831],
              [-73.773038, 40.848125],
              [-73.769648, 40.84466],
              [-73.766032, 40.844961],
              [-73.765128, 40.854228],
              [-73.766333, 40.857317],
              [-73.770552, 40.86033],
              [-73.773361, 40.859449],
            ],
          ],
          [
            [
              [-74.04086, 40.700117],
              [-74.04692, 40.691139],
              [-74.047313, 40.690466],
              [-74.046359, 40.689175],
              [-74.044451, 40.688445],
              [-74.043441, 40.68968],
              [-74.037998, 40.698995],
              [-74.039401, 40.700454],
              [-74.040018, 40.700678],
              [-74.04086, 40.700117],
            ],
          ],
          [
            [
              [-74.144428, 40.53516],
              [-74.14023, 40.533738],
              [-74.137241, 40.530076],
              [-74.121672, 40.542691],
              [-74.112585, 40.547603],
              [-74.111471, 40.546908],
              [-74.090797, 40.566463],
              [-74.068184, 40.584102],
              [-74.059184, 40.593502],
              [-74.053125, 40.603678],
              [-74.060345, 40.611999],
              [-74.067598, 40.623865],
              [-74.0697, 40.641216],
              [-74.075884, 40.648101],
              [-74.086485, 40.648601],
              [-74.120186, 40.642201],
              [-74.152973, 40.638886],
              [-74.170187, 40.642201],
              [-74.174085, 40.645109],
              [-74.180191, 40.645521],
              [-74.1894, 40.642121],
              [-74.20058, 40.631448],
              [-74.201812, 40.619507],
              [-74.200994, 40.616906],
              [-74.196096, 40.616169],
              [-74.195407, 40.601806],
              [-74.19682, 40.597037],
              [-74.204054, 40.589336],
              [-74.210887, 40.560902],
              [-74.216997, 40.554991],
              [-74.229002, 40.555041],
              [-74.247808, 40.543396],
              [-74.241732, 40.531273],
              [-74.242888, 40.520903],
              [-74.252702, 40.513895],
              [-74.256088, 40.507903],
              [-74.254588, 40.502303],
              [-74.250188, 40.496703],
              [-74.246688, 40.496103],
              [-74.23324, 40.501299],
              [-74.219787, 40.502603],
              [-74.210474, 40.509448],
              [-74.199923, 40.511729],
              [-74.182157, 40.520634],
              [-74.177986, 40.519603],
              [-74.160859, 40.52679],
              [-74.148697, 40.534489],
              [-74.144428, 40.53516],
            ],
          ],
          [
            [
              [-72.132225, 41.104387],
              [-72.140737, 41.100835],
              [-72.142929, 41.097811],
              [-72.141921, 41.094371],
              [-72.139233, 41.092451],
              [-72.12056, 41.093171],
              [-72.1064, 41.088883],
              [-72.103152, 41.086484],
              [-72.097136, 41.075844],
              [-72.0972, 41.054884],
              [-72.095711, 41.05402],
              [-72.086975, 41.058292],
              [-72.081167, 41.09394],
              [-72.084207, 41.101524],
              [-72.126704, 41.115139],
              [-72.128352, 41.108131],
              [-72.132225, 41.104387],
            ],
          ],
          [
            [
              [-71.943563, 41.286675],
              [-71.952864, 41.285098],
              [-71.980061, 41.280291],
              [-71.991117, 41.281331],
              [-72.006872, 41.27348],
              [-72.018926, 41.274114],
              [-72.023422, 41.270994],
              [-72.029438, 41.26309],
              [-72.034958, 41.255458],
              [-72.036846, 41.249794],
              [-72.002461, 41.252867],
              [-71.994717, 41.256451],
              [-71.978926, 41.265002],
              [-71.962598, 41.270968],
              [-71.94627, 41.276306],
              [-71.935259, 41.280579],
              [-71.926802, 41.290122],
              [-71.943563, 41.286675],
            ],
          ],
          [
            [
              [-73.767176, 40.886299],
              [-73.767276, 40.886899],
              [-73.768276, 40.887599],
              [-73.770576, 40.888399],
              [-73.772276, 40.887499],
              [-73.772776, 40.884599],
              [-73.775176, 40.884199],
              [-73.775276, 40.882199],
              [-73.770876, 40.879299],
              [-73.766976, 40.880099],
              [-73.766276, 40.881099],
              [-73.767076, 40.883499],
              [-73.767076, 40.884799],
              [-73.767076, 40.885399],
              [-73.767176, 40.886299],
            ],
          ],
          [
            [
              [-71.383586, 41.464782],
              [-71.380947, 41.474561],
              [-71.360403, 41.483121],
              [-71.363292, 41.501952],
              [-71.359868, 41.556308],
              [-71.36356, 41.57086],
              [-71.370194, 41.573963],
              [-71.373618, 41.573214],
              [-71.379021, 41.567772],
              [-71.384478, 41.556736],
              [-71.392137, 41.524468],
              [-71.391005, 41.514578],
              [-71.378914, 41.504948],
              [-71.386511, 41.493071],
              [-71.395927, 41.492215],
              [-71.40056, 41.46094],
              [-71.399568, 41.448596],
              [-71.390275, 41.455043],
              [-71.389284, 41.460605],
              [-71.383586, 41.464782],
            ],
          ],
          [
            [
              [-71.326769, 41.491286],
              [-71.341122, 41.498598],
              [-71.343013, 41.495615],
              [-71.327822, 41.482985],
              [-71.325365, 41.487601],
              [-71.326769, 41.491286],
            ],
          ],
          [
            [
              [-71.3312, 41.580318],
              [-71.326103, 41.578583],
              [-71.317474, 41.583187],
              [-71.307381, 41.597984],
              [-71.303352, 41.606591],
              [-71.30555, 41.622523],
              [-71.314889, 41.630398],
              [-71.330711, 41.632992],
              [-71.343666, 41.6399],
              [-71.342514, 41.644791],
              [-71.337048, 41.646146],
              [-71.336182, 41.647961],
              [-71.338696, 41.658782],
              [-71.348402, 41.663727],
              [-71.366165, 41.66098],
              [-71.362869, 41.651457],
              [-71.34657, 41.632229],
              [-71.333305, 41.629536],
              [-71.325877, 41.623988],
              [-71.326609, 41.616114],
              [-71.329559, 41.609097],
              [-71.333751, 41.605859],
              [-71.337048, 41.594688],
              [-71.335949, 41.585898],
              [-71.3312, 41.580318],
            ],
          ],
          [
            [
              [-71.281571, 41.648207],
              [-71.283005, 41.644434],
              [-71.286755, 41.642725],
              [-71.283791, 41.637797],
              [-71.274315, 41.638125],
              [-71.278171, 41.647309],
              [-71.281571, 41.648207],
            ],
          ],
          [
            [
              [-71.58955, 41.196557],
              [-71.594994, 41.188392],
              [-71.605565, 41.182139],
              [-71.613133, 41.160281],
              [-71.611706, 41.153239],
              [-71.599993, 41.146932],
              [-71.5937, 41.146339],
              [-71.551953, 41.151718],
              [-71.547051, 41.153684],
              [-71.543872, 41.161321],
              [-71.544446, 41.164912],
              [-71.550226, 41.166787],
              [-71.560969, 41.176186],
              [-71.565752, 41.184373],
              [-71.564119, 41.195372],
              [-71.557459, 41.204542],
              [-71.554067, 41.212957],
              [-71.555006, 41.216822],
              [-71.561093, 41.224207],
              [-71.573785, 41.228436],
              [-71.576661, 41.224434],
              [-71.577301, 41.21471],
              [-71.580228, 41.204837],
              [-71.58955, 41.196557],
            ],
          ],
        ],
      },
      properties: { region: 'NORTHEAST' },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-87.800477, 42.49192],
              [-87.809672, 42.51482],
              [-87.812273, 42.52982],
              [-87.812632, 42.547562],
              [-87.812724, 42.552104],
              [-87.812851, 42.558352],
              [-87.813135, 42.572424],
              [-87.813142, 42.572768],
              [-87.813223, 42.576759],
              [-87.813273, 42.57922],
              [-87.812871, 42.580576],
              [-87.811617, 42.584809],
              [-87.810873, 42.58732],
              [-87.815074, 42.59412],
              [-87.815736, 42.596045],
              [-87.819374, 42.60662],
              [-87.819674, 42.61582],
              [-87.819407, 42.617327],
              [-87.814674, 42.64402],
              [-87.813445, 42.647345],
              [-87.811371, 42.652959],
              [-87.809885, 42.656982],
              [-87.80988, 42.656997],
              [-87.807082, 42.664571],
              [-87.805768, 42.668128],
              [-87.805421, 42.669067],
              [-87.803127, 42.675276],
              [-87.803074, 42.675419],
              [-87.803028, 42.675501],
              [-87.802989, 42.675569],
              [-87.802876, 42.675768],
              [-87.802377, 42.676651],
              [-87.794874, 42.689919],
              [-87.786774, 42.700719],
              [-87.785074, 42.700819],
              [-87.784015, 42.70372],
              [-87.783489, 42.705164],
              [-87.782374, 42.708219],
              [-87.782023, 42.710008],
              [-87.78032, 42.718679],
              [-87.778627, 42.727299],
              [-87.778824, 42.728432],
              [-87.779527, 42.732482],
              [-87.781333, 42.742879],
              [-87.781642, 42.744656],
              [-87.781655, 42.744733],
              [-87.781849, 42.745847],
              [-87.782174, 42.747719],
              [-87.781949, 42.74857],
              [-87.781016, 42.75209],
              [-87.780782, 42.752973],
              [-87.778774, 42.760556],
              [-87.778174, 42.762819],
              [-87.777432, 42.763781],
              [-87.77134, 42.771687],
              [-87.769774, 42.773719],
              [-87.766675, 42.784896],
              [-87.773623, 42.793388],
              [-87.773699, 42.793481],
              [-87.785936, 42.801168],
              [-87.786291, 42.801391],
              [-87.789953, 42.803691],
              [-87.793976, 42.806218],
              [-87.796201, 42.808428],
              [-87.803773, 42.815948],
              [-87.804033, 42.816205],
              [-87.822324, 42.834371],
              [-87.823278, 42.835318],
              [-87.824, 42.836649],
              [-87.825352, 42.839144],
              [-87.827021, 42.842222],
              [-87.831176, 42.849886],
              [-87.834879, 42.856717],
              [-87.845811, 42.884256],
              [-87.84778, 42.889216],
              [-87.847745, 42.889595],
              [-87.846708, 42.900756],
              [-87.844578, 42.923688],
              [-87.842681, 42.944116],
              [-87.84276, 42.944679],
              [-87.842786, 42.944865],
              [-87.843575, 42.950519],
              [-87.843835, 42.952375],
              [-87.844739, 42.958848],
              [-87.845181, 42.962015],
              [-87.857182, 42.978015],
              [-87.878683, 42.992415],
              [-87.887683, 43.000514],
              [-87.887703, 43.000552],
              [-87.887789, 43.000715],
              [-87.888804, 43.002631],
              [-87.889095, 43.003181],
              [-87.889342, 43.003647],
              [-87.893511, 43.011521],
              [-87.895784, 43.015814],
              [-87.896157, 43.017486],
              [-87.896398, 43.018565],
              [-87.896647, 43.01968],
              [-87.896836, 43.02053],
              [-87.898684, 43.028813],
              [-87.898184, 43.030689],
              [-87.896598, 43.036637],
              [-87.896227, 43.038028],
              [-87.895127, 43.042152],
              [-87.895084, 43.042313],
              [-87.895028, 43.042351],
              [-87.894813, 43.042497],
              [-87.889883, 43.045834],
              [-87.882084, 43.051113],
              [-87.882069, 43.05113],
              [-87.88193, 43.051285],
              [-87.876343, 43.057529],
              [-87.87546, 43.058516],
              [-87.870217, 43.064376],
              [-87.870184, 43.064412],
              [-87.866484, 43.074412],
              [-87.866487, 43.074419],
              [-87.870459, 43.084598],
              [-87.871928, 43.088363],
              [-87.872255, 43.089199],
              [-87.872352, 43.089449],
              [-87.872362, 43.089474],
              [-87.872493, 43.08981],
              [-87.876084, 43.099011],
              [-87.877915, 43.100617],
              [-87.879169, 43.101717],
              [-87.893185, 43.114011],
              [-87.900463, 43.125874],
              [-87.900485, 43.12591],
              [-87.900496, 43.126],
              [-87.901359, 43.133002],
              [-87.901385, 43.13321],
              [-87.901345, 43.133357],
              [-87.900285, 43.13731],
              [-87.89902, 43.139112],
              [-87.898105, 43.140417],
              [-87.896008, 43.143405],
              [-87.892285, 43.14871],
              [-87.891059, 43.151108],
              [-87.889634, 43.153894],
              [-87.889375, 43.1544],
              [-87.889327, 43.154493],
              [-87.888849, 43.155429],
              [-87.88638, 43.160255],
              [-87.881085, 43.170609],
              [-87.884769, 43.179674],
              [-87.884872, 43.179929],
              [-87.884878, 43.179944],
              [-87.886266, 43.183359],
              [-87.887586, 43.186608],
              [-87.88857, 43.187795],
              [-87.89209, 43.192044],
              [-87.895554, 43.196225],
              [-87.896286, 43.197108],
              [-87.897125, 43.199468],
              [-87.897316, 43.200003],
              [-87.897326, 43.200031],
              [-87.897331, 43.200046],
              [-87.910087, 43.235907],
              [-87.910172, 43.236634],
              [-87.911512, 43.248064],
              [-87.911787, 43.250406],
              [-87.910345, 43.255296],
              [-87.909053, 43.259678],
              [-87.907306, 43.265604],
              [-87.907291, 43.265653],
              [-87.907289, 43.265661],
              [-87.906611, 43.26796],
              [-87.906605, 43.26798],
              [-87.906599, 43.268002],
              [-87.906583, 43.268055],
              [-87.906565, 43.268115],
              [-87.906502, 43.26833],
              [-87.906483, 43.268393],
              [-87.906465, 43.268454],
              [-87.904251, 43.275962],
              [-87.903451, 43.278676],
              [-87.903141, 43.279728],
              [-87.903094, 43.279887],
              [-87.902967, 43.280319],
              [-87.901847, 43.284117],
              [-87.900255, 43.287081],
              [-87.897813, 43.291628],
              [-87.889207, 43.307652],
              [-87.888342, 43.313294],
              [-87.888335, 43.313342],
              [-87.888328, 43.313388],
              [-87.888314, 43.313476],
              [-87.888312, 43.313489],
              [-87.888122, 43.314731],
              [-87.882392, 43.352099],
              [-87.877448, 43.369235],
              [-87.872504, 43.380178],
              [-87.869099, 43.386295],
              [-87.867504, 43.389158],
              [-87.865048, 43.39357],
              [-87.855608, 43.405441],
              [-87.827319, 43.434849],
              [-87.807799, 43.461136],
              [-87.793239, 43.492783],
              [-87.797336, 43.510623],
              [-87.797608, 43.52731],
              [-87.794321, 43.543034],
              [-87.793075, 43.54899],
              [-87.790277, 43.562376],
              [-87.790135, 43.563054],
              [-87.789105, 43.564844],
              [-87.782271, 43.576726],
              [-87.781255, 43.578493],
              [-87.780175, 43.579889],
              [-87.742522, 43.628574],
              [-87.742485, 43.628622],
              [-87.738638, 43.633597],
              [-87.737859, 43.634604],
              [-87.736146, 43.636819],
              [-87.735972, 43.637044],
              [-87.735489, 43.637668],
              [-87.735065, 43.638217],
              [-87.734312, 43.63919],
              [-87.733622, 43.640181],
              [-87.72646, 43.650462],
              [-87.706242, 43.679488],
              [-87.706204, 43.679542],
              [-87.703671, 43.685339],
              [-87.702685, 43.687596],
              [-87.702985, 43.706395],
              [-87.703144, 43.706901],
              [-87.707923, 43.722064],
              [-87.708185, 43.722895],
              [-87.709885, 43.735795],
              [-87.708321, 43.742737],
              [-87.708285, 43.742895],
              [-87.708167, 43.742979],
              [-87.705185, 43.745095],
              [-87.70463, 43.746256],
              [-87.703047, 43.749565],
              [-87.702985, 43.749695],
              [-87.700085, 43.761395],
              [-87.70009, 43.76159],
              [-87.700245, 43.767129],
              [-87.700251, 43.76735],
              [-87.726405, 43.810442],
              [-87.726407, 43.810445],
              [-87.726408, 43.810454],
              [-87.726772, 43.812885],
              [-87.727686, 43.818989],
              [-87.7296, 43.831782],
              [-87.729217, 43.840582],
              [-87.728728, 43.851833],
              [-87.728698, 43.852524],
              [-87.734881, 43.87043],
              [-87.736017, 43.873721],
              [-87.736178, 43.880421],
              [-87.735436, 43.882219],
              [-87.734457, 43.88459],
              [-87.733735, 43.88634],
              [-87.731322, 43.892184],
              [-87.730645, 43.893825],
              [-87.73063, 43.893862],
              [-87.728885, 43.89809],
              [-87.728542, 43.89892],
              [-87.726841, 43.90304],
              [-87.726803, 43.903133],
              [-87.726766, 43.903297],
              [-87.724244, 43.914557],
              [-87.723716, 43.916915],
              [-87.7221, 43.924128],
              [-87.721268, 43.92784],
              [-87.720734, 43.930224],
              [-87.720382, 43.931794],
              [-87.720121, 43.932958],
              [-87.719194, 43.9371],
              [-87.719041, 43.93778],
              [-87.719041, 43.937781],
              [-87.71817, 43.939498],
              [-87.716037, 43.943705],
              [-87.709463, 43.950747],
              [-87.706656, 43.953753],
              [-87.704679, 43.955872],
              [-87.703951, 43.956651],
              [-87.702719, 43.958926],
              [-87.702707, 43.958946],
              [-87.700321, 43.963351],
              [-87.700125, 43.963712],
              [-87.699029, 43.965734],
              [-87.69892, 43.965936],
              [-87.695511, 43.989524],
              [-87.695503, 43.989582],
              [-87.695053, 43.990715],
              [-87.691479, 43.99971],
              [-87.686389, 44.01252],
              [-87.683361, 44.020139],
              [-87.671316, 44.03735],
              [-87.656083, 44.051794],
              [-87.656062, 44.051919],
              [-87.653691, 44.065961],
              [-87.653483, 44.067194],
              [-87.655183, 44.081894],
              [-87.654935, 44.082552],
              [-87.651507, 44.091639],
              [-87.647603, 44.101991],
              [-87.647551, 44.102128],
              [-87.646719, 44.104335],
              [-87.646583, 44.104694],
              [-87.6458, 44.105222],
              [-87.621082, 44.121895],
              [-87.603572, 44.13039],
              [-87.600882, 44.131695],
              [-87.599055, 44.132301],
              [-87.59791, 44.13268],
              [-87.59668, 44.133088],
              [-87.570533, 44.141757],
              [-87.567817, 44.142658],
              [-87.567045, 44.142914],
              [-87.563551, 44.144072],
              [-87.563181, 44.144195],
              [-87.550076, 44.152933],
              [-87.53994, 44.15969],
              [-87.51966, 44.17987],
              [-87.512903, 44.192808],
              [-87.507419, 44.210803],
              [-87.508412, 44.229546],
              [-87.508419, 44.229669],
              [-87.508457, 44.229755],
              [-87.515314, 44.245328],
              [-87.515399, 44.245522],
              [-87.515406, 44.245537],
              [-87.521318, 44.258965],
              [-87.52133, 44.258993],
              [-87.521755, 44.259957],
              [-87.521862, 44.26014],
              [-87.522557, 44.261329],
              [-87.52284, 44.261813],
              [-87.523179, 44.262393],
              [-87.524193, 44.264128],
              [-87.524459, 44.264583],
              [-87.524691, 44.264979],
              [-87.525211, 44.265869],
              [-87.525294, 44.26601],
              [-87.525455, 44.266285],
              [-87.525485, 44.266338],
              [-87.525643, 44.266609],
              [-87.525703, 44.266711],
              [-87.525797, 44.266871],
              [-87.525824, 44.266918],
              [-87.526226, 44.267605],
              [-87.526391, 44.267888],
              [-87.526466, 44.268016],
              [-87.541053, 44.292968],
              [-87.541155, 44.293143],
              [-87.541156, 44.293147],
              [-87.541265, 44.293567],
              [-87.541382, 44.294018],
              [-87.544675, 44.306707],
              [-87.544716, 44.306864],
              [-87.544725, 44.307068],
              [-87.545382, 44.321385],
              [-87.54295, 44.327513],
              [-87.541517, 44.331123],
              [-87.533606, 44.351052],
              [-87.533583, 44.351111],
              [-87.521663, 44.366719],
              [-87.521047, 44.367526],
              [-87.519106, 44.372122],
              [-87.518094, 44.374519],
              [-87.51774, 44.375357],
              [-87.517597, 44.375696],
              [-87.517881, 44.390082],
              [-87.517965, 44.394356],
              [-87.515482, 44.402077],
              [-87.512886, 44.410153],
              [-87.512311, 44.411941],
              [-87.511635, 44.414043],
              [-87.511387, 44.414502],
              [-87.507651, 44.421418],
              [-87.506362, 44.423804],
              [-87.502309, 44.443219],
              [-87.499719, 44.455625],
              [-87.499674, 44.455837],
              [-87.499349, 44.457395],
              [-87.498934, 44.459384],
              [-87.498872, 44.45968],
              [-87.49886, 44.459737],
              [-87.498662, 44.460686],
              [-87.495252, 44.467215],
              [-87.495176, 44.46736],
              [-87.494678, 44.468314],
              [-87.492333, 44.472804],
              [-87.490024, 44.477224],
              [-87.486822, 44.491477],
              [-87.484042, 44.503856],
              [-87.483914, 44.504425],
              [-87.483873, 44.505742],
              [-87.483696, 44.511354],
              [-87.481884, 44.516065],
              [-87.472934, 44.539338],
              [-87.468093, 44.551925],
              [-87.467398, 44.553055],
              [-87.467214, 44.553355],
              [-87.467089, 44.553557],
              [-87.446963, 44.586274],
              [-87.437751, 44.604559],
              [-87.437493, 44.605071],
              [-87.435766, 44.606472],
              [-87.418028, 44.62087],
              [-87.40541, 44.627191],
              [-87.403724, 44.628974],
              [-87.401629, 44.631191],
              [-87.393521, 44.640655],
              [-87.38684, 44.652157],
              [-87.37849, 44.666534],
              [-87.373228, 44.675593],
              [-87.368263, 44.684141],
              [-87.367992, 44.684474],
              [-87.36115, 44.692876],
              [-87.354249, 44.70135],
              [-87.354172, 44.701445],
              [-87.353789, 44.701915],
              [-87.349559, 44.709039],
              [-87.348082, 44.711526],
              [-87.343508, 44.719228],
              [-87.341491, 44.725535],
              [-87.341226, 44.726364],
              [-87.339904, 44.730498],
              [-87.339155, 44.732839],
              [-87.337584, 44.737751],
              [-87.320855, 44.767953],
              [-87.319903, 44.769672],
              [-87.318982, 44.771335],
              [-87.319013, 44.771632],
              [-87.31903, 44.771794],
              [-87.319169, 44.773135],
              [-87.319796, 44.77917],
              [-87.320397, 44.784963],
              [-87.315813, 44.791034],
              [-87.314247, 44.793109],
              [-87.31388, 44.793595],
              [-87.313751, 44.793766],
              [-87.313692, 44.793838],
              [-87.313363, 44.794237],
              [-87.307482, 44.801377],
              [-87.304824, 44.804603],
              [-87.294869, 44.809131],
              [-87.282561, 44.814729],
              [-87.27603, 44.83318],
              [-87.274769, 44.835187],
              [-87.267564, 44.846655],
              [-87.267441, 44.846851],
              [-87.267061, 44.847025],
              [-87.246171, 44.856571],
              [-87.224891, 44.866295],
              [-87.211398, 44.872461],
              [-87.204904, 44.875429],
              [-87.204545, 44.875593],
              [-87.204809, 44.877159],
              [-87.204815, 44.877199],
              [-87.206184, 44.885329],
              [-87.206285, 44.885928],
              [-87.209265, 44.889182],
              [-87.212587, 44.892809],
              [-87.21671, 44.897309],
              [-87.217149, 44.897789],
              [-87.217195, 44.897839],
              [-87.217171, 44.898013],
              [-87.216146, 44.905379],
              [-87.216074, 44.9059],
              [-87.216059, 44.906009],
              [-87.215977, 44.906597],
              [-87.215808, 44.906744],
              [-87.204238, 44.916819],
              [-87.187984, 44.924845],
              [-87.186732, 44.925463],
              [-87.185858, 44.925632],
              [-87.182421, 44.926297],
              [-87.17492, 44.927749],
              [-87.1717, 44.931476],
              [-87.17524, 44.939753],
              [-87.179974, 44.942753],
              [-87.188074, 44.947886],
              [-87.188375, 44.948077],
              [-87.188399, 44.94856],
              [-87.188582, 44.952193],
              [-87.189383, 44.968164],
              [-87.189402, 44.968524],
              [-87.189407, 44.968632],
              [-87.189134, 44.969078],
              [-87.187585, 44.971606],
              [-87.182922, 44.979221],
              [-87.181901, 44.980887],
              [-87.181428, 44.981505],
              [-87.169694, 44.996836],
              [-87.169676, 44.99686],
              [-87.169494, 44.997096],
              [-87.16797, 44.999088],
              [-87.167474, 44.999736],
              [-87.163561, 45.004848],
              [-87.163529, 45.00489],
              [-87.163477, 45.004913],
              [-87.154084, 45.009117],
              [-87.141048, 45.012175],
              [-87.139384, 45.012565],
              [-87.138024, 45.015327],
              [-87.134354, 45.02278],
              [-87.132344, 45.026862],
              [-87.124808, 45.042167],
              [-87.124797, 45.043262],
              [-87.124788, 45.044141],
              [-87.124744, 45.048608],
              [-87.124737, 45.049268],
              [-87.124727, 45.050344],
              [-87.124722, 45.050833],
              [-87.124701, 45.052936],
              [-87.121156, 45.058311],
              [-87.097479, 45.055771],
              [-87.096387, 45.055654],
              [-87.092177, 45.055203],
              [-87.091761, 45.055158],
              [-87.091639, 45.055145],
              [-87.090849, 45.055465],
              [-87.086351, 45.057287],
              [-87.082419, 45.058879],
              [-87.081866, 45.059103],
              [-87.080755, 45.06471],
              [-87.080271, 45.067154],
              [-87.079555, 45.07077],
              [-87.079552, 45.070783],
              [-87.064864, 45.078427],
              [-87.063376, 45.079202],
              [-87.063157, 45.079316],
              [-87.063129, 45.079356],
              [-87.061966, 45.081015],
              [-87.058259, 45.086304],
              [-87.057444, 45.087467],
              [-87.057415, 45.087472],
              [-87.05078, 45.088663],
              [-87.048359, 45.089098],
              [-87.048213, 45.089124],
              [-87.048346, 45.092647],
              [-87.048406, 45.094259],
              [-87.048911, 45.107665],
              [-87.048951, 45.108718],
              [-87.049231, 45.109712],
              [-87.049268, 45.109845],
              [-87.049346, 45.110122],
              [-87.05075, 45.115111],
              [-87.051049, 45.116172],
              [-87.054342, 45.119968],
              [-87.054282, 45.120074],
              [-87.045748, 45.134987],
              [-87.042286, 45.136841],
              [-87.042114, 45.136933],
              [-87.041564, 45.137228],
              [-87.040175, 45.137972],
              [-87.035838, 45.140294],
              [-87.035465, 45.140494],
              [-87.034667, 45.140921],
              [-87.034621, 45.140946],
              [-87.03355, 45.141519],
              [-87.033546, 45.141522],
              [-87.033117, 45.141752],
              [-87.033114, 45.141753],
              [-87.03292, 45.141963],
              [-87.032461, 45.14246],
              [-87.032344, 45.142586],
              [-87.032194, 45.142748],
              [-87.031307, 45.143709],
              [-87.031167, 45.14386],
              [-87.030126, 45.144986],
              [-87.030105, 45.145009],
              [-87.028957, 45.14625],
              [-87.028847, 45.14637],
              [-87.02898, 45.146467],
              [-87.029164, 45.146603],
              [-87.030225, 45.147382],
              [-87.034083, 45.150216],
              [-87.036716, 45.15215],
              [-87.038479, 45.153445],
              [-87.041145, 45.155404],
              [-87.044176, 45.15763],
              [-87.045225, 45.158401],
              [-87.045242, 45.158798],
              [-87.04548, 45.164271],
              [-87.04566, 45.168403],
              [-87.045681, 45.168889],
              [-87.045687, 45.169016],
              [-87.045701, 45.169351],
              [-87.045883, 45.173543],
              [-87.045899, 45.173902],
              [-87.041106, 45.210052],
              [-87.041075, 45.210283],
              [-87.041063, 45.210375],
              [-87.040924, 45.211421],
              [-87.040909, 45.211535],
              [-87.034524, 45.219734],
              [-87.032576, 45.222235],
              [-87.032546, 45.222274],
              [-87.032521, 45.222274],
              [-87.007583, 45.222127],
              [-87.00754, 45.222127],
              [-87.005468, 45.214114],
              [-87.005359, 45.213694],
              [-87.005243, 45.213607],
              [-87.002806, 45.211773],
              [-87.000112, 45.212429],
              [-86.997316, 45.21311],
              [-86.995804, 45.213478],
              [-86.988075, 45.21536],
              [-86.985973, 45.215872],
              [-86.983708, 45.21947],
              [-86.983001, 45.220593],
              [-86.981956, 45.222254],
              [-86.98108, 45.223646],
              [-86.978759, 45.227333],
              [-86.978697, 45.227538],
              [-86.974086, 45.242864],
              [-86.973651, 45.244308],
              [-86.973483, 45.244867],
              [-86.97346, 45.244944],
              [-86.973453, 45.244966],
              [-86.973022, 45.246399],
              [-86.973287, 45.246381],
              [-86.976711, 45.246146],
              [-86.982393, 45.24898],
              [-86.982669, 45.249117],
              [-86.983066, 45.250764],
              [-86.984172, 45.255346],
              [-86.984975, 45.258674],
              [-86.984938, 45.259036],
              [-86.984495, 45.263409],
              [-86.984398, 45.264366],
              [-86.983597, 45.264971],
              [-86.977355, 45.269687],
              [-86.974622, 45.271752],
              [-86.974528, 45.271823],
              [-86.974346, 45.272113],
              [-86.973227, 45.27389],
              [-86.972786, 45.274591],
              [-86.970355, 45.278455],
              [-86.977714, 45.290575],
              [-86.97778, 45.290684],
              [-86.980058, 45.292598],
              [-86.983227, 45.29526],
              [-86.983355, 45.295368],
              [-86.98388, 45.295499],
              [-86.984223, 45.295585],
              [-86.993201, 45.297833],
              [-86.993528, 45.297915],
              [-86.994112, 45.298061],
              [-87.015797, 45.29919],
              [-87.017036, 45.299254],
              [-87.021088, 45.296541],
              [-87.034077, 45.287844],
              [-87.034206, 45.287758],
              [-87.041463, 45.285518],
              [-87.04313, 45.285003],
              [-87.043497, 45.28489],
              [-87.043724, 45.28482],
              [-87.043895, 45.284767],
              [-87.048745, 45.285464],
              [-87.050796, 45.285758],
              [-87.0517, 45.285888],
              [-87.051979, 45.286215],
              [-87.052872, 45.287262],
              [-87.052927, 45.287326],
              [-87.053417, 45.287901],
              [-87.057627, 45.292838],
              [-87.070845, 45.280532],
              [-87.071035, 45.280355],
              [-87.078316, 45.265723],
              [-87.101681, 45.259027],
              [-87.10843, 45.257093],
              [-87.108743, 45.257003],
              [-87.109014, 45.256458],
              [-87.109541, 45.255397],
              [-87.116432, 45.24152],
              [-87.116456, 45.24145],
              [-87.117391, 45.23874],
              [-87.121266, 45.2275],
              [-87.121288, 45.227438],
              [-87.121667, 45.226337],
              [-87.122819, 45.222997],
              [-87.122708, 45.221786],
              [-87.122364, 45.218023],
              [-87.122248, 45.216764],
              [-87.122226, 45.216519],
              [-87.122194, 45.216168],
              [-87.122098, 45.215121],
              [-87.121609, 45.209783],
              [-87.121566, 45.209698],
              [-87.121541, 45.209649],
              [-87.119654, 45.20593],
              [-87.11945, 45.205529],
              [-87.119405, 45.20544],
              [-87.119413, 45.205237],
              [-87.119511, 45.202754],
              [-87.119522, 45.202488],
              [-87.119534, 45.202184],
              [-87.119768, 45.196271],
              [-87.11978, 45.195965],
              [-87.119784, 45.195866],
              [-87.119822, 45.194908],
              [-87.119825, 45.194814],
              [-87.119864, 45.193843],
              [-87.119868, 45.193724],
              [-87.119874, 45.193581],
              [-87.119876, 45.193527],
              [-87.119887, 45.193242],
              [-87.119894, 45.193071],
              [-87.119921, 45.192386],
              [-87.119925, 45.19228],
              [-87.119968, 45.191198],
              [-87.119971, 45.191125],
              [-87.119972, 45.191103],
              [-87.123689, 45.18989],
              [-87.124549, 45.190162],
              [-87.128597, 45.191441],
              [-87.12981, 45.191825],
              [-87.132874, 45.192794],
              [-87.13303, 45.192843],
              [-87.142708, 45.191437],
              [-87.147657, 45.190719],
              [-87.147709, 45.190711],
              [-87.163169, 45.185331],
              [-87.167179, 45.183594],
              [-87.168252, 45.18216],
              [-87.168298, 45.182099],
              [-87.170062, 45.179741],
              [-87.170266, 45.179468],
              [-87.171233, 45.178175],
              [-87.171272, 45.178123],
              [-87.173722, 45.17485],
              [-87.175068, 45.17305],
              [-87.17517, 45.173],
              [-87.195213, 45.16311],
              [-87.195876, 45.163201],
              [-87.200385, 45.163819],
              [-87.207963, 45.164857],
              [-87.213483, 45.165614],
              [-87.21437, 45.165735],
              [-87.220937, 45.173773],
              [-87.221707, 45.174716],
              [-87.221971, 45.175039],
              [-87.222316, 45.174959],
              [-87.224065, 45.174551],
              [-87.231214, 45.172887],
              [-87.231925, 45.172316],
              [-87.23822, 45.167262],
              [-87.238224, 45.167259],
              [-87.238229, 45.167238],
              [-87.238426, 45.166492],
              [-87.242924, 45.149377],
              [-87.242331, 45.146773],
              [-87.240308, 45.137886],
              [-87.240813, 45.137559],
              [-87.250487, 45.131289],
              [-87.254072, 45.126323],
              [-87.257449, 45.121644],
              [-87.260595, 45.106007],
              [-87.260542, 45.092585],
              [-87.260631, 45.092355],
              [-87.264877, 45.081361],
              [-87.268695, 45.077884],
              [-87.268737, 45.077847],
              [-87.269231, 45.077396],
              [-87.284208, 45.06376],
              [-87.28428, 45.063694],
              [-87.300146, 45.054075],
              [-87.300724, 45.053724],
              [-87.300887, 45.053625],
              [-87.30247, 45.052666],
              [-87.302831, 45.052447],
              [-87.303149, 45.052146],
              [-87.30342, 45.05189],
              [-87.303475, 45.051838],
              [-87.307394, 45.04813],
              [-87.315879, 45.040103],
              [-87.322022, 45.03429],
              [-87.322117, 45.034201],
              [-87.336457, 45.01353],
              [-87.336548, 45.013431],
              [-87.345091, 45.004151],
              [-87.351487, 44.997203],
              [-87.360288, 44.987643],
              [-87.363492, 44.980798],
              [-87.370075, 44.966736],
              [-87.371854, 44.962935],
              [-87.372568, 44.96141],
              [-87.372599, 44.961343],
              [-87.373046, 44.960388],
              [-87.374805, 44.956631],
              [-87.382436, 44.94608],
              [-87.384669, 44.942993],
              [-87.385066, 44.942445],
              [-87.387253, 44.939421],
              [-87.389006, 44.937988],
              [-87.393058, 44.934677],
              [-87.393405, 44.934393],
              [-87.393672, 44.933899],
              [-87.393752, 44.933751],
              [-87.398368, 44.925226],
              [-87.405005, 44.911806],
              [-87.405361, 44.909626],
              [-87.406199, 44.90449],
              [-87.401947, 44.9024],
              [-87.400488, 44.901683],
              [-87.397359, 44.900145],
              [-87.397184, 44.900059],
              [-87.396972, 44.899955],
              [-87.393399, 44.898199],
              [-87.39227, 44.897037],
              [-87.39198, 44.896739],
              [-87.39107, 44.895803],
              [-87.3908, 44.895524],
              [-87.390651, 44.895372],
              [-87.390604, 44.895323],
              [-87.38649, 44.89109],
              [-87.386396, 44.890993],
              [-87.386375, 44.890972],
              [-87.386111, 44.890699],
              [-87.385396, 44.889964],
              [-87.383631, 44.885115],
              [-87.383655, 44.884723],
              [-87.38367, 44.884475],
              [-87.383833, 44.881788],
              [-87.383839, 44.881685],
              [-87.383874, 44.881116],
              [-87.384593, 44.869277],
              [-87.384821, 44.865532],
              [-87.405541, 44.860047],
              [-87.405658, 44.860098],
              [-87.408779, 44.861453],
              [-87.410015, 44.86199],
              [-87.410919, 44.863259],
              [-87.419253, 44.87496],
              [-87.419951, 44.87594],
              [-87.419135, 44.885052],
              [-87.419114, 44.885285],
              [-87.419106, 44.885378],
              [-87.420327, 44.887596],
              [-87.421007, 44.887869],
              [-87.428144, 44.890738],
              [-87.433005, 44.892691],
              [-87.433128, 44.892741],
              [-87.437084, 44.892718],
              [-87.441339, 44.889723],
              [-87.456688, 44.878918],
              [-87.472639, 44.86769],
              [-87.478489, 44.863572],
              [-87.499063, 44.864207],
              [-87.501578, 44.864285],
              [-87.502431, 44.864619],
              [-87.504303, 44.865352],
              [-87.504405, 44.865392],
              [-87.504868, 44.865573],
              [-87.512129, 44.868416],
              [-87.513413, 44.868919],
              [-87.513775, 44.869061],
              [-87.51459, 44.86938],
              [-87.515142, 44.869596],
              [-87.530794, 44.857594],
              [-87.530999, 44.857437],
              [-87.534723, 44.85625],
              [-87.550003, 44.851381],
              [-87.550288, 44.85129],
              [-87.560183, 44.85208],
              [-87.570851, 44.852932],
              [-87.573175, 44.853118],
              [-87.581306, 44.851791],
              [-87.581635, 44.851638],
              [-87.609784, 44.838514],
              [-87.610018, 44.838405],
              [-87.610063, 44.838384],
              [-87.610245, 44.838217],
              [-87.611118, 44.837416],
              [-87.611852, 44.836743],
              [-87.616242, 44.832715],
              [-87.616384, 44.832585],
              [-87.622014, 44.827419],
              [-87.632699, 44.817616],
              [-87.632892, 44.817439],
              [-87.632977, 44.817361],
              [-87.633418, 44.816956],
              [-87.634059, 44.816369],
              [-87.634381, 44.816073],
              [-87.63439, 44.816065],
              [-87.634476, 44.815986],
              [-87.635265, 44.815263],
              [-87.635416, 44.815124],
              [-87.637104, 44.813575],
              [-87.644545, 44.801571],
              [-87.644637, 44.801423],
              [-87.644646, 44.801407],
              [-87.645229, 44.800466],
              [-87.6463, 44.798739],
              [-87.647764, 44.797347],
              [-87.662056, 44.783758],
              [-87.677995, 44.768602],
              [-87.678368, 44.768247],
              [-87.679709, 44.766973],
              [-87.687497, 44.759567],
              [-87.688207, 44.758892],
              [-87.698167, 44.747226],
              [-87.698246, 44.747133],
              [-87.698584, 44.746738],
              [-87.698653, 44.746657],
              [-87.700539, 44.744448],
              [-87.700778, 44.744169],
              [-87.701022, 44.743882],
              [-87.703557, 44.740914],
              [-87.704653, 44.73963],
              [-87.705733, 44.738364],
              [-87.705852, 44.738225],
              [-87.714401, 44.730449],
              [-87.720312, 44.725073],
              [-87.720889, 44.724548],
              [-87.721059, 44.723522],
              [-87.721252, 44.722361],
              [-87.721816, 44.718969],
              [-87.720599, 44.714984],
              [-87.720248, 44.713833],
              [-87.718427, 44.70787],
              [-87.718409, 44.707811],
              [-87.718413, 44.707765],
              [-87.71978, 44.693246],
              [-87.729836, 44.682015],
              [-87.733701, 44.678916],
              [-87.736058, 44.677025],
              [-87.748409, 44.667122],
              [-87.74909, 44.664131],
              [-87.750899, 44.656192],
              [-87.756031, 44.649129],
              [-87.756048, 44.649117],
              [-87.762376, 44.644501],
              [-87.762912, 44.64411],
              [-87.765774, 44.642023],
              [-87.77516, 44.639281],
              [-87.78824, 44.638137],
              [-87.808366, 44.636378],
              [-87.808819, 44.636338],
              [-87.809076, 44.636189],
              [-87.820083, 44.629816],
              [-87.823444, 44.62787],
              [-87.829229, 44.624521],
              [-87.830848, 44.623583],
              [-87.836101, 44.621375],
              [-87.837416, 44.620822],
              [-87.842164, 44.618826],
              [-87.866884, 44.608434],
              [-87.867941, 44.607606],
              [-87.88741, 44.592356],
              [-87.890868, 44.589647],
              [-87.891717, 44.588982],
              [-87.891727, 44.588977],
              [-87.894356, 44.587745],
              [-87.896412, 44.58678],
              [-87.901179, 44.584545],
              [-87.902319, 44.583079],
              [-87.903689, 44.581317],
              [-87.901236, 44.577648],
              [-87.901061, 44.577386],
              [-87.900634, 44.576747],
              [-87.900198, 44.576095],
              [-87.899183, 44.574576],
              [-87.898888, 44.574135],
              [-87.898907, 44.574091],
              [-87.899368, 44.573043],
              [-87.900668, 44.570084],
              [-87.901177, 44.568925],
              [-87.901178, 44.568924],
              [-87.901206, 44.568887],
              [-87.915846, 44.549612],
              [-87.917, 44.548093],
              [-87.917467, 44.547622],
              [-87.924044, 44.540991],
              [-87.929001, 44.535993],
              [-87.935707, 44.533138],
              [-87.939972, 44.531323],
              [-87.943801, 44.529693],
              [-87.970702, 44.530292],
              [-87.977901, 44.532137],
              [-87.982821, 44.533398],
              [-87.986059, 44.534228],
              [-87.990468, 44.535358],
              [-87.990985, 44.535491],
              [-87.998536, 44.537426],
              [-87.999002, 44.537546],
              [-88.000099, 44.537827],
              [-88.005518, 44.539216],
              [-88.016709, 44.547518],
              [-88.020707, 44.550484],
              [-88.037178, 44.562705],
              [-88.042414, 44.566589],
              [-88.042261, 44.567344],
              [-88.041775, 44.569746],
              [-88.041659, 44.57032],
              [-88.041561, 44.570804],
              [-88.041485, 44.571183],
              [-88.041358, 44.571809],
              [-88.041202, 44.572581],
              [-88.041162, 44.572614],
              [-88.039489, 44.573995],
              [-88.039092, 44.574324],
              [-88.036104, 44.576791],
              [-88.036103, 44.576792],
              [-88.034535, 44.577175],
              [-88.028148, 44.578736],
              [-88.027103, 44.578992],
              [-88.022853, 44.584196],
              [-88.019465, 44.588344],
              [-88.016404, 44.592092],
              [-88.016373, 44.592172],
              [-88.015092, 44.595478],
              [-88.014735, 44.5964],
              [-88.012395, 44.602438],
              [-88.001943, 44.603909],
              [-87.998716, 44.609288],
              [-87.998836, 44.609523],
              [-88.001172, 44.614112],
              [-88.006409, 44.624399],
              [-88.006871, 44.625306],
              [-88.007013, 44.625586],
              [-88.007158, 44.625871],
              [-88.007489, 44.626521],
              [-88.008717, 44.628932],
              [-88.009463, 44.630398],
              [-88.009472, 44.630594],
              [-88.009486, 44.630897],
              [-88.009523, 44.631711],
              [-88.009766, 44.637081],
              [-88.007287, 44.645779],
              [-88.00334, 44.65963],
              [-88.002677, 44.661956],
              [-88.002254, 44.663442],
              [-88.002085, 44.664035],
              [-88.000321, 44.664686],
              [-87.998964, 44.665187],
              [-87.99011, 44.668455],
              [-87.990081, 44.669791],
              [-87.989912, 44.677587],
              [-87.989717, 44.686582],
              [-87.98947, 44.687918],
              [-87.989376, 44.688424],
              [-87.989344, 44.688598],
              [-87.98925, 44.689107],
              [-87.988667, 44.692255],
              [-87.987417, 44.699005],
              [-87.987296, 44.699657],
              [-87.986134, 44.705936],
              [-87.986055, 44.70636],
              [-87.984401, 44.715298],
              [-87.984247, 44.716129],
              [-87.984094, 44.716955],
              [-87.98395, 44.717735],
              [-87.983941, 44.717781],
              [-87.983494, 44.720196],
              [-87.983065, 44.72073],
              [-87.972654, 44.733687],
              [-87.964714, 44.74357],
              [-87.956849, 44.749272],
              [-87.95156, 44.753107],
              [-87.941453, 44.75608],
              [-87.926816, 44.778555],
              [-87.925845, 44.780301],
              [-87.923588, 44.784361],
              [-87.918874, 44.79284],
              [-87.911366, 44.806345],
              [-87.906582, 44.814949],
              [-87.905444, 44.816997],
              [-87.904484, 44.818723],
              [-87.904281, 44.819246],
              [-87.903844, 44.820376],
              [-87.903395, 44.821534],
              [-87.902166, 44.824708],
              [-87.901814, 44.825616],
              [-87.901137, 44.827365],
              [-87.899787, 44.828051],
              [-87.897931, 44.828995],
              [-87.895812, 44.830072],
              [-87.89257, 44.83172],
              [-87.885709, 44.835208],
              [-87.878218, 44.839016],
              [-87.871679, 44.839816],
              [-87.866237, 44.840481],
              [-87.865898, 44.840988],
              [-87.857469, 44.853599],
              [-87.857121, 44.85412],
              [-87.855962, 44.855854],
              [-87.854938, 44.857386],
              [-87.854681, 44.857771],
              [-87.854184, 44.859633],
              [-87.852789, 44.86486],
              [-87.84914, 44.86942],
              [-87.848324, 44.87044],
              [-87.847616, 44.870692],
              [-87.838359, 44.873987],
              [-87.836916, 44.87578],
              [-87.835497, 44.877544],
              [-87.832764, 44.880939],
              [-87.827751, 44.891229],
              [-87.832137, 44.896569],
              [-87.833521, 44.898254],
              [-87.833731, 44.89851],
              [-87.834275, 44.899172],
              [-87.836082, 44.901371],
              [-87.836743, 44.902177],
              [-87.837017, 44.902509],
              [-87.839561, 44.905607],
              [-87.840382, 44.907289],
              [-87.842375, 44.911371],
              [-87.84264, 44.911916],
              [-87.842719, 44.912077],
              [-87.842844, 44.912586],
              [-87.844299, 44.918524],
              [-87.843433, 44.924355],
              [-87.839028, 44.931718],
              [-87.837647, 44.933091],
              [-87.822192, 44.948457],
              [-87.821983, 44.948665],
              [-87.821485, 44.949161],
              [-87.82105, 44.949593],
              [-87.820848, 44.949793],
              [-87.820281, 44.950358],
              [-87.819525, 44.951109],
              [-87.819369, 44.951178],
              [-87.819313, 44.951203],
              [-87.818113, 44.951736],
              [-87.817912, 44.951826],
              [-87.817713, 44.951914],
              [-87.817551, 44.951986],
              [-87.817285, 44.952104],
              [-87.816151, 44.952608],
              [-87.815134, 44.95306],
              [-87.813866, 44.953623],
              [-87.813276, 44.953885],
              [-87.812989, 44.954013],
              [-87.812594, 44.954109],
              [-87.792325, 44.95905],
              [-87.791987, 44.959132],
              [-87.791372, 44.959282],
              [-87.789934, 44.959633],
              [-87.788987, 44.959863],
              [-87.781464, 44.961697],
              [-87.781298, 44.961738],
              [-87.766872, 44.965254],
              [-87.766115, 44.965351],
              [-87.762846, 44.965768],
              [-87.7627, 44.965786],
              [-87.76262, 44.965796],
              [-87.696492, 44.974233],
              [-87.661964, 44.973035],
              [-87.630298, 44.976865],
              [-87.624693, 45.014176],
              [-87.625748, 45.045157],
              [-87.610395, 45.075617],
              [-87.601849, 45.082297],
              [-87.594718, 45.085134],
              [-87.591583, 45.083792],
              [-87.587992, 45.085271],
              [-87.587147, 45.089495],
              [-87.590208, 45.095264],
              [-87.581969, 45.097206],
              [-87.589396, 45.09649],
              [-87.59027, 45.096406],
              [-87.592318, 45.097779],
              [-87.597665, 45.101365],
              [-87.598689, 45.102052],
              [-87.60012, 45.103011],
              [-87.601086, 45.104092],
              [-87.601649, 45.104721],
              [-87.601981, 45.105092],
              [-87.602179, 45.105314],
              [-87.602217, 45.105356],
              [-87.602542, 45.105719],
              [-87.604464, 45.107868],
              [-87.605193, 45.108684],
              [-87.606757, 45.110433],
              [-87.608951, 45.112886],
              [-87.610073, 45.114141],
              [-87.611216, 45.119568],
              [-87.611497, 45.120901],
              [-87.6115, 45.120915],
              [-87.611814, 45.122406],
              [-87.612019, 45.123377],
              [-87.60928, 45.13232],
              [-87.607958, 45.134583],
              [-87.607812, 45.134833],
              [-87.600796, 45.146842],
              [-87.596556, 45.152316],
              [-87.587822, 45.163591],
              [-87.585651, 45.166394],
              [-87.582324, 45.169039],
              [-87.563417, 45.18407],
              [-87.556327, 45.187759],
              [-87.552468, 45.189767],
              [-87.548964, 45.191591],
              [-87.535346, 45.203734],
              [-87.530499, 45.208056],
              [-87.512336, 45.224252],
              [-87.504186, 45.232742],
              [-87.503302, 45.233662],
              [-87.496869, 45.240364],
              [-87.465201, 45.273351],
              [-87.464794, 45.273662],
              [-87.456414, 45.280053],
              [-87.455519, 45.280736],
              [-87.438908, 45.293405],
              [-87.437507, 45.30367],
              [-87.437257, 45.3055],
              [-87.436128, 45.307705],
              [-87.431684, 45.316383],
              [-87.427379, 45.320854],
              [-87.409987, 45.33892],
              [-87.399973, 45.349322],
              [-87.39452, 45.363702],
              [-87.3925, 45.369028],
              [-87.391446, 45.369759],
              [-87.389849, 45.370866],
              [-87.389478, 45.371123],
              [-87.389181, 45.371329],
              [-87.387851, 45.372251],
              [-87.371282, 45.383738],
              [-87.364368, 45.388532],
              [-87.360529, 45.397464],
              [-87.360078, 45.398512],
              [-87.359512, 45.399829],
              [-87.351306, 45.407328],
              [-87.350852, 45.407743],
              [-87.338083, 45.41436],
              [-87.336152, 45.41536],
              [-87.330882, 45.421598],
              [-87.329505, 45.423229],
              [-87.328248, 45.424716],
              [-87.327749, 45.425307],
              [-87.326069, 45.429459],
              [-87.325834, 45.43004],
              [-87.326855, 45.43051],
              [-87.327367, 45.430745],
              [-87.32864, 45.431331],
              [-87.329958, 45.431937],
              [-87.331107, 45.433673],
              [-87.33324, 45.436897],
              [-87.333309, 45.437269],
              [-87.334249, 45.442315],
              [-87.334033, 45.443273],
              [-87.333407, 45.446056],
              [-87.333147, 45.447208],
              [-87.330262, 45.451011],
              [-87.319703, 45.464929],
              [-87.317416, 45.466712],
              [-87.306122, 45.475513],
              [-87.289443, 45.50053],
              [-87.288726, 45.501606],
              [-87.280709, 45.517624],
              [-87.264446, 45.550118],
              [-87.263763, 45.551482],
              [-87.263488, 45.552032],
              [-87.261979, 45.553954],
              [-87.260709, 45.555573],
              [-87.250122, 45.569059],
              [-87.234612, 45.588817],
              [-87.232472, 45.59087],
              [-87.223647, 45.599338],
              [-87.218989, 45.60576],
              [-87.215616, 45.610408],
              [-87.21122, 45.616468],
              [-87.196852, 45.636275],
              [-87.191496, 45.641827],
              [-87.173493, 45.66049],
              [-87.172241, 45.661788],
              [-87.161593, 45.666741],
              [-87.15033, 45.67198],
              [-87.146713, 45.673662],
              [-87.129412, 45.68171],
              [-87.12857, 45.681909],
              [-87.112524, 45.685696],
              [-87.111638, 45.685905],
              [-87.100265, 45.694808],
              [-87.099725, 45.695231],
              [-87.099411, 45.698514],
              [-87.099401, 45.698614],
              [-87.095455, 45.701039],
              [-87.093365, 45.701473],
              [-87.074873, 45.705312],
              [-87.074813, 45.705325],
              [-87.073932, 45.705508],
              [-87.061339, 45.708122],
              [-87.059533, 45.708497],
              [-87.059953, 45.708893],
              [-87.070442, 45.718779],
              [-87.061721, 45.732821],
              [-87.057444, 45.736822],
              [-87.052908, 45.747983],
              [-87.05555, 45.751535],
              [-87.062406, 45.753296],
              [-87.064302, 45.758828],
              [-87.063975, 45.76651],
              [-87.058601, 45.778126],
              [-87.058127, 45.779152],
              [-87.058413, 45.788071],
              [-87.058628, 45.794772],
              [-87.058682, 45.796447],
              [-87.058844, 45.80151],
              [-87.058489, 45.804285],
              [-87.058277, 45.80594],
              [-87.058207, 45.806483],
              [-87.057882, 45.809021],
              [-87.057863, 45.80917],
              [-87.057439, 45.812483],
              [-87.052043, 45.821879],
              [-87.050104, 45.823844],
              [-87.039842, 45.834245],
              [-87.031435, 45.837238],
              [-87.018902, 45.838886],
              [-87.006225, 45.832312],
              [-87.006095, 45.832244],
              [-87.00508, 45.831718],
              [-86.988438, 45.810621],
              [-86.981624, 45.792221],
              [-86.981341, 45.76616],
              [-86.975224, 45.75313],
              [-86.977655, 45.728768],
              [-86.982413, 45.719873],
              [-86.984588, 45.705812],
              [-86.981349, 45.696463],
              [-86.969765, 45.691895],
              [-86.967315, 45.684923],
              [-86.966885, 45.675001],
              [-86.964275, 45.672761],
              [-86.944158, 45.695833],
              [-86.92106, 45.697868],
              [-86.904089, 45.709546],
              [-86.895342, 45.711464],
              [-86.876904, 45.711891],
              [-86.870392, 45.710087],
              [-86.838746, 45.722307],
              [-86.841818, 45.729051],
              [-86.838658, 45.741831],
              [-86.821814, 45.757164],
              [-86.820868, 45.760776],
              [-86.823743, 45.765486],
              [-86.821523, 45.770356],
              [-86.801476, 45.780027],
              [-86.785722, 45.794517],
              [-86.773279, 45.811385],
              [-86.774612, 45.821696],
              [-86.777225, 45.827183],
              [-86.782259, 45.82995],
              [-86.784177, 45.854641],
              [-86.78208, 45.860195],
              [-86.758449, 45.867274],
              [-86.749638, 45.867796],
              [-86.742466, 45.864719],
              [-86.72852, 45.848759],
              [-86.721113, 45.845431],
              [-86.645998, 45.833888],
              [-86.632478, 45.843309],
              [-86.633168, 45.860068],
              [-86.625736, 45.868295],
              [-86.613536, 45.875982],
              [-86.603293, 45.876626],
              [-86.593184, 45.88511],
              [-86.583304, 45.898784],
              [-86.567719, 45.9005],
              [-86.553608, 45.896476],
              [-86.541464, 45.890234],
              [-86.532989, 45.882665],
              [-86.529573, 45.874974],
              [-86.528224, 45.856974],
              [-86.529208, 45.853043],
              [-86.538831, 45.840083],
              [-86.545602, 45.836495],
              [-86.549723, 45.836039],
              [-86.555186, 45.831696],
              [-86.559044, 45.822323],
              [-86.555547, 45.813499],
              [-86.557215, 45.808172],
              [-86.563392, 45.804469],
              [-86.571172, 45.805452],
              [-86.576858, 45.801473],
              [-86.581759, 45.794797],
              [-86.581071, 45.791802],
              [-86.576869, 45.788502],
              [-86.583391, 45.778242],
              [-86.597661, 45.775385],
              [-86.612137, 45.779356],
              [-86.617336, 45.783538],
              [-86.631018, 45.782019],
              [-86.634902, 45.763536],
              [-86.633138, 45.747654],
              [-86.647319, 45.732618],
              [-86.662762, 45.728964],
              [-86.67148, 45.72053],
              [-86.669263, 45.71086],
              [-86.665511, 45.70903],
              [-86.665677, 45.702217],
              [-86.676184, 45.691862],
              [-86.689102, 45.687862],
              [-86.705184, 45.690901],
              [-86.715781, 45.683949],
              [-86.718191, 45.67732],
              [-86.717828, 45.668106],
              [-86.708038, 45.649202],
              [-86.695275, 45.648175],
              [-86.688772, 45.639969],
              [-86.687208, 45.634253],
              [-86.666127, 45.621689],
              [-86.648439, 45.615992],
              [-86.633224, 45.618249],
              [-86.62387, 45.613262],
              [-86.616893, 45.606796],
              [-86.616972, 45.620581],
              [-86.627938, 45.659293],
              [-86.625132, 45.663819],
              [-86.62043, 45.667098],
              [-86.611306, 45.669733],
              [-86.593613, 45.665625],
              [-86.587528, 45.666456],
              [-86.584771, 45.682007],
              [-86.585847, 45.704922],
              [-86.580936, 45.71192],
              [-86.570627, 45.716412],
              [-86.54143, 45.70811],
              [-86.537258, 45.708361],
              [-86.53328, 45.710849],
              [-86.525166, 45.720797],
              [-86.523197, 45.736498],
              [-86.518281, 45.747688],
              [-86.51457, 45.752337],
              [-86.504216, 45.75423],
              [-86.496251, 45.749255],
              [-86.486028, 45.746608],
              [-86.47905, 45.757416],
              [-86.466039, 45.759741],
              [-86.459866, 45.758042],
              [-86.455534, 45.75685],
              [-86.442335, 45.760026],
              [-86.440329, 45.760508],
              [-86.439661, 45.760669],
              [-86.43553, 45.764452],
              [-86.435493, 45.764485],
              [-86.431921, 45.767756],
              [-86.428294, 45.77562],
              [-86.427183, 45.77905],
              [-86.428946, 45.782524],
              [-86.428423, 45.785587],
              [-86.424828, 45.789747],
              [-86.415971, 45.793793],
              [-86.401656, 45.795412],
              [-86.395809, 45.78974],
              [-86.369918, 45.789254],
              [-86.363808, 45.790057],
              [-86.351658, 45.798132],
              [-86.355062, 45.805355],
              [-86.349134, 45.83416],
              [-86.332625, 45.851813],
              [-86.324232, 45.90608],
              [-86.315981, 45.915247],
              [-86.278007, 45.942057],
              [-86.254768, 45.94864],
              [-86.248008, 45.944849],
              [-86.233613, 45.945802],
              [-86.22906, 45.94857],
              [-86.220546, 45.958883],
              [-86.208255, 45.962978],
              [-86.196618, 45.963185],
              [-86.159415, 45.953765],
              [-86.150173, 45.954494],
              [-86.145714, 45.957372],
              [-86.123567, 45.964748],
              [-86.094753, 45.966704],
              [-86.072067, 45.965313],
              [-86.050956, 45.962205],
              [-85.998868, 45.950968],
              [-85.954063, 45.936629],
              [-85.920581, 45.920994],
              [-85.913769, 45.919439],
              [-85.910264, 45.922112],
              [-85.917238, 45.927782],
              [-85.926017, 45.932104],
              [-85.926213, 45.938093],
              [-85.922737, 45.948287],
              [-85.912604, 45.956302],
              [-85.91237, 45.956487],
              [-85.9091, 45.959074],
              [-85.893196, 45.967253],
              [-85.882442, 45.96862],
              [-85.865402, 45.968257],
              [-85.861157, 45.968167],
              [-85.86019, 45.968016],
              [-85.843016, 45.965342],
              [-85.842404, 45.965247],
              [-85.839025, 45.966107],
              [-85.838366, 45.966275],
              [-85.838133, 45.966334],
              [-85.835456, 45.967016],
              [-85.835217, 45.967077],
              [-85.834504, 45.967258],
              [-85.832603, 45.967742],
              [-85.832261, 45.968172],
              [-85.82978, 45.9713],
              [-85.826278, 45.975714],
              [-85.826034, 45.976021],
              [-85.825819, 45.976292],
              [-85.820721, 45.978239],
              [-85.818006, 45.979276],
              [-85.817558, 45.979447],
              [-85.817066, 45.979491],
              [-85.811054, 45.980032],
              [-85.810442, 45.980087],
              [-85.8092, 45.979931],
              [-85.791841, 45.977745],
              [-85.790639, 45.977594],
              [-85.790279, 45.97748],
              [-85.774055, 45.972337],
              [-85.770938, 45.971349],
              [-85.760165, 45.968914],
              [-85.743618, 45.965173],
              [-85.74353, 45.965174],
              [-85.731776, 45.965317],
              [-85.725153, 45.965398],
              [-85.724246, 45.965409],
              [-85.716228, 45.963852],
              [-85.706548, 45.961973],
              [-85.704951, 45.961662],
              [-85.704237, 45.961524],
              [-85.701627, 45.961017],
              [-85.697609, 45.960237],
              [-85.697203, 45.960158],
              [-85.688149, 45.962025],
              [-85.664609, 45.96688],
              [-85.663966, 45.967013],
              [-85.654738, 45.973648],
              [-85.654686, 45.973686],
              [-85.650942, 45.979824],
              [-85.650434, 45.980656],
              [-85.648942, 45.983103],
              [-85.648581, 45.983695],
              [-85.647554, 45.984519],
              [-85.64743, 45.984619],
              [-85.646359, 45.985477],
              [-85.646279, 45.985541],
              [-85.62933, 45.999136],
              [-85.628998, 45.999403],
              [-85.628293, 45.999968],
              [-85.625118, 46.002515],
              [-85.617709, 46.008458],
              [-85.617577, 46.008665],
              [-85.615661, 46.01168],
              [-85.603785, 46.030363],
              [-85.563567, 46.06182],
              [-85.561097, 46.063751],
              [-85.54595, 46.075598],
              [-85.542974, 46.077926],
              [-85.540858, 46.079581],
              [-85.539479, 46.080416],
              [-85.533341, 46.084131],
              [-85.529058, 46.086724],
              [-85.528947, 46.086791],
              [-85.528403, 46.087121],
              [-85.521636, 46.091217],
              [-85.52157, 46.091257],
              [-85.521424, 46.091314],
              [-85.512696, 46.094727],
              [-85.50024, 46.096915],
              [-85.5001, 46.09694],
              [-85.499422, 46.09692],
              [-85.486316, 46.096543],
              [-85.48072, 46.096382],
              [-85.480603, 46.096379],
              [-85.480315, 46.096283],
              [-85.476097, 46.094876],
              [-85.468899, 46.092474],
              [-85.466828, 46.091783],
              [-85.45315, 46.087219],
              [-85.44699, 46.085164],
              [-85.445976, 46.086272],
              [-85.445835, 46.086426],
              [-85.440191, 46.092593],
              [-85.440908, 46.093053],
              [-85.442255, 46.093916],
              [-85.442293, 46.093941],
              [-85.442112, 46.094867],
              [-85.441934, 46.095783],
              [-85.441932, 46.095793],
              [-85.441879, 46.095815],
              [-85.44157, 46.095942],
              [-85.437768, 46.097504],
              [-85.437352, 46.097675],
              [-85.432064, 46.099848],
              [-85.429533, 46.100888],
              [-85.42921, 46.101021],
              [-85.426916, 46.101964],
              [-85.412064, 46.101437],
              [-85.409463, 46.100585],
              [-85.404194, 46.098859],
              [-85.393832, 46.095465],
              [-85.390047, 46.091381],
              [-85.382927, 46.083698],
              [-85.382781, 46.08354],
              [-85.382312, 46.083035],
              [-85.381394, 46.082044],
              [-85.381263, 46.082086],
              [-85.367158, 46.086606],
              [-85.366622, 46.086778],
              [-85.356339, 46.092022],
              [-85.356214, 46.092086],
              [-85.3561, 46.092089],
              [-85.33628, 46.092586],
              [-85.335911, 46.092595],
              [-85.335466, 46.092459],
              [-85.316264, 46.086608],
              [-85.310613, 46.083773],
              [-85.304238, 46.080576],
              [-85.295321, 46.076103],
              [-85.290046, 46.073456],
              [-85.287936, 46.072398],
              [-85.287693, 46.072276],
              [-85.278345, 46.069426],
              [-85.268308, 46.066365],
              [-85.266385, 46.065779],
              [-85.255375, 46.064502],
              [-85.248414, 46.063694],
              [-85.225052, 46.060984],
              [-85.222959, 46.060741],
              [-85.222511, 46.060689],
              [-85.222416, 46.060629],
              [-85.221206, 46.059864],
              [-85.220289, 46.059283],
              [-85.217705, 46.057648],
              [-85.214657, 46.055719],
              [-85.210834, 46.053301],
              [-85.197523, 46.044878],
              [-85.195201, 46.045802],
              [-85.194724, 46.045992],
              [-85.19063, 46.047622],
              [-85.152027, 46.050725],
              [-85.151825, 46.050705],
              [-85.151738, 46.050696],
              [-85.147103, 46.05023],
              [-85.14516, 46.050035],
              [-85.142456, 46.049764],
              [-85.140835, 46.049601],
              [-85.139572, 46.049173],
              [-85.13765, 46.048522],
              [-85.133704, 46.047184],
              [-85.130433, 46.046076],
              [-85.127202, 46.044481],
              [-85.127046, 46.044404],
              [-85.125243, 46.043515],
              [-85.124796, 46.043294],
              [-85.113601, 46.037769],
              [-85.106684, 46.034356],
              [-85.105148, 46.033598],
              [-85.102899, 46.032488],
              [-85.102862, 46.032477],
              [-85.088818, 46.028378],
              [-85.088345, 46.028304],
              [-85.081934, 46.027295],
              [-85.055581, 46.023148],
              [-85.054297, 46.022766],
              [-85.048972, 46.021182],
              [-85.047974, 46.020885],
              [-85.047028, 46.020603],
              [-85.020951, 46.012845],
              [-85.01399, 46.010774],
              [-85.010941, 46.009412],
              [-85.010208, 46.009084],
              [-85.003597, 46.00613],
              [-84.992511, 45.998751],
              [-84.974714, 45.986905],
              [-84.974668, 45.986874],
              [-84.973556, 45.986134],
              [-84.971232, 45.984208],
              [-84.937134, 45.955949],
              [-84.936953, 45.955716],
              [-84.936565, 45.955217],
              [-84.917484, 45.93067],
              [-84.917288, 45.930576],
              [-84.902913, 45.923673],
              [-84.902572, 45.923557],
              [-84.879835, 45.915847],
              [-84.879507, 45.915546],
              [-84.878969, 45.915053],
              [-84.877253, 45.91348],
              [-84.873273, 45.909832],
              [-84.873254, 45.909815],
              [-84.870355, 45.908432],
              [-84.867851, 45.907237],
              [-84.861494, 45.904204],
              [-84.860544, 45.903751],
              [-84.859025, 45.903026],
              [-84.855982, 45.901574],
              [-84.853303, 45.900296],
              [-84.852916, 45.900111],
              [-84.850592, 45.899694],
              [-84.846035, 45.898875],
              [-84.844615, 45.89862],
              [-84.843087, 45.898346],
              [-84.842243, 45.898194],
              [-84.842147, 45.898005],
              [-84.840666, 45.895074],
              [-84.839639, 45.893042],
              [-84.837635, 45.889075],
              [-84.837624, 45.889054],
              [-84.837717, 45.888226],
              [-84.837841, 45.887123],
              [-84.838228, 45.883685],
              [-84.838472, 45.881512],
              [-84.838427, 45.881452],
              [-84.838282, 45.881258],
              [-84.835147, 45.87706],
              [-84.834236, 45.875841],
              [-84.834213, 45.87581],
              [-84.831947, 45.872776],
              [-84.831396, 45.872038],
              [-84.828996, 45.871209],
              [-84.820557, 45.868293],
              [-84.792763, 45.858691],
              [-84.7754, 45.849932],
              [-84.773761, 45.849105],
              [-84.758333, 45.841322],
              [-84.754672, 45.839475],
              [-84.751507, 45.837878],
              [-84.747033, 45.835621],
              [-84.746985, 45.835597],
              [-84.726921, 45.836964],
              [-84.725734, 45.837045],
              [-84.723552, 45.84408],
              [-84.723005, 45.845845],
              [-84.722764, 45.846621],
              [-84.721468, 45.84762],
              [-84.721011, 45.847972],
              [-84.720836, 45.848107],
              [-84.720609, 45.848116],
              [-84.709261, 45.848548],
              [-84.707676, 45.848609],
              [-84.706383, 45.848658],
              [-84.705978, 45.848837],
              [-84.705923, 45.848861],
              [-84.705036, 45.849253],
              [-84.704647, 45.849425],
              [-84.702295, 45.850464],
              [-84.702256, 45.850557],
              [-84.701183, 45.853092],
              [-84.701594, 45.853461],
              [-84.702122, 45.853935],
              [-84.709727, 45.860766],
              [-84.715365, 45.86583],
              [-84.715481, 45.865934],
              [-84.715501, 45.865962],
              [-84.721276, 45.873908],
              [-84.721277, 45.873911],
              [-84.729482, 45.895263],
              [-84.730252, 45.897267],
              [-84.734002, 45.907026],
              [-84.713251, 45.916047],
              [-84.713614, 45.920366],
              [-84.718955, 45.927449],
              [-84.733041, 45.932837],
              [-84.73937, 45.941816],
              [-84.738849, 45.945792],
              [-84.730179, 45.961198],
              [-84.723039, 45.967279],
              [-84.703948, 45.970901],
              [-84.687712, 45.97126],
              [-84.685254, 45.973454],
              [-84.684368, 45.977499],
              [-84.686269, 45.979144],
              [-84.6927, 46.016963],
              [-84.692735, 46.027019],
              [-84.687322, 46.03488],
              [-84.675835, 46.046009],
              [-84.66671, 46.050486],
              [-84.656567, 46.052654],
              [-84.647609, 46.049704],
              [-84.609063, 46.026418],
              [-84.586592, 46.026584],
              [-84.581081, 46.031041],
              [-84.563891, 46.032459],
              [-84.544405, 46.02286],
              [-84.540995, 46.019501],
              [-84.533426, 46.00572],
              [-84.530444, 45.991385],
              [-84.534648, 45.978132],
              [-84.534422, 45.972762],
              [-84.532392, 45.969448],
              [-84.525052, 45.968578],
              [-84.514071, 45.971292],
              [-84.514123, 45.987242],
              [-84.507201, 45.991169],
              [-84.488536, 45.98882],
              [-84.485625, 45.988453],
              [-84.484009, 45.98825],
              [-84.482773, 45.986035],
              [-84.482442, 45.985441],
              [-84.482506, 45.985109],
              [-84.483062, 45.982242],
              [-84.482563, 45.981391],
              [-84.4808, 45.978385],
              [-84.480436, 45.977764],
              [-84.478576, 45.976814],
              [-84.473694, 45.974321],
              [-84.463128, 45.968925],
              [-84.459956, 45.970343],
              [-84.443336, 45.977775],
              [-84.44314, 45.977862],
              [-84.443138, 45.977863],
              [-84.443086, 45.977825],
              [-84.437633, 45.97375],
              [-84.436574, 45.97193],
              [-84.436454, 45.971722],
              [-84.428689, 45.958371],
              [-84.428239, 45.958144],
              [-84.411212, 45.949539],
              [-84.399582, 45.943662],
              [-84.39946, 45.9436],
              [-84.399134, 45.943436],
              [-84.39854, 45.943136],
              [-84.398323, 45.943026],
              [-84.398007, 45.942866],
              [-84.391464, 45.93956],
              [-84.387383, 45.937497],
              [-84.376431, 45.931963],
              [-84.376429, 45.931962],
              [-84.357525, 45.939881],
              [-84.353714, 45.941478],
              [-84.353272, 45.941663],
              [-84.353259, 45.941671],
              [-84.345451, 45.946569],
              [-84.331572, 45.955274],
              [-84.330346, 45.956043],
              [-84.330021, 45.956247],
              [-84.327177, 45.95624],
              [-84.326413, 45.956238],
              [-84.325787, 45.956237],
              [-84.325115, 45.956235],
              [-84.324647, 45.956234],
              [-84.320494, 45.956224],
              [-84.320017, 45.956223],
              [-84.319565, 45.956222],
              [-84.317422, 45.956217],
              [-84.281663, 45.956132],
              [-84.266673, 45.956096],
              [-84.261858, 45.956084],
              [-84.2613, 45.956083],
              [-84.254952, 45.956068],
              [-84.253993, 45.956727],
              [-84.238174, 45.967595],
              [-84.218951, 45.9681],
              [-84.213885, 45.968233],
              [-84.203135, 45.968516],
              [-84.17806, 45.969175],
              [-84.175244, 45.967671],
              [-84.174763, 45.967414],
              [-84.17225, 45.966072],
              [-84.169368, 45.966919],
              [-84.140816, 45.975308],
              [-84.140461, 45.975348],
              [-84.114284, 45.978322],
              [-84.111174, 45.978675],
              [-84.107204, 45.977161],
              [-84.10537, 45.972948],
              [-84.090391, 45.967256],
              [-84.080071, 45.970822],
              [-84.017565, 45.959046],
              [-83.996471, 45.961461],
              [-83.985141, 45.967133],
              [-83.952183, 45.965498],
              [-83.921257, 45.958075],
              [-83.910838, 45.965613],
              [-83.881055, 45.968185],
              [-83.879616, 45.966196],
              [-83.864859, 45.959465],
              [-83.846437, 45.953181],
              [-83.840869, 45.952726],
              [-83.835505, 45.941843],
              [-83.827566, 45.941236],
              [-83.82281, 45.943985],
              [-83.808147, 45.945693],
              [-83.803332, 45.943362],
              [-83.80104, 45.937582],
              [-83.78611, 45.933375],
              [-83.768854, 45.932069],
              [-83.766233, 45.935221],
              [-83.742778, 45.938002],
              [-83.732986, 45.937641],
              [-83.719433, 45.934078],
              [-83.687695, 45.935389],
              [-83.65766, 45.945463],
              [-83.632214, 45.932287],
              [-83.583052, 45.915919],
              [-83.561838, 45.912562],
              [-83.526347, 45.918636],
              [-83.517242, 45.923614],
              [-83.510623, 45.929324],
              [-83.488809, 45.96874],
              [-83.481765, 45.971873],
              [-83.473221, 45.984422],
              [-83.473946, 45.988558],
              [-83.480639, 45.996164],
              [-83.488348, 45.999543],
              [-83.49484, 45.999541],
              [-83.532913, 46.011328],
              [-83.540845, 46.021247],
              [-83.543366, 46.037196],
              [-83.547202, 46.047868],
              [-83.554059, 46.058882],
              [-83.565351, 46.061898],
              [-83.572574, 46.069895],
              [-83.57264, 46.074922],
              [-83.57609, 46.083513],
              [-83.581315, 46.089613],
              [-83.598612, 46.090085],
              [-83.615343, 46.095976],
              [-83.625554, 46.102212],
              [-83.63498, 46.103953],
              [-83.661161, 46.100258],
              [-83.703861, 46.103366],
              [-83.719791, 46.101031],
              [-83.7233, 46.09381],
              [-83.728165, 46.090957],
              [-83.755991, 46.092159],
              [-83.771821, 46.090999],
              [-83.779996, 46.093515],
              [-83.792867, 46.101971],
              [-83.81241, 46.108598],
              [-83.815826, 46.108529],
              [-83.824036, 46.103638],
              [-83.81252, 46.073469],
              [-83.796555, 46.056688],
              [-83.773785, 46.051471],
              [-83.765233, 46.031935],
              [-83.765277, 46.018363],
              [-83.776436, 46.004202],
              [-83.794055, 45.995801],
              [-83.818202, 46.002425],
              [-83.830146, 46.022324],
              [-83.845399, 46.025679],
              [-83.868233, 45.995075],
              [-83.873147, 45.993426],
              [-83.900535, 45.998918],
              [-83.908583, 46.011471],
              [-83.931175, 46.017871],
              [-83.93547, 46.020385],
              [-83.939012, 46.029226],
              [-83.943933, 46.031465],
              [-83.95141, 46.029042],
              [-83.963808, 46.027833],
              [-83.989526, 46.032823],
              [-84.006082, 46.044586],
              [-84.027861, 46.054784],
              [-84.051712, 46.079189],
              [-84.066257, 46.087438],
              [-84.071741, 46.092441],
              [-84.072398, 46.09669],
              [-84.069147, 46.103978],
              [-84.061329, 46.113482],
              [-84.0519, 46.11981],
              [-84.038696, 46.12562],
              [-84.031036, 46.123186],
              [-84.026536, 46.131648],
              [-84.060383, 46.146138],
              [-84.089309, 46.146432],
              [-84.095818, 46.147733],
              [-84.100126, 46.15077],
              [-84.113259, 46.16886],
              [-84.114941, 46.174114],
              [-84.125022, 46.180209],
              [-84.17164, 46.181731],
              [-84.177298, 46.183993],
              [-84.196669, 46.16615],
              [-84.221001, 46.163062],
              [-84.251424, 46.175888],
              [-84.247687, 46.17989],
              [-84.245233, 46.192571],
              [-84.249164, 46.206461],
              [-84.233117, 46.224037],
              [-84.219494, 46.231992],
              [-84.182732, 46.23545],
              [-84.159485, 46.233233],
              [-84.152499, 46.227875],
              [-84.15223, 46.226254],
              [-84.152042, 46.224937],
              [-84.151666, 46.224184],
              [-84.150725, 46.223808],
              [-84.14922, 46.223808],
              [-84.14715, 46.224184],
              [-84.14595, 46.224995],
              [-84.134652, 46.23214],
              [-84.125024, 46.232885],
              [-84.118175, 46.233968],
              [-84.108089, 46.241238],
              [-84.115563, 46.268225],
              [-84.138906, 46.372221],
              [-84.146172, 46.41852],
              [-84.125026, 46.470143],
              [-84.111225, 46.504119],
              [-84.117925, 46.517619],
              [-84.128925, 46.530119],
              [-84.139426, 46.532219],
              [-84.193729, 46.53992],
              [-84.226131, 46.53392],
              [-84.264266, 46.495055],
              [-84.325371, 46.500021],
              [-84.37504, 46.508669],
              [-84.394725, 46.499242],
              [-84.420274, 46.501077],
              [-84.445149, 46.489016],
              [-84.463322, 46.467435],
              [-84.455256, 46.462785],
              [-84.455527, 46.453897],
              [-84.462597, 46.44094],
              [-84.471848, 46.434289],
              [-84.479513, 46.432573],
              [-84.493401, 46.440313],
              [-84.503719, 46.43919],
              [-84.551496, 46.418522],
              [-84.573522, 46.427895],
              [-84.584167, 46.43941],
              [-84.607945, 46.456747],
              [-84.616489, 46.47187],
              [-84.63102, 46.484868],
              [-84.65388, 46.48225],
              [-84.678423, 46.487694],
              [-84.689672, 46.483923],
              [-84.723338, 46.468266],
              [-84.769151, 46.453523],
              [-84.800101, 46.446219],
              [-84.829491, 46.444071],
              [-84.843907, 46.448661],
              [-84.849767, 46.460245],
              [-84.861448, 46.46993],
              [-84.87507, 46.466781],
              [-84.893423, 46.465406],
              [-84.915184, 46.467515],
              [-84.921931, 46.469962],
              [-84.934432, 46.480315],
              [-84.937145, 46.489252],
              [-84.947269, 46.487399],
              [-84.955307, 46.480269],
              [-84.969464, 46.47629],
              [-85.015211, 46.479712],
              [-85.025598, 46.483028],
              [-85.033766, 46.48767],
              [-85.049847, 46.503963],
              [-85.054943, 46.51475],
              [-85.056133, 46.52652],
              [-85.052954, 46.532827],
              [-85.045534, 46.537694],
              [-85.027083, 46.543038],
              [-85.025491, 46.546397],
              [-85.027374, 46.553756],
              [-85.029594, 46.554419],
              [-85.031507, 46.568703],
              [-85.035476, 46.581547],
              [-85.037056, 46.600995],
              [-85.035504, 46.625021],
              [-85.028291, 46.675125],
              [-85.030078, 46.684769],
              [-85.027513, 46.697451],
              [-85.020159, 46.712463],
              [-85.007616, 46.728339],
              [-84.987539, 46.745483],
              [-84.95158, 46.769488],
              [-84.954009, 46.771362],
              [-84.964652, 46.772845],
              [-84.989497, 46.772403],
              [-85.00924, 46.769224],
              [-85.036286, 46.760435],
              [-85.063556, 46.757856],
              [-85.173042, 46.763634],
              [-85.237873, 46.755703],
              [-85.256031, 46.753481],
              [-85.25686, 46.75338],
              [-85.257999, 46.753078],
              [-85.289846, 46.744644],
              [-85.296395, 46.742114],
              [-85.347047, 46.722546],
              [-85.362572, 46.716548],
              [-85.369805, 46.713754],
              [-85.482096, 46.680432],
              [-85.482978, 46.680283],
              [-85.50951, 46.675786],
              [-85.542517, 46.674263],
              [-85.547593, 46.674304],
              [-85.558762, 46.674395],
              [-85.584989, 46.674608],
              [-85.587345, 46.674627],
              [-85.587741, 46.674672],
              [-85.593558, 46.675334],
              [-85.594158, 46.675402],
              [-85.595806, 46.67559],
              [-85.61747, 46.678054],
              [-85.624573, 46.678862],
              [-85.647387, 46.679658],
              [-85.663673, 46.680227],
              [-85.668753, 46.680404],
              [-85.674011, 46.68003],
              [-85.700945, 46.678114],
              [-85.714415, 46.677156],
              [-85.738624, 46.677298],
              [-85.739929, 46.677305],
              [-85.742834, 46.677322],
              [-85.750606, 46.677368],
              [-85.751345, 46.67743],
              [-85.792506, 46.68088],
              [-85.794923, 46.681083],
              [-85.796641, 46.681374],
              [-85.815747, 46.68461],
              [-85.840211, 46.688753],
              [-85.841057, 46.688896],
              [-85.85662, 46.689748],
              [-85.857755, 46.68981],
              [-85.864549, 46.690182],
              [-85.877908, 46.690914],
              [-85.924047, 46.684733],
              [-85.95367, 46.676869],
              [-85.995044, 46.673676],
              [-86.036969, 46.667627],
              [-86.074219, 46.657799],
              [-86.099843, 46.654615],
              [-86.112126, 46.655044],
              [-86.119862, 46.657256],
              [-86.138295, 46.672935],
              [-86.161681, 46.669475],
              [-86.188024, 46.654008],
              [-86.34989, 46.578035],
              [-86.390409, 46.563194],
              [-86.437167, 46.54896],
              [-86.44439, 46.548137],
              [-86.45993, 46.551928],
              [-86.469306, 46.551422],
              [-86.481956, 46.542709],
              [-86.484003, 46.535965],
              [-86.495054, 46.524874],
              [-86.524959, 46.505381],
              [-86.557731, 46.487434],
              [-86.586168, 46.463324],
              [-86.609039, 46.470239],
              [-86.606932, 46.478531],
              [-86.609393, 46.492976],
              [-86.612173, 46.493295],
              [-86.618061, 46.489452],
              [-86.620603, 46.483873],
              [-86.627441, 46.47754],
              [-86.636671, 46.478298],
              [-86.646393, 46.485776],
              [-86.645528, 46.492039],
              [-86.641088, 46.500438],
              [-86.63453, 46.504523],
              [-86.632109, 46.508865],
              [-86.629086, 46.518144],
              [-86.62738, 46.53371],
              [-86.652865, 46.560555],
              [-86.656479, 46.558453],
              [-86.670927, 46.556489],
              [-86.675764, 46.557061],
              [-86.678182, 46.561039],
              [-86.695645, 46.555026],
              [-86.709325, 46.543914],
              [-86.701929, 46.511571],
              [-86.696001, 46.50316],
              [-86.683819, 46.498079],
              [-86.686468, 46.471655],
              [-86.688816, 46.463152],
              [-86.686412, 46.454965],
              [-86.698139, 46.438624],
              [-86.70323, 46.439378],
              [-86.710573, 46.444908],
              [-86.730829, 46.468057],
              [-86.731096, 46.47176],
              [-86.735929, 46.475231],
              [-86.750157, 46.479109],
              [-86.768516, 46.479072],
              [-86.787905, 46.477729],
              [-86.803557, 46.466669],
              [-86.808817, 46.460611],
              [-86.810967, 46.449663],
              [-86.816026, 46.437892],
              [-86.837448, 46.434186],
              [-86.850111, 46.434114],
              [-86.875151, 46.43728],
              [-86.883919, 46.441514],
              [-86.883976, 46.450976],
              [-86.889094, 46.458499],
              [-86.903742, 46.466138],
              [-86.927725, 46.464566],
              [-86.947077, 46.472064],
              [-86.949526, 46.476315],
              [-86.946218, 46.479059],
              [-86.94698, 46.484567],
              [-86.962842, 46.509646],
              [-86.964534, 46.516549],
              [-86.976958, 46.526581],
              [-87.008724, 46.532723],
              [-87.017136, 46.53355],
              [-87.029892, 46.525599],
              [-87.046022, 46.519956],
              [-87.077279, 46.515339],
              [-87.09876, 46.503609],
              [-87.107559, 46.496124],
              [-87.116618, 46.495163],
              [-87.12744, 46.494014],
              [-87.145946, 46.495387],
              [-87.175065, 46.497548],
              [-87.175105, 46.497538],
              [-87.200147, 46.491382],
              [-87.202404, 46.490827],
              [-87.205147, 46.490702],
              [-87.258145, 46.488282],
              [-87.258732, 46.488255],
              [-87.259116, 46.488283],
              [-87.309402, 46.491919],
              [-87.310755, 46.492017],
              [-87.312109, 46.49231],
              [-87.351071, 46.500749],
              [-87.352448, 46.501324],
              [-87.366767, 46.507303],
              [-87.381349, 46.517292],
              [-87.38929, 46.524472],
              [-87.393985, 46.533183],
              [-87.3903, 46.542577],
              [-87.375613, 46.54714],
              [-87.382206, 46.553681],
              [-87.392828, 46.570852],
              [-87.392974, 46.572523],
              [-87.381649, 46.580059],
              [-87.383961, 46.59307],
              [-87.403275, 46.595215],
              [-87.411167, 46.601669],
              [-87.442612, 46.602776],
              [-87.451368, 46.605923],
              [-87.464108, 46.614811],
              [-87.467563, 46.626228],
              [-87.466537, 46.631555],
              [-87.467965, 46.635623],
              [-87.469023, 46.635918],
              [-87.492409, 46.642435],
              [-87.49286, 46.642561],
              [-87.493405, 46.642826],
              [-87.501511, 46.646762],
              [-87.503025, 46.647497],
              [-87.503238, 46.647796],
              [-87.506657, 46.652599],
              [-87.519176, 46.670186],
              [-87.524444, 46.677586],
              [-87.524419, 46.67783],
              [-87.523744, 46.6843],
              [-87.523361, 46.687977],
              [-87.523308, 46.688488],
              [-87.532638, 46.694469],
              [-87.533529, 46.69504],
              [-87.534504, 46.695664],
              [-87.54392, 46.7017],
              [-87.549097, 46.705019],
              [-87.551989, 46.706872],
              [-87.553048, 46.707551],
              [-87.557436, 46.710364],
              [-87.567343, 46.716714],
              [-87.573203, 46.720471],
              [-87.581674, 46.729399],
              [-87.582745, 46.730527],
              [-87.58357, 46.732839],
              [-87.584568, 46.735637],
              [-87.587626, 46.744206],
              [-87.587755, 46.744568],
              [-87.589671, 46.749937],
              [-87.590502, 46.752267],
              [-87.590767, 46.753009],
              [-87.590865, 46.753653],
              [-87.591082, 46.755087],
              [-87.591362, 46.756932],
              [-87.591455, 46.757544],
              [-87.591907, 46.760525],
              [-87.591973, 46.760965],
              [-87.59222, 46.762594],
              [-87.592227, 46.762635],
              [-87.593148, 46.768713],
              [-87.594384, 46.776863],
              [-87.595276, 46.782745],
              [-87.595307, 46.78295],
              [-87.607988, 46.788408],
              [-87.609008, 46.789258],
              [-87.610582, 46.790571],
              [-87.613586, 46.793074],
              [-87.613654, 46.793131],
              [-87.6168, 46.795753],
              [-87.617852, 46.796631],
              [-87.619747, 46.79821],
              [-87.627124, 46.80436],
              [-87.627356, 46.804553],
              [-87.628081, 46.805157],
              [-87.628284, 46.805428],
              [-87.628786, 46.806096],
              [-87.6333, 46.812107],
              [-87.640839, 46.813534],
              [-87.641887, 46.813733],
              [-87.642789, 46.813609],
              [-87.646539, 46.813094],
              [-87.65151, 46.812411],
              [-87.662261, 46.815157],
              [-87.672015, 46.820415],
              [-87.674345, 46.82405],
              [-87.673973, 46.825179],
              [-87.673274, 46.8273],
              [-87.673177, 46.827593],
              [-87.673433, 46.82935],
              [-87.673469, 46.829598],
              [-87.674541, 46.836964],
              [-87.675046, 46.83742],
              [-87.679573, 46.841507],
              [-87.680668, 46.842496],
              [-87.681561, 46.842392],
              [-87.68672, 46.841794],
              [-87.687164, 46.841742],
              [-87.68728, 46.841351],
              [-87.687875, 46.839343],
              [-87.68793, 46.839159],
              [-87.685735, 46.832639],
              [-87.685698, 46.83253],
              [-87.685787, 46.832477],
              [-87.69459, 46.827182],
              [-87.713737, 46.825534],
              [-87.725649, 46.82739],
              [-87.72588, 46.827426],
              [-87.727358, 46.827656],
              [-87.731522, 46.831196],
              [-87.734325, 46.836955],
              [-87.736469, 46.846096],
              [-87.736539, 46.846393],
              [-87.736732, 46.847216],
              [-87.735106, 46.849751],
              [-87.735039, 46.849856],
              [-87.73487, 46.85012],
              [-87.740846, 46.864834],
              [-87.740917, 46.865007],
              [-87.741014, 46.865247],
              [-87.741857, 46.865274],
              [-87.744403, 46.865355],
              [-87.744893, 46.865371],
              [-87.745665, 46.865396],
              [-87.746646, 46.865427],
              [-87.748498, 46.864428],
              [-87.754448, 46.861219],
              [-87.755748, 46.860518],
              [-87.755868, 46.860453],
              [-87.755937, 46.860459],
              [-87.765835, 46.861303],
              [-87.765989, 46.861316],
              [-87.766243, 46.861446],
              [-87.776804, 46.866823],
              [-87.778752, 46.870422],
              [-87.778289, 46.870834],
              [-87.776346, 46.872562],
              [-87.776313, 46.872591],
              [-87.776567, 46.874293],
              [-87.776672, 46.874999],
              [-87.77693, 46.876726],
              [-87.777156, 46.876854],
              [-87.777527, 46.877064],
              [-87.777749, 46.87719],
              [-87.781969, 46.87958],
              [-87.782461, 46.879859],
              [-87.783216, 46.879927],
              [-87.788186, 46.880373],
              [-87.793194, 46.880822],
              [-87.813226, 46.888023],
              [-87.813228, 46.888025],
              [-87.81412, 46.888808],
              [-87.816794, 46.891154],
              [-87.827162, 46.889713],
              [-87.830204, 46.888556],
              [-87.838889, 46.885252],
              [-87.841228, 46.884363],
              [-87.844637, 46.884049],
              [-87.846195, 46.883905],
              [-87.847037, 46.884163],
              [-87.873893, 46.892381],
              [-87.874538, 46.892578],
              [-87.875051, 46.892918],
              [-87.88792, 46.901451],
              [-87.90007, 46.909508],
              [-87.900339, 46.909686],
              [-87.900695, 46.909682],
              [-87.908791, 46.90959],
              [-87.910624, 46.909569],
              [-87.911474, 46.909559],
              [-87.914489, 46.909525],
              [-87.915943, 46.909508],
              [-87.954687, 46.909066],
              [-87.955745, 46.909054],
              [-87.956, 46.909051],
              [-87.957115, 46.908936],
              [-87.958255, 46.908819],
              [-87.97549, 46.907048],
              [-87.982258, 46.906353],
              [-87.98334, 46.906242],
              [-87.986113, 46.905957],
              [-87.98629, 46.905967],
              [-88.003693, 46.906948],
              [-88.004298, 46.906982],
              [-88.029373, 46.908684],
              [-88.030053, 46.90873],
              [-88.032408, 46.90889],
              [-88.032911, 46.909038],
              [-88.044551, 46.912473],
              [-88.063614, 46.918097],
              [-88.065192, 46.918563],
              [-88.074736, 46.919647],
              [-88.080087, 46.920255],
              [-88.08187, 46.920458],
              [-88.082263, 46.920392],
              [-88.08377, 46.92014],
              [-88.083937, 46.920112],
              [-88.097609, 46.917827],
              [-88.098858, 46.917618],
              [-88.0989, 46.917611],
              [-88.099227, 46.917556],
              [-88.100133, 46.917405],
              [-88.101315, 46.917207],
              [-88.101457, 46.917166],
              [-88.102362, 46.916906],
              [-88.102816, 46.916775],
              [-88.105195, 46.916091],
              [-88.106377, 46.915751],
              [-88.122862, 46.911009],
              [-88.124573, 46.910517],
              [-88.124935, 46.910413],
              [-88.126378, 46.909998],
              [-88.126927, 46.90984],
              [-88.130288, 46.909369],
              [-88.160704, 46.90511],
              [-88.161913, 46.904941],
              [-88.175197, 46.90458],
              [-88.181908, 46.912431],
              [-88.18295, 46.91365],
              [-88.187522, 46.918999],
              [-88.185964, 46.920025],
              [-88.177921, 46.92532],
              [-88.176156, 46.926483],
              [-88.175568, 46.92687],
              [-88.171317, 46.929669],
              [-88.170905, 46.92994],
              [-88.167989, 46.931861],
              [-88.156359, 46.939518],
              [-88.150114, 46.94363],
              [-88.13521, 46.959689],
              [-88.132876, 46.962204],
              [-88.132957, 46.962237],
              [-88.14175, 46.965865],
              [-88.142057, 46.965992],
              [-88.142339, 46.966108],
              [-88.142528, 46.966186],
              [-88.142807, 46.966302],
              [-88.142893, 46.966337],
              [-88.143614, 46.966635],
              [-88.143688, 46.966665],
              [-88.145561, 46.966409],
              [-88.155374, 46.965069],
              [-88.15543, 46.96504],
              [-88.156273, 46.964598],
              [-88.160086, 46.962599],
              [-88.160571, 46.962345],
              [-88.162437, 46.961366],
              [-88.162833, 46.961158],
              [-88.162856, 46.961146],
              [-88.164059, 46.960516],
              [-88.164704, 46.960178],
              [-88.167227, 46.958855],
              [-88.167373, 46.9588],
              [-88.176758, 46.955245],
              [-88.194361, 46.948578],
              [-88.232969, 46.933955],
              [-88.233334, 46.933817],
              [-88.235702, 46.93292],
              [-88.2358, 46.932883],
              [-88.238324, 46.931927],
              [-88.240846, 46.930972],
              [-88.240926, 46.930942],
              [-88.24134, 46.930785],
              [-88.241858, 46.930589],
              [-88.243175, 46.93009],
              [-88.244437, 46.929612],
              [-88.246872, 46.927611],
              [-88.246953, 46.927545],
              [-88.250141, 46.924926],
              [-88.258072, 46.918409],
              [-88.261593, 46.915516],
              [-88.272478, 46.910595],
              [-88.273929, 46.909939],
              [-88.27473, 46.909577],
              [-88.276915, 46.908589],
              [-88.281244, 46.906632],
              [-88.282066, 46.906154],
              [-88.282087, 46.906142],
              [-88.286473, 46.903592],
              [-88.288767, 46.902259],
              [-88.289298, 46.90195],
              [-88.296476, 46.897778],
              [-88.299515, 46.896012],
              [-88.305045, 46.892797],
              [-88.307261, 46.891509],
              [-88.307978, 46.891092],
              [-88.308786, 46.890622],
              [-88.31029, 46.889748],
              [-88.310714, 46.889415],
              [-88.333092, 46.871835],
              [-88.333168, 46.871775],
              [-88.334647, 46.870613],
              [-88.34743, 46.860571],
              [-88.35173, 46.857193],
              [-88.35194, 46.857028],
              [-88.352145, 46.857009],
              [-88.36026, 46.856258],
              [-88.360868, 46.856202],
              [-88.361936, 46.856352],
              [-88.362502, 46.856432],
              [-88.368767, 46.857313],
              [-88.372501, 46.858192],
              [-88.375577, 46.857313],
              [-88.378432, 46.854897],
              [-88.38019, 46.852481],
              [-88.380849, 46.850064],
              [-88.381727, 46.847868],
              [-88.381947, 46.84611],
              [-88.382204, 46.844477],
              [-88.38141, 46.838466],
              [-88.415225, 46.811715],
              [-88.433835, 46.793502],
              [-88.438427, 46.786714],
              [-88.462349, 46.786711],
              [-88.473342, 46.806226],
              [-88.482579, 46.826197],
              [-88.483748, 46.831727],
              [-88.477935, 46.85056],
              [-88.477845, 46.852091],
              [-88.477681, 46.854902],
              [-88.47762, 46.855937],
              [-88.476918, 46.867946],
              [-88.476098, 46.881957],
              [-88.475859, 46.886042],
              [-88.474217, 46.889034],
              [-88.457776, 46.918999],
              [-88.455404, 46.923321],
              [-88.455117, 46.924305],
              [-88.454781, 46.925458],
              [-88.454353, 46.926928],
              [-88.454333, 46.926996],
              [-88.452354, 46.933787],
              [-88.452129, 46.934557],
              [-88.450823, 46.939038],
              [-88.44857, 46.946769],
              [-88.443901, 46.972251],
              [-88.416364, 46.977071],
              [-88.41616, 46.977106],
              [-88.411145, 46.977984],
              [-88.41089, 46.97819],
              [-88.410157, 46.978782],
              [-88.406229, 46.981955],
              [-88.405352, 46.982663],
              [-88.404498, 46.983353],
              [-88.389698, 46.999937],
              [-88.388564, 47.001208],
              [-88.387612, 47.002275],
              [-88.386538, 47.003477],
              [-88.386153, 47.003909],
              [-88.385606, 47.004522],
              [-88.385507, 47.004588],
              [-88.385338, 47.0047],
              [-88.384442, 47.005296],
              [-88.379268, 47.008736],
              [-88.374238, 47.012081],
              [-88.373966, 47.012262],
              [-88.368358, 47.018408],
              [-88.368062, 47.018733],
              [-88.367624, 47.019213],
              [-88.359139, 47.039536],
              [-88.359054, 47.039739],
              [-88.358873, 47.040389],
              [-88.35855, 47.041546],
              [-88.358201, 47.042798],
              [-88.357661, 47.044739],
              [-88.357556, 47.045113],
              [-88.356884, 47.047524],
              [-88.354011, 47.057835],
              [-88.353952, 47.058047],
              [-88.353191, 47.069063],
              [-88.349952, 47.076377],
              [-88.347197, 47.078921],
              [-88.346709, 47.079372],
              [-88.346501, 47.079407],
              [-88.344658, 47.079718],
              [-88.340052, 47.080494],
              [-88.337406, 47.081617],
              [-88.333076, 47.083455],
              [-88.315051, 47.091108],
              [-88.313033, 47.091964],
              [-88.297772, 47.098443],
              [-88.297625, 47.098505],
              [-88.297547, 47.098639],
              [-88.296645, 47.100199],
              [-88.294082, 47.10463],
              [-88.291688, 47.10877],
              [-88.291217, 47.109585],
              [-88.290708, 47.110465],
              [-88.290598, 47.110655],
              [-88.289534, 47.112494],
              [-88.289005, 47.11341],
              [-88.28893, 47.113539],
              [-88.28869, 47.113954],
              [-88.288347, 47.114547],
              [-88.288309, 47.114738],
              [-88.287981, 47.116376],
              [-88.287901, 47.116779],
              [-88.287822, 47.117174],
              [-88.287313, 47.119721],
              [-88.287173, 47.12042],
              [-88.28726, 47.121041],
              [-88.287792, 47.124822],
              [-88.28787, 47.125374],
              [-88.288481, 47.125823],
              [-88.28865, 47.125947],
              [-88.289543, 47.126604],
              [-88.289058, 47.129581],
              [-88.28904, 47.129689],
              [-88.288994, 47.129743],
              [-88.281743, 47.138163],
              [-88.281701, 47.138212],
              [-88.281652, 47.138239],
              [-88.272017, 47.143511],
              [-88.263292, 47.145115],
              [-88.262972, 47.145174],
              [-88.262537, 47.145087],
              [-88.255676, 47.143715],
              [-88.255303, 47.14364],
              [-88.254267, 47.142853],
              [-88.254205, 47.142807],
              [-88.253834, 47.142524],
              [-88.250814, 47.140231],
              [-88.250785, 47.140209],
              [-88.250645, 47.139752],
              [-88.249838, 47.137106],
              [-88.249571, 47.136231],
              [-88.247628, 47.135981],
              [-88.239895, 47.139436],
              [-88.232164, 47.145975],
              [-88.231797, 47.149609],
              [-88.234295, 47.149446],
              [-88.236566, 47.149297],
              [-88.236721, 47.149287],
              [-88.236961, 47.149449],
              [-88.238408, 47.150423],
              [-88.23947, 47.151137],
              [-88.239487, 47.151176],
              [-88.242062, 47.157059],
              [-88.24266, 47.158426],
              [-88.242561, 47.160902],
              [-88.242157, 47.170988],
              [-88.242142, 47.171358],
              [-88.242109, 47.172184],
              [-88.242006, 47.174767],
              [-88.240295, 47.179609],
              [-88.237024, 47.188862],
              [-88.236892, 47.189236],
              [-88.235041, 47.191532],
              [-88.229132, 47.198862],
              [-88.228987, 47.199042],
              [-88.227552, 47.199938],
              [-88.212361, 47.209423],
              [-88.204849, 47.210498],
              [-88.194218, 47.209242],
              [-88.163059, 47.216278],
              [-88.131943, 47.239554],
              [-88.117456, 47.255174],
              [-88.108833, 47.259131],
              [-88.096851, 47.261351],
              [-88.071476, 47.286768],
              [-88.06009, 47.295796],
              [-88.054849, 47.29824],
              [-88.016478, 47.306275],
              [-87.989133, 47.322633],
              [-87.968604, 47.332582],
              [-87.958386, 47.334435],
              [-87.946352, 47.334254],
              [-87.94336, 47.335899],
              [-87.93825, 47.342299],
              [-87.938787, 47.346777],
              [-87.947397, 47.355461],
              [-87.954796, 47.356809],
              [-87.962567, 47.362543],
              [-87.965598, 47.368645],
              [-87.965063, 47.37443],
              [-87.957058, 47.38726],
              [-87.941613, 47.390073],
              [-87.882245, 47.395588],
              [-87.8567, 47.395387],
              [-87.848252, 47.394864],
              [-87.834822, 47.390478],
              [-87.827115, 47.38616],
              [-87.815371, 47.38479],
              [-87.800294, 47.392148],
              [-87.765019, 47.398652],
              [-87.759057, 47.403013],
              [-87.75138, 47.405066],
              [-87.742417, 47.405823],
              [-87.721274, 47.401032],
              [-87.712421, 47.4014],
              [-87.710471, 47.4062],
              [-87.715942, 47.439816],
              [-87.730804, 47.449112],
              [-87.756739, 47.460717],
              [-87.801184, 47.473301],
              [-87.816958, 47.471998],
              [-87.898036, 47.474872],
              [-87.902416, 47.477045],
              [-87.920259, 47.478169],
              [-87.920321, 47.478173],
              [-87.921103, 47.478222],
              [-87.922224, 47.478293],
              [-87.927548, 47.478629],
              [-87.928137, 47.478666],
              [-87.928726, 47.478703],
              [-87.929269, 47.478737],
              [-87.929672, 47.478743],
              [-87.948287, 47.478999],
              [-87.951912, 47.479048],
              [-87.954458, 47.479083],
              [-87.954672, 47.479086],
              [-87.955374, 47.479096],
              [-87.95669, 47.479114],
              [-87.957582, 47.479126],
              [-87.958042, 47.479133],
              [-87.959166, 47.479148],
              [-87.962546, 47.479195],
              [-87.978121, 47.479409],
              [-87.978934, 47.47942],
              [-87.98174, 47.479264],
              [-87.982227, 47.479236],
              [-88.009704, 47.477704],
              [-88.010415, 47.477665],
              [-88.01083, 47.477642],
              [-88.014516, 47.477436],
              [-88.015502, 47.477381],
              [-88.017268, 47.477283],
              [-88.021555, 47.477044],
              [-88.027085, 47.476735],
              [-88.031089, 47.476512],
              [-88.03113, 47.47651],
              [-88.03659, 47.476205],
              [-88.040242, 47.476002],
              [-88.040291, 47.475999],
              [-88.046665, 47.475159],
              [-88.047857, 47.475002],
              [-88.048077, 47.474973],
              [-88.048226, 47.470008],
              [-88.049326, 47.469785],
              [-88.067043, 47.468454],
              [-88.07358, 47.467963],
              [-88.073982, 47.467933],
              [-88.074681, 47.46788],
              [-88.076388, 47.467752],
              [-88.079183, 47.468133],
              [-88.080271, 47.468282],
              [-88.080796, 47.468353],
              [-88.080916, 47.46837],
              [-88.081277, 47.468419],
              [-88.081892, 47.468503],
              [-88.08358, 47.468733],
              [-88.08485, 47.468906],
              [-88.085252, 47.468961],
              [-88.089966, 47.468418],
              [-88.090299, 47.46838],
              [-88.12848, 47.46398],
              [-88.129274, 47.463889],
              [-88.137698, 47.462918],
              [-88.139651, 47.462693],
              [-88.140537, 47.462482],
              [-88.143573, 47.461759],
              [-88.150437, 47.460125],
              [-88.150571, 47.460093],
              [-88.15076, 47.460078],
              [-88.167009, 47.458812],
              [-88.167703, 47.458758],
              [-88.169383, 47.458627],
              [-88.179998, 47.457799],
              [-88.181763, 47.457661],
              [-88.18182, 47.457657],
              [-88.206036, 47.451658],
              [-88.207239, 47.45136],
              [-88.207853, 47.451208],
              [-88.213059, 47.449918],
              [-88.213141, 47.449898],
              [-88.217662, 47.448778],
              [-88.217822, 47.448738],
              [-88.216977, 47.445493],
              [-88.218424, 47.441585],
              [-88.225797, 47.436279],
              [-88.227446, 47.435093],
              [-88.228645, 47.434568],
              [-88.238091, 47.430437],
              [-88.239161, 47.429969],
              [-88.23944, 47.429923],
              [-88.274709, 47.424118],
              [-88.28406, 47.422579],
              [-88.285195, 47.422392],
              [-88.285635, 47.422146],
              [-88.301214, 47.413451],
              [-88.303447, 47.412204],
              [-88.324083, 47.403542],
              [-88.360313, 47.392951],
              [-88.378917, 47.387513],
              [-88.389459, 47.384431],
              [-88.39144, 47.383533],
              [-88.394239, 47.382264],
              [-88.399726, 47.379777],
              [-88.400224, 47.379551],
              [-88.418673, 47.371188],
              [-88.418841, 47.371058],
              [-88.431446, 47.361343],
              [-88.431753, 47.361106],
              [-88.432162, 47.360791],
              [-88.458952, 47.340142],
              [-88.459262, 47.339903],
              [-88.465089, 47.333542],
              [-88.465888, 47.33267],
              [-88.470484, 47.327653],
              [-88.471103, 47.326442],
              [-88.477733, 47.31346],
              [-88.478951, 47.312405],
              [-88.487116, 47.305335],
              [-88.498756, 47.295256],
              [-88.50078, 47.293503],
              [-88.50116, 47.293256],
              [-88.504898, 47.290831],
              [-88.512421, 47.285948],
              [-88.514786, 47.284414],
              [-88.515276, 47.284096],
              [-88.518091, 47.282269],
              [-88.526764, 47.276641],
              [-88.57172, 47.247466],
              [-88.573301, 47.246441],
              [-88.573326, 47.246424],
              [-88.573997, 47.245989],
              [-88.584652, 47.242447],
              [-88.584912, 47.242361],
              [-88.585196, 47.242321],
              [-88.598622, 47.240454],
              [-88.608087, 47.239137],
              [-88.60983, 47.238894],
              [-88.609867, 47.238877],
              [-88.618613, 47.234715],
              [-88.623302, 47.232484],
              [-88.623579, 47.232352],
              [-88.625119, 47.23184],
              [-88.633915, 47.228915],
              [-88.640323, 47.226784],
              [-88.642047, 47.226659],
              [-88.648001, 47.226229],
              [-88.656359, 47.225624],
              [-88.657496, 47.225164],
              [-88.666614, 47.221475],
              [-88.672395, 47.219137],
              [-88.673172, 47.218729],
              [-88.673771, 47.218415],
              [-88.674917, 47.217814],
              [-88.676624, 47.216918],
              [-88.698282, 47.205554],
              [-88.698919, 47.20522],
              [-88.69966, 47.204831],
              [-88.700047, 47.204586],
              [-88.702029, 47.203333],
              [-88.702086, 47.203296],
              [-88.712138, 47.196937],
              [-88.728327, 47.186695],
              [-88.728541, 47.18656],
              [-88.729688, 47.185834],
              [-88.74665, 47.171118],
              [-88.746724, 47.171055],
              [-88.750496, 47.167782],
              [-88.764351, 47.155762],
              [-88.778022, 47.150465],
              [-88.779188, 47.15051],
              [-88.783821, 47.150691],
              [-88.784612, 47.150722],
              [-88.789813, 47.150925],
              [-88.798779, 47.147511],
              [-88.813748, 47.141813],
              [-88.814834, 47.141399],
              [-88.815355, 47.140987],
              [-88.815403, 47.14095],
              [-88.816553, 47.140042],
              [-88.816684, 47.139938],
              [-88.825475, 47.132994],
              [-88.825619, 47.132881],
              [-88.826028, 47.132558],
              [-88.848176, 47.115065],
              [-88.854656, 47.114343],
              [-88.855126, 47.11429],
              [-88.855372, 47.114263],
              [-88.872087, 47.107487],
              [-88.885361, 47.102107],
              [-88.885418, 47.102084],
              [-88.88914, 47.100575],
              [-88.890122, 47.099603],
              [-88.890422, 47.099306],
              [-88.890708, 47.099024],
              [-88.899857, 47.089969],
              [-88.903706, 47.086161],
              [-88.903933, 47.085579],
              [-88.908288, 47.074396],
              [-88.914189, 47.059246],
              [-88.914976, 47.05794],
              [-88.923458, 47.043872],
              [-88.924492, 47.042156],
              [-88.925586, 47.040923],
              [-88.933329, 47.0322],
              [-88.944045, 47.020129],
              [-88.957276, 47.010111],
              [-88.959409, 47.008496],
              [-88.960337, 47.008053],
              [-88.972802, 47.002096],
              [-88.978433, 47.000196],
              [-88.978813, 47.000068],
              [-88.982483, 46.99883],
              [-88.987197, 46.997239],
              [-88.99172, 46.996463],
              [-88.992399, 46.996347],
              [-88.998417, 46.995314],
              [-88.998907, 46.99531],
              [-89.022994, 46.99512],
              [-89.027648, 46.999839],
              [-89.02893, 47.00114],
              [-89.038116, 46.999643],
              [-89.03949, 46.999419],
              [-89.048164, 46.995416],
              [-89.058591, 46.990604],
              [-89.063103, 46.988522],
              [-89.086742, 46.985298],
              [-89.106277, 46.98648],
              [-89.113158, 46.989356],
              [-89.115903, 46.991933],
              [-89.118106, 46.994002],
              [-89.118339, 46.99422],
              [-89.124799, 46.993209],
              [-89.128101, 46.992692],
              [-89.128698, 46.992599],
              [-89.142282, 46.985033],
              [-89.142425, 46.984954],
              [-89.142595, 46.984859],
              [-89.168244, 46.965536],
              [-89.168493, 46.965279],
              [-89.18373, 46.949529],
              [-89.199648, 46.933075],
              [-89.201511, 46.931149],
              [-89.202811, 46.930253],
              [-89.226244, 46.914105],
              [-89.227914, 46.912954],
              [-89.228362, 46.912751],
              [-89.249143, 46.903326],
              [-89.249938, 46.903029],
              [-89.278612, 46.89231],
              [-89.28578, 46.88963],
              [-89.304623, 46.882586],
              [-89.317396, 46.877811],
              [-89.33613, 46.870807],
              [-89.370788, 46.857851],
              [-89.372032, 46.857386],
              [-89.395386, 46.850127],
              [-89.401123, 46.848344],
              [-89.413413, 46.844524],
              [-89.415154, 46.843983],
              [-89.434016, 46.840131],
              [-89.437047, 46.839512],
              [-89.440145, 46.839319],
              [-89.445313, 46.838996],
              [-89.445969, 46.838955],
              [-89.446583, 46.838917],
              [-89.448445, 46.838801],
              [-89.448454, 46.8388],
              [-89.453185, 46.838505],
              [-89.469446, 46.83749],
              [-89.469651, 46.837477],
              [-89.470547, 46.837421],
              [-89.470619, 46.837416],
              [-89.470915, 46.837398],
              [-89.47154, 46.837359],
              [-89.471849, 46.837376],
              [-89.475333, 46.837569],
              [-89.485166, 46.838112],
              [-89.491079, 46.838438],
              [-89.491252, 46.838448],
              [-89.491307, 46.83847],
              [-89.494019, 46.83957],
              [-89.49776, 46.841086],
              [-89.49908, 46.841621],
              [-89.499248, 46.841623],
              [-89.500227, 46.841638],
              [-89.513938, 46.841835],
              [-89.515665, 46.841362],
              [-89.516895, 46.841025],
              [-89.525656, 46.838625],
              [-89.534331, 46.836248],
              [-89.535683, 46.835878],
              [-89.538927, 46.835496],
              [-89.540709, 46.835286],
              [-89.542408, 46.835086],
              [-89.564509, 46.832483],
              [-89.569808, 46.831859],
              [-89.570326, 46.831723],
              [-89.572423, 46.831174],
              [-89.578217, 46.829657],
              [-89.598527, 46.824338],
              [-89.619329, 46.81889],
              [-89.634938, 46.819488],
              [-89.637309, 46.821384],
              [-89.642255, 46.82534],
              [-89.64344, 46.825709],
              [-89.646854, 46.826771],
              [-89.651795, 46.828309],
              [-89.659681, 46.830762],
              [-89.660625, 46.831056],
              [-89.673375, 46.833229],
              [-89.676878, 46.833019],
              [-89.677771, 46.832965],
              [-89.678469, 46.832923],
              [-89.708084, 46.831145],
              [-89.708303, 46.831132],
              [-89.708873, 46.831098],
              [-89.710062, 46.831026],
              [-89.713354, 46.830829],
              [-89.717848, 46.830559],
              [-89.720277, 46.830413],
              [-89.724471, 46.829701],
              [-89.757585, 46.824082],
              [-89.78708, 46.819077],
              [-89.788353, 46.818861],
              [-89.790663, 46.818469],
              [-89.828129, 46.805389],
              [-89.830093, 46.804703],
              [-89.830863, 46.804434],
              [-89.831956, 46.804053],
              [-89.841453, 46.799308],
              [-89.844691, 46.79769],
              [-89.846962, 46.796556],
              [-89.848652, 46.795711],
              [-89.850979, 46.793974],
              [-89.851966, 46.793237],
              [-89.862544, 46.785341],
              [-89.875069, 46.775991],
              [-89.888687, 46.765826],
              [-89.892355, 46.763088],
              [-89.907516, 46.74987],
              [-89.918466, 46.740324],
              [-89.957101, 46.716929],
              [-89.973803, 46.710322],
              [-89.985817, 46.70319],
              [-89.996034, 46.693225],
              [-90.028392, 46.67439],
              [-90.04542, 46.668272],
              [-90.100695, 46.655132],
              [-90.164026, 46.645515],
              [-90.237609, 46.624485],
              [-90.250176, 46.621776],
              [-90.251669, 46.621454],
              [-90.265291, 46.618517],
              [-90.265294, 46.618516],
              [-90.278287, 46.613555],
              [-90.279723, 46.613007],
              [-90.28315, 46.611698],
              [-90.284189, 46.611302],
              [-90.28455, 46.611164],
              [-90.29546, 46.606998],
              [-90.306609, 46.602741],
              [-90.327604, 46.607739],
              [-90.327626, 46.607744],
              [-90.347801, 46.600842],
              [-90.348407, 46.600635],
              [-90.353284, 46.598219],
              [-90.355341, 46.5972],
              [-90.371717, 46.589088],
              [-90.394936, 46.577586],
              [-90.396772, 46.576677],
              [-90.39731, 46.57641],
              [-90.39735, 46.576391],
              [-90.398478, 46.575832],
              [-90.417943, 46.56619],
              [-90.418136, 46.566094],
              [-90.433367, 46.562492],
              [-90.434812, 46.56215],
              [-90.436314, 46.561795],
              [-90.436512, 46.561748],
              [-90.437532, 46.561507],
              [-90.437596, 46.561492],
              [-90.438174, 46.561695],
              [-90.440085, 46.562365],
              [-90.472483, 46.57373],
              [-90.47376, 46.574178],
              [-90.476046, 46.575276],
              [-90.476315, 46.575405],
              [-90.47648, 46.575484],
              [-90.478469, 46.576439],
              [-90.478826, 46.57661],
              [-90.497359, 46.585509],
              [-90.505909, 46.589614],
              [-90.51851, 46.587885],
              [-90.519002, 46.587817],
              [-90.519105, 46.587803],
              [-90.522674, 46.587313],
              [-90.525334, 46.586949],
              [-90.525498, 46.586926],
              [-90.525788, 46.58679],
              [-90.527776, 46.585858],
              [-90.537829, 46.581143],
              [-90.537962, 46.581081],
              [-90.538346, 46.581182],
              [-90.549596, 46.584138],
              [-90.556224, 46.58588],
              [-90.558141, 46.586384],
              [-90.561126, 46.587816],
              [-90.561966, 46.588218],
              [-90.563668, 46.589034],
              [-90.579422, 46.596589],
              [-90.580191, 46.596958],
              [-90.581408, 46.597541],
              [-90.586249, 46.599863],
              [-90.590712, 46.602433],
              [-90.590811, 46.60249],
              [-90.591894, 46.603114],
              [-90.595583, 46.605238],
              [-90.59585, 46.605392],
              [-90.599375, 46.607422],
              [-90.599602, 46.607552],
              [-90.606177, 46.611339],
              [-90.60672, 46.611651],
              [-90.607649, 46.612186],
              [-90.627885, 46.623839],
              [-90.650949, 46.637837],
              [-90.654497, 46.63999],
              [-90.694721, 46.664402],
              [-90.705375, 46.671381],
              [-90.724924, 46.684186],
              [-90.73726, 46.692267],
              [-90.739549, 46.689981],
              [-90.739565, 46.689943],
              [-90.748026, 46.669968],
              [-90.74809, 46.669817],
              [-90.756495, 46.664591],
              [-90.756312, 46.66182],
              [-90.755289, 46.646323],
              [-90.755287, 46.646289],
              [-90.755381, 46.646225],
              [-90.768381, 46.637362],
              [-90.770192, 46.636127],
              [-90.772455, 46.635097],
              [-90.792583, 46.625938],
              [-90.794775, 46.624941],
              [-90.829031, 46.616066],
              [-90.82907, 46.616051],
              [-90.830011, 46.615702],
              [-90.831226, 46.61525],
              [-90.831868, 46.615012],
              [-90.834259, 46.614123],
              [-90.837306, 46.612991],
              [-90.841708, 46.611355],
              [-90.842058, 46.611225],
              [-90.843189, 46.610805],
              [-90.843225, 46.610791],
              [-90.849684, 46.608391],
              [-90.851889, 46.607571],
              [-90.852153, 46.607473],
              [-90.85338, 46.607017],
              [-90.854575, 46.606573],
              [-90.85609, 46.60601],
              [-90.856244, 46.605953],
              [-90.856811, 46.605742],
              [-90.858725, 46.605031],
              [-90.864284, 46.602965],
              [-90.86712, 46.601911],
              [-90.873154, 46.601223],
              [-90.885007, 46.594752],
              [-90.885103, 46.5947],
              [-90.886197, 46.594102],
              [-90.891944, 46.590964],
              [-90.901725, 46.585624],
              [-90.901918, 46.585519],
              [-90.905572, 46.583524],
              [-90.906058, 46.58343],
              [-90.909815, 46.582703],
              [-90.916982, 46.583014],
              [-90.918266, 46.58307],
              [-90.918352, 46.583089],
              [-90.918414, 46.583103],
              [-90.91992, 46.583444],
              [-90.920132, 46.583492],
              [-90.920411, 46.583555],
              [-90.921483, 46.583797],
              [-90.923438, 46.584239],
              [-90.92356, 46.584267],
              [-90.927387, 46.585132],
              [-90.941102, 46.588232],
              [-90.941374, 46.588293],
              [-90.94193, 46.588419],
              [-90.942101, 46.588573],
              [-90.947159, 46.593138],
              [-90.947287, 46.593253],
              [-90.947572, 46.59351],
              [-90.951476, 46.597033],
              [-90.951528, 46.599827],
              [-90.951543, 46.600621],
              [-90.951418, 46.600774],
              [-90.950544, 46.601845],
              [-90.950215, 46.602248],
              [-90.949621, 46.602975],
              [-90.949532, 46.603019],
              [-90.93868, 46.608322],
              [-90.938617, 46.608398],
              [-90.93831, 46.608768],
              [-90.933208, 46.614913],
              [-90.93212, 46.616223],
              [-90.931623, 46.616822],
              [-90.926745, 46.622698],
              [-90.924489, 46.625415],
              [-90.924487, 46.625417],
              [-90.920936, 46.631584],
              [-90.920936, 46.631606],
              [-90.920867, 46.635515],
              [-90.92085, 46.636492],
              [-90.920835, 46.637351],
              [-90.920813, 46.637432],
              [-90.915367, 46.657615],
              [-90.915152, 46.65841],
              [-90.914619, 46.659054],
              [-90.911353, 46.662996],
              [-90.911281, 46.663083],
              [-90.909688, 46.66354],
              [-90.909176, 46.663687],
              [-90.905567, 46.664722],
              [-90.905273, 46.664807],
              [-90.896529, 46.667315],
              [-90.885943, 46.670353],
              [-90.885869, 46.670374],
              [-90.870956, 46.678945],
              [-90.870739, 46.67907],
              [-90.870532, 46.679189],
              [-90.870079, 46.679449],
              [-90.868468, 46.680375],
              [-90.868376, 46.680457],
              [-90.867981, 46.68081],
              [-90.867823, 46.680952],
              [-90.867423, 46.681309],
              [-90.865745, 46.682808],
              [-90.865494, 46.683033],
              [-90.854692, 46.692686],
              [-90.854539, 46.692822],
              [-90.853927, 46.693369],
              [-90.853829, 46.693457],
              [-90.853807, 46.693579],
              [-90.853644, 46.694464],
              [-90.852731, 46.699437],
              [-90.852704, 46.699582],
              [-90.852916, 46.699866],
              [-90.853225, 46.70028],
              [-90.859601, 46.708826],
              [-90.859797, 46.709088],
              [-90.860897, 46.710562],
              [-90.861353, 46.711173],
              [-90.863864, 46.714539],
              [-90.868024, 46.720115],
              [-90.868273, 46.720448],
              [-90.868531, 46.720794],
              [-90.868607, 46.720896],
              [-90.869461, 46.722039],
              [-90.870396, 46.723293],
              [-90.870577, 46.723623],
              [-90.871612, 46.725509],
              [-90.875829, 46.733195],
              [-90.876039, 46.733577],
              [-90.876334, 46.734115],
              [-90.876426, 46.734284],
              [-90.876538, 46.734487],
              [-90.878343, 46.737777],
              [-90.87881, 46.738629],
              [-90.881622, 46.743753],
              [-90.882099, 46.744622],
              [-90.883396, 46.746987],
              [-90.883443, 46.747255],
              [-90.885021, 46.756341],
              [-90.875925, 46.760321],
              [-90.874598, 46.760902],
              [-90.866694, 46.764361],
              [-90.866586, 46.764408],
              [-90.866337, 46.764626],
              [-90.862333, 46.768135],
              [-90.86088, 46.771079],
              [-90.859445, 46.773985],
              [-90.859724, 46.774433],
              [-90.863542, 46.780565],
              [-90.859999, 46.784769],
              [-90.856677, 46.788712],
              [-90.856531, 46.788885],
              [-90.856317, 46.788894],
              [-90.855746, 46.788918],
              [-90.855472, 46.788929],
              [-90.854916, 46.788952],
              [-90.847214, 46.789274],
              [-90.835607, 46.789759],
              [-90.835319, 46.790051],
              [-90.835028, 46.790346],
              [-90.835008, 46.790366],
              [-90.831645, 46.793777],
              [-90.830094, 46.795349],
              [-90.829933, 46.795513],
              [-90.829048, 46.79641],
              [-90.828057, 46.797415],
              [-90.82735, 46.799345],
              [-90.826337, 46.80211],
              [-90.825696, 46.803858],
              [-90.821967, 46.806545],
              [-90.80927, 46.815695],
              [-90.80137, 46.821389],
              [-90.801041, 46.821626],
              [-90.798936, 46.823143],
              [-90.798545, 46.823922],
              [-90.797404, 46.8262],
              [-90.796437, 46.828129],
              [-90.795957, 46.829087],
              [-90.795693, 46.829614],
              [-90.793713, 46.833566],
              [-90.792034, 46.836916],
              [-90.78804, 46.844886],
              [-90.781011, 46.858911],
              [-90.780972, 46.858989],
              [-90.77024, 46.876184],
              [-90.77017, 46.876296],
              [-90.761567, 46.88317],
              [-90.761295, 46.883238],
              [-90.754753, 46.884875],
              [-90.754734, 46.88488],
              [-90.754692, 46.884915],
              [-90.751151, 46.887863],
              [-90.751031, 46.887963],
              [-90.750952, 46.890293],
              [-90.750889, 46.892136],
              [-90.750871, 46.892643],
              [-90.750858, 46.893035],
              [-90.751048, 46.893305],
              [-90.751329, 46.893702],
              [-90.752725, 46.89568],
              [-90.754388, 46.898037],
              [-90.754552, 46.89827],
              [-90.75563, 46.899247],
              [-90.759364, 46.902634],
              [-90.760095, 46.903296],
              [-90.785606, 46.926431],
              [-90.78601, 46.926672],
              [-90.786502, 46.926964],
              [-90.786595, 46.927019],
              [-90.805028, 46.937987],
              [-90.833091, 46.954686],
              [-90.837617, 46.957379],
              [-90.837716, 46.957438],
              [-90.837973, 46.957506],
              [-90.838814, 46.957728],
              [-90.855165, 46.962045],
              [-90.855874, 46.962232],
              [-90.871126, 46.961129],
              [-90.875635, 46.959515],
              [-90.875995, 46.959386],
              [-90.876006, 46.959382],
              [-90.876211, 46.959309],
              [-90.876213, 46.959308],
              [-90.876544, 46.959189],
              [-90.876778, 46.959106],
              [-90.877092, 46.958993],
              [-90.877165, 46.958967],
              [-90.877324, 46.95891],
              [-90.879621, 46.958088],
              [-90.880358, 46.957661],
              [-90.908598, 46.941305],
              [-90.908654, 46.941221],
              [-90.913838, 46.9334],
              [-90.914044, 46.933346],
              [-90.921382, 46.931434],
              [-90.921811, 46.931322],
              [-90.92204, 46.931372],
              [-90.94056, 46.935394],
              [-90.953685, 46.938244],
              [-90.953865, 46.938283],
              [-90.954537, 46.938429],
              [-90.954612, 46.938468],
              [-90.964072, 46.943369],
              [-90.964865, 46.94378],
              [-90.968419, 46.94391],
              [-90.973755, 46.941304],
              [-90.980235, 46.931937],
              [-90.983192, 46.927662],
              [-90.984617, 46.925602],
              [-90.985815, 46.924689],
              [-90.987013, 46.923776],
              [-90.995149, 46.917577],
              [-90.996825, 46.916851],
              [-90.997943, 46.916367],
              [-90.998848, 46.915975],
              [-91.004752, 46.916187],
              [-91.004892, 46.916192],
              [-91.005199, 46.916203],
              [-91.005872, 46.915976],
              [-91.007997, 46.915259],
              [-91.010689, 46.914352],
              [-91.016184, 46.912499],
              [-91.016237, 46.912481],
              [-91.018024, 46.911879],
              [-91.018045, 46.911872],
              [-91.019141, 46.911502],
              [-91.01967, 46.911211],
              [-91.021538, 46.910185],
              [-91.023976, 46.908845],
              [-91.024009, 46.908827],
              [-91.030583, 46.905215],
              [-91.032508, 46.904158],
              [-91.033447, 46.903642],
              [-91.034518, 46.903053],
              [-91.035936, 46.896679],
              [-91.036193, 46.895523],
              [-91.036622, 46.893594],
              [-91.03989, 46.88923],
              [-91.042992, 46.887358],
              [-91.04922, 46.8836],
              [-91.049232, 46.883593],
              [-91.050153, 46.883037],
              [-91.052991, 46.881325],
              [-91.056258, 46.880678],
              [-91.066193, 46.87871],
              [-91.06822, 46.878309],
              [-91.069331, 46.878772],
              [-91.072584, 46.880126],
              [-91.080951, 46.883609],
              [-91.085077, 46.88322],
              [-91.088721, 46.882877],
              [-91.090916, 46.88267],
              [-91.093714, 46.879882],
              [-91.094096, 46.877423],
              [-91.094498, 46.874837],
              [-91.09462, 46.87405],
              [-91.094724, 46.873383],
              [-91.094828, 46.872714],
              [-91.095058, 46.871234],
              [-91.096028, 46.864987],
              [-91.096342, 46.862965],
              [-91.096565, 46.86153],
              [-91.09755, 46.861098],
              [-91.098125, 46.860847],
              [-91.098346, 46.86075],
              [-91.09878, 46.86056],
              [-91.10549, 46.85762],
              [-91.107323, 46.857469],
              [-91.11854, 46.856548],
              [-91.123109, 46.856173],
              [-91.12353, 46.856273],
              [-91.134732, 46.858935],
              [-91.134948, 46.858986],
              [-91.134977, 46.859023],
              [-91.136512, 46.860975],
              [-91.134882, 46.865784],
              [-91.134724, 46.86625],
              [-91.134184, 46.867843],
              [-91.133674, 46.869348],
              [-91.133337, 46.870341],
              [-91.133772, 46.871043],
              [-91.134668, 46.87249],
              [-91.139758, 46.873148],
              [-91.140165, 46.873201],
              [-91.140301, 46.873105],
              [-91.14385, 46.870595],
              [-91.143877, 46.870576],
              [-91.144266, 46.870301],
              [-91.147837, 46.863082],
              [-91.148026, 46.862906],
              [-91.156108, 46.855414],
              [-91.167601, 46.84476],
              [-91.168297, 46.844727],
              [-91.178292, 46.844259],
              [-91.200107, 46.854017],
              [-91.204439, 46.858816],
              [-91.204839, 46.859727],
              [-91.207524, 46.865835],
              [-91.211113, 46.866696],
              [-91.211647, 46.866824],
              [-91.214886, 46.866137],
              [-91.226796, 46.86361],
              [-91.232733, 46.860035],
              [-91.235283, 46.857368],
              [-91.23773, 46.854809],
              [-91.249471, 46.842531],
              [-91.250806, 46.841135],
              [-91.256563, 46.836989],
              [-91.256705, 46.836887],
              [-91.256873, 46.836833],
              [-91.263445, 46.834722],
              [-91.263725, 46.834632],
              [-91.265816, 46.83396],
              [-91.265866, 46.833944],
              [-91.266404, 46.833891],
              [-91.278558, 46.832689],
              [-91.289541, 46.831604],
              [-91.301879, 46.830384],
              [-91.302295, 46.830343],
              [-91.303594, 46.829978],
              [-91.304512, 46.82972],
              [-91.305487, 46.829446],
              [-91.30705, 46.829007],
              [-91.314815, 46.826825],
              [-91.315061, 46.826729],
              [-91.32101, 46.824414],
              [-91.322202, 46.82395],
              [-91.326045, 46.822454],
              [-91.328848, 46.821363],
              [-91.330433, 46.820746],
              [-91.330463, 46.820735],
              [-91.33757, 46.817969],
              [-91.33825, 46.817704],
              [-91.352191, 46.807417],
              [-91.35533, 46.804035],
              [-91.359434, 46.799612],
              [-91.360804, 46.798136],
              [-91.363644, 46.796612],
              [-91.365277, 46.795736],
              [-91.365536, 46.795597],
              [-91.365974, 46.795362],
              [-91.366888, 46.794872],
              [-91.367498, 46.794545],
              [-91.368819, 46.793836],
              [-91.369387, 46.793745],
              [-91.380577, 46.791951],
              [-91.386155, 46.791057],
              [-91.390774, 46.790316],
              [-91.391469, 46.790205],
              [-91.394764, 46.790694],
              [-91.396261, 46.790917],
              [-91.396959, 46.79102],
              [-91.39714, 46.791047],
              [-91.398256, 46.791213],
              [-91.411799, 46.78964],
              [-91.423713, 46.78217],
              [-91.426491, 46.781208],
              [-91.428526, 46.780504],
              [-91.436955, 46.777586],
              [-91.449327, 46.773303],
              [-91.44957, 46.773252],
              [-91.462774, 46.770471],
              [-91.467168, 46.769546],
              [-91.470124, 46.768923],
              [-91.470181, 46.768911],
              [-91.472097, 46.768717],
              [-91.488247, 46.767086],
              [-91.489125, 46.766997],
              [-91.491744, 46.766732],
              [-91.492429, 46.766663],
              [-91.492493, 46.766615],
              [-91.493037, 46.76621],
              [-91.493643, 46.765757],
              [-91.499696, 46.761243],
              [-91.500042, 46.761128],
              [-91.50716, 46.758757],
              [-91.507586, 46.758615],
              [-91.507819, 46.758538],
              [-91.510595, 46.757614],
              [-91.511077, 46.757453],
              [-91.517712, 46.756774],
              [-91.524766, 46.756052],
              [-91.535764, 46.754926],
              [-91.537115, 46.754788],
              [-91.537583, 46.754817],
              [-91.543057, 46.755153],
              [-91.551408, 46.755666],
              [-91.551445, 46.755674],
              [-91.557503, 46.756155],
              [-91.569075, 46.757074],
              [-91.571423, 46.75726],
              [-91.574019, 46.757466],
              [-91.574291, 46.757488],
              [-91.576632, 46.757037],
              [-91.590684, 46.754331],
              [-91.592203, 46.753788],
              [-91.592742, 46.753595],
              [-91.593442, 46.753345],
              [-91.625387, 46.741924],
              [-91.635107, 46.738449],
              [-91.635161, 46.73843],
              [-91.636005, 46.738128],
              [-91.63604, 46.738116],
              [-91.636919, 46.737802],
              [-91.645502, 46.734733],
              [-91.646146, 46.734575],
              [-91.652915, 46.732911],
              [-91.658739, 46.731479],
              [-91.66067, 46.731004],
              [-91.662426, 46.730572],
              [-91.667534, 46.729317],
              [-91.675621, 46.727329],
              [-91.677021, 46.726984],
              [-91.735632, 46.712575],
              [-91.748787, 46.709341],
              [-91.74965, 46.709129],
              [-91.758619, 46.705927],
              [-91.781928, 46.697604],
              [-91.790132, 46.694675],
              [-91.790473, 46.694624],
              [-91.798455, 46.693422],
              [-91.799987, 46.693192],
              [-91.814669, 46.690982],
              [-91.817099, 46.690617],
              [-91.817185, 46.690604],
              [-91.820027, 46.690176],
              [-91.831355, 46.689906],
              [-91.840288, 46.689693],
              [-91.857462, 46.692362],
              [-91.864491, 46.69185],
              [-91.866583, 46.691697],
              [-91.87484, 46.691095],
              [-91.876183, 46.690997],
              [-91.877371, 46.69091],
              [-91.87873, 46.690811],
              [-91.886963, 46.690211],
              [-91.930261, 46.682273],
              [-91.942988, 46.679939],
              [-91.961889, 46.682539],
              [-91.973389, 46.686439],
              [-91.987889, 46.692739],
              [-92.007989, 46.705039],
              [-92.01529, 46.706469],
              [-92.025789, 46.710839],
              [-92.06449, 46.745439],
              [-92.088289, 46.773639],
              [-92.094089, 46.787839],
              [-92.086089, 46.794339],
              [-92.062088, 46.804038],
              [-92.058888, 46.809938],
              [-92.013405, 46.833727],
              [-91.997987, 46.838737],
              [-91.985086, 46.849637],
              [-91.952985, 46.867037],
              [-91.914984, 46.883836],
              [-91.906483, 46.891236],
              [-91.883238, 46.905728],
              [-91.871286, 46.908352],
              [-91.841349, 46.925215],
              [-91.834852, 46.927135],
              [-91.826068, 46.927199],
              [-91.806851, 46.933727],
              [-91.794039, 46.939676],
              [-91.780675, 46.945881],
              [-91.7773, 46.951799],
              [-91.737098, 46.982853],
              [-91.704649, 47.005246],
              [-91.666477, 47.014297],
              [-91.660248, 47.019288],
              [-91.644564, 47.026491],
              [-91.637164, 47.040429],
              [-91.626824, 47.049953],
              [-91.613173, 47.059192],
              [-91.604949, 47.063309],
              [-91.600969, 47.063425],
              [-91.591508, 47.068684],
              [-91.573817, 47.089917],
              [-91.518793, 47.108121],
              [-91.506998, 47.118489],
              [-91.497902, 47.122579],
              [-91.477351, 47.125667],
              [-91.456965, 47.139156],
              [-91.452031, 47.145158],
              [-91.418805, 47.172152],
              [-91.398455, 47.183916],
              [-91.387021, 47.187293],
              [-91.374191, 47.1978],
              [-91.357803, 47.206743],
              [-91.35385, 47.212686],
              [-91.326019, 47.238993],
              [-91.288478, 47.26596],
              [-91.270697, 47.277134],
              [-91.26595, 47.279479],
              [-91.262512, 47.27929],
              [-91.250163, 47.29049],
              [-91.238658, 47.304976],
              [-91.206248, 47.329182],
              [-91.188772, 47.340082],
              [-91.170037, 47.366266],
              [-91.156513, 47.378816],
              [-91.146958, 47.381464],
              [-91.131268, 47.393567],
              [-91.128131, 47.399619],
              [-91.106218, 47.411806],
              [-91.097569, 47.413888],
              [-91.077712, 47.428767],
              [-91.045646, 47.456525],
              [-91.032945, 47.458236],
              [-91.023125, 47.464964],
              [-91.023124, 47.464964],
              [-90.939072, 47.514532],
              [-90.927975, 47.519008],
              [-90.919375, 47.519784],
              [-90.914247, 47.522639],
              [-90.909801, 47.526215],
              [-90.910127, 47.530178],
              [-90.907494, 47.532873],
              [-90.86827, 47.5569],
              [-90.735927, 47.624343],
              [-90.686382, 47.643594],
              [-90.647837, 47.656176],
              [-90.584954, 47.68074],
              [-90.551291, 47.690266],
              [-90.537105, 47.703055],
              [-90.458365, 47.7214],
              [-90.441912, 47.726404],
              [-90.437712, 47.731612],
              [-90.42139, 47.73515],
              [-90.393823, 47.738271],
              [-90.386234, 47.7411],
              [-90.332686, 47.746387],
              [-90.330254, 47.750892],
              [-90.323446, 47.753771],
              [-90.313958, 47.756681],
              [-90.30634, 47.756627],
              [-90.295952, 47.759054],
              [-90.248794, 47.772763],
              [-90.229145, 47.776198],
              [-90.187636, 47.77813],
              [-90.178755, 47.786414],
              [-90.16079, 47.792807],
              [-90.132078, 47.79572],
              [-90.1168, 47.79538],
              [-90.08816, 47.803041],
              [-90.082354, 47.803619],
              [-90.075559, 47.803303],
              [-90.072241, 47.807727],
              [-90.072025, 47.811105],
              [-90.042761, 47.817568],
              [-90.01373, 47.821373],
              [-89.974296, 47.830514],
              [-89.933899, 47.84676],
              [-89.92752, 47.850825],
              [-89.930844, 47.857723],
              [-89.923649, 47.862062],
              [-89.87158, 47.874194],
              [-89.85396, 47.873997],
              [-89.793539, 47.891358],
              [-89.758714, 47.906993],
              [-89.737539, 47.918183],
              [-89.72973, 47.925245],
              [-89.697619, 47.941288],
              [-89.660616, 47.951216],
              [-89.639545, 47.95359],
              [-89.638285, 47.954275],
              [-89.639844, 47.959826],
              [-89.640129, 47.96793],
              [-89.637015, 47.973465],
              [-89.631825, 47.980039],
              [-89.624559, 47.983153],
              [-89.611412, 47.980731],
              [-89.59589, 47.971046],
              [-89.58823, 47.9662],
              [-89.572315, 47.967238],
              [-89.555015, 47.974849],
              [-89.552939, 47.980731],
              [-89.551555, 47.987305],
              [-89.541521, 47.992841],
              [-89.495344, 48.002356],
              [-89.491739, 48.005212],
              [-89.489226, 48.014528],
              [-89.564288, 48.00293],
              [-89.655793, 48.007532],
              [-89.687891, 48.010826],
              [-89.724184, 48.019818],
              [-89.749314, 48.023325],
              [-89.763967, 48.022969],
              [-89.819802, 48.015099],
              [-89.847571, 47.992442],
              [-89.873286, 47.985419],
              [-89.897414, 47.987599],
              [-89.968255, 48.014482],
              [-89.99305, 48.028404],
              [-89.996702, 48.035391],
              [-89.993822, 48.049027],
              [-89.997852, 48.057567],
              [-90.023595, 48.084708],
              [-90.073873, 48.101138],
              [-90.091639, 48.10463],
              [-90.1239, 48.107131],
              [-90.12509, 48.107702],
              [-90.136191, 48.112136],
              [-90.176605, 48.112445],
              [-90.312386, 48.1053],
              [-90.330052, 48.102399],
              [-90.337177, 48.099771],
              [-90.343484, 48.095064],
              [-90.344234, 48.094447],
              [-90.403219, 48.105114],
              [-90.452022, 48.105006],
              [-90.495398, 48.099787],
              [-90.495637, 48.099444],
              [-90.569763, 48.106951],
              [-90.751608, 48.090968],
              [-90.761625, 48.098283],
              [-90.774191, 48.118575],
              [-90.774225, 48.118894],
              [-90.775962, 48.122229],
              [-90.776133, 48.122481],
              [-90.793841, 48.135569],
              [-90.795308, 48.135523],
              [-90.789776, 48.143472],
              [-90.804207, 48.177833],
              [-90.839176, 48.239511],
              [-90.843624, 48.243576],
              [-90.847352, 48.244443],
              [-90.88548, 48.245784],
              [-90.976955, 48.219452],
              [-91.032942, 48.190794],
              [-91.03555, 48.189459],
              [-91.035858, 48.189436],
              [-91.138482, 48.151458],
              [-91.138311, 48.151024],
              [-91.140773, 48.147689],
              [-91.176181, 48.125811],
              [-91.250112, 48.084087],
              [-91.26638, 48.078713],
              [-91.290215, 48.073945],
              [-91.328738, 48.070588],
              [-91.340159, 48.073236],
              [-91.488067, 48.068111],
              [-91.569746, 48.093348],
              [-91.641062, 48.097703],
              [-91.71185, 48.114598],
              [-91.712226, 48.116883],
              [-91.708099, 48.122985],
              [-91.699336, 48.144728],
              [-91.710519, 48.193898],
              [-91.714931, 48.19913],
              [-91.742313, 48.204491],
              [-91.789693, 48.197829],
              [-91.798268, 48.200086],
              [-91.867641, 48.218341],
              [-91.906967, 48.23777],
              [-91.907597, 48.238183],
              [-91.954397, 48.251199],
              [-91.954432, 48.251678],
              [-91.977486, 48.24634],
              [-91.977555, 48.24714],
              [-91.989545, 48.260214],
              [-92.030872, 48.325824],
              [-92.055228, 48.359213],
              [-92.26228, 48.354933],
              [-92.288994, 48.342991],
              [-92.304561, 48.322977],
              [-92.306309, 48.316442],
              [-92.301451, 48.288608],
              [-92.295668, 48.278118],
              [-92.295053, 48.276587],
              [-92.325304, 48.23703],
              [-92.384387, 48.242914],
              [-92.415121, 48.293841],
              [-92.456325, 48.414204],
              [-92.507285, 48.447875],
              [-92.537202, 48.447703],
              [-92.575636, 48.440827],
              [-92.656027, 48.436709],
              [-92.687998, 48.443889],
              [-92.712562, 48.463013],
              [-92.698824, 48.494892],
              [-92.684866, 48.497611],
              [-92.661418, 48.496557],
              [-92.636696, 48.499428],
              [-92.627237, 48.503383],
              [-92.631137, 48.508077],
              [-92.631117, 48.508252],
              [-92.625374, 48.512916],
              [-92.625151, 48.513048],
              [-92.625739, 48.518189],
              [-92.634931, 48.542873],
              [-92.657881, 48.546263],
              [-92.728046, 48.53929],
              [-92.980484, 48.624915],
              [-93.088438, 48.627597],
              [-93.14242, 48.624924],
              [-93.17999, 48.624926],
              [-93.207398, 48.642474],
              [-93.254854, 48.642784],
              [-93.347528, 48.62662],
              [-93.367025, 48.608283],
              [-93.40366, 48.607593],
              [-93.464308, 48.591792],
              [-93.466007, 48.587291],
              [-93.461731, 48.57403],
              [-93.457046, 48.567199],
              [-93.456675, 48.561834],
              [-93.460798, 48.550552],
              [-93.467504, 48.545664],
              [-93.544361, 48.529109],
              [-93.662337, 48.515708],
              [-93.756483, 48.515366],
              [-93.771741, 48.515825],
              [-93.794454, 48.516021],
              [-93.815178, 48.526508],
              [-93.818253, 48.530046],
              [-93.818375, 48.534442],
              [-93.811201, 48.542385],
              [-93.805369, 48.568393],
              [-93.806763, 48.577616],
              [-93.822644, 48.609067],
              [-93.834323, 48.624954],
              [-93.840754, 48.628548],
              [-94.052452, 48.64402],
              [-94.126336, 48.644447],
              [-94.224276, 48.649527],
              [-94.244394, 48.653442],
              [-94.250191, 48.656323],
              [-94.250497, 48.656654],
              [-94.251169, 48.683514],
              [-94.260541, 48.696381],
              [-94.290737, 48.707747],
              [-94.308446, 48.710239],
              [-94.388848, 48.711945],
              [-94.416191, 48.710948],
              [-94.431854, 48.706588],
              [-94.468728, 48.696324],
              [-94.533057, 48.701262],
              [-94.628854, 48.738789],
              [-94.64515, 48.748991],
              [-94.646256, 48.749975],
              [-94.690863, 48.778047],
              [-94.690889, 48.778066],
              [-94.690246, 48.863363],
              [-94.690302, 48.863711],
              [-94.683127, 48.883376],
              [-94.683069, 48.883929],
              [-94.718932, 48.999991],
              [-94.750218, 48.999992],
              [-94.750221, 49.099763],
              [-94.773223, 49.120733],
              [-94.797527, 49.197791],
              [-94.824291, 49.308834],
              [-94.909273, 49.350176],
              [-94.957465, 49.370186],
              [-94.988908, 49.368897],
              [-95.014415, 49.356405],
              [-95.058404, 49.35317],
              [-95.126467, 49.369439],
              [-95.153314, 49.384358],
              [-95.15335, 49.383079],
              [-95.153293, 49.369107],
              [-95.153259, 49.367691],
              [-95.15333, 49.365886],
              [-95.153407, 49.354397],
              [-95.153344, 49.343662],
              [-95.153284, 49.343409],
              [-95.15333, 49.309287],
              [-95.153331, 49.308442],
              [-95.153319, 49.30772],
              [-95.153333, 49.305655],
              [-95.153424, 49.249995],
              [-95.153309, 49.18488],
              [-95.153711, 48.998903],
              [-95.319895, 48.998769],
              [-95.322946, 48.998767],
              [-95.340962, 48.99874],
              [-95.355819, 48.998735],
              [-95.368698, 48.998729],
              [-96.405412, 48.99982],
              [-97.229039, 49.000687],
              [-97.411216, 49.00051],
              [-97.77575, 49.000574],
              [-97.950205, 49.000459],
              [-98.999819, 48.999769],
              [-99.5257, 48.999423],
              [-99.861454, 48.999202],
              [-99.861488, 48.999156],
              [-99.913705, 48.999049],
              [-99.91378, 48.999049],
              [-100.182707, 48.99923],
              [-100.431676, 48.999398],
              [-100.431642, 48.999604],
              [-100.434351, 48.99957],
              [-100.433981, 48.99941],
              [-100.907107, 48.999593],
              [-100.913634, 48.999662],
              [-100.917939, 48.999571],
              [-100.920577, 48.99956],
              [-101.216182, 48.999469],
              [-101.220754, 48.999455],
              [-101.225187, 48.999566],
              [-101.225915, 48.999531],
              [-101.496737, 48.999355],
              [-102.021144, 48.999015],
              [-102.131614, 48.998842],
              [-102.151847, 48.998798],
              [-102.211301, 48.998554],
              [-102.216993, 48.998553],
              [-102.938793, 48.998998],
              [-103.852287, 48.999561],
              [-103.856072, 48.999572],
              [-103.858363, 48.999606],
              [-103.862738, 48.999639],
              [-103.865336, 48.999591],
              [-103.876905, 48.999544],
              [-103.917428, 48.999585],
              [-103.918921, 48.999551],
              [-103.921976, 48.999551],
              [-103.923261, 48.999562],
              [-103.968611, 48.999525],
              [-103.969479, 48.999525],
              [-103.976459, 48.999605],
              [-103.980868, 48.999581],
              [-103.982361, 48.999615],
              [-103.983786, 48.999604],
              [-103.988925, 48.99958],
              [-103.992467, 48.999567],
              [-104.048736, 48.999877],
              [-104.048478, 48.987007],
              [-104.048616, 48.966736],
              [-104.048555, 48.963772],
              [-104.0488, 48.958997],
              [-104.048627, 48.957124],
              [-104.048698, 48.951823],
              [-104.048872, 48.94963],
              [-104.04877, 48.943301],
              [-104.048701, 48.940331],
              [-104.048807, 48.933636],
              [-104.048744, 48.912113],
              [-104.048746, 48.906858],
              [-104.048643, 48.902609],
              [-104.048719, 48.879921],
              [-104.048893, 48.875739],
              [-104.048883, 48.874008],
              [-104.048824, 48.867539],
              [-104.048652, 48.865734],
              [-104.0489, 48.847387],
              [-104.048569, 48.797052],
              [-104.048537, 48.788552],
              [-104.048548, 48.751356],
              [-104.04834, 48.747133],
              [-104.047883, 48.664191],
              [-104.047849, 48.663163],
              [-104.047861, 48.658856],
              [-104.047865, 48.65745],
              [-104.047887, 48.649911],
              [-104.047819, 48.648631],
              [-104.047582, 48.633984],
              [-104.047582, 48.633976],
              [-104.04762, 48.627015],
              [-104.047586, 48.625644],
              [-104.04793, 48.62019],
              [-104.048212, 48.599055],
              [-104.047974, 48.591606],
              [-104.047811, 48.56277],
              [-104.047783, 48.539737],
              [-104.047648, 48.531489],
              [-104.047876, 48.530798],
              [-104.047513, 48.525913],
              [-104.047675, 48.517852],
              [-104.047555, 48.49414],
              [-104.047392, 48.467086],
              [-104.047259, 48.452941],
              [-104.047294, 48.452529],
              [-104.047192, 48.447251],
              [-104.04709, 48.445903],
              [-104.04696, 48.421065],
              [-104.047134, 48.411057],
              [-104.046969, 48.390675],
              [-104.046913, 48.389433],
              [-104.046913, 48.389429],
              [-104.046654, 48.374773],
              [-104.046371, 48.374154],
              [-104.046332, 48.34229],
              [-104.046039, 48.256761],
              [-104.045861, 48.255097],
              [-104.045645, 48.246179],
              [-104.045729, 48.244586],
              [-104.045692, 48.241415],
              [-104.04556, 48.193913],
              [-104.045424, 48.192473],
              [-104.045498, 48.176249],
              [-104.045399, 48.16439],
              [-104.04412, 47.996107],
              [-104.044162, 47.992836],
              [-104.043933, 47.971515],
              [-104.043497, 47.95449],
              [-104.043329, 47.949554],
              [-104.04223, 47.891031],
              [-104.041662, 47.862282],
              [-104.041869, 47.841699],
              [-104.042567, 47.808237],
              [-104.042432, 47.805358],
              [-104.042384, 47.803256],
              [-104.043199, 47.747292],
              [-104.043242, 47.747106],
              [-104.044621, 47.45938],
              [-104.044797, 47.438445],
              [-104.045069, 47.397461],
              [-104.045333, 47.343452],
              [-104.045313, 47.331955],
              [-104.045307, 47.330128],
              [-104.045121, 47.276969],
              [-104.045155, 47.27393],
              [-104.045088, 47.271406],
              [-104.045057, 47.266868],
              [-104.045091, 47.265953],
              [-104.045159, 47.263874],
              [-104.045081, 47.092813],
              [-104.045018, 47.081202],
              [-104.045354, 47.078574],
              [-104.045259, 47.063901],
              [-104.045227, 47.057502],
              [-104.045195, 47.053639],
              [-104.045052, 47.040863],
              [-104.045076, 47.037589],
              [-104.045566, 46.941231],
              [-104.045535, 46.934009],
              [-104.045542, 46.933887],
              [-104.045402, 46.725423],
              [-104.045403, 46.722177],
              [-104.04537, 46.721332],
              [-104.045572, 46.713881],
              [-104.045474, 46.708738],
              [-104.045271, 46.641449],
              [-104.045271, 46.641443],
              [-104.045335, 46.540929],
              [-104.045462, 46.341895],
              [-104.045469, 46.324545],
              [-104.045633, 46.280188],
              [-104.04667, 46.000001],
              [-104.045443, 45.94531],
              [-104.04403, 45.881975],
              [-104.04403, 45.881971],
              [-104.044009, 45.871974],
              [-104.043814, 45.868385],
              [-104.041937, 45.557915],
              [-104.041647, 45.550691],
              [-104.041717, 45.539122],
              [-104.041145, 45.503367],
              [-104.041274, 45.499994],
              [-104.041764, 45.490789],
              [-104.04041, 45.393474],
              [-104.040114, 45.374214],
              [-104.040265, 45.345356],
              [-104.040358, 45.335946],
              [-104.040274, 45.212891],
              [-104.040128, 44.999987],
              [-104.057698, 44.997431],
              [-104.055963, 44.768236],
              [-104.055963, 44.767962],
              [-104.055934, 44.72372],
              [-104.05587, 44.723422],
              [-104.055777, 44.700466],
              [-104.055938, 44.693881],
              [-104.05581, 44.691343],
              [-104.055877, 44.571016],
              [-104.055892, 44.543341],
              [-104.055927, 44.51773],
              [-104.054487, 44.180381],
              [-104.054562, 44.141081],
              [-104.05495, 43.93809],
              [-104.055077, 43.936535],
              [-104.055104, 43.853478],
              [-104.055138, 43.750421],
              [-104.055133, 43.747105],
              [-104.054902, 43.583852],
              [-104.054885, 43.583512],
              [-104.05484, 43.579368],
              [-104.055032, 43.558603],
              [-104.054787, 43.503328],
              [-104.054786, 43.503072],
              [-104.054779, 43.477815],
              [-104.054766, 43.428914],
              [-104.054614, 43.390949],
              [-104.054403, 43.325914],
              [-104.054218, 43.30437],
              [-104.053884, 43.297047],
              [-104.053876, 43.289801],
              [-104.053127, 43.000585],
              [-104.052863, 42.754569],
              [-104.052809, 42.749966],
              [-104.052583, 42.650062],
              [-104.052741, 42.633982],
              [-104.052586, 42.630917],
              [-104.052773, 42.611766],
              [-104.052775, 42.61159],
              [-104.052775, 42.610813],
              [-104.052776, 42.25822],
              [-104.052793, 42.249962],
              [-104.052761, 42.170278],
              [-104.052547, 42.166801],
              [-104.053001, 42.137254],
              [-104.052738, 42.133769],
              [-104.0526, 42.124963],
              [-104.052954, 42.089077],
              [-104.052967, 42.075004],
              [-104.05288, 42.021761],
              [-104.052729, 42.016318],
              [-104.052704, 42.001718],
              [-104.052699, 41.998673],
              [-104.052761, 41.994967],
              [-104.05283, 41.9946],
              [-104.052856, 41.975958],
              [-104.052734, 41.973007],
              [-104.052991, 41.914973],
              [-104.052931, 41.906143],
              [-104.053026, 41.885464],
              [-104.052774, 41.733401],
              [-104.05283, 41.697954],
              [-104.052913, 41.64519],
              [-104.052945, 41.638167],
              [-104.052975, 41.622931],
              [-104.052735, 41.613676],
              [-104.052859, 41.592254],
              [-104.05254, 41.564274],
              [-104.052531, 41.552723],
              [-104.052584, 41.55265],
              [-104.052692, 41.541154],
              [-104.052686, 41.539111],
              [-104.052476, 41.522343],
              [-104.052478, 41.515754],
              [-104.05234, 41.417865],
              [-104.05216, 41.407662],
              [-104.052287, 41.393307],
              [-104.052287, 41.393214],
              [-104.052324, 41.321144],
              [-104.052476, 41.320961],
              [-104.052568, 41.316202],
              [-104.052453, 41.278202],
              [-104.052574, 41.278019],
              [-104.052666, 41.275251],
              [-104.053142, 41.114457],
              [-104.053083, 41.104985],
              [-104.053025, 41.090274],
              [-104.053177, 41.089725],
              [-104.053097, 41.018045],
              [-104.053158, 41.016809],
              [-104.053249, 41.001406],
              [-104.039238, 41.001502],
              [-104.023383, 41.001887],
              [-104.018223, 41.001617],
              [-103.972642, 41.001615],
              [-103.971373, 41.001524],
              [-103.953525, 41.001596],
              [-103.896207, 41.00175],
              [-103.877967, 41.001673],
              [-103.858449, 41.001681],
              [-103.574522, 41.001721],
              [-103.497447, 41.001635],
              [-103.486697, 41.001914],
              [-103.421975, 41.002007],
              [-103.421925, 41.001969],
              [-103.382493, 41.001883],
              [-103.365314, 41.001846],
              [-103.362979, 41.001844],
              [-103.077804, 41.002298],
              [-103.076536, 41.002253],
              [-103.059538, 41.002368],
              [-103.057998, 41.002368],
              [-103.043444, 41.002344],
              [-103.038704, 41.002251],
              [-103.002026, 41.002486],
              [-103.000102, 41.0024],
              [-102.98269, 41.002157],
              [-102.981483, 41.002112],
              [-102.963669, 41.002186],
              [-102.962522, 41.002072],
              [-102.960706, 41.002059],
              [-102.959624, 41.002095],
              [-102.94483, 41.002303],
              [-102.943109, 41.002051],
              [-102.925568, 41.00228],
              [-102.924029, 41.002142],
              [-102.906547, 41.002276],
              [-102.904796, 41.002207],
              [-102.887407, 41.002178],
              [-102.885746, 41.002131],
              [-102.867822, 41.002183],
              [-102.865784, 41.001988],
              [-102.849263, 41.002301],
              [-102.846455, 41.002256],
              [-102.830303, 41.002351],
              [-102.82728, 41.002143],
              [-102.773546, 41.002414],
              [-102.766723, 41.002275],
              [-102.754617, 41.002361],
              [-102.739624, 41.00223],
              [-102.653463, 41.002332],
              [-102.621033, 41.002597],
              [-102.578696, 41.002291],
              [-102.575738, 41.002268],
              [-102.575496, 41.0022],
              [-102.566048, 41.0022],
              [-102.556789, 41.002219],
              [-102.487955, 41.002445],
              [-102.470537, 41.002382],
              [-102.469223, 41.002424],
              [-102.379593, 41.002301],
              [-102.364066, 41.002174],
              [-102.292833, 41.002207],
              [-102.292622, 41.00223],
              [-102.292553, 41.002207],
              [-102.291354, 41.002207],
              [-102.2721, 41.002245],
              [-102.267812, 41.002383],
              [-102.231931, 41.002327],
              [-102.2122, 41.002462],
              [-102.209361, 41.002442],
              [-102.19121, 41.002326],
              [-102.124972, 41.002338],
              [-102.070598, 41.002423],
              [-102.051718, 41.002377],
              [-102.051614, 41.002377],
              [-102.051292, 40.749591],
              [-102.051292, 40.749586],
              [-102.051398, 40.697542],
              [-102.051725, 40.537839],
              [-102.051519, 40.520094],
              [-102.051465, 40.440008],
              [-102.05184, 40.396396],
              [-102.051572, 40.39308],
              [-102.051669, 40.349213],
              [-102.051922, 40.235344],
              [-102.051894, 40.229193],
              [-102.051909, 40.162674],
              [-102.052001, 40.148359],
              [-102.051744, 40.003078],
              [-102.051569, 39.849805],
              [-102.051363, 39.843471],
              [-102.051318, 39.833311],
              [-102.051254, 39.818992],
              [-102.050594, 39.675594],
              [-102.049954, 39.592331],
              [-102.049806, 39.574058],
              [-102.049764, 39.56818],
              [-102.049554, 39.538932],
              [-102.049673, 39.536691],
              [-102.049679, 39.506183],
              [-102.049369, 39.423333],
              [-102.04937, 39.41821],
              [-102.049167, 39.403597],
              [-102.04896, 39.373712],
              [-102.048449, 39.303138],
              [-102.04725, 39.13702],
              [-102.047189, 39.133147],
              [-102.047134, 39.129701],
              [-102.046571, 39.047038],
              [-102.045388, 38.813392],
              [-102.045334, 38.799463],
              [-102.045448, 38.783453],
              [-102.045371, 38.770064],
              [-102.045287, 38.755528],
              [-102.045375, 38.754339],
              [-102.045212, 38.697567],
              [-102.045156, 38.688555],
              [-102.045127, 38.686725],
              [-102.04516, 38.675221],
              [-102.045102, 38.674946],
              [-102.045074, 38.669617],
              [-102.045288, 38.615249],
              [-102.045288, 38.615168],
              [-102.045211, 38.581609],
              [-102.045189, 38.558732],
              [-102.045223, 38.543797],
              [-102.045112, 38.523784],
              [-102.045262, 38.505532],
              [-102.045263, 38.505395],
              [-102.044944, 38.384419],
              [-102.044613, 38.312324],
              [-102.044568, 38.268819],
              [-102.044567, 38.268749],
              [-102.04451, 38.262412],
              [-102.044398, 38.250015],
              [-102.043844, 37.928102],
              [-102.043845, 37.926135],
              [-102.043219, 37.867929],
              [-102.043033, 37.824146],
              [-102.042953, 37.803535],
              [-102.042668, 37.788758],
              [-102.042158, 37.760164],
              [-102.04199, 37.738541],
              [-102.041876, 37.723875],
              [-102.041574, 37.680436],
              [-102.041694, 37.665681],
              [-102.041582, 37.654495],
              [-102.041585, 37.644282],
              [-102.041618, 37.607868],
              [-102.041894, 37.557977],
              [-102.041899, 37.541186],
              [-102.042016, 37.535261],
              [-102.041786, 37.506066],
              [-102.041801, 37.469488],
              [-102.041755, 37.434855],
              [-102.041669, 37.43474],
              [-102.041676, 37.409898],
              [-102.041826, 37.389191],
              [-102.042089, 37.352819],
              [-102.041974, 37.352613],
              [-102.041817, 37.30949],
              [-102.041664, 37.29765],
              [-102.041963, 37.258164],
              [-102.042002, 37.141744],
              [-102.042135, 37.125021],
              [-102.042092, 37.125021],
              [-102.041809, 37.111973],
              [-102.041983, 37.106551],
              [-102.04192, 37.035083],
              [-102.041749, 37.034397],
              [-102.041921, 37.032178],
              [-102.04195, 37.030805],
              [-102.041952, 37.024742],
              [-102.04224, 36.993083],
              [-102.028207, 36.993125],
              [-102.028204, 36.993125],
              [-102.000447, 36.993272],
              [-102.000447, 36.993249],
              [-101.90244, 36.993702],
              [-101.601593, 36.995095],
              [-101.600396, 36.995153],
              [-101.55526, 36.995414],
              [-101.555239, 36.995414],
              [-101.519066, 36.995546],
              [-101.485326, 36.995611],
              [-101.415005, 36.995966],
              [-101.413868, 36.996008],
              [-101.37818, 36.996164],
              [-101.359674, 36.996232],
              [-101.357797, 36.996271],
              [-101.212909, 36.997044],
              [-101.211486, 36.997124],
              [-101.066742, 36.997921],
              [-101.053589, 36.997967],
              [-101.012641, 36.998176],
              [-100.996502, 36.998044],
              [-100.945566, 36.998152],
              [-100.945469, 36.998153],
              [-100.904588, 36.998561],
              [-100.904274, 36.998745],
              [-100.89166, 36.998604],
              [-100.855634, 36.998626],
              [-100.814277, 36.999085],
              [-100.806116, 36.999091],
              [-100.765484, 36.999177],
              [-100.756894, 36.999357],
              [-100.675552, 36.999688],
              [-100.633327, 36.999936],
              [-100.633323, 36.999936],
              [-100.62977, 37.000025],
              [-100.591413, 37.000399],
              [-100.591328, 37.000376],
              [-100.552683, 37.000735],
              [-100.551598, 37.00062],
              [-100.201676, 37.002081],
              [-100.193754, 37.002133],
              [-100.192371, 37.002036],
              [-100.187547, 37.002082],
              [-100.115722, 37.002206],
              [-100.089484, 37.002092],
              [-100.005706, 37.001726],
              [-100.002563, 37.001706],
              [-100.001286, 37.001699],
              [-99.995201, 37.001631],
              [-99.786016, 37.000931],
              [-99.774816, 37.000841],
              [-99.774255, 37.000837],
              [-99.657658, 37.000197],
              [-99.625399, 36.999671],
              [-99.558068, 36.999528],
              [-99.541116, 36.999573],
              [-99.508574, 36.999658],
              [-99.504093, 36.999648],
              [-99.502665, 36.999645],
              [-99.500395, 36.999637],
              [-99.500395, 36.999576],
              [-99.484333, 36.999626],
              [-99.456203, 36.999471],
              [-99.277506, 36.999579],
              [-99.24812, 36.999565],
              [-99.129449, 36.999422],
              [-99.124883, 36.99942],
              [-99.029337, 36.999595],
              [-99.000303, 36.99951],
              [-98.994371, 36.999493],
              [-98.88058, 36.999309],
              [-98.880009, 36.999263],
              [-98.869449, 36.999286],
              [-98.797452, 36.999229],
              [-98.793711, 36.999227],
              [-98.791936, 36.999255],
              [-98.761597, 36.999425],
              [-98.718465, 36.99918],
              [-98.714512, 36.99906],
              [-98.544872, 36.998997],
              [-98.54466, 36.998996],
              [-98.420209, 36.998516],
              [-98.418268, 36.998538],
              [-98.408991, 36.998513],
              [-98.354073, 36.997961],
              [-98.347149, 36.997962],
              [-98.346188, 36.997962],
              [-98.237712, 36.997972],
              [-98.219499, 36.997824],
              [-98.208218, 36.997997],
              [-98.177596, 36.998009],
              [-98.147452, 36.998162],
              [-98.111985, 36.998133],
              [-98.045342, 36.998327],
              [-98.03989, 36.998349],
              [-98.033955, 36.998366],
              [-97.802313, 36.998713],
              [-97.802298, 36.998713],
              [-97.783489, 36.998847],
              [-97.783432, 36.998961],
              [-97.768704, 36.99875],
              [-97.697104, 36.998826],
              [-97.650466, 36.999004],
              [-97.637137, 36.99909],
              [-97.606549, 36.998682],
              [-97.564536, 36.998711],
              [-97.546498, 36.998747],
              [-97.5459, 36.998709],
              [-97.527292, 36.99875],
              [-97.472861, 36.998721],
              [-97.462346, 36.998685],
              [-97.46228, 36.998685],
              [-97.384925, 36.998843],
              [-97.372421, 36.998861],
              [-97.147721, 36.999111],
              [-97.122597, 36.999036],
              [-97.120285, 36.999014],
              [-97.104276, 36.99902],
              [-97.100652, 36.998998],
              [-97.039784, 36.999],
              [-97.030082, 36.998929],
              [-96.975562, 36.999019],
              [-96.967371, 36.999067],
              [-96.934642, 36.99907],
              [-96.921915, 36.999151],
              [-96.917093, 36.999182],
              [-96.90351, 36.999132],
              [-96.902083, 36.999155],
              [-96.87629, 36.999233],
              [-96.867517, 36.999217],
              [-96.822791, 36.999182],
              [-96.795199, 36.99886],
              [-96.79206, 36.99918],
              [-96.749838, 36.998988],
              [-96.74127, 36.999239],
              [-96.73659, 36.999286],
              [-96.710482, 36.999271],
              [-96.705431, 36.999203],
              [-96.525493, 36.999147],
              [-96.415412, 36.999113],
              [-96.394272, 36.999221],
              [-96.279079, 36.999272],
              [-96.276368, 36.999271],
              [-96.217571, 36.99907],
              [-96.200028, 36.999028],
              [-96.184768, 36.999211],
              [-96.154017, 36.999161],
              [-96.152384, 36.999051],
              [-96.149709, 36.99904],
              [-96.147143, 36.999022],
              [-96.143207, 36.999134],
              [-96.14121, 36.998973],
              [-96.00081, 36.99886],
              [-95.96427, 36.999094],
              [-95.936992, 36.999268],
              [-95.928122, 36.999245],
              [-95.91018, 36.999336],
              [-95.877151, 36.999304],
              [-95.875257, 36.999302],
              [-95.873944, 36.9993],
              [-95.866899, 36.999261],
              [-95.80798, 36.999124],
              [-95.786762, 36.99931],
              [-95.768719, 36.999205],
              [-95.759905, 36.999271],
              [-95.741908, 36.999244],
              [-95.718054, 36.999255],
              [-95.714887, 36.999279],
              [-95.71038, 36.999371],
              [-95.696659, 36.999215],
              [-95.686452, 36.999349],
              [-95.664301, 36.999322],
              [-95.630079, 36.99932],
              [-95.62435, 36.99936],
              [-95.615934, 36.999365],
              [-95.61214, 36.999321],
              [-95.573598, 36.99931],
              [-95.534401, 36.999332],
              [-95.522415, 36.999281],
              [-95.511578, 36.999235],
              [-95.407683, 36.999241],
              [-95.407572, 36.999241],
              [-95.33121, 36.99938],
              [-95.328327, 36.999366],
              [-95.328058, 36.999365],
              [-95.322565, 36.999358],
              [-95.195307, 36.999565],
              [-95.177301, 36.99952],
              [-95.155372, 36.99954],
              [-95.155187, 36.999539],
              [-95.073509, 36.999509],
              [-95.073504, 36.999509],
              [-95.049499, 36.99958],
              [-95.037857, 36.999497],
              [-95.030324, 36.999517],
              [-95.011433, 36.999535],
              [-95.00762, 36.999514],
              [-94.995293, 36.999529],
              [-94.853197, 36.998874],
              [-94.849801, 36.998876],
              [-94.840926, 36.998833],
              [-94.83128, 36.998812],
              [-94.777257, 36.998764],
              [-94.739324, 36.998687],
              [-94.737183, 36.998665],
              [-94.71277, 36.998794],
              [-94.701797, 36.998814],
              [-94.699735, 36.998805],
              [-94.61808, 36.998135],
              [-94.618049, 36.996208],
              [-94.618031, 36.994704],
              [-94.618026, 36.950158],
              [-94.618109, 36.946564],
              [-94.618166, 36.937584],
              [-94.618295, 36.929647],
              [-94.618207, 36.926236],
              [-94.618282, 36.911472],
              [-94.618243, 36.897027],
              [-94.618658, 36.880064],
              [-94.61838, 36.84732],
              [-94.618307, 36.76656],
              [-94.61813, 36.701423],
              [-94.618025, 36.66943],
              [-94.618019, 36.667921],
              [-94.617815, 36.612604],
              [-94.617865, 36.606851],
              [-94.617853, 36.59912],
              [-94.617814, 36.577732],
              [-94.617897, 36.536983],
              [-94.617868, 36.53609],
              [-94.617997, 36.53428],
              [-94.617883, 36.517799],
              [-94.617877, 36.514999],
              [-94.617919, 36.499414],
              [-94.55929, 36.499496],
              [-94.519478, 36.499214],
              [-94.111473, 36.498597],
              [-94.110673, 36.498587],
              [-94.100252, 36.49867],
              [-94.098588, 36.498676],
              [-94.077089, 36.49873],
              [-93.96392, 36.498717],
              [-93.95919, 36.498717],
              [-93.92184, 36.498718],
              [-93.906128, 36.498718],
              [-93.866758, 36.498789],
              [-93.728022, 36.499037],
              [-93.727552, 36.499055],
              [-93.718893, 36.499178],
              [-93.709956, 36.499179],
              [-93.700171, 36.499135],
              [-93.584282, 36.498896],
              [-93.584281, 36.498896],
              [-93.514512, 36.498881],
              [-93.507408, 36.498911],
              [-93.426989, 36.498585],
              [-93.396079, 36.498669],
              [-93.394718, 36.498519],
              [-93.315337, 36.498408],
              [-93.315324, 36.498408],
              [-93.296117, 36.498389],
              [-93.088988, 36.498184],
              [-93.087635, 36.498239],
              [-93.069512, 36.498242],
              [-93.068455, 36.49825],
              [-93.013742, 36.49813],
              [-92.894336, 36.497867],
              [-92.894001, 36.49785],
              [-92.854049, 36.497983],
              [-92.838876, 36.498033],
              [-92.838621, 36.498079],
              [-92.772341, 36.497772],
              [-92.772333, 36.497772],
              [-92.529145, 36.497739],
              [-92.318415, 36.497711],
              [-92.309424, 36.497894],
              [-92.216412, 36.498417],
              [-92.214143, 36.498372],
              [-92.211449, 36.498395],
              [-92.199396, 36.498351],
              [-92.150295, 36.498634],
              [-92.137741, 36.498706],
              [-92.120415, 36.498863],
              [-92.120306, 36.498864],
              [-92.098356, 36.498803],
              [-92.074934, 36.498761],
              [-92.057178, 36.49867],
              [-92.055789, 36.49867],
              [-92.028847, 36.498642],
              [-92.019375, 36.498524],
              [-91.988751, 36.498498],
              [-91.985802, 36.498431],
              [-91.865995, 36.498783],
              [-91.864385, 36.498789],
              [-91.805981, 36.498987],
              [-91.80204, 36.498963],
              [-91.7995, 36.498952],
              [-91.784713, 36.499074],
              [-91.766111, 36.499114],
              [-91.726663, 36.499209],
              [-91.687615, 36.499397],
              [-91.686026, 36.499374],
              [-91.672343, 36.499463],
              [-91.64259, 36.499335],
              [-91.631439, 36.499198],
              [-91.601317, 36.499343],
              [-91.596213, 36.499162],
              [-91.549163, 36.499161],
              [-91.539359, 36.499116],
              [-91.53687, 36.499156],
              [-91.529774, 36.499022],
              [-91.450005, 36.497538],
              [-91.446284, 36.497469],
              [-91.436502, 36.497377],
              [-91.433298, 36.497262],
              [-91.407261, 36.497123],
              [-91.407137, 36.497112],
              [-91.405141, 36.497165],
              [-91.404915, 36.49712],
              [-91.227398, 36.497617],
              [-91.218645, 36.497564],
              [-91.21736, 36.497511],
              [-91.126529, 36.497712],
              [-91.096277, 36.497893],
              [-91.09588, 36.49787],
              [-91.017974, 36.498062],
              [-91.008558, 36.49827],
              [-90.963063, 36.498418],
              [-90.960648, 36.498426],
              [-90.87922, 36.498378],
              [-90.876867, 36.498423],
              [-90.876567, 36.498313],
              [-90.873775, 36.498074],
              [-90.850434, 36.498548],
              [-90.784398, 36.498524],
              [-90.782454, 36.498523],
              [-90.765672, 36.498494],
              [-90.711226, 36.498318],
              [-90.693005, 36.49851],
              [-90.653246, 36.498488],
              [-90.648494, 36.498447],
              [-90.612554, 36.498559],
              [-90.60545, 36.498459],
              [-90.5943, 36.498459],
              [-90.585342, 36.498497],
              [-90.57618, 36.498446],
              [-90.576112, 36.498446],
              [-90.50016, 36.498399],
              [-90.495027, 36.498371],
              [-90.494575, 36.498368],
              [-90.339892, 36.498213],
              [-90.228943, 36.497771],
              [-90.220732, 36.497858],
              [-90.220702, 36.497858],
              [-90.217323, 36.497797],
              [-90.193943, 36.497823],
              [-90.152481, 36.497952],
              [-90.154409, 36.496832],
              [-90.156369, 36.487748],
              [-90.133993, 36.437906],
              [-90.072897, 36.393007],
              [-90.064514, 36.382085],
              [-90.06398, 36.303038],
              [-90.076301, 36.280708],
              [-90.083731, 36.272332],
              [-90.114922, 36.265595],
              [-90.198735, 36.201382],
              [-90.220425, 36.184764],
              [-90.319168, 36.089976],
              [-90.36443, 36.013625],
              [-90.368718, 35.995812],
              [-90.342616, 35.995895],
              [-90.339434, 35.996033],
              [-90.292376, 35.996397],
              [-90.288947, 35.996418],
              [-90.2888, 35.996419],
              [-90.158812, 35.997375],
              [-90.127331, 35.997635],
              [-90.12635, 35.997596],
              [-89.972563, 35.998994],
              [-89.965327, 35.998813],
              [-89.961075, 35.999135],
              [-89.959893, 35.99902],
              [-89.959377, 35.99902],
              [-89.959375, 35.99902],
              [-89.901183, 35.999365],
              [-89.896508, 35.999432],
              [-89.875586, 35.999562],
              [-89.875085, 35.999578],
              [-89.87459, 35.999575],
              [-89.86901, 35.99964],
              [-89.770255, 36.000524],
              [-89.769973, 36.000536],
              [-89.737648, 36.000567],
              [-89.737564, 36.000522],
              [-89.733095, 36.000608],
              [-89.706932, 36.000981],
              [-89.690306, 36.024835],
              [-89.687254, 36.034048],
              [-89.684439, 36.051719],
              [-89.624235, 36.108626],
              [-89.601936, 36.11947],
              [-89.594, 36.12719],
              [-89.591605, 36.144096],
              [-89.594397, 36.155457],
              [-89.607004, 36.171179],
              [-89.618228, 36.179966],
              [-89.629452, 36.185382],
              [-89.699817, 36.248384],
              [-89.691308, 36.252079],
              [-89.678046, 36.248284],
              [-89.602374, 36.238106],
              [-89.589561, 36.239116],
              [-89.541621, 36.247891],
              [-89.534745, 36.252576],
              [-89.535529, 36.270541],
              [-89.539487, 36.277368],
              [-89.544797, 36.280458],
              [-89.554289, 36.277751],
              [-89.578492, 36.288317],
              [-89.611819, 36.309088],
              [-89.620255, 36.323006],
              [-89.6198, 36.329546],
              [-89.615841, 36.336085],
              [-89.610689, 36.340442],
              [-89.605668, 36.342234],
              [-89.581636, 36.342357],
              [-89.560439, 36.337746],
              [-89.545006, 36.336809],
              [-89.531822, 36.339246],
              [-89.519, 36.3486],
              [-89.513178, 36.359897],
              [-89.509558, 36.375065],
              [-89.519501, 36.475419],
              [-89.522674, 36.481305],
              [-89.5391, 36.498201],
              [-89.560344, 36.525436],
              [-89.570071, 36.544387],
              [-89.571509, 36.552569],
              [-89.566817, 36.564216],
              [-89.55264, 36.577178],
              [-89.546113, 36.579989],
              [-89.527583, 36.581147],
              [-89.500076, 36.576305],
              [-89.484836, 36.571821],
              [-89.479093, 36.568206],
              [-89.473341, 36.559918],
              [-89.467761, 36.546847],
              [-89.465445, 36.536163],
              [-89.465888, 36.529946],
              [-89.47246, 36.513741],
              [-89.485106, 36.497692],
              [-89.493495, 36.4787],
              [-89.493198, 36.470124],
              [-89.486215, 36.46162],
              [-89.471718, 36.457001],
              [-89.460436, 36.45814],
              [-89.448468, 36.46442],
              [-89.429311, 36.481875],
              [-89.417293, 36.499033],
              [-89.400581, 36.538337],
              [-89.38814, 36.573416],
              [-89.376367, 36.613868],
              [-89.365548, 36.625059],
              [-89.343753, 36.630991],
              [-89.327578, 36.632127],
              [-89.326731, 36.632186],
              [-89.313405, 36.62012],
              [-89.294637, 36.593729],
              [-89.27171, 36.571387],
              [-89.259994, 36.565149],
              [-89.236542, 36.566824],
              [-89.227319, 36.569375],
              [-89.213563, 36.580119],
              [-89.202607, 36.601576],
              [-89.200902, 36.618177],
              [-89.197654, 36.628936],
              [-89.187749, 36.641115],
              [-89.174741, 36.650416],
              [-89.174733, 36.650476],
              [-89.171882, 36.672526],
              [-89.19948, 36.716045],
              [-89.201047, 36.725772],
              [-89.197808, 36.739412],
              [-89.184523, 36.753638],
              [-89.169106, 36.759473],
              [-89.142313, 36.755369],
              [-89.130399, 36.751702],
              [-89.123548, 36.78522],
              [-89.12353, 36.785309],
              [-89.179229, 36.812915],
              [-89.178574, 36.816554],
              [-89.177177, 36.835779],
              [-89.147674, 36.847148],
              [-89.100766, 36.943973],
              [-89.100794, 36.944006],
              [-89.132685, 36.9822],
              [-89.166447, 37.003337],
              [-89.173595, 37.011409],
              [-89.178975, 37.020928],
              [-89.182509, 37.037275],
              [-89.181369, 37.046305],
              [-89.175725, 37.062069],
              [-89.171881, 37.068184],
              [-89.168087, 37.074218],
              [-89.086526, 37.165602],
              [-89.041263, 37.202881],
              [-89.000968, 37.224401],
              [-88.98326, 37.228685],
              [-88.966831, 37.229891],
              [-88.933399, 37.225007],
              [-88.933385, 37.225005],
              [-88.942111, 37.228811],
              [-88.928021, 37.226281],
              [-88.916934, 37.224291],
              [-88.809206, 37.189235],
              [-88.625889, 37.119458],
              [-88.589207, 37.099655],
              [-88.576718, 37.085852],
              [-88.564152, 37.07844],
              [-88.560032, 37.07601],
              [-88.545403, 37.070003],
              [-88.531576, 37.067192],
              [-88.514356, 37.065231],
              [-88.490297, 37.066669],
              [-88.482856, 37.067114],
              [-88.458948, 37.073796],
              [-88.444605, 37.098601],
              [-88.424403, 37.152428],
              [-88.447764, 37.203527],
              [-88.458763, 37.213536],
              [-88.471753, 37.220155],
              [-88.509328, 37.26213],
              [-88.515939, 37.284043],
              [-88.514661, 37.290948],
              [-88.476592, 37.386875],
              [-88.470224, 37.396255],
              [-88.456, 37.408482],
              [-88.439333, 37.416416],
              [-88.414895, 37.423461],
              [-88.408808, 37.425216],
              [-88.358436, 37.40486],
              [-88.330622, 37.429316],
              [-88.312585, 37.440591],
              [-88.281667, 37.452596],
              [-88.255193, 37.456748],
              [-88.083395, 37.473683],
              [-88.062562, 37.489385],
              [-88.061292, 37.505232],
              [-88.061311, 37.505332],
              [-88.063311, 37.515755],
              [-88.072242, 37.528826],
              [-88.121517, 37.568166],
              [-88.133235, 37.574154],
              [-88.133306, 37.574191],
              [-88.133393, 37.574235],
              [-88.133416, 37.574277],
              [-88.139973, 37.586451],
              [-88.156827, 37.632801],
              [-88.160187, 37.657592],
              [-88.158207, 37.664542],
              [-88.151646, 37.675098],
              [-88.122412, 37.709685],
              [-88.072538, 37.733286],
              [-88.059588, 37.742608],
              [-88.050969, 37.752599],
              [-88.045008, 37.762436],
              [-88.039, 37.775454],
              [-88.02803, 37.799224],
              [-88.017314, 37.801911],
              [-88.004706, 37.800145],
              [-87.976389, 37.788004],
              [-87.970869, 37.783456],
              [-87.943756, 37.776843],
              [-87.90681, 37.807624],
              [-87.903804, 37.817762],
              [-87.907773, 37.837611],
              [-87.910276, 37.843416],
              [-87.914892, 37.849618],
              [-87.927303, 37.858709],
              [-87.936228, 37.867937],
              [-87.940005, 37.875044],
              [-87.940839, 37.883338],
              [-87.940069, 37.88767],
              [-87.936784, 37.892587],
              [-87.927424, 37.902038],
              [-87.904789, 37.924892],
              [-87.898062, 37.927514],
              [-87.883321, 37.926238],
              [-87.87254, 37.920999],
              [-87.865558, 37.915056],
              [-87.857243, 37.900649],
              [-87.841193, 37.882325],
              [-87.830578, 37.876516],
              [-87.7909, 37.875714],
              [-87.783643, 37.877759],
              [-87.76226, 37.890906],
              [-87.700421, 37.900858],
              [-87.684018, 37.903498],
              [-87.67573, 37.90193],
              [-87.666481, 37.895786],
              [-87.662865, 37.885578],
              [-87.681633, 37.855917],
              [-87.6819, 37.84641],
              [-87.679188, 37.836321],
              [-87.670889, 37.828429],
              [-87.645858, 37.825899],
              [-87.615399, 37.831974],
              [-87.606599, 37.838669],
              [-87.591504, 37.856642],
              [-87.588729, 37.860984],
              [-87.588426, 37.868791],
              [-87.591582, 37.887194],
              [-87.597118, 37.892394],
              [-87.620272, 37.906922],
              [-87.626256, 37.916138],
              [-87.62896, 37.926714],
              [-87.601416, 37.972542],
              [-87.592916, 37.975842],
              [-87.585916, 37.975442],
              [-87.581115, 37.973442],
              [-87.574715, 37.967742],
              [-87.573415, 37.962642],
              [-87.574287, 37.954842],
              [-87.57203, 37.947466],
              [-87.559342, 37.931146],
              [-87.550333, 37.92489],
              [-87.511499, 37.906426],
              [-87.451185, 37.941034],
              [-87.450458, 37.941451],
              [-87.436859, 37.944192],
              [-87.418585, 37.944763],
              [-87.402632, 37.942267],
              [-87.380247, 37.935596],
              [-87.302324, 37.898445],
              [-87.269561, 37.877155],
              [-87.26293, 37.872846],
              [-87.20224, 37.843791],
              [-87.132621, 37.791008],
              [-87.128749, 37.785728],
              [-87.119229, 37.782848],
              [-87.111133, 37.782512],
              [-87.090636, 37.787808],
              [-87.077404, 37.796209],
              [-87.067836, 37.806065],
              [-87.057836, 37.827457],
              [-87.043854, 37.870796],
              [-87.043407, 37.87994],
              [-87.046237, 37.889866],
              [-87.042249, 37.898291],
              [-87.033444, 37.906593],
              [-87.010315, 37.919668],
              [-86.978957, 37.9302],
              [-86.97883, 37.930214],
              [-86.919329, 37.936664],
              [-86.902413, 37.946161],
              [-86.884961, 37.964373],
              [-86.85595, 37.987292],
              [-86.823491, 37.998939],
              [-86.815267, 37.998877],
              [-86.814776, 37.998638],
              [-86.794985, 37.988982],
              [-86.787695, 37.971449],
              [-86.770179, 37.940264],
              [-86.75099, 37.912893],
              [-86.740877, 37.902568],
              [-86.73146, 37.89434],
              [-86.72351, 37.892831],
              [-86.718462, 37.893123],
              [-86.709164, 37.89764],
              [-86.660293, 37.865057],
              [-86.655296, 37.842508],
              [-86.655285, 37.842506],
              [-86.648028, 37.841425],
              [-86.634271, 37.843845],
              [-86.604624, 37.858272],
              [-86.525174, 37.968228],
              [-86.524969, 38.027879],
              [-86.521825, 38.038327],
              [-86.517289, 38.042634],
              [-86.51176, 38.044448],
              [-86.490858, 38.045796],
              [-86.490853, 38.045796],
              [-86.466876, 38.046597],
              [-86.452192, 38.05049],
              [-86.438236, 38.060426],
              [-86.432789, 38.067171],
              [-86.430091, 38.078638],
              [-86.426508, 38.081784],
              [-86.398661, 38.106238],
              [-86.332567, 38.130131],
              [-86.326788, 38.134604],
              [-86.323453, 38.139032],
              [-86.314292, 38.14261],
              [-86.309727, 38.144393],
              [-86.283964, 38.143185],
              [-86.271223, 38.130112],
              [-86.278034, 38.102426],
              [-86.27872, 38.089303],
              [-86.273584, 38.067443],
              [-86.266891, 38.057125],
              [-86.220371, 38.027922],
              [-86.178983, 38.011308],
              [-86.172186, 38.00992],
              [-86.029509, 37.99264],
              [-85.998609, 37.997775],
              [-85.951467, 38.005608],
              [-85.947952, 38.007083],
              [-85.941403, 38.009831],
              [-85.930235, 38.018311],
              [-85.922395, 38.028679],
              [-85.911607, 38.06689],
              [-85.906163, 38.08617],
              [-85.904564, 38.10027],
              [-85.905164, 38.11107],
              [-85.909464, 38.14007],
              [-85.908764, 38.161169],
              [-85.89955, 38.180343],
              [-85.897664, 38.184269],
              [-85.829364, 38.276769],
              [-85.823764, 38.280569],
              [-85.816164, 38.282969],
              [-85.791575, 38.288566],
              [-85.791563, 38.288569],
              [-85.780963, 38.288469],
              [-85.773363, 38.286169],
              [-85.765963, 38.280469],
              [-85.766563, 38.27767],
              [-85.761062, 38.27257],
              [-85.750962, 38.26787],
              [-85.744862, 38.26717],
              [-85.683561, 38.295469],
              [-85.675017, 38.301317],
              [-85.653641, 38.327108],
              [-85.638777, 38.361443],
              [-85.638044, 38.38027],
              [-85.638041, 38.380338],
              [-85.632937, 38.395666],
              [-85.620521, 38.423105],
              [-85.607629, 38.439295],
              [-85.462518, 38.512602],
              [-85.433136, 38.523914],
              [-85.432928, 38.524072],
              [-85.423077, 38.531581],
              [-85.417322, 38.540763],
              [-85.4156, 38.546341],
              [-85.415821, 38.563558],
              [-85.427467, 38.586735],
              [-85.439351, 38.610388],
              [-85.456978, 38.689135],
              [-85.452114, 38.709348],
              [-85.434065, 38.729455],
              [-85.422021, 38.734834],
              [-85.410925, 38.73708],
              [-85.333285, 38.74048],
              [-85.289226, 38.74241],
              [-85.275454, 38.741172],
              [-85.258846, 38.737754],
              [-85.246505, 38.731821],
              [-85.226062, 38.705456],
              [-85.213257, 38.695446],
              [-85.201498, 38.691575],
              [-85.189362, 38.687579],
              [-85.172528, 38.688082],
              [-85.156158, 38.692251],
              [-85.13868, 38.699168],
              [-85.106902, 38.720789],
              [-85.100963, 38.7268],
              [-85.024205, 38.763311],
              [-84.995939, 38.776756],
              [-84.984627, 38.779072],
              [-84.973432, 38.778847],
              [-84.944296, 38.775184],
              [-84.844412, 38.787078],
              [-84.81335, 38.79833],
              [-84.791078, 38.855859],
              [-84.785799, 38.869496],
              [-84.785111, 38.879988],
              [-84.789521, 38.884687],
              [-84.813182, 38.930583],
              [-84.849445, 39.000923],
              [-84.878614, 39.030296],
              [-84.889065, 39.04082],
              [-84.897171, 39.052407],
              [-84.897364, 39.057378],
              [-84.888873, 39.066376],
              [-84.831197, 39.10192],
              [-84.820157, 39.10548],
              [-84.78768, 39.115297],
              [-84.766749, 39.138558],
              [-84.754449, 39.146658],
              [-84.744149, 39.147458],
              [-84.732048, 39.144458],
              [-84.718548, 39.137059],
              [-84.689747, 39.104159],
              [-84.684847, 39.100459],
              [-84.632446, 39.07676],
              [-84.623732, 39.074427],
              [-84.620112, 39.073457],
              [-84.603444, 39.073699],
              [-84.510057, 39.093593],
              [-84.509743, 39.09366],
              [-84.506082, 39.095081],
              [-84.502062, 39.096641],
              [-84.493743, 39.10246],
              [-84.432841, 39.094261],
              [-84.326539, 39.027463],
              [-84.319936, 39.022081],
              [-84.31368, 39.016981],
              [-84.304698, 39.006455],
              [-84.234453, 38.893226],
              [-84.232132, 38.880483],
              [-84.232478, 38.874638],
              [-84.233727, 38.853576],
              [-84.231306, 38.830552],
              [-84.229954, 38.82765],
              [-84.2253, 38.817665],
              [-84.212904, 38.805707],
              [-84.205592, 38.802588],
              [-84.071491, 38.770475],
              [-84.052707, 38.770542],
              [-84.044486, 38.770572],
              [-83.978814, 38.787104],
              [-83.962123, 38.787384],
              [-83.943978, 38.783616],
              [-83.903971, 38.76816],
              [-83.903918, 38.76815],
              [-83.870443, 38.761608],
              [-83.859028, 38.756793],
              [-83.85333, 38.752572],
              [-83.777823, 38.674453],
              [-83.773682, 38.661309],
              [-83.769347, 38.65522],
              [-83.762445, 38.652103],
              [-83.706043, 38.637101],
              [-83.679484, 38.630036],
              [-83.663911, 38.62793],
              [-83.655425, 38.629735],
              [-83.649737, 38.632753],
              [-83.646701, 38.637489],
              [-83.642994, 38.643273],
              [-83.636208, 38.670584],
              [-83.626922, 38.679387],
              [-83.615736, 38.684145],
              [-83.574754, 38.692671],
              [-83.533339, 38.702105],
              [-83.520953, 38.703045],
              [-83.512571, 38.701716],
              [-83.369077, 38.659334],
              [-83.333347, 38.641562],
              [-83.324157, 38.633326],
              [-83.320531, 38.622713],
              [-83.2821, 38.602987],
              [-83.265769, 38.605278],
              [-83.156926, 38.620547],
              [-83.142836, 38.625076],
              [-83.135046, 38.631719],
              [-83.127652, 38.642451],
              [-83.030889, 38.72556],
              [-83.030702, 38.72572],
              [-83.011816, 38.730057],
              [-82.979395, 38.725976],
              [-82.968695, 38.728776],
              [-82.943147, 38.74328],
              [-82.923694, 38.750076],
              [-82.894193, 38.756576],
              [-82.889193, 38.756076],
              [-82.879492, 38.751476],
              [-82.875492, 38.747276],
              [-82.874466, 38.745346],
              [-82.871292, 38.739376],
              [-82.869992, 38.730477],
              [-82.870392, 38.722077],
              [-82.873492, 38.710077],
              [-82.869592, 38.678177],
              [-82.853554, 38.610926],
              [-82.847186, 38.595166],
              [-82.839538, 38.586159],
              [-82.820161, 38.572703],
              [-82.816012, 38.570733],
              [-82.800112, 38.563183],
              [-82.789776, 38.559951],
              [-82.730958, 38.559264],
              [-82.724846, 38.5576],
              [-82.696621, 38.542112],
              [-82.690509, 38.536576],
              [-82.665548, 38.505808],
              [-82.665485, 38.505734],
              [-82.593673, 38.421809],
              [-82.560664, 38.404338],
              [-82.520178, 38.407582],
              [-82.50667, 38.410092],
              [-82.34064, 38.440948],
              [-82.330335, 38.4445],
              [-82.323999, 38.449268],
              [-82.320223, 38.454516],
              [-82.313935, 38.468084],
              [-82.295571, 38.539783],
              [-82.293271, 38.560283],
              [-82.293871, 38.572683],
              [-82.291271, 38.578983],
              [-82.287102, 38.582588],
              [-82.27427, 38.593683],
              [-82.26207, 38.598183],
              [-82.245969, 38.598483],
              [-82.218967, 38.591683],
              [-82.193824, 38.593096],
              [-82.181967, 38.599384],
              [-82.177267, 38.603784],
              [-82.175167, 38.608484],
              [-82.172066, 38.619284],
              [-82.172066, 38.625984],
              [-82.182467, 38.708782],
              [-82.188268, 38.734082],
              [-82.198882, 38.757725],
              [-82.220449, 38.773739],
              [-82.221566, 38.787187],
              [-82.215759, 38.797462],
              [-82.191172, 38.815137],
              [-82.184428, 38.816529],
              [-82.139279, 38.866407],
              [-82.098762, 38.958288],
              [-82.093165, 38.97098],
              [-82.051563, 38.994378],
              [-82.045663, 39.003778],
              [-82.041563, 39.017878],
              [-82.035963, 39.025478],
              [-82.017562, 39.030078],
              [-82.002261, 39.027878],
              [-81.935619, 38.9895],
              [-81.919783, 38.968494],
              [-81.900595, 38.937671],
              [-81.89847, 38.929603],
              [-81.90091, 38.924338],
              [-81.926671, 38.901311],
              [-81.928352, 38.895371],
              [-81.926967, 38.891602],
              [-81.908645, 38.87846],
              [-81.874857, 38.881174],
              [-81.759995, 38.925828],
              [-81.756131, 38.933545],
              [-81.764253, 39.015279],
              [-81.772854, 39.026179],
              [-81.793304, 39.040353],
              [-81.803355, 39.047678],
              [-81.811655, 39.059578],
              [-81.814155, 39.073478],
              [-81.812355, 39.082078],
              [-81.747253, 39.095378],
              [-81.747253, 39.095379],
              [-81.749689, 39.180742],
              [-81.749853, 39.186489],
              [-81.740061, 39.190652],
              [-81.721551, 39.212448],
              [-81.695724, 39.242859],
              [-81.605816, 39.275851],
              [-81.542346, 39.352874],
              [-81.467744, 39.403774],
              [-81.456143, 39.409274],
              [-81.446543, 39.410374],
              [-81.435642, 39.408474],
              [-81.412706, 39.394618],
              [-81.406689, 39.38809],
              [-81.393794, 39.351706],
              [-81.384556, 39.343449],
              [-81.375961, 39.341697],
              [-81.371271, 39.342062],
              [-81.356911, 39.343178],
              [-81.347567, 39.34577],
              [-81.295373, 39.37529],
              [-81.270716, 39.385914],
              [-81.249088, 39.389992],
              [-81.223581, 39.386062],
              [-81.215617, 39.388602],
              [-81.127696, 39.464879],
              [-81.063587, 39.520497],
              [-81.038691, 39.540464],
              [-81.020055, 39.55541],
              [-80.943782, 39.606926],
              [-80.892208, 39.616756],
              [-80.88036, 39.620706],
              [-80.831871, 39.705655],
              [-80.829764, 39.711839],
              [-80.828618, 39.720848],
              [-80.812342, 39.848845],
              [-80.806179, 39.897306],
              [-80.809619, 39.905626],
              [-80.808722, 39.91257],
              [-80.806018, 39.91713],
              [-80.759455, 39.958233],
              [-80.743166, 39.969113],
              [-80.740126, 39.970793],
              [-80.732051, 40.03324],
              [-80.731504, 40.037472],
              [-80.730904, 40.049172],
              [-80.733104, 40.058772],
              [-80.726504, 40.089072],
              [-80.705482, 40.153047],
              [-80.703052, 40.157231],
              [-80.685391, 40.187642],
              [-80.652098, 40.24497],
              [-80.644598, 40.25127],
              [-80.637198, 40.25507],
              [-80.616696, 40.28027],
              [-80.602895, 40.307069],
              [-80.599895, 40.317669],
              [-80.609313, 40.360468],
              [-80.619196, 40.381768],
              [-80.617346, 40.396004],
              [-80.612295, 40.434867],
              [-80.599194, 40.482566],
              [-80.610259, 40.490962],
              [-80.666917, 40.573664],
              [-80.667957, 40.582496],
              [-80.665892, 40.587728],
              [-80.634355, 40.616095],
              [-80.627171, 40.619936],
              [-80.601494, 40.625387],
              [-80.594065, 40.623664],
              [-80.589041, 40.620128],
              [-80.56072, 40.62368],
              [-80.518991, 40.638801],
              [-80.519058, 40.792298],
              [-80.518992, 40.801221],
              [-80.519081, 40.849157],
              [-80.51902, 40.850073],
              [-80.519039, 40.851339],
              [-80.519764, 40.899858],
              [-80.51979, 40.900761],
              [-80.519091, 40.921061],
              [-80.519, 40.98738],
              [-80.518989, 40.995445],
              [-80.518927, 41.015387],
              [-80.51896, 41.061546],
              [-80.518928, 41.070954],
              [-80.51896, 41.071866],
              [-80.518999, 41.075014],
              [-80.519088, 41.082074],
              [-80.519092, 41.090658],
              [-80.519125, 41.100819],
              [-80.519192, 41.105358],
              [-80.518992, 41.115958],
              [-80.519056, 41.125057],
              [-80.519012, 41.125057],
              [-80.519012, 41.125093],
              [-80.519012, 41.125116],
              [-80.519167, 41.133343],
              [-80.519167, 41.133388],
              [-80.519115, 41.14552],
              [-80.519144, 41.171203],
              [-80.51883, 41.209213],
              [-80.518893, 41.219356],
              [-80.518893, 41.219357],
              [-80.518893, 41.232556],
              [-80.518693, 41.248855],
              [-80.518893, 41.265155],
              [-80.518993, 41.268155],
              [-80.518996, 41.2683],
              [-80.518794, 41.305509],
              [-80.519129, 41.312408],
              [-80.519265, 41.333495],
              [-80.519281, 41.335958],
              [-80.519281, 41.337145],
              [-80.519281, 41.337174],
              [-80.519311, 41.339052],
              [-80.519293, 41.339054],
              [-80.519293, 41.339654],
              [-80.519345, 41.340145],
              [-80.519345, 41.34074],
              [-80.519297, 41.350833],
              [-80.519249, 41.36103],
              [-80.519217, 41.372006],
              [-80.519249, 41.378918],
              [-80.519025, 41.416438],
              [-80.518993, 41.416437],
              [-80.518993, 41.435454],
              [-80.519169, 41.462581],
              [-80.519209, 41.489013],
              [-80.519225, 41.499924],
              [-80.519157, 41.528769],
              [-80.519339, 41.539297],
              [-80.519357, 41.669767],
              [-80.519424, 41.671228],
              [-80.519373, 41.701473],
              [-80.519408, 41.739359],
              [-80.519369, 41.752487],
              [-80.519239, 41.765138],
              [-80.519294, 41.849563],
              [-80.519345, 41.929168],
              [-80.519304, 41.943992],
              [-80.519405, 41.976158],
              [-80.519425, 41.977522],
              [-80.519425, 41.977523],
              [-80.519461, 41.977513],
              [-80.522057, 41.97678],
              [-80.525521, 41.975803],
              [-80.529274, 41.974744],
              [-80.530164, 41.974493],
              [-80.53139, 41.974147],
              [-80.533774, 41.973475],
              [-80.553836, 41.967815],
              [-80.555898, 41.967065],
              [-80.560671, 41.965328],
              [-80.563327, 41.964362],
              [-80.572028, 41.961196],
              [-80.5755, 41.959932],
              [-80.576591, 41.959535],
              [-80.576735, 41.959483],
              [-80.579439, 41.958499],
              [-80.581882, 41.95761],
              [-80.60861, 41.950325],
              [-80.619242, 41.947428],
              [-80.619443, 41.947373],
              [-80.635576, 41.942976],
              [-80.693429, 41.927208],
              [-80.699363, 41.925591],
              [-80.708293, 41.923157],
              [-80.712218, 41.922087],
              [-80.717469, 41.920656],
              [-80.720816, 41.919744],
              [-80.727504, 41.918593],
              [-80.757945, 41.913352],
              [-80.762176, 41.912173],
              [-80.766046, 41.911095],
              [-80.76802, 41.910545],
              [-80.770756, 41.909782],
              [-80.771784, 41.909496],
              [-80.77709, 41.908018],
              [-80.781112, 41.906897],
              [-80.782052, 41.906635],
              [-80.782944, 41.908294],
              [-80.784682, 41.911525],
              [-80.785497, 41.911429],
              [-80.78641, 41.911322],
              [-80.794388, 41.910386],
              [-80.798311, 41.909926],
              [-80.799822, 41.909749],
              [-80.800794, 41.909635],
              [-80.801436, 41.908982],
              [-80.806133, 41.904211],
              [-80.80801, 41.902304],
              [-80.808697, 41.901606],
              [-80.812659, 41.899125],
              [-80.81324, 41.89876],
              [-80.814943, 41.897694],
              [-80.816444, 41.897188],
              [-80.819165, 41.896271],
              [-80.826889, 41.893668],
              [-80.852064, 41.885183],
              [-80.853542, 41.884685],
              [-80.900342, 41.868912],
              [-80.916528, 41.865954],
              [-80.936244, 41.862352],
              [-80.958494, 41.859838],
              [-80.971141, 41.858409],
              [-80.973674, 41.858122],
              [-80.991799, 41.856074],
              [-81.002117, 41.854908],
              [-81.002663, 41.854846],
              [-81.01049, 41.853962],
              [-81.024525, 41.846469],
              [-81.05192, 41.839557],
              [-81.092716, 41.822988],
              [-81.095592, 41.822216],
              [-81.098931, 41.821319],
              [-81.112885, 41.817571],
              [-81.122295, 41.813503],
              [-81.167638, 41.793903],
              [-81.183328, 41.78712],
              [-81.184368, 41.786671],
              [-81.192684, 41.783389],
              [-81.201721, 41.779822],
              [-81.202359, 41.77957],
              [-81.247607, 41.761712],
              [-81.247832, 41.761623],
              [-81.248609, 41.761316],
              [-81.248672, 41.761291],
              [-81.251918, 41.760634],
              [-81.252977, 41.76042],
              [-81.25552, 41.759905],
              [-81.259349, 41.75913],
              [-81.26311, 41.758369],
              [-81.263751, 41.758239],
              [-81.264224, 41.758143],
              [-81.265576, 41.758298],
              [-81.279187, 41.759859],
              [-81.279925, 41.759944],
              [-81.286925, 41.760243],
              [-81.288892, 41.758945],
              [-81.301626, 41.750543],
              [-81.306495, 41.748392],
              [-81.30701, 41.748164],
              [-81.309499, 41.747064],
              [-81.330154, 41.737938],
              [-81.353229, 41.727743],
              [-81.367498, 41.719441],
              [-81.36867, 41.718759],
              [-81.368913, 41.718618],
              [-81.372587, 41.71648],
              [-81.373666, 41.715852],
              [-81.374454, 41.715393],
              [-81.374509, 41.715361],
              [-81.380935, 41.711622],
              [-81.388269, 41.707355],
              [-81.388632, 41.707144],
              [-81.400617, 41.699624],
              [-81.400686, 41.699581],
              [-81.402417, 41.698495],
              [-81.404476, 41.697203],
              [-81.406098, 41.696185],
              [-81.407984, 41.695002],
              [-81.413062, 41.691816],
              [-81.431441, 41.680285],
              [-81.435582, 41.677686],
              [-81.437014, 41.676788],
              [-81.437809, 41.676289],
              [-81.438971, 41.67556],
              [-81.441339, 41.674074],
              [-81.441803, 41.673783],
              [-81.442552, 41.673314],
              [-81.442645, 41.673255],
              [-81.44272, 41.673178],
              [-81.442843, 41.673051],
              [-81.443647, 41.672222],
              [-81.447734, 41.668011],
              [-81.452461, 41.663139],
              [-81.466038, 41.649148],
              [-81.477544, 41.640086],
              [-81.486919, 41.632704],
              [-81.48864, 41.631348],
              [-81.50044, 41.623448],
              [-81.509359, 41.620739],
              [-81.520707, 41.617292],
              [-81.527026, 41.615373],
              [-81.529742, 41.614548],
              [-81.529955, 41.614374],
              [-81.531612, 41.613023],
              [-81.531674, 41.612972],
              [-81.562844, 41.587549],
              [-81.575577, 41.578267],
              [-81.575715, 41.578167],
              [-81.577459, 41.576896],
              [-81.578666, 41.576016],
              [-81.579285, 41.575565],
              [-81.579727, 41.575243],
              [-81.579746, 41.575228],
              [-81.579815, 41.575178],
              [-81.591471, 41.566682],
              [-81.591981, 41.56631],
              [-81.593092, 41.5655],
              [-81.593144, 41.565462],
              [-81.599747, 41.560649],
              [-81.60967, 41.55474],
              [-81.610163, 41.554446],
              [-81.615816, 41.551079],
              [-81.616567, 41.550633],
              [-81.61691, 41.550428],
              [-81.627431, 41.544163],
              [-81.633652, 41.540458],
              [-81.641055, 41.538321],
              [-81.648453, 41.536185],
              [-81.649872, 41.535775],
              [-81.664851, 41.53145],
              [-81.664884, 41.53143],
              [-81.688058, 41.517321],
              [-81.691248, 41.515379],
              [-81.69325, 41.514161],
              [-81.706864, 41.505872],
              [-81.707622, 41.505108],
              [-81.710953, 41.50175],
              [-81.710986, 41.501734],
              [-81.71559, 41.499549],
              [-81.716836, 41.498957],
              [-81.71931, 41.497782],
              [-81.725763, 41.494718],
              [-81.726429, 41.494402],
              [-81.727806, 41.493749],
              [-81.732674, 41.491437],
              [-81.738755, 41.48855],
              [-81.741852, 41.487827],
              [-81.744272, 41.487263],
              [-81.744755, 41.48715],
              [-81.745818, 41.487348],
              [-81.746095, 41.4874],
              [-81.75861, 41.489736],
              [-81.762489, 41.49046],
              [-81.768856, 41.491649],
              [-81.768898, 41.491663],
              [-81.782258, 41.49605],
              [-81.794157, 41.496648],
              [-81.794449, 41.49663],
              [-81.799746, 41.496311],
              [-81.800253, 41.496281],
              [-81.801207, 41.496223],
              [-81.810758, 41.495648],
              [-81.810992, 41.495592],
              [-81.836059, 41.489614],
              [-81.837092, 41.489367],
              [-81.850141, 41.486255],
              [-81.860262, 41.483841],
              [-81.87736, 41.483445],
              [-81.928652, 41.490226],
              [-81.930404, 41.490457],
              [-81.937862, 41.491443],
              [-81.958463, 41.498642],
              [-81.962664, 41.501341],
              [-81.964912, 41.505446],
              [-81.96813, 41.506422],
              [-81.994565, 41.51444],
              [-82.011966, 41.515639],
              [-82.094169, 41.495039],
              [-82.165373, 41.47444],
              [-82.181598, 41.471634],
              [-82.184774, 41.47404],
              [-82.186174, 41.47344],
              [-82.18885, 41.468097],
              [-82.193375, 41.46454],
              [-82.254678, 41.434441],
              [-82.268479, 41.430842],
              [-82.283488, 41.429283],
              [-82.29158, 41.428442],
              [-82.334182, 41.430243],
              [-82.348076, 41.428431],
              [-82.361784, 41.426644],
              [-82.398086, 41.413945],
              [-82.431315, 41.396866],
              [-82.460599, 41.386316],
              [-82.481214, 41.381342],
              [-82.499099, 41.381541],
              [-82.513827, 41.384257],
              [-82.55808, 41.400005],
              [-82.616952, 41.428425],
              [-82.617745, 41.431833],
              [-82.658302, 41.461878],
              [-82.687921, 41.492324],
              [-82.694722, 41.493945],
              [-82.710013, 41.49759],
              [-82.713904, 41.501697],
              [-82.719811, 41.510296],
              [-82.719956, 41.510735],
              [-82.721914, 41.516677],
              [-82.716492, 41.522227],
              [-82.711632, 41.527201],
              [-82.710967, 41.536221],
              [-82.710935, 41.536648],
              [-82.711332, 41.53695],
              [-82.715227, 41.539913],
              [-82.717595, 41.541715],
              [-82.717878, 41.54193],
              [-82.720539, 41.542307],
              [-82.722069, 41.542524],
              [-82.727656, 41.543316],
              [-82.728489, 41.543434],
              [-82.730516, 41.543721],
              [-82.731628, 41.543879],
              [-82.7319, 41.543918],
              [-82.732886, 41.544057],
              [-82.739868, 41.545047],
              [-82.749907, 41.54647],
              [-82.77201, 41.54058],
              [-82.785496, 41.540675],
              [-82.794324, 41.546486],
              [-82.820207, 41.570664],
              [-82.834101, 41.587587],
              [-82.847657, 41.585639],
              [-82.852957, 41.583327],
              [-82.854263, 41.581945],
              [-82.856919, 41.579135],
              [-82.857316, 41.578714],
              [-82.857945, 41.578049],
              [-82.859531, 41.576371],
              [-82.858702, 41.574025],
              [-82.856647, 41.568216],
              [-82.856088, 41.566633],
              [-82.855197, 41.564114],
              [-82.856533, 41.55065],
              [-82.85677, 41.548262],
              [-82.857841, 41.547051],
              [-82.861323, 41.543116],
              [-82.866262, 41.537534],
              [-82.869422, 41.533962],
              [-82.875229, 41.529684],
              [-82.882305, 41.52577],
              [-82.8882, 41.522508],
              [-82.896854, 41.519541],
              [-82.897728, 41.519241],
              [-82.934369, 41.514353],
              [-82.958481, 41.521104],
              [-82.969574, 41.52421],
              [-82.969642, 41.524229],
              [-82.96985, 41.524327],
              [-82.999897, 41.538525],
              [-82.999916, 41.538534],
              [-83.016753, 41.548773],
              [-83.017473, 41.549211],
              [-83.019057, 41.550174],
              [-83.028072, 41.555656],
              [-83.030764, 41.557864],
              [-83.031653, 41.558592],
              [-83.042909, 41.567823],
              [-83.043079, 41.567963],
              [-83.043287, 41.568205],
              [-83.048222, 41.573951],
              [-83.066593, 41.59534],
              [-83.086036, 41.60668],
              [-83.103928, 41.613558],
              [-83.145887, 41.617904],
              [-83.165713, 41.623246],
              [-83.194524, 41.631008],
              [-83.23166, 41.644218],
              [-83.238191, 41.651167],
              [-83.278455, 41.672078],
              [-83.285181, 41.674673],
              [-83.287125, 41.675423],
              [-83.288469, 41.675941],
              [-83.289682, 41.676409],
              [-83.29068, 41.676794],
              [-83.293928, 41.680846],
              [-83.29561, 41.681905],
              [-83.298731, 41.683871],
              [-83.326825, 41.701562],
              [-83.337977, 41.70341],
              [-83.337985, 41.698682],
              [-83.341817, 41.693518],
              [-83.357073, 41.687763],
              [-83.37573, 41.686647],
              [-83.39263, 41.691947],
              [-83.409531, 41.691247],
              [-83.446032, 41.706847],
              [-83.449001, 41.710719],
              [-83.455626, 41.727445],
              [-83.453832, 41.732647],
              [-83.451897, 41.734486],
              [-83.43436, 41.737058],
              [-83.424155, 41.74071],
              [-83.424076, 41.740738],
              [-83.42418, 41.741042],
              [-83.42643, 41.747639],
              [-83.427308, 41.750214],
              [-83.427336, 41.750267],
              [-83.427377, 41.750346],
              [-83.431103, 41.757457],
              [-83.431951, 41.759074],
              [-83.432078, 41.759316],
              [-83.432832, 41.760756],
              [-83.432973, 41.761025],
              [-83.434238, 41.763439],
              [-83.435571, 41.765983],
              [-83.437197, 41.769085],
              [-83.437231, 41.76915],
              [-83.437516, 41.769694],
              [-83.437935, 41.771086],
              [-83.443364, 41.789118],
              [-83.442843, 41.795121],
              [-83.442521, 41.79883],
              [-83.442316, 41.80119],
              [-83.441668, 41.808646],
              [-83.439612, 41.813162],
              [-83.436298, 41.816471],
              [-83.435946, 41.816823],
              [-83.434204, 41.818562],
              [-83.431183, 41.819506],
              [-83.426321, 41.821026],
              [-83.425393, 41.821316],
              [-83.422391, 41.822255],
              [-83.422316, 41.822278],
              [-83.409596, 41.830325],
              [-83.40822, 41.832654],
              [-83.39622, 41.852965],
              [-83.393822, 41.855976],
              [-83.389289, 41.861668],
              [-83.381955, 41.870877],
              [-83.379705, 41.871729],
              [-83.372445, 41.874477],
              [-83.372198, 41.874122],
              [-83.366187, 41.865505],
              [-83.359467, 41.867849],
              [-83.341557, 41.879956],
              [-83.335961, 41.889721],
              [-83.335658, 41.892009],
              [-83.335132, 41.895992],
              [-83.335103, 41.896209],
              [-83.334346, 41.901939],
              [-83.334173, 41.903247],
              [-83.333642, 41.907261],
              [-83.332998, 41.908757],
              [-83.330498, 41.914565],
              [-83.32706, 41.922554],
              [-83.326029, 41.924948],
              [-83.326024, 41.924961],
              [-83.326007, 41.924979],
              [-83.315859, 41.935893],
              [-83.305639, 41.941557],
              [-83.303465, 41.942762],
              [-83.302904, 41.943073],
              [-83.299467, 41.943902],
              [-83.29823, 41.9442],
              [-83.295982, 41.944742],
              [-83.293015, 41.944626],
              [-83.292761, 41.944616],
              [-83.28713, 41.944397],
              [-83.270491, 41.939337],
              [-83.269521, 41.939042],
              [-83.257292, 41.950745],
              [-83.257199, 41.95367],
              [-83.257143, 41.955438],
              [-83.257043, 41.958615],
              [-83.257009, 41.959686],
              [-83.256803, 41.960021],
              [-83.255123, 41.962759],
              [-83.249828, 41.971386],
              [-83.249204, 41.972402],
              [-83.248741, 41.972735],
              [-83.22929, 41.986725],
              [-83.228607, 41.987216],
              [-83.228502, 41.987291],
              [-83.22841, 41.987325],
              [-83.227744, 41.987571],
              [-83.224947, 41.988603],
              [-83.223369, 41.989185],
              [-83.223354, 41.989191],
              [-83.216897, 41.988561],
              [-83.216835, 41.98862],
              [-83.209379, 41.995736],
              [-83.208647, 42.00504],
              [-83.190535, 42.006172],
              [-83.187246, 42.007573],
              [-83.181475, 42.019301],
              [-83.185822, 42.029367],
              [-83.185858, 42.029451],
              [-83.18824, 42.031329],
              [-83.185526, 42.052243],
              [-83.186877, 42.061206],
              [-83.189115, 42.061853],
              [-83.188598, 42.066431],
              [-83.170589, 42.07294],
              [-83.168759, 42.073601],
              [-83.157624, 42.085542],
              [-83.133511, 42.088143],
              [-83.124522, 42.137641],
              [-83.133923, 42.17474],
              [-83.131343, 42.20276],
              [-83.128022, 42.238839],
              [-83.096521, 42.290138],
              [-83.079721, 42.308638],
              [-83.064121, 42.317738],
              [-83.01832, 42.329739],
              [-82.988619, 42.332439],
              [-82.959416, 42.339638],
              [-82.92397, 42.352068],
              [-82.928815, 42.359437],
              [-82.919114, 42.374437],
              [-82.915114, 42.378137],
              [-82.898413, 42.385437],
              [-82.894013, 42.389437],
              [-82.888413, 42.398237],
              [-82.886113, 42.408137],
              [-82.870347, 42.450888],
              [-82.870572, 42.451235],
              [-82.883915, 42.471836],
              [-82.882316, 42.501035],
              [-82.874416, 42.523535],
              [-82.860213, 42.540842],
              [-82.859316, 42.541935],
              [-82.851016, 42.548935],
              [-82.849316, 42.555734],
              [-82.845916, 42.560634],
              [-82.834216, 42.567849],
              [-82.821016, 42.570734],
              [-82.796715, 42.571034],
              [-82.789114, 42.568434],
              [-82.784514, 42.563634],
              [-82.782414, 42.564834],
              [-82.781514, 42.571634],
              [-82.788116, 42.582835],
              [-82.788977, 42.592661],
              [-82.787573, 42.5983],
              [-82.789017, 42.603434],
              [-82.811017, 42.610933],
              [-82.819017, 42.616333],
              [-82.820118, 42.626333],
              [-82.813518, 42.640833],
              [-82.797318, 42.654032],
              [-82.792418, 42.655132],
              [-82.780817, 42.652232],
              [-82.765583, 42.655725],
              [-82.753317, 42.669732],
              [-82.726366, 42.682768],
              [-82.707841, 42.68351],
              [-82.706135, 42.683578],
              [-82.700964, 42.689548],
              [-82.6855, 42.690036],
              [-82.674287, 42.687049],
              [-82.659781, 42.678618],
              [-82.635262, 42.675552],
              [-82.630851, 42.673341],
              [-82.623797, 42.665395],
              [-82.623043, 42.655951],
              [-82.626396, 42.647385],
              [-82.630922, 42.64211],
              [-82.645715, 42.631145],
              [-82.669103, 42.637225],
              [-82.689836, 42.627148],
              [-82.690124, 42.625033],
              [-82.681593, 42.618672],
              [-82.683482, 42.609433],
              [-82.700818, 42.606687],
              [-82.713042, 42.597904],
              [-82.711151, 42.590884],
              [-82.701152, 42.585991],
              [-82.688061, 42.588417],
              [-82.681036, 42.574695],
              [-82.680758, 42.557909],
              [-82.664335, 42.546244],
              [-82.670956, 42.537989],
              [-82.679522, 42.53552],
              [-82.685397, 42.528659],
              [-82.686417, 42.518597],
              [-82.679059, 42.52221],
              [-82.624907, 42.557229],
              [-82.607068, 42.548843],
              [-82.589779, 42.550678],
              [-82.583996, 42.554041],
              [-82.523337, 42.607486],
              [-82.518782, 42.613888],
              [-82.509935, 42.637294],
              [-82.483697, 42.733212],
              [-82.469912, 42.887459],
              [-82.455027, 42.926866],
              [-82.447778, 42.937066],
              [-82.415937, 43.005555],
              [-82.422768, 43.007956],
              [-82.443433, 43.039942],
              [-82.450724, 43.051229],
              [-82.457221, 43.061285],
              [-82.457319, 43.06147],
              [-82.471053, 43.087581],
              [-82.486042, 43.102486],
              [-82.486684, 43.104688],
              [-82.490494, 43.117759],
              [-82.490614, 43.118172],
              [-82.490634, 43.118314],
              [-82.490979, 43.120782],
              [-82.493021, 43.135363],
              [-82.493347, 43.137685],
              [-82.493977, 43.142186],
              [-82.494014, 43.142453],
              [-82.494052, 43.142722],
              [-82.494072, 43.142864],
              [-82.494194, 43.143736],
              [-82.495685, 43.147316],
              [-82.500061, 43.157827],
              [-82.501529, 43.161351],
              [-82.501656, 43.161656],
              [-82.50299, 43.168137],
              [-82.503157, 43.168946],
              [-82.508881, 43.196748],
              [-82.519123, 43.212737],
              [-82.523086, 43.225361],
              [-82.532396, 43.30577],
              [-82.529416, 43.316243],
              [-82.530128, 43.333805],
              [-82.536794, 43.34851],
              [-82.535627, 43.368062],
              [-82.53993, 43.422378],
              [-82.538578, 43.431594],
              [-82.539517, 43.437539],
              [-82.55354, 43.464111],
              [-82.565505, 43.497063],
              [-82.565691, 43.502904],
              [-82.585654, 43.543969],
              [-82.593785, 43.581467],
              [-82.597911, 43.590016],
              [-82.6005, 43.602935],
              [-82.605783, 43.669489],
              [-82.60483, 43.678884],
              [-82.606233, 43.690437],
              [-82.612224, 43.739771],
              [-82.617213, 43.746788],
              [-82.619079, 43.756088],
              [-82.617955, 43.768596],
              [-82.633641, 43.831224],
              [-82.644345, 43.837539],
              [-82.647784, 43.842684],
              [-82.647467, 43.84449],
              [-82.642899, 43.846419],
              [-82.643166, 43.852468],
              [-82.65545, 43.867883],
              [-82.678642, 43.88373],
              [-82.693505, 43.91798],
              [-82.709839, 43.948226],
              [-82.712235, 43.94961],
              [-82.728528, 43.972615],
              [-82.738992, 43.989506],
              [-82.746255, 43.996037],
              [-82.765018, 44.006845],
              [-82.783198, 44.009366],
              [-82.788298, 44.013712],
              [-82.793205, 44.023247],
              [-82.833103, 44.036851],
              [-82.875889, 44.045046],
              [-82.889831, 44.050952],
              [-82.915976, 44.070503],
              [-82.928884, 44.069389],
              [-82.947368, 44.062187],
              [-82.956658, 44.063306],
              [-82.958688, 44.065774],
              [-82.967439, 44.066138],
              [-82.990728, 44.048846],
              [-82.999283, 44.04651],
              [-83.024604, 44.045174],
              [-83.029868, 44.041175],
              [-83.046577, 44.01571],
              [-83.058741, 44.006224],
              [-83.066026, 44.003366],
              [-83.079297, 44.001079],
              [-83.10782, 44.003245],
              [-83.120659, 44.00095],
              [-83.134881, 43.993147],
              [-83.145407, 43.989441],
              [-83.180618, 43.982109],
              [-83.195688, 43.983137],
              [-83.227093, 43.981003],
              [-83.26153, 43.973525],
              [-83.26185, 43.969021],
              [-83.26898, 43.956132],
              [-83.28231, 43.938031],
              [-83.30569, 43.922489],
              [-83.318656, 43.91762],
              [-83.338067, 43.915687],
              [-83.347365, 43.91216],
              [-83.348648, 43.909915],
              [-83.348007, 43.906388],
              [-83.340976, 43.904541],
              [-83.333532, 43.89852],
              [-83.331788, 43.893901],
              [-83.33227, 43.880522],
              [-83.358869, 43.857395],
              [-83.389424, 43.844229],
              [-83.389017, 43.840457],
              [-83.390344, 43.839132],
              [-83.407647, 43.831998],
              [-83.410853, 43.825585],
              [-83.412456, 43.817569],
              [-83.410663, 43.80773],
              [-83.411453, 43.805033],
              [-83.416378, 43.801034],
              [-83.426068, 43.799915],
              [-83.438311, 43.786846],
              [-83.446752, 43.77186],
              [-83.441591, 43.770175],
              [-83.438878, 43.767135],
              [-83.440171, 43.761694],
              [-83.459628, 43.740931],
              [-83.46508, 43.733843],
              [-83.467429, 43.72892],
              [-83.470053, 43.723418],
              [-83.48007, 43.714636],
              [-83.506657, 43.710907],
              [-83.513461, 43.714607],
              [-83.515853, 43.718157],
              [-83.524837, 43.716948],
              [-83.540187, 43.708746],
              [-83.55147, 43.699901],
              [-83.549044, 43.693798],
              [-83.553707, 43.685432],
              [-83.563157, 43.684564],
              [-83.595579, 43.650249],
              [-83.618602, 43.628891],
              [-83.654192, 43.59929],
              [-83.666052, 43.591292],
              [-83.669795, 43.59079],
              [-83.699253, 43.596792],
              [-83.703446, 43.597646],
              [-83.725793, 43.618691],
              [-83.769886, 43.634924],
              [-83.770693, 43.628691],
              [-83.778919, 43.630056],
              [-83.806774, 43.641221],
              [-83.814674, 43.643022],
              [-83.852076, 43.644922],
              [-83.897078, 43.664022],
              [-83.909479, 43.672622],
              [-83.929462, 43.701269],
              [-83.939297, 43.715369],
              [-83.954347, 43.750647],
              [-83.956021, 43.759286],
              [-83.954792, 43.760932],
              [-83.945426, 43.759946],
              [-83.929375, 43.777091],
              [-83.926345, 43.787398],
              [-83.917875, 43.856509],
              [-83.916815, 43.89905],
              [-83.911128, 43.91052],
              [-83.907388, 43.918062],
              [-83.890912, 43.923314],
              [-83.890145, 43.934672],
              [-83.885543, 43.946154],
              [-83.885526, 43.946197],
              [-83.885328, 43.946691],
              [-83.880113, 43.955261],
              [-83.880011, 43.955428],
              [-83.877694, 43.959235],
              [-83.877047, 43.959351],
              [-83.869614, 43.960682],
              [-83.869406, 43.960719],
              [-83.859743, 43.969389],
              [-83.859615, 43.969504],
              [-83.859459, 43.969643],
              [-83.859305, 43.969782],
              [-83.859114, 43.969953],
              [-83.858528, 43.970479],
              [-83.858373, 43.970618],
              [-83.856371, 43.972414],
              [-83.856128, 43.972632],
              [-83.856077, 43.972822],
              [-83.855653, 43.974391],
              [-83.855602, 43.974581],
              [-83.855572, 43.974691],
              [-83.855516, 43.974899],
              [-83.855219, 43.975997],
              [-83.85493, 43.977067],
              [-83.853582, 43.977984],
              [-83.851884, 43.97914],
              [-83.85175, 43.979231],
              [-83.851496, 43.979403],
              [-83.848276, 43.981594],
              [-83.829123, 43.989077],
              [-83.829102, 43.989085],
              [-83.829077, 43.989095],
              [-83.828398, 43.989032],
              [-83.82808, 43.989003],
              [-83.787863, 43.985279],
              [-83.779086, 43.985235],
              [-83.763774, 43.985158],
              [-83.763345, 43.98525],
              [-83.763015, 43.985321],
              [-83.76283, 43.985361],
              [-83.757063, 43.986599],
              [-83.746779, 43.988807],
              [-83.743806, 43.991529],
              [-83.708741, 43.992997],
              [-83.680108, 43.994196],
              [-83.687892, 44.020709],
              [-83.679654, 44.036365],
              [-83.650116, 44.052404],
              [-83.621078, 44.056186],
              [-83.601173, 44.054686],
              [-83.58409, 44.056748],
              [-83.590437, 44.069569],
              [-83.591361, 44.079237],
              [-83.588004, 44.086758],
              [-83.573071, 44.101298],
              [-83.567714, 44.119652],
              [-83.567978, 44.121207],
              [-83.568509, 44.124343],
              [-83.568915, 44.126734],
              [-83.568831, 44.128819],
              [-83.568803, 44.129513],
              [-83.568243, 44.143475],
              [-83.568238, 44.143587],
              [-83.5682, 44.144542],
              [-83.567941, 44.150983],
              [-83.567744, 44.155899],
              [-83.566366, 44.160066],
              [-83.565984, 44.161219],
              [-83.565257, 44.163418],
              [-83.565225, 44.163517],
              [-83.553834, 44.197956],
              [-83.552872, 44.210718],
              [-83.549096, 44.227282],
              [-83.53771, 44.248171],
              [-83.524817, 44.261558],
              [-83.508839, 44.273711],
              [-83.500392, 44.27661],
              [-83.479531, 44.28009],
              [-83.463049, 44.278838],
              [-83.460958, 44.278176],
              [-83.447742, 44.273991],
              [-83.445805, 44.273378],
              [-83.442731, 44.265361],
              [-83.429689, 44.269708],
              [-83.425762, 44.272487],
              [-83.419236, 44.2878],
              [-83.414301, 44.294543],
              [-83.401822, 44.301831],
              [-83.373607, 44.327784],
              [-83.364312, 44.33259],
              [-83.352115, 44.332366],
              [-83.343738, 44.329763],
              [-83.336988, 44.332919],
              [-83.332533, 44.340464],
              [-83.335248, 44.357995],
              [-83.333757, 44.372486],
              [-83.321648, 44.404502],
              [-83.321553, 44.409119],
              [-83.324616, 44.415039],
              [-83.327171, 44.429234],
              [-83.326824, 44.444411],
              [-83.31761, 44.486058],
              [-83.318216, 44.511734],
              [-83.318276, 44.514294],
              [-83.318279, 44.514416],
              [-83.318104, 44.514871],
              [-83.311529, 44.531956],
              [-83.311245, 44.532693],
              [-83.310376, 44.534952],
              [-83.310185, 44.535448],
              [-83.309385, 44.537528],
              [-83.308471, 44.539902],
              [-83.308906, 44.54814],
              [-83.308918, 44.54836],
              [-83.309117, 44.549043],
              [-83.309234, 44.549444],
              [-83.313623, 44.564498],
              [-83.313649, 44.564588],
              [-83.313744, 44.566076],
              [-83.313792, 44.566822],
              [-83.313813, 44.567148],
              [-83.313893, 44.568395],
              [-83.313925, 44.568888],
              [-83.314013, 44.570266],
              [-83.314098, 44.571592],
              [-83.314127, 44.572043],
              [-83.315503, 44.593514],
              [-83.315603, 44.595079],
              [-83.315435, 44.597193],
              [-83.315277, 44.599178],
              [-83.31504, 44.602152],
              [-83.315037, 44.60219],
              [-83.314534, 44.608512],
              [-83.314517, 44.608725],
              [-83.31445, 44.608926],
              [-83.309869, 44.622703],
              [-83.309802, 44.622906],
              [-83.309222, 44.62465],
              [-83.307504, 44.629816],
              [-83.307116, 44.630313],
              [-83.295377, 44.64536],
              [-83.289442, 44.652968],
              [-83.287802, 44.657703],
              [-83.287585, 44.658328],
              [-83.287211, 44.659409],
              [-83.286874, 44.66038],
              [-83.285992, 44.662927],
              [-83.279288, 44.682278],
              [-83.279129, 44.682735],
              [-83.277476, 44.687507],
              [-83.276836, 44.689354],
              [-83.276137, 44.69434],
              [-83.275601, 44.698161],
              [-83.275543, 44.698574],
              [-83.2755, 44.698882],
              [-83.275318, 44.700177],
              [-83.275281, 44.700441],
              [-83.275078, 44.701891],
              [-83.274674, 44.70477],
              [-83.273393, 44.713901],
              [-83.274103, 44.714421],
              [-83.274747, 44.714893],
              [-83.277213, 44.7167],
              [-83.283098, 44.721011],
              [-83.284128, 44.721766],
              [-83.284724, 44.72245],
              [-83.288214, 44.726453],
              [-83.290665, 44.729265],
              [-83.290944, 44.729974],
              [-83.296265, 44.743502],
              [-83.2973, 44.746134],
              [-83.29742, 44.747203],
              [-83.297526, 44.74814],
              [-83.297797, 44.750547],
              [-83.298237, 44.754465],
              [-83.298287, 44.754907],
              [-83.298021, 44.755632],
              [-83.296971, 44.758495],
              [-83.296969, 44.758543],
              [-83.296125, 44.778828],
              [-83.295696, 44.789112],
              [-83.29565, 44.790237],
              [-83.295518, 44.793397],
              [-83.29553, 44.793486],
              [-83.298618, 44.815416],
              [-83.299737, 44.823362],
              [-83.300648, 44.829831],
              [-83.306854, 44.83541],
              [-83.308578, 44.83696],
              [-83.312478, 44.840466],
              [-83.312831, 44.840783],
              [-83.31294, 44.840882],
              [-83.31433, 44.842131],
              [-83.314429, 44.84222],
              [-83.318373, 44.84844],
              [-83.321089, 44.852723],
              [-83.321241, 44.852962],
              [-83.321237, 44.853102],
              [-83.321093, 44.858494],
              [-83.320503, 44.880571],
              [-83.352815, 44.886164],
              [-83.39396, 44.903056],
              [-83.398879, 44.906417],
              [-83.404596, 44.918761],
              [-83.425311, 44.926741],
              [-83.433032, 44.93289],
              [-83.438856, 44.940843],
              [-83.443718, 44.952247],
              [-83.450013, 44.990219],
              [-83.438948, 45.000011],
              [-83.435822, 45.000012],
              [-83.431254, 45.007998],
              [-83.435249, 45.011883],
              [-83.446342, 45.016655],
              [-83.454168, 45.03188],
              [-83.453363, 45.035331],
              [-83.442052, 45.051056],
              [-83.433798, 45.057616],
              [-83.399255, 45.070364],
              [-83.36747, 45.062268],
              [-83.357609, 45.050613],
              [-83.340257, 45.041545],
              [-83.302153, 45.032315],
              [-83.287974, 45.026462],
              [-83.271506, 45.023417],
              [-83.265896, 45.026844],
              [-83.271464, 45.038114],
              [-83.277037, 45.044767],
              [-83.280272, 45.045962],
              [-83.291346, 45.062597],
              [-83.290827, 45.069157],
              [-83.298275, 45.090483],
              [-83.30788, 45.099093],
              [-83.318442, 45.12893],
              [-83.319315, 45.137684],
              [-83.315924, 45.139992],
              [-83.316118, 45.141958],
              [-83.337822, 45.14712],
              [-83.348684, 45.161516],
              [-83.359895, 45.16302],
              [-83.363678, 45.166469],
              [-83.368046, 45.172478],
              [-83.368896, 45.182168],
              [-83.381647, 45.203357],
              [-83.384265, 45.203472],
              [-83.387587, 45.207107],
              [-83.405914, 45.227157],
              [-83.41241, 45.238905],
              [-83.412569, 45.245807],
              [-83.388034, 45.254976],
              [-83.381743, 45.268983],
              [-83.385104, 45.274195],
              [-83.388274, 45.276916],
              [-83.398845, 45.279107],
              [-83.400261, 45.2794],
              [-83.400753, 45.279502],
              [-83.40088, 45.279528],
              [-83.401091, 45.279572],
              [-83.42051, 45.289787],
              [-83.422272, 45.290713],
              [-83.422389, 45.290775],
              [-83.422486, 45.290989],
              [-83.423178, 45.292506],
              [-83.42514, 45.296808],
              [-83.43304, 45.303688],
              [-83.445672, 45.310612],
              [-83.468099, 45.33245],
              [-83.477728, 45.341827],
              [-83.477794, 45.341891],
              [-83.488826, 45.355872],
              [-83.496704, 45.357536],
              [-83.514717, 45.34646],
              [-83.520258, 45.347239],
              [-83.538306, 45.358167],
              [-83.545729, 45.358397],
              [-83.546799, 45.352637],
              [-83.550268, 45.350832],
              [-83.570361, 45.347198],
              [-83.599273, 45.352561],
              [-83.64379, 45.37171],
              [-83.667934, 45.384675],
              [-83.697316, 45.396239],
              [-83.721815, 45.413304],
              [-83.737321, 45.410943],
              [-83.755569, 45.411034],
              [-83.773171, 45.417302],
              [-83.788777, 45.416415],
              [-83.806622, 45.419159],
              [-83.841543, 45.435287],
              [-83.85856, 45.446865],
              [-83.881813, 45.467907],
              [-83.909472, 45.485784],
              [-83.939261, 45.493189],
              [-83.978017, 45.494138],
              [-83.99835, 45.491158],
              [-84.009582, 45.495069],
              [-84.028813, 45.497225],
              [-84.036286, 45.496245],
              [-84.039958, 45.493733],
              [-84.056138, 45.489349],
              [-84.075792, 45.490537],
              [-84.095905, 45.497298],
              [-84.109238, 45.505171],
              [-84.116687, 45.51305],
              [-84.122309, 45.523788],
              [-84.126971, 45.542428],
              [-84.126532, 45.556616],
              [-84.128867, 45.562284],
              [-84.139462, 45.573714],
              [-84.157121, 45.585305],
              [-84.180514, 45.604639],
              [-84.196043, 45.621456],
              [-84.204218, 45.627116],
              [-84.215268, 45.634767],
              [-84.270238, 45.64479],
              [-84.289685, 45.653296],
              [-84.329537, 45.66438],
              [-84.376403, 45.655565],
              [-84.400283, 45.663345],
              [-84.413642, 45.669427],
              [-84.427495, 45.669201],
              [-84.435415, 45.664106],
              [-84.442348, 45.654771],
              [-84.46168, 45.652404],
              [-84.538998, 45.690383],
              [-84.539165, 45.690478],
              [-84.539167, 45.69048],
              [-84.553311, 45.698566],
              [-84.555496, 45.702268],
              [-84.573631, 45.710381],
              [-84.604712, 45.721668],
              [-84.644822, 45.73999],
              [-84.679546, 45.749095],
              [-84.681967, 45.756197],
              [-84.715996, 45.766174],
              [-84.718904, 45.777599],
              [-84.726192, 45.786905],
              [-84.732388, 45.787928],
              [-84.734065, 45.788205],
              [-84.742, 45.784134],
              [-84.751571, 45.782733],
              [-84.772765, 45.789301],
              [-84.774014, 45.788957],
              [-84.774156, 45.788918],
              [-84.780313, 45.787224],
              [-84.793153, 45.780463],
              [-84.792337, 45.778497],
              [-84.79229, 45.778464],
              [-84.787228, 45.774892],
              [-84.7798, 45.76965],
              [-84.781373, 45.76108],
              [-84.781995, 45.760345],
              [-84.788808, 45.752298],
              [-84.788821, 45.752283],
              [-84.788893, 45.752248],
              [-84.78958, 45.751919],
              [-84.792474, 45.75053],
              [-84.799558, 45.74713],
              [-84.800664, 45.74698],
              [-84.805114, 45.746378],
              [-84.806642, 45.746171],
              [-84.808285, 45.746103],
              [-84.810411, 45.746015],
              [-84.810953, 45.745993],
              [-84.840981, 45.744751],
              [-84.866976, 45.752066],
              [-84.910398, 45.75001],
              [-84.919996, 45.754643],
              [-84.920691, 45.754979],
              [-84.922478, 45.755842],
              [-84.924664, 45.756897],
              [-84.92523, 45.757021],
              [-84.926802, 45.757366],
              [-84.931463, 45.758389],
              [-84.93779, 45.759777],
              [-84.938312, 45.759892],
              [-84.995105, 45.759855],
              [-85.00741, 45.763168],
              [-85.009173, 45.762463],
              [-85.014509, 45.760329],
              [-85.011433, 45.757962],
              [-85.002914, 45.75394],
              [-85.001656, 45.753819],
              [-84.996755, 45.753347],
              [-84.985318, 45.752247],
              [-84.984568, 45.752175],
              [-84.983933, 45.752114],
              [-84.983829, 45.752104],
              [-84.983316, 45.752055],
              [-84.982973, 45.752022],
              [-84.982328, 45.75196],
              [-84.968309, 45.745252],
              [-84.95813, 45.740381],
              [-84.955394, 45.739072],
              [-84.954275, 45.738537],
              [-84.951745, 45.737326],
              [-84.95084, 45.736893],
              [-84.950226, 45.736299],
              [-84.947266, 45.733435],
              [-84.945958, 45.732169],
              [-84.943982, 45.730257],
              [-84.942543, 45.728865],
              [-84.942125, 45.72846],
              [-84.942098, 45.728349],
              [-84.940526, 45.721832],
              [-84.941073, 45.719879],
              [-84.942636, 45.714292],
              [-84.943756, 45.71029],
              [-84.94565, 45.708621],
              [-84.970213, 45.686984],
              [-84.97095, 45.686334],
              [-84.974237, 45.684178],
              [-84.996067, 45.669861],
              [-84.996336, 45.669685],
              [-84.997431, 45.667762],
              [-85.001154, 45.661225],
              [-85.002344, 45.660239],
              [-85.005645, 45.657504],
              [-85.007026, 45.65636],
              [-85.013218, 45.652789],
              [-85.014352, 45.652134],
              [-85.015341, 45.651564],
              [-85.019374, 45.65051],
              [-85.020107, 45.650319],
              [-85.03559, 45.646273],
              [-85.041037, 45.644849],
              [-85.044872, 45.643847],
              [-85.061006, 45.639631],
              [-85.061488, 45.639505],
              [-85.063974, 45.637604],
              [-85.065716, 45.636272],
              [-85.071381, 45.63194],
              [-85.074243, 45.629752],
              [-85.07491, 45.629242],
              [-85.075461, 45.625295],
              [-85.075678, 45.623742],
              [-85.075686, 45.623688],
              [-85.076284, 45.62266],
              [-85.07937, 45.617355],
              [-85.079528, 45.617083],
              [-85.093525, 45.600121],
              [-85.095531, 45.598562],
              [-85.096798, 45.597576],
              [-85.101977, 45.59355],
              [-85.102221, 45.59336],
              [-85.102917, 45.59282],
              [-85.103077, 45.592695],
              [-85.103521, 45.59235],
              [-85.105458, 45.590844],
              [-85.106246, 45.590231],
              [-85.106909, 45.589716],
              [-85.107744, 45.589067],
              [-85.111737, 45.585962],
              [-85.111909, 45.585829],
              [-85.112406, 45.585042],
              [-85.11243, 45.585004],
              [-85.117812, 45.576482],
              [-85.118353, 45.575625],
              [-85.118637, 45.575175],
              [-85.118825, 45.574123],
              [-85.119026, 45.573002],
              [-85.119737, 45.569026],
              [-85.119721, 45.568915],
              [-85.119675, 45.568597],
              [-85.119494, 45.567338],
              [-85.117656, 45.55455],
              [-85.117406, 45.552811],
              [-85.11587, 45.542125],
              [-85.115785, 45.541533],
              [-85.115479, 45.539406],
              [-85.110955, 45.526488],
              [-85.110884, 45.526285],
              [-85.109353, 45.521915],
              [-85.109252, 45.521626],
              [-85.103943, 45.510252],
              [-85.097142, 45.495684],
              [-85.088386, 45.476928],
              [-85.087756, 45.476335],
              [-85.070485, 45.460096],
              [-85.069573, 45.459239],
              [-85.052994, 45.446191],
              [-85.050747, 45.444423],
              [-85.050234, 45.444019],
              [-85.046943, 45.441429],
              [-85.040936, 45.436701],
              [-85.040272, 45.436509],
              [-85.037741, 45.435776],
              [-85.034856, 45.434941],
              [-84.994191, 45.423173],
              [-84.978608, 45.418663],
              [-84.977116, 45.420035],
              [-84.978373, 45.420171],
              [-84.983836, 45.420764],
              [-84.984928, 45.421471],
              [-84.987143, 45.422906],
              [-84.987416, 45.423082],
              [-84.989224, 45.424253],
              [-84.990785, 45.425264],
              [-84.990041, 45.427618],
              [-84.981192, 45.429336],
              [-84.980953, 45.429382],
              [-84.980467, 45.42932],
              [-84.978969, 45.429131],
              [-84.976623, 45.428833],
              [-84.97637, 45.428801],
              [-84.922006, 45.421914],
              [-84.916165, 45.417639],
              [-84.912956, 45.409776],
              [-84.912537, 45.402828],
              [-84.91585, 45.393115],
              [-84.959119, 45.375973],
              [-84.975357, 45.373587],
              [-84.998603, 45.370173],
              [-85.022234, 45.366701],
              [-85.032813, 45.361251],
              [-85.043101, 45.361506],
              [-85.043446, 45.361582],
              [-85.043721, 45.361643],
              [-85.045526, 45.362041],
              [-85.046635, 45.362287],
              [-85.054805, 45.364091],
              [-85.060905, 45.364522],
              [-85.063459, 45.364703],
              [-85.06425, 45.364758],
              [-85.066969, 45.364951],
              [-85.073617, 45.36542],
              [-85.095985, 45.367001],
              [-85.143651, 45.370369],
              [-85.182471, 45.360824],
              [-85.196704, 45.360641],
              [-85.209673, 45.356937],
              [-85.235629, 45.339374],
              [-85.252193, 45.330863],
              [-85.25505, 45.325675],
              [-85.262996, 45.319507],
              [-85.273789, 45.315443],
              [-85.289568, 45.314052],
              [-85.294848, 45.316408],
              [-85.307646, 45.31314],
              [-85.323941, 45.303355],
              [-85.335016, 45.294027],
              [-85.355478, 45.282774],
              [-85.371593, 45.270834],
              [-85.388593, 45.23524],
              [-85.387463, 45.207565],
              [-85.386726, 45.189497],
              [-85.380464, 45.180876],
              [-85.376948, 45.142881],
              [-85.372571, 45.126241],
              [-85.366908, 45.116938],
              [-85.366412, 45.069023],
              [-85.377586, 45.055713],
              [-85.380659, 45.046319],
              [-85.381654, 45.018407],
              [-85.378286, 44.998587],
              [-85.3958, 44.931018],
              [-85.406173, 44.911773],
              [-85.423003, 44.895019],
              [-85.425804, 44.881646],
              [-85.44225, 44.859817],
              [-85.452683, 44.845969],
              [-85.455336, 44.842448],
              [-85.456007, 44.841558],
              [-85.457328, 44.839804],
              [-85.457472, 44.839613],
              [-85.457475, 44.839609],
              [-85.460445, 44.835667],
              [-85.462622, 44.826327],
              [-85.462906, 44.82511],
              [-85.462916, 44.825067],
              [-85.462943, 44.825044],
              [-85.474622, 44.815107],
              [-85.474796, 44.814959],
              [-85.475114, 44.814816],
              [-85.475748, 44.814532],
              [-85.477423, 44.813781],
              [-85.481972, 44.81174],
              [-85.484668, 44.810531],
              [-85.496314, 44.805308],
              [-85.499591, 44.803838],
              [-85.507473, 44.790372],
              [-85.508462, 44.788682],
              [-85.509251, 44.787334],
              [-85.507113, 44.784271],
              [-85.505244, 44.781594],
              [-85.504787, 44.778577],
              [-85.504079, 44.773901],
              [-85.503935, 44.772951],
              [-85.5047, 44.768518],
              [-85.504772, 44.768102],
              [-85.504775, 44.768082],
              [-85.509432, 44.763964],
              [-85.523296, 44.751702],
              [-85.527216, 44.748235],
              [-85.538285, 44.746821],
              [-85.554083, 44.748715],
              [-85.554326, 44.748744],
              [-85.554774, 44.748917],
              [-85.571301, 44.755293],
              [-85.575916, 44.759602],
              [-85.576566, 44.760208],
              [-85.576239, 44.760807],
              [-85.57517, 44.762766],
              [-85.571018, 44.770377],
              [-85.568781, 44.774477],
              [-85.560488, 44.789679],
              [-85.560488, 44.78969],
              [-85.560424, 44.794772],
              [-85.560409, 44.79595],
              [-85.5604, 44.796655],
              [-85.560352, 44.800454],
              [-85.560348, 44.800772],
              [-85.560253, 44.808359],
              [-85.560232, 44.809974],
              [-85.560231, 44.810072],
              [-85.557952, 44.814372],
              [-85.555894, 44.818256],
              [-85.553844, 44.820298],
              [-85.55285, 44.821288],
              [-85.551797, 44.822338],
              [-85.547119, 44.826998],
              [-85.546021, 44.828092],
              [-85.542706, 44.831395],
              [-85.539924, 44.834166],
              [-85.538522, 44.834918],
              [-85.533434, 44.837648],
              [-85.527181, 44.841002],
              [-85.519096, 44.845339],
              [-85.518845, 44.8454],
              [-85.516997, 44.845846],
              [-85.513575, 44.846674],
              [-85.511751, 44.847114],
              [-85.508617, 44.847872],
              [-85.508227, 44.848352],
              [-85.502386, 44.855551],
              [-85.502182, 44.855802],
              [-85.500872, 44.85883],
              [-85.498007, 44.865451],
              [-85.489921, 44.896694],
              [-85.489704, 44.897533],
              [-85.488624, 44.901707],
              [-85.488927, 44.902217],
              [-85.489477, 44.903145],
              [-85.49249, 44.90822],
              [-85.492397, 44.909719],
              [-85.491496, 44.924205],
              [-85.491471, 44.92461],
              [-85.491414, 44.925531],
              [-85.491403, 44.925695],
              [-85.491393, 44.925868],
              [-85.491286, 44.927585],
              [-85.491239, 44.927804],
              [-85.491215, 44.927918],
              [-85.490713, 44.930274],
              [-85.489895, 44.934118],
              [-85.489049, 44.938087],
              [-85.48574, 44.953626],
              [-85.474274, 44.958529],
              [-85.472258, 44.959391],
              [-85.471646, 44.959331],
              [-85.471261, 44.959294],
              [-85.470688, 44.959238],
              [-85.46665, 44.958844],
              [-85.464944, 44.961062],
              [-85.466848, 44.967853],
              [-85.46802, 44.972035],
              [-85.468293, 44.973008],
              [-85.470215, 44.979864],
              [-85.470462, 44.980745],
              [-85.471708, 44.983453],
              [-85.472676, 44.985558],
              [-85.475204, 44.991053],
              [-85.492386, 44.989849],
              [-85.4926, 44.989834],
              [-85.518875, 44.974665],
              [-85.520034, 44.973996],
              [-85.520789, 44.971338],
              [-85.521896, 44.967446],
              [-85.5221, 44.966727],
              [-85.520698, 44.962008],
              [-85.520443, 44.961149],
              [-85.520205, 44.960347],
              [-85.529233, 44.936955],
              [-85.530477, 44.933732],
              [-85.533553, 44.925762],
              [-85.538288, 44.918845],
              [-85.538945, 44.917885],
              [-85.539703, 44.916779],
              [-85.551567, 44.906481],
              [-85.556471, 44.902223],
              [-85.556647, 44.90207],
              [-85.557257, 44.901541],
              [-85.562503, 44.896987],
              [-85.562936, 44.896612],
              [-85.564509, 44.895246],
              [-85.559524, 44.888113],
              [-85.553509, 44.890924],
              [-85.553348, 44.890916],
              [-85.530649, 44.889763],
              [-85.530711, 44.889314],
              [-85.530729, 44.889182],
              [-85.532931, 44.87319],
              [-85.539042, 44.868868],
              [-85.545891, 44.864024],
              [-85.581392, 44.808294],
              [-85.581717, 44.807784],
              [-85.590985, 44.783914],
              [-85.591124, 44.7831],
              [-85.591145, 44.782981],
              [-85.591852, 44.778839],
              [-85.593449, 44.769499],
              [-85.593474, 44.769348],
              [-85.593571, 44.768783],
              [-85.593833, 44.768651],
              [-85.599103, 44.765996],
              [-85.599256, 44.765919],
              [-85.599874, 44.765878],
              [-85.605586, 44.765502],
              [-85.607701, 44.765363],
              [-85.610776, 44.76516],
              [-85.619648, 44.766371],
              [-85.620551, 44.766494],
              [-85.623607, 44.766911],
              [-85.624541, 44.767038],
              [-85.627982, 44.767508],
              [-85.636097, 44.771329],
              [-85.640216, 44.775051],
              [-85.640781, 44.775561],
              [-85.637, 44.790078],
              [-85.641652, 44.810816],
              [-85.651435, 44.831624],
              [-85.652355, 44.849092],
              [-85.648932, 44.87401],
              [-85.645456, 44.883645],
              [-85.639842, 44.890255],
              [-85.625497, 44.921107],
              [-85.621403, 44.923123],
              [-85.602034, 44.926743],
              [-85.602356, 44.974272],
              [-85.604301, 44.990983],
              [-85.606588, 44.990662],
              [-85.621878, 45.004529],
              [-85.609123, 45.013103],
              [-85.599652, 45.021749],
              [-85.597181, 45.040547],
              [-85.573976, 45.043361],
              [-85.57016, 45.041278],
              [-85.56613, 45.043633],
              [-85.566066, 45.059201],
              [-85.573353, 45.068382],
              [-85.583198, 45.071304],
              [-85.609266, 45.11351],
              [-85.614319, 45.127562],
              [-85.599801, 45.149286],
              [-85.590434, 45.153175],
              [-85.573893, 45.155488],
              [-85.570178, 45.155145],
              [-85.568489, 45.153762],
              [-85.566493, 45.153762],
              [-85.564897, 45.153962],
              [-85.5639, 45.154361],
              [-85.563102, 45.155358],
              [-85.562104, 45.156954],
              [-85.56168, 45.15894],
              [-85.552179, 45.167352],
              [-85.536892, 45.173385],
              [-85.531461, 45.177247],
              [-85.526734, 45.189316],
              [-85.540497, 45.210169],
              [-85.551072, 45.210742],
              [-85.561809, 45.200524],
              [-85.564654, 45.192546],
              [-85.585986, 45.180381],
              [-85.593064, 45.178527],
              [-85.606963, 45.178477],
              [-85.611684, 45.181104],
              [-85.613174, 45.184624],
              [-85.618639, 45.186771],
              [-85.656024, 45.145788],
              [-85.674861, 45.116216],
              [-85.675671, 45.10554],
              [-85.681096, 45.092693],
              [-85.695715, 45.076461],
              [-85.712262, 45.065622],
              [-85.740836, 45.055575],
              [-85.746444, 45.051229],
              [-85.761943, 45.023454],
              [-85.771395, 45.015181],
              [-85.776207, 45.000574],
              [-85.778278, 44.983075],
              [-85.780439, 44.977932],
              [-85.807403, 44.949814],
              [-85.815451, 44.945631],
              [-85.83615, 44.940256],
              [-85.854304, 44.938147],
              [-85.869852, 44.939031],
              [-85.879934, 44.943305],
              [-85.891543, 44.957783],
              [-85.897626, 44.962014],
              [-85.915851, 44.968307],
              [-85.9316, 44.968788],
              [-85.938589, 44.964559],
              [-85.942099, 44.954317],
              [-85.952721, 44.940758],
              [-85.961603, 44.935567],
              [-85.967169, 44.929484],
              [-85.972824, 44.914781],
              [-85.980219, 44.906136],
              [-85.992535, 44.900026],
              [-86.009355, 44.899454],
              [-86.021513, 44.902774],
              [-86.031194, 44.907349],
              [-86.038332, 44.915696],
              [-86.058862, 44.911012],
              [-86.066745, 44.905685],
              [-86.07099, 44.895876],
              [-86.072468, 44.884788],
              [-86.071112, 44.86542],
              [-86.066031, 44.834852],
              [-86.065966, 44.821522],
              [-86.071746, 44.804717],
              [-86.073073, 44.778393],
              [-86.073506, 44.769803],
              [-86.074658, 44.766792],
              [-86.076719, 44.761407],
              [-86.076811, 44.761167],
              [-86.077068, 44.760494],
              [-86.077933, 44.758234],
              [-86.089186, 44.741496],
              [-86.09074, 44.740544],
              [-86.105473, 44.731522],
              [-86.106182, 44.731088],
              [-86.108303, 44.730646],
              [-86.120759, 44.728048],
              [-86.121125, 44.727972],
              [-86.122466, 44.727979],
              [-86.122946, 44.727982],
              [-86.160268, 44.728189],
              [-86.160585, 44.727988],
              [-86.169323, 44.722448],
              [-86.172201, 44.720623],
              [-86.232482, 44.70605],
              [-86.248474, 44.699046],
              [-86.254996, 44.691935],
              [-86.256796, 44.686769],
              [-86.259029, 44.663654],
              [-86.25395, 44.64808],
              [-86.231828, 44.609107],
              [-86.22545, 44.59459],
              [-86.220697, 44.566742],
              [-86.223788, 44.549043],
              [-86.233503, 44.518278],
              [-86.238743, 44.501682],
              [-86.243745, 44.488929],
              [-86.248816, 44.483116],
              [-86.248897, 44.483024],
              [-86.248914, 44.483004],
              [-86.251605, 44.465443],
              [-86.251843, 44.451632],
              [-86.24832, 44.434758],
              [-86.248083, 44.420946],
              [-86.251926, 44.400984],
              [-86.26871, 44.345324],
              [-86.300264, 44.308197],
              [-86.304433, 44.301852],
              [-86.304691, 44.301459],
              [-86.311943, 44.290422],
              [-86.312774, 44.289158],
              [-86.313612, 44.287882],
              [-86.316025, 44.28421],
              [-86.316513, 44.283293],
              [-86.316651, 44.283034],
              [-86.318328, 44.279884],
              [-86.319063, 44.278503],
              [-86.326902, 44.263781],
              [-86.327287, 44.263057],
              [-86.343793, 44.249608],
              [-86.349294, 44.235459],
              [-86.351638, 44.229429],
              [-86.354313, 44.224342],
              [-86.354592, 44.223811],
              [-86.362847, 44.208113],
              [-86.380062, 44.189472],
              [-86.380188, 44.189272],
              [-86.386867, 44.178685],
              [-86.3965, 44.163418],
              [-86.397023, 44.162589],
              [-86.397874, 44.161239],
              [-86.400645, 44.156848],
              [-86.421108, 44.12948],
              [-86.421576, 44.128962],
              [-86.425162, 44.124993],
              [-86.425876, 44.124203],
              [-86.426873, 44.123099],
              [-86.429871, 44.119782],
              [-86.446609, 44.106193],
              [-86.446883, 44.10597],
              [-86.447126, 44.105832],
              [-86.447678, 44.105519],
              [-86.454895, 44.101429],
              [-86.469295, 44.093267],
              [-86.497937, 44.077033],
              [-86.500453, 44.075607],
              [-86.501243, 44.074873],
              [-86.508415, 44.068206],
              [-86.508764, 44.067881],
              [-86.509052, 44.067408],
              [-86.514573, 44.05833],
              [-86.514702, 44.058119],
              [-86.514704, 44.057672],
              [-86.514742, 44.04792],
              [-86.508827, 44.032755],
              [-86.50444, 44.026044],
              [-86.504133, 44.025575],
              [-86.502998, 44.023839],
              [-86.501738, 44.021912],
              [-86.484399, 44.002382],
              [-86.483331, 44.001179],
              [-86.481606, 43.998599],
              [-86.46322, 43.971101],
              [-86.463136, 43.970976],
              [-86.463087, 43.970807],
              [-86.462756, 43.969655],
              [-86.454401, 43.940624],
              [-86.451275, 43.929763],
              [-86.44955, 43.92377],
              [-86.448147, 43.918897],
              [-86.448009, 43.918416],
              [-86.447915, 43.918089],
              [-86.446463, 43.901349],
              [-86.445938, 43.89529],
              [-86.44573, 43.892897],
              [-86.445455, 43.889726],
              [-86.434985, 43.858771],
              [-86.434258, 43.856623],
              [-86.434078, 43.85609],
              [-86.433915, 43.855608],
              [-86.433471, 43.853176],
              [-86.432894, 43.850013],
              [-86.431238, 43.840941],
              [-86.431198, 43.84072],
              [-86.431182, 43.838119],
              [-86.431176, 43.837177],
              [-86.431172, 43.836638],
              [-86.431064, 43.819406],
              [-86.431063, 43.819178],
              [-86.431043, 43.815975],
              [-86.43114, 43.815569],
              [-86.437391, 43.789334],
              [-86.437722, 43.788573],
              [-86.442786, 43.776934],
              [-86.444903, 43.772069],
              [-86.445123, 43.771564],
              [-86.445532, 43.770945],
              [-86.460444, 43.748366],
              [-86.461554, 43.746685],
              [-86.463436, 43.744687],
              [-86.480267, 43.726819],
              [-86.480628, 43.726436],
              [-86.480655, 43.726407],
              [-86.481854, 43.725135],
              [-86.486983, 43.720358],
              [-86.488381, 43.719056],
              [-86.496187, 43.711787],
              [-86.501899, 43.706467],
              [-86.502989, 43.705452],
              [-86.503192, 43.705263],
              [-86.504679, 43.703878],
              [-86.50669, 43.702004],
              [-86.50762, 43.701138],
              [-86.510319, 43.698625],
              [-86.511008, 43.697867],
              [-86.514371, 43.69417],
              [-86.516152, 43.692212],
              [-86.517867, 43.690326],
              [-86.526863, 43.680435],
              [-86.527667, 43.679552],
              [-86.529179, 43.677889],
              [-86.529686, 43.676849],
              [-86.538186, 43.659403],
              [-86.538482, 43.658795],
              [-86.538763, 43.657061],
              [-86.54064, 43.645499],
              [-86.540787, 43.644593],
              [-86.54081, 43.642516],
              [-86.540896, 43.634969],
              [-86.540906, 43.634047],
              [-86.540916, 43.633158],
              [-86.539303, 43.62272],
              [-86.539291, 43.622642],
              [-86.539103, 43.621424],
              [-86.538921, 43.620244],
              [-86.538876, 43.619957],
              [-86.538497, 43.617501],
              [-86.537923, 43.615965],
              [-86.529507, 43.593462],
              [-86.520248, 43.576796],
              [-86.520205, 43.576718],
              [-86.519912, 43.576278],
              [-86.518698, 43.574458],
              [-86.517493, 43.572651],
              [-86.516725, 43.571499],
              [-86.516295, 43.570854],
              [-86.515838, 43.570169],
              [-86.515108, 43.569074],
              [-86.514168, 43.567664],
              [-86.512317, 43.564887],
              [-86.509339, 43.560421],
              [-86.509205, 43.560221],
              [-86.505799, 43.555112],
              [-86.483083, 43.521045],
              [-86.483043, 43.520984],
              [-86.482255, 43.519803],
              [-86.48187, 43.519225],
              [-86.48165, 43.518896],
              [-86.481158, 43.518158],
              [-86.479552, 43.51575],
              [-86.479276, 43.515335],
              [-86.478716, 43.514091],
              [-86.477424, 43.511223],
              [-86.476956, 43.510184],
              [-86.468919, 43.492344],
              [-86.468754, 43.491979],
              [-86.468747, 43.491963],
              [-86.462195, 43.472328],
              [-86.457561, 43.458441],
              [-86.456845, 43.456294],
              [-86.456083, 43.45401],
              [-86.45457, 43.449475],
              [-86.448743, 43.432013],
              [-86.448479, 43.431329],
              [-86.438875, 43.406427],
              [-86.438267, 43.404851],
              [-86.438028, 43.404231],
              [-86.437896, 43.40389],
              [-86.435271, 43.397083],
              [-86.435124, 43.396702],
              [-86.434842, 43.3961],
              [-86.434757, 43.395919],
              [-86.427585, 43.380607],
              [-86.411941, 43.347209],
              [-86.407832, 43.338436],
              [-86.404831, 43.33292],
              [-86.403541, 43.330548],
              [-86.40301, 43.329572],
              [-86.401684, 43.327135],
              [-86.39575, 43.316225],
              [-86.393385, 43.312622],
              [-86.392124, 43.310701],
              [-86.38941, 43.306565],
              [-86.388493, 43.305168],
              [-86.386374, 43.301941],
              [-86.386096, 43.301516],
              [-86.383821, 43.298051],
              [-86.382882, 43.29662],
              [-86.357996, 43.258703],
              [-86.354505, 43.253385],
              [-86.352314, 43.250047],
              [-86.352192, 43.24986],
              [-86.350027, 43.246562],
              [-86.349801, 43.246217],
              [-86.34891, 43.24486],
              [-86.348647, 43.244459],
              [-86.344643, 43.23836],
              [-86.329836, 43.2158],
              [-86.316259, 43.195114],
              [-86.311887, 43.187837],
              [-86.311336, 43.18692],
              [-86.299048, 43.166465],
              [-86.280756, 43.136015],
              [-86.271996, 43.118365],
              [-86.254646, 43.083409],
              [-86.250517, 43.066993],
              [-86.250069, 43.057489],
              [-86.244277, 43.049681],
              [-86.232707, 43.015762],
              [-86.226305, 42.988284],
              [-86.216209, 42.919007],
              [-86.214138, 42.883555],
              [-86.210737, 42.859128],
              [-86.211815, 42.833236],
              [-86.210863, 42.783832],
              [-86.208886, 42.76754],
              [-86.208309, 42.762789],
              [-86.206834, 42.719424],
              [-86.208654, 42.69209],
              [-86.21602, 42.664413],
              [-86.226638, 42.644922],
              [-86.22905, 42.637693],
              [-86.225613, 42.594765],
              [-86.225978, 42.593084],
              [-86.226037, 42.592811],
              [-86.228082, 42.583397],
              [-86.23119, 42.575435],
              [-86.234594, 42.566715],
              [-86.234755, 42.566302],
              [-86.235254, 42.565023],
              [-86.23528, 42.564958],
              [-86.240642, 42.54],
              [-86.241446, 42.534697],
              [-86.24971, 42.480212],
              [-86.261573, 42.443894],
              [-86.273893, 42.41928],
              [-86.276878, 42.413317],
              [-86.284969, 42.401814],
              [-86.284448, 42.394563],
              [-86.297168, 42.358207],
              [-86.321803, 42.310743],
              [-86.356218, 42.254166],
              [-86.36488, 42.243133],
              [-86.380035, 42.22383],
              [-86.380407, 42.223357],
              [-86.381434, 42.222048],
              [-86.383585, 42.21931],
              [-86.383665, 42.219207],
              [-86.385179, 42.217279],
              [-86.386591, 42.215723],
              [-86.393518, 42.20809],
              [-86.393565, 42.208039],
              [-86.394183, 42.207357],
              [-86.394997, 42.20646],
              [-86.397692, 42.203491],
              [-86.398536, 42.202561],
              [-86.398915, 42.202143],
              [-86.402183, 42.198542],
              [-86.404146, 42.196379],
              [-86.437148, 42.163453],
              [-86.437909, 42.162694],
              [-86.439416, 42.16119],
              [-86.440762, 42.159847],
              [-86.463685, 42.136977],
              [-86.463967, 42.136696],
              [-86.464356, 42.136308],
              [-86.464897, 42.135767],
              [-86.464913, 42.135752],
              [-86.466262, 42.134406],
              [-86.466576, 42.134138],
              [-86.479031, 42.123519],
              [-86.485223, 42.118239],
              [-86.490122, 42.105139],
              [-86.501322, 42.08454],
              [-86.508856, 42.072986],
              [-86.532161, 42.037246],
              [-86.53264, 42.036512],
              [-86.532934, 42.036061],
              [-86.533855, 42.034648],
              [-86.536063, 42.031262],
              [-86.541089, 42.023555],
              [-86.541718, 42.02259],
              [-86.544867, 42.017761],
              [-86.545288, 42.017115],
              [-86.549237, 42.011059],
              [-86.549328, 42.01092],
              [-86.556421, 42.000042],
              [-86.556537, 41.999782],
              [-86.561542, 41.988559],
              [-86.563598, 41.983948],
              [-86.563904, 41.983262],
              [-86.564077, 41.982874],
              [-86.564276, 41.982427],
              [-86.564722, 41.981427],
              [-86.581518, 41.943765],
              [-86.582197, 41.942241],
              [-86.582894, 41.941179],
              [-86.585264, 41.937562],
              [-86.585696, 41.936904],
              [-86.586721, 41.935341],
              [-86.587763, 41.933752],
              [-86.587827, 41.933653],
              [-86.588662, 41.93238],
              [-86.596802, 41.919964],
              [-86.597899, 41.918291],
              [-86.600524, 41.91531],
              [-86.610896, 41.903532],
              [-86.611511, 41.902833],
              [-86.61208, 41.902188],
              [-86.612251, 41.901993],
              [-86.616029, 41.897703],
              [-86.616886, 41.89673],
              [-86.616978, 41.896625],
              [-86.619442, 41.893827],
              [-86.621259, 41.89234],
              [-86.623774, 41.890282],
              [-86.623837, 41.89023],
              [-86.629344, 41.885723],
              [-86.629867, 41.885295],
              [-86.643965, 41.873757],
              [-86.644048, 41.873689],
              [-86.645296, 41.872668],
              [-86.6476, 41.870782],
              [-86.648971, 41.869659],
              [-86.679355, 41.844793],
              [-86.679672, 41.844579],
              [-86.697541, 41.832513],
              [-86.715578, 41.820334],
              [-86.717037, 41.819349],
              [-86.735207, 41.808901],
              [-86.751292, 41.799652],
              [-86.774798, 41.786137],
              [-86.77608, 41.785399],
              [-86.777227, 41.78474],
              [-86.777943, 41.784371],
              [-86.79351, 41.776359],
              [-86.794632, 41.775782],
              [-86.794712, 41.77574],
              [-86.801772, 41.772107],
              [-86.802065, 41.771956],
              [-86.82355, 41.760898],
              [-86.824828, 41.76024],
              [-86.875429, 41.737939],
              [-86.90913, 41.726938],
              [-86.932747, 41.71104],
              [-86.93483, 41.709638],
              [-87.00964, 41.68152],
              [-87.027888, 41.674661],
              [-87.066033, 41.661845],
              [-87.120322, 41.645701],
              [-87.125835, 41.650302],
              [-87.160784, 41.645385],
              [-87.160625, 41.637266],
              [-87.187651, 41.629653],
              [-87.22066, 41.624356],
              [-87.222644, 41.624161],
              [-87.261536, 41.620336],
              [-87.278437, 41.619736],
              [-87.287637, 41.622236],
              [-87.324338, 41.623036],
              [-87.365439, 41.629536],
              [-87.394539, 41.637235],
              [-87.42344, 41.642835],
              [-87.42984, 41.646035],
              [-87.438941, 41.654335],
              [-87.432396, 41.66053],
              [-87.432953, 41.665102],
              [-87.434849, 41.666887],
              [-87.437191, 41.669006],
              [-87.43853, 41.670679],
              [-87.441987, 41.671905],
              [-87.446113, 41.66934],
              [-87.453041, 41.673035],
              [-87.463142, 41.675535],
              [-87.470742, 41.672835],
              [-87.505343, 41.691535],
              [-87.511043, 41.696535],
              [-87.515243, 41.704235],
              [-87.520544, 41.709935],
              [-87.524044, 41.708335],
              [-87.524141, 41.72399],
              [-87.530745, 41.748235],
              [-87.542845, 41.752135],
              [-87.560646, 41.766034],
              [-87.576347, 41.786034],
              [-87.58055, 41.80275],
              [-87.58092, 41.804225],
              [-87.580948, 41.804334],
              [-87.587054, 41.811342],
              [-87.587123, 41.811422],
              [-87.600549, 41.826833],
              [-87.60945, 41.845233],
              [-87.616251, 41.868933],
              [-87.616537, 41.882396],
              [-87.615734, 41.882958],
              [-87.613654, 41.884412],
              [-87.613556, 41.88448],
              [-87.614188, 41.888421],
              [-87.61268, 41.889248],
              [-87.611659, 41.890708],
              [-87.611659, 41.892216],
              [-87.612291, 41.893335],
              [-87.614163, 41.893418],
              [-87.617433, 41.898032],
              [-87.619852, 41.901392],
              [-87.622944, 41.90202],
              [-87.624052, 41.904232],
              [-87.624134, 41.904574],
              [-87.624763, 41.907209],
              [-87.627038, 41.916738],
              [-87.63087, 41.932784],
              [-87.630953, 41.933132],
              [-87.668982, 42.029142],
              [-87.671094, 42.042802],
              [-87.671894, 42.047972],
              [-87.671184, 42.050548],
              [-87.671119, 42.050781],
              [-87.670699, 42.052305],
              [-87.670512, 42.05298],
              [-87.671462, 42.058334],
              [-87.679843, 42.071713],
              [-87.68075, 42.07316],
              [-87.682179, 42.075441],
              [-87.682359, 42.075729],
              [-87.70237, 42.089442],
              [-87.703882, 42.090478],
              [-87.704594, 42.090966],
              [-87.706415, 42.092213],
              [-87.71096, 42.095328],
              [-87.712206, 42.096455],
              [-87.717169, 42.100947],
              [-87.717276, 42.101044],
              [-87.717504, 42.10125],
              [-87.718065, 42.101758],
              [-87.720303, 42.103783],
              [-87.720407, 42.103878],
              [-87.7215, 42.104866],
              [-87.72222, 42.105518],
              [-87.722306, 42.105596],
              [-87.723723, 42.106879],
              [-87.724603, 42.107674],
              [-87.724661, 42.107727],
              [-87.725196, 42.108373],
              [-87.727005, 42.110554],
              [-87.727248, 42.110847],
              [-87.728191, 42.111984],
              [-87.728335, 42.112157],
              [-87.729378, 42.113414],
              [-87.729387, 42.113426],
              [-87.730463, 42.114723],
              [-87.733929, 42.118903],
              [-87.739529, 42.125655],
              [-87.739735, 42.125903],
              [-87.740718, 42.127089],
              [-87.740787, 42.127172],
              [-87.741318, 42.127812],
              [-87.741662, 42.128227],
              [-87.746421, 42.134729],
              [-87.748486, 42.13755],
              [-87.750396, 42.14016],
              [-87.754358, 42.145573],
              [-87.754444, 42.145691],
              [-87.754767, 42.146132],
              [-87.755826, 42.147579],
              [-87.75639, 42.14835],
              [-87.759327, 42.152362],
              [-87.775295, 42.174179],
              [-87.787241, 42.190501],
              [-87.788313, 42.191966],
              [-87.796779, 42.203533],
              [-87.796937, 42.203748],
              [-87.797444, 42.204442],
              [-87.797497, 42.204514],
              [-87.7983, 42.205611],
              [-87.798589, 42.206007],
              [-87.800066, 42.208024],
              [-87.803873, 42.215449],
              [-87.808395, 42.224271],
              [-87.812267, 42.231823],
              [-87.812315, 42.231935],
              [-87.812422, 42.232185],
              [-87.812461, 42.232278],
              [-87.825313, 42.262313],
              [-87.826944, 42.266125],
              [-87.82772, 42.267937],
              [-87.828034, 42.268673],
              [-87.828569, 42.269922],
              [-87.831286, 42.283772],
              [-87.83253, 42.290109],
              [-87.832738, 42.291173],
              [-87.833468, 42.294892],
              [-87.834769, 42.301522],
              [-87.831221, 42.32853],
              [-87.830986, 42.330317],
              [-87.830646, 42.331368],
              [-87.826717, 42.343497],
              [-87.820871, 42.361544],
              [-87.820858, 42.361584],
              [-87.81657, 42.364621],
              [-87.81557, 42.366416],
              [-87.80613, 42.383357],
              [-87.80537, 42.384721],
              [-87.80375, 42.413793],
              [-87.803529, 42.417759],
              [-87.80337, 42.420621],
              [-87.800752, 42.445867],
              [-87.798071, 42.471721],
              [-87.79823, 42.473054],
              [-87.798971, 42.479278],
              [-87.800317, 42.490578],
              [-87.800477, 42.49192],
            ],
          ],
          [
            [
              [-90.456677, 47.016737],
              [-90.457272, 47.013707],
              [-90.457315, 47.013488],
              [-90.457453, 47.012783],
              [-90.457688, 47.012484],
              [-90.465321, 47.002777],
              [-90.465465, 47.002593],
              [-90.464087, 46.994681],
              [-90.464079, 46.994636],
              [-90.457445, 46.996735],
              [-90.453619, 46.997946],
              [-90.448857, 46.999452],
              [-90.429539, 47.005565],
              [-90.429397, 47.00561],
              [-90.428438, 47.006064],
              [-90.428273, 47.006142],
              [-90.42732, 47.006593],
              [-90.425351, 47.007526],
              [-90.413428, 47.01317],
              [-90.413133, 47.013533],
              [-90.412886, 47.013836],
              [-90.411972, 47.014958],
              [-90.409437, 47.018072],
              [-90.405033, 47.023482],
              [-90.403908, 47.024864],
              [-90.403499, 47.025366],
              [-90.403321, 47.02659],
              [-90.403306, 47.026693],
              [-90.400427, 47.046463],
              [-90.400409, 47.046588],
              [-90.400365, 47.046691],
              [-90.400219, 47.047034],
              [-90.400067, 47.047391],
              [-90.396275, 47.056299],
              [-90.396177, 47.056528],
              [-90.395988, 47.056972],
              [-90.394312, 47.060909],
              [-90.394212, 47.061452],
              [-90.393507, 47.065302],
              [-90.393351, 47.066153],
              [-90.393342, 47.066204],
              [-90.393277, 47.066557],
              [-90.393241, 47.066753],
              [-90.393035, 47.067877],
              [-90.393077, 47.068304],
              [-90.393111, 47.068644],
              [-90.393115, 47.068687],
              [-90.393723, 47.074859],
              [-90.39383, 47.075941],
              [-90.393848, 47.075956],
              [-90.39495, 47.076841],
              [-90.39517, 47.077017],
              [-90.395367, 47.077175],
              [-90.398913, 47.077239],
              [-90.400234, 47.077263],
              [-90.417272, 47.07757],
              [-90.425277, 47.075934],
              [-90.427087, 47.075564],
              [-90.42837, 47.075302],
              [-90.434543, 47.07404],
              [-90.434762, 47.073996],
              [-90.435387, 47.073868],
              [-90.437271, 47.073483],
              [-90.438734, 47.072557],
              [-90.441968, 47.070511],
              [-90.448439, 47.066415],
              [-90.449024, 47.066045],
              [-90.449075, 47.066013],
              [-90.449083, 47.065995],
              [-90.449572, 47.064965],
              [-90.455024, 47.05347],
              [-90.455113, 47.053071],
              [-90.455502, 47.051331],
              [-90.457128, 47.044058],
              [-90.457076, 47.043506],
              [-90.45638, 47.036062],
              [-90.456008, 47.032085],
              [-90.455251, 47.024],
              [-90.4553, 47.02375],
              [-90.456677, 47.016737],
            ],
          ],
          [
            [
              [-90.636718, 46.861323],
              [-90.637091, 46.860895],
              [-90.637885, 46.859981],
              [-90.643218, 46.853844],
              [-90.646982, 46.851001],
              [-90.647486, 46.85062],
              [-90.650914, 46.848031],
              [-90.651231, 46.847792],
              [-90.651804, 46.847359],
              [-90.654472, 46.845344],
              [-90.654497, 46.845325],
              [-90.655691, 46.844424],
              [-90.655873, 46.844286],
              [-90.656109, 46.844108],
              [-90.656946, 46.843476],
              [-90.672908, 46.835202],
              [-90.675364, 46.833929],
              [-90.682954, 46.831225],
              [-90.694496, 46.827114],
              [-90.704619, 46.823508],
              [-90.712381, 46.820743],
              [-90.720932, 46.815897],
              [-90.727818, 46.810434],
              [-90.727952, 46.809319],
              [-90.728384, 46.805707],
              [-90.728546, 46.804356],
              [-90.729581, 46.803395],
              [-90.732823, 46.800385],
              [-90.733001, 46.800219],
              [-90.733231, 46.800183],
              [-90.736609, 46.799654],
              [-90.740603, 46.799029],
              [-90.74572, 46.798228],
              [-90.758586, 46.796214],
              [-90.759119, 46.796044],
              [-90.781682, 46.788835],
              [-90.790231, 46.786103],
              [-90.791562, 46.784983],
              [-90.791517, 46.784713],
              [-90.791392, 46.783955],
              [-90.791358, 46.783752],
              [-90.791085, 46.782097],
              [-90.790992, 46.781534],
              [-90.790965, 46.781373],
              [-90.789243, 46.779529],
              [-90.788926, 46.779191],
              [-90.783086, 46.772939],
              [-90.785415, 46.76452],
              [-90.787554, 46.756786],
              [-90.788285, 46.754145],
              [-90.78843, 46.753619],
              [-90.788515, 46.753313],
              [-90.788304, 46.75331],
              [-90.78781, 46.753302],
              [-90.787751, 46.753301],
              [-90.774436, 46.753086],
              [-90.771228, 46.753034],
              [-90.766611, 46.754187],
              [-90.765221, 46.754534],
              [-90.763647, 46.754927],
              [-90.7625, 46.755547],
              [-90.758019, 46.757969],
              [-90.739425, 46.768021],
              [-90.73884, 46.768539],
              [-90.734915, 46.772015],
              [-90.723938, 46.781737],
              [-90.716456, 46.785418],
              [-90.706594, 46.783752],
              [-90.696934, 46.782119],
              [-90.696465, 46.78204],
              [-90.692974, 46.782641],
              [-90.691473, 46.782899],
              [-90.689259, 46.78328],
              [-90.688602, 46.783393],
              [-90.68763, 46.78356],
              [-90.679469, 46.784964],
              [-90.66326, 46.787754],
              [-90.661517, 46.788054],
              [-90.661154, 46.788116],
              [-90.660541, 46.788221],
              [-90.65892, 46.7885],
              [-90.657179, 46.7888],
              [-90.656358, 46.789745],
              [-90.655682, 46.790524],
              [-90.655611, 46.790606],
              [-90.655483, 46.790753],
              [-90.655375, 46.790877],
              [-90.655339, 46.790919],
              [-90.654103, 46.792342],
              [-90.653417, 46.793131],
              [-90.652591, 46.794083],
              [-90.652219, 46.794511],
              [-90.652236, 46.794589],
              [-90.652343, 46.795088],
              [-90.652906, 46.797707],
              [-90.652916, 46.797755],
              [-90.65455, 46.798723],
              [-90.654861, 46.798907],
              [-90.65531, 46.799173],
              [-90.665389, 46.799394],
              [-90.670049, 46.799496],
              [-90.670438, 46.799633],
              [-90.685753, 46.805003],
              [-90.683356, 46.813275],
              [-90.676133, 46.818986],
              [-90.673838, 46.819684],
              [-90.658031, 46.824493],
              [-90.62548, 46.834395],
              [-90.61424, 46.837815],
              [-90.613822, 46.837942],
              [-90.613569, 46.837958],
              [-90.610306, 46.838168],
              [-90.609501, 46.838219],
              [-90.60329, 46.838618],
              [-90.601288, 46.838747],
              [-90.589921, 46.839476],
              [-90.58505, 46.839789],
              [-90.584489, 46.839825],
              [-90.582347, 46.840454],
              [-90.57839, 46.841616],
              [-90.578263, 46.841653],
              [-90.570652, 46.846192],
              [-90.569108, 46.847112],
              [-90.568874, 46.847252],
              [-90.568938, 46.847391],
              [-90.569868, 46.849398],
              [-90.570006, 46.849696],
              [-90.587306, 46.858015],
              [-90.587392, 46.858056],
              [-90.58819, 46.858827],
              [-90.593899, 46.864344],
              [-90.601924, 46.872099],
              [-90.602552, 46.872706],
              [-90.602619, 46.872715],
              [-90.616452, 46.874466],
              [-90.622048, 46.872872],
              [-90.634048, 46.864396],
              [-90.636386, 46.861705],
              [-90.636718, 46.861323],
            ],
          ],
          [
            [
              [-90.579568, 46.91823],
              [-90.569169, 46.920309],
              [-90.557319, 46.918693],
              [-90.55328, 46.916674],
              [-90.550371, 46.915829],
              [-90.549104, 46.915461],
              [-90.545872, 46.916673],
              [-90.545105, 46.917287],
              [-90.543852, 46.918289],
              [-90.543583, 46.923002],
              [-90.539947, 46.92785],
              [-90.535368, 46.931486],
              [-90.532652, 46.932489],
              [-90.524056, 46.935664],
              [-90.524018, 46.935714],
              [-90.511124, 46.952885],
              [-90.508157, 46.956836],
              [-90.509372, 46.958438],
              [-90.50988, 46.959108],
              [-90.511623, 46.961407],
              [-90.512211, 46.961719],
              [-90.512884, 46.962076],
              [-90.513328, 46.962312],
              [-90.514616, 46.962996],
              [-90.514782, 46.963084],
              [-90.521791, 46.966804],
              [-90.523298, 46.967604],
              [-90.524874, 46.96786],
              [-90.528182, 46.968396],
              [-90.528804, 46.968497],
              [-90.530597, 46.968099],
              [-90.572383, 46.958835],
              [-90.601153, 46.952457],
              [-90.601876, 46.952251],
              [-90.633915, 46.943113],
              [-90.634507, 46.942944],
              [-90.643328, 46.933944],
              [-90.643966, 46.933294],
              [-90.64479, 46.932453],
              [-90.64534, 46.931893],
              [-90.646351, 46.93086],
              [-90.651043, 46.926074],
              [-90.651834, 46.925267],
              [-90.654797, 46.919276],
              [-90.654805, 46.919259],
              [-90.654796, 46.919249],
              [-90.644218, 46.908455],
              [-90.644144, 46.908379],
              [-90.64412, 46.908373],
              [-90.637124, 46.906724],
              [-90.625685, 46.909011],
              [-90.624635, 46.909221],
              [-90.623547, 46.909438],
              [-90.592933, 46.915558],
              [-90.579568, 46.91823],
            ],
          ],
          [
            [
              [-87.500105, 45.061117],
              [-87.500603, 45.061094],
              [-87.501802, 45.060841],
              [-87.50244, 45.060706],
              [-87.503602, 45.060272],
              [-87.50428, 45.060067],
              [-87.504488, 45.060024],
              [-87.506054, 45.059702],
              [-87.506109, 45.059644],
              [-87.506184, 45.059565],
              [-87.506086, 45.059461],
              [-87.506055, 45.059428],
              [-87.504967, 45.059287],
              [-87.504281, 45.059198],
              [-87.501572, 45.058602],
              [-87.500105, 45.058167],
              [-87.498863, 45.057847],
              [-87.49867, 45.057779],
              [-87.498379, 45.057733],
              [-87.494475, 45.056523],
              [-87.492668, 45.055792],
              [-87.490925, 45.055039],
              [-87.490312, 45.054948],
              [-87.490189, 45.055017],
              [-87.490151, 45.055039],
              [-87.490216, 45.055222],
              [-87.491345, 45.056022],
              [-87.491507, 45.05609],
              [-87.491636, 45.056227],
              [-87.491765, 45.056273],
              [-87.492023, 45.056502],
              [-87.492314, 45.056936],
              [-87.492411, 45.057233],
              [-87.492516, 45.057419],
              [-87.49254, 45.057462],
              [-87.492563, 45.057653],
              [-87.492573, 45.057736],
              [-87.492691, 45.057799],
              [-87.492702, 45.057805],
              [-87.49285, 45.058325],
              [-87.492864, 45.058376],
              [-87.493381, 45.059107],
              [-87.494543, 45.060044],
              [-87.495479, 45.060661],
              [-87.496415, 45.061072],
              [-87.497254, 45.061278],
              [-87.498964, 45.061231],
              [-87.500105, 45.061117],
            ],
          ],
          [
            [
              [-86.945964, 45.407673],
              [-86.946837, 45.40541],
              [-86.947074, 45.404796],
              [-86.947346, 45.40409],
              [-86.951176, 45.394162],
              [-86.951866, 45.392373],
              [-86.953773, 45.38743],
              [-86.954329, 45.385989],
              [-86.955204, 45.383721],
              [-86.95497, 45.383194],
              [-86.948803, 45.369338],
              [-86.948743, 45.369205],
              [-86.948731, 45.369178],
              [-86.947684, 45.366825],
              [-86.947604, 45.366645],
              [-86.94751, 45.366434],
              [-86.947142, 45.364085],
              [-86.946791, 45.361845],
              [-86.946503, 45.360004],
              [-86.946475, 45.359826],
              [-86.946297, 45.35869],
              [-86.948272, 45.355682],
              [-86.95336, 45.35472],
              [-86.953389, 45.354715],
              [-86.954435, 45.353706],
              [-86.956198, 45.352006],
              [-86.956192, 45.351179],
              [-86.95614, 45.343785],
              [-86.956129, 45.342267],
              [-86.956054, 45.342202],
              [-86.955691, 45.341888],
              [-86.955577, 45.341788],
              [-86.955456, 45.341684],
              [-86.95499, 45.34128],
              [-86.95155, 45.338298],
              [-86.948087, 45.335296],
              [-86.946943, 45.335058],
              [-86.946796, 45.335027],
              [-86.94107, 45.333836],
              [-86.940715, 45.333762],
              [-86.937368, 45.333065],
              [-86.925681, 45.3242],
              [-86.913995, 45.31211],
              [-86.904898, 45.296839],
              [-86.904362, 45.296662],
              [-86.901602, 45.29575],
              [-86.900636, 45.295431],
              [-86.899891, 45.295185],
              [-86.896928, 45.2983],
              [-86.896922, 45.298521],
              [-86.896667, 45.307275],
              [-86.899488, 45.322588],
              [-86.895055, 45.329035],
              [-86.887802, 45.332259],
              [-86.880572, 45.331467],
              [-86.879361, 45.331335],
              [-86.875117, 45.33087],
              [-86.874761, 45.331008],
              [-86.874685, 45.331037],
              [-86.872296, 45.331962],
              [-86.86951, 45.333041],
              [-86.869041, 45.333223],
              [-86.869031, 45.333244],
              [-86.866054, 45.339765],
              [-86.865634, 45.340686],
              [-86.865499, 45.340981],
              [-86.865528, 45.341136],
              [-86.866126, 45.344356],
              [-86.866244, 45.344992],
              [-86.86771, 45.35289],
              [-86.867743, 45.353065],
              [-86.864314, 45.362764],
              [-86.863719, 45.364446],
              [-86.863694, 45.364518],
              [-86.8636, 45.364783],
              [-86.863563, 45.364888],
              [-86.863367, 45.365],
              [-86.858384, 45.367846],
              [-86.857308, 45.36846],
              [-86.853182, 45.370816],
              [-86.853103, 45.370861],
              [-86.841432, 45.389601],
              [-86.837482, 45.393432],
              [-86.82473, 45.405798],
              [-86.824383, 45.406135],
              [-86.822083, 45.406868],
              [-86.81954, 45.407679],
              [-86.818073, 45.408147],
              [-86.817148, 45.40795],
              [-86.815881, 45.40768],
              [-86.814956, 45.407483],
              [-86.808658, 45.406143],
              [-86.808303, 45.406067],
              [-86.805415, 45.407324],
              [-86.805652, 45.410247],
              [-86.805767, 45.411661],
              [-86.805843, 45.412592],
              [-86.805868, 45.412903],
              [-86.805978, 45.413159],
              [-86.80991, 45.422283],
              [-86.810055, 45.422619],
              [-86.81551, 45.425998],
              [-86.816741, 45.42676],
              [-86.817069, 45.426963],
              [-86.82177, 45.427602],
              [-86.828071, 45.428459],
              [-86.828661, 45.428539],
              [-86.828731, 45.428461],
              [-86.830755, 45.426186],
              [-86.8309, 45.426023],
              [-86.830175, 45.422092],
              [-86.830123, 45.421805],
              [-86.829905, 45.420623],
              [-86.829143, 45.41649],
              [-86.829352, 45.415516],
              [-86.829741, 45.413705],
              [-86.830331, 45.410955],
              [-86.830353, 45.410852],
              [-86.853082, 45.405562],
              [-86.853145, 45.405547],
              [-86.855993, 45.407777],
              [-86.859922, 45.410853],
              [-86.861317, 45.411946],
              [-86.861472, 45.412067],
              [-86.862174, 45.412151],
              [-86.865002, 45.412489],
              [-86.877502, 45.413981],
              [-86.880629, 45.412965],
              [-86.883364, 45.412076],
              [-86.892893, 45.40898],
              [-86.898049, 45.408753],
              [-86.902739, 45.408547],
              [-86.909743, 45.408239],
              [-86.914004, 45.408052],
              [-86.917686, 45.40789],
              [-86.927768, 45.411183],
              [-86.928045, 45.411273],
              [-86.928246, 45.411784],
              [-86.929028, 45.41377],
              [-86.930511, 45.417536],
              [-86.934091, 45.420972],
              [-86.934276, 45.421149],
              [-86.934724, 45.421123],
              [-86.936224, 45.421035],
              [-86.937393, 45.420966],
              [-86.941237, 45.417075],
              [-86.942901, 45.415392],
              [-86.943041, 45.41525],
              [-86.945964, 45.407673],
            ],
          ],
          [
            [
              [-85.566441, 45.760222],
              [-85.567781, 45.757655],
              [-85.567128, 45.750419],
              [-85.564774, 45.745462],
              [-85.565132, 45.730719],
              [-85.572309, 45.711449],
              [-85.583724, 45.700796],
              [-85.590769, 45.698051],
              [-85.600842, 45.68886],
              [-85.604881, 45.681932],
              [-85.609295, 45.658067],
              [-85.604951, 45.647599],
              [-85.604521, 45.639256],
              [-85.608653, 45.632008],
              [-85.61985, 45.624547],
              [-85.630016, 45.598166],
              [-85.622741, 45.586028],
              [-85.618049, 45.582647],
              [-85.561634, 45.572213],
              [-85.541129, 45.575045],
              [-85.534064, 45.578198],
              [-85.530273, 45.589253],
              [-85.526895, 45.59159],
              [-85.518038, 45.592912],
              [-85.509276, 45.596475],
              [-85.491347, 45.609665],
              [-85.487026, 45.621211],
              [-85.490252, 45.652122],
              [-85.500451, 45.664298],
              [-85.503767, 45.670472],
              [-85.506104, 45.681148],
              [-85.5028, 45.690998],
              [-85.494016, 45.698476],
              [-85.494154, 45.705378],
              [-85.498777, 45.726291],
              [-85.510895, 45.734414],
              [-85.520803, 45.737247],
              [-85.521911, 45.739419],
              [-85.520569, 45.744745],
              [-85.515145, 45.749451],
              [-85.50904, 45.748488],
              [-85.508522, 45.744991],
              [-85.510091, 45.742888],
              [-85.508818, 45.742358],
              [-85.503758, 45.742771],
              [-85.497656, 45.746246],
              [-85.501267, 45.754415],
              [-85.506133, 45.754715],
              [-85.525237, 45.750462],
              [-85.53562, 45.750394],
              [-85.54375, 45.751413],
              [-85.54956, 45.757266],
              [-85.566441, 45.760222],
            ],
          ],
          [
            [
              [-88.684434, 48.115785],
              [-88.695353, 48.110549],
              [-88.705586, 48.111013],
              [-88.728198, 48.101914],
              [-88.744458, 48.092769],
              [-88.764256, 48.085189],
              [-88.77183, 48.079457],
              [-88.772077, 48.070502],
              [-88.787556, 48.063035],
              [-88.810461, 48.055247],
              [-88.816084, 48.057006],
              [-88.835714, 48.056752],
              [-88.893701, 48.03477],
              [-88.896327, 48.031801],
              [-88.895069, 48.029059],
              [-88.915032, 48.020681],
              [-88.927529, 48.019615],
              [-88.931487, 48.021637],
              [-88.940886, 48.01959],
              [-88.994163, 48.00229],
              [-89.018303, 47.992525],
              [-89.095207, 47.967922],
              [-89.179154, 47.93503],
              [-89.214499, 47.913895],
              [-89.221332, 47.908069],
              [-89.22071, 47.90085],
              [-89.226327, 47.895438],
              [-89.247127, 47.888503],
              [-89.255202, 47.876102],
              [-89.250936, 47.870377],
              [-89.246774, 47.871016],
              [-89.228507, 47.858039],
              [-89.234535, 47.855373],
              [-89.235552, 47.853774],
              [-89.234533, 47.851718],
              [-89.201812, 47.850243],
              [-89.192207, 47.84106],
              [-89.192681, 47.83343],
              [-89.19017, 47.831603],
              [-89.157738, 47.824015],
              [-89.124134, 47.828616],
              [-89.107991, 47.835705],
              [-89.056412, 47.852598],
              [-89.044463, 47.85575],
              [-89.022736, 47.858532],
              [-88.998939, 47.86749],
              [-88.911665, 47.891344],
              [-88.898986, 47.900685],
              [-88.899698, 47.902445],
              [-88.942387, 47.895436],
              [-88.957985, 47.895436],
              [-88.968903, 47.901675],
              [-88.968903, 47.909474],
              [-88.962664, 47.923512],
              [-88.923573, 47.937976],
              [-88.918029, 47.945605],
              [-88.899184, 47.9533],
              [-88.852923, 47.965322],
              [-88.832063, 47.965213],
              [-88.791959, 47.978938],
              [-88.772357, 47.981126],
              [-88.718555, 47.995134],
              [-88.670073, 48.011446],
              [-88.579784, 48.058669],
              [-88.575048, 48.064154],
              [-88.573924, 48.068861],
              [-88.575869, 48.075166],
              [-88.578395, 48.078003],
              [-88.578053, 48.084373],
              [-88.566938, 48.093719],
              [-88.511902, 48.121699],
              [-88.4857, 48.137683],
              [-88.469573, 48.152879],
              [-88.459697, 48.158551],
              [-88.449502, 48.163312],
              [-88.427373, 48.166764],
              [-88.419875, 48.170731],
              [-88.418244, 48.18037],
              [-88.422601, 48.190975],
              [-88.447236, 48.182916],
              [-88.459735, 48.183807],
              [-88.482039, 48.179915],
              [-88.491961, 48.175466],
              [-88.501088, 48.168181],
              [-88.524753, 48.165291],
              [-88.547033, 48.174891],
              [-88.578413, 48.16237],
              [-88.614026, 48.154797],
              [-88.656915, 48.139225],
              [-88.674192, 48.127165],
              [-88.676395, 48.124876],
              [-88.675628, 48.120444],
              [-88.684434, 48.115785],
            ],
          ],
          [
            [
              [-84.593232, 45.817389],
              [-84.590198, 45.813217],
              [-84.587572, 45.8067],
              [-84.58195, 45.802633],
              [-84.561562, 45.796213],
              [-84.549902, 45.789859],
              [-84.52506, 45.764168],
              [-84.509301, 45.754336],
              [-84.507476, 45.744644],
              [-84.500892, 45.737259],
              [-84.484128, 45.73071],
              [-84.469183, 45.732246],
              [-84.45104, 45.727952],
              [-84.430026, 45.726307],
              [-84.418902, 45.721712],
              [-84.405852, 45.722417],
              [-84.394038, 45.727623],
              [-84.3956, 45.732925],
              [-84.394292, 45.735301],
              [-84.372248, 45.745784],
              [-84.370241, 45.75619],
              [-84.356312, 45.769495],
              [-84.35602, 45.771895],
              [-84.403208, 45.784394],
              [-84.41091, 45.797217],
              [-84.419335, 45.806747],
              [-84.42159, 45.805651],
              [-84.419696, 45.799823],
              [-84.421267, 45.792694],
              [-84.426724, 45.788194],
              [-84.432472, 45.786732],
              [-84.492951, 45.805343],
              [-84.514441, 45.81012],
              [-84.538395, 45.807843],
              [-84.578328, 45.820092],
              [-84.589272, 45.825795],
              [-84.602922, 45.85164],
              [-84.6082, 45.861631],
              [-84.622515, 45.87753],
              [-84.629437, 45.882578],
              [-84.641804, 45.885486],
              [-84.646876, 45.884642],
              [-84.651336, 45.862844],
              [-84.650783, 45.85921],
              [-84.6397, 45.852624],
              [-84.629239, 45.850014],
              [-84.623863, 45.846579],
              [-84.612845, 45.834528],
              [-84.611893, 45.833487],
              [-84.61184, 45.833429],
              [-84.597043, 45.822629],
              [-84.594241, 45.818776],
              [-84.593232, 45.817389],
            ],
          ],
          [
            [
              [-86.093536, 45.007838],
              [-86.101214, 45.018101],
              [-86.101894, 45.022811],
              [-86.100315, 45.02624],
              [-86.097094, 45.030128],
              [-86.093451, 45.03166],
              [-86.079103, 45.030795],
              [-86.093166, 45.041492],
              [-86.117908, 45.048478],
              [-86.138095, 45.043038],
              [-86.141644, 45.040251],
              [-86.154557, 45.018102],
              [-86.156689, 45.010535],
              [-86.154824, 45.002394],
              [-86.133655, 44.996874],
              [-86.115699, 44.999093],
              [-86.093536, 45.007838],
            ],
          ],
          [
            [
              [-86.033174, 45.15842],
              [-86.04443, 45.159582],
              [-86.050473, 45.158418],
              [-86.059393, 45.152291],
              [-86.065016, 45.140266],
              [-86.060396, 45.104617],
              [-86.058653, 45.100776],
              [-86.052424, 45.095311],
              [-86.037129, 45.086576],
              [-86.019874, 45.071665],
              [-86.013073, 45.063774],
              [-85.99736, 45.055929],
              [-85.976883, 45.06266],
              [-85.977082, 45.072993],
              [-85.982799, 45.080787],
              [-85.984095, 45.087073],
              [-85.980433, 45.113046],
              [-85.976434, 45.120706],
              [-85.976803, 45.138363],
              [-85.989412, 45.151069],
              [-85.993194, 45.152805],
              [-86.005946, 45.155751],
              [-86.033174, 45.15842],
            ],
          ],
          [
            [
              [-82.700208, 41.61219],
              [-82.703438, 41.617734],
              [-82.70731, 41.619609],
              [-82.718802, 41.619629],
              [-82.735707, 41.603361],
              [-82.735766, 41.600982],
              [-82.725827, 41.595199],
              [-82.702027, 41.585437],
              [-82.688744, 41.585896],
              [-82.686033, 41.587246],
              [-82.680669, 41.594611],
              [-82.677772, 41.617986],
              [-82.68015, 41.61897],
              [-82.691123, 41.611331],
              [-82.700208, 41.61219],
            ],
          ],
          [
            [
              [-82.824731, 41.659428],
              [-82.834092, 41.657121],
              [-82.843602, 41.647009],
              [-82.842099, 41.628323],
              [-82.834662, 41.629331],
              [-82.827011, 41.633701],
              [-82.797493, 41.658197],
              [-82.794198, 41.662496],
              [-82.793069, 41.664692],
              [-82.796333, 41.665973],
              [-82.805179, 41.664281],
              [-82.808587, 41.661682],
              [-82.824731, 41.659428],
            ],
          ],
          [
            [
              [-82.803341, 41.693837],
              [-82.812805, 41.692002],
              [-82.826443, 41.684774],
              [-82.813781, 41.670594],
              [-82.805423, 41.67192],
              [-82.805137, 41.674931],
              [-82.801539, 41.682577],
              [-82.790561, 41.68997],
              [-82.782719, 41.694003],
              [-82.786304, 41.69714],
              [-82.803341, 41.693837],
            ],
          ],
          [
            [
              [-82.813489, 41.723468],
              [-82.820409, 41.724549],
              [-82.82572, 41.72281],
              [-82.832709, 41.71565],
              [-82.835577, 41.710823],
              [-82.835118, 41.708971],
              [-82.816133, 41.706732],
              [-82.808869, 41.708333],
              [-82.810487, 41.720524],
              [-82.813489, 41.723468],
            ],
          ],
        ],
      },
      properties: { region: 'MIDWEST' },
    },
  ],
};
